(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire403d"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire403d"] = parcelRequire;
}
parcelRequire.register("g85JO", function(module, exports) {
"use strict";

module.exports = (parcelRequire("6mHgG"));

});
parcelRequire.register("6mHgG", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $4a265c46e3f8f73b$export$dca3b0875bd9a954; }, function (v) { return $4a265c46e3f8f73b$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $4a265c46e3f8f73b$export$16fa2f45be04daa8; }, function (v) { return $4a265c46e3f8f73b$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $4a265c46e3f8f73b$export$ffb0004e005737fa; }, function (v) { return $4a265c46e3f8f73b$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $4a265c46e3f8f73b$export$e2c29f18771995cb; }, function (v) { return $4a265c46e3f8f73b$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $4a265c46e3f8f73b$export$221d75b3f55bb0bd; }, function (v) { return $4a265c46e3f8f73b$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $4a265c46e3f8f73b$export$5f8d39834fd61797; }, function (v) { return $4a265c46e3f8f73b$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $4a265c46e3f8f73b$export$74bf444e3cd11ea5; }, function (v) { return $4a265c46e3f8f73b$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $4a265c46e3f8f73b$export$ae55be85d98224ed; }, function (v) { return $4a265c46e3f8f73b$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $4a265c46e3f8f73b$export$e530037191fcd5d7; }, function (v) { return $4a265c46e3f8f73b$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $4a265c46e3f8f73b$export$fd42f52fd3ae1109; }, function (v) { return $4a265c46e3f8f73b$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $4a265c46e3f8f73b$export$c8a8987d4410bf2d; }, function (v) { return $4a265c46e3f8f73b$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $4a265c46e3f8f73b$export$d38cd72104c1f0e9; }, function (v) { return $4a265c46e3f8f73b$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $4a265c46e3f8f73b$export$7d1e3a5e95ceca43; }, function (v) { return $4a265c46e3f8f73b$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $4a265c46e3f8f73b$export$257a8862b851cb5b; }, function (v) { return $4a265c46e3f8f73b$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $4a265c46e3f8f73b$export$a8257692ac88316c; }, function (v) { return $4a265c46e3f8f73b$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $4a265c46e3f8f73b$export$488013bae63b21da; }, function (v) { return $4a265c46e3f8f73b$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $4a265c46e3f8f73b$export$7c73462e0d25e514; }, function (v) { return $4a265c46e3f8f73b$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "useCallback", function () { return $4a265c46e3f8f73b$export$35808ee640e87ca7; }, function (v) { return $4a265c46e3f8f73b$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $4a265c46e3f8f73b$export$fae74005e78b1a27; }, function (v) { return $4a265c46e3f8f73b$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $4a265c46e3f8f73b$export$dc8fbce3eb94dc1e; }, function (v) { return $4a265c46e3f8f73b$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useEffect", function () { return $4a265c46e3f8f73b$export$6d9c69b0de29b591; }, function (v) { return $4a265c46e3f8f73b$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $4a265c46e3f8f73b$export$d5a552a76deda3c2; }, function (v) { return $4a265c46e3f8f73b$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $4a265c46e3f8f73b$export$e5c5a5f917a5871c; }, function (v) { return $4a265c46e3f8f73b$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $4a265c46e3f8f73b$export$1538c33de8887b59; }, function (v) { return $4a265c46e3f8f73b$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $4a265c46e3f8f73b$export$13e3392192263954; }, function (v) { return $4a265c46e3f8f73b$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $4a265c46e3f8f73b$export$b8f5890fc79d6aca; }, function (v) { return $4a265c46e3f8f73b$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $4a265c46e3f8f73b$export$60241385465d0a34; }, function (v) { return $4a265c46e3f8f73b$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "version", function () { return $4a265c46e3f8f73b$export$83d89fbfd8236492; }, function (v) { return $4a265c46e3f8f73b$export$83d89fbfd8236492 = v; });
/** @license React v16.13.1
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4a265c46e3f8f73b$export$dca3b0875bd9a954;
var $4a265c46e3f8f73b$export$16fa2f45be04daa8;
var $4a265c46e3f8f73b$export$ffb0004e005737fa;
var $4a265c46e3f8f73b$export$e2c29f18771995cb;
var $4a265c46e3f8f73b$export$221d75b3f55bb0bd;
var $4a265c46e3f8f73b$export$5f8d39834fd61797;
var $4a265c46e3f8f73b$export$74bf444e3cd11ea5;
var $4a265c46e3f8f73b$export$ae55be85d98224ed;
var $4a265c46e3f8f73b$export$e530037191fcd5d7;
var $4a265c46e3f8f73b$export$fd42f52fd3ae1109;
var $4a265c46e3f8f73b$export$c8a8987d4410bf2d;
var $4a265c46e3f8f73b$export$d38cd72104c1f0e9;
var $4a265c46e3f8f73b$export$7d1e3a5e95ceca43;
var $4a265c46e3f8f73b$export$257a8862b851cb5b;
var $4a265c46e3f8f73b$export$a8257692ac88316c;
var $4a265c46e3f8f73b$export$488013bae63b21da;
var $4a265c46e3f8f73b$export$7c73462e0d25e514;
var $4a265c46e3f8f73b$export$35808ee640e87ca7;
var $4a265c46e3f8f73b$export$fae74005e78b1a27;
var $4a265c46e3f8f73b$export$dc8fbce3eb94dc1e;
var $4a265c46e3f8f73b$export$6d9c69b0de29b591;
var $4a265c46e3f8f73b$export$d5a552a76deda3c2;
var $4a265c46e3f8f73b$export$e5c5a5f917a5871c;
var $4a265c46e3f8f73b$export$1538c33de8887b59;
var $4a265c46e3f8f73b$export$13e3392192263954;
var $4a265c46e3f8f73b$export$b8f5890fc79d6aca;
var $4a265c46e3f8f73b$export$60241385465d0a34;
var $4a265c46e3f8f73b$export$83d89fbfd8236492;
"use strict";

var $22Kv0 = parcelRequire("22Kv0");
var $4a265c46e3f8f73b$var$n = "function" === typeof Symbol && Symbol.for, $4a265c46e3f8f73b$var$p = $4a265c46e3f8f73b$var$n ? Symbol.for("react.element") : 60103, $4a265c46e3f8f73b$var$q = $4a265c46e3f8f73b$var$n ? Symbol.for("react.portal") : 60106, $4a265c46e3f8f73b$var$r = $4a265c46e3f8f73b$var$n ? Symbol.for("react.fragment") : 60107, $4a265c46e3f8f73b$var$t = $4a265c46e3f8f73b$var$n ? Symbol.for("react.strict_mode") : 60108, $4a265c46e3f8f73b$var$u = $4a265c46e3f8f73b$var$n ? Symbol.for("react.profiler") : 60114, $4a265c46e3f8f73b$var$v = $4a265c46e3f8f73b$var$n ? Symbol.for("react.provider") : 60109, $4a265c46e3f8f73b$var$w = $4a265c46e3f8f73b$var$n ? Symbol.for("react.context") : 60110, $4a265c46e3f8f73b$var$x = $4a265c46e3f8f73b$var$n ? Symbol.for("react.forward_ref") : 60112, $4a265c46e3f8f73b$var$y = $4a265c46e3f8f73b$var$n ? Symbol.for("react.suspense") : 60113, $4a265c46e3f8f73b$var$z = $4a265c46e3f8f73b$var$n ? Symbol.for("react.memo") : 60115, $4a265c46e3f8f73b$var$A = $4a265c46e3f8f73b$var$n ? Symbol.for("react.lazy") : 60116, $4a265c46e3f8f73b$var$B = "function" === typeof Symbol && Symbol.iterator;
function $4a265c46e3f8f73b$var$C(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $4a265c46e3f8f73b$var$D = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $4a265c46e3f8f73b$var$E = {};
function $4a265c46e3f8f73b$var$F(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $4a265c46e3f8f73b$var$E;
    this.updater = c || $4a265c46e3f8f73b$var$D;
}
$4a265c46e3f8f73b$var$F.prototype.isReactComponent = {};
$4a265c46e3f8f73b$var$F.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($4a265c46e3f8f73b$var$C(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$4a265c46e3f8f73b$var$F.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $4a265c46e3f8f73b$var$G() {}
$4a265c46e3f8f73b$var$G.prototype = $4a265c46e3f8f73b$var$F.prototype;
function $4a265c46e3f8f73b$var$H(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $4a265c46e3f8f73b$var$E;
    this.updater = c || $4a265c46e3f8f73b$var$D;
}
var $4a265c46e3f8f73b$var$I = $4a265c46e3f8f73b$var$H.prototype = new $4a265c46e3f8f73b$var$G;
$4a265c46e3f8f73b$var$I.constructor = $4a265c46e3f8f73b$var$H;
$22Kv0($4a265c46e3f8f73b$var$I, $4a265c46e3f8f73b$var$F.prototype);
$4a265c46e3f8f73b$var$I.isPureReactComponent = !0;
var $4a265c46e3f8f73b$var$J = {
    current: null
}, $4a265c46e3f8f73b$var$K = Object.prototype.hasOwnProperty, $4a265c46e3f8f73b$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $4a265c46e3f8f73b$var$M(a, b, c) {
    var e, d = {}, g = null, k = null;
    if (null != b) for(e in void 0 !== b.ref && (k = b.ref), void 0 !== b.key && (g = "" + b.key), b)$4a265c46e3f8f73b$var$K.call(b, e) && !$4a265c46e3f8f73b$var$L.hasOwnProperty(e) && (d[e] = b[e]);
    var f = arguments.length - 2;
    if (1 === f) d.children = c;
    else if (1 < f) {
        for(var h = Array(f), m = 0; m < f; m++)h[m] = arguments[m + 2];
        d.children = h;
    }
    if (a && a.defaultProps) for(e in f = a.defaultProps, f)void 0 === d[e] && (d[e] = f[e]);
    return {
        $$typeof: $4a265c46e3f8f73b$var$p,
        type: a,
        key: g,
        ref: k,
        props: d,
        _owner: $4a265c46e3f8f73b$var$J.current
    };
}
function $4a265c46e3f8f73b$var$N(a, b) {
    return {
        $$typeof: $4a265c46e3f8f73b$var$p,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $4a265c46e3f8f73b$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $4a265c46e3f8f73b$var$p;
}
function $4a265c46e3f8f73b$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + ("" + a).replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $4a265c46e3f8f73b$var$P = /\/+/g, $4a265c46e3f8f73b$var$Q = [];
function $4a265c46e3f8f73b$var$R(a, b, c, e) {
    if ($4a265c46e3f8f73b$var$Q.length) {
        var d = $4a265c46e3f8f73b$var$Q.pop();
        d.result = a;
        d.keyPrefix = b;
        d.func = c;
        d.context = e;
        d.count = 0;
        return d;
    }
    return {
        result: a,
        keyPrefix: b,
        func: c,
        context: e,
        count: 0
    };
}
function $4a265c46e3f8f73b$var$S(a) {
    a.result = null;
    a.keyPrefix = null;
    a.func = null;
    a.context = null;
    a.count = 0;
    10 > $4a265c46e3f8f73b$var$Q.length && $4a265c46e3f8f73b$var$Q.push(a);
}
function $4a265c46e3f8f73b$var$T(a, b, c, e) {
    var d = typeof a;
    if ("undefined" === d || "boolean" === d) a = null;
    var g = !1;
    if (null === a) g = !0;
    else switch(d){
        case "string":
        case "number":
            g = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $4a265c46e3f8f73b$var$p:
                case $4a265c46e3f8f73b$var$q:
                    g = !0;
            }
    }
    if (g) return c(e, a, "" === b ? "." + $4a265c46e3f8f73b$var$U(a, 0) : b), 1;
    g = 0;
    b = "" === b ? "." : b + ":";
    if (Array.isArray(a)) for(var k = 0; k < a.length; k++){
        d = a[k];
        var f = b + $4a265c46e3f8f73b$var$U(d, k);
        g += $4a265c46e3f8f73b$var$T(d, f, c, e);
    }
    else if (null === a || "object" !== typeof a ? f = null : (f = $4a265c46e3f8f73b$var$B && a[$4a265c46e3f8f73b$var$B] || a["@@iterator"], f = "function" === typeof f ? f : null), "function" === typeof f) for(a = f.call(a), k = 0; !(d = a.next()).done;)d = d.value, f = b + $4a265c46e3f8f73b$var$U(d, k++), g += $4a265c46e3f8f73b$var$T(d, f, c, e);
    else if ("object" === d) throw c = "" + a, Error($4a265c46e3f8f73b$var$C(31, "[object Object]" === c ? "object with keys {" + Object.keys(a).join(", ") + "}" : c, ""));
    return g;
}
function $4a265c46e3f8f73b$var$V(a, b, c) {
    return null == a ? 0 : $4a265c46e3f8f73b$var$T(a, "", b, c);
}
function $4a265c46e3f8f73b$var$U(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $4a265c46e3f8f73b$var$escape(a.key) : b.toString(36);
}
function $4a265c46e3f8f73b$var$W(a, b) {
    a.func.call(a.context, b, a.count++);
}
function $4a265c46e3f8f73b$var$aa(a, b, c) {
    var e = a.result, d = a.keyPrefix;
    a = a.func.call(a.context, b, a.count++);
    Array.isArray(a) ? $4a265c46e3f8f73b$var$X(a, e, c, function(a) {
        return a;
    }) : null != a && ($4a265c46e3f8f73b$var$O(a) && (a = $4a265c46e3f8f73b$var$N(a, d + (!a.key || b && b.key === a.key ? "" : ("" + a.key).replace($4a265c46e3f8f73b$var$P, "$&/") + "/") + c)), e.push(a));
}
function $4a265c46e3f8f73b$var$X(a, b, c, e, d) {
    var g = "";
    null != c && (g = ("" + c).replace($4a265c46e3f8f73b$var$P, "$&/") + "/");
    b = $4a265c46e3f8f73b$var$R(b, g, e, d);
    $4a265c46e3f8f73b$var$V(a, $4a265c46e3f8f73b$var$aa, b);
    $4a265c46e3f8f73b$var$S(b);
}
var $4a265c46e3f8f73b$var$Y = {
    current: null
};
function $4a265c46e3f8f73b$var$Z() {
    var a = $4a265c46e3f8f73b$var$Y.current;
    if (null === a) throw Error($4a265c46e3f8f73b$var$C(321));
    return a;
}
var $4a265c46e3f8f73b$var$ba = {
    ReactCurrentDispatcher: $4a265c46e3f8f73b$var$Y,
    ReactCurrentBatchConfig: {
        suspense: null
    },
    ReactCurrentOwner: $4a265c46e3f8f73b$var$J,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $22Kv0
};
$4a265c46e3f8f73b$export$dca3b0875bd9a954 = {
    map: function(a, b, c) {
        if (null == a) return a;
        var e = [];
        $4a265c46e3f8f73b$var$X(a, e, null, b, c);
        return e;
    },
    forEach: function(a, b, c) {
        if (null == a) return a;
        b = $4a265c46e3f8f73b$var$R(null, null, b, c);
        $4a265c46e3f8f73b$var$V(a, $4a265c46e3f8f73b$var$W, b);
        $4a265c46e3f8f73b$var$S(b);
    },
    count: function(a) {
        return $4a265c46e3f8f73b$var$V(a, function() {
            return null;
        }, null);
    },
    toArray: function(a) {
        var b = [];
        $4a265c46e3f8f73b$var$X(a, b, null, function(a) {
            return a;
        });
        return b;
    },
    only: function(a) {
        if (!$4a265c46e3f8f73b$var$O(a)) throw Error($4a265c46e3f8f73b$var$C(143));
        return a;
    }
};
$4a265c46e3f8f73b$export$16fa2f45be04daa8 = $4a265c46e3f8f73b$var$F;
$4a265c46e3f8f73b$export$ffb0004e005737fa = $4a265c46e3f8f73b$var$r;
$4a265c46e3f8f73b$export$e2c29f18771995cb = $4a265c46e3f8f73b$var$u;
$4a265c46e3f8f73b$export$221d75b3f55bb0bd = $4a265c46e3f8f73b$var$H;
$4a265c46e3f8f73b$export$5f8d39834fd61797 = $4a265c46e3f8f73b$var$t;
$4a265c46e3f8f73b$export$74bf444e3cd11ea5 = $4a265c46e3f8f73b$var$y;
$4a265c46e3f8f73b$export$ae55be85d98224ed = $4a265c46e3f8f73b$var$ba;
$4a265c46e3f8f73b$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($4a265c46e3f8f73b$var$C(267, a));
    var e = $22Kv0({}, a.props), d = a.key, g = a.ref, k = a._owner;
    if (null != b) {
        void 0 !== b.ref && (g = b.ref, k = $4a265c46e3f8f73b$var$J.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var f = a.type.defaultProps;
        for(h in b)$4a265c46e3f8f73b$var$K.call(b, h) && !$4a265c46e3f8f73b$var$L.hasOwnProperty(h) && (e[h] = void 0 === b[h] && void 0 !== f ? f[h] : b[h]);
    }
    var h = arguments.length - 2;
    if (1 === h) e.children = c;
    else if (1 < h) {
        f = Array(h);
        for(var m = 0; m < h; m++)f[m] = arguments[m + 2];
        e.children = f;
    }
    return {
        $$typeof: $4a265c46e3f8f73b$var$p,
        type: a.type,
        key: d,
        ref: g,
        props: e,
        _owner: k
    };
};
$4a265c46e3f8f73b$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $4a265c46e3f8f73b$var$w,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $4a265c46e3f8f73b$var$v,
        _context: a
    };
    return a.Consumer = a;
};
$4a265c46e3f8f73b$export$c8a8987d4410bf2d = $4a265c46e3f8f73b$var$M;
$4a265c46e3f8f73b$export$d38cd72104c1f0e9 = function(a) {
    var b = $4a265c46e3f8f73b$var$M.bind(null, a);
    b.type = a;
    return b;
};
$4a265c46e3f8f73b$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$4a265c46e3f8f73b$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $4a265c46e3f8f73b$var$x,
        render: a
    };
};
$4a265c46e3f8f73b$export$a8257692ac88316c = $4a265c46e3f8f73b$var$O;
$4a265c46e3f8f73b$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $4a265c46e3f8f73b$var$A,
        _ctor: a,
        _status: -1,
        _result: null
    };
};
$4a265c46e3f8f73b$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $4a265c46e3f8f73b$var$z,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$4a265c46e3f8f73b$export$35808ee640e87ca7 = function(a, b) {
    return $4a265c46e3f8f73b$var$Z().useCallback(a, b);
};
$4a265c46e3f8f73b$export$fae74005e78b1a27 = function(a, b) {
    return $4a265c46e3f8f73b$var$Z().useContext(a, b);
};
$4a265c46e3f8f73b$export$dc8fbce3eb94dc1e = function() {};
$4a265c46e3f8f73b$export$6d9c69b0de29b591 = function(a, b) {
    return $4a265c46e3f8f73b$var$Z().useEffect(a, b);
};
$4a265c46e3f8f73b$export$d5a552a76deda3c2 = function(a, b, c) {
    return $4a265c46e3f8f73b$var$Z().useImperativeHandle(a, b, c);
};
$4a265c46e3f8f73b$export$e5c5a5f917a5871c = function(a, b) {
    return $4a265c46e3f8f73b$var$Z().useLayoutEffect(a, b);
};
$4a265c46e3f8f73b$export$1538c33de8887b59 = function(a, b) {
    return $4a265c46e3f8f73b$var$Z().useMemo(a, b);
};
$4a265c46e3f8f73b$export$13e3392192263954 = function(a, b, c) {
    return $4a265c46e3f8f73b$var$Z().useReducer(a, b, c);
};
$4a265c46e3f8f73b$export$b8f5890fc79d6aca = function(a) {
    return $4a265c46e3f8f73b$var$Z().useRef(a);
};
$4a265c46e3f8f73b$export$60241385465d0a34 = function(a) {
    return $4a265c46e3f8f73b$var$Z().useState(a);
};
$4a265c46e3f8f73b$export$83d89fbfd8236492 = "16.13.1";

});
parcelRequire.register("22Kv0", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $17cfd6695af3e4f0$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $17cfd6695af3e4f0$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $17cfd6695af3e4f0$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $17cfd6695af3e4f0$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $17cfd6695af3e4f0$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $17cfd6695af3e4f0$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $17cfd6695af3e4f0$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($17cfd6695af3e4f0$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($17cfd6695af3e4f0$var$getOwnPropertySymbols) {
            symbols = $17cfd6695af3e4f0$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($17cfd6695af3e4f0$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});



parcelRequire.register("8Iy3Z", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $658cdb1025f1b3cd$export$ae55be85d98224ed; }, function (v) { return $658cdb1025f1b3cd$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $658cdb1025f1b3cd$export$d39a5bbd09211389; }, function (v) { return $658cdb1025f1b3cd$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $658cdb1025f1b3cd$export$466bfc07425424d5; }, function (v) { return $658cdb1025f1b3cd$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $658cdb1025f1b3cd$export$cd75ccfd720a3cd4; }, function (v) { return $658cdb1025f1b3cd$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $658cdb1025f1b3cd$export$fa8d919ba61d84db; }, function (v) { return $658cdb1025f1b3cd$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "render", function () { return $658cdb1025f1b3cd$export$b3890eb0ae9dca99; }, function (v) { return $658cdb1025f1b3cd$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $658cdb1025f1b3cd$export$502457920280e6be; }, function (v) { return $658cdb1025f1b3cd$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $658cdb1025f1b3cd$export$c78a37762a8d58e1; }, function (v) { return $658cdb1025f1b3cd$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_createPortal", function () { return $658cdb1025f1b3cd$export$2577ef5d2565d52f; }, function (v) { return $658cdb1025f1b3cd$export$2577ef5d2565d52f = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $658cdb1025f1b3cd$export$dc54d992c10e8a18; }, function (v) { return $658cdb1025f1b3cd$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $658cdb1025f1b3cd$export$83d89fbfd8236492; }, function (v) { return $658cdb1025f1b3cd$export$83d89fbfd8236492 = v; });
/** @license React v16.13.1
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $658cdb1025f1b3cd$export$ae55be85d98224ed;
var $658cdb1025f1b3cd$export$d39a5bbd09211389;
var $658cdb1025f1b3cd$export$466bfc07425424d5;
var $658cdb1025f1b3cd$export$cd75ccfd720a3cd4;
var $658cdb1025f1b3cd$export$fa8d919ba61d84db;
var $658cdb1025f1b3cd$export$b3890eb0ae9dca99;
var $658cdb1025f1b3cd$export$502457920280e6be;
var $658cdb1025f1b3cd$export$c78a37762a8d58e1;
var $658cdb1025f1b3cd$export$2577ef5d2565d52f;
var $658cdb1025f1b3cd$export$dc54d992c10e8a18;
var $658cdb1025f1b3cd$export$83d89fbfd8236492;
"use strict";

var $g85JO = parcelRequire("g85JO");

var $22Kv0 = parcelRequire("22Kv0");

var $lze1c = parcelRequire("lze1c");
function $658cdb1025f1b3cd$var$u(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$g85JO) throw Error($658cdb1025f1b3cd$var$u(227));
function $658cdb1025f1b3cd$var$ba(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $658cdb1025f1b3cd$var$da = !1, $658cdb1025f1b3cd$var$ea = null, $658cdb1025f1b3cd$var$fa = !1, $658cdb1025f1b3cd$var$ha = null, $658cdb1025f1b3cd$var$ia = {
    onError: function(a) {
        $658cdb1025f1b3cd$var$da = !0;
        $658cdb1025f1b3cd$var$ea = a;
    }
};
function $658cdb1025f1b3cd$var$ja(a, b, c, d, e, f, g, h, k) {
    $658cdb1025f1b3cd$var$da = !1;
    $658cdb1025f1b3cd$var$ea = null;
    $658cdb1025f1b3cd$var$ba.apply($658cdb1025f1b3cd$var$ia, arguments);
}
function $658cdb1025f1b3cd$var$ka(a, b, c, d, e, f, g, h, k) {
    $658cdb1025f1b3cd$var$ja.apply(this, arguments);
    if ($658cdb1025f1b3cd$var$da) {
        if ($658cdb1025f1b3cd$var$da) {
            var l = $658cdb1025f1b3cd$var$ea;
            $658cdb1025f1b3cd$var$da = !1;
            $658cdb1025f1b3cd$var$ea = null;
        } else throw Error($658cdb1025f1b3cd$var$u(198));
        $658cdb1025f1b3cd$var$fa || ($658cdb1025f1b3cd$var$fa = !0, $658cdb1025f1b3cd$var$ha = l);
    }
}
var $658cdb1025f1b3cd$var$la = null, $658cdb1025f1b3cd$var$ma = null, $658cdb1025f1b3cd$var$na = null;
function $658cdb1025f1b3cd$var$oa(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = $658cdb1025f1b3cd$var$na(c);
    $658cdb1025f1b3cd$var$ka(d, b, void 0, a);
    a.currentTarget = null;
}
var $658cdb1025f1b3cd$var$pa = null, $658cdb1025f1b3cd$var$qa = {};
function $658cdb1025f1b3cd$var$ra() {
    if ($658cdb1025f1b3cd$var$pa) for(var a in $658cdb1025f1b3cd$var$qa){
        var b = $658cdb1025f1b3cd$var$qa[a], c = $658cdb1025f1b3cd$var$pa.indexOf(a);
        if (!(-1 < c)) throw Error($658cdb1025f1b3cd$var$u(96, a));
        if (!$658cdb1025f1b3cd$var$sa[c]) {
            if (!b.extractEvents) throw Error($658cdb1025f1b3cd$var$u(97, a));
            $658cdb1025f1b3cd$var$sa[c] = b;
            c = b.eventTypes;
            for(var d in c){
                var e = void 0;
                var f = c[d], g = b, h = d;
                if ($658cdb1025f1b3cd$var$ta.hasOwnProperty(h)) throw Error($658cdb1025f1b3cd$var$u(99, h));
                $658cdb1025f1b3cd$var$ta[h] = f;
                var k = f.phasedRegistrationNames;
                if (k) {
                    for(e in k)k.hasOwnProperty(e) && $658cdb1025f1b3cd$var$ua(k[e], g, h);
                    e = !0;
                } else f.registrationName ? ($658cdb1025f1b3cd$var$ua(f.registrationName, g, h), e = !0) : e = !1;
                if (!e) throw Error($658cdb1025f1b3cd$var$u(98, d, a));
            }
        }
    }
}
function $658cdb1025f1b3cd$var$ua(a, b, c) {
    if ($658cdb1025f1b3cd$var$va[a]) throw Error($658cdb1025f1b3cd$var$u(100, a));
    $658cdb1025f1b3cd$var$va[a] = b;
    $658cdb1025f1b3cd$var$wa[a] = b.eventTypes[c].dependencies;
}
var $658cdb1025f1b3cd$var$sa = [], $658cdb1025f1b3cd$var$ta = {}, $658cdb1025f1b3cd$var$va = {}, $658cdb1025f1b3cd$var$wa = {};
function $658cdb1025f1b3cd$var$xa(a) {
    var b = !1, c;
    for(c in a)if (a.hasOwnProperty(c)) {
        var d = a[c];
        if (!$658cdb1025f1b3cd$var$qa.hasOwnProperty(c) || $658cdb1025f1b3cd$var$qa[c] !== d) {
            if ($658cdb1025f1b3cd$var$qa[c]) throw Error($658cdb1025f1b3cd$var$u(102, c));
            $658cdb1025f1b3cd$var$qa[c] = d;
            b = !0;
        }
    }
    b && $658cdb1025f1b3cd$var$ra();
}
var $658cdb1025f1b3cd$var$ya = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $658cdb1025f1b3cd$var$za = null, $658cdb1025f1b3cd$var$Aa = null, $658cdb1025f1b3cd$var$Ba = null;
function $658cdb1025f1b3cd$var$Ca(a) {
    if (a = $658cdb1025f1b3cd$var$ma(a)) {
        if ("function" !== typeof $658cdb1025f1b3cd$var$za) throw Error($658cdb1025f1b3cd$var$u(280));
        var b = a.stateNode;
        b && (b = $658cdb1025f1b3cd$var$la(b), $658cdb1025f1b3cd$var$za(a.stateNode, a.type, b));
    }
}
function $658cdb1025f1b3cd$var$Da(a) {
    $658cdb1025f1b3cd$var$Aa ? $658cdb1025f1b3cd$var$Ba ? $658cdb1025f1b3cd$var$Ba.push(a) : $658cdb1025f1b3cd$var$Ba = [
        a
    ] : $658cdb1025f1b3cd$var$Aa = a;
}
function $658cdb1025f1b3cd$var$Ea() {
    if ($658cdb1025f1b3cd$var$Aa) {
        var a = $658cdb1025f1b3cd$var$Aa, b = $658cdb1025f1b3cd$var$Ba;
        $658cdb1025f1b3cd$var$Ba = $658cdb1025f1b3cd$var$Aa = null;
        $658cdb1025f1b3cd$var$Ca(a);
        if (b) for(a = 0; a < b.length; a++)$658cdb1025f1b3cd$var$Ca(b[a]);
    }
}
function $658cdb1025f1b3cd$var$Fa(a, b) {
    return a(b);
}
function $658cdb1025f1b3cd$var$Ga(a, b, c, d, e) {
    return a(b, c, d, e);
}
function $658cdb1025f1b3cd$var$Ha() {}
var $658cdb1025f1b3cd$var$Ia = $658cdb1025f1b3cd$var$Fa, $658cdb1025f1b3cd$var$Ja = !1, $658cdb1025f1b3cd$var$Ka = !1;
function $658cdb1025f1b3cd$var$La() {
    if (null !== $658cdb1025f1b3cd$var$Aa || null !== $658cdb1025f1b3cd$var$Ba) $658cdb1025f1b3cd$var$Ha(), $658cdb1025f1b3cd$var$Ea();
}
function $658cdb1025f1b3cd$var$Ma(a, b, c) {
    if ($658cdb1025f1b3cd$var$Ka) return a(b, c);
    $658cdb1025f1b3cd$var$Ka = !0;
    try {
        return $658cdb1025f1b3cd$var$Ia(a, b, c);
    } finally{
        $658cdb1025f1b3cd$var$Ka = !1, $658cdb1025f1b3cd$var$La();
    }
}
var $658cdb1025f1b3cd$var$Na = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $658cdb1025f1b3cd$var$Oa = Object.prototype.hasOwnProperty, $658cdb1025f1b3cd$var$Pa = {}, $658cdb1025f1b3cd$var$Qa = {};
function $658cdb1025f1b3cd$var$Ra(a) {
    if ($658cdb1025f1b3cd$var$Oa.call($658cdb1025f1b3cd$var$Qa, a)) return !0;
    if ($658cdb1025f1b3cd$var$Oa.call($658cdb1025f1b3cd$var$Pa, a)) return !1;
    if ($658cdb1025f1b3cd$var$Na.test(a)) return $658cdb1025f1b3cd$var$Qa[a] = !0;
    $658cdb1025f1b3cd$var$Pa[a] = !0;
    return !1;
}
function $658cdb1025f1b3cd$var$Sa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $658cdb1025f1b3cd$var$Ta(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $658cdb1025f1b3cd$var$Sa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $658cdb1025f1b3cd$var$v(a, b, c, d, e, f) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
}
var $658cdb1025f1b3cd$var$C = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $658cdb1025f1b3cd$var$C[a] = new $658cdb1025f1b3cd$var$v(a, 0, !1, a, null, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $658cdb1025f1b3cd$var$C[b] = new $658cdb1025f1b3cd$var$v(b, 1, !1, a[1], null, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $658cdb1025f1b3cd$var$C[a] = new $658cdb1025f1b3cd$var$v(a, 2, !1, a.toLowerCase(), null, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $658cdb1025f1b3cd$var$C[a] = new $658cdb1025f1b3cd$var$v(a, 2, !1, a, null, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $658cdb1025f1b3cd$var$C[a] = new $658cdb1025f1b3cd$var$v(a, 3, !1, a.toLowerCase(), null, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $658cdb1025f1b3cd$var$C[a] = new $658cdb1025f1b3cd$var$v(a, 3, !0, a, null, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $658cdb1025f1b3cd$var$C[a] = new $658cdb1025f1b3cd$var$v(a, 4, !1, a, null, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $658cdb1025f1b3cd$var$C[a] = new $658cdb1025f1b3cd$var$v(a, 6, !1, a, null, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $658cdb1025f1b3cd$var$C[a] = new $658cdb1025f1b3cd$var$v(a, 5, !1, a.toLowerCase(), null, !1);
});
var $658cdb1025f1b3cd$var$Ua = /[\-:]([a-z])/g;
function $658cdb1025f1b3cd$var$Va(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($658cdb1025f1b3cd$var$Ua, $658cdb1025f1b3cd$var$Va);
    $658cdb1025f1b3cd$var$C[b] = new $658cdb1025f1b3cd$var$v(b, 1, !1, a, null, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($658cdb1025f1b3cd$var$Ua, $658cdb1025f1b3cd$var$Va);
    $658cdb1025f1b3cd$var$C[b] = new $658cdb1025f1b3cd$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($658cdb1025f1b3cd$var$Ua, $658cdb1025f1b3cd$var$Va);
    $658cdb1025f1b3cd$var$C[b] = new $658cdb1025f1b3cd$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $658cdb1025f1b3cd$var$C[a] = new $658cdb1025f1b3cd$var$v(a, 1, !1, a.toLowerCase(), null, !1);
});
$658cdb1025f1b3cd$var$C.xlinkHref = new $658cdb1025f1b3cd$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $658cdb1025f1b3cd$var$C[a] = new $658cdb1025f1b3cd$var$v(a, 1, !1, a.toLowerCase(), null, !0);
});
var $658cdb1025f1b3cd$var$Wa = $g85JO.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
$658cdb1025f1b3cd$var$Wa.hasOwnProperty("ReactCurrentDispatcher") || ($658cdb1025f1b3cd$var$Wa.ReactCurrentDispatcher = {
    current: null
});
$658cdb1025f1b3cd$var$Wa.hasOwnProperty("ReactCurrentBatchConfig") || ($658cdb1025f1b3cd$var$Wa.ReactCurrentBatchConfig = {
    suspense: null
});
function $658cdb1025f1b3cd$var$Xa(a, b, c, d) {
    var e = $658cdb1025f1b3cd$var$C.hasOwnProperty(b) ? $658cdb1025f1b3cd$var$C[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || ($658cdb1025f1b3cd$var$Ta(b, c, e, d) && (c = null), d || null === e ? $658cdb1025f1b3cd$var$Ra(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var $658cdb1025f1b3cd$var$Ya = /^(.*)[\\\/]/, $658cdb1025f1b3cd$var$E = "function" === typeof Symbol && Symbol.for, $658cdb1025f1b3cd$var$Za = $658cdb1025f1b3cd$var$E ? Symbol.for("react.element") : 60103, $658cdb1025f1b3cd$var$$a = $658cdb1025f1b3cd$var$E ? Symbol.for("react.portal") : 60106, $658cdb1025f1b3cd$var$ab = $658cdb1025f1b3cd$var$E ? Symbol.for("react.fragment") : 60107, $658cdb1025f1b3cd$var$bb = $658cdb1025f1b3cd$var$E ? Symbol.for("react.strict_mode") : 60108, $658cdb1025f1b3cd$var$cb = $658cdb1025f1b3cd$var$E ? Symbol.for("react.profiler") : 60114, $658cdb1025f1b3cd$var$db = $658cdb1025f1b3cd$var$E ? Symbol.for("react.provider") : 60109, $658cdb1025f1b3cd$var$eb = $658cdb1025f1b3cd$var$E ? Symbol.for("react.context") : 60110, $658cdb1025f1b3cd$var$fb = $658cdb1025f1b3cd$var$E ? Symbol.for("react.concurrent_mode") : 60111, $658cdb1025f1b3cd$var$gb = $658cdb1025f1b3cd$var$E ? Symbol.for("react.forward_ref") : 60112, $658cdb1025f1b3cd$var$hb = $658cdb1025f1b3cd$var$E ? Symbol.for("react.suspense") : 60113, $658cdb1025f1b3cd$var$ib = $658cdb1025f1b3cd$var$E ? Symbol.for("react.suspense_list") : 60120, $658cdb1025f1b3cd$var$jb = $658cdb1025f1b3cd$var$E ? Symbol.for("react.memo") : 60115, $658cdb1025f1b3cd$var$kb = $658cdb1025f1b3cd$var$E ? Symbol.for("react.lazy") : 60116, $658cdb1025f1b3cd$var$lb = $658cdb1025f1b3cd$var$E ? Symbol.for("react.block") : 60121, $658cdb1025f1b3cd$var$mb = "function" === typeof Symbol && Symbol.iterator;
function $658cdb1025f1b3cd$var$nb(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $658cdb1025f1b3cd$var$mb && a[$658cdb1025f1b3cd$var$mb] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function $658cdb1025f1b3cd$var$ob(a) {
    if (-1 === a._status) {
        a._status = 0;
        var b = a._ctor;
        b = b();
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
}
function $658cdb1025f1b3cd$var$pb(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $658cdb1025f1b3cd$var$ab:
            return "Fragment";
        case $658cdb1025f1b3cd$var$$a:
            return "Portal";
        case $658cdb1025f1b3cd$var$cb:
            return "Profiler";
        case $658cdb1025f1b3cd$var$bb:
            return "StrictMode";
        case $658cdb1025f1b3cd$var$hb:
            return "Suspense";
        case $658cdb1025f1b3cd$var$ib:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $658cdb1025f1b3cd$var$eb:
            return "Context.Consumer";
        case $658cdb1025f1b3cd$var$db:
            return "Context.Provider";
        case $658cdb1025f1b3cd$var$gb:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case $658cdb1025f1b3cd$var$jb:
            return $658cdb1025f1b3cd$var$pb(a.type);
        case $658cdb1025f1b3cd$var$lb:
            return $658cdb1025f1b3cd$var$pb(a.render);
        case $658cdb1025f1b3cd$var$kb:
            if (a = 1 === a._status ? a._result : null) return $658cdb1025f1b3cd$var$pb(a);
    }
    return null;
}
function $658cdb1025f1b3cd$var$qb(a) {
    var b = "";
    do {
        a: switch(a.tag){
            case 3:
            case 4:
            case 6:
            case 7:
            case 10:
            case 9:
                var c = "";
                break a;
            default:
                var d = a._debugOwner, e = a._debugSource, f = $658cdb1025f1b3cd$var$pb(a.type);
                c = null;
                d && (c = $658cdb1025f1b3cd$var$pb(d.type));
                d = f;
                f = "";
                e ? f = " (at " + e.fileName.replace($658cdb1025f1b3cd$var$Ya, "") + ":" + e.lineNumber + ")" : c && (f = " (created by " + c + ")");
                c = "\n    in " + (d || "Unknown") + f;
        }
        b += c;
        a = a.return;
    }while (a);
    return b;
}
function $658cdb1025f1b3cd$var$rb(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function $658cdb1025f1b3cd$var$sb(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $658cdb1025f1b3cd$var$tb(a) {
    var b = $658cdb1025f1b3cd$var$sb(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $658cdb1025f1b3cd$var$xb(a) {
    a._valueTracker || (a._valueTracker = $658cdb1025f1b3cd$var$tb(a));
}
function $658cdb1025f1b3cd$var$yb(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $658cdb1025f1b3cd$var$sb(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $658cdb1025f1b3cd$var$zb(a, b) {
    var c = b.checked;
    return $22Kv0({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $658cdb1025f1b3cd$var$Ab(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $658cdb1025f1b3cd$var$rb(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $658cdb1025f1b3cd$var$Bb(a, b) {
    b = b.checked;
    null != b && $658cdb1025f1b3cd$var$Xa(a, "checked", b, !1);
}
function $658cdb1025f1b3cd$var$Cb(a, b) {
    $658cdb1025f1b3cd$var$Bb(a, b);
    var c = $658cdb1025f1b3cd$var$rb(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $658cdb1025f1b3cd$var$Db(a, b.type, c) : b.hasOwnProperty("defaultValue") && $658cdb1025f1b3cd$var$Db(a, b.type, $658cdb1025f1b3cd$var$rb(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $658cdb1025f1b3cd$var$Eb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $658cdb1025f1b3cd$var$Db(a, b, c) {
    if ("number" !== b || a.ownerDocument.activeElement !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function $658cdb1025f1b3cd$var$Fb(a) {
    var b = "";
    $g85JO.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function $658cdb1025f1b3cd$var$Gb(a, b) {
    a = $22Kv0({
        children: void 0
    }, b);
    if (b = $658cdb1025f1b3cd$var$Fb(b.children)) a.children = b;
    return a;
}
function $658cdb1025f1b3cd$var$Hb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $658cdb1025f1b3cd$var$rb(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $658cdb1025f1b3cd$var$Ib(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($658cdb1025f1b3cd$var$u(91));
    return $22Kv0({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $658cdb1025f1b3cd$var$Jb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($658cdb1025f1b3cd$var$u(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error($658cdb1025f1b3cd$var$u(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $658cdb1025f1b3cd$var$rb(c)
    };
}
function $658cdb1025f1b3cd$var$Kb(a, b) {
    var c = $658cdb1025f1b3cd$var$rb(b.value), d = $658cdb1025f1b3cd$var$rb(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $658cdb1025f1b3cd$var$Lb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var $658cdb1025f1b3cd$var$Mb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function $658cdb1025f1b3cd$var$Nb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $658cdb1025f1b3cd$var$Ob(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $658cdb1025f1b3cd$var$Nb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $658cdb1025f1b3cd$var$Pb, $658cdb1025f1b3cd$var$Qb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== $658cdb1025f1b3cd$var$Mb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        $658cdb1025f1b3cd$var$Pb = $658cdb1025f1b3cd$var$Pb || document.createElement("div");
        $658cdb1025f1b3cd$var$Pb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $658cdb1025f1b3cd$var$Pb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $658cdb1025f1b3cd$var$Rb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
function $658cdb1025f1b3cd$var$Sb(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $658cdb1025f1b3cd$var$Tb = {
    animationend: $658cdb1025f1b3cd$var$Sb("Animation", "AnimationEnd"),
    animationiteration: $658cdb1025f1b3cd$var$Sb("Animation", "AnimationIteration"),
    animationstart: $658cdb1025f1b3cd$var$Sb("Animation", "AnimationStart"),
    transitionend: $658cdb1025f1b3cd$var$Sb("Transition", "TransitionEnd")
}, $658cdb1025f1b3cd$var$Ub = {}, $658cdb1025f1b3cd$var$Vb = {};
$658cdb1025f1b3cd$var$ya && ($658cdb1025f1b3cd$var$Vb = document.createElement("div").style, "AnimationEvent" in window || (delete $658cdb1025f1b3cd$var$Tb.animationend.animation, delete $658cdb1025f1b3cd$var$Tb.animationiteration.animation, delete $658cdb1025f1b3cd$var$Tb.animationstart.animation), "TransitionEvent" in window || delete $658cdb1025f1b3cd$var$Tb.transitionend.transition);
function $658cdb1025f1b3cd$var$Wb(a) {
    if ($658cdb1025f1b3cd$var$Ub[a]) return $658cdb1025f1b3cd$var$Ub[a];
    if (!$658cdb1025f1b3cd$var$Tb[a]) return a;
    var b = $658cdb1025f1b3cd$var$Tb[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $658cdb1025f1b3cd$var$Vb) return $658cdb1025f1b3cd$var$Ub[a] = b[c];
    return a;
}
var $658cdb1025f1b3cd$var$Xb = $658cdb1025f1b3cd$var$Wb("animationend"), $658cdb1025f1b3cd$var$Yb = $658cdb1025f1b3cd$var$Wb("animationiteration"), $658cdb1025f1b3cd$var$Zb = $658cdb1025f1b3cd$var$Wb("animationstart"), $658cdb1025f1b3cd$var$$b = $658cdb1025f1b3cd$var$Wb("transitionend"), $658cdb1025f1b3cd$var$ac = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $658cdb1025f1b3cd$var$bc = new ("function" === typeof WeakMap ? WeakMap : Map);
function $658cdb1025f1b3cd$var$cc(a) {
    var b = $658cdb1025f1b3cd$var$bc.get(a);
    void 0 === b && (b = new Map, $658cdb1025f1b3cd$var$bc.set(a, b));
    return b;
}
function $658cdb1025f1b3cd$var$dc(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.effectTag & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $658cdb1025f1b3cd$var$ec(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $658cdb1025f1b3cd$var$fc(a) {
    if ($658cdb1025f1b3cd$var$dc(a) !== a) throw Error($658cdb1025f1b3cd$var$u(188));
}
function $658cdb1025f1b3cd$var$gc(a) {
    var b = a.alternate;
    if (!b) {
        b = $658cdb1025f1b3cd$var$dc(a);
        if (null === b) throw Error($658cdb1025f1b3cd$var$u(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $658cdb1025f1b3cd$var$fc(e), a;
                if (f === d) return $658cdb1025f1b3cd$var$fc(e), b;
                f = f.sibling;
            }
            throw Error($658cdb1025f1b3cd$var$u(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($658cdb1025f1b3cd$var$u(189));
            }
        }
        if (c.alternate !== d) throw Error($658cdb1025f1b3cd$var$u(190));
    }
    if (3 !== c.tag) throw Error($658cdb1025f1b3cd$var$u(188));
    return c.stateNode.current === c ? a : b;
}
function $658cdb1025f1b3cd$var$hc(a) {
    a = $658cdb1025f1b3cd$var$gc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function $658cdb1025f1b3cd$var$ic(a, b) {
    if (null == b) throw Error($658cdb1025f1b3cd$var$u(30));
    if (null == a) return b;
    if (Array.isArray(a)) {
        if (Array.isArray(b)) return a.push.apply(a, b), a;
        a.push(b);
        return a;
    }
    return Array.isArray(b) ? [
        a
    ].concat(b) : [
        a,
        b
    ];
}
function $658cdb1025f1b3cd$var$jc(a, b, c) {
    Array.isArray(a) ? a.forEach(b, c) : a && b.call(c, a);
}
var $658cdb1025f1b3cd$var$kc = null;
function $658cdb1025f1b3cd$var$lc(a) {
    if (a) {
        var b = a._dispatchListeners, c = a._dispatchInstances;
        if (Array.isArray(b)) for(var d = 0; d < b.length && !a.isPropagationStopped(); d++)$658cdb1025f1b3cd$var$oa(a, b[d], c[d]);
        else b && $658cdb1025f1b3cd$var$oa(a, b, c);
        a._dispatchListeners = null;
        a._dispatchInstances = null;
        a.isPersistent() || a.constructor.release(a);
    }
}
function $658cdb1025f1b3cd$var$mc(a) {
    null !== a && ($658cdb1025f1b3cd$var$kc = $658cdb1025f1b3cd$var$ic($658cdb1025f1b3cd$var$kc, a));
    a = $658cdb1025f1b3cd$var$kc;
    $658cdb1025f1b3cd$var$kc = null;
    if (a) {
        $658cdb1025f1b3cd$var$jc(a, $658cdb1025f1b3cd$var$lc);
        if ($658cdb1025f1b3cd$var$kc) throw Error($658cdb1025f1b3cd$var$u(95));
        if ($658cdb1025f1b3cd$var$fa) throw a = $658cdb1025f1b3cd$var$ha, $658cdb1025f1b3cd$var$fa = !1, $658cdb1025f1b3cd$var$ha = null, a;
    }
}
function $658cdb1025f1b3cd$var$nc(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
function $658cdb1025f1b3cd$var$oc(a) {
    if (!$658cdb1025f1b3cd$var$ya) return !1;
    a = "on" + a;
    var b = a in document;
    b || (b = document.createElement("div"), b.setAttribute(a, "return;"), b = "function" === typeof b[a]);
    return b;
}
var $658cdb1025f1b3cd$var$pc = [];
function $658cdb1025f1b3cd$var$qc(a) {
    a.topLevelType = null;
    a.nativeEvent = null;
    a.targetInst = null;
    a.ancestors.length = 0;
    10 > $658cdb1025f1b3cd$var$pc.length && $658cdb1025f1b3cd$var$pc.push(a);
}
function $658cdb1025f1b3cd$var$rc(a, b, c, d) {
    if ($658cdb1025f1b3cd$var$pc.length) {
        var e = $658cdb1025f1b3cd$var$pc.pop();
        e.topLevelType = a;
        e.eventSystemFlags = d;
        e.nativeEvent = b;
        e.targetInst = c;
        return e;
    }
    return {
        topLevelType: a,
        eventSystemFlags: d,
        nativeEvent: b,
        targetInst: c,
        ancestors: []
    };
}
function $658cdb1025f1b3cd$var$sc(a) {
    var b = a.targetInst, c = b;
    do {
        if (!c) {
            a.ancestors.push(c);
            break;
        }
        var d = c;
        if (3 === d.tag) d = d.stateNode.containerInfo;
        else {
            for(; d.return;)d = d.return;
            d = 3 !== d.tag ? null : d.stateNode.containerInfo;
        }
        if (!d) break;
        b = c.tag;
        5 !== b && 6 !== b || a.ancestors.push(c);
        c = $658cdb1025f1b3cd$var$tc(d);
    }while (c);
    for(c = 0; c < a.ancestors.length; c++){
        b = a.ancestors[c];
        var e = $658cdb1025f1b3cd$var$nc(a.nativeEvent);
        d = a.topLevelType;
        var f = a.nativeEvent, g = a.eventSystemFlags;
        0 === c && (g |= 64);
        for(var h = null, k = 0; k < $658cdb1025f1b3cd$var$sa.length; k++){
            var l = $658cdb1025f1b3cd$var$sa[k];
            l && (l = l.extractEvents(d, b, f, e, g)) && (h = $658cdb1025f1b3cd$var$ic(h, l));
        }
        $658cdb1025f1b3cd$var$mc(h);
    }
}
function $658cdb1025f1b3cd$var$uc(a, b, c) {
    if (!c.has(a)) {
        switch(a){
            case "scroll":
                $658cdb1025f1b3cd$var$vc(b, "scroll", !0);
                break;
            case "focus":
            case "blur":
                $658cdb1025f1b3cd$var$vc(b, "focus", !0);
                $658cdb1025f1b3cd$var$vc(b, "blur", !0);
                c.set("blur", null);
                c.set("focus", null);
                break;
            case "cancel":
            case "close":
                $658cdb1025f1b3cd$var$oc(a) && $658cdb1025f1b3cd$var$vc(b, a, !0);
                break;
            case "invalid":
            case "submit":
            case "reset":
                break;
            default:
                -1 === $658cdb1025f1b3cd$var$ac.indexOf(a) && $658cdb1025f1b3cd$var$F(a, b);
        }
        c.set(a, null);
    }
}
var $658cdb1025f1b3cd$var$wc, $658cdb1025f1b3cd$var$xc, $658cdb1025f1b3cd$var$yc, $658cdb1025f1b3cd$var$zc = !1, $658cdb1025f1b3cd$var$Ac = [], $658cdb1025f1b3cd$var$Bc = null, $658cdb1025f1b3cd$var$Cc = null, $658cdb1025f1b3cd$var$Dc = null, $658cdb1025f1b3cd$var$Ec = new Map, $658cdb1025f1b3cd$var$Fc = new Map, $658cdb1025f1b3cd$var$Gc = [], $658cdb1025f1b3cd$var$Hc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "), $658cdb1025f1b3cd$var$Ic = "focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function $658cdb1025f1b3cd$var$Jc(a, b) {
    var c = $658cdb1025f1b3cd$var$cc(b);
    $658cdb1025f1b3cd$var$Hc.forEach(function(a) {
        $658cdb1025f1b3cd$var$uc(a, b, c);
    });
    $658cdb1025f1b3cd$var$Ic.forEach(function(a) {
        $658cdb1025f1b3cd$var$uc(a, b, c);
    });
}
function $658cdb1025f1b3cd$var$Kc(a, b, c, d, e) {
    return {
        blockedOn: a,
        topLevelType: b,
        eventSystemFlags: c | 32,
        nativeEvent: e,
        container: d
    };
}
function $658cdb1025f1b3cd$var$Lc(a, b) {
    switch(a){
        case "focus":
        case "blur":
            $658cdb1025f1b3cd$var$Bc = null;
            break;
        case "dragenter":
        case "dragleave":
            $658cdb1025f1b3cd$var$Cc = null;
            break;
        case "mouseover":
        case "mouseout":
            $658cdb1025f1b3cd$var$Dc = null;
            break;
        case "pointerover":
        case "pointerout":
            $658cdb1025f1b3cd$var$Ec.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $658cdb1025f1b3cd$var$Fc.delete(b.pointerId);
    }
}
function $658cdb1025f1b3cd$var$Mc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = $658cdb1025f1b3cd$var$Kc(b, c, d, e, f), null !== b && (b = $658cdb1025f1b3cd$var$Nc(b), null !== b && $658cdb1025f1b3cd$var$xc(b)), a;
    a.eventSystemFlags |= d;
    return a;
}
function $658cdb1025f1b3cd$var$Oc(a, b, c, d, e) {
    switch(b){
        case "focus":
            return $658cdb1025f1b3cd$var$Bc = $658cdb1025f1b3cd$var$Mc($658cdb1025f1b3cd$var$Bc, a, b, c, d, e), !0;
        case "dragenter":
            return $658cdb1025f1b3cd$var$Cc = $658cdb1025f1b3cd$var$Mc($658cdb1025f1b3cd$var$Cc, a, b, c, d, e), !0;
        case "mouseover":
            return $658cdb1025f1b3cd$var$Dc = $658cdb1025f1b3cd$var$Mc($658cdb1025f1b3cd$var$Dc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $658cdb1025f1b3cd$var$Ec.set(f, $658cdb1025f1b3cd$var$Mc($658cdb1025f1b3cd$var$Ec.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $658cdb1025f1b3cd$var$Fc.set(f, $658cdb1025f1b3cd$var$Mc($658cdb1025f1b3cd$var$Fc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $658cdb1025f1b3cd$var$Pc(a) {
    var b = $658cdb1025f1b3cd$var$tc(a.target);
    if (null !== b) {
        var c = $658cdb1025f1b3cd$var$dc(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $658cdb1025f1b3cd$var$ec(c), null !== b) {
                    a.blockedOn = b;
                    $lze1c.unstable_runWithPriority(a.priority, function() {
                        $658cdb1025f1b3cd$var$yc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $658cdb1025f1b3cd$var$Qc(a) {
    if (null !== a.blockedOn) return !1;
    var b = $658cdb1025f1b3cd$var$Rc(a.topLevelType, a.eventSystemFlags, a.container, a.nativeEvent);
    if (null !== b) {
        var c = $658cdb1025f1b3cd$var$Nc(b);
        null !== c && $658cdb1025f1b3cd$var$xc(c);
        a.blockedOn = b;
        return !1;
    }
    return !0;
}
function $658cdb1025f1b3cd$var$Sc(a, b, c) {
    $658cdb1025f1b3cd$var$Qc(a) && c.delete(b);
}
function $658cdb1025f1b3cd$var$Tc() {
    for($658cdb1025f1b3cd$var$zc = !1; 0 < $658cdb1025f1b3cd$var$Ac.length;){
        var a = $658cdb1025f1b3cd$var$Ac[0];
        if (null !== a.blockedOn) {
            a = $658cdb1025f1b3cd$var$Nc(a.blockedOn);
            null !== a && $658cdb1025f1b3cd$var$wc(a);
            break;
        }
        var b = $658cdb1025f1b3cd$var$Rc(a.topLevelType, a.eventSystemFlags, a.container, a.nativeEvent);
        null !== b ? a.blockedOn = b : $658cdb1025f1b3cd$var$Ac.shift();
    }
    null !== $658cdb1025f1b3cd$var$Bc && $658cdb1025f1b3cd$var$Qc($658cdb1025f1b3cd$var$Bc) && ($658cdb1025f1b3cd$var$Bc = null);
    null !== $658cdb1025f1b3cd$var$Cc && $658cdb1025f1b3cd$var$Qc($658cdb1025f1b3cd$var$Cc) && ($658cdb1025f1b3cd$var$Cc = null);
    null !== $658cdb1025f1b3cd$var$Dc && $658cdb1025f1b3cd$var$Qc($658cdb1025f1b3cd$var$Dc) && ($658cdb1025f1b3cd$var$Dc = null);
    $658cdb1025f1b3cd$var$Ec.forEach($658cdb1025f1b3cd$var$Sc);
    $658cdb1025f1b3cd$var$Fc.forEach($658cdb1025f1b3cd$var$Sc);
}
function $658cdb1025f1b3cd$var$Uc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $658cdb1025f1b3cd$var$zc || ($658cdb1025f1b3cd$var$zc = !0, $lze1c.unstable_scheduleCallback($lze1c.unstable_NormalPriority, $658cdb1025f1b3cd$var$Tc)));
}
function $658cdb1025f1b3cd$var$Vc(a) {
    function b(b) {
        return $658cdb1025f1b3cd$var$Uc(b, a);
    }
    if (0 < $658cdb1025f1b3cd$var$Ac.length) {
        $658cdb1025f1b3cd$var$Uc($658cdb1025f1b3cd$var$Ac[0], a);
        for(var c = 1; c < $658cdb1025f1b3cd$var$Ac.length; c++){
            var d = $658cdb1025f1b3cd$var$Ac[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $658cdb1025f1b3cd$var$Bc && $658cdb1025f1b3cd$var$Uc($658cdb1025f1b3cd$var$Bc, a);
    null !== $658cdb1025f1b3cd$var$Cc && $658cdb1025f1b3cd$var$Uc($658cdb1025f1b3cd$var$Cc, a);
    null !== $658cdb1025f1b3cd$var$Dc && $658cdb1025f1b3cd$var$Uc($658cdb1025f1b3cd$var$Dc, a);
    $658cdb1025f1b3cd$var$Ec.forEach(b);
    $658cdb1025f1b3cd$var$Fc.forEach(b);
    for(c = 0; c < $658cdb1025f1b3cd$var$Gc.length; c++)d = $658cdb1025f1b3cd$var$Gc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $658cdb1025f1b3cd$var$Gc.length && (c = $658cdb1025f1b3cd$var$Gc[0], null === c.blockedOn);)$658cdb1025f1b3cd$var$Pc(c), null === c.blockedOn && $658cdb1025f1b3cd$var$Gc.shift();
}
var $658cdb1025f1b3cd$var$Wc = {}, $658cdb1025f1b3cd$var$Yc = new Map, $658cdb1025f1b3cd$var$Zc = new Map, $658cdb1025f1b3cd$var$$c = [
    "abort",
    "abort",
    $658cdb1025f1b3cd$var$Xb,
    "animationEnd",
    $658cdb1025f1b3cd$var$Yb,
    "animationIteration",
    $658cdb1025f1b3cd$var$Zb,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    $658cdb1025f1b3cd$var$$b,
    "transitionEnd",
    "waiting",
    "waiting"
];
function $658cdb1025f1b3cd$var$ad(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1], f = "on" + (e[0].toUpperCase() + e.slice(1));
        f = {
            phasedRegistrationNames: {
                bubbled: f,
                captured: f + "Capture"
            },
            dependencies: [
                d
            ],
            eventPriority: b
        };
        $658cdb1025f1b3cd$var$Zc.set(d, b);
        $658cdb1025f1b3cd$var$Yc.set(d, f);
        $658cdb1025f1b3cd$var$Wc[e] = f;
    }
}
$658cdb1025f1b3cd$var$ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
$658cdb1025f1b3cd$var$ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
$658cdb1025f1b3cd$var$ad($658cdb1025f1b3cd$var$$c, 2);
for(var $658cdb1025f1b3cd$var$bd = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), $658cdb1025f1b3cd$var$cd = 0; $658cdb1025f1b3cd$var$cd < $658cdb1025f1b3cd$var$bd.length; $658cdb1025f1b3cd$var$cd++)$658cdb1025f1b3cd$var$Zc.set($658cdb1025f1b3cd$var$bd[$658cdb1025f1b3cd$var$cd], 0);
var $658cdb1025f1b3cd$var$dd = $lze1c.unstable_UserBlockingPriority, $658cdb1025f1b3cd$var$ed = $lze1c.unstable_runWithPriority, $658cdb1025f1b3cd$var$fd = !0;
function $658cdb1025f1b3cd$var$F(a, b) {
    $658cdb1025f1b3cd$var$vc(b, a, !1);
}
function $658cdb1025f1b3cd$var$vc(a, b, c) {
    var d = $658cdb1025f1b3cd$var$Zc.get(b);
    switch(void 0 === d ? 2 : d){
        case 0:
            d = $658cdb1025f1b3cd$var$gd.bind(null, b, 1, a);
            break;
        case 1:
            d = $658cdb1025f1b3cd$var$hd.bind(null, b, 1, a);
            break;
        default:
            d = $658cdb1025f1b3cd$var$id.bind(null, b, 1, a);
    }
    c ? a.addEventListener(b, d, !0) : a.addEventListener(b, d, !1);
}
function $658cdb1025f1b3cd$var$gd(a, b, c, d) {
    $658cdb1025f1b3cd$var$Ja || $658cdb1025f1b3cd$var$Ha();
    var e = $658cdb1025f1b3cd$var$id, f = $658cdb1025f1b3cd$var$Ja;
    $658cdb1025f1b3cd$var$Ja = !0;
    try {
        $658cdb1025f1b3cd$var$Ga(e, a, b, c, d);
    } finally{
        ($658cdb1025f1b3cd$var$Ja = f) || $658cdb1025f1b3cd$var$La();
    }
}
function $658cdb1025f1b3cd$var$hd(a, b, c, d) {
    $658cdb1025f1b3cd$var$ed($658cdb1025f1b3cd$var$dd, $658cdb1025f1b3cd$var$id.bind(null, a, b, c, d));
}
function $658cdb1025f1b3cd$var$id(a, b, c, d) {
    if ($658cdb1025f1b3cd$var$fd) {
        if (0 < $658cdb1025f1b3cd$var$Ac.length && -1 < $658cdb1025f1b3cd$var$Hc.indexOf(a)) a = $658cdb1025f1b3cd$var$Kc(null, a, b, c, d), $658cdb1025f1b3cd$var$Ac.push(a);
        else {
            var e = $658cdb1025f1b3cd$var$Rc(a, b, c, d);
            if (null === e) $658cdb1025f1b3cd$var$Lc(a, d);
            else if (-1 < $658cdb1025f1b3cd$var$Hc.indexOf(a)) a = $658cdb1025f1b3cd$var$Kc(e, a, b, c, d), $658cdb1025f1b3cd$var$Ac.push(a);
            else if (!$658cdb1025f1b3cd$var$Oc(e, a, b, c, d)) {
                $658cdb1025f1b3cd$var$Lc(a, d);
                a = $658cdb1025f1b3cd$var$rc(a, d, null, b);
                try {
                    $658cdb1025f1b3cd$var$Ma($658cdb1025f1b3cd$var$sc, a);
                } finally{
                    $658cdb1025f1b3cd$var$qc(a);
                }
            }
        }
    }
}
function $658cdb1025f1b3cd$var$Rc(a, b, c, d) {
    c = $658cdb1025f1b3cd$var$nc(d);
    c = $658cdb1025f1b3cd$var$tc(c);
    if (null !== c) {
        var e = $658cdb1025f1b3cd$var$dc(c);
        if (null === e) c = null;
        else {
            var f = e.tag;
            if (13 === f) {
                c = $658cdb1025f1b3cd$var$ec(e);
                if (null !== c) return c;
                c = null;
            } else if (3 === f) {
                if (e.stateNode.hydrate) return 3 === e.tag ? e.stateNode.containerInfo : null;
                c = null;
            } else e !== c && (c = null);
        }
    }
    a = $658cdb1025f1b3cd$var$rc(a, d, c, b);
    try {
        $658cdb1025f1b3cd$var$Ma($658cdb1025f1b3cd$var$sc, a);
    } finally{
        $658cdb1025f1b3cd$var$qc(a);
    }
    return null;
}
var $658cdb1025f1b3cd$var$jd = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $658cdb1025f1b3cd$var$kd = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($658cdb1025f1b3cd$var$jd).forEach(function(a) {
    $658cdb1025f1b3cd$var$kd.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $658cdb1025f1b3cd$var$jd[b] = $658cdb1025f1b3cd$var$jd[a];
    });
});
function $658cdb1025f1b3cd$var$ld(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $658cdb1025f1b3cd$var$jd.hasOwnProperty(a) && $658cdb1025f1b3cd$var$jd[a] ? ("" + b).trim() : b + "px";
}
function $658cdb1025f1b3cd$var$md(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $658cdb1025f1b3cd$var$ld(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $658cdb1025f1b3cd$var$nd = $22Kv0({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $658cdb1025f1b3cd$var$od(a, b) {
    if (b) {
        if ($658cdb1025f1b3cd$var$nd[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($658cdb1025f1b3cd$var$u(137, a, ""));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($658cdb1025f1b3cd$var$u(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error($658cdb1025f1b3cd$var$u(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($658cdb1025f1b3cd$var$u(62, ""));
    }
}
function $658cdb1025f1b3cd$var$pd(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $658cdb1025f1b3cd$var$qd = $658cdb1025f1b3cd$var$Mb.html;
function $658cdb1025f1b3cd$var$rd(a, b) {
    a = 9 === a.nodeType || 11 === a.nodeType ? a : a.ownerDocument;
    var c = $658cdb1025f1b3cd$var$cc(a);
    b = $658cdb1025f1b3cd$var$wa[b];
    for(var d = 0; d < b.length; d++)$658cdb1025f1b3cd$var$uc(b[d], a, c);
}
function $658cdb1025f1b3cd$var$sd() {}
function $658cdb1025f1b3cd$var$td(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $658cdb1025f1b3cd$var$ud(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $658cdb1025f1b3cd$var$vd(a, b) {
    var c = $658cdb1025f1b3cd$var$ud(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $658cdb1025f1b3cd$var$ud(c);
    }
}
function $658cdb1025f1b3cd$var$wd(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $658cdb1025f1b3cd$var$wd(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $658cdb1025f1b3cd$var$xd() {
    for(var a = window, b = $658cdb1025f1b3cd$var$td(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $658cdb1025f1b3cd$var$td(a.document);
    }
    return b;
}
function $658cdb1025f1b3cd$var$yd(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var $658cdb1025f1b3cd$var$zd = "$", $658cdb1025f1b3cd$var$Ad = "/$", $658cdb1025f1b3cd$var$Bd = "$?", $658cdb1025f1b3cd$var$Cd = "$!", $658cdb1025f1b3cd$var$Dd = null, $658cdb1025f1b3cd$var$Ed = null;
function $658cdb1025f1b3cd$var$Fd(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function $658cdb1025f1b3cd$var$Gd(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $658cdb1025f1b3cd$var$Hd = "function" === typeof setTimeout ? setTimeout : void 0, $658cdb1025f1b3cd$var$Id = "function" === typeof clearTimeout ? clearTimeout : void 0;
function $658cdb1025f1b3cd$var$Jd(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function $658cdb1025f1b3cd$var$Kd(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if (c === $658cdb1025f1b3cd$var$zd || c === $658cdb1025f1b3cd$var$Cd || c === $658cdb1025f1b3cd$var$Bd) {
                if (0 === b) return a;
                b--;
            } else c === $658cdb1025f1b3cd$var$Ad && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $658cdb1025f1b3cd$var$Ld = Math.random().toString(36).slice(2), $658cdb1025f1b3cd$var$Md = "__reactInternalInstance$" + $658cdb1025f1b3cd$var$Ld, $658cdb1025f1b3cd$var$Nd = "__reactEventHandlers$" + $658cdb1025f1b3cd$var$Ld, $658cdb1025f1b3cd$var$Od = "__reactContainere$" + $658cdb1025f1b3cd$var$Ld;
function $658cdb1025f1b3cd$var$tc(a) {
    var b = a[$658cdb1025f1b3cd$var$Md];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$658cdb1025f1b3cd$var$Od] || c[$658cdb1025f1b3cd$var$Md]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $658cdb1025f1b3cd$var$Kd(a); null !== a;){
                if (c = a[$658cdb1025f1b3cd$var$Md]) return c;
                a = $658cdb1025f1b3cd$var$Kd(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $658cdb1025f1b3cd$var$Nc(a) {
    a = a[$658cdb1025f1b3cd$var$Md] || a[$658cdb1025f1b3cd$var$Od];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $658cdb1025f1b3cd$var$Pd(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($658cdb1025f1b3cd$var$u(33));
}
function $658cdb1025f1b3cd$var$Qd(a) {
    return a[$658cdb1025f1b3cd$var$Nd] || null;
}
function $658cdb1025f1b3cd$var$Rd(a) {
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $658cdb1025f1b3cd$var$Sd(a, b) {
    var c = a.stateNode;
    if (!c) return null;
    var d = $658cdb1025f1b3cd$var$la(c);
    if (!d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($658cdb1025f1b3cd$var$u(231, b, typeof c));
    return c;
}
function $658cdb1025f1b3cd$var$Td(a, b, c) {
    if (b = $658cdb1025f1b3cd$var$Sd(a, c.dispatchConfig.phasedRegistrationNames[b])) c._dispatchListeners = $658cdb1025f1b3cd$var$ic(c._dispatchListeners, b), c._dispatchInstances = $658cdb1025f1b3cd$var$ic(c._dispatchInstances, a);
}
function $658cdb1025f1b3cd$var$Ud(a) {
    if (a && a.dispatchConfig.phasedRegistrationNames) {
        for(var b = a._targetInst, c = []; b;)c.push(b), b = $658cdb1025f1b3cd$var$Rd(b);
        for(b = c.length; 0 < b--;)$658cdb1025f1b3cd$var$Td(c[b], "captured", a);
        for(b = 0; b < c.length; b++)$658cdb1025f1b3cd$var$Td(c[b], "bubbled", a);
    }
}
function $658cdb1025f1b3cd$var$Vd(a, b, c) {
    a && c && c.dispatchConfig.registrationName && (b = $658cdb1025f1b3cd$var$Sd(a, c.dispatchConfig.registrationName)) && (c._dispatchListeners = $658cdb1025f1b3cd$var$ic(c._dispatchListeners, b), c._dispatchInstances = $658cdb1025f1b3cd$var$ic(c._dispatchInstances, a));
}
function $658cdb1025f1b3cd$var$Wd(a) {
    a && a.dispatchConfig.registrationName && $658cdb1025f1b3cd$var$Vd(a._targetInst, null, a);
}
function $658cdb1025f1b3cd$var$Xd(a) {
    $658cdb1025f1b3cd$var$jc(a, $658cdb1025f1b3cd$var$Ud);
}
var $658cdb1025f1b3cd$var$Yd = null, $658cdb1025f1b3cd$var$Zd = null, $658cdb1025f1b3cd$var$$d = null;
function $658cdb1025f1b3cd$var$ae() {
    if ($658cdb1025f1b3cd$var$$d) return $658cdb1025f1b3cd$var$$d;
    var a, b = $658cdb1025f1b3cd$var$Zd, c = b.length, d, e = "value" in $658cdb1025f1b3cd$var$Yd ? $658cdb1025f1b3cd$var$Yd.value : $658cdb1025f1b3cd$var$Yd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $658cdb1025f1b3cd$var$$d = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $658cdb1025f1b3cd$var$be() {
    return !0;
}
function $658cdb1025f1b3cd$var$ce() {
    return !1;
}
function $658cdb1025f1b3cd$var$G(a, b, c, d) {
    this.dispatchConfig = a;
    this._targetInst = b;
    this.nativeEvent = c;
    a = this.constructor.Interface;
    for(var e in a)a.hasOwnProperty(e) && ((b = a[e]) ? this[e] = b(c) : "target" === e ? this.target = d : this[e] = c[e]);
    this.isDefaultPrevented = (null != c.defaultPrevented ? c.defaultPrevented : !1 === c.returnValue) ? $658cdb1025f1b3cd$var$be : $658cdb1025f1b3cd$var$ce;
    this.isPropagationStopped = $658cdb1025f1b3cd$var$ce;
    return this;
}
$22Kv0($658cdb1025f1b3cd$var$G.prototype, {
    preventDefault: function() {
        this.defaultPrevented = !0;
        var a = this.nativeEvent;
        a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $658cdb1025f1b3cd$var$be);
    },
    stopPropagation: function() {
        var a = this.nativeEvent;
        a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $658cdb1025f1b3cd$var$be);
    },
    persist: function() {
        this.isPersistent = $658cdb1025f1b3cd$var$be;
    },
    isPersistent: $658cdb1025f1b3cd$var$ce,
    destructor: function() {
        var a = this.constructor.Interface, b;
        for(b in a)this[b] = null;
        this.nativeEvent = this._targetInst = this.dispatchConfig = null;
        this.isPropagationStopped = this.isDefaultPrevented = $658cdb1025f1b3cd$var$ce;
        this._dispatchInstances = this._dispatchListeners = null;
    }
});
$658cdb1025f1b3cd$var$G.Interface = {
    type: null,
    target: null,
    currentTarget: function() {
        return null;
    },
    eventPhase: null,
    bubbles: null,
    cancelable: null,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: null,
    isTrusted: null
};
$658cdb1025f1b3cd$var$G.extend = function(a) {
    function b() {}
    function c() {
        return d.apply(this, arguments);
    }
    var d = this;
    b.prototype = d.prototype;
    var e = new b;
    $22Kv0(e, c.prototype);
    c.prototype = e;
    c.prototype.constructor = c;
    c.Interface = $22Kv0({}, d.Interface, a);
    c.extend = d.extend;
    $658cdb1025f1b3cd$var$de(c);
    return c;
};
$658cdb1025f1b3cd$var$de($658cdb1025f1b3cd$var$G);
function $658cdb1025f1b3cd$var$ee(a, b, c, d) {
    if (this.eventPool.length) {
        var e = this.eventPool.pop();
        this.call(e, a, b, c, d);
        return e;
    }
    return new this(a, b, c, d);
}
function $658cdb1025f1b3cd$var$fe(a) {
    if (!(a instanceof this)) throw Error($658cdb1025f1b3cd$var$u(279));
    a.destructor();
    10 > this.eventPool.length && this.eventPool.push(a);
}
function $658cdb1025f1b3cd$var$de(a) {
    a.eventPool = [];
    a.getPooled = $658cdb1025f1b3cd$var$ee;
    a.release = $658cdb1025f1b3cd$var$fe;
}
var $658cdb1025f1b3cd$var$ge = $658cdb1025f1b3cd$var$G.extend({
    data: null
}), $658cdb1025f1b3cd$var$he = $658cdb1025f1b3cd$var$G.extend({
    data: null
}), $658cdb1025f1b3cd$var$ie = [
    9,
    13,
    27,
    32
], $658cdb1025f1b3cd$var$je = $658cdb1025f1b3cd$var$ya && "CompositionEvent" in window, $658cdb1025f1b3cd$var$ke = null;
$658cdb1025f1b3cd$var$ya && "documentMode" in document && ($658cdb1025f1b3cd$var$ke = document.documentMode);
var $658cdb1025f1b3cd$var$le = $658cdb1025f1b3cd$var$ya && "TextEvent" in window && !$658cdb1025f1b3cd$var$ke, $658cdb1025f1b3cd$var$me = $658cdb1025f1b3cd$var$ya && (!$658cdb1025f1b3cd$var$je || $658cdb1025f1b3cd$var$ke && 8 < $658cdb1025f1b3cd$var$ke && 11 >= $658cdb1025f1b3cd$var$ke), $658cdb1025f1b3cd$var$ne = String.fromCharCode(32), $658cdb1025f1b3cd$var$oe = {
    beforeInput: {
        phasedRegistrationNames: {
            bubbled: "onBeforeInput",
            captured: "onBeforeInputCapture"
        },
        dependencies: [
            "compositionend",
            "keypress",
            "textInput",
            "paste"
        ]
    },
    compositionEnd: {
        phasedRegistrationNames: {
            bubbled: "onCompositionEnd",
            captured: "onCompositionEndCapture"
        },
        dependencies: "blur compositionend keydown keypress keyup mousedown".split(" ")
    },
    compositionStart: {
        phasedRegistrationNames: {
            bubbled: "onCompositionStart",
            captured: "onCompositionStartCapture"
        },
        dependencies: "blur compositionstart keydown keypress keyup mousedown".split(" ")
    },
    compositionUpdate: {
        phasedRegistrationNames: {
            bubbled: "onCompositionUpdate",
            captured: "onCompositionUpdateCapture"
        },
        dependencies: "blur compositionupdate keydown keypress keyup mousedown".split(" ")
    }
}, $658cdb1025f1b3cd$var$pe = !1;
function $658cdb1025f1b3cd$var$qe(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $658cdb1025f1b3cd$var$ie.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "blur":
            return !0;
        default:
            return !1;
    }
}
function $658cdb1025f1b3cd$var$re(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $658cdb1025f1b3cd$var$se = !1;
function $658cdb1025f1b3cd$var$te(a, b) {
    switch(a){
        case "compositionend":
            return $658cdb1025f1b3cd$var$re(b);
        case "keypress":
            if (32 !== b.which) return null;
            $658cdb1025f1b3cd$var$pe = !0;
            return $658cdb1025f1b3cd$var$ne;
        case "textInput":
            return a = b.data, a === $658cdb1025f1b3cd$var$ne && $658cdb1025f1b3cd$var$pe ? null : a;
        default:
            return null;
    }
}
function $658cdb1025f1b3cd$var$ue(a, b) {
    if ($658cdb1025f1b3cd$var$se) return "compositionend" === a || !$658cdb1025f1b3cd$var$je && $658cdb1025f1b3cd$var$qe(a, b) ? (a = $658cdb1025f1b3cd$var$ae(), $658cdb1025f1b3cd$var$$d = $658cdb1025f1b3cd$var$Zd = $658cdb1025f1b3cd$var$Yd = null, $658cdb1025f1b3cd$var$se = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $658cdb1025f1b3cd$var$me && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $658cdb1025f1b3cd$var$ve = {
    eventTypes: $658cdb1025f1b3cd$var$oe,
    extractEvents: function(a, b, c, d) {
        var e;
        if ($658cdb1025f1b3cd$var$je) b: {
            switch(a){
                case "compositionstart":
                    var f = $658cdb1025f1b3cd$var$oe.compositionStart;
                    break b;
                case "compositionend":
                    f = $658cdb1025f1b3cd$var$oe.compositionEnd;
                    break b;
                case "compositionupdate":
                    f = $658cdb1025f1b3cd$var$oe.compositionUpdate;
                    break b;
            }
            f = void 0;
        }
        else $658cdb1025f1b3cd$var$se ? $658cdb1025f1b3cd$var$qe(a, c) && (f = $658cdb1025f1b3cd$var$oe.compositionEnd) : "keydown" === a && 229 === c.keyCode && (f = $658cdb1025f1b3cd$var$oe.compositionStart);
        f ? ($658cdb1025f1b3cd$var$me && "ko" !== c.locale && ($658cdb1025f1b3cd$var$se || f !== $658cdb1025f1b3cd$var$oe.compositionStart ? f === $658cdb1025f1b3cd$var$oe.compositionEnd && $658cdb1025f1b3cd$var$se && (e = $658cdb1025f1b3cd$var$ae()) : ($658cdb1025f1b3cd$var$Yd = d, $658cdb1025f1b3cd$var$Zd = "value" in $658cdb1025f1b3cd$var$Yd ? $658cdb1025f1b3cd$var$Yd.value : $658cdb1025f1b3cd$var$Yd.textContent, $658cdb1025f1b3cd$var$se = !0)), f = $658cdb1025f1b3cd$var$ge.getPooled(f, b, c, d), e ? f.data = e : (e = $658cdb1025f1b3cd$var$re(c), null !== e && (f.data = e)), $658cdb1025f1b3cd$var$Xd(f), e = f) : e = null;
        (a = $658cdb1025f1b3cd$var$le ? $658cdb1025f1b3cd$var$te(a, c) : $658cdb1025f1b3cd$var$ue(a, c)) ? (b = $658cdb1025f1b3cd$var$he.getPooled($658cdb1025f1b3cd$var$oe.beforeInput, b, c, d), b.data = a, $658cdb1025f1b3cd$var$Xd(b)) : b = null;
        return null === e ? b : null === b ? e : [
            e,
            b
        ];
    }
}, $658cdb1025f1b3cd$var$we = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $658cdb1025f1b3cd$var$xe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$658cdb1025f1b3cd$var$we[a.type] : "textarea" === b ? !0 : !1;
}
var $658cdb1025f1b3cd$var$ye = {
    change: {
        phasedRegistrationNames: {
            bubbled: "onChange",
            captured: "onChangeCapture"
        },
        dependencies: "blur change click focus input keydown keyup selectionchange".split(" ")
    }
};
function $658cdb1025f1b3cd$var$ze(a, b, c) {
    a = $658cdb1025f1b3cd$var$G.getPooled($658cdb1025f1b3cd$var$ye.change, a, b, c);
    a.type = "change";
    $658cdb1025f1b3cd$var$Da(c);
    $658cdb1025f1b3cd$var$Xd(a);
    return a;
}
var $658cdb1025f1b3cd$var$Ae = null, $658cdb1025f1b3cd$var$Be = null;
function $658cdb1025f1b3cd$var$Ce(a) {
    $658cdb1025f1b3cd$var$mc(a);
}
function $658cdb1025f1b3cd$var$De(a) {
    var b = $658cdb1025f1b3cd$var$Pd(a);
    if ($658cdb1025f1b3cd$var$yb(b)) return a;
}
function $658cdb1025f1b3cd$var$Ee(a, b) {
    if ("change" === a) return b;
}
var $658cdb1025f1b3cd$var$Fe = !1;
$658cdb1025f1b3cd$var$ya && ($658cdb1025f1b3cd$var$Fe = $658cdb1025f1b3cd$var$oc("input") && (!document.documentMode || 9 < document.documentMode));
function $658cdb1025f1b3cd$var$Ge() {
    $658cdb1025f1b3cd$var$Ae && ($658cdb1025f1b3cd$var$Ae.detachEvent("onpropertychange", $658cdb1025f1b3cd$var$He), $658cdb1025f1b3cd$var$Be = $658cdb1025f1b3cd$var$Ae = null);
}
function $658cdb1025f1b3cd$var$He(a) {
    if ("value" === a.propertyName && $658cdb1025f1b3cd$var$De($658cdb1025f1b3cd$var$Be)) {
        if (a = $658cdb1025f1b3cd$var$ze($658cdb1025f1b3cd$var$Be, a, $658cdb1025f1b3cd$var$nc(a)), $658cdb1025f1b3cd$var$Ja) $658cdb1025f1b3cd$var$mc(a);
        else {
            $658cdb1025f1b3cd$var$Ja = !0;
            try {
                $658cdb1025f1b3cd$var$Fa($658cdb1025f1b3cd$var$Ce, a);
            } finally{
                $658cdb1025f1b3cd$var$Ja = !1, $658cdb1025f1b3cd$var$La();
            }
        }
    }
}
function $658cdb1025f1b3cd$var$Ie(a, b, c) {
    "focus" === a ? ($658cdb1025f1b3cd$var$Ge(), $658cdb1025f1b3cd$var$Ae = b, $658cdb1025f1b3cd$var$Be = c, $658cdb1025f1b3cd$var$Ae.attachEvent("onpropertychange", $658cdb1025f1b3cd$var$He)) : "blur" === a && $658cdb1025f1b3cd$var$Ge();
}
function $658cdb1025f1b3cd$var$Je(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $658cdb1025f1b3cd$var$De($658cdb1025f1b3cd$var$Be);
}
function $658cdb1025f1b3cd$var$Ke(a, b) {
    if ("click" === a) return $658cdb1025f1b3cd$var$De(b);
}
function $658cdb1025f1b3cd$var$Le(a, b) {
    if ("input" === a || "change" === a) return $658cdb1025f1b3cd$var$De(b);
}
var $658cdb1025f1b3cd$var$Me = {
    eventTypes: $658cdb1025f1b3cd$var$ye,
    _isInputEventSupported: $658cdb1025f1b3cd$var$Fe,
    extractEvents: function(a, b, c, d) {
        var e = b ? $658cdb1025f1b3cd$var$Pd(b) : window, f = e.nodeName && e.nodeName.toLowerCase();
        if ("select" === f || "input" === f && "file" === e.type) var g = $658cdb1025f1b3cd$var$Ee;
        else if ($658cdb1025f1b3cd$var$xe(e)) {
            if ($658cdb1025f1b3cd$var$Fe) g = $658cdb1025f1b3cd$var$Le;
            else {
                g = $658cdb1025f1b3cd$var$Je;
                var h = $658cdb1025f1b3cd$var$Ie;
            }
        } else (f = e.nodeName) && "input" === f.toLowerCase() && ("checkbox" === e.type || "radio" === e.type) && (g = $658cdb1025f1b3cd$var$Ke);
        if (g && (g = g(a, b))) return $658cdb1025f1b3cd$var$ze(g, c, d);
        h && h(a, e, b);
        "blur" === a && (a = e._wrapperState) && a.controlled && "number" === e.type && $658cdb1025f1b3cd$var$Db(e, "number", e.value);
    }
}, $658cdb1025f1b3cd$var$Ne = $658cdb1025f1b3cd$var$G.extend({
    view: null,
    detail: null
}), $658cdb1025f1b3cd$var$Oe = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $658cdb1025f1b3cd$var$Pe(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $658cdb1025f1b3cd$var$Oe[a]) ? !!b[a] : !1;
}
function $658cdb1025f1b3cd$var$Qe() {
    return $658cdb1025f1b3cd$var$Pe;
}
var $658cdb1025f1b3cd$var$Re = 0, $658cdb1025f1b3cd$var$Se = 0, $658cdb1025f1b3cd$var$Te = !1, $658cdb1025f1b3cd$var$Ue = !1, $658cdb1025f1b3cd$var$Ve = $658cdb1025f1b3cd$var$Ne.extend({
    screenX: null,
    screenY: null,
    clientX: null,
    clientY: null,
    pageX: null,
    pageY: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    getModifierState: $658cdb1025f1b3cd$var$Qe,
    button: null,
    buttons: null,
    relatedTarget: function(a) {
        return a.relatedTarget || (a.fromElement === a.srcElement ? a.toElement : a.fromElement);
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        var b = $658cdb1025f1b3cd$var$Re;
        $658cdb1025f1b3cd$var$Re = a.screenX;
        return $658cdb1025f1b3cd$var$Te ? "mousemove" === a.type ? a.screenX - b : 0 : ($658cdb1025f1b3cd$var$Te = !0, 0);
    },
    movementY: function(a) {
        if ("movementY" in a) return a.movementY;
        var b = $658cdb1025f1b3cd$var$Se;
        $658cdb1025f1b3cd$var$Se = a.screenY;
        return $658cdb1025f1b3cd$var$Ue ? "mousemove" === a.type ? a.screenY - b : 0 : ($658cdb1025f1b3cd$var$Ue = !0, 0);
    }
}), $658cdb1025f1b3cd$var$We = $658cdb1025f1b3cd$var$Ve.extend({
    pointerId: null,
    width: null,
    height: null,
    pressure: null,
    tangentialPressure: null,
    tiltX: null,
    tiltY: null,
    twist: null,
    pointerType: null,
    isPrimary: null
}), $658cdb1025f1b3cd$var$Xe = {
    mouseEnter: {
        registrationName: "onMouseEnter",
        dependencies: [
            "mouseout",
            "mouseover"
        ]
    },
    mouseLeave: {
        registrationName: "onMouseLeave",
        dependencies: [
            "mouseout",
            "mouseover"
        ]
    },
    pointerEnter: {
        registrationName: "onPointerEnter",
        dependencies: [
            "pointerout",
            "pointerover"
        ]
    },
    pointerLeave: {
        registrationName: "onPointerLeave",
        dependencies: [
            "pointerout",
            "pointerover"
        ]
    }
}, $658cdb1025f1b3cd$var$Ye = {
    eventTypes: $658cdb1025f1b3cd$var$Xe,
    extractEvents: function(a, b, c, d, e) {
        var f = "mouseover" === a || "pointerover" === a, g = "mouseout" === a || "pointerout" === a;
        if (f && 0 === (e & 32) && (c.relatedTarget || c.fromElement) || !g && !f) return null;
        f = d.window === d ? d : (f = d.ownerDocument) ? f.defaultView || f.parentWindow : window;
        if (g) {
            if (g = b, b = (b = c.relatedTarget || c.toElement) ? $658cdb1025f1b3cd$var$tc(b) : null, null !== b) {
                var h = $658cdb1025f1b3cd$var$dc(b);
                if (b !== h || 5 !== b.tag && 6 !== b.tag) b = null;
            }
        } else g = null;
        if (g === b) return null;
        if ("mouseout" === a || "mouseover" === a) {
            var k = $658cdb1025f1b3cd$var$Ve;
            var l = $658cdb1025f1b3cd$var$Xe.mouseLeave;
            var m = $658cdb1025f1b3cd$var$Xe.mouseEnter;
            var p = "mouse";
        } else if ("pointerout" === a || "pointerover" === a) k = $658cdb1025f1b3cd$var$We, l = $658cdb1025f1b3cd$var$Xe.pointerLeave, m = $658cdb1025f1b3cd$var$Xe.pointerEnter, p = "pointer";
        a = null == g ? f : $658cdb1025f1b3cd$var$Pd(g);
        f = null == b ? f : $658cdb1025f1b3cd$var$Pd(b);
        l = k.getPooled(l, g, c, d);
        l.type = p + "leave";
        l.target = a;
        l.relatedTarget = f;
        c = k.getPooled(m, b, c, d);
        c.type = p + "enter";
        c.target = f;
        c.relatedTarget = a;
        d = g;
        p = b;
        if (d && p) a: {
            k = d;
            m = p;
            g = 0;
            for(a = k; a; a = $658cdb1025f1b3cd$var$Rd(a))g++;
            a = 0;
            for(b = m; b; b = $658cdb1025f1b3cd$var$Rd(b))a++;
            for(; 0 < g - a;)k = $658cdb1025f1b3cd$var$Rd(k), g--;
            for(; 0 < a - g;)m = $658cdb1025f1b3cd$var$Rd(m), a--;
            for(; g--;){
                if (k === m || k === m.alternate) break a;
                k = $658cdb1025f1b3cd$var$Rd(k);
                m = $658cdb1025f1b3cd$var$Rd(m);
            }
            k = null;
        }
        else k = null;
        m = k;
        for(k = []; d && d !== m;){
            g = d.alternate;
            if (null !== g && g === m) break;
            k.push(d);
            d = $658cdb1025f1b3cd$var$Rd(d);
        }
        for(d = []; p && p !== m;){
            g = p.alternate;
            if (null !== g && g === m) break;
            d.push(p);
            p = $658cdb1025f1b3cd$var$Rd(p);
        }
        for(p = 0; p < k.length; p++)$658cdb1025f1b3cd$var$Vd(k[p], "bubbled", l);
        for(p = d.length; 0 < p--;)$658cdb1025f1b3cd$var$Vd(d[p], "captured", c);
        return 0 === (e & 64) ? [
            l
        ] : [
            l,
            c
        ];
    }
};
function $658cdb1025f1b3cd$var$Ze(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $658cdb1025f1b3cd$var$$e = "function" === typeof Object.is ? Object.is : $658cdb1025f1b3cd$var$Ze, $658cdb1025f1b3cd$var$af = Object.prototype.hasOwnProperty;
function $658cdb1025f1b3cd$var$bf(a, b) {
    if ($658cdb1025f1b3cd$var$$e(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!$658cdb1025f1b3cd$var$af.call(b, c[d]) || !$658cdb1025f1b3cd$var$$e(a[c[d]], b[c[d]])) return !1;
    return !0;
}
var $658cdb1025f1b3cd$var$cf = $658cdb1025f1b3cd$var$ya && "documentMode" in document && 11 >= document.documentMode, $658cdb1025f1b3cd$var$df = {
    select: {
        phasedRegistrationNames: {
            bubbled: "onSelect",
            captured: "onSelectCapture"
        },
        dependencies: "blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")
    }
}, $658cdb1025f1b3cd$var$ef = null, $658cdb1025f1b3cd$var$ff = null, $658cdb1025f1b3cd$var$gf = null, $658cdb1025f1b3cd$var$hf = !1;
function $658cdb1025f1b3cd$var$jf(a, b) {
    var c = b.window === b ? b.document : 9 === b.nodeType ? b : b.ownerDocument;
    if ($658cdb1025f1b3cd$var$hf || null == $658cdb1025f1b3cd$var$ef || $658cdb1025f1b3cd$var$ef !== $658cdb1025f1b3cd$var$td(c)) return null;
    c = $658cdb1025f1b3cd$var$ef;
    "selectionStart" in c && $658cdb1025f1b3cd$var$yd(c) ? c = {
        start: c.selectionStart,
        end: c.selectionEnd
    } : (c = (c.ownerDocument && c.ownerDocument.defaultView || window).getSelection(), c = {
        anchorNode: c.anchorNode,
        anchorOffset: c.anchorOffset,
        focusNode: c.focusNode,
        focusOffset: c.focusOffset
    });
    return $658cdb1025f1b3cd$var$gf && $658cdb1025f1b3cd$var$bf($658cdb1025f1b3cd$var$gf, c) ? null : ($658cdb1025f1b3cd$var$gf = c, a = $658cdb1025f1b3cd$var$G.getPooled($658cdb1025f1b3cd$var$df.select, $658cdb1025f1b3cd$var$ff, a, b), a.type = "select", a.target = $658cdb1025f1b3cd$var$ef, $658cdb1025f1b3cd$var$Xd(a), a);
}
var $658cdb1025f1b3cd$var$kf = {
    eventTypes: $658cdb1025f1b3cd$var$df,
    extractEvents: function(a, b, c, d, e, f) {
        e = f || (d.window === d ? d.document : 9 === d.nodeType ? d : d.ownerDocument);
        if (!(f = !e)) {
            a: {
                e = $658cdb1025f1b3cd$var$cc(e);
                f = $658cdb1025f1b3cd$var$wa.onSelect;
                for(var g = 0; g < f.length; g++)if (!e.has(f[g])) {
                    e = !1;
                    break a;
                }
                e = !0;
            }
            f = !e;
        }
        if (f) return null;
        e = b ? $658cdb1025f1b3cd$var$Pd(b) : window;
        switch(a){
            case "focus":
                if ($658cdb1025f1b3cd$var$xe(e) || "true" === e.contentEditable) $658cdb1025f1b3cd$var$ef = e, $658cdb1025f1b3cd$var$ff = b, $658cdb1025f1b3cd$var$gf = null;
                break;
            case "blur":
                $658cdb1025f1b3cd$var$gf = $658cdb1025f1b3cd$var$ff = $658cdb1025f1b3cd$var$ef = null;
                break;
            case "mousedown":
                $658cdb1025f1b3cd$var$hf = !0;
                break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
                return $658cdb1025f1b3cd$var$hf = !1, $658cdb1025f1b3cd$var$jf(c, d);
            case "selectionchange":
                if ($658cdb1025f1b3cd$var$cf) break;
            case "keydown":
            case "keyup":
                return $658cdb1025f1b3cd$var$jf(c, d);
        }
        return null;
    }
}, $658cdb1025f1b3cd$var$lf = $658cdb1025f1b3cd$var$G.extend({
    animationName: null,
    elapsedTime: null,
    pseudoElement: null
}), $658cdb1025f1b3cd$var$mf = $658cdb1025f1b3cd$var$G.extend({
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $658cdb1025f1b3cd$var$nf = $658cdb1025f1b3cd$var$Ne.extend({
    relatedTarget: null
});
function $658cdb1025f1b3cd$var$of(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
var $658cdb1025f1b3cd$var$pf = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $658cdb1025f1b3cd$var$qf = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $658cdb1025f1b3cd$var$rf = $658cdb1025f1b3cd$var$Ne.extend({
    key: function(a) {
        if (a.key) {
            var b = $658cdb1025f1b3cd$var$pf[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $658cdb1025f1b3cd$var$of(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $658cdb1025f1b3cd$var$qf[a.keyCode] || "Unidentified" : "";
    },
    location: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    repeat: null,
    locale: null,
    getModifierState: $658cdb1025f1b3cd$var$Qe,
    charCode: function(a) {
        return "keypress" === a.type ? $658cdb1025f1b3cd$var$of(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $658cdb1025f1b3cd$var$of(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $658cdb1025f1b3cd$var$sf = $658cdb1025f1b3cd$var$Ve.extend({
    dataTransfer: null
}), $658cdb1025f1b3cd$var$tf = $658cdb1025f1b3cd$var$Ne.extend({
    touches: null,
    targetTouches: null,
    changedTouches: null,
    altKey: null,
    metaKey: null,
    ctrlKey: null,
    shiftKey: null,
    getModifierState: $658cdb1025f1b3cd$var$Qe
}), $658cdb1025f1b3cd$var$uf = $658cdb1025f1b3cd$var$G.extend({
    propertyName: null,
    elapsedTime: null,
    pseudoElement: null
}), $658cdb1025f1b3cd$var$vf = $658cdb1025f1b3cd$var$Ve.extend({
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: null,
    deltaMode: null
}), $658cdb1025f1b3cd$var$wf = {
    eventTypes: $658cdb1025f1b3cd$var$Wc,
    extractEvents: function(a, b, c, d) {
        var e = $658cdb1025f1b3cd$var$Yc.get(a);
        if (!e) return null;
        switch(a){
            case "keypress":
                if (0 === $658cdb1025f1b3cd$var$of(c)) return null;
            case "keydown":
            case "keyup":
                a = $658cdb1025f1b3cd$var$rf;
                break;
            case "blur":
            case "focus":
                a = $658cdb1025f1b3cd$var$nf;
                break;
            case "click":
                if (2 === c.button) return null;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
                a = $658cdb1025f1b3cd$var$Ve;
                break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
                a = $658cdb1025f1b3cd$var$sf;
                break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
                a = $658cdb1025f1b3cd$var$tf;
                break;
            case $658cdb1025f1b3cd$var$Xb:
            case $658cdb1025f1b3cd$var$Yb:
            case $658cdb1025f1b3cd$var$Zb:
                a = $658cdb1025f1b3cd$var$lf;
                break;
            case $658cdb1025f1b3cd$var$$b:
                a = $658cdb1025f1b3cd$var$uf;
                break;
            case "scroll":
                a = $658cdb1025f1b3cd$var$Ne;
                break;
            case "wheel":
                a = $658cdb1025f1b3cd$var$vf;
                break;
            case "copy":
            case "cut":
            case "paste":
                a = $658cdb1025f1b3cd$var$mf;
                break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
                a = $658cdb1025f1b3cd$var$We;
                break;
            default:
                a = $658cdb1025f1b3cd$var$G;
        }
        b = a.getPooled(e, b, c, d);
        $658cdb1025f1b3cd$var$Xd(b);
        return b;
    }
};
if ($658cdb1025f1b3cd$var$pa) throw Error($658cdb1025f1b3cd$var$u(101));
$658cdb1025f1b3cd$var$pa = Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
$658cdb1025f1b3cd$var$ra();
var $658cdb1025f1b3cd$var$xf = $658cdb1025f1b3cd$var$Nc;
$658cdb1025f1b3cd$var$la = $658cdb1025f1b3cd$var$Qd;
$658cdb1025f1b3cd$var$ma = $658cdb1025f1b3cd$var$xf;
$658cdb1025f1b3cd$var$na = $658cdb1025f1b3cd$var$Pd;
$658cdb1025f1b3cd$var$xa({
    SimpleEventPlugin: $658cdb1025f1b3cd$var$wf,
    EnterLeaveEventPlugin: $658cdb1025f1b3cd$var$Ye,
    ChangeEventPlugin: $658cdb1025f1b3cd$var$Me,
    SelectEventPlugin: $658cdb1025f1b3cd$var$kf,
    BeforeInputEventPlugin: $658cdb1025f1b3cd$var$ve
});
var $658cdb1025f1b3cd$var$yf = [], $658cdb1025f1b3cd$var$zf = -1;
function $658cdb1025f1b3cd$var$H(a) {
    0 > $658cdb1025f1b3cd$var$zf || (a.current = $658cdb1025f1b3cd$var$yf[$658cdb1025f1b3cd$var$zf], $658cdb1025f1b3cd$var$yf[$658cdb1025f1b3cd$var$zf] = null, $658cdb1025f1b3cd$var$zf--);
}
function $658cdb1025f1b3cd$var$I(a, b) {
    $658cdb1025f1b3cd$var$zf++;
    $658cdb1025f1b3cd$var$yf[$658cdb1025f1b3cd$var$zf] = a.current;
    a.current = b;
}
var $658cdb1025f1b3cd$var$Af = {}, $658cdb1025f1b3cd$var$J = {
    current: $658cdb1025f1b3cd$var$Af
}, $658cdb1025f1b3cd$var$K = {
    current: !1
}, $658cdb1025f1b3cd$var$Bf = $658cdb1025f1b3cd$var$Af;
function $658cdb1025f1b3cd$var$Cf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $658cdb1025f1b3cd$var$Af;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $658cdb1025f1b3cd$var$L(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $658cdb1025f1b3cd$var$Df() {
    $658cdb1025f1b3cd$var$H($658cdb1025f1b3cd$var$K);
    $658cdb1025f1b3cd$var$H($658cdb1025f1b3cd$var$J);
}
function $658cdb1025f1b3cd$var$Ef(a, b, c) {
    if ($658cdb1025f1b3cd$var$J.current !== $658cdb1025f1b3cd$var$Af) throw Error($658cdb1025f1b3cd$var$u(168));
    $658cdb1025f1b3cd$var$I($658cdb1025f1b3cd$var$J, b);
    $658cdb1025f1b3cd$var$I($658cdb1025f1b3cd$var$K, c);
}
function $658cdb1025f1b3cd$var$Ff(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error($658cdb1025f1b3cd$var$u(108, $658cdb1025f1b3cd$var$pb(b) || "Unknown", e));
    return $22Kv0({}, c, {}, d);
}
function $658cdb1025f1b3cd$var$Gf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $658cdb1025f1b3cd$var$Af;
    $658cdb1025f1b3cd$var$Bf = $658cdb1025f1b3cd$var$J.current;
    $658cdb1025f1b3cd$var$I($658cdb1025f1b3cd$var$J, a);
    $658cdb1025f1b3cd$var$I($658cdb1025f1b3cd$var$K, $658cdb1025f1b3cd$var$K.current);
    return !0;
}
function $658cdb1025f1b3cd$var$Hf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($658cdb1025f1b3cd$var$u(169));
    c ? (a = $658cdb1025f1b3cd$var$Ff(a, b, $658cdb1025f1b3cd$var$Bf), d.__reactInternalMemoizedMergedChildContext = a, $658cdb1025f1b3cd$var$H($658cdb1025f1b3cd$var$K), $658cdb1025f1b3cd$var$H($658cdb1025f1b3cd$var$J), $658cdb1025f1b3cd$var$I($658cdb1025f1b3cd$var$J, a)) : $658cdb1025f1b3cd$var$H($658cdb1025f1b3cd$var$K);
    $658cdb1025f1b3cd$var$I($658cdb1025f1b3cd$var$K, c);
}
var $658cdb1025f1b3cd$var$If = $lze1c.unstable_runWithPriority, $658cdb1025f1b3cd$var$Jf = $lze1c.unstable_scheduleCallback, $658cdb1025f1b3cd$var$Kf = $lze1c.unstable_cancelCallback, $658cdb1025f1b3cd$var$Lf = $lze1c.unstable_requestPaint, $658cdb1025f1b3cd$var$Mf = $lze1c.unstable_now, $658cdb1025f1b3cd$var$Nf = $lze1c.unstable_getCurrentPriorityLevel, $658cdb1025f1b3cd$var$Of = $lze1c.unstable_ImmediatePriority, $658cdb1025f1b3cd$var$Pf = $lze1c.unstable_UserBlockingPriority, $658cdb1025f1b3cd$var$Qf = $lze1c.unstable_NormalPriority, $658cdb1025f1b3cd$var$Rf = $lze1c.unstable_LowPriority, $658cdb1025f1b3cd$var$Sf = $lze1c.unstable_IdlePriority, $658cdb1025f1b3cd$var$Tf = {}, $658cdb1025f1b3cd$var$Uf = $lze1c.unstable_shouldYield, $658cdb1025f1b3cd$var$Vf = void 0 !== $658cdb1025f1b3cd$var$Lf ? $658cdb1025f1b3cd$var$Lf : function() {}, $658cdb1025f1b3cd$var$Wf = null, $658cdb1025f1b3cd$var$Xf = null, $658cdb1025f1b3cd$var$Yf = !1, $658cdb1025f1b3cd$var$Zf = $658cdb1025f1b3cd$var$Mf(), $658cdb1025f1b3cd$var$$f = 1E4 > $658cdb1025f1b3cd$var$Zf ? $658cdb1025f1b3cd$var$Mf : function() {
    return $658cdb1025f1b3cd$var$Mf() - $658cdb1025f1b3cd$var$Zf;
};
function $658cdb1025f1b3cd$var$ag() {
    switch($658cdb1025f1b3cd$var$Nf()){
        case $658cdb1025f1b3cd$var$Of:
            return 99;
        case $658cdb1025f1b3cd$var$Pf:
            return 98;
        case $658cdb1025f1b3cd$var$Qf:
            return 97;
        case $658cdb1025f1b3cd$var$Rf:
            return 96;
        case $658cdb1025f1b3cd$var$Sf:
            return 95;
        default:
            throw Error($658cdb1025f1b3cd$var$u(332));
    }
}
function $658cdb1025f1b3cd$var$bg(a) {
    switch(a){
        case 99:
            return $658cdb1025f1b3cd$var$Of;
        case 98:
            return $658cdb1025f1b3cd$var$Pf;
        case 97:
            return $658cdb1025f1b3cd$var$Qf;
        case 96:
            return $658cdb1025f1b3cd$var$Rf;
        case 95:
            return $658cdb1025f1b3cd$var$Sf;
        default:
            throw Error($658cdb1025f1b3cd$var$u(332));
    }
}
function $658cdb1025f1b3cd$var$cg(a, b) {
    a = $658cdb1025f1b3cd$var$bg(a);
    return $658cdb1025f1b3cd$var$If(a, b);
}
function $658cdb1025f1b3cd$var$dg(a, b, c) {
    a = $658cdb1025f1b3cd$var$bg(a);
    return $658cdb1025f1b3cd$var$Jf(a, b, c);
}
function $658cdb1025f1b3cd$var$eg(a) {
    null === $658cdb1025f1b3cd$var$Wf ? ($658cdb1025f1b3cd$var$Wf = [
        a
    ], $658cdb1025f1b3cd$var$Xf = $658cdb1025f1b3cd$var$Jf($658cdb1025f1b3cd$var$Of, $658cdb1025f1b3cd$var$fg)) : $658cdb1025f1b3cd$var$Wf.push(a);
    return $658cdb1025f1b3cd$var$Tf;
}
function $658cdb1025f1b3cd$var$gg() {
    if (null !== $658cdb1025f1b3cd$var$Xf) {
        var a = $658cdb1025f1b3cd$var$Xf;
        $658cdb1025f1b3cd$var$Xf = null;
        $658cdb1025f1b3cd$var$Kf(a);
    }
    $658cdb1025f1b3cd$var$fg();
}
function $658cdb1025f1b3cd$var$fg() {
    if (!$658cdb1025f1b3cd$var$Yf && null !== $658cdb1025f1b3cd$var$Wf) {
        $658cdb1025f1b3cd$var$Yf = !0;
        var a = 0;
        try {
            var b = $658cdb1025f1b3cd$var$Wf;
            $658cdb1025f1b3cd$var$cg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            $658cdb1025f1b3cd$var$Wf = null;
        } catch (c) {
            throw null !== $658cdb1025f1b3cd$var$Wf && ($658cdb1025f1b3cd$var$Wf = $658cdb1025f1b3cd$var$Wf.slice(a + 1)), $658cdb1025f1b3cd$var$Jf($658cdb1025f1b3cd$var$Of, $658cdb1025f1b3cd$var$gg), c;
        } finally{
            $658cdb1025f1b3cd$var$Yf = !1;
        }
    }
}
function $658cdb1025f1b3cd$var$hg(a, b, c) {
    c /= 10;
    return 1073741821 - (((1073741821 - a + b / 10) / c | 0) + 1) * c;
}
function $658cdb1025f1b3cd$var$ig(a, b) {
    if (a && a.defaultProps) {
        b = $22Kv0({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
    }
    return b;
}
var $658cdb1025f1b3cd$var$jg = {
    current: null
}, $658cdb1025f1b3cd$var$kg = null, $658cdb1025f1b3cd$var$lg = null, $658cdb1025f1b3cd$var$mg = null;
function $658cdb1025f1b3cd$var$ng() {
    $658cdb1025f1b3cd$var$mg = $658cdb1025f1b3cd$var$lg = $658cdb1025f1b3cd$var$kg = null;
}
function $658cdb1025f1b3cd$var$og(a) {
    var b = $658cdb1025f1b3cd$var$jg.current;
    $658cdb1025f1b3cd$var$H($658cdb1025f1b3cd$var$jg);
    a.type._context._currentValue = b;
}
function $658cdb1025f1b3cd$var$pg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if (a.childExpirationTime < b) a.childExpirationTime = b, null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
        else if (null !== c && c.childExpirationTime < b) c.childExpirationTime = b;
        else break;
        a = a.return;
    }
}
function $658cdb1025f1b3cd$var$qg(a, b) {
    $658cdb1025f1b3cd$var$kg = a;
    $658cdb1025f1b3cd$var$mg = $658cdb1025f1b3cd$var$lg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (a.expirationTime >= b && ($658cdb1025f1b3cd$var$rg = !0), a.firstContext = null);
}
function $658cdb1025f1b3cd$var$sg(a, b) {
    if ($658cdb1025f1b3cd$var$mg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) $658cdb1025f1b3cd$var$mg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === $658cdb1025f1b3cd$var$lg) {
            if (null === $658cdb1025f1b3cd$var$kg) throw Error($658cdb1025f1b3cd$var$u(308));
            $658cdb1025f1b3cd$var$lg = b;
            $658cdb1025f1b3cd$var$kg.dependencies = {
                expirationTime: 0,
                firstContext: b,
                responders: null
            };
        } else $658cdb1025f1b3cd$var$lg = $658cdb1025f1b3cd$var$lg.next = b;
    }
    return a._currentValue;
}
var $658cdb1025f1b3cd$var$tg = !1;
function $658cdb1025f1b3cd$var$ug(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        baseQueue: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function $658cdb1025f1b3cd$var$vg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        baseQueue: a.baseQueue,
        shared: a.shared,
        effects: a.effects
    });
}
function $658cdb1025f1b3cd$var$wg(a, b) {
    a = {
        expirationTime: a,
        suspenseConfig: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
    return a.next = a;
}
function $658cdb1025f1b3cd$var$xg(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function $658cdb1025f1b3cd$var$yg(a, b) {
    var c = a.alternate;
    null !== c && $658cdb1025f1b3cd$var$vg(c, a);
    a = a.updateQueue;
    c = a.baseQueue;
    null === c ? (a.baseQueue = b.next = b, b.next = b) : (b.next = c.next, c.next = b);
}
function $658cdb1025f1b3cd$var$zg(a, b, c, d) {
    var e = a.updateQueue;
    $658cdb1025f1b3cd$var$tg = !1;
    var f = e.baseQueue, g = e.shared.pending;
    if (null !== g) {
        if (null !== f) {
            var h = f.next;
            f.next = g.next;
            g.next = h;
        }
        f = g;
        e.shared.pending = null;
        h = a.alternate;
        null !== h && (h = h.updateQueue, null !== h && (h.baseQueue = g));
    }
    if (null !== f) {
        h = f.next;
        var k = e.baseState, l = 0, m = null, p = null, x = null;
        if (null !== h) {
            var z = h;
            do {
                g = z.expirationTime;
                if (g < d) {
                    var ca = {
                        expirationTime: z.expirationTime,
                        suspenseConfig: z.suspenseConfig,
                        tag: z.tag,
                        payload: z.payload,
                        callback: z.callback,
                        next: null
                    };
                    null === x ? (p = x = ca, m = k) : x = x.next = ca;
                    g > l && (l = g);
                } else {
                    null !== x && (x = x.next = {
                        expirationTime: 1073741823,
                        suspenseConfig: z.suspenseConfig,
                        tag: z.tag,
                        payload: z.payload,
                        callback: z.callback,
                        next: null
                    });
                    $658cdb1025f1b3cd$var$Ag(g, z.suspenseConfig);
                    a: {
                        var D = a, t = z;
                        g = b;
                        ca = c;
                        switch(t.tag){
                            case 1:
                                D = t.payload;
                                if ("function" === typeof D) {
                                    k = D.call(ca, k, g);
                                    break a;
                                }
                                k = D;
                                break a;
                            case 3:
                                D.effectTag = D.effectTag & -4097 | 64;
                            case 0:
                                D = t.payload;
                                g = "function" === typeof D ? D.call(ca, k, g) : D;
                                if (null === g || void 0 === g) break a;
                                k = $22Kv0({}, k, g);
                                break a;
                            case 2:
                                $658cdb1025f1b3cd$var$tg = !0;
                        }
                    }
                    null !== z.callback && (a.effectTag |= 32, g = e.effects, null === g ? e.effects = [
                        z
                    ] : g.push(z));
                }
                z = z.next;
                if (null === z || z === h) {
                    if (g = e.shared.pending, null === g) break;
                    else z = f.next = g.next, g.next = h, e.baseQueue = f = g, e.shared.pending = null;
                }
            }while (1);
        }
        null === x ? m = k : x.next = p;
        e.baseState = m;
        e.baseQueue = x;
        $658cdb1025f1b3cd$var$Bg(l);
        a.expirationTime = l;
        a.memoizedState = k;
    }
}
function $658cdb1025f1b3cd$var$Cg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = e;
            e = c;
            if ("function" !== typeof d) throw Error($658cdb1025f1b3cd$var$u(191, d));
            d.call(e);
        }
    }
}
var $658cdb1025f1b3cd$var$Dg = $658cdb1025f1b3cd$var$Wa.ReactCurrentBatchConfig, $658cdb1025f1b3cd$var$Eg = (new $g85JO.Component).refs;
function $658cdb1025f1b3cd$var$Fg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $22Kv0({}, b, c);
    a.memoizedState = c;
    0 === a.expirationTime && (a.updateQueue.baseState = c);
}
var $658cdb1025f1b3cd$var$Jg = {
    isMounted: function(a) {
        return (a = a._reactInternalFiber) ? $658cdb1025f1b3cd$var$dc(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternalFiber;
        var d = $658cdb1025f1b3cd$var$Gg(), e = $658cdb1025f1b3cd$var$Dg.suspense;
        d = $658cdb1025f1b3cd$var$Hg(d, a, e);
        e = $658cdb1025f1b3cd$var$wg(d, e);
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        $658cdb1025f1b3cd$var$xg(a, e);
        $658cdb1025f1b3cd$var$Ig(a, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternalFiber;
        var d = $658cdb1025f1b3cd$var$Gg(), e = $658cdb1025f1b3cd$var$Dg.suspense;
        d = $658cdb1025f1b3cd$var$Hg(d, a, e);
        e = $658cdb1025f1b3cd$var$wg(d, e);
        e.tag = 1;
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        $658cdb1025f1b3cd$var$xg(a, e);
        $658cdb1025f1b3cd$var$Ig(a, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternalFiber;
        var c = $658cdb1025f1b3cd$var$Gg(), d = $658cdb1025f1b3cd$var$Dg.suspense;
        c = $658cdb1025f1b3cd$var$Hg(c, a, d);
        d = $658cdb1025f1b3cd$var$wg(c, d);
        d.tag = 2;
        void 0 !== b && null !== b && (d.callback = b);
        $658cdb1025f1b3cd$var$xg(a, d);
        $658cdb1025f1b3cd$var$Ig(a, c);
    }
};
function $658cdb1025f1b3cd$var$Kg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$658cdb1025f1b3cd$var$bf(c, d) || !$658cdb1025f1b3cd$var$bf(e, f) : !0;
}
function $658cdb1025f1b3cd$var$Lg(a, b, c) {
    var d = !1, e = $658cdb1025f1b3cd$var$Af;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $658cdb1025f1b3cd$var$sg(f) : (e = $658cdb1025f1b3cd$var$L(b) ? $658cdb1025f1b3cd$var$Bf : $658cdb1025f1b3cd$var$J.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $658cdb1025f1b3cd$var$Cf(a, e) : $658cdb1025f1b3cd$var$Af);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $658cdb1025f1b3cd$var$Jg;
    a.stateNode = b;
    b._reactInternalFiber = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $658cdb1025f1b3cd$var$Mg(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $658cdb1025f1b3cd$var$Jg.enqueueReplaceState(b, b.state, null);
}
function $658cdb1025f1b3cd$var$Ng(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $658cdb1025f1b3cd$var$Eg;
    $658cdb1025f1b3cd$var$ug(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $658cdb1025f1b3cd$var$sg(f) : (f = $658cdb1025f1b3cd$var$L(b) ? $658cdb1025f1b3cd$var$Bf : $658cdb1025f1b3cd$var$J.current, e.context = $658cdb1025f1b3cd$var$Cf(a, f));
    $658cdb1025f1b3cd$var$zg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($658cdb1025f1b3cd$var$Fg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $658cdb1025f1b3cd$var$Jg.enqueueReplaceState(e, e.state, null), $658cdb1025f1b3cd$var$zg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.effectTag |= 4);
}
var $658cdb1025f1b3cd$var$Og = Array.isArray;
function $658cdb1025f1b3cd$var$Pg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($658cdb1025f1b3cd$var$u(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($658cdb1025f1b3cd$var$u(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === $658cdb1025f1b3cd$var$Eg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error($658cdb1025f1b3cd$var$u(284));
        if (!c._owner) throw Error($658cdb1025f1b3cd$var$u(290, a));
    }
    return a;
}
function $658cdb1025f1b3cd$var$Qg(a, b) {
    if ("textarea" !== a.type) throw Error($658cdb1025f1b3cd$var$u(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b, ""));
}
function $658cdb1025f1b3cd$var$Rg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.effectTag = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $658cdb1025f1b3cd$var$Sg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.effectTag = 2, c) : d;
        b.effectTag = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.effectTag = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $658cdb1025f1b3cd$var$Tg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = $658cdb1025f1b3cd$var$Pg(a, b, c), d.return = a, d;
        d = $658cdb1025f1b3cd$var$Ug(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $658cdb1025f1b3cd$var$Pg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $658cdb1025f1b3cd$var$Vg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $658cdb1025f1b3cd$var$Wg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function p(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = $658cdb1025f1b3cd$var$Tg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $658cdb1025f1b3cd$var$Za:
                    return c = $658cdb1025f1b3cd$var$Ug(b.type, b.key, b.props, null, a.mode, c), c.ref = $658cdb1025f1b3cd$var$Pg(a, null, b), c.return = a, c;
                case $658cdb1025f1b3cd$var$$a:
                    return b = $658cdb1025f1b3cd$var$Vg(b, a.mode, c), b.return = a, b;
            }
            if ($658cdb1025f1b3cd$var$Og(b) || $658cdb1025f1b3cd$var$nb(b)) return b = $658cdb1025f1b3cd$var$Wg(b, a.mode, c, null), b.return = a, b;
            $658cdb1025f1b3cd$var$Qg(a, b);
        }
        return null;
    }
    function x(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $658cdb1025f1b3cd$var$Za:
                    return c.key === e ? c.type === $658cdb1025f1b3cd$var$ab ? m(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case $658cdb1025f1b3cd$var$$a:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if ($658cdb1025f1b3cd$var$Og(c) || $658cdb1025f1b3cd$var$nb(c)) return null !== e ? null : m(a, b, c, d, null);
            $658cdb1025f1b3cd$var$Qg(a, c);
        }
        return null;
    }
    function z(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $658cdb1025f1b3cd$var$Za:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === $658cdb1025f1b3cd$var$ab ? m(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case $658cdb1025f1b3cd$var$$a:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if ($658cdb1025f1b3cd$var$Og(d) || $658cdb1025f1b3cd$var$nb(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $658cdb1025f1b3cd$var$Qg(b, d);
        }
        return null;
    }
    function ca(e, g, h, k) {
        for(var l = null, t = null, m = g, y = g = 0, A = null; null !== m && y < h.length; y++){
            m.index > y ? (A = m, m = null) : A = m.sibling;
            var q = x(e, m, h[y], k);
            if (null === q) {
                null === m && (m = A);
                break;
            }
            a && m && null === q.alternate && b(e, m);
            g = f(q, g, y);
            null === t ? l = q : t.sibling = q;
            t = q;
            m = A;
        }
        if (y === h.length) return c(e, m), l;
        if (null === m) {
            for(; y < h.length; y++)m = p(e, h[y], k), null !== m && (g = f(m, g, y), null === t ? l = m : t.sibling = m, t = m);
            return l;
        }
        for(m = d(e, m); y < h.length; y++)A = z(m, e, y, h[y], k), null !== A && (a && null !== A.alternate && m.delete(null === A.key ? y : A.key), g = f(A, g, y), null === t ? l = A : t.sibling = A, t = A);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function D(e, g, h, l) {
        var k = $658cdb1025f1b3cd$var$nb(h);
        if ("function" !== typeof k) throw Error($658cdb1025f1b3cd$var$u(150));
        h = k.call(h);
        if (null == h) throw Error($658cdb1025f1b3cd$var$u(151));
        for(var m = k = null, t = g, y = g = 0, A = null, q = h.next(); null !== t && !q.done; y++, q = h.next()){
            t.index > y ? (A = t, t = null) : A = t.sibling;
            var D = x(e, t, q.value, l);
            if (null === D) {
                null === t && (t = A);
                break;
            }
            a && t && null === D.alternate && b(e, t);
            g = f(D, g, y);
            null === m ? k = D : m.sibling = D;
            m = D;
            t = A;
        }
        if (q.done) return c(e, t), k;
        if (null === t) {
            for(; !q.done; y++, q = h.next())q = p(e, q.value, l), null !== q && (g = f(q, g, y), null === m ? k = q : m.sibling = q, m = q);
            return k;
        }
        for(t = d(e, t); !q.done; y++, q = h.next())q = z(t, e, y, q.value, l), null !== q && (a && null !== q.alternate && t.delete(null === q.key ? y : q.key), g = f(q, g, y), null === m ? k = q : m.sibling = q, m = q);
        a && t.forEach(function(a) {
            return b(e, a);
        });
        return k;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === $658cdb1025f1b3cd$var$ab && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case $658cdb1025f1b3cd$var$Za:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === $658cdb1025f1b3cd$var$ab) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = $658cdb1025f1b3cd$var$Pg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === $658cdb1025f1b3cd$var$ab ? (d = $658cdb1025f1b3cd$var$Wg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $658cdb1025f1b3cd$var$Ug(f.type, f.key, f.props, null, a.mode, h), h.ref = $658cdb1025f1b3cd$var$Pg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case $658cdb1025f1b3cd$var$$a:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = $658cdb1025f1b3cd$var$Vg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $658cdb1025f1b3cd$var$Tg(f, a.mode, h), d.return = a, a = d), g(a);
        if ($658cdb1025f1b3cd$var$Og(f)) return ca(a, d, f, h);
        if ($658cdb1025f1b3cd$var$nb(f)) return D(a, d, f, h);
        l && $658cdb1025f1b3cd$var$Qg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 0:
                throw a = a.type, Error($658cdb1025f1b3cd$var$u(152, a.displayName || a.name || "Component"));
        }
        return c(a, d);
    };
}
var $658cdb1025f1b3cd$var$Xg = $658cdb1025f1b3cd$var$Rg(!0), $658cdb1025f1b3cd$var$Yg = $658cdb1025f1b3cd$var$Rg(!1), $658cdb1025f1b3cd$var$Zg = {}, $658cdb1025f1b3cd$var$$g = {
    current: $658cdb1025f1b3cd$var$Zg
}, $658cdb1025f1b3cd$var$ah = {
    current: $658cdb1025f1b3cd$var$Zg
}, $658cdb1025f1b3cd$var$bh = {
    current: $658cdb1025f1b3cd$var$Zg
};
function $658cdb1025f1b3cd$var$ch(a) {
    if (a === $658cdb1025f1b3cd$var$Zg) throw Error($658cdb1025f1b3cd$var$u(174));
    return a;
}
function $658cdb1025f1b3cd$var$dh(a, b) {
    $658cdb1025f1b3cd$var$I($658cdb1025f1b3cd$var$bh, b);
    $658cdb1025f1b3cd$var$I($658cdb1025f1b3cd$var$ah, a);
    $658cdb1025f1b3cd$var$I($658cdb1025f1b3cd$var$$g, $658cdb1025f1b3cd$var$Zg);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $658cdb1025f1b3cd$var$Ob(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $658cdb1025f1b3cd$var$Ob(b, a);
    }
    $658cdb1025f1b3cd$var$H($658cdb1025f1b3cd$var$$g);
    $658cdb1025f1b3cd$var$I($658cdb1025f1b3cd$var$$g, b);
}
function $658cdb1025f1b3cd$var$eh() {
    $658cdb1025f1b3cd$var$H($658cdb1025f1b3cd$var$$g);
    $658cdb1025f1b3cd$var$H($658cdb1025f1b3cd$var$ah);
    $658cdb1025f1b3cd$var$H($658cdb1025f1b3cd$var$bh);
}
function $658cdb1025f1b3cd$var$fh(a) {
    $658cdb1025f1b3cd$var$ch($658cdb1025f1b3cd$var$bh.current);
    var b = $658cdb1025f1b3cd$var$ch($658cdb1025f1b3cd$var$$g.current);
    var c = $658cdb1025f1b3cd$var$Ob(b, a.type);
    b !== c && ($658cdb1025f1b3cd$var$I($658cdb1025f1b3cd$var$ah, a), $658cdb1025f1b3cd$var$I($658cdb1025f1b3cd$var$$g, c));
}
function $658cdb1025f1b3cd$var$gh(a) {
    $658cdb1025f1b3cd$var$ah.current === a && ($658cdb1025f1b3cd$var$H($658cdb1025f1b3cd$var$$g), $658cdb1025f1b3cd$var$H($658cdb1025f1b3cd$var$ah));
}
var $658cdb1025f1b3cd$var$M = {
    current: 0
};
function $658cdb1025f1b3cd$var$hh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || c.data === $658cdb1025f1b3cd$var$Bd || c.data === $658cdb1025f1b3cd$var$Cd)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.effectTag & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
function $658cdb1025f1b3cd$var$ih(a, b) {
    return {
        responder: a,
        props: b
    };
}
var $658cdb1025f1b3cd$var$jh = $658cdb1025f1b3cd$var$Wa.ReactCurrentDispatcher, $658cdb1025f1b3cd$var$kh = $658cdb1025f1b3cd$var$Wa.ReactCurrentBatchConfig, $658cdb1025f1b3cd$var$lh = 0, $658cdb1025f1b3cd$var$N = null, $658cdb1025f1b3cd$var$O = null, $658cdb1025f1b3cd$var$P = null, $658cdb1025f1b3cd$var$mh = !1;
function $658cdb1025f1b3cd$var$Q() {
    throw Error($658cdb1025f1b3cd$var$u(321));
}
function $658cdb1025f1b3cd$var$nh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$658cdb1025f1b3cd$var$$e(a[c], b[c])) return !1;
    return !0;
}
function $658cdb1025f1b3cd$var$oh(a, b, c, d, e, f) {
    $658cdb1025f1b3cd$var$lh = f;
    $658cdb1025f1b3cd$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.expirationTime = 0;
    $658cdb1025f1b3cd$var$jh.current = null === a || null === a.memoizedState ? $658cdb1025f1b3cd$var$ph : $658cdb1025f1b3cd$var$qh;
    a = c(d, e);
    if (b.expirationTime === $658cdb1025f1b3cd$var$lh) {
        f = 0;
        do {
            b.expirationTime = 0;
            if (!(25 > f)) throw Error($658cdb1025f1b3cd$var$u(301));
            f += 1;
            $658cdb1025f1b3cd$var$P = $658cdb1025f1b3cd$var$O = null;
            b.updateQueue = null;
            $658cdb1025f1b3cd$var$jh.current = $658cdb1025f1b3cd$var$rh;
            a = c(d, e);
        }while (b.expirationTime === $658cdb1025f1b3cd$var$lh);
    }
    $658cdb1025f1b3cd$var$jh.current = $658cdb1025f1b3cd$var$sh;
    b = null !== $658cdb1025f1b3cd$var$O && null !== $658cdb1025f1b3cd$var$O.next;
    $658cdb1025f1b3cd$var$lh = 0;
    $658cdb1025f1b3cd$var$P = $658cdb1025f1b3cd$var$O = $658cdb1025f1b3cd$var$N = null;
    $658cdb1025f1b3cd$var$mh = !1;
    if (b) throw Error($658cdb1025f1b3cd$var$u(300));
    return a;
}
function $658cdb1025f1b3cd$var$th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $658cdb1025f1b3cd$var$P ? $658cdb1025f1b3cd$var$N.memoizedState = $658cdb1025f1b3cd$var$P = a : $658cdb1025f1b3cd$var$P = $658cdb1025f1b3cd$var$P.next = a;
    return $658cdb1025f1b3cd$var$P;
}
function $658cdb1025f1b3cd$var$uh() {
    if (null === $658cdb1025f1b3cd$var$O) {
        var a = $658cdb1025f1b3cd$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $658cdb1025f1b3cd$var$O.next;
    var b = null === $658cdb1025f1b3cd$var$P ? $658cdb1025f1b3cd$var$N.memoizedState : $658cdb1025f1b3cd$var$P.next;
    if (null !== b) $658cdb1025f1b3cd$var$P = b, $658cdb1025f1b3cd$var$O = a;
    else {
        if (null === a) throw Error($658cdb1025f1b3cd$var$u(310));
        $658cdb1025f1b3cd$var$O = a;
        a = {
            memoizedState: $658cdb1025f1b3cd$var$O.memoizedState,
            baseState: $658cdb1025f1b3cd$var$O.baseState,
            baseQueue: $658cdb1025f1b3cd$var$O.baseQueue,
            queue: $658cdb1025f1b3cd$var$O.queue,
            next: null
        };
        null === $658cdb1025f1b3cd$var$P ? $658cdb1025f1b3cd$var$N.memoizedState = $658cdb1025f1b3cd$var$P = a : $658cdb1025f1b3cd$var$P = $658cdb1025f1b3cd$var$P.next = a;
    }
    return $658cdb1025f1b3cd$var$P;
}
function $658cdb1025f1b3cd$var$vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $658cdb1025f1b3cd$var$wh(a) {
    var b = $658cdb1025f1b3cd$var$uh(), c = b.queue;
    if (null === c) throw Error($658cdb1025f1b3cd$var$u(311));
    c.lastRenderedReducer = a;
    var d = $658cdb1025f1b3cd$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.expirationTime;
            if (l < $658cdb1025f1b3cd$var$lh) {
                var m = {
                    expirationTime: k.expirationTime,
                    suspenseConfig: k.suspenseConfig,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = m, f = d) : h = h.next = m;
                l > $658cdb1025f1b3cd$var$N.expirationTime && ($658cdb1025f1b3cd$var$N.expirationTime = l, $658cdb1025f1b3cd$var$Bg(l));
            } else null !== h && (h = h.next = {
                expirationTime: 1073741823,
                suspenseConfig: k.suspenseConfig,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), $658cdb1025f1b3cd$var$Ag(l, k.suspenseConfig), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        $658cdb1025f1b3cd$var$$e(d, b.memoizedState) || ($658cdb1025f1b3cd$var$rg = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $658cdb1025f1b3cd$var$xh(a) {
    var b = $658cdb1025f1b3cd$var$uh(), c = b.queue;
    if (null === c) throw Error($658cdb1025f1b3cd$var$u(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $658cdb1025f1b3cd$var$$e(f, b.memoizedState) || ($658cdb1025f1b3cd$var$rg = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $658cdb1025f1b3cd$var$yh(a) {
    var b = $658cdb1025f1b3cd$var$th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: $658cdb1025f1b3cd$var$vh,
        lastRenderedState: a
    };
    a = a.dispatch = $658cdb1025f1b3cd$var$zh.bind(null, $658cdb1025f1b3cd$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $658cdb1025f1b3cd$var$Ah(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $658cdb1025f1b3cd$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, $658cdb1025f1b3cd$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $658cdb1025f1b3cd$var$Bh() {
    return $658cdb1025f1b3cd$var$uh().memoizedState;
}
function $658cdb1025f1b3cd$var$Ch(a, b, c, d) {
    var e = $658cdb1025f1b3cd$var$th();
    $658cdb1025f1b3cd$var$N.effectTag |= a;
    e.memoizedState = $658cdb1025f1b3cd$var$Ah(1 | b, c, void 0, void 0 === d ? null : d);
}
function $658cdb1025f1b3cd$var$Dh(a, b, c, d) {
    var e = $658cdb1025f1b3cd$var$uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $658cdb1025f1b3cd$var$O) {
        var g = $658cdb1025f1b3cd$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $658cdb1025f1b3cd$var$nh(d, g.deps)) {
            $658cdb1025f1b3cd$var$Ah(b, c, f, d);
            return;
        }
    }
    $658cdb1025f1b3cd$var$N.effectTag |= a;
    e.memoizedState = $658cdb1025f1b3cd$var$Ah(1 | b, c, f, d);
}
function $658cdb1025f1b3cd$var$Eh(a, b) {
    return $658cdb1025f1b3cd$var$Ch(516, 4, a, b);
}
function $658cdb1025f1b3cd$var$Fh(a, b) {
    return $658cdb1025f1b3cd$var$Dh(516, 4, a, b);
}
function $658cdb1025f1b3cd$var$Gh(a, b) {
    return $658cdb1025f1b3cd$var$Dh(4, 2, a, b);
}
function $658cdb1025f1b3cd$var$Hh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $658cdb1025f1b3cd$var$Ih(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $658cdb1025f1b3cd$var$Dh(4, 2, $658cdb1025f1b3cd$var$Hh.bind(null, b, a), c);
}
function $658cdb1025f1b3cd$var$Jh() {}
function $658cdb1025f1b3cd$var$Kh(a, b) {
    $658cdb1025f1b3cd$var$th().memoizedState = [
        a,
        void 0 === b ? null : b
    ];
    return a;
}
function $658cdb1025f1b3cd$var$Lh(a, b) {
    var c = $658cdb1025f1b3cd$var$uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $658cdb1025f1b3cd$var$nh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $658cdb1025f1b3cd$var$Mh(a, b) {
    var c = $658cdb1025f1b3cd$var$uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $658cdb1025f1b3cd$var$nh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $658cdb1025f1b3cd$var$Nh(a, b, c) {
    var d = $658cdb1025f1b3cd$var$ag();
    $658cdb1025f1b3cd$var$cg(98 > d ? 98 : d, function() {
        a(!0);
    });
    $658cdb1025f1b3cd$var$cg(97 < d ? 97 : d, function() {
        var d = $658cdb1025f1b3cd$var$kh.suspense;
        $658cdb1025f1b3cd$var$kh.suspense = void 0 === b ? null : b;
        try {
            a(!1), c();
        } finally{
            $658cdb1025f1b3cd$var$kh.suspense = d;
        }
    });
}
function $658cdb1025f1b3cd$var$zh(a, b, c) {
    var d = $658cdb1025f1b3cd$var$Gg(), e = $658cdb1025f1b3cd$var$Dg.suspense;
    d = $658cdb1025f1b3cd$var$Hg(d, a, e);
    e = {
        expirationTime: d,
        suspenseConfig: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    };
    var f = b.pending;
    null === f ? e.next = e : (e.next = f.next, f.next = e);
    b.pending = e;
    f = a.alternate;
    if (a === $658cdb1025f1b3cd$var$N || null !== f && f === $658cdb1025f1b3cd$var$N) $658cdb1025f1b3cd$var$mh = !0, e.expirationTime = $658cdb1025f1b3cd$var$lh, $658cdb1025f1b3cd$var$N.expirationTime = $658cdb1025f1b3cd$var$lh;
    else {
        if (0 === a.expirationTime && (null === f || 0 === f.expirationTime) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.eagerReducer = f;
            e.eagerState = h;
            if ($658cdb1025f1b3cd$var$$e(h, g)) return;
        } catch (k) {} finally{}
        $658cdb1025f1b3cd$var$Ig(a, d);
    }
}
var $658cdb1025f1b3cd$var$sh = {
    readContext: $658cdb1025f1b3cd$var$sg,
    useCallback: $658cdb1025f1b3cd$var$Q,
    useContext: $658cdb1025f1b3cd$var$Q,
    useEffect: $658cdb1025f1b3cd$var$Q,
    useImperativeHandle: $658cdb1025f1b3cd$var$Q,
    useLayoutEffect: $658cdb1025f1b3cd$var$Q,
    useMemo: $658cdb1025f1b3cd$var$Q,
    useReducer: $658cdb1025f1b3cd$var$Q,
    useRef: $658cdb1025f1b3cd$var$Q,
    useState: $658cdb1025f1b3cd$var$Q,
    useDebugValue: $658cdb1025f1b3cd$var$Q,
    useResponder: $658cdb1025f1b3cd$var$Q,
    useDeferredValue: $658cdb1025f1b3cd$var$Q,
    useTransition: $658cdb1025f1b3cd$var$Q
}, $658cdb1025f1b3cd$var$ph = {
    readContext: $658cdb1025f1b3cd$var$sg,
    useCallback: $658cdb1025f1b3cd$var$Kh,
    useContext: $658cdb1025f1b3cd$var$sg,
    useEffect: $658cdb1025f1b3cd$var$Eh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $658cdb1025f1b3cd$var$Ch(4, 2, $658cdb1025f1b3cd$var$Hh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $658cdb1025f1b3cd$var$Ch(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $658cdb1025f1b3cd$var$th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $658cdb1025f1b3cd$var$th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = $658cdb1025f1b3cd$var$zh.bind(null, $658cdb1025f1b3cd$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $658cdb1025f1b3cd$var$th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $658cdb1025f1b3cd$var$yh,
    useDebugValue: $658cdb1025f1b3cd$var$Jh,
    useResponder: $658cdb1025f1b3cd$var$ih,
    useDeferredValue: function(a, b) {
        var c = $658cdb1025f1b3cd$var$yh(a), d = c[0], e = c[1];
        $658cdb1025f1b3cd$var$Eh(function() {
            var c = $658cdb1025f1b3cd$var$kh.suspense;
            $658cdb1025f1b3cd$var$kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                $658cdb1025f1b3cd$var$kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = $658cdb1025f1b3cd$var$yh(!1), c = b[0];
        b = b[1];
        return [
            $658cdb1025f1b3cd$var$Kh($658cdb1025f1b3cd$var$Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, $658cdb1025f1b3cd$var$qh = {
    readContext: $658cdb1025f1b3cd$var$sg,
    useCallback: $658cdb1025f1b3cd$var$Lh,
    useContext: $658cdb1025f1b3cd$var$sg,
    useEffect: $658cdb1025f1b3cd$var$Fh,
    useImperativeHandle: $658cdb1025f1b3cd$var$Ih,
    useLayoutEffect: $658cdb1025f1b3cd$var$Gh,
    useMemo: $658cdb1025f1b3cd$var$Mh,
    useReducer: $658cdb1025f1b3cd$var$wh,
    useRef: $658cdb1025f1b3cd$var$Bh,
    useState: function() {
        return $658cdb1025f1b3cd$var$wh($658cdb1025f1b3cd$var$vh);
    },
    useDebugValue: $658cdb1025f1b3cd$var$Jh,
    useResponder: $658cdb1025f1b3cd$var$ih,
    useDeferredValue: function(a, b) {
        var c = $658cdb1025f1b3cd$var$wh($658cdb1025f1b3cd$var$vh), d = c[0], e = c[1];
        $658cdb1025f1b3cd$var$Fh(function() {
            var c = $658cdb1025f1b3cd$var$kh.suspense;
            $658cdb1025f1b3cd$var$kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                $658cdb1025f1b3cd$var$kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = $658cdb1025f1b3cd$var$wh($658cdb1025f1b3cd$var$vh), c = b[0];
        b = b[1];
        return [
            $658cdb1025f1b3cd$var$Lh($658cdb1025f1b3cd$var$Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, $658cdb1025f1b3cd$var$rh = {
    readContext: $658cdb1025f1b3cd$var$sg,
    useCallback: $658cdb1025f1b3cd$var$Lh,
    useContext: $658cdb1025f1b3cd$var$sg,
    useEffect: $658cdb1025f1b3cd$var$Fh,
    useImperativeHandle: $658cdb1025f1b3cd$var$Ih,
    useLayoutEffect: $658cdb1025f1b3cd$var$Gh,
    useMemo: $658cdb1025f1b3cd$var$Mh,
    useReducer: $658cdb1025f1b3cd$var$xh,
    useRef: $658cdb1025f1b3cd$var$Bh,
    useState: function() {
        return $658cdb1025f1b3cd$var$xh($658cdb1025f1b3cd$var$vh);
    },
    useDebugValue: $658cdb1025f1b3cd$var$Jh,
    useResponder: $658cdb1025f1b3cd$var$ih,
    useDeferredValue: function(a, b) {
        var c = $658cdb1025f1b3cd$var$xh($658cdb1025f1b3cd$var$vh), d = c[0], e = c[1];
        $658cdb1025f1b3cd$var$Fh(function() {
            var c = $658cdb1025f1b3cd$var$kh.suspense;
            $658cdb1025f1b3cd$var$kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                $658cdb1025f1b3cd$var$kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = $658cdb1025f1b3cd$var$xh($658cdb1025f1b3cd$var$vh), c = b[0];
        b = b[1];
        return [
            $658cdb1025f1b3cd$var$Lh($658cdb1025f1b3cd$var$Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, $658cdb1025f1b3cd$var$Oh = null, $658cdb1025f1b3cd$var$Ph = null, $658cdb1025f1b3cd$var$Qh = !1;
function $658cdb1025f1b3cd$var$Rh(a, b) {
    var c = $658cdb1025f1b3cd$var$Sh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.effectTag = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function $658cdb1025f1b3cd$var$Th(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function $658cdb1025f1b3cd$var$Uh(a) {
    if ($658cdb1025f1b3cd$var$Qh) {
        var b = $658cdb1025f1b3cd$var$Ph;
        if (b) {
            var c = b;
            if (!$658cdb1025f1b3cd$var$Th(a, b)) {
                b = $658cdb1025f1b3cd$var$Jd(c.nextSibling);
                if (!b || !$658cdb1025f1b3cd$var$Th(a, b)) {
                    a.effectTag = a.effectTag & -1025 | 2;
                    $658cdb1025f1b3cd$var$Qh = !1;
                    $658cdb1025f1b3cd$var$Oh = a;
                    return;
                }
                $658cdb1025f1b3cd$var$Rh($658cdb1025f1b3cd$var$Oh, c);
            }
            $658cdb1025f1b3cd$var$Oh = a;
            $658cdb1025f1b3cd$var$Ph = $658cdb1025f1b3cd$var$Jd(b.firstChild);
        } else a.effectTag = a.effectTag & -1025 | 2, $658cdb1025f1b3cd$var$Qh = !1, $658cdb1025f1b3cd$var$Oh = a;
    }
}
function $658cdb1025f1b3cd$var$Vh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $658cdb1025f1b3cd$var$Oh = a;
}
function $658cdb1025f1b3cd$var$Wh(a) {
    if (a !== $658cdb1025f1b3cd$var$Oh) return !1;
    if (!$658cdb1025f1b3cd$var$Qh) return $658cdb1025f1b3cd$var$Vh(a), $658cdb1025f1b3cd$var$Qh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !$658cdb1025f1b3cd$var$Gd(b, a.memoizedProps)) for(b = $658cdb1025f1b3cd$var$Ph; b;)$658cdb1025f1b3cd$var$Rh(a, b), b = $658cdb1025f1b3cd$var$Jd(b.nextSibling);
    $658cdb1025f1b3cd$var$Vh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($658cdb1025f1b3cd$var$u(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if (c === $658cdb1025f1b3cd$var$Ad) {
                        if (0 === b) {
                            $658cdb1025f1b3cd$var$Ph = $658cdb1025f1b3cd$var$Jd(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else c !== $658cdb1025f1b3cd$var$zd && c !== $658cdb1025f1b3cd$var$Cd && c !== $658cdb1025f1b3cd$var$Bd || b++;
                }
                a = a.nextSibling;
            }
            $658cdb1025f1b3cd$var$Ph = null;
        }
    } else $658cdb1025f1b3cd$var$Ph = $658cdb1025f1b3cd$var$Oh ? $658cdb1025f1b3cd$var$Jd(a.stateNode.nextSibling) : null;
    return !0;
}
function $658cdb1025f1b3cd$var$Xh() {
    $658cdb1025f1b3cd$var$Ph = $658cdb1025f1b3cd$var$Oh = null;
    $658cdb1025f1b3cd$var$Qh = !1;
}
var $658cdb1025f1b3cd$var$Yh = $658cdb1025f1b3cd$var$Wa.ReactCurrentOwner, $658cdb1025f1b3cd$var$rg = !1;
function $658cdb1025f1b3cd$var$R(a, b, c, d) {
    b.child = null === a ? $658cdb1025f1b3cd$var$Yg(b, null, c, d) : $658cdb1025f1b3cd$var$Xg(b, a.child, c, d);
}
function $658cdb1025f1b3cd$var$Zh(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $658cdb1025f1b3cd$var$qg(b, e);
    d = $658cdb1025f1b3cd$var$oh(a, b, c, d, f, e);
    if (null !== a && !$658cdb1025f1b3cd$var$rg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $658cdb1025f1b3cd$var$$h(a, b, e);
    b.effectTag |= 1;
    $658cdb1025f1b3cd$var$R(a, b, d, e);
    return b.child;
}
function $658cdb1025f1b3cd$var$ai(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !$658cdb1025f1b3cd$var$bi(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, $658cdb1025f1b3cd$var$ci(a, b, g, d, e, f);
        a = $658cdb1025f1b3cd$var$Ug(c.type, null, d, null, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (e < f && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : $658cdb1025f1b3cd$var$bf, c(e, d) && a.ref === b.ref)) return $658cdb1025f1b3cd$var$$h(a, b, f);
    b.effectTag |= 1;
    a = $658cdb1025f1b3cd$var$Sg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $658cdb1025f1b3cd$var$ci(a, b, c, d, e, f) {
    return null !== a && $658cdb1025f1b3cd$var$bf(a.memoizedProps, d) && a.ref === b.ref && ($658cdb1025f1b3cd$var$rg = !1, e < f) ? (b.expirationTime = a.expirationTime, $658cdb1025f1b3cd$var$$h(a, b, f)) : $658cdb1025f1b3cd$var$di(a, b, c, d, f);
}
function $658cdb1025f1b3cd$var$ei(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.effectTag |= 128;
}
function $658cdb1025f1b3cd$var$di(a, b, c, d, e) {
    var f = $658cdb1025f1b3cd$var$L(c) ? $658cdb1025f1b3cd$var$Bf : $658cdb1025f1b3cd$var$J.current;
    f = $658cdb1025f1b3cd$var$Cf(b, f);
    $658cdb1025f1b3cd$var$qg(b, e);
    c = $658cdb1025f1b3cd$var$oh(a, b, c, d, f, e);
    if (null !== a && !$658cdb1025f1b3cd$var$rg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $658cdb1025f1b3cd$var$$h(a, b, e);
    b.effectTag |= 1;
    $658cdb1025f1b3cd$var$R(a, b, c, e);
    return b.child;
}
function $658cdb1025f1b3cd$var$fi(a, b, c, d, e) {
    if ($658cdb1025f1b3cd$var$L(c)) {
        var f = !0;
        $658cdb1025f1b3cd$var$Gf(b);
    } else f = !1;
    $658cdb1025f1b3cd$var$qg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), $658cdb1025f1b3cd$var$Lg(b, c, d), $658cdb1025f1b3cd$var$Ng(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $658cdb1025f1b3cd$var$sg(l) : (l = $658cdb1025f1b3cd$var$L(c) ? $658cdb1025f1b3cd$var$Bf : $658cdb1025f1b3cd$var$J.current, l = $658cdb1025f1b3cd$var$Cf(b, l));
        var m = c.getDerivedStateFromProps, p = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        p || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $658cdb1025f1b3cd$var$Mg(b, g, d, l);
        $658cdb1025f1b3cd$var$tg = !1;
        var x = b.memoizedState;
        g.state = x;
        $658cdb1025f1b3cd$var$zg(b, d, g, e);
        k = b.memoizedState;
        h !== d || x !== k || $658cdb1025f1b3cd$var$K.current || $658cdb1025f1b3cd$var$tg ? ("function" === typeof m && ($658cdb1025f1b3cd$var$Fg(b, c, m, d), k = b.memoizedState), (h = $658cdb1025f1b3cd$var$tg || $658cdb1025f1b3cd$var$Kg(b, c, h, d, x, k, l)) ? (p || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.effectTag |= 4)) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), d = !1);
    } else g = b.stateNode, $658cdb1025f1b3cd$var$vg(a, b), h = b.memoizedProps, g.props = b.type === b.elementType ? h : $658cdb1025f1b3cd$var$ig(b.type, h), k = g.context, l = c.contextType, "object" === typeof l && null !== l ? l = $658cdb1025f1b3cd$var$sg(l) : (l = $658cdb1025f1b3cd$var$L(c) ? $658cdb1025f1b3cd$var$Bf : $658cdb1025f1b3cd$var$J.current, l = $658cdb1025f1b3cd$var$Cf(b, l)), m = c.getDerivedStateFromProps, (p = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $658cdb1025f1b3cd$var$Mg(b, g, d, l), $658cdb1025f1b3cd$var$tg = !1, k = b.memoizedState, g.state = k, $658cdb1025f1b3cd$var$zg(b, d, g, e), x = b.memoizedState, h !== d || k !== x || $658cdb1025f1b3cd$var$K.current || $658cdb1025f1b3cd$var$tg ? ("function" === typeof m && ($658cdb1025f1b3cd$var$Fg(b, c, m, d), x = b.memoizedState), (m = $658cdb1025f1b3cd$var$tg || $658cdb1025f1b3cd$var$Kg(b, c, h, d, k, x, l)) ? (p || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, l), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, l)), "function" === typeof g.componentDidUpdate && (b.effectTag |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.effectTag |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = l, d = m) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), d = !1);
    return $658cdb1025f1b3cd$var$gi(a, b, c, d, f, e);
}
function $658cdb1025f1b3cd$var$gi(a, b, c, d, e, f) {
    $658cdb1025f1b3cd$var$ei(a, b);
    var g = 0 !== (b.effectTag & 64);
    if (!d && !g) return e && $658cdb1025f1b3cd$var$Hf(b, c, !1), $658cdb1025f1b3cd$var$$h(a, b, f);
    d = b.stateNode;
    $658cdb1025f1b3cd$var$Yh.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.effectTag |= 1;
    null !== a && g ? (b.child = $658cdb1025f1b3cd$var$Xg(b, a.child, null, f), b.child = $658cdb1025f1b3cd$var$Xg(b, null, h, f)) : $658cdb1025f1b3cd$var$R(a, b, h, f);
    b.memoizedState = d.state;
    e && $658cdb1025f1b3cd$var$Hf(b, c, !0);
    return b.child;
}
function $658cdb1025f1b3cd$var$hi(a) {
    var b = a.stateNode;
    b.pendingContext ? $658cdb1025f1b3cd$var$Ef(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $658cdb1025f1b3cd$var$Ef(a, b.context, !1);
    $658cdb1025f1b3cd$var$dh(a, b.containerInfo);
}
var $658cdb1025f1b3cd$var$ii = {
    dehydrated: null,
    retryTime: 0
};
function $658cdb1025f1b3cd$var$ji(a, b, c) {
    var d = b.mode, e = b.pendingProps, f = $658cdb1025f1b3cd$var$M.current, g = !1, h;
    (h = 0 !== (b.effectTag & 64)) || (h = 0 !== (f & 2) && (null === a || null !== a.memoizedState));
    h ? (g = !0, b.effectTag &= -65) : null !== a && null === a.memoizedState || void 0 === e.fallback || !0 === e.unstable_avoidThisFallback || (f |= 1);
    $658cdb1025f1b3cd$var$I($658cdb1025f1b3cd$var$M, f & 1);
    if (null === a) {
        void 0 !== e.fallback && $658cdb1025f1b3cd$var$Uh(b);
        if (g) {
            g = e.fallback;
            e = $658cdb1025f1b3cd$var$Wg(null, d, 0, null);
            e.return = b;
            if (0 === (b.mode & 2)) for(a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;)a.return = e, a = a.sibling;
            c = $658cdb1025f1b3cd$var$Wg(g, d, c, null);
            c.return = b;
            e.sibling = c;
            b.memoizedState = $658cdb1025f1b3cd$var$ii;
            b.child = e;
            return c;
        }
        d = e.children;
        b.memoizedState = null;
        return b.child = $658cdb1025f1b3cd$var$Yg(b, null, d, c);
    }
    if (null !== a.memoizedState) {
        a = a.child;
        d = a.sibling;
        if (g) {
            e = e.fallback;
            c = $658cdb1025f1b3cd$var$Sg(a, a.pendingProps);
            c.return = b;
            if (0 === (b.mode & 2) && (g = null !== b.memoizedState ? b.child.child : b.child, g !== a.child)) for(c.child = g; null !== g;)g.return = c, g = g.sibling;
            d = $658cdb1025f1b3cd$var$Sg(d, e);
            d.return = b;
            c.sibling = d;
            c.childExpirationTime = 0;
            b.memoizedState = $658cdb1025f1b3cd$var$ii;
            b.child = c;
            return d;
        }
        c = $658cdb1025f1b3cd$var$Xg(b, a.child, e.children, c);
        b.memoizedState = null;
        return b.child = c;
    }
    a = a.child;
    if (g) {
        g = e.fallback;
        e = $658cdb1025f1b3cd$var$Wg(null, d, 0, null);
        e.return = b;
        e.child = a;
        null !== a && (a.return = e);
        if (0 === (b.mode & 2)) for(a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;)a.return = e, a = a.sibling;
        c = $658cdb1025f1b3cd$var$Wg(g, d, c, null);
        c.return = b;
        e.sibling = c;
        c.effectTag |= 2;
        e.childExpirationTime = 0;
        b.memoizedState = $658cdb1025f1b3cd$var$ii;
        b.child = e;
        return c;
    }
    b.memoizedState = null;
    return b.child = $658cdb1025f1b3cd$var$Xg(b, a, e.children, c);
}
function $658cdb1025f1b3cd$var$ki(a, b) {
    a.expirationTime < b && (a.expirationTime = b);
    var c = a.alternate;
    null !== c && c.expirationTime < b && (c.expirationTime = b);
    $658cdb1025f1b3cd$var$pg(a.return, b);
}
function $658cdb1025f1b3cd$var$li(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailExpiration: 0,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailExpiration = 0, g.tailMode = e, g.lastEffect = f);
}
function $658cdb1025f1b3cd$var$mi(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $658cdb1025f1b3cd$var$R(a, b, d.children, c);
    d = $658cdb1025f1b3cd$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.effectTag |= 64;
    else {
        if (null !== a && 0 !== (a.effectTag & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $658cdb1025f1b3cd$var$ki(a, c);
            else if (19 === a.tag) $658cdb1025f1b3cd$var$ki(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $658cdb1025f1b3cd$var$I($658cdb1025f1b3cd$var$M, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $658cdb1025f1b3cd$var$hh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $658cdb1025f1b3cd$var$li(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $658cdb1025f1b3cd$var$hh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $658cdb1025f1b3cd$var$li(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            $658cdb1025f1b3cd$var$li(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $658cdb1025f1b3cd$var$$h(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    var d = b.expirationTime;
    0 !== d && $658cdb1025f1b3cd$var$Bg(d);
    if (b.childExpirationTime < c) return null;
    if (null !== a && b.child !== a.child) throw Error($658cdb1025f1b3cd$var$u(153));
    if (null !== b.child) {
        a = b.child;
        c = $658cdb1025f1b3cd$var$Sg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $658cdb1025f1b3cd$var$Sg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
var $658cdb1025f1b3cd$var$ni, $658cdb1025f1b3cd$var$oi, $658cdb1025f1b3cd$var$pi, $658cdb1025f1b3cd$var$qi;
$658cdb1025f1b3cd$var$ni = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$658cdb1025f1b3cd$var$oi = function() {};
$658cdb1025f1b3cd$var$pi = function(a, b, c, d, e) {
    var f = a.memoizedProps;
    if (f !== d) {
        var g = b.stateNode;
        $658cdb1025f1b3cd$var$ch($658cdb1025f1b3cd$var$$g.current);
        a = null;
        switch(c){
            case "input":
                f = $658cdb1025f1b3cd$var$zb(g, f);
                d = $658cdb1025f1b3cd$var$zb(g, d);
                a = [];
                break;
            case "option":
                f = $658cdb1025f1b3cd$var$Gb(g, f);
                d = $658cdb1025f1b3cd$var$Gb(g, d);
                a = [];
                break;
            case "select":
                f = $22Kv0({}, f, {
                    value: void 0
                });
                d = $22Kv0({}, d, {
                    value: void 0
                });
                a = [];
                break;
            case "textarea":
                f = $658cdb1025f1b3cd$var$Ib(g, f);
                d = $658cdb1025f1b3cd$var$Ib(g, d);
                a = [];
                break;
            default:
                "function" !== typeof f.onClick && "function" === typeof d.onClick && (g.onclick = $658cdb1025f1b3cd$var$sd);
        }
        $658cdb1025f1b3cd$var$od(c, d);
        var h, k;
        c = null;
        for(h in f)if (!d.hasOwnProperty(h) && f.hasOwnProperty(h) && null != f[h]) {
            if ("style" === h) for(k in g = f[h], g)g.hasOwnProperty(k) && (c || (c = {}), c[k] = "");
            else "dangerouslySetInnerHTML" !== h && "children" !== h && "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && "autoFocus" !== h && ($658cdb1025f1b3cd$var$va.hasOwnProperty(h) ? a || (a = []) : (a = a || []).push(h, null));
        }
        for(h in d){
            var l = d[h];
            g = null != f ? f[h] : void 0;
            if (d.hasOwnProperty(h) && l !== g && (null != l || null != g)) {
                if ("style" === h) {
                    if (g) {
                        for(k in g)!g.hasOwnProperty(k) || l && l.hasOwnProperty(k) || (c || (c = {}), c[k] = "");
                        for(k in l)l.hasOwnProperty(k) && g[k] !== l[k] && (c || (c = {}), c[k] = l[k]);
                    } else c || (a || (a = []), a.push(h, c)), c = l;
                } else "dangerouslySetInnerHTML" === h ? (l = l ? l.__html : void 0, g = g ? g.__html : void 0, null != l && g !== l && (a = a || []).push(h, l)) : "children" === h ? g === l || "string" !== typeof l && "number" !== typeof l || (a = a || []).push(h, "" + l) : "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && ($658cdb1025f1b3cd$var$va.hasOwnProperty(h) ? (null != l && $658cdb1025f1b3cd$var$rd(e, h), a || g === l || (a = [])) : (a = a || []).push(h, l));
            }
        }
        c && (a = a || []).push("style", c);
        e = a;
        if (b.updateQueue = e) b.effectTag |= 4;
    }
};
$658cdb1025f1b3cd$var$qi = function(a, b, c, d) {
    c !== d && (b.effectTag |= 4);
};
function $658cdb1025f1b3cd$var$ri(a, b) {
    switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $658cdb1025f1b3cd$var$si(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return $658cdb1025f1b3cd$var$L(b.type) && $658cdb1025f1b3cd$var$Df(), null;
        case 3:
            return $658cdb1025f1b3cd$var$eh(), $658cdb1025f1b3cd$var$H($658cdb1025f1b3cd$var$K), $658cdb1025f1b3cd$var$H($658cdb1025f1b3cd$var$J), c = b.stateNode, c.pendingContext && (c.context = c.pendingContext, c.pendingContext = null), null !== a && null !== a.child || !$658cdb1025f1b3cd$var$Wh(b) || (b.effectTag |= 4), $658cdb1025f1b3cd$var$oi(b), null;
        case 5:
            $658cdb1025f1b3cd$var$gh(b);
            c = $658cdb1025f1b3cd$var$ch($658cdb1025f1b3cd$var$bh.current);
            var e = b.type;
            if (null !== a && null != b.stateNode) $658cdb1025f1b3cd$var$pi(a, b, e, d, c), a.ref !== b.ref && (b.effectTag |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($658cdb1025f1b3cd$var$u(166));
                    return null;
                }
                a = $658cdb1025f1b3cd$var$ch($658cdb1025f1b3cd$var$$g.current);
                if ($658cdb1025f1b3cd$var$Wh(b)) {
                    d = b.stateNode;
                    e = b.type;
                    var f = b.memoizedProps;
                    d[$658cdb1025f1b3cd$var$Md] = b;
                    d[$658cdb1025f1b3cd$var$Nd] = f;
                    switch(e){
                        case "iframe":
                        case "object":
                        case "embed":
                            $658cdb1025f1b3cd$var$F("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < $658cdb1025f1b3cd$var$ac.length; a++)$658cdb1025f1b3cd$var$F($658cdb1025f1b3cd$var$ac[a], d);
                            break;
                        case "source":
                            $658cdb1025f1b3cd$var$F("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $658cdb1025f1b3cd$var$F("error", d);
                            $658cdb1025f1b3cd$var$F("load", d);
                            break;
                        case "form":
                            $658cdb1025f1b3cd$var$F("reset", d);
                            $658cdb1025f1b3cd$var$F("submit", d);
                            break;
                        case "details":
                            $658cdb1025f1b3cd$var$F("toggle", d);
                            break;
                        case "input":
                            $658cdb1025f1b3cd$var$Ab(d, f);
                            $658cdb1025f1b3cd$var$F("invalid", d);
                            $658cdb1025f1b3cd$var$rd(c, "onChange");
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $658cdb1025f1b3cd$var$F("invalid", d);
                            $658cdb1025f1b3cd$var$rd(c, "onChange");
                            break;
                        case "textarea":
                            $658cdb1025f1b3cd$var$Jb(d, f), $658cdb1025f1b3cd$var$F("invalid", d), $658cdb1025f1b3cd$var$rd(c, "onChange");
                    }
                    $658cdb1025f1b3cd$var$od(e, f);
                    a = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (a = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (a = [
                            "children",
                            "" + h
                        ]) : $658cdb1025f1b3cd$var$va.hasOwnProperty(g) && null != h && $658cdb1025f1b3cd$var$rd(c, g);
                    }
                    switch(e){
                        case "input":
                            $658cdb1025f1b3cd$var$xb(d);
                            $658cdb1025f1b3cd$var$Eb(d, f, !0);
                            break;
                        case "textarea":
                            $658cdb1025f1b3cd$var$xb(d);
                            $658cdb1025f1b3cd$var$Lb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $658cdb1025f1b3cd$var$sd);
                    }
                    c = a;
                    b.updateQueue = c;
                    null !== c && (b.effectTag |= 4);
                } else {
                    g = 9 === c.nodeType ? c : c.ownerDocument;
                    a === $658cdb1025f1b3cd$var$qd && (a = $658cdb1025f1b3cd$var$Nb(e));
                    a === $658cdb1025f1b3cd$var$qd ? "script" === e ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(e, {
                        is: d.is
                    }) : (a = g.createElement(e), "select" === e && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, e);
                    a[$658cdb1025f1b3cd$var$Md] = b;
                    a[$658cdb1025f1b3cd$var$Nd] = d;
                    $658cdb1025f1b3cd$var$ni(a, b, !1, !1);
                    b.stateNode = a;
                    g = $658cdb1025f1b3cd$var$pd(e, d);
                    switch(e){
                        case "iframe":
                        case "object":
                        case "embed":
                            $658cdb1025f1b3cd$var$F("load", a);
                            h = d;
                            break;
                        case "video":
                        case "audio":
                            for(h = 0; h < $658cdb1025f1b3cd$var$ac.length; h++)$658cdb1025f1b3cd$var$F($658cdb1025f1b3cd$var$ac[h], a);
                            h = d;
                            break;
                        case "source":
                            $658cdb1025f1b3cd$var$F("error", a);
                            h = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $658cdb1025f1b3cd$var$F("error", a);
                            $658cdb1025f1b3cd$var$F("load", a);
                            h = d;
                            break;
                        case "form":
                            $658cdb1025f1b3cd$var$F("reset", a);
                            $658cdb1025f1b3cd$var$F("submit", a);
                            h = d;
                            break;
                        case "details":
                            $658cdb1025f1b3cd$var$F("toggle", a);
                            h = d;
                            break;
                        case "input":
                            $658cdb1025f1b3cd$var$Ab(a, d);
                            h = $658cdb1025f1b3cd$var$zb(a, d);
                            $658cdb1025f1b3cd$var$F("invalid", a);
                            $658cdb1025f1b3cd$var$rd(c, "onChange");
                            break;
                        case "option":
                            h = $658cdb1025f1b3cd$var$Gb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            h = $22Kv0({}, d, {
                                value: void 0
                            });
                            $658cdb1025f1b3cd$var$F("invalid", a);
                            $658cdb1025f1b3cd$var$rd(c, "onChange");
                            break;
                        case "textarea":
                            $658cdb1025f1b3cd$var$Jb(a, d);
                            h = $658cdb1025f1b3cd$var$Ib(a, d);
                            $658cdb1025f1b3cd$var$F("invalid", a);
                            $658cdb1025f1b3cd$var$rd(c, "onChange");
                            break;
                        default:
                            h = d;
                    }
                    $658cdb1025f1b3cd$var$od(e, h);
                    var k = h;
                    for(f in k)if (k.hasOwnProperty(f)) {
                        var l = k[f];
                        "style" === f ? $658cdb1025f1b3cd$var$md(a, l) : "dangerouslySetInnerHTML" === f ? (l = l ? l.__html : void 0, null != l && $658cdb1025f1b3cd$var$Qb(a, l)) : "children" === f ? "string" === typeof l ? ("textarea" !== e || "" !== l) && $658cdb1025f1b3cd$var$Rb(a, l) : "number" === typeof l && $658cdb1025f1b3cd$var$Rb(a, "" + l) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($658cdb1025f1b3cd$var$va.hasOwnProperty(f) ? null != l && $658cdb1025f1b3cd$var$rd(c, f) : null != l && $658cdb1025f1b3cd$var$Xa(a, f, l, g));
                    }
                    switch(e){
                        case "input":
                            $658cdb1025f1b3cd$var$xb(a);
                            $658cdb1025f1b3cd$var$Eb(a, d, !1);
                            break;
                        case "textarea":
                            $658cdb1025f1b3cd$var$xb(a);
                            $658cdb1025f1b3cd$var$Lb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + $658cdb1025f1b3cd$var$rb(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            c = d.value;
                            null != c ? $658cdb1025f1b3cd$var$Hb(a, !!d.multiple, c, !1) : null != d.defaultValue && $658cdb1025f1b3cd$var$Hb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof h.onClick && (a.onclick = $658cdb1025f1b3cd$var$sd);
                    }
                    $658cdb1025f1b3cd$var$Fd(e, d) && (b.effectTag |= 4);
                }
                null !== b.ref && (b.effectTag |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) $658cdb1025f1b3cd$var$qi(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($658cdb1025f1b3cd$var$u(166));
                c = $658cdb1025f1b3cd$var$ch($658cdb1025f1b3cd$var$bh.current);
                $658cdb1025f1b3cd$var$ch($658cdb1025f1b3cd$var$$g.current);
                $658cdb1025f1b3cd$var$Wh(b) ? (c = b.stateNode, d = b.memoizedProps, c[$658cdb1025f1b3cd$var$Md] = b, c.nodeValue !== d && (b.effectTag |= 4)) : (c = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), c[$658cdb1025f1b3cd$var$Md] = b, b.stateNode = c);
            }
            return null;
        case 13:
            $658cdb1025f1b3cd$var$H($658cdb1025f1b3cd$var$M);
            d = b.memoizedState;
            if (0 !== (b.effectTag & 64)) return b.expirationTime = c, b;
            c = null !== d;
            d = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && $658cdb1025f1b3cd$var$Wh(b) : (e = a.memoizedState, d = null !== e, c || null === e || (e = a.child.sibling, null !== e && (f = b.firstEffect, null !== f ? (b.firstEffect = e, e.nextEffect = f) : (b.firstEffect = b.lastEffect = e, e.nextEffect = null), e.effectTag = 8)));
            if (c && !d && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== ($658cdb1025f1b3cd$var$M.current & 1)) $658cdb1025f1b3cd$var$S === $658cdb1025f1b3cd$var$ti && ($658cdb1025f1b3cd$var$S = $658cdb1025f1b3cd$var$ui);
                else {
                    if ($658cdb1025f1b3cd$var$S === $658cdb1025f1b3cd$var$ti || $658cdb1025f1b3cd$var$S === $658cdb1025f1b3cd$var$ui) $658cdb1025f1b3cd$var$S = $658cdb1025f1b3cd$var$vi;
                    0 !== $658cdb1025f1b3cd$var$wi && null !== $658cdb1025f1b3cd$var$T && ($658cdb1025f1b3cd$var$xi($658cdb1025f1b3cd$var$T, $658cdb1025f1b3cd$var$U), $658cdb1025f1b3cd$var$yi($658cdb1025f1b3cd$var$T, $658cdb1025f1b3cd$var$wi));
                }
            }
            if (c || d) b.effectTag |= 4;
            return null;
        case 4:
            return $658cdb1025f1b3cd$var$eh(), $658cdb1025f1b3cd$var$oi(b), null;
        case 10:
            return $658cdb1025f1b3cd$var$og(b), null;
        case 17:
            return $658cdb1025f1b3cd$var$L(b.type) && $658cdb1025f1b3cd$var$Df(), null;
        case 19:
            $658cdb1025f1b3cd$var$H($658cdb1025f1b3cd$var$M);
            d = b.memoizedState;
            if (null === d) return null;
            e = 0 !== (b.effectTag & 64);
            f = d.rendering;
            if (null === f) {
                if (e) $658cdb1025f1b3cd$var$ri(d, !1);
                else {
                    if ($658cdb1025f1b3cd$var$S !== $658cdb1025f1b3cd$var$ti || null !== a && 0 !== (a.effectTag & 64)) for(f = b.child; null !== f;){
                        a = $658cdb1025f1b3cd$var$hh(f);
                        if (null !== a) {
                            b.effectTag |= 64;
                            $658cdb1025f1b3cd$var$ri(d, !1);
                            e = a.updateQueue;
                            null !== e && (b.updateQueue = e, b.effectTag |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            for(d = b.child; null !== d;)e = d, f = c, e.effectTag &= 2, e.nextEffect = null, e.firstEffect = null, e.lastEffect = null, a = e.alternate, null === a ? (e.childExpirationTime = 0, e.expirationTime = f, e.child = null, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null) : (e.childExpirationTime = a.childExpirationTime, e.expirationTime = a.expirationTime, e.child = a.child, e.memoizedProps = a.memoizedProps, e.memoizedState = a.memoizedState, e.updateQueue = a.updateQueue, f = a.dependencies, e.dependencies = null === f ? null : {
                                expirationTime: f.expirationTime,
                                firstContext: f.firstContext,
                                responders: f.responders
                            }), d = d.sibling;
                            $658cdb1025f1b3cd$var$I($658cdb1025f1b3cd$var$M, $658cdb1025f1b3cd$var$M.current & 1 | 2);
                            return b.child;
                        }
                        f = f.sibling;
                    }
                }
            } else {
                if (!e) {
                    if (a = $658cdb1025f1b3cd$var$hh(f), null !== a) {
                        if (b.effectTag |= 64, e = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.effectTag |= 4), $658cdb1025f1b3cd$var$ri(d, !0), null === d.tail && "hidden" === d.tailMode && !f.alternate) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * $658cdb1025f1b3cd$var$$f() - d.renderingStartTime > d.tailExpiration && 1 < c && (b.effectTag |= 64, e = !0, $658cdb1025f1b3cd$var$ri(d, !1), b.expirationTime = b.childExpirationTime = c - 1);
                }
                d.isBackwards ? (f.sibling = b.child, b.child = f) : (c = d.last, null !== c ? c.sibling = f : b.child = f, d.last = f);
            }
            return null !== d.tail ? (0 === d.tailExpiration && (d.tailExpiration = $658cdb1025f1b3cd$var$$f() + 500), c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = $658cdb1025f1b3cd$var$$f(), c.sibling = null, b = $658cdb1025f1b3cd$var$M.current, $658cdb1025f1b3cd$var$I($658cdb1025f1b3cd$var$M, e ? b & 1 | 2 : b & 1), c) : null;
    }
    throw Error($658cdb1025f1b3cd$var$u(156, b.tag));
}
function $658cdb1025f1b3cd$var$zi(a) {
    switch(a.tag){
        case 1:
            $658cdb1025f1b3cd$var$L(a.type) && $658cdb1025f1b3cd$var$Df();
            var b = a.effectTag;
            return b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
        case 3:
            $658cdb1025f1b3cd$var$eh();
            $658cdb1025f1b3cd$var$H($658cdb1025f1b3cd$var$K);
            $658cdb1025f1b3cd$var$H($658cdb1025f1b3cd$var$J);
            b = a.effectTag;
            if (0 !== (b & 64)) throw Error($658cdb1025f1b3cd$var$u(285));
            a.effectTag = b & -4097 | 64;
            return a;
        case 5:
            return $658cdb1025f1b3cd$var$gh(a), null;
        case 13:
            return $658cdb1025f1b3cd$var$H($658cdb1025f1b3cd$var$M), b = a.effectTag, b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
        case 19:
            return $658cdb1025f1b3cd$var$H($658cdb1025f1b3cd$var$M), null;
        case 4:
            return $658cdb1025f1b3cd$var$eh(), null;
        case 10:
            return $658cdb1025f1b3cd$var$og(a), null;
        default:
            return null;
    }
}
function $658cdb1025f1b3cd$var$Ai(a, b) {
    return {
        value: a,
        source: b,
        stack: $658cdb1025f1b3cd$var$qb(b)
    };
}
var $658cdb1025f1b3cd$var$Bi = "function" === typeof WeakSet ? WeakSet : Set;
function $658cdb1025f1b3cd$var$Ci(a, b) {
    var c = b.source, d = b.stack;
    null === d && null !== c && (d = $658cdb1025f1b3cd$var$qb(c));
    null !== c && $658cdb1025f1b3cd$var$pb(c.type);
    b = b.value;
    null !== a && 1 === a.tag && $658cdb1025f1b3cd$var$pb(a.type);
    try {
        console.error(b);
    } catch (e) {
        setTimeout(function() {
            throw e;
        });
    }
}
function $658cdb1025f1b3cd$var$Di(a, b) {
    try {
        b.props = a.memoizedProps, b.state = a.memoizedState, b.componentWillUnmount();
    } catch (c) {
        $658cdb1025f1b3cd$var$Ei(a, c);
    }
}
function $658cdb1025f1b3cd$var$Fi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            $658cdb1025f1b3cd$var$Ei(a, c);
        }
        else b.current = null;
    }
}
function $658cdb1025f1b3cd$var$Gi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.effectTag & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : $658cdb1025f1b3cd$var$ig(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error($658cdb1025f1b3cd$var$u(163));
}
function $658cdb1025f1b3cd$var$Hi(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.destroy;
                c.destroy = void 0;
                void 0 !== d && d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $658cdb1025f1b3cd$var$Ii(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $658cdb1025f1b3cd$var$Ji(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            $658cdb1025f1b3cd$var$Ii(3, c);
            return;
        case 1:
            a = c.stateNode;
            if (c.effectTag & 4) {
                if (null === b) a.componentDidMount();
                else {
                    var d = c.elementType === c.type ? b.memoizedProps : $658cdb1025f1b3cd$var$ig(c.type, b.memoizedProps);
                    a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate);
                }
            }
            b = c.updateQueue;
            null !== b && $658cdb1025f1b3cd$var$Cg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                $658cdb1025f1b3cd$var$Cg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.effectTag & 4 && $658cdb1025f1b3cd$var$Fd(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && $658cdb1025f1b3cd$var$Vc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
            return;
    }
    throw Error($658cdb1025f1b3cd$var$u(163));
}
function $658cdb1025f1b3cd$var$Ki(a, b, c) {
    "function" === typeof $658cdb1025f1b3cd$var$Li && $658cdb1025f1b3cd$var$Li(b);
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var d = a.next;
                $658cdb1025f1b3cd$var$cg(97 < c ? 97 : c, function() {
                    var a = d;
                    do {
                        var c = a.destroy;
                        if (void 0 !== c) {
                            var g = b;
                            try {
                                c();
                            } catch (h) {
                                $658cdb1025f1b3cd$var$Ei(g, h);
                            }
                        }
                        a = a.next;
                    }while (a !== d);
                });
            }
            break;
        case 1:
            $658cdb1025f1b3cd$var$Fi(b);
            c = b.stateNode;
            "function" === typeof c.componentWillUnmount && $658cdb1025f1b3cd$var$Di(b, c);
            break;
        case 5:
            $658cdb1025f1b3cd$var$Fi(b);
            break;
        case 4:
            $658cdb1025f1b3cd$var$Mi(a, b, c);
    }
}
function $658cdb1025f1b3cd$var$Ni(a) {
    var b = a.alternate;
    a.return = null;
    a.child = null;
    a.memoizedState = null;
    a.updateQueue = null;
    a.dependencies = null;
    a.alternate = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.pendingProps = null;
    a.memoizedProps = null;
    a.stateNode = null;
    null !== b && $658cdb1025f1b3cd$var$Ni(b);
}
function $658cdb1025f1b3cd$var$Oi(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $658cdb1025f1b3cd$var$Pi(a) {
    a: {
        for(var b = a.return; null !== b;){
            if ($658cdb1025f1b3cd$var$Oi(b)) {
                var c = b;
                break a;
            }
            b = b.return;
        }
        throw Error($658cdb1025f1b3cd$var$u(160));
    }
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error($658cdb1025f1b3cd$var$u(161));
    }
    c.effectTag & 16 && ($658cdb1025f1b3cd$var$Rb(b, ""), c.effectTag &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || $658cdb1025f1b3cd$var$Oi(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.effectTag & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.effectTag & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? $658cdb1025f1b3cd$var$Qi(a, c, b) : $658cdb1025f1b3cd$var$Ri(a, c, b);
}
function $658cdb1025f1b3cd$var$Qi(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $658cdb1025f1b3cd$var$sd));
    else if (4 !== d && (a = a.child, null !== a)) for($658cdb1025f1b3cd$var$Qi(a, b, c), a = a.sibling; null !== a;)$658cdb1025f1b3cd$var$Qi(a, b, c), a = a.sibling;
}
function $658cdb1025f1b3cd$var$Ri(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($658cdb1025f1b3cd$var$Ri(a, b, c), a = a.sibling; null !== a;)$658cdb1025f1b3cd$var$Ri(a, b, c), a = a.sibling;
}
function $658cdb1025f1b3cd$var$Mi(a, b, c) {
    for(var d = b, e = !1, f, g;;){
        if (!e) {
            e = d.return;
            a: for(;;){
                if (null === e) throw Error($658cdb1025f1b3cd$var$u(160));
                f = e.stateNode;
                switch(e.tag){
                    case 5:
                        g = !1;
                        break a;
                    case 3:
                        f = f.containerInfo;
                        g = !0;
                        break a;
                    case 4:
                        f = f.containerInfo;
                        g = !0;
                        break a;
                }
                e = e.return;
            }
            e = !0;
        }
        if (5 === d.tag || 6 === d.tag) {
            a: for(var h = a, k = d, l = c, m = k;;)if ($658cdb1025f1b3cd$var$Ki(h, m, l), null !== m.child && 4 !== m.tag) m.child.return = m, m = m.child;
            else {
                if (m === k) break a;
                for(; null === m.sibling;){
                    if (null === m.return || m.return === k) break a;
                    m = m.return;
                }
                m.sibling.return = m.return;
                m = m.sibling;
            }
            g ? (h = f, k = d.stateNode, 8 === h.nodeType ? h.parentNode.removeChild(k) : h.removeChild(k)) : f.removeChild(d.stateNode);
        } else if (4 === d.tag) {
            if (null !== d.child) {
                f = d.stateNode.containerInfo;
                g = !0;
                d.child.return = d;
                d = d.child;
                continue;
            }
        } else if ($658cdb1025f1b3cd$var$Ki(a, d, c), null !== d.child) {
            d.child.return = d;
            d = d.child;
            continue;
        }
        if (d === b) break;
        for(; null === d.sibling;){
            if (null === d.return || d.return === b) return;
            d = d.return;
            4 === d.tag && (e = !1);
        }
        d.sibling.return = d.return;
        d = d.sibling;
    }
}
function $658cdb1025f1b3cd$var$Si(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            $658cdb1025f1b3cd$var$Hi(3, b);
            return;
        case 1:
            return;
        case 5:
            var c = b.stateNode;
            if (null != c) {
                var d = b.memoizedProps, e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[$658cdb1025f1b3cd$var$Nd] = d;
                    "input" === a && "radio" === d.type && null != d.name && $658cdb1025f1b3cd$var$Bb(c, d);
                    $658cdb1025f1b3cd$var$pd(a, e);
                    b = $658cdb1025f1b3cd$var$pd(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? $658cdb1025f1b3cd$var$md(c, h) : "dangerouslySetInnerHTML" === g ? $658cdb1025f1b3cd$var$Qb(c, h) : "children" === g ? $658cdb1025f1b3cd$var$Rb(c, h) : $658cdb1025f1b3cd$var$Xa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            $658cdb1025f1b3cd$var$Cb(c, d);
                            break;
                        case "textarea":
                            $658cdb1025f1b3cd$var$Kb(c, d);
                            break;
                        case "select":
                            b = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, a = d.value, null != a ? $658cdb1025f1b3cd$var$Hb(c, !!d.multiple, a, !1) : b !== !!d.multiple && (null != d.defaultValue ? $658cdb1025f1b3cd$var$Hb(c, !!d.multiple, d.defaultValue, !0) : $658cdb1025f1b3cd$var$Hb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error($658cdb1025f1b3cd$var$u(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            b = b.stateNode;
            b.hydrate && (b.hydrate = !1, $658cdb1025f1b3cd$var$Vc(b.containerInfo));
            return;
        case 12:
            return;
        case 13:
            c = b;
            null === b.memoizedState ? d = !1 : (d = !0, c = b.child, $658cdb1025f1b3cd$var$Ti = $658cdb1025f1b3cd$var$$f());
            if (null !== c) a: for(a = c;;){
                if (5 === a.tag) f = a.stateNode, d ? (f = f.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (f = a.stateNode, e = a.memoizedProps.style, e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null, f.style.display = $658cdb1025f1b3cd$var$ld("display", e));
                else if (6 === a.tag) a.stateNode.nodeValue = d ? "" : a.memoizedProps;
                else if (13 === a.tag && null !== a.memoizedState && null === a.memoizedState.dehydrated) {
                    f = a.child.sibling;
                    f.return = a;
                    a = f;
                    continue;
                } else if (null !== a.child) {
                    a.child.return = a;
                    a = a.child;
                    continue;
                }
                if (a === c) break;
                for(; null === a.sibling;){
                    if (null === a.return || a.return === c) break a;
                    a = a.return;
                }
                a.sibling.return = a.return;
                a = a.sibling;
            }
            $658cdb1025f1b3cd$var$Ui(b);
            return;
        case 19:
            $658cdb1025f1b3cd$var$Ui(b);
            return;
        case 17:
            return;
    }
    throw Error($658cdb1025f1b3cd$var$u(163));
}
function $658cdb1025f1b3cd$var$Ui(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $658cdb1025f1b3cd$var$Bi);
        b.forEach(function(b) {
            var d = $658cdb1025f1b3cd$var$Vi.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
var $658cdb1025f1b3cd$var$Wi = "function" === typeof WeakMap ? WeakMap : Map;
function $658cdb1025f1b3cd$var$Xi(a, b, c) {
    c = $658cdb1025f1b3cd$var$wg(c, null);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $658cdb1025f1b3cd$var$Yi || ($658cdb1025f1b3cd$var$Yi = !0, $658cdb1025f1b3cd$var$Zi = d);
        $658cdb1025f1b3cd$var$Ci(a, b);
    };
    return c;
}
function $658cdb1025f1b3cd$var$$i(a, b, c) {
    c = $658cdb1025f1b3cd$var$wg(c, null);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            $658cdb1025f1b3cd$var$Ci(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === $658cdb1025f1b3cd$var$aj ? $658cdb1025f1b3cd$var$aj = new Set([
            this
        ]) : $658cdb1025f1b3cd$var$aj.add(this), $658cdb1025f1b3cd$var$Ci(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var $658cdb1025f1b3cd$var$bj = Math.ceil, $658cdb1025f1b3cd$var$cj = $658cdb1025f1b3cd$var$Wa.ReactCurrentDispatcher, $658cdb1025f1b3cd$var$dj = $658cdb1025f1b3cd$var$Wa.ReactCurrentOwner, $658cdb1025f1b3cd$var$V = 0, $658cdb1025f1b3cd$var$ej = 8, $658cdb1025f1b3cd$var$fj = 16, $658cdb1025f1b3cd$var$gj = 32, $658cdb1025f1b3cd$var$ti = 0, $658cdb1025f1b3cd$var$hj = 1, $658cdb1025f1b3cd$var$ij = 2, $658cdb1025f1b3cd$var$ui = 3, $658cdb1025f1b3cd$var$vi = 4, $658cdb1025f1b3cd$var$jj = 5, $658cdb1025f1b3cd$var$W = $658cdb1025f1b3cd$var$V, $658cdb1025f1b3cd$var$T = null, $658cdb1025f1b3cd$var$X = null, $658cdb1025f1b3cd$var$U = 0, $658cdb1025f1b3cd$var$S = $658cdb1025f1b3cd$var$ti, $658cdb1025f1b3cd$var$kj = null, $658cdb1025f1b3cd$var$lj = 1073741823, $658cdb1025f1b3cd$var$mj = 1073741823, $658cdb1025f1b3cd$var$nj = null, $658cdb1025f1b3cd$var$wi = 0, $658cdb1025f1b3cd$var$oj = !1, $658cdb1025f1b3cd$var$Ti = 0, $658cdb1025f1b3cd$var$pj = 500, $658cdb1025f1b3cd$var$Y = null, $658cdb1025f1b3cd$var$Yi = !1, $658cdb1025f1b3cd$var$Zi = null, $658cdb1025f1b3cd$var$aj = null, $658cdb1025f1b3cd$var$qj = !1, $658cdb1025f1b3cd$var$rj = null, $658cdb1025f1b3cd$var$sj = 90, $658cdb1025f1b3cd$var$tj = null, $658cdb1025f1b3cd$var$uj = 0, $658cdb1025f1b3cd$var$vj = null, $658cdb1025f1b3cd$var$wj = 0;
function $658cdb1025f1b3cd$var$Gg() {
    return ($658cdb1025f1b3cd$var$W & ($658cdb1025f1b3cd$var$fj | $658cdb1025f1b3cd$var$gj)) !== $658cdb1025f1b3cd$var$V ? 1073741821 - ($658cdb1025f1b3cd$var$$f() / 10 | 0) : 0 !== $658cdb1025f1b3cd$var$wj ? $658cdb1025f1b3cd$var$wj : $658cdb1025f1b3cd$var$wj = 1073741821 - ($658cdb1025f1b3cd$var$$f() / 10 | 0);
}
function $658cdb1025f1b3cd$var$Hg(a, b, c) {
    b = b.mode;
    if (0 === (b & 2)) return 1073741823;
    var d = $658cdb1025f1b3cd$var$ag();
    if (0 === (b & 4)) return 99 === d ? 1073741823 : 1073741822;
    if (($658cdb1025f1b3cd$var$W & $658cdb1025f1b3cd$var$fj) !== $658cdb1025f1b3cd$var$V) return $658cdb1025f1b3cd$var$U;
    if (null !== c) a = $658cdb1025f1b3cd$var$hg(a, c.timeoutMs | 0 || 5E3, 250);
    else switch(d){
        case 99:
            a = 1073741823;
            break;
        case 98:
            a = $658cdb1025f1b3cd$var$hg(a, 150, 100);
            break;
        case 97:
        case 96:
            a = $658cdb1025f1b3cd$var$hg(a, 5E3, 250);
            break;
        case 95:
            a = 2;
            break;
        default:
            throw Error($658cdb1025f1b3cd$var$u(326));
    }
    null !== $658cdb1025f1b3cd$var$T && a === $658cdb1025f1b3cd$var$U && --a;
    return a;
}
function $658cdb1025f1b3cd$var$Ig(a, b) {
    if (50 < $658cdb1025f1b3cd$var$uj) throw $658cdb1025f1b3cd$var$uj = 0, $658cdb1025f1b3cd$var$vj = null, Error($658cdb1025f1b3cd$var$u(185));
    a = $658cdb1025f1b3cd$var$xj(a, b);
    if (null !== a) {
        var c = $658cdb1025f1b3cd$var$ag();
        1073741823 === b ? ($658cdb1025f1b3cd$var$W & $658cdb1025f1b3cd$var$ej) !== $658cdb1025f1b3cd$var$V && ($658cdb1025f1b3cd$var$W & ($658cdb1025f1b3cd$var$fj | $658cdb1025f1b3cd$var$gj)) === $658cdb1025f1b3cd$var$V ? $658cdb1025f1b3cd$var$yj(a) : ($658cdb1025f1b3cd$var$Z(a), $658cdb1025f1b3cd$var$W === $658cdb1025f1b3cd$var$V && $658cdb1025f1b3cd$var$gg()) : $658cdb1025f1b3cd$var$Z(a);
        ($658cdb1025f1b3cd$var$W & 4) === $658cdb1025f1b3cd$var$V || 98 !== c && 99 !== c || (null === $658cdb1025f1b3cd$var$tj ? $658cdb1025f1b3cd$var$tj = new Map([
            [
                a,
                b
            ]
        ]) : (c = $658cdb1025f1b3cd$var$tj.get(a), (void 0 === c || c > b) && $658cdb1025f1b3cd$var$tj.set(a, b)));
    }
}
function $658cdb1025f1b3cd$var$xj(a, b) {
    a.expirationTime < b && (a.expirationTime = b);
    var c = a.alternate;
    null !== c && c.expirationTime < b && (c.expirationTime = b);
    var d = a.return, e = null;
    if (null === d && 3 === a.tag) e = a.stateNode;
    else for(; null !== d;){
        c = d.alternate;
        d.childExpirationTime < b && (d.childExpirationTime = b);
        null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
        if (null === d.return && 3 === d.tag) {
            e = d.stateNode;
            break;
        }
        d = d.return;
    }
    null !== e && ($658cdb1025f1b3cd$var$T === e && ($658cdb1025f1b3cd$var$Bg(b), $658cdb1025f1b3cd$var$S === $658cdb1025f1b3cd$var$vi && $658cdb1025f1b3cd$var$xi(e, $658cdb1025f1b3cd$var$U)), $658cdb1025f1b3cd$var$yi(e, b));
    return e;
}
function $658cdb1025f1b3cd$var$zj(a) {
    var b = a.lastExpiredTime;
    if (0 !== b) return b;
    b = a.firstPendingTime;
    if (!$658cdb1025f1b3cd$var$Aj(a, b)) return b;
    var c = a.lastPingedTime;
    a = a.nextKnownPendingLevel;
    a = c > a ? c : a;
    return 2 >= a && b !== a ? 0 : a;
}
function $658cdb1025f1b3cd$var$Z(a) {
    if (0 !== a.lastExpiredTime) a.callbackExpirationTime = 1073741823, a.callbackPriority = 99, a.callbackNode = $658cdb1025f1b3cd$var$eg($658cdb1025f1b3cd$var$yj.bind(null, a));
    else {
        var b = $658cdb1025f1b3cd$var$zj(a), c = a.callbackNode;
        if (0 === b) null !== c && (a.callbackNode = null, a.callbackExpirationTime = 0, a.callbackPriority = 90);
        else {
            var d = $658cdb1025f1b3cd$var$Gg();
            1073741823 === b ? d = 99 : 1 === b || 2 === b ? d = 95 : (d = 10 * (1073741821 - b) - 10 * (1073741821 - d), d = 0 >= d ? 99 : 250 >= d ? 98 : 5250 >= d ? 97 : 95);
            if (null !== c) {
                var e = a.callbackPriority;
                if (a.callbackExpirationTime === b && e >= d) return;
                c !== $658cdb1025f1b3cd$var$Tf && $658cdb1025f1b3cd$var$Kf(c);
            }
            a.callbackExpirationTime = b;
            a.callbackPriority = d;
            b = 1073741823 === b ? $658cdb1025f1b3cd$var$eg($658cdb1025f1b3cd$var$yj.bind(null, a)) : $658cdb1025f1b3cd$var$dg(d, $658cdb1025f1b3cd$var$Bj.bind(null, a), {
                timeout: 10 * (1073741821 - b) - $658cdb1025f1b3cd$var$$f()
            });
            a.callbackNode = b;
        }
    }
}
function $658cdb1025f1b3cd$var$Bj(a, b) {
    $658cdb1025f1b3cd$var$wj = 0;
    if (b) return b = $658cdb1025f1b3cd$var$Gg(), $658cdb1025f1b3cd$var$Cj(a, b), $658cdb1025f1b3cd$var$Z(a), null;
    var c = $658cdb1025f1b3cd$var$zj(a);
    if (0 !== c) {
        b = a.callbackNode;
        if (($658cdb1025f1b3cd$var$W & ($658cdb1025f1b3cd$var$fj | $658cdb1025f1b3cd$var$gj)) !== $658cdb1025f1b3cd$var$V) throw Error($658cdb1025f1b3cd$var$u(327));
        $658cdb1025f1b3cd$var$Dj();
        a === $658cdb1025f1b3cd$var$T && c === $658cdb1025f1b3cd$var$U || $658cdb1025f1b3cd$var$Ej(a, c);
        if (null !== $658cdb1025f1b3cd$var$X) {
            var d = $658cdb1025f1b3cd$var$W;
            $658cdb1025f1b3cd$var$W |= $658cdb1025f1b3cd$var$fj;
            var e = $658cdb1025f1b3cd$var$Fj();
            for(;;)try {
                $658cdb1025f1b3cd$var$Gj();
                break;
            } catch (h) {
                $658cdb1025f1b3cd$var$Hj(a, h);
            }
            $658cdb1025f1b3cd$var$ng();
            $658cdb1025f1b3cd$var$W = d;
            $658cdb1025f1b3cd$var$cj.current = e;
            if ($658cdb1025f1b3cd$var$S === $658cdb1025f1b3cd$var$hj) throw b = $658cdb1025f1b3cd$var$kj, $658cdb1025f1b3cd$var$Ej(a, c), $658cdb1025f1b3cd$var$xi(a, c), $658cdb1025f1b3cd$var$Z(a), b;
            if (null === $658cdb1025f1b3cd$var$X) switch(e = a.finishedWork = a.current.alternate, a.finishedExpirationTime = c, d = $658cdb1025f1b3cd$var$S, $658cdb1025f1b3cd$var$T = null, d){
                case $658cdb1025f1b3cd$var$ti:
                case $658cdb1025f1b3cd$var$hj:
                    throw Error($658cdb1025f1b3cd$var$u(345));
                case $658cdb1025f1b3cd$var$ij:
                    $658cdb1025f1b3cd$var$Cj(a, 2 < c ? 2 : c);
                    break;
                case $658cdb1025f1b3cd$var$ui:
                    $658cdb1025f1b3cd$var$xi(a, c);
                    d = a.lastSuspendedTime;
                    c === d && (a.nextKnownPendingLevel = $658cdb1025f1b3cd$var$Ij(e));
                    if (1073741823 === $658cdb1025f1b3cd$var$lj && (e = $658cdb1025f1b3cd$var$Ti + $658cdb1025f1b3cd$var$pj - $658cdb1025f1b3cd$var$$f(), 10 < e)) {
                        if ($658cdb1025f1b3cd$var$oj) {
                            var f = a.lastPingedTime;
                            if (0 === f || f >= c) {
                                a.lastPingedTime = c;
                                $658cdb1025f1b3cd$var$Ej(a, c);
                                break;
                            }
                        }
                        f = $658cdb1025f1b3cd$var$zj(a);
                        if (0 !== f && f !== c) break;
                        if (0 !== d && d !== c) {
                            a.lastPingedTime = d;
                            break;
                        }
                        a.timeoutHandle = $658cdb1025f1b3cd$var$Hd($658cdb1025f1b3cd$var$Jj.bind(null, a), e);
                        break;
                    }
                    $658cdb1025f1b3cd$var$Jj(a);
                    break;
                case $658cdb1025f1b3cd$var$vi:
                    $658cdb1025f1b3cd$var$xi(a, c);
                    d = a.lastSuspendedTime;
                    c === d && (a.nextKnownPendingLevel = $658cdb1025f1b3cd$var$Ij(e));
                    if ($658cdb1025f1b3cd$var$oj && (e = a.lastPingedTime, 0 === e || e >= c)) {
                        a.lastPingedTime = c;
                        $658cdb1025f1b3cd$var$Ej(a, c);
                        break;
                    }
                    e = $658cdb1025f1b3cd$var$zj(a);
                    if (0 !== e && e !== c) break;
                    if (0 !== d && d !== c) {
                        a.lastPingedTime = d;
                        break;
                    }
                    1073741823 !== $658cdb1025f1b3cd$var$mj ? d = 10 * (1073741821 - $658cdb1025f1b3cd$var$mj) - $658cdb1025f1b3cd$var$$f() : 1073741823 === $658cdb1025f1b3cd$var$lj ? d = 0 : (d = 10 * (1073741821 - $658cdb1025f1b3cd$var$lj) - 5E3, e = $658cdb1025f1b3cd$var$$f(), c = 10 * (1073741821 - c) - e, d = e - d, 0 > d && (d = 0), d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $658cdb1025f1b3cd$var$bj(d / 1960)) - d, c < d && (d = c));
                    if (10 < d) {
                        a.timeoutHandle = $658cdb1025f1b3cd$var$Hd($658cdb1025f1b3cd$var$Jj.bind(null, a), d);
                        break;
                    }
                    $658cdb1025f1b3cd$var$Jj(a);
                    break;
                case $658cdb1025f1b3cd$var$jj:
                    if (1073741823 !== $658cdb1025f1b3cd$var$lj && null !== $658cdb1025f1b3cd$var$nj) {
                        f = $658cdb1025f1b3cd$var$lj;
                        var g = $658cdb1025f1b3cd$var$nj;
                        d = g.busyMinDurationMs | 0;
                        0 >= d ? d = 0 : (e = g.busyDelayMs | 0, f = $658cdb1025f1b3cd$var$$f() - (10 * (1073741821 - f) - (g.timeoutMs | 0 || 5E3)), d = f <= e ? 0 : e + d - f);
                        if (10 < d) {
                            $658cdb1025f1b3cd$var$xi(a, c);
                            a.timeoutHandle = $658cdb1025f1b3cd$var$Hd($658cdb1025f1b3cd$var$Jj.bind(null, a), d);
                            break;
                        }
                    }
                    $658cdb1025f1b3cd$var$Jj(a);
                    break;
                default:
                    throw Error($658cdb1025f1b3cd$var$u(329));
            }
            $658cdb1025f1b3cd$var$Z(a);
            if (a.callbackNode === b) return $658cdb1025f1b3cd$var$Bj.bind(null, a);
        }
    }
    return null;
}
function $658cdb1025f1b3cd$var$yj(a) {
    var b = a.lastExpiredTime;
    b = 0 !== b ? b : 1073741823;
    if (($658cdb1025f1b3cd$var$W & ($658cdb1025f1b3cd$var$fj | $658cdb1025f1b3cd$var$gj)) !== $658cdb1025f1b3cd$var$V) throw Error($658cdb1025f1b3cd$var$u(327));
    $658cdb1025f1b3cd$var$Dj();
    a === $658cdb1025f1b3cd$var$T && b === $658cdb1025f1b3cd$var$U || $658cdb1025f1b3cd$var$Ej(a, b);
    if (null !== $658cdb1025f1b3cd$var$X) {
        var c = $658cdb1025f1b3cd$var$W;
        $658cdb1025f1b3cd$var$W |= $658cdb1025f1b3cd$var$fj;
        var d = $658cdb1025f1b3cd$var$Fj();
        for(;;)try {
            $658cdb1025f1b3cd$var$Kj();
            break;
        } catch (e) {
            $658cdb1025f1b3cd$var$Hj(a, e);
        }
        $658cdb1025f1b3cd$var$ng();
        $658cdb1025f1b3cd$var$W = c;
        $658cdb1025f1b3cd$var$cj.current = d;
        if ($658cdb1025f1b3cd$var$S === $658cdb1025f1b3cd$var$hj) throw c = $658cdb1025f1b3cd$var$kj, $658cdb1025f1b3cd$var$Ej(a, b), $658cdb1025f1b3cd$var$xi(a, b), $658cdb1025f1b3cd$var$Z(a), c;
        if (null !== $658cdb1025f1b3cd$var$X) throw Error($658cdb1025f1b3cd$var$u(261));
        a.finishedWork = a.current.alternate;
        a.finishedExpirationTime = b;
        $658cdb1025f1b3cd$var$T = null;
        $658cdb1025f1b3cd$var$Jj(a);
        $658cdb1025f1b3cd$var$Z(a);
    }
    return null;
}
function $658cdb1025f1b3cd$var$Lj() {
    if (null !== $658cdb1025f1b3cd$var$tj) {
        var a = $658cdb1025f1b3cd$var$tj;
        $658cdb1025f1b3cd$var$tj = null;
        a.forEach(function(a, c) {
            $658cdb1025f1b3cd$var$Cj(c, a);
            $658cdb1025f1b3cd$var$Z(c);
        });
        $658cdb1025f1b3cd$var$gg();
    }
}
function $658cdb1025f1b3cd$var$Mj(a, b) {
    var c = $658cdb1025f1b3cd$var$W;
    $658cdb1025f1b3cd$var$W |= 1;
    try {
        return a(b);
    } finally{
        $658cdb1025f1b3cd$var$W = c, $658cdb1025f1b3cd$var$W === $658cdb1025f1b3cd$var$V && $658cdb1025f1b3cd$var$gg();
    }
}
function $658cdb1025f1b3cd$var$Nj(a, b) {
    var c = $658cdb1025f1b3cd$var$W;
    $658cdb1025f1b3cd$var$W &= -2;
    $658cdb1025f1b3cd$var$W |= $658cdb1025f1b3cd$var$ej;
    try {
        return a(b);
    } finally{
        $658cdb1025f1b3cd$var$W = c, $658cdb1025f1b3cd$var$W === $658cdb1025f1b3cd$var$V && $658cdb1025f1b3cd$var$gg();
    }
}
function $658cdb1025f1b3cd$var$Ej(a, b) {
    a.finishedWork = null;
    a.finishedExpirationTime = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $658cdb1025f1b3cd$var$Id(c));
    if (null !== $658cdb1025f1b3cd$var$X) for(c = $658cdb1025f1b3cd$var$X.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $658cdb1025f1b3cd$var$Df();
                break;
            case 3:
                $658cdb1025f1b3cd$var$eh();
                $658cdb1025f1b3cd$var$H($658cdb1025f1b3cd$var$K);
                $658cdb1025f1b3cd$var$H($658cdb1025f1b3cd$var$J);
                break;
            case 5:
                $658cdb1025f1b3cd$var$gh(d);
                break;
            case 4:
                $658cdb1025f1b3cd$var$eh();
                break;
            case 13:
                $658cdb1025f1b3cd$var$H($658cdb1025f1b3cd$var$M);
                break;
            case 19:
                $658cdb1025f1b3cd$var$H($658cdb1025f1b3cd$var$M);
                break;
            case 10:
                $658cdb1025f1b3cd$var$og(d);
        }
        c = c.return;
    }
    $658cdb1025f1b3cd$var$T = a;
    $658cdb1025f1b3cd$var$X = $658cdb1025f1b3cd$var$Sg(a.current, null);
    $658cdb1025f1b3cd$var$U = b;
    $658cdb1025f1b3cd$var$S = $658cdb1025f1b3cd$var$ti;
    $658cdb1025f1b3cd$var$kj = null;
    $658cdb1025f1b3cd$var$mj = $658cdb1025f1b3cd$var$lj = 1073741823;
    $658cdb1025f1b3cd$var$nj = null;
    $658cdb1025f1b3cd$var$wi = 0;
    $658cdb1025f1b3cd$var$oj = !1;
}
function $658cdb1025f1b3cd$var$Hj(a, b) {
    do {
        try {
            $658cdb1025f1b3cd$var$ng();
            $658cdb1025f1b3cd$var$jh.current = $658cdb1025f1b3cd$var$sh;
            if ($658cdb1025f1b3cd$var$mh) for(var c = $658cdb1025f1b3cd$var$N.memoizedState; null !== c;){
                var d = c.queue;
                null !== d && (d.pending = null);
                c = c.next;
            }
            $658cdb1025f1b3cd$var$lh = 0;
            $658cdb1025f1b3cd$var$P = $658cdb1025f1b3cd$var$O = $658cdb1025f1b3cd$var$N = null;
            $658cdb1025f1b3cd$var$mh = !1;
            if (null === $658cdb1025f1b3cd$var$X || null === $658cdb1025f1b3cd$var$X.return) return $658cdb1025f1b3cd$var$S = $658cdb1025f1b3cd$var$hj, $658cdb1025f1b3cd$var$kj = b, $658cdb1025f1b3cd$var$X = null;
            a: {
                var e = a, f = $658cdb1025f1b3cd$var$X.return, g = $658cdb1025f1b3cd$var$X, h = b;
                b = $658cdb1025f1b3cd$var$U;
                g.effectTag |= 2048;
                g.firstEffect = g.lastEffect = null;
                if (null !== h && "object" === typeof h && "function" === typeof h.then) {
                    var k = h;
                    if (0 === (g.mode & 2)) {
                        var l = g.alternate;
                        l ? (g.updateQueue = l.updateQueue, g.memoizedState = l.memoizedState, g.expirationTime = l.expirationTime) : (g.updateQueue = null, g.memoizedState = null);
                    }
                    var m = 0 !== ($658cdb1025f1b3cd$var$M.current & 1), p = f;
                    do {
                        var x;
                        if (x = 13 === p.tag) {
                            var z = p.memoizedState;
                            if (null !== z) x = null !== z.dehydrated ? !0 : !1;
                            else {
                                var ca = p.memoizedProps;
                                x = void 0 === ca.fallback ? !1 : !0 !== ca.unstable_avoidThisFallback ? !0 : m ? !1 : !0;
                            }
                        }
                        if (x) {
                            var D = p.updateQueue;
                            if (null === D) {
                                var t = new Set;
                                t.add(k);
                                p.updateQueue = t;
                            } else D.add(k);
                            if (0 === (p.mode & 2)) {
                                p.effectTag |= 64;
                                g.effectTag &= -2981;
                                if (1 === g.tag) {
                                    if (null === g.alternate) g.tag = 17;
                                    else {
                                        var y = $658cdb1025f1b3cd$var$wg(1073741823, null);
                                        y.tag = 2;
                                        $658cdb1025f1b3cd$var$xg(g, y);
                                    }
                                }
                                g.expirationTime = 1073741823;
                                break a;
                            }
                            h = void 0;
                            g = b;
                            var A = e.pingCache;
                            null === A ? (A = e.pingCache = new $658cdb1025f1b3cd$var$Wi, h = new Set, A.set(k, h)) : (h = A.get(k), void 0 === h && (h = new Set, A.set(k, h)));
                            if (!h.has(g)) {
                                h.add(g);
                                var q = $658cdb1025f1b3cd$var$Oj.bind(null, e, k, g);
                                k.then(q, q);
                            }
                            p.effectTag |= 4096;
                            p.expirationTime = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    h = Error(($658cdb1025f1b3cd$var$pb(g.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display." + $658cdb1025f1b3cd$var$qb(g));
                }
                $658cdb1025f1b3cd$var$S !== $658cdb1025f1b3cd$var$jj && ($658cdb1025f1b3cd$var$S = $658cdb1025f1b3cd$var$ij);
                h = $658cdb1025f1b3cd$var$Ai(h, g);
                p = f;
                do {
                    switch(p.tag){
                        case 3:
                            k = h;
                            p.effectTag |= 4096;
                            p.expirationTime = b;
                            var B = $658cdb1025f1b3cd$var$Xi(p, k, b);
                            $658cdb1025f1b3cd$var$yg(p, B);
                            break a;
                        case 1:
                            k = h;
                            var w = p.type, ub = p.stateNode;
                            if (0 === (p.effectTag & 64) && ("function" === typeof w.getDerivedStateFromError || null !== ub && "function" === typeof ub.componentDidCatch && (null === $658cdb1025f1b3cd$var$aj || !$658cdb1025f1b3cd$var$aj.has(ub)))) {
                                p.effectTag |= 4096;
                                p.expirationTime = b;
                                var vb = $658cdb1025f1b3cd$var$$i(p, k, b);
                                $658cdb1025f1b3cd$var$yg(p, vb);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            $658cdb1025f1b3cd$var$X = $658cdb1025f1b3cd$var$Pj($658cdb1025f1b3cd$var$X);
        } catch (Xc) {
            b = Xc;
            continue;
        }
        break;
    }while (1);
}
function $658cdb1025f1b3cd$var$Fj() {
    var a = $658cdb1025f1b3cd$var$cj.current;
    $658cdb1025f1b3cd$var$cj.current = $658cdb1025f1b3cd$var$sh;
    return null === a ? $658cdb1025f1b3cd$var$sh : a;
}
function $658cdb1025f1b3cd$var$Ag(a, b) {
    a < $658cdb1025f1b3cd$var$lj && 2 < a && ($658cdb1025f1b3cd$var$lj = a);
    null !== b && a < $658cdb1025f1b3cd$var$mj && 2 < a && ($658cdb1025f1b3cd$var$mj = a, $658cdb1025f1b3cd$var$nj = b);
}
function $658cdb1025f1b3cd$var$Bg(a) {
    a > $658cdb1025f1b3cd$var$wi && ($658cdb1025f1b3cd$var$wi = a);
}
function $658cdb1025f1b3cd$var$Kj() {
    for(; null !== $658cdb1025f1b3cd$var$X;)$658cdb1025f1b3cd$var$X = $658cdb1025f1b3cd$var$Qj($658cdb1025f1b3cd$var$X);
}
function $658cdb1025f1b3cd$var$Gj() {
    for(; null !== $658cdb1025f1b3cd$var$X && !$658cdb1025f1b3cd$var$Uf();)$658cdb1025f1b3cd$var$X = $658cdb1025f1b3cd$var$Qj($658cdb1025f1b3cd$var$X);
}
function $658cdb1025f1b3cd$var$Qj(a) {
    var b = $658cdb1025f1b3cd$var$Rj(a.alternate, a, $658cdb1025f1b3cd$var$U);
    a.memoizedProps = a.pendingProps;
    null === b && (b = $658cdb1025f1b3cd$var$Pj(a));
    $658cdb1025f1b3cd$var$dj.current = null;
    return b;
}
function $658cdb1025f1b3cd$var$Pj(a) {
    $658cdb1025f1b3cd$var$X = a;
    do {
        var b = $658cdb1025f1b3cd$var$X.alternate;
        a = $658cdb1025f1b3cd$var$X.return;
        if (0 === ($658cdb1025f1b3cd$var$X.effectTag & 2048)) {
            b = $658cdb1025f1b3cd$var$si(b, $658cdb1025f1b3cd$var$X, $658cdb1025f1b3cd$var$U);
            if (1 === $658cdb1025f1b3cd$var$U || 1 !== $658cdb1025f1b3cd$var$X.childExpirationTime) {
                for(var c = 0, d = $658cdb1025f1b3cd$var$X.child; null !== d;){
                    var e = d.expirationTime, f = d.childExpirationTime;
                    e > c && (c = e);
                    f > c && (c = f);
                    d = d.sibling;
                }
                $658cdb1025f1b3cd$var$X.childExpirationTime = c;
            }
            if (null !== b) return b;
            null !== a && 0 === (a.effectTag & 2048) && (null === a.firstEffect && (a.firstEffect = $658cdb1025f1b3cd$var$X.firstEffect), null !== $658cdb1025f1b3cd$var$X.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = $658cdb1025f1b3cd$var$X.firstEffect), a.lastEffect = $658cdb1025f1b3cd$var$X.lastEffect), 1 < $658cdb1025f1b3cd$var$X.effectTag && (null !== a.lastEffect ? a.lastEffect.nextEffect = $658cdb1025f1b3cd$var$X : a.firstEffect = $658cdb1025f1b3cd$var$X, a.lastEffect = $658cdb1025f1b3cd$var$X));
        } else {
            b = $658cdb1025f1b3cd$var$zi($658cdb1025f1b3cd$var$X);
            if (null !== b) return b.effectTag &= 2047, b;
            null !== a && (a.firstEffect = a.lastEffect = null, a.effectTag |= 2048);
        }
        b = $658cdb1025f1b3cd$var$X.sibling;
        if (null !== b) return b;
        $658cdb1025f1b3cd$var$X = a;
    }while (null !== $658cdb1025f1b3cd$var$X);
    $658cdb1025f1b3cd$var$S === $658cdb1025f1b3cd$var$ti && ($658cdb1025f1b3cd$var$S = $658cdb1025f1b3cd$var$jj);
    return null;
}
function $658cdb1025f1b3cd$var$Ij(a) {
    var b = a.expirationTime;
    a = a.childExpirationTime;
    return b > a ? b : a;
}
function $658cdb1025f1b3cd$var$Jj(a) {
    var b = $658cdb1025f1b3cd$var$ag();
    $658cdb1025f1b3cd$var$cg(99, $658cdb1025f1b3cd$var$Sj.bind(null, a, b));
    return null;
}
function $658cdb1025f1b3cd$var$Sj(a, b) {
    do $658cdb1025f1b3cd$var$Dj();
    while (null !== $658cdb1025f1b3cd$var$rj);
    if (($658cdb1025f1b3cd$var$W & ($658cdb1025f1b3cd$var$fj | $658cdb1025f1b3cd$var$gj)) !== $658cdb1025f1b3cd$var$V) throw Error($658cdb1025f1b3cd$var$u(327));
    var c = a.finishedWork, d = a.finishedExpirationTime;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedExpirationTime = 0;
    if (c === a.current) throw Error($658cdb1025f1b3cd$var$u(177));
    a.callbackNode = null;
    a.callbackExpirationTime = 0;
    a.callbackPriority = 90;
    a.nextKnownPendingLevel = 0;
    var e = $658cdb1025f1b3cd$var$Ij(c);
    a.firstPendingTime = e;
    d <= a.lastSuspendedTime ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : d <= a.firstSuspendedTime && (a.firstSuspendedTime = d - 1);
    d <= a.lastPingedTime && (a.lastPingedTime = 0);
    d <= a.lastExpiredTime && (a.lastExpiredTime = 0);
    a === $658cdb1025f1b3cd$var$T && ($658cdb1025f1b3cd$var$X = $658cdb1025f1b3cd$var$T = null, $658cdb1025f1b3cd$var$U = 0);
    1 < c.effectTag ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, e = c.firstEffect) : e = c : e = c.firstEffect;
    if (null !== e) {
        var f = $658cdb1025f1b3cd$var$W;
        $658cdb1025f1b3cd$var$W |= $658cdb1025f1b3cd$var$gj;
        $658cdb1025f1b3cd$var$dj.current = null;
        $658cdb1025f1b3cd$var$Dd = $658cdb1025f1b3cd$var$fd;
        var g = $658cdb1025f1b3cd$var$xd();
        if ($658cdb1025f1b3cd$var$yd(g)) {
            if ("selectionStart" in g) var h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: {
                h = (h = g.ownerDocument) && h.defaultView || window;
                var k = h.getSelection && h.getSelection();
                if (k && 0 !== k.rangeCount) {
                    h = k.anchorNode;
                    var l = k.anchorOffset, m = k.focusNode;
                    k = k.focusOffset;
                    try {
                        h.nodeType, m.nodeType;
                    } catch (wb) {
                        h = null;
                        break a;
                    }
                    var p = 0, x = -1, z = -1, ca = 0, D = 0, t = g, y = null;
                    b: for(;;){
                        for(var A;;){
                            t !== h || 0 !== l && 3 !== t.nodeType || (x = p + l);
                            t !== m || 0 !== k && 3 !== t.nodeType || (z = p + k);
                            3 === t.nodeType && (p += t.nodeValue.length);
                            if (null === (A = t.firstChild)) break;
                            y = t;
                            t = A;
                        }
                        for(;;){
                            if (t === g) break b;
                            y === h && ++ca === l && (x = p);
                            y === m && ++D === k && (z = p);
                            if (null !== (A = t.nextSibling)) break;
                            t = y;
                            y = t.parentNode;
                        }
                        t = A;
                    }
                    h = -1 === x || -1 === z ? null : {
                        start: x,
                        end: z
                    };
                } else h = null;
            }
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        $658cdb1025f1b3cd$var$Ed = {
            activeElementDetached: null,
            focusedElem: g,
            selectionRange: h
        };
        $658cdb1025f1b3cd$var$fd = !1;
        $658cdb1025f1b3cd$var$Y = e;
        do try {
            $658cdb1025f1b3cd$var$Tj();
        } catch (wb) {
            if (null === $658cdb1025f1b3cd$var$Y) throw Error($658cdb1025f1b3cd$var$u(330));
            $658cdb1025f1b3cd$var$Ei($658cdb1025f1b3cd$var$Y, wb);
            $658cdb1025f1b3cd$var$Y = $658cdb1025f1b3cd$var$Y.nextEffect;
        }
        while (null !== $658cdb1025f1b3cd$var$Y);
        $658cdb1025f1b3cd$var$Y = e;
        do try {
            for(g = a, h = b; null !== $658cdb1025f1b3cd$var$Y;){
                var q = $658cdb1025f1b3cd$var$Y.effectTag;
                q & 16 && $658cdb1025f1b3cd$var$Rb($658cdb1025f1b3cd$var$Y.stateNode, "");
                if (q & 128) {
                    var B = $658cdb1025f1b3cd$var$Y.alternate;
                    if (null !== B) {
                        var w = B.ref;
                        null !== w && ("function" === typeof w ? w(null) : w.current = null);
                    }
                }
                switch(q & 1038){
                    case 2:
                        $658cdb1025f1b3cd$var$Pi($658cdb1025f1b3cd$var$Y);
                        $658cdb1025f1b3cd$var$Y.effectTag &= -3;
                        break;
                    case 6:
                        $658cdb1025f1b3cd$var$Pi($658cdb1025f1b3cd$var$Y);
                        $658cdb1025f1b3cd$var$Y.effectTag &= -3;
                        $658cdb1025f1b3cd$var$Si($658cdb1025f1b3cd$var$Y.alternate, $658cdb1025f1b3cd$var$Y);
                        break;
                    case 1024:
                        $658cdb1025f1b3cd$var$Y.effectTag &= -1025;
                        break;
                    case 1028:
                        $658cdb1025f1b3cd$var$Y.effectTag &= -1025;
                        $658cdb1025f1b3cd$var$Si($658cdb1025f1b3cd$var$Y.alternate, $658cdb1025f1b3cd$var$Y);
                        break;
                    case 4:
                        $658cdb1025f1b3cd$var$Si($658cdb1025f1b3cd$var$Y.alternate, $658cdb1025f1b3cd$var$Y);
                        break;
                    case 8:
                        l = $658cdb1025f1b3cd$var$Y, $658cdb1025f1b3cd$var$Mi(g, l, h), $658cdb1025f1b3cd$var$Ni(l);
                }
                $658cdb1025f1b3cd$var$Y = $658cdb1025f1b3cd$var$Y.nextEffect;
            }
        } catch (wb) {
            if (null === $658cdb1025f1b3cd$var$Y) throw Error($658cdb1025f1b3cd$var$u(330));
            $658cdb1025f1b3cd$var$Ei($658cdb1025f1b3cd$var$Y, wb);
            $658cdb1025f1b3cd$var$Y = $658cdb1025f1b3cd$var$Y.nextEffect;
        }
        while (null !== $658cdb1025f1b3cd$var$Y);
        w = $658cdb1025f1b3cd$var$Ed;
        B = $658cdb1025f1b3cd$var$xd();
        q = w.focusedElem;
        h = w.selectionRange;
        if (B !== q && q && q.ownerDocument && $658cdb1025f1b3cd$var$wd(q.ownerDocument.documentElement, q)) {
            null !== h && $658cdb1025f1b3cd$var$yd(q) && (B = h.start, w = h.end, void 0 === w && (w = B), "selectionStart" in q ? (q.selectionStart = B, q.selectionEnd = Math.min(w, q.value.length)) : (w = (B = q.ownerDocument || document) && B.defaultView || window, w.getSelection && (w = w.getSelection(), l = q.textContent.length, g = Math.min(h.start, l), h = void 0 === h.end ? g : Math.min(h.end, l), !w.extend && g > h && (l = h, h = g, g = l), l = $658cdb1025f1b3cd$var$vd(q, g), m = $658cdb1025f1b3cd$var$vd(q, h), l && m && (1 !== w.rangeCount || w.anchorNode !== l.node || w.anchorOffset !== l.offset || w.focusNode !== m.node || w.focusOffset !== m.offset) && (B = B.createRange(), B.setStart(l.node, l.offset), w.removeAllRanges(), g > h ? (w.addRange(B), w.extend(m.node, m.offset)) : (B.setEnd(m.node, m.offset), w.addRange(B))))));
            B = [];
            for(w = q; w = w.parentNode;)1 === w.nodeType && B.push({
                element: w,
                left: w.scrollLeft,
                top: w.scrollTop
            });
            "function" === typeof q.focus && q.focus();
            for(q = 0; q < B.length; q++)w = B[q], w.element.scrollLeft = w.left, w.element.scrollTop = w.top;
        }
        $658cdb1025f1b3cd$var$fd = !!$658cdb1025f1b3cd$var$Dd;
        $658cdb1025f1b3cd$var$Ed = $658cdb1025f1b3cd$var$Dd = null;
        a.current = c;
        $658cdb1025f1b3cd$var$Y = e;
        do try {
            for(q = a; null !== $658cdb1025f1b3cd$var$Y;){
                var ub = $658cdb1025f1b3cd$var$Y.effectTag;
                ub & 36 && $658cdb1025f1b3cd$var$Ji(q, $658cdb1025f1b3cd$var$Y.alternate, $658cdb1025f1b3cd$var$Y);
                if (ub & 128) {
                    B = void 0;
                    var vb = $658cdb1025f1b3cd$var$Y.ref;
                    if (null !== vb) {
                        var Xc = $658cdb1025f1b3cd$var$Y.stateNode;
                        switch($658cdb1025f1b3cd$var$Y.tag){
                            case 5:
                                B = Xc;
                                break;
                            default:
                                B = Xc;
                        }
                        "function" === typeof vb ? vb(B) : vb.current = B;
                    }
                }
                $658cdb1025f1b3cd$var$Y = $658cdb1025f1b3cd$var$Y.nextEffect;
            }
        } catch (wb) {
            if (null === $658cdb1025f1b3cd$var$Y) throw Error($658cdb1025f1b3cd$var$u(330));
            $658cdb1025f1b3cd$var$Ei($658cdb1025f1b3cd$var$Y, wb);
            $658cdb1025f1b3cd$var$Y = $658cdb1025f1b3cd$var$Y.nextEffect;
        }
        while (null !== $658cdb1025f1b3cd$var$Y);
        $658cdb1025f1b3cd$var$Y = null;
        $658cdb1025f1b3cd$var$Vf();
        $658cdb1025f1b3cd$var$W = f;
    } else a.current = c;
    if ($658cdb1025f1b3cd$var$qj) $658cdb1025f1b3cd$var$qj = !1, $658cdb1025f1b3cd$var$rj = a, $658cdb1025f1b3cd$var$sj = b;
    else for($658cdb1025f1b3cd$var$Y = e; null !== $658cdb1025f1b3cd$var$Y;)b = $658cdb1025f1b3cd$var$Y.nextEffect, $658cdb1025f1b3cd$var$Y.nextEffect = null, $658cdb1025f1b3cd$var$Y = b;
    b = a.firstPendingTime;
    0 === b && ($658cdb1025f1b3cd$var$aj = null);
    1073741823 === b ? a === $658cdb1025f1b3cd$var$vj ? $658cdb1025f1b3cd$var$uj++ : ($658cdb1025f1b3cd$var$uj = 0, $658cdb1025f1b3cd$var$vj = a) : $658cdb1025f1b3cd$var$uj = 0;
    "function" === typeof $658cdb1025f1b3cd$var$Uj && $658cdb1025f1b3cd$var$Uj(c.stateNode, d);
    $658cdb1025f1b3cd$var$Z(a);
    if ($658cdb1025f1b3cd$var$Yi) throw $658cdb1025f1b3cd$var$Yi = !1, a = $658cdb1025f1b3cd$var$Zi, $658cdb1025f1b3cd$var$Zi = null, a;
    if (($658cdb1025f1b3cd$var$W & $658cdb1025f1b3cd$var$ej) !== $658cdb1025f1b3cd$var$V) return null;
    $658cdb1025f1b3cd$var$gg();
    return null;
}
function $658cdb1025f1b3cd$var$Tj() {
    for(; null !== $658cdb1025f1b3cd$var$Y;){
        var a = $658cdb1025f1b3cd$var$Y.effectTag;
        0 !== (a & 256) && $658cdb1025f1b3cd$var$Gi($658cdb1025f1b3cd$var$Y.alternate, $658cdb1025f1b3cd$var$Y);
        0 === (a & 512) || $658cdb1025f1b3cd$var$qj || ($658cdb1025f1b3cd$var$qj = !0, $658cdb1025f1b3cd$var$dg(97, function() {
            $658cdb1025f1b3cd$var$Dj();
            return null;
        }));
        $658cdb1025f1b3cd$var$Y = $658cdb1025f1b3cd$var$Y.nextEffect;
    }
}
function $658cdb1025f1b3cd$var$Dj() {
    if (90 !== $658cdb1025f1b3cd$var$sj) {
        var a = 97 < $658cdb1025f1b3cd$var$sj ? 97 : $658cdb1025f1b3cd$var$sj;
        $658cdb1025f1b3cd$var$sj = 90;
        return $658cdb1025f1b3cd$var$cg(a, $658cdb1025f1b3cd$var$Vj);
    }
}
function $658cdb1025f1b3cd$var$Vj() {
    if (null === $658cdb1025f1b3cd$var$rj) return !1;
    var a = $658cdb1025f1b3cd$var$rj;
    $658cdb1025f1b3cd$var$rj = null;
    if (($658cdb1025f1b3cd$var$W & ($658cdb1025f1b3cd$var$fj | $658cdb1025f1b3cd$var$gj)) !== $658cdb1025f1b3cd$var$V) throw Error($658cdb1025f1b3cd$var$u(331));
    var b = $658cdb1025f1b3cd$var$W;
    $658cdb1025f1b3cd$var$W |= $658cdb1025f1b3cd$var$gj;
    for(a = a.current.firstEffect; null !== a;){
        try {
            var c = a;
            if (0 !== (c.effectTag & 512)) switch(c.tag){
                case 0:
                case 11:
                case 15:
                case 22:
                    $658cdb1025f1b3cd$var$Hi(5, c), $658cdb1025f1b3cd$var$Ii(5, c);
            }
        } catch (d) {
            if (null === a) throw Error($658cdb1025f1b3cd$var$u(330));
            $658cdb1025f1b3cd$var$Ei(a, d);
        }
        c = a.nextEffect;
        a.nextEffect = null;
        a = c;
    }
    $658cdb1025f1b3cd$var$W = b;
    $658cdb1025f1b3cd$var$gg();
    return !0;
}
function $658cdb1025f1b3cd$var$Wj(a, b, c) {
    b = $658cdb1025f1b3cd$var$Ai(c, b);
    b = $658cdb1025f1b3cd$var$Xi(a, b, 1073741823);
    $658cdb1025f1b3cd$var$xg(a, b);
    a = $658cdb1025f1b3cd$var$xj(a, 1073741823);
    null !== a && $658cdb1025f1b3cd$var$Z(a);
}
function $658cdb1025f1b3cd$var$Ei(a, b) {
    if (3 === a.tag) $658cdb1025f1b3cd$var$Wj(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            $658cdb1025f1b3cd$var$Wj(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $658cdb1025f1b3cd$var$aj || !$658cdb1025f1b3cd$var$aj.has(d))) {
                a = $658cdb1025f1b3cd$var$Ai(b, a);
                a = $658cdb1025f1b3cd$var$$i(c, a, 1073741823);
                $658cdb1025f1b3cd$var$xg(c, a);
                c = $658cdb1025f1b3cd$var$xj(c, 1073741823);
                null !== c && $658cdb1025f1b3cd$var$Z(c);
                break;
            }
        }
        c = c.return;
    }
}
function $658cdb1025f1b3cd$var$Oj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    $658cdb1025f1b3cd$var$T === a && $658cdb1025f1b3cd$var$U === c ? $658cdb1025f1b3cd$var$S === $658cdb1025f1b3cd$var$vi || $658cdb1025f1b3cd$var$S === $658cdb1025f1b3cd$var$ui && 1073741823 === $658cdb1025f1b3cd$var$lj && $658cdb1025f1b3cd$var$$f() - $658cdb1025f1b3cd$var$Ti < $658cdb1025f1b3cd$var$pj ? $658cdb1025f1b3cd$var$Ej(a, $658cdb1025f1b3cd$var$U) : $658cdb1025f1b3cd$var$oj = !0 : $658cdb1025f1b3cd$var$Aj(a, c) && (b = a.lastPingedTime, 0 !== b && b < c || (a.lastPingedTime = c, $658cdb1025f1b3cd$var$Z(a)));
}
function $658cdb1025f1b3cd$var$Vi(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = $658cdb1025f1b3cd$var$Gg(), b = $658cdb1025f1b3cd$var$Hg(b, a, null));
    a = $658cdb1025f1b3cd$var$xj(a, b);
    null !== a && $658cdb1025f1b3cd$var$Z(a);
}
var $658cdb1025f1b3cd$var$Rj;
$658cdb1025f1b3cd$var$Rj = function(a, b, c) {
    var d = b.expirationTime;
    if (null !== a) {
        var e = b.pendingProps;
        if (a.memoizedProps !== e || $658cdb1025f1b3cd$var$K.current) $658cdb1025f1b3cd$var$rg = !0;
        else {
            if (d < c) {
                $658cdb1025f1b3cd$var$rg = !1;
                switch(b.tag){
                    case 3:
                        $658cdb1025f1b3cd$var$hi(b);
                        $658cdb1025f1b3cd$var$Xh();
                        break;
                    case 5:
                        $658cdb1025f1b3cd$var$fh(b);
                        if (b.mode & 4 && 1 !== c && e.hidden) return b.expirationTime = b.childExpirationTime = 1, null;
                        break;
                    case 1:
                        $658cdb1025f1b3cd$var$L(b.type) && $658cdb1025f1b3cd$var$Gf(b);
                        break;
                    case 4:
                        $658cdb1025f1b3cd$var$dh(b, b.stateNode.containerInfo);
                        break;
                    case 10:
                        d = b.memoizedProps.value;
                        e = b.type._context;
                        $658cdb1025f1b3cd$var$I($658cdb1025f1b3cd$var$jg, e._currentValue);
                        e._currentValue = d;
                        break;
                    case 13:
                        if (null !== b.memoizedState) {
                            d = b.child.childExpirationTime;
                            if (0 !== d && d >= c) return $658cdb1025f1b3cd$var$ji(a, b, c);
                            $658cdb1025f1b3cd$var$I($658cdb1025f1b3cd$var$M, $658cdb1025f1b3cd$var$M.current & 1);
                            b = $658cdb1025f1b3cd$var$$h(a, b, c);
                            return null !== b ? b.sibling : null;
                        }
                        $658cdb1025f1b3cd$var$I($658cdb1025f1b3cd$var$M, $658cdb1025f1b3cd$var$M.current & 1);
                        break;
                    case 19:
                        d = b.childExpirationTime >= c;
                        if (0 !== (a.effectTag & 64)) {
                            if (d) return $658cdb1025f1b3cd$var$mi(a, b, c);
                            b.effectTag |= 64;
                        }
                        e = b.memoizedState;
                        null !== e && (e.rendering = null, e.tail = null);
                        $658cdb1025f1b3cd$var$I($658cdb1025f1b3cd$var$M, $658cdb1025f1b3cd$var$M.current);
                        if (!d) return null;
                }
                return $658cdb1025f1b3cd$var$$h(a, b, c);
            }
            $658cdb1025f1b3cd$var$rg = !1;
        }
    } else $658cdb1025f1b3cd$var$rg = !1;
    b.expirationTime = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
            a = b.pendingProps;
            e = $658cdb1025f1b3cd$var$Cf(b, $658cdb1025f1b3cd$var$J.current);
            $658cdb1025f1b3cd$var$qg(b, c);
            e = $658cdb1025f1b3cd$var$oh(null, b, d, a, e, c);
            b.effectTag |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if ($658cdb1025f1b3cd$var$L(d)) {
                    var f = !0;
                    $658cdb1025f1b3cd$var$Gf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                $658cdb1025f1b3cd$var$ug(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && $658cdb1025f1b3cd$var$Fg(b, d, g, a);
                e.updater = $658cdb1025f1b3cd$var$Jg;
                b.stateNode = e;
                e._reactInternalFiber = b;
                $658cdb1025f1b3cd$var$Ng(b, d, a, c);
                b = $658cdb1025f1b3cd$var$gi(null, b, d, !0, f, c);
            } else b.tag = 0, $658cdb1025f1b3cd$var$R(null, b, e, c), b = b.child;
            return b;
        case 16:
            a: {
                e = b.elementType;
                null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
                a = b.pendingProps;
                $658cdb1025f1b3cd$var$ob(e);
                if (1 !== e._status) throw e._result;
                e = e._result;
                b.type = e;
                f = b.tag = $658cdb1025f1b3cd$var$Xj(e);
                a = $658cdb1025f1b3cd$var$ig(e, a);
                switch(f){
                    case 0:
                        b = $658cdb1025f1b3cd$var$di(null, b, e, a, c);
                        break a;
                    case 1:
                        b = $658cdb1025f1b3cd$var$fi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = $658cdb1025f1b3cd$var$Zh(null, b, e, a, c);
                        break a;
                    case 14:
                        b = $658cdb1025f1b3cd$var$ai(null, b, e, $658cdb1025f1b3cd$var$ig(e.type, a), d, c);
                        break a;
                }
                throw Error($658cdb1025f1b3cd$var$u(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $658cdb1025f1b3cd$var$ig(d, e), $658cdb1025f1b3cd$var$di(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $658cdb1025f1b3cd$var$ig(d, e), $658cdb1025f1b3cd$var$fi(a, b, d, e, c);
        case 3:
            $658cdb1025f1b3cd$var$hi(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error($658cdb1025f1b3cd$var$u(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            $658cdb1025f1b3cd$var$vg(a, b);
            $658cdb1025f1b3cd$var$zg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) $658cdb1025f1b3cd$var$Xh(), b = $658cdb1025f1b3cd$var$$h(a, b, c);
            else {
                if (e = b.stateNode.hydrate) $658cdb1025f1b3cd$var$Ph = $658cdb1025f1b3cd$var$Jd(b.stateNode.containerInfo.firstChild), $658cdb1025f1b3cd$var$Oh = b, e = $658cdb1025f1b3cd$var$Qh = !0;
                if (e) for(c = $658cdb1025f1b3cd$var$Yg(b, null, d, c), b.child = c; c;)c.effectTag = c.effectTag & -3 | 1024, c = c.sibling;
                else $658cdb1025f1b3cd$var$R(a, b, d, c), $658cdb1025f1b3cd$var$Xh();
                b = b.child;
            }
            return b;
        case 5:
            return $658cdb1025f1b3cd$var$fh(b), null === a && $658cdb1025f1b3cd$var$Uh(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $658cdb1025f1b3cd$var$Gd(d, e) ? g = null : null !== f && $658cdb1025f1b3cd$var$Gd(d, f) && (b.effectTag |= 16), $658cdb1025f1b3cd$var$ei(a, b), b.mode & 4 && 1 !== c && e.hidden ? (b.expirationTime = b.childExpirationTime = 1, b = null) : ($658cdb1025f1b3cd$var$R(a, b, g, c), b = b.child), b;
        case 6:
            return null === a && $658cdb1025f1b3cd$var$Uh(b), null;
        case 13:
            return $658cdb1025f1b3cd$var$ji(a, b, c);
        case 4:
            return $658cdb1025f1b3cd$var$dh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $658cdb1025f1b3cd$var$Xg(b, null, d, c) : $658cdb1025f1b3cd$var$R(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $658cdb1025f1b3cd$var$ig(d, e), $658cdb1025f1b3cd$var$Zh(a, b, d, e, c);
        case 7:
            return $658cdb1025f1b3cd$var$R(a, b, b.pendingProps, c), b.child;
        case 8:
            return $658cdb1025f1b3cd$var$R(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $658cdb1025f1b3cd$var$R(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                $658cdb1025f1b3cd$var$I($658cdb1025f1b3cd$var$jg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = $658cdb1025f1b3cd$var$$e(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !$658cdb1025f1b3cd$var$K.current) {
                            b = $658cdb1025f1b3cd$var$$h(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = $658cdb1025f1b3cd$var$wg(c, null), l.tag = 2, $658cdb1025f1b3cd$var$xg(h, l));
                                    h.expirationTime < c && (h.expirationTime = c);
                                    l = h.alternate;
                                    null !== l && l.expirationTime < c && (l.expirationTime = c);
                                    $658cdb1025f1b3cd$var$pg(h.return, c);
                                    k.expirationTime < c && (k.expirationTime = c);
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                $658cdb1025f1b3cd$var$R(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, $658cdb1025f1b3cd$var$qg(b, c), e = $658cdb1025f1b3cd$var$sg(e, f.unstable_observedBits), d = d(e), b.effectTag |= 1, $658cdb1025f1b3cd$var$R(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = $658cdb1025f1b3cd$var$ig(e, b.pendingProps), f = $658cdb1025f1b3cd$var$ig(e.type, f), $658cdb1025f1b3cd$var$ai(a, b, e, f, d, c);
        case 15:
            return $658cdb1025f1b3cd$var$ci(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $658cdb1025f1b3cd$var$ig(d, e), null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), b.tag = 1, $658cdb1025f1b3cd$var$L(d) ? (a = !0, $658cdb1025f1b3cd$var$Gf(b)) : a = !1, $658cdb1025f1b3cd$var$qg(b, c), $658cdb1025f1b3cd$var$Lg(b, d, e), $658cdb1025f1b3cd$var$Ng(b, d, e, c), $658cdb1025f1b3cd$var$gi(null, b, d, !0, a, c);
        case 19:
            return $658cdb1025f1b3cd$var$mi(a, b, c);
    }
    throw Error($658cdb1025f1b3cd$var$u(156, b.tag));
};
var $658cdb1025f1b3cd$var$Uj = null, $658cdb1025f1b3cd$var$Li = null;
function $658cdb1025f1b3cd$var$Yj(a) {
    if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
    var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (b.isDisabled || !b.supportsFiber) return !0;
    try {
        var c = b.inject(a);
        $658cdb1025f1b3cd$var$Uj = function(a) {
            try {
                b.onCommitFiberRoot(c, a, void 0, 64 === (a.current.effectTag & 64));
            } catch (e) {}
        };
        $658cdb1025f1b3cd$var$Li = function(a) {
            try {
                b.onCommitFiberUnmount(c, a);
            } catch (e) {}
        };
    } catch (d) {}
    return !0;
}
function $658cdb1025f1b3cd$var$Zj(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.effectTag = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childExpirationTime = this.expirationTime = 0;
    this.alternate = null;
}
function $658cdb1025f1b3cd$var$Sh(a, b, c, d) {
    return new $658cdb1025f1b3cd$var$Zj(a, b, c, d);
}
function $658cdb1025f1b3cd$var$bi(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $658cdb1025f1b3cd$var$Xj(a) {
    if ("function" === typeof a) return $658cdb1025f1b3cd$var$bi(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $658cdb1025f1b3cd$var$gb) return 11;
        if (a === $658cdb1025f1b3cd$var$jb) return 14;
    }
    return 2;
}
function $658cdb1025f1b3cd$var$Sg(a, b) {
    var c = a.alternate;
    null === c ? (c = $658cdb1025f1b3cd$var$Sh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.effectTag = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childExpirationTime = a.childExpirationTime;
    c.expirationTime = a.expirationTime;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        expirationTime: b.expirationTime,
        firstContext: b.firstContext,
        responders: b.responders
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $658cdb1025f1b3cd$var$Ug(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $658cdb1025f1b3cd$var$bi(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $658cdb1025f1b3cd$var$ab:
            return $658cdb1025f1b3cd$var$Wg(c.children, e, f, b);
        case $658cdb1025f1b3cd$var$fb:
            g = 8;
            e |= 7;
            break;
        case $658cdb1025f1b3cd$var$bb:
            g = 8;
            e |= 1;
            break;
        case $658cdb1025f1b3cd$var$cb:
            return a = $658cdb1025f1b3cd$var$Sh(12, c, b, e | 8), a.elementType = $658cdb1025f1b3cd$var$cb, a.type = $658cdb1025f1b3cd$var$cb, a.expirationTime = f, a;
        case $658cdb1025f1b3cd$var$hb:
            return a = $658cdb1025f1b3cd$var$Sh(13, c, b, e), a.type = $658cdb1025f1b3cd$var$hb, a.elementType = $658cdb1025f1b3cd$var$hb, a.expirationTime = f, a;
        case $658cdb1025f1b3cd$var$ib:
            return a = $658cdb1025f1b3cd$var$Sh(19, c, b, e), a.elementType = $658cdb1025f1b3cd$var$ib, a.expirationTime = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $658cdb1025f1b3cd$var$db:
                    g = 10;
                    break a;
                case $658cdb1025f1b3cd$var$eb:
                    g = 9;
                    break a;
                case $658cdb1025f1b3cd$var$gb:
                    g = 11;
                    break a;
                case $658cdb1025f1b3cd$var$jb:
                    g = 14;
                    break a;
                case $658cdb1025f1b3cd$var$kb:
                    g = 16;
                    d = null;
                    break a;
                case $658cdb1025f1b3cd$var$lb:
                    g = 22;
                    break a;
            }
            throw Error($658cdb1025f1b3cd$var$u(130, null == a ? a : typeof a, ""));
    }
    b = $658cdb1025f1b3cd$var$Sh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.expirationTime = f;
    return b;
}
function $658cdb1025f1b3cd$var$Wg(a, b, c, d) {
    a = $658cdb1025f1b3cd$var$Sh(7, a, d, b);
    a.expirationTime = c;
    return a;
}
function $658cdb1025f1b3cd$var$Tg(a, b, c) {
    a = $658cdb1025f1b3cd$var$Sh(6, a, null, b);
    a.expirationTime = c;
    return a;
}
function $658cdb1025f1b3cd$var$Vg(a, b, c) {
    b = $658cdb1025f1b3cd$var$Sh(4, null !== a.children ? a.children : [], a.key, b);
    b.expirationTime = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $658cdb1025f1b3cd$var$ak(a, b, c) {
    this.tag = b;
    this.current = null;
    this.containerInfo = a;
    this.pingCache = this.pendingChildren = null;
    this.finishedExpirationTime = 0;
    this.finishedWork = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 90;
    this.lastExpiredTime = this.lastPingedTime = this.nextKnownPendingLevel = this.lastSuspendedTime = this.firstSuspendedTime = this.firstPendingTime = 0;
}
function $658cdb1025f1b3cd$var$Aj(a, b) {
    var c = a.firstSuspendedTime;
    a = a.lastSuspendedTime;
    return 0 !== c && c >= b && a <= b;
}
function $658cdb1025f1b3cd$var$xi(a, b) {
    var c = a.firstSuspendedTime, d = a.lastSuspendedTime;
    c < b && (a.firstSuspendedTime = b);
    if (d > b || 0 === c) a.lastSuspendedTime = b;
    b <= a.lastPingedTime && (a.lastPingedTime = 0);
    b <= a.lastExpiredTime && (a.lastExpiredTime = 0);
}
function $658cdb1025f1b3cd$var$yi(a, b) {
    b > a.firstPendingTime && (a.firstPendingTime = b);
    var c = a.firstSuspendedTime;
    0 !== c && (b >= c ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : b >= a.lastSuspendedTime && (a.lastSuspendedTime = b + 1), b > a.nextKnownPendingLevel && (a.nextKnownPendingLevel = b));
}
function $658cdb1025f1b3cd$var$Cj(a, b) {
    var c = a.lastExpiredTime;
    if (0 === c || c > b) a.lastExpiredTime = b;
}
function $658cdb1025f1b3cd$var$bk(a, b, c, d) {
    var e = b.current, f = $658cdb1025f1b3cd$var$Gg(), g = $658cdb1025f1b3cd$var$Dg.suspense;
    f = $658cdb1025f1b3cd$var$Hg(f, e, g);
    a: if (c) {
        c = c._reactInternalFiber;
        b: {
            if ($658cdb1025f1b3cd$var$dc(c) !== c || 1 !== c.tag) throw Error($658cdb1025f1b3cd$var$u(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if ($658cdb1025f1b3cd$var$L(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error($658cdb1025f1b3cd$var$u(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if ($658cdb1025f1b3cd$var$L(k)) {
                c = $658cdb1025f1b3cd$var$Ff(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = $658cdb1025f1b3cd$var$Af;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $658cdb1025f1b3cd$var$wg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    $658cdb1025f1b3cd$var$xg(e, b);
    $658cdb1025f1b3cd$var$Ig(e, f);
    return f;
}
function $658cdb1025f1b3cd$var$ck(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $658cdb1025f1b3cd$var$dk(a, b) {
    a = a.memoizedState;
    null !== a && null !== a.dehydrated && a.retryTime < b && (a.retryTime = b);
}
function $658cdb1025f1b3cd$var$ek(a, b) {
    $658cdb1025f1b3cd$var$dk(a, b);
    (a = a.alternate) && $658cdb1025f1b3cd$var$dk(a, b);
}
function $658cdb1025f1b3cd$var$fk(a, b, c) {
    c = null != c && !0 === c.hydrate;
    var d = new $658cdb1025f1b3cd$var$ak(a, b, c), e = $658cdb1025f1b3cd$var$Sh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    d.current = e;
    e.stateNode = d;
    $658cdb1025f1b3cd$var$ug(e);
    a[$658cdb1025f1b3cd$var$Od] = d.current;
    c && 0 !== b && $658cdb1025f1b3cd$var$Jc(a, 9 === a.nodeType ? a : a.ownerDocument);
    this._internalRoot = d;
}
$658cdb1025f1b3cd$var$fk.prototype.render = function(a) {
    $658cdb1025f1b3cd$var$bk(a, this._internalRoot, null, null);
};
$658cdb1025f1b3cd$var$fk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    $658cdb1025f1b3cd$var$bk(null, a, null, function() {
        b[$658cdb1025f1b3cd$var$Od] = null;
    });
};
function $658cdb1025f1b3cd$var$gk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $658cdb1025f1b3cd$var$hk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new $658cdb1025f1b3cd$var$fk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function $658cdb1025f1b3cd$var$ik(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $658cdb1025f1b3cd$var$ck(g);
                h.call(a);
            };
        }
        $658cdb1025f1b3cd$var$bk(b, g, a, e);
    } else {
        f = c._reactRootContainer = $658cdb1025f1b3cd$var$hk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = $658cdb1025f1b3cd$var$ck(g);
                k.call(a);
            };
        }
        $658cdb1025f1b3cd$var$Nj(function() {
            $658cdb1025f1b3cd$var$bk(b, g, a, e);
        });
    }
    return $658cdb1025f1b3cd$var$ck(g);
}
function $658cdb1025f1b3cd$var$jk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $658cdb1025f1b3cd$var$$a,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
$658cdb1025f1b3cd$var$wc = function(a) {
    if (13 === a.tag) {
        var b = $658cdb1025f1b3cd$var$hg($658cdb1025f1b3cd$var$Gg(), 150, 100);
        $658cdb1025f1b3cd$var$Ig(a, b);
        $658cdb1025f1b3cd$var$ek(a, b);
    }
};
$658cdb1025f1b3cd$var$xc = function(a) {
    13 === a.tag && ($658cdb1025f1b3cd$var$Ig(a, 3), $658cdb1025f1b3cd$var$ek(a, 3));
};
$658cdb1025f1b3cd$var$yc = function(a) {
    if (13 === a.tag) {
        var b = $658cdb1025f1b3cd$var$Gg();
        b = $658cdb1025f1b3cd$var$Hg(b, a, null);
        $658cdb1025f1b3cd$var$Ig(a, b);
        $658cdb1025f1b3cd$var$ek(a, b);
    }
};
$658cdb1025f1b3cd$var$za = function(a, b, c) {
    switch(b){
        case "input":
            $658cdb1025f1b3cd$var$Cb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $658cdb1025f1b3cd$var$Qd(d);
                        if (!e) throw Error($658cdb1025f1b3cd$var$u(90));
                        $658cdb1025f1b3cd$var$yb(d);
                        $658cdb1025f1b3cd$var$Cb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $658cdb1025f1b3cd$var$Kb(a, c);
            break;
        case "select":
            b = c.value, null != b && $658cdb1025f1b3cd$var$Hb(a, !!c.multiple, b, !1);
    }
};
$658cdb1025f1b3cd$var$Fa = $658cdb1025f1b3cd$var$Mj;
$658cdb1025f1b3cd$var$Ga = function(a, b, c, d, e) {
    var f = $658cdb1025f1b3cd$var$W;
    $658cdb1025f1b3cd$var$W |= 4;
    try {
        return $658cdb1025f1b3cd$var$cg(98, a.bind(null, b, c, d, e));
    } finally{
        $658cdb1025f1b3cd$var$W = f, $658cdb1025f1b3cd$var$W === $658cdb1025f1b3cd$var$V && $658cdb1025f1b3cd$var$gg();
    }
};
$658cdb1025f1b3cd$var$Ha = function() {
    ($658cdb1025f1b3cd$var$W & (1 | $658cdb1025f1b3cd$var$fj | $658cdb1025f1b3cd$var$gj)) === $658cdb1025f1b3cd$var$V && ($658cdb1025f1b3cd$var$Lj(), $658cdb1025f1b3cd$var$Dj());
};
$658cdb1025f1b3cd$var$Ia = function(a, b) {
    var c = $658cdb1025f1b3cd$var$W;
    $658cdb1025f1b3cd$var$W |= 2;
    try {
        return a(b);
    } finally{
        $658cdb1025f1b3cd$var$W = c, $658cdb1025f1b3cd$var$W === $658cdb1025f1b3cd$var$V && $658cdb1025f1b3cd$var$gg();
    }
};
function $658cdb1025f1b3cd$var$kk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$658cdb1025f1b3cd$var$gk(b)) throw Error($658cdb1025f1b3cd$var$u(200));
    return $658cdb1025f1b3cd$var$jk(a, b, null, c);
}
var $658cdb1025f1b3cd$var$lk = {
    Events: [
        $658cdb1025f1b3cd$var$Nc,
        $658cdb1025f1b3cd$var$Pd,
        $658cdb1025f1b3cd$var$Qd,
        $658cdb1025f1b3cd$var$xa,
        $658cdb1025f1b3cd$var$ta,
        $658cdb1025f1b3cd$var$Xd,
        function(a) {
            $658cdb1025f1b3cd$var$jc(a, $658cdb1025f1b3cd$var$Wd);
        },
        $658cdb1025f1b3cd$var$Da,
        $658cdb1025f1b3cd$var$Ea,
        $658cdb1025f1b3cd$var$id,
        $658cdb1025f1b3cd$var$mc,
        $658cdb1025f1b3cd$var$Dj,
        {
            current: !1
        }
    ]
};
(function(a) {
    var b = a.findFiberByHostInstance;
    return $658cdb1025f1b3cd$var$Yj($22Kv0({}, a, {
        overrideHookState: null,
        overrideProps: null,
        setSuspenseHandler: null,
        scheduleUpdate: null,
        currentDispatcherRef: $658cdb1025f1b3cd$var$Wa.ReactCurrentDispatcher,
        findHostInstanceByFiber: function(a) {
            a = $658cdb1025f1b3cd$var$hc(a);
            return null === a ? null : a.stateNode;
        },
        findFiberByHostInstance: function(a) {
            return b ? b(a) : null;
        },
        findHostInstancesForRefresh: null,
        scheduleRefresh: null,
        scheduleRoot: null,
        setRefreshHandler: null,
        getCurrentFiber: null
    }));
})({
    findFiberByHostInstance: $658cdb1025f1b3cd$var$tc,
    bundleType: 0,
    version: "16.13.1",
    rendererPackageName: "react-dom"
});
$658cdb1025f1b3cd$export$ae55be85d98224ed = $658cdb1025f1b3cd$var$lk;
$658cdb1025f1b3cd$export$d39a5bbd09211389 = $658cdb1025f1b3cd$var$kk;
$658cdb1025f1b3cd$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternalFiber;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($658cdb1025f1b3cd$var$u(188));
        throw Error($658cdb1025f1b3cd$var$u(268, Object.keys(a)));
    }
    a = $658cdb1025f1b3cd$var$hc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$658cdb1025f1b3cd$export$cd75ccfd720a3cd4 = function(a, b) {
    if (($658cdb1025f1b3cd$var$W & ($658cdb1025f1b3cd$var$fj | $658cdb1025f1b3cd$var$gj)) !== $658cdb1025f1b3cd$var$V) throw Error($658cdb1025f1b3cd$var$u(187));
    var c = $658cdb1025f1b3cd$var$W;
    $658cdb1025f1b3cd$var$W |= 1;
    try {
        return $658cdb1025f1b3cd$var$cg(99, a.bind(null, b));
    } finally{
        $658cdb1025f1b3cd$var$W = c, $658cdb1025f1b3cd$var$gg();
    }
};
$658cdb1025f1b3cd$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$658cdb1025f1b3cd$var$gk(b)) throw Error($658cdb1025f1b3cd$var$u(200));
    return $658cdb1025f1b3cd$var$ik(null, a, b, !0, c);
};
$658cdb1025f1b3cd$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$658cdb1025f1b3cd$var$gk(b)) throw Error($658cdb1025f1b3cd$var$u(200));
    return $658cdb1025f1b3cd$var$ik(null, a, b, !1, c);
};
$658cdb1025f1b3cd$export$502457920280e6be = function(a) {
    if (!$658cdb1025f1b3cd$var$gk(a)) throw Error($658cdb1025f1b3cd$var$u(40));
    return a._reactRootContainer ? ($658cdb1025f1b3cd$var$Nj(function() {
        $658cdb1025f1b3cd$var$ik(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$658cdb1025f1b3cd$var$Od] = null;
        });
    }), !0) : !1;
};
$658cdb1025f1b3cd$export$c78a37762a8d58e1 = $658cdb1025f1b3cd$var$Mj;
$658cdb1025f1b3cd$export$2577ef5d2565d52f = function(a, b) {
    return $658cdb1025f1b3cd$var$kk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
$658cdb1025f1b3cd$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$658cdb1025f1b3cd$var$gk(c)) throw Error($658cdb1025f1b3cd$var$u(200));
    if (null == a || void 0 === a._reactInternalFiber) throw Error($658cdb1025f1b3cd$var$u(38));
    return $658cdb1025f1b3cd$var$ik(a, b, c, !1, d);
};
$658cdb1025f1b3cd$export$83d89fbfd8236492 = "16.13.1";

});
parcelRequire.register("lze1c", function(module, exports) {
"use strict";

module.exports = (parcelRequire("hngRT"));

});
parcelRequire.register("hngRT", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $ca61ab55d1e46435$export$c4744153514ff05d; }, function (v) { return $ca61ab55d1e46435$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $ca61ab55d1e46435$export$d66a1c1c77bd778b; }, function (v) { return $ca61ab55d1e46435$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $ca61ab55d1e46435$export$3e506c1ccc9cc1a7; }, function (v) { return $ca61ab55d1e46435$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $ca61ab55d1e46435$export$e26fe2ed2fa76875; }, function (v) { return $ca61ab55d1e46435$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $ca61ab55d1e46435$export$502329bbf4b505b1; }, function (v) { return $ca61ab55d1e46435$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $ca61ab55d1e46435$export$6e3807111c4874c4; }, function (v) { return $ca61ab55d1e46435$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $ca61ab55d1e46435$export$c27134553091fb3a; }, function (v) { return $ca61ab55d1e46435$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $ca61ab55d1e46435$export$33ee1acdc04fd2a2; }, function (v) { return $ca61ab55d1e46435$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $ca61ab55d1e46435$export$b00a404bbd5edef2; }, function (v) { return $ca61ab55d1e46435$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $ca61ab55d1e46435$export$8352ce38b91d0c62; }, function (v) { return $ca61ab55d1e46435$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $ca61ab55d1e46435$export$d3dfb8e4810cb555; }, function (v) { return $ca61ab55d1e46435$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $ca61ab55d1e46435$export$839f9183b0465a69; }, function (v) { return $ca61ab55d1e46435$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $ca61ab55d1e46435$export$72fdf0e06517287b; }, function (v) { return $ca61ab55d1e46435$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $ca61ab55d1e46435$export$4b844e58a3e414b4; }, function (v) { return $ca61ab55d1e46435$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $ca61ab55d1e46435$export$816d2913ae6b83b1; }, function (v) { return $ca61ab55d1e46435$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $ca61ab55d1e46435$export$61bcfe829111a1d0; }, function (v) { return $ca61ab55d1e46435$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $ca61ab55d1e46435$export$7ee8c9beb337bc3f; }, function (v) { return $ca61ab55d1e46435$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $ca61ab55d1e46435$export$b5836b71941fa3ed; }, function (v) { return $ca61ab55d1e46435$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $ca61ab55d1e46435$export$cf845f2c119da08a; }, function (v) { return $ca61ab55d1e46435$export$cf845f2c119da08a = v; });
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ca61ab55d1e46435$export$c4744153514ff05d;
var $ca61ab55d1e46435$export$d66a1c1c77bd778b;
var $ca61ab55d1e46435$export$3e506c1ccc9cc1a7;
var $ca61ab55d1e46435$export$e26fe2ed2fa76875;
var $ca61ab55d1e46435$export$502329bbf4b505b1;
var $ca61ab55d1e46435$export$6e3807111c4874c4;
var $ca61ab55d1e46435$export$c27134553091fb3a;
var $ca61ab55d1e46435$export$33ee1acdc04fd2a2;
var $ca61ab55d1e46435$export$b00a404bbd5edef2;
var $ca61ab55d1e46435$export$8352ce38b91d0c62;
var $ca61ab55d1e46435$export$d3dfb8e4810cb555;
var $ca61ab55d1e46435$export$839f9183b0465a69;
var $ca61ab55d1e46435$export$72fdf0e06517287b;
var $ca61ab55d1e46435$export$4b844e58a3e414b4;
var $ca61ab55d1e46435$export$816d2913ae6b83b1;
var $ca61ab55d1e46435$export$61bcfe829111a1d0;
var $ca61ab55d1e46435$export$7ee8c9beb337bc3f;
var $ca61ab55d1e46435$export$b5836b71941fa3ed;
var $ca61ab55d1e46435$export$cf845f2c119da08a;
"use strict";
var $ca61ab55d1e46435$var$f, $ca61ab55d1e46435$var$g, $ca61ab55d1e46435$var$h, $ca61ab55d1e46435$var$k, $ca61ab55d1e46435$var$l;
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $ca61ab55d1e46435$var$p = null, $ca61ab55d1e46435$var$q = null, $ca61ab55d1e46435$var$t = function() {
        if (null !== $ca61ab55d1e46435$var$p) try {
            var a = $ca61ab55d1e46435$export$c4744153514ff05d();
            $ca61ab55d1e46435$var$p(!0, a);
            $ca61ab55d1e46435$var$p = null;
        } catch (b) {
            throw setTimeout($ca61ab55d1e46435$var$t, 0), b;
        }
    }, $ca61ab55d1e46435$var$u = Date.now();
    $ca61ab55d1e46435$export$c4744153514ff05d = function() {
        return Date.now() - $ca61ab55d1e46435$var$u;
    };
    $ca61ab55d1e46435$var$f = function(a) {
        null !== $ca61ab55d1e46435$var$p ? setTimeout($ca61ab55d1e46435$var$f, 0, a) : ($ca61ab55d1e46435$var$p = a, setTimeout($ca61ab55d1e46435$var$t, 0));
    };
    $ca61ab55d1e46435$var$g = function(a, b) {
        $ca61ab55d1e46435$var$q = setTimeout(a, b);
    };
    $ca61ab55d1e46435$var$h = function() {
        clearTimeout($ca61ab55d1e46435$var$q);
    };
    $ca61ab55d1e46435$var$k = function() {
        return !1;
    };
    $ca61ab55d1e46435$var$l = $ca61ab55d1e46435$export$d66a1c1c77bd778b = function() {};
} else {
    var $ca61ab55d1e46435$var$w = window.performance, $ca61ab55d1e46435$var$x = window.Date, $ca61ab55d1e46435$var$y = window.setTimeout, $ca61ab55d1e46435$var$z = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $ca61ab55d1e46435$var$A = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
        "function" !== typeof $ca61ab55d1e46435$var$A && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
    }
    if ("object" === typeof $ca61ab55d1e46435$var$w && "function" === typeof $ca61ab55d1e46435$var$w.now) $ca61ab55d1e46435$export$c4744153514ff05d = function() {
        return $ca61ab55d1e46435$var$w.now();
    };
    else {
        var $ca61ab55d1e46435$var$B = $ca61ab55d1e46435$var$x.now();
        $ca61ab55d1e46435$export$c4744153514ff05d = function() {
            return $ca61ab55d1e46435$var$x.now() - $ca61ab55d1e46435$var$B;
        };
    }
    var $ca61ab55d1e46435$var$C = !1, $ca61ab55d1e46435$var$D = null, $ca61ab55d1e46435$var$E = -1, $ca61ab55d1e46435$var$F = 5, $ca61ab55d1e46435$var$G = 0;
    $ca61ab55d1e46435$var$k = function() {
        return $ca61ab55d1e46435$export$c4744153514ff05d() >= $ca61ab55d1e46435$var$G;
    };
    $ca61ab55d1e46435$var$l = function() {};
    $ca61ab55d1e46435$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported") : $ca61ab55d1e46435$var$F = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $ca61ab55d1e46435$var$H = new MessageChannel, $ca61ab55d1e46435$var$I = $ca61ab55d1e46435$var$H.port2;
    $ca61ab55d1e46435$var$H.port1.onmessage = function() {
        if (null !== $ca61ab55d1e46435$var$D) {
            var a = $ca61ab55d1e46435$export$c4744153514ff05d();
            $ca61ab55d1e46435$var$G = a + $ca61ab55d1e46435$var$F;
            try {
                $ca61ab55d1e46435$var$D(!0, a) ? $ca61ab55d1e46435$var$I.postMessage(null) : ($ca61ab55d1e46435$var$C = !1, $ca61ab55d1e46435$var$D = null);
            } catch (b) {
                throw $ca61ab55d1e46435$var$I.postMessage(null), b;
            }
        } else $ca61ab55d1e46435$var$C = !1;
    };
    $ca61ab55d1e46435$var$f = function(a) {
        $ca61ab55d1e46435$var$D = a;
        $ca61ab55d1e46435$var$C || ($ca61ab55d1e46435$var$C = !0, $ca61ab55d1e46435$var$I.postMessage(null));
    };
    $ca61ab55d1e46435$var$g = function(a, b) {
        $ca61ab55d1e46435$var$E = $ca61ab55d1e46435$var$y(function() {
            a($ca61ab55d1e46435$export$c4744153514ff05d());
        }, b);
    };
    $ca61ab55d1e46435$var$h = function() {
        $ca61ab55d1e46435$var$z($ca61ab55d1e46435$var$E);
        $ca61ab55d1e46435$var$E = -1;
    };
}
function $ca61ab55d1e46435$var$J(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $ca61ab55d1e46435$var$K(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $ca61ab55d1e46435$var$L(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $ca61ab55d1e46435$var$M(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $ca61ab55d1e46435$var$K(n, c)) void 0 !== r && 0 > $ca61ab55d1e46435$var$K(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $ca61ab55d1e46435$var$K(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $ca61ab55d1e46435$var$K(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $ca61ab55d1e46435$var$N = [], $ca61ab55d1e46435$var$O = [], $ca61ab55d1e46435$var$P = 1, $ca61ab55d1e46435$var$Q = null, $ca61ab55d1e46435$var$R = 3, $ca61ab55d1e46435$var$S = !1, $ca61ab55d1e46435$var$T = !1, $ca61ab55d1e46435$var$U = !1;
function $ca61ab55d1e46435$var$V(a) {
    for(var b = $ca61ab55d1e46435$var$L($ca61ab55d1e46435$var$O); null !== b;){
        if (null === b.callback) $ca61ab55d1e46435$var$M($ca61ab55d1e46435$var$O);
        else if (b.startTime <= a) $ca61ab55d1e46435$var$M($ca61ab55d1e46435$var$O), b.sortIndex = b.expirationTime, $ca61ab55d1e46435$var$J($ca61ab55d1e46435$var$N, b);
        else break;
        b = $ca61ab55d1e46435$var$L($ca61ab55d1e46435$var$O);
    }
}
function $ca61ab55d1e46435$var$W(a) {
    $ca61ab55d1e46435$var$U = !1;
    $ca61ab55d1e46435$var$V(a);
    if (!$ca61ab55d1e46435$var$T) {
        if (null !== $ca61ab55d1e46435$var$L($ca61ab55d1e46435$var$N)) $ca61ab55d1e46435$var$T = !0, $ca61ab55d1e46435$var$f($ca61ab55d1e46435$var$X);
        else {
            var b = $ca61ab55d1e46435$var$L($ca61ab55d1e46435$var$O);
            null !== b && $ca61ab55d1e46435$var$g($ca61ab55d1e46435$var$W, b.startTime - a);
        }
    }
}
function $ca61ab55d1e46435$var$X(a, b) {
    $ca61ab55d1e46435$var$T = !1;
    $ca61ab55d1e46435$var$U && ($ca61ab55d1e46435$var$U = !1, $ca61ab55d1e46435$var$h());
    $ca61ab55d1e46435$var$S = !0;
    var c = $ca61ab55d1e46435$var$R;
    try {
        $ca61ab55d1e46435$var$V(b);
        for($ca61ab55d1e46435$var$Q = $ca61ab55d1e46435$var$L($ca61ab55d1e46435$var$N); null !== $ca61ab55d1e46435$var$Q && (!($ca61ab55d1e46435$var$Q.expirationTime > b) || a && !$ca61ab55d1e46435$var$k());){
            var d = $ca61ab55d1e46435$var$Q.callback;
            if (null !== d) {
                $ca61ab55d1e46435$var$Q.callback = null;
                $ca61ab55d1e46435$var$R = $ca61ab55d1e46435$var$Q.priorityLevel;
                var e = d($ca61ab55d1e46435$var$Q.expirationTime <= b);
                b = $ca61ab55d1e46435$export$c4744153514ff05d();
                "function" === typeof e ? $ca61ab55d1e46435$var$Q.callback = e : $ca61ab55d1e46435$var$Q === $ca61ab55d1e46435$var$L($ca61ab55d1e46435$var$N) && $ca61ab55d1e46435$var$M($ca61ab55d1e46435$var$N);
                $ca61ab55d1e46435$var$V(b);
            } else $ca61ab55d1e46435$var$M($ca61ab55d1e46435$var$N);
            $ca61ab55d1e46435$var$Q = $ca61ab55d1e46435$var$L($ca61ab55d1e46435$var$N);
        }
        if (null !== $ca61ab55d1e46435$var$Q) var m = !0;
        else {
            var n = $ca61ab55d1e46435$var$L($ca61ab55d1e46435$var$O);
            null !== n && $ca61ab55d1e46435$var$g($ca61ab55d1e46435$var$W, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $ca61ab55d1e46435$var$Q = null, $ca61ab55d1e46435$var$R = c, $ca61ab55d1e46435$var$S = !1;
    }
}
function $ca61ab55d1e46435$var$Y(a) {
    switch(a){
        case 1:
            return -1;
        case 2:
            return 250;
        case 5:
            return 1073741823;
        case 4:
            return 1E4;
        default:
            return 5E3;
    }
}
var $ca61ab55d1e46435$var$Z = $ca61ab55d1e46435$var$l;
$ca61ab55d1e46435$export$3e506c1ccc9cc1a7 = 5;
$ca61ab55d1e46435$export$e26fe2ed2fa76875 = 1;
$ca61ab55d1e46435$export$502329bbf4b505b1 = 4;
$ca61ab55d1e46435$export$6e3807111c4874c4 = 3;
$ca61ab55d1e46435$export$c27134553091fb3a = null;
$ca61ab55d1e46435$export$33ee1acdc04fd2a2 = 2;
$ca61ab55d1e46435$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$ca61ab55d1e46435$export$8352ce38b91d0c62 = function() {
    $ca61ab55d1e46435$var$T || $ca61ab55d1e46435$var$S || ($ca61ab55d1e46435$var$T = !0, $ca61ab55d1e46435$var$f($ca61ab55d1e46435$var$X));
};
$ca61ab55d1e46435$export$d3dfb8e4810cb555 = function() {
    return $ca61ab55d1e46435$var$R;
};
$ca61ab55d1e46435$export$839f9183b0465a69 = function() {
    return $ca61ab55d1e46435$var$L($ca61ab55d1e46435$var$N);
};
$ca61ab55d1e46435$export$72fdf0e06517287b = function(a) {
    switch($ca61ab55d1e46435$var$R){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $ca61ab55d1e46435$var$R;
    }
    var c = $ca61ab55d1e46435$var$R;
    $ca61ab55d1e46435$var$R = b;
    try {
        return a();
    } finally{
        $ca61ab55d1e46435$var$R = c;
    }
};
$ca61ab55d1e46435$export$4b844e58a3e414b4 = function() {};
$ca61ab55d1e46435$export$816d2913ae6b83b1 = $ca61ab55d1e46435$var$Z;
$ca61ab55d1e46435$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $ca61ab55d1e46435$var$R;
    $ca61ab55d1e46435$var$R = a;
    try {
        return b();
    } finally{
        $ca61ab55d1e46435$var$R = c;
    }
};
$ca61ab55d1e46435$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $ca61ab55d1e46435$export$c4744153514ff05d();
    if ("object" === typeof c && null !== c) {
        var e = c.delay;
        e = "number" === typeof e && 0 < e ? d + e : d;
        c = "number" === typeof c.timeout ? c.timeout : $ca61ab55d1e46435$var$Y(a);
    } else c = $ca61ab55d1e46435$var$Y(a), e = d;
    c = e + c;
    a = {
        id: $ca61ab55d1e46435$var$P++,
        callback: b,
        priorityLevel: a,
        startTime: e,
        expirationTime: c,
        sortIndex: -1
    };
    e > d ? (a.sortIndex = e, $ca61ab55d1e46435$var$J($ca61ab55d1e46435$var$O, a), null === $ca61ab55d1e46435$var$L($ca61ab55d1e46435$var$N) && a === $ca61ab55d1e46435$var$L($ca61ab55d1e46435$var$O) && ($ca61ab55d1e46435$var$U ? $ca61ab55d1e46435$var$h() : $ca61ab55d1e46435$var$U = !0, $ca61ab55d1e46435$var$g($ca61ab55d1e46435$var$W, e - d))) : (a.sortIndex = c, $ca61ab55d1e46435$var$J($ca61ab55d1e46435$var$N, a), $ca61ab55d1e46435$var$T || $ca61ab55d1e46435$var$S || ($ca61ab55d1e46435$var$T = !0, $ca61ab55d1e46435$var$f($ca61ab55d1e46435$var$X)));
    return a;
};
$ca61ab55d1e46435$export$b5836b71941fa3ed = function() {
    var a = $ca61ab55d1e46435$export$c4744153514ff05d();
    $ca61ab55d1e46435$var$V(a);
    var b = $ca61ab55d1e46435$var$L($ca61ab55d1e46435$var$N);
    return b !== $ca61ab55d1e46435$var$Q && null !== $ca61ab55d1e46435$var$Q && null !== b && null !== b.callback && b.startTime <= a && b.expirationTime < $ca61ab55d1e46435$var$Q.expirationTime || $ca61ab55d1e46435$var$k();
};
$ca61ab55d1e46435$export$cf845f2c119da08a = function(a) {
    var b = $ca61ab55d1e46435$var$R;
    return function() {
        var c = $ca61ab55d1e46435$var$R;
        $ca61ab55d1e46435$var$R = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $ca61ab55d1e46435$var$R = c;
        }
    };
};

});



parcelRequire.register("iaNTL", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $bYlId = parcelRequire("bYlId");
function $d3afddee53892e5e$var$emptyFunction() {}
function $d3afddee53892e5e$var$emptyFunctionWithReset() {}
$d3afddee53892e5e$var$emptyFunctionWithReset.resetWarningCache = $d3afddee53892e5e$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $bYlId) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $d3afddee53892e5e$var$emptyFunctionWithReset,
        resetWarningCache: $d3afddee53892e5e$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRequire.register("bYlId", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $8b7623e2c2e05724$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $8b7623e2c2e05724$var$ReactPropTypesSecret;

});


parcelRequire.register("kSeqf", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $f32409c1b79251cc$export$bdfd709ae4826697; }, function (v) { return $f32409c1b79251cc$export$bdfd709ae4826697 = v; });
var $f32409c1b79251cc$export$bdfd709ae4826697;
var $f32409c1b79251cc$export$c9e73fbda7da57b6;
var $f32409c1b79251cc$export$5a759dc7a1cfb72a;
"use strict";
var $f32409c1b79251cc$var$bundleURL = {};
function $f32409c1b79251cc$var$getBundleURLCached(id) {
    var value = $f32409c1b79251cc$var$bundleURL[id];
    if (!value) {
        value = $f32409c1b79251cc$var$getBundleURL();
        $f32409c1b79251cc$var$bundleURL[id] = value;
    }
    return value;
}
function $f32409c1b79251cc$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $f32409c1b79251cc$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $f32409c1b79251cc$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $f32409c1b79251cc$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$f32409c1b79251cc$export$bdfd709ae4826697 = $f32409c1b79251cc$var$getBundleURLCached;
$f32409c1b79251cc$export$c9e73fbda7da57b6 = $f32409c1b79251cc$var$getBaseURL;
$f32409c1b79251cc$export$5a759dc7a1cfb72a = $f32409c1b79251cc$var$getOrigin;

});

parcelRequire.register("4fEaA", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("876af")).default; });
$parcel$export(module.exports, "TweenLite", function () { return (parcelRequire("hYzRA")).default; });
$parcel$export(module.exports, "TweenMax", function () { return (parcelRequire("876af")).default; });
$parcel$export(module.exports, "TimelineLite", function () { return (parcelRequire("6ifWP")).default; });
$parcel$export(module.exports, "TimelineMax", function () { return (parcelRequire("9fTje")).default; });
$parcel$export(module.exports, "CSSPlugin", function () { return (parcelRequire("50C1t")).default; });
$parcel$export(module.exports, "AttrPlugin", function () { return (parcelRequire("uj8kT")).default; });
$parcel$export(module.exports, "BezierPlugin", function () { return (parcelRequire("51K6f")).default; });
$parcel$export(module.exports, "RoundPropsPlugin", function () { return (parcelRequire("jPhug")).default; });
$parcel$export(module.exports, "DirectionalRotationPlugin", function () { return (parcelRequire("dMZ37")).default; });
$parcel$export(module.exports, "TweenPlugin", function () { return (parcelRequire("hYzRA")).TweenPlugin; });
$parcel$export(module.exports, "Ease", function () { return (parcelRequire("hYzRA")).Ease; });
$parcel$export(module.exports, "Power0", function () { return (parcelRequire("hYzRA")).Power0; });
$parcel$export(module.exports, "Power1", function () { return (parcelRequire("hYzRA")).Power1; });
$parcel$export(module.exports, "Power2", function () { return (parcelRequire("hYzRA")).Power2; });
$parcel$export(module.exports, "Power3", function () { return (parcelRequire("hYzRA")).Power3; });
$parcel$export(module.exports, "Power4", function () { return (parcelRequire("hYzRA")).Power4; });
$parcel$export(module.exports, "Linear", function () { return (parcelRequire("hYzRA")).Linear; });
$parcel$export(module.exports, "Back", function () { return (parcelRequire("4kabR")).Back; });
$parcel$export(module.exports, "Elastic", function () { return (parcelRequire("4kabR")).Elastic; });
$parcel$export(module.exports, "Bounce", function () { return (parcelRequire("4kabR")).Bounce; });
$parcel$export(module.exports, "RoughEase", function () { return (parcelRequire("4kabR")).RoughEase; });
$parcel$export(module.exports, "SlowMo", function () { return (parcelRequire("4kabR")).SlowMo; });
$parcel$export(module.exports, "SteppedEase", function () { return (parcelRequire("4kabR")).SteppedEase; });
$parcel$export(module.exports, "Circ", function () { return (parcelRequire("4kabR")).Circ; });
$parcel$export(module.exports, "Expo", function () { return (parcelRequire("4kabR")).Expo; });
$parcel$export(module.exports, "Sine", function () { return (parcelRequire("4kabR")).Sine; });
$parcel$export(module.exports, "ExpoScaleEase", function () { return (parcelRequire("4kabR")).ExpoScaleEase; });
$parcel$export(module.exports, "_gsScope", function () { return (parcelRequire("hYzRA"))._gsScope; });
/*!
 * VERSION: 2.1.3
 * DATE: 2019-05-17
 * UPDATES AND DOCS AT: http://greensock.com
 *
 * @license Copyright (c) 2008-2019, GreenSock. All rights reserved.
 * This work is subject to the terms at http://greensock.com/standard-license or for
 * Club GreenSock members, the software agreement that was issued with your membership.
 *
 * @author: Jack Doyle, jack@greensock.com
 **/ 
var $hYzRA = parcelRequire("hYzRA");

var $6ifWP = parcelRequire("6ifWP");

var $9fTje = parcelRequire("9fTje");

var $876af = parcelRequire("876af");

var $50C1t = parcelRequire("50C1t");

var $uj8kT = parcelRequire("uj8kT");

var $jPhug = parcelRequire("jPhug");

var $dMZ37 = parcelRequire("dMZ37");

var $51K6f = parcelRequire("51K6f");

var $4kabR = parcelRequire("4kabR");

});
parcelRequire.register("hYzRA", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "_gsScope", function () { return $d163dbfd7d10e9ea$export$1824eb36b59182; });
$parcel$export(module.exports, "TweenLite", function () { return $d163dbfd7d10e9ea$export$2a5557542e634d07; });
$parcel$export(module.exports, "globals", function () { return $d163dbfd7d10e9ea$export$816be348776d53c1; });
$parcel$export(module.exports, "default", function () { return $d163dbfd7d10e9ea$export$2a5557542e634d07; });
$parcel$export(module.exports, "SimpleTimeline", function () { return $d163dbfd7d10e9ea$export$8c24d35d7aa285be; });
$parcel$export(module.exports, "Animation", function () { return $d163dbfd7d10e9ea$export$c35d437ae5945fcd; });
$parcel$export(module.exports, "Ease", function () { return $d163dbfd7d10e9ea$export$e60daad661aebae6; });
$parcel$export(module.exports, "Linear", function () { return $d163dbfd7d10e9ea$export$cff00ccf6e2392de; });
$parcel$export(module.exports, "Power0", function () { return $d163dbfd7d10e9ea$export$2fae1e8613537d5f; });
$parcel$export(module.exports, "Power1", function () { return $d163dbfd7d10e9ea$export$5d84ab4efbecec39; });
$parcel$export(module.exports, "Power2", function () { return $d163dbfd7d10e9ea$export$d8c694b7490ad65d; });
$parcel$export(module.exports, "Power3", function () { return $d163dbfd7d10e9ea$export$acebdf2b184a0b6f; });
$parcel$export(module.exports, "Power4", function () { return $d163dbfd7d10e9ea$export$42e40a141003d2f0; });
$parcel$export(module.exports, "TweenPlugin", function () { return $d163dbfd7d10e9ea$export$dff375347c6b75b7; });
$parcel$export(module.exports, "EventDispatcher", function () { return $d163dbfd7d10e9ea$export$ec8b666c5fe2c75a; });
/*!
 * VERSION: 2.1.3
 * DATE: 2019-05-17
 * UPDATES AND DOCS AT: http://greensock.com
 *
 * @license Copyright (c) 2008-2019, GreenSock. All rights reserved.
 * This work is subject to the terms at http://greensock.com/standard-license or for
 * Club GreenSock members, the software agreement that was issued with your membership.
 *
 * @author: Jack Doyle, jack@greensock.com
 */ /* eslint-disable */ /* ES6 changes:
	- declare and export _gsScope at top.
	- set var TweenLite = the result of the main function
	- export default TweenLite at the bottom
	- return TweenLite at the bottom of the main function
	- pass in _gsScope as the first parameter of the main function (which is actually at the bottom)
	- remove the "export to multiple environments" in Definition().
 */ var $d163dbfd7d10e9ea$export$1824eb36b59182 = typeof window !== "undefined" ? window : typeof module !== "undefined" && module.exports && typeof $parcel$global !== "undefined" ? $parcel$global : undefined || {};
var $d163dbfd7d10e9ea$export$2a5557542e634d07 = function(window1) {
    "use strict";
    var _exports = {}, _doc = window1.document, _globals = window1.GreenSockGlobals = window1.GreenSockGlobals || window1;
    if (_globals.TweenLite) return _globals.TweenLite; //in case the core set of classes is already loaded, don't instantiate twice.
    var _namespace = function(ns) {
        var a = ns.split("."), p = _globals, i;
        for(i = 0; i < a.length; i++)p[a[i]] = p = p[a[i]] || {};
        return p;
    }, gs = _namespace("com.greensock"), _tinyNum = 0.00000001, _slice = function(a) {
        var b = [], l = a.length, i;
        for(i = 0; i !== l; b.push(a[i++]));
        return b;
    }, _emptyFunc = function() {}, _isArray = function() {
        var toString = Object.prototype.toString, array = toString.call([]);
        return function(obj) {
            return obj != null && (obj instanceof Array || typeof obj === "object" && !!obj.push && toString.call(obj) === array);
        };
    }(), a, i, p, _ticker, _tickerActive, _defLookup = {}, /**
			 * @constructor
			 * Defines a GreenSock class, optionally with an array of dependencies that must be instantiated first and passed into the definition.
			 * This allows users to load GreenSock JS files in any order even if they have interdependencies (like CSSPlugin extends TweenPlugin which is
			 * inside TweenLite.js, but if CSSPlugin is loaded first, it should wait to run its code until TweenLite.js loads and instantiates TweenPlugin
			 * and then pass TweenPlugin to CSSPlugin's definition). This is all done automatically and internally.
			 *
			 * Every definition will be added to a "com.greensock" global object (typically window, but if a window.GreenSockGlobals object is found,
			 * it will go there as of v1.7). For example, TweenLite will be found at window.com.greensock.TweenLite and since it's a global class that should be available anywhere,
			 * it is ALSO referenced at window.TweenLite. However some classes aren't considered global, like the base com.greensock.core.Animation class, so
			 * those will only be at the package like window.com.greensock.core.Animation. Again, if you define a GreenSockGlobals object on the window, everything
			 * gets tucked neatly inside there instead of on the window directly. This allows you to do advanced things like load multiple versions of GreenSock
			 * files and put them into distinct objects (imagine a banner ad uses a newer version but the main site uses an older one). In that case, you could
			 * sandbox the banner one like:
			 *
			 * <script>
			 *     var gs = window.GreenSockGlobals = {}; //the newer version we're about to load could now be referenced in a "gs" object, like gs.TweenLite.to(...). Use whatever alias you want as long as it's unique, "gs" or "banner" or whatever.
			 * </script>
			 * <script src="js/greensock/v1.7/TweenMax.js"></script>
			 * <script>
			 *     window.GreenSockGlobals = window._gsQueue = window._gsDefine = null; //reset it back to null (along with the special _gsQueue variable) so that the next load of TweenMax affects the window and we can reference things directly like TweenLite.to(...)
			 * </script>
			 * <script src="js/greensock/v1.6/TweenMax.js"></script>
			 * <script>
			 *     gs.TweenLite.to(...); //would use v1.7
			 *     TweenLite.to(...); //would use v1.6
			 * </script>
			 *
			 * @param {!string} ns The namespace of the class definition, leaving off "com.greensock." as that's assumed. For example, "TweenLite" or "plugins.CSSPlugin" or "easing.Back".
			 * @param {!Array.<string>} dependencies An array of dependencies (described as their namespaces minus "com.greensock." prefix). For example ["TweenLite","plugins.TweenPlugin","core.Animation"]
			 * @param {!function():Object} func The function that should be called and passed the resolved dependencies which will return the actual class for this definition.
			 * @param {boolean=} global If true, the class will be added to the global scope (typically window unless you define a window.GreenSockGlobals object)
			 */ Definition = function(ns, dependencies, func, global1) {
        this.sc = _defLookup[ns] ? _defLookup[ns].sc : []; //subclasses
        _defLookup[ns] = this;
        this.gsClass = null;
        this.func = func;
        var _classes = [];
        this.check = function(init) {
            var i = dependencies.length, missing = i, cur, a, n, cl;
            while(--i > -1){
                if ((cur = _defLookup[dependencies[i]] || new Definition(dependencies[i], [])).gsClass) {
                    _classes[i] = cur.gsClass;
                    missing--;
                } else if (init) cur.sc.push(this);
            }
            if (missing === 0 && func) {
                a = ("com.greensock." + ns).split(".");
                n = a.pop();
                cl = _namespace(a.join("."))[n] = this.gsClass = func.apply(func, _classes);
                //exports to multiple environments
                if (global1) _globals[n] = _exports[n] = cl; //provides a way to avoid global namespace pollution. By default, the main classes like TweenLite, Power1, Strong, etc. are added to window unless a GreenSockGlobals is defined. So if you want to have things added to a custom object instead, just do something like window.GreenSockGlobals = {} before loading any GreenSock files. You can even set up an alias like window.GreenSockGlobals = windows.gs = {} so that you can access everything like gs.TweenLite. Also remember that ALL classes are added to the window.com.greensock object (in their respective packages, like com.greensock.easing.Power1, com.greensock.TweenLite, etc.)
                for(i = 0; i < this.sc.length; i++)this.sc[i].check();
            }
        };
        this.check(true);
    }, //used to create Definition instances (which basically registers a class that has dependencies).
    _gsDefine = window1._gsDefine = function(ns, dependencies, func, global1) {
        return new Definition(ns, dependencies, func, global1);
    }, //a quick way to create a class that doesn't have any dependencies. Returns the class, but first registers it in the GreenSock namespace so that other classes can grab it (other classes might be dependent on the class).
    _class = gs._class = function(ns, func, global1) {
        func = func || function() {};
        _gsDefine(ns, [], function() {
            return func;
        }, global1);
        return func;
    };
    _gsDefine.globals = _globals;
    /*
 * ----------------------------------------------------------------
 * Ease
 * ----------------------------------------------------------------
 */ var _baseParams = [
        0,
        0,
        1,
        1
    ], Ease = _class("easing.Ease", function(func, extraParams, type, power) {
        this._func = func;
        this._type = type || 0;
        this._power = power || 0;
        this._params = extraParams ? _baseParams.concat(extraParams) : _baseParams;
    }, true), _easeMap = Ease.map = {}, _easeReg = Ease.register = function(ease, names, types, create) {
        var na = names.split(","), i = na.length, ta = (types || "easeIn,easeOut,easeInOut").split(","), e, name, j, type;
        while(--i > -1){
            name = na[i];
            e = create ? _class("easing." + name, null, true) : gs.easing[name] || {};
            j = ta.length;
            while(--j > -1){
                type = ta[j];
                _easeMap[name + "." + type] = _easeMap[type + name] = e[type] = ease.getRatio ? ease : ease[type] || new ease();
            }
        }
    };
    p = Ease.prototype;
    p._calcEnd = false;
    p.getRatio = function(p) {
        if (this._func) {
            this._params[0] = p;
            return this._func.apply(null, this._params);
        }
        var t = this._type, pw = this._power, r = t === 1 ? 1 - p : t === 2 ? p : p < 0.5 ? p * 2 : (1 - p) * 2;
        if (pw === 1) r *= r;
        else if (pw === 2) r *= r * r;
        else if (pw === 3) r *= r * r * r;
        else if (pw === 4) r *= r * r * r * r;
        return t === 1 ? 1 - r : t === 2 ? r : p < 0.5 ? r / 2 : 1 - r / 2;
    };
    //create all the standard eases like Linear, Quad, Cubic, Quart, Quint, Strong, Power0, Power1, Power2, Power3, and Power4 (each with easeIn, easeOut, and easeInOut)
    a = [
        "Linear",
        "Quad",
        "Cubic",
        "Quart",
        "Quint,Strong"
    ];
    i = a.length;
    while(--i > -1){
        p = a[i] + ",Power" + i;
        _easeReg(new Ease(null, null, 1, i), p, "easeOut", true);
        _easeReg(new Ease(null, null, 2, i), p, "easeIn" + (i === 0 ? ",easeNone" : ""));
        _easeReg(new Ease(null, null, 3, i), p, "easeInOut");
    }
    _easeMap.linear = gs.easing.Linear.easeIn;
    _easeMap.swing = gs.easing.Quad.easeInOut; //for jQuery folks
    /*
 * ----------------------------------------------------------------
 * EventDispatcher
 * ----------------------------------------------------------------
 */ var EventDispatcher = _class("events.EventDispatcher", function(target) {
        this._listeners = {};
        this._eventTarget = target || this;
    });
    p = EventDispatcher.prototype;
    p.addEventListener = function(type, callback, scope, useParam, priority) {
        priority = priority || 0;
        var list = this._listeners[type], index = 0, listener, i;
        if (this === _ticker && !_tickerActive) _ticker.wake();
        if (list == null) this._listeners[type] = list = [];
        i = list.length;
        while(--i > -1){
            listener = list[i];
            if (listener.c === callback && listener.s === scope) list.splice(i, 1);
            else if (index === 0 && listener.pr < priority) index = i + 1;
        }
        list.splice(index, 0, {
            c: callback,
            s: scope,
            up: useParam,
            pr: priority
        });
    };
    p.removeEventListener = function(type, callback) {
        var list = this._listeners[type], i;
        if (list) {
            i = list.length;
            while(--i > -1)if (list[i].c === callback) {
                list.splice(i, 1);
                return;
            }
        }
    };
    p.dispatchEvent = function(type) {
        var list = this._listeners[type], i, t, listener;
        if (list) {
            i = list.length;
            if (i > 1) list = list.slice(0); //in case addEventListener() is called from within a listener/callback (otherwise the index could change, resulting in a skip)
            t = this._eventTarget;
            while(--i > -1){
                listener = list[i];
                if (listener) {
                    if (listener.up) listener.c.call(listener.s || t, {
                        type: type,
                        target: t
                    });
                    else listener.c.call(listener.s || t);
                }
            }
        }
    };
    /*
 * ----------------------------------------------------------------
 * Ticker
 * ----------------------------------------------------------------
 */ var _reqAnimFrame = window1.requestAnimationFrame, _cancelAnimFrame = window1.cancelAnimationFrame, _getTime = Date.now || function() {
        return new Date().getTime();
    }, _lastUpdate = _getTime();
    //now try to determine the requestAnimationFrame and cancelAnimationFrame functions and if none are found, we'll use a setTimeout()/clearTimeout() polyfill.
    a = [
        "ms",
        "moz",
        "webkit",
        "o"
    ];
    i = a.length;
    while(--i > -1 && !_reqAnimFrame){
        _reqAnimFrame = window1[a[i] + "RequestAnimationFrame"];
        _cancelAnimFrame = window1[a[i] + "CancelAnimationFrame"] || window1[a[i] + "CancelRequestAnimationFrame"];
    }
    _class("Ticker", function(fps, useRAF) {
        var _self = this, _startTime = _getTime(), _useRAF = useRAF !== false && _reqAnimFrame ? "auto" : false, _lagThreshold = 500, _adjustedLag = 33, _tickWord = "tick", _fps, _req, _id, _gap, _nextTime, _tick = function(manual) {
            var elapsed = _getTime() - _lastUpdate, overlap, dispatch;
            if (elapsed > _lagThreshold) _startTime += elapsed - _adjustedLag;
            _lastUpdate += elapsed;
            _self.time = (_lastUpdate - _startTime) / 1000;
            overlap = _self.time - _nextTime;
            if (!_fps || overlap > 0 || manual === true) {
                _self.frame++;
                _nextTime += overlap + (overlap >= _gap ? 0.004 : _gap - overlap);
                dispatch = true;
            }
            if (manual !== true) _id = _req(_tick);
            if (dispatch) _self.dispatchEvent(_tickWord);
        };
        EventDispatcher.call(_self);
        _self.time = _self.frame = 0;
        _self.tick = function() {
            _tick(true);
        };
        _self.lagSmoothing = function(threshold, adjustedLag) {
            if (!arguments.length) return _lagThreshold < 1 / _tinyNum;
            _lagThreshold = threshold || 1 / _tinyNum; //zero should be interpreted as basically unlimited
            _adjustedLag = Math.min(adjustedLag, _lagThreshold, 0);
        };
        _self.sleep = function() {
            if (_id == null) return;
            if (!_useRAF || !_cancelAnimFrame) clearTimeout(_id);
            else _cancelAnimFrame(_id);
            _req = _emptyFunc;
            _id = null;
            if (_self === _ticker) _tickerActive = false;
        };
        _self.wake = function(seamless) {
            if (_id !== null) _self.sleep();
            else if (seamless) _startTime += -_lastUpdate + (_lastUpdate = _getTime());
            else if (_self.frame > 10) _lastUpdate = _getTime() - _lagThreshold + 5;
            _req = _fps === 0 ? _emptyFunc : !_useRAF || !_reqAnimFrame ? function(f) {
                return setTimeout(f, (_nextTime - _self.time) * 1000 + 1 | 0);
            } : _reqAnimFrame;
            if (_self === _ticker) _tickerActive = true;
            _tick(2);
        };
        _self.fps = function(value) {
            if (!arguments.length) return _fps;
            _fps = value;
            _gap = 1 / (_fps || 60);
            _nextTime = this.time + _gap;
            _self.wake();
        };
        _self.useRAF = function(value) {
            if (!arguments.length) return _useRAF;
            _self.sleep();
            _useRAF = value;
            _self.fps(_fps);
        };
        _self.fps(fps);
        //a bug in iOS 6 Safari occasionally prevents the requestAnimationFrame from working initially, so we use a 1.5-second timeout that automatically falls back to setTimeout() if it senses this condition.
        setTimeout(function() {
            if (_useRAF === "auto" && _self.frame < 5 && (_doc || {}).visibilityState !== "hidden") _self.useRAF(false);
        }, 1500);
    });
    p = gs.Ticker.prototype = new gs.events.EventDispatcher();
    p.constructor = gs.Ticker;
    /*
 * ----------------------------------------------------------------
 * Animation
 * ----------------------------------------------------------------
 */ var Animation = _class("core.Animation", function(duration, vars) {
        this.vars = vars = vars || {};
        this._duration = this._totalDuration = duration || 0;
        this._delay = Number(vars.delay) || 0;
        this._timeScale = 1;
        this._active = !!vars.immediateRender;
        this.data = vars.data;
        this._reversed = !!vars.reversed;
        if (!_rootTimeline) return;
        if (!_tickerActive) _ticker.wake();
        var tl = this.vars.useFrames ? _rootFramesTimeline : _rootTimeline;
        tl.add(this, tl._time);
        if (this.vars.paused) this.paused(true);
    });
    _ticker = Animation.ticker = new gs.Ticker();
    p = Animation.prototype;
    p._dirty = p._gc = p._initted = p._paused = false;
    p._totalTime = p._time = 0;
    p._rawPrevTime = -1;
    p._next = p._last = p._onUpdate = p._timeline = p.timeline = null;
    p._paused = false;
    //some browsers (like iOS) occasionally drop the requestAnimationFrame event when the user switches to a different tab and then comes back again, so we use a 2-second setTimeout() to sense if/when that condition occurs and then wake() the ticker.
    var _checkTimeout = function() {
        if (_tickerActive && _getTime() - _lastUpdate > 2000 && ((_doc || {}).visibilityState !== "hidden" || !_ticker.lagSmoothing())) _ticker.wake();
        var t = setTimeout(_checkTimeout, 2000);
        if (t.unref) // allows a node process to exit even if the timeout’s callback hasn't been invoked. Without it, the node process could hang as this function is called every two seconds.
        t.unref();
    };
    _checkTimeout();
    p.play = function(from, suppressEvents) {
        if (from != null) this.seek(from, suppressEvents);
        return this.reversed(false).paused(false);
    };
    p.pause = function(atTime, suppressEvents) {
        if (atTime != null) this.seek(atTime, suppressEvents);
        return this.paused(true);
    };
    p.resume = function(from, suppressEvents) {
        if (from != null) this.seek(from, suppressEvents);
        return this.paused(false);
    };
    p.seek = function(time, suppressEvents) {
        return this.totalTime(Number(time), suppressEvents !== false);
    };
    p.restart = function(includeDelay, suppressEvents) {
        return this.reversed(false).paused(false).totalTime(includeDelay ? -this._delay : 0, suppressEvents !== false, true);
    };
    p.reverse = function(from, suppressEvents) {
        if (from != null) this.seek(from || this.totalDuration(), suppressEvents);
        return this.reversed(true).paused(false);
    };
    p.render = function(time, suppressEvents, force) {
    //stub - we override this method in subclasses.
    };
    p.invalidate = function() {
        this._time = this._totalTime = 0;
        this._initted = this._gc = false;
        this._rawPrevTime = -1;
        if (this._gc || !this.timeline) this._enabled(true);
        return this;
    };
    p.isActive = function() {
        var tl = this._timeline, startTime = this._startTime, rawTime;
        return !tl || !this._gc && !this._paused && tl.isActive() && (rawTime = tl.rawTime(true)) >= startTime && rawTime < startTime + this.totalDuration() / this._timeScale - _tinyNum;
    };
    p._enabled = function(enabled, ignoreTimeline) {
        if (!_tickerActive) _ticker.wake();
        this._gc = !enabled;
        this._active = this.isActive();
        if (ignoreTimeline !== true) {
            if (enabled && !this.timeline) this._timeline.add(this, this._startTime - this._delay);
            else if (!enabled && this.timeline) this._timeline._remove(this, true);
        }
        return false;
    };
    p._kill = function(vars, target) {
        return this._enabled(false, false);
    };
    p.kill = function(vars, target) {
        this._kill(vars, target);
        return this;
    };
    p._uncache = function(includeSelf) {
        var tween = includeSelf ? this : this.timeline;
        while(tween){
            tween._dirty = true;
            tween = tween.timeline;
        }
        return this;
    };
    p._swapSelfInParams = function(params) {
        var i = params.length, copy = params.concat();
        while(--i > -1)if (params[i] === "{self}") copy[i] = this;
        return copy;
    };
    p._callback = function(type) {
        var v = this.vars, callback = v[type], params = v[type + "Params"], scope = v[type + "Scope"] || v.callbackScope || this, l = params ? params.length : 0;
        switch(l){
            case 0:
                callback.call(scope);
                break;
            case 1:
                callback.call(scope, params[0]);
                break;
            case 2:
                callback.call(scope, params[0], params[1]);
                break;
            default:
                callback.apply(scope, params);
        }
    };
    //----Animation getters/setters --------------------------------------------------------
    p.eventCallback = function(type, callback, params, scope) {
        if ((type || "").substr(0, 2) === "on") {
            var v = this.vars;
            if (arguments.length === 1) return v[type];
            if (callback == null) delete v[type];
            else {
                v[type] = callback;
                v[type + "Params"] = _isArray(params) && params.join("").indexOf("{self}") !== -1 ? this._swapSelfInParams(params) : params;
                v[type + "Scope"] = scope;
            }
            if (type === "onUpdate") this._onUpdate = callback;
        }
        return this;
    };
    p.delay = function(value) {
        if (!arguments.length) return this._delay;
        if (this._timeline.smoothChildTiming) this.startTime(this._startTime + value - this._delay);
        this._delay = value;
        return this;
    };
    p.duration = function(value) {
        if (!arguments.length) {
            this._dirty = false;
            return this._duration;
        }
        this._duration = this._totalDuration = value;
        this._uncache(true); //true in case it's a TweenMax or TimelineMax that has a repeat - we'll need to refresh the totalDuration.
        if (this._timeline.smoothChildTiming) {
            if (this._time > 0) {
                if (this._time < this._duration) {
                    if (value !== 0) this.totalTime(this._totalTime * (value / this._duration), true);
                }
            }
        }
        return this;
    };
    p.totalDuration = function(value) {
        this._dirty = false;
        return !arguments.length ? this._totalDuration : this.duration(value);
    };
    p.time = function(value, suppressEvents) {
        if (!arguments.length) return this._time;
        if (this._dirty) this.totalDuration();
        return this.totalTime(value > this._duration ? this._duration : value, suppressEvents);
    };
    p.totalTime = function(time, suppressEvents, uncapped) {
        if (!_tickerActive) _ticker.wake();
        if (!arguments.length) return this._totalTime;
        if (this._timeline) {
            if (time < 0 && !uncapped) time += this.totalDuration();
            if (this._timeline.smoothChildTiming) {
                if (this._dirty) this.totalDuration();
                var totalDuration = this._totalDuration, tl = this._timeline;
                if (time > totalDuration && !uncapped) time = totalDuration;
                this._startTime = (this._paused ? this._pauseTime : tl._time) - (!this._reversed ? time : totalDuration - time) / this._timeScale;
                if (!tl._dirty) this._uncache(false);
                //in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The startTime of that child would get pushed out, but one of the ancestors may have completed.
                if (tl._timeline) while(tl._timeline){
                    if (tl._timeline._time !== (tl._startTime + tl._totalTime) / tl._timeScale) tl.totalTime(tl._totalTime, true);
                    tl = tl._timeline;
                }
            }
            if (this._gc) this._enabled(true, false);
            if (this._totalTime !== time || this._duration === 0) {
                if (_lazyTweens.length) _lazyRender();
                this.render(time, suppressEvents, false);
                if (_lazyTweens.length) _lazyRender();
            }
        }
        return this;
    };
    p.progress = p.totalProgress = function(value, suppressEvents) {
        var duration = this.duration();
        return !arguments.length ? duration ? this._time / duration : this.ratio : this.totalTime(duration * value, suppressEvents);
    };
    p.startTime = function(value) {
        if (!arguments.length) return this._startTime;
        if (value !== this._startTime) {
            this._startTime = value;
            if (this.timeline) {
                if (this.timeline._sortChildren) this.timeline.add(this, value - this._delay); //ensures that any necessary re-sequencing of Animations in the timeline occurs to make sure the rendering order is correct.
            }
        }
        return this;
    };
    p.endTime = function(includeRepeats) {
        return this._startTime + (includeRepeats != false ? this.totalDuration() : this.duration()) / this._timeScale;
    };
    p.timeScale = function(value) {
        if (!arguments.length) return this._timeScale;
        var pauseTime, t;
        value = value || _tinyNum; //can't allow zero because it'll throw the math off
        if (this._timeline && this._timeline.smoothChildTiming) {
            pauseTime = this._pauseTime;
            t = pauseTime || pauseTime === 0 ? pauseTime : this._timeline.totalTime();
            this._startTime = t - (t - this._startTime) * this._timeScale / value;
        }
        this._timeScale = value;
        t = this.timeline;
        while(t && t.timeline){
            t._dirty = true;
            t.totalDuration();
            t = t.timeline;
        }
        return this;
    };
    p.reversed = function(value) {
        if (!arguments.length) return this._reversed;
        if (value != this._reversed) {
            this._reversed = value;
            this.totalTime(this._timeline && !this._timeline.smoothChildTiming ? this.totalDuration() - this._totalTime : this._totalTime, true);
        }
        return this;
    };
    p.paused = function(value) {
        if (!arguments.length) return this._paused;
        var tl = this._timeline, raw, elapsed;
        if (value != this._paused) {
            if (tl) {
                if (!_tickerActive && !value) _ticker.wake();
                raw = tl.rawTime();
                elapsed = raw - this._pauseTime;
                if (!value && tl.smoothChildTiming) {
                    this._startTime += elapsed;
                    this._uncache(false);
                }
                this._pauseTime = value ? raw : null;
                this._paused = value;
                this._active = this.isActive();
                if (!value && elapsed !== 0 && this._initted && this.duration()) {
                    raw = tl.smoothChildTiming ? this._totalTime : (raw - this._startTime) / this._timeScale;
                    this.render(raw, raw === this._totalTime, true); //in case the target's properties changed via some other tween or manual update by the user, we should force a render.
                }
            }
        }
        if (this._gc && !value) this._enabled(true, false);
        return this;
    };
    /*
 * ----------------------------------------------------------------
 * SimpleTimeline
 * ----------------------------------------------------------------
 */ var SimpleTimeline = _class("core.SimpleTimeline", function(vars) {
        Animation.call(this, 0, vars);
        this.autoRemoveChildren = this.smoothChildTiming = true;
    });
    p = SimpleTimeline.prototype = new Animation();
    p.constructor = SimpleTimeline;
    p.kill()._gc = false;
    p._first = p._last = p._recent = null;
    p._sortChildren = false;
    p.add = p.insert = function(child, position, align, stagger) {
        var prevTween, st;
        child._startTime = Number(position || 0) + child._delay;
        if (child._paused) {
            if (this !== child._timeline) child._pauseTime = this.rawTime() - (child._timeline.rawTime() - child._pauseTime);
        }
        if (child.timeline) child.timeline._remove(child, true); //removes from existing timeline so that it can be properly added to this one.
        child.timeline = child._timeline = this;
        if (child._gc) child._enabled(true, true);
        prevTween = this._last;
        if (this._sortChildren) {
            st = child._startTime;
            while(prevTween && prevTween._startTime > st)prevTween = prevTween._prev;
        }
        if (prevTween) {
            child._next = prevTween._next;
            prevTween._next = child;
        } else {
            child._next = this._first;
            this._first = child;
        }
        if (child._next) child._next._prev = child;
        else this._last = child;
        child._prev = prevTween;
        this._recent = child;
        if (this._timeline) this._uncache(true);
        return this;
    };
    p._remove = function(tween, skipDisable) {
        if (tween.timeline === this) {
            if (!skipDisable) tween._enabled(false, true);
            if (tween._prev) tween._prev._next = tween._next;
            else if (this._first === tween) this._first = tween._next;
            if (tween._next) tween._next._prev = tween._prev;
            else if (this._last === tween) this._last = tween._prev;
            tween._next = tween._prev = tween.timeline = null;
            if (tween === this._recent) this._recent = this._last;
            if (this._timeline) this._uncache(true);
        }
        return this;
    };
    p.render = function(time, suppressEvents, force) {
        var tween = this._first, next;
        this._totalTime = this._time = this._rawPrevTime = time;
        while(tween){
            next = tween._next; //record it here because the value could change after rendering...
            if (tween._active || time >= tween._startTime && !tween._paused && !tween._gc) {
                if (!tween._reversed) tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
                else tween.render((!tween._dirty ? tween._totalDuration : tween.totalDuration()) - (time - tween._startTime) * tween._timeScale, suppressEvents, force);
            }
            tween = next;
        }
    };
    p.rawTime = function() {
        if (!_tickerActive) _ticker.wake();
        return this._totalTime;
    };
    /*
 * ----------------------------------------------------------------
 * TweenLite
 * ----------------------------------------------------------------
 */ var TweenLite = _class("TweenLite", function(target, duration, vars) {
        Animation.call(this, duration, vars);
        this.render = TweenLite.prototype.render; //speed optimization (avoid prototype lookup on this "hot" method)
        if (target == null) throw "Cannot tween a null target.";
        this.target = target = typeof target !== "string" ? target : TweenLite.selector(target) || target;
        var isSelector = target.jquery || target.length && target !== window1 && target[0] && (target[0] === window1 || target[0].nodeType && target[0].style && !target.nodeType), overwrite = this.vars.overwrite, i, targ, targets;
        this._overwrite = overwrite = overwrite == null ? _overwriteLookup[TweenLite.defaultOverwrite] : typeof overwrite === "number" ? overwrite >> 0 : _overwriteLookup[overwrite];
        if ((isSelector || target instanceof Array || target.push && _isArray(target)) && typeof target[0] !== "number") {
            this._targets = targets = _slice(target); //don't use Array.prototype.slice.call(target, 0) because that doesn't work in IE8 with a NodeList that's returned by querySelectorAll()
            this._propLookup = [];
            this._siblings = [];
            for(i = 0; i < targets.length; i++){
                targ = targets[i];
                if (!targ) {
                    targets.splice(i--, 1);
                    continue;
                } else if (typeof targ === "string") {
                    targ = targets[i--] = TweenLite.selector(targ); //in case it's an array of strings
                    if (typeof targ === "string") targets.splice(i + 1, 1); //to avoid an endless loop (can't imagine why the selector would return a string, but just in case)
                    continue;
                } else if (targ.length && targ !== window1 && targ[0] && (targ[0] === window1 || targ[0].nodeType && targ[0].style && !targ.nodeType)) {
                    targets.splice(i--, 1);
                    this._targets = targets = targets.concat(_slice(targ));
                    continue;
                }
                this._siblings[i] = _register(targ, this, false);
                if (overwrite === 1) {
                    if (this._siblings[i].length > 1) _applyOverwrite(targ, this, null, 1, this._siblings[i]);
                }
            }
        } else {
            this._propLookup = {};
            this._siblings = _register(target, this, false);
            if (overwrite === 1) {
                if (this._siblings.length > 1) _applyOverwrite(target, this, null, 1, this._siblings);
            }
        }
        if (this.vars.immediateRender || duration === 0 && this._delay === 0 && this.vars.immediateRender !== false) {
            this._time = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
            this.render(Math.min(0, -this._delay)); //in case delay is negative
        }
    }, true), _isSelector = function(v) {
        return v && v.length && v !== window1 && v[0] && (v[0] === window1 || v[0].nodeType && v[0].style && !v.nodeType); //we cannot check "nodeType" if the target is window from within an iframe, otherwise it will trigger a security error in some browsers like Firefox.
    }, _autoCSS = function(vars, target) {
        var css = {}, p;
        for(p in vars)if (!_reservedProps[p] && (!(p in target) || p === "transform" || p === "x" || p === "y" || p === "width" || p === "height" || p === "className" || p === "border") && (!_plugins[p] || _plugins[p] && _plugins[p]._autoCSS)) {
            css[p] = vars[p];
            delete vars[p];
        }
        vars.css = css;
    };
    p = TweenLite.prototype = new Animation();
    p.constructor = TweenLite;
    p.kill()._gc = false;
    //----TweenLite defaults, overwrite management, and root updates ----------------------------------------------------
    p.ratio = 0;
    p._firstPT = p._targets = p._overwrittenProps = p._startAt = null;
    p._notifyPluginsOfEnabled = p._lazy = false;
    TweenLite.version = "2.1.3";
    TweenLite.defaultEase = p._ease = new Ease(null, null, 1, 1);
    TweenLite.defaultOverwrite = "auto";
    TweenLite.ticker = _ticker;
    TweenLite.autoSleep = 120;
    TweenLite.lagSmoothing = function(threshold, adjustedLag) {
        _ticker.lagSmoothing(threshold, adjustedLag);
    };
    TweenLite.selector = window1.$ || window1.jQuery || function(e) {
        var selector = window1.$ || window1.jQuery;
        if (selector) {
            TweenLite.selector = selector;
            return selector(e);
        }
        if (!_doc) _doc = window1.document;
        return !_doc ? e : _doc.querySelectorAll ? _doc.querySelectorAll(e) : _doc.getElementById(e.charAt(0) === "#" ? e.substr(1) : e);
    };
    var _lazyTweens = [], _lazyLookup = {}, _numbersExp = /(?:(-|-=|\+=)?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/ig, _relExp = /[\+-]=-?[\.\d]/, //_nonNumbersExp = /(?:([\-+](?!(\d|=)))|[^\d\-+=e]|(e(?![\-+][\d])))+/ig,
    _setRatio = function(v) {
        var pt = this._firstPT, min = 0.000001, val;
        while(pt){
            val = !pt.blob ? pt.c * v + pt.s : v === 1 && this.end != null ? this.end : v ? this.join("") : this.start;
            if (pt.m) val = pt.m.call(this._tween, val, this._target || pt.t, this._tween);
            else if (val < min) {
                if (val > -min && !pt.blob) val = 0;
            }
            if (!pt.f) pt.t[pt.p] = val;
            else if (pt.fp) pt.t[pt.p](pt.fp, val);
            else pt.t[pt.p](val);
            pt = pt._next;
        }
    }, _blobRound = function(v) {
        return (v * 1000 | 0) / 1000 + "";
    }, //compares two strings (start/end), finds the numbers that are different and spits back an array representing the whole value but with the changing values isolated as elements. For example, "rgb(0,0,0)" and "rgb(100,50,0)" would become ["rgb(", 0, ",", 50, ",0)"]. Notice it merges the parts that are identical (performance optimization). The array also has a linked list of PropTweens attached starting with _firstPT that contain the tweening data (t, p, s, c, f, etc.). It also stores the starting value as a "start" property so that we can revert to it if/when necessary, like when a tween rewinds fully. If the quantity of numbers differs between the start and end, it will always prioritize the end value(s). The pt parameter is optional - it's for a PropTween that will be appended to the end of the linked list and is typically for actually setting the value after all of the elements have been updated (with array.join("")).
    _blobDif = function(start, end, filter, pt) {
        var a = [], charIndex = 0, s = "", color = 0, startNums, endNums, num, i, l, nonNumbers, currentNum;
        a.start = start;
        a.end = end;
        start = a[0] = start + ""; //ensure values are strings
        end = a[1] = end + "";
        if (filter) {
            filter(a); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.
            start = a[0];
            end = a[1];
        }
        a.length = 0;
        startNums = start.match(_numbersExp) || [];
        endNums = end.match(_numbersExp) || [];
        if (pt) {
            pt._next = null;
            pt.blob = 1;
            a._firstPT = a._applyPT = pt; //apply last in the linked list (which means inserting it first)
        }
        l = endNums.length;
        for(i = 0; i < l; i++){
            currentNum = endNums[i];
            nonNumbers = end.substr(charIndex, end.indexOf(currentNum, charIndex) - charIndex);
            s += nonNumbers || !i ? nonNumbers : ","; //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
            charIndex += nonNumbers.length;
            if (color) color = (color + 1) % 5;
            else if (nonNumbers.substr(-5) === "rgba(") color = 1;
            if (currentNum === startNums[i] || startNums.length <= i) s += currentNum;
            else {
                if (s) {
                    a.push(s);
                    s = "";
                }
                num = parseFloat(startNums[i]);
                a.push(num);
                a._firstPT = {
                    _next: a._firstPT,
                    t: a,
                    p: a.length - 1,
                    s: num,
                    c: (currentNum.charAt(1) === "=" ? parseInt(currentNum.charAt(0) + "1", 10) * parseFloat(currentNum.substr(2)) : parseFloat(currentNum) - num) || 0,
                    f: 0,
                    m: color && color < 4 ? Math.round : _blobRound
                }; //limiting to 3 decimal places and casting as a string can really help performance when array.join() is called!
            //note: we don't set _prev because we'll never need to remove individual PropTweens from this list.
            }
            charIndex += currentNum.length;
        }
        s += end.substr(charIndex);
        if (s) a.push(s);
        a.setRatio = _setRatio;
        if (_relExp.test(end)) a.end = null;
        return a;
    }, //note: "funcParam" is only necessary for function-based getters/setters that require an extra parameter like getAttribute("width") and setAttribute("width", value). In this example, funcParam would be "width". Used by AttrPlugin for example.
    _addPropTween = function(target, prop, start, end, overwriteProp, mod, funcParam, stringFilter, index) {
        if (typeof end === "function") end = end(index || 0, target);
        var type = typeof target[prop], getterName = type !== "function" ? "" : prop.indexOf("set") || typeof target["get" + prop.substr(3)] !== "function" ? prop : "get" + prop.substr(3), s = start !== "get" ? start : !getterName ? target[prop] : funcParam ? target[getterName](funcParam) : target[getterName](), isRelative = typeof end === "string" && end.charAt(1) === "=", pt = {
            t: target,
            p: prop,
            s: s,
            f: type === "function",
            pg: 0,
            n: overwriteProp || prop,
            m: !mod ? 0 : typeof mod === "function" ? mod : Math.round,
            pr: 0,
            c: isRelative ? parseInt(end.charAt(0) + "1", 10) * parseFloat(end.substr(2)) : parseFloat(end) - s || 0
        }, blob;
        if (typeof s !== "number" || typeof end !== "number" && !isRelative) {
            if (funcParam || isNaN(s) || !isRelative && isNaN(end) || typeof s === "boolean" || typeof end === "boolean") {
                //a blob (string that has multiple numbers in it)
                pt.fp = funcParam;
                blob = _blobDif(s, isRelative ? parseFloat(pt.s) + pt.c + (pt.s + "").replace(/[0-9\-\.]/g, "") : end, stringFilter || TweenLite.defaultStringFilter, pt);
                pt = {
                    t: blob,
                    p: "setRatio",
                    s: 0,
                    c: 1,
                    f: 2,
                    pg: 0,
                    n: overwriteProp || prop,
                    pr: 0,
                    m: 0
                }; //"2" indicates it's a Blob property tween. Needed for RoundPropsPlugin for example.
            } else {
                pt.s = parseFloat(s);
                if (!isRelative) pt.c = parseFloat(end) - pt.s || 0;
            }
        }
        if (pt.c) {
            if (pt._next = this._firstPT) pt._next._prev = pt;
            this._firstPT = pt;
            return pt;
        }
    }, _internals = TweenLite._internals = {
        isArray: _isArray,
        isSelector: _isSelector,
        lazyTweens: _lazyTweens,
        blobDif: _blobDif
    }, _plugins = TweenLite._plugins = {}, _tweenLookup = _internals.tweenLookup = {}, _tweenLookupNum = 0, _reservedProps = _internals.reservedProps = {
        ease: 1,
        delay: 1,
        overwrite: 1,
        onComplete: 1,
        onCompleteParams: 1,
        onCompleteScope: 1,
        useFrames: 1,
        runBackwards: 1,
        startAt: 1,
        onUpdate: 1,
        onUpdateParams: 1,
        onUpdateScope: 1,
        onStart: 1,
        onStartParams: 1,
        onStartScope: 1,
        onReverseComplete: 1,
        onReverseCompleteParams: 1,
        onReverseCompleteScope: 1,
        onRepeat: 1,
        onRepeatParams: 1,
        onRepeatScope: 1,
        easeParams: 1,
        yoyo: 1,
        immediateRender: 1,
        repeat: 1,
        repeatDelay: 1,
        data: 1,
        paused: 1,
        reversed: 1,
        autoCSS: 1,
        lazy: 1,
        onOverwrite: 1,
        callbackScope: 1,
        stringFilter: 1,
        id: 1,
        yoyoEase: 1,
        stagger: 1
    }, _overwriteLookup = {
        none: 0,
        all: 1,
        auto: 2,
        concurrent: 3,
        allOnStart: 4,
        preexisting: 5,
        "true": 1,
        "false": 0
    }, _rootFramesTimeline = Animation._rootFramesTimeline = new SimpleTimeline(), _rootTimeline = Animation._rootTimeline = new SimpleTimeline(), _nextGCFrame = 30, _lazyRender = _internals.lazyRender = function() {
        var l = _lazyTweens.length, i, tween;
        _lazyLookup = {};
        for(i = 0; i < l; i++){
            tween = _lazyTweens[i];
            if (tween && tween._lazy !== false) {
                tween.render(tween._lazy[0], tween._lazy[1], true);
                tween._lazy = false;
            }
        }
        _lazyTweens.length = 0;
    };
    _rootTimeline._startTime = _ticker.time;
    _rootFramesTimeline._startTime = _ticker.frame;
    _rootTimeline._active = _rootFramesTimeline._active = true;
    setTimeout(_lazyRender, 1); //on some mobile devices, there isn't a "tick" before code runs which means any lazy renders wouldn't run before the next official "tick".
    Animation._updateRoot = TweenLite.render = function() {
        var i, a, p;
        if (_lazyTweens.length) _lazyRender();
        _rootTimeline.render((_ticker.time - _rootTimeline._startTime) * _rootTimeline._timeScale, false, false);
        _rootFramesTimeline.render((_ticker.frame - _rootFramesTimeline._startTime) * _rootFramesTimeline._timeScale, false, false);
        if (_lazyTweens.length) _lazyRender();
        if (_ticker.frame >= _nextGCFrame) {
            _nextGCFrame = _ticker.frame + (parseInt(TweenLite.autoSleep, 10) || 120);
            for(p in _tweenLookup){
                a = _tweenLookup[p].tweens;
                i = a.length;
                while(--i > -1)if (a[i]._gc) a.splice(i, 1);
                if (a.length === 0) delete _tweenLookup[p];
            }
            //if there are no more tweens in the root timelines, or if they're all paused, make the _timer sleep to reduce load on the CPU slightly
            p = _rootTimeline._first;
            if (!p || p._paused) {
                if (TweenLite.autoSleep && !_rootFramesTimeline._first && _ticker._listeners.tick.length === 1) {
                    while(p && p._paused)p = p._next;
                    if (!p) _ticker.sleep();
                }
            }
        }
    };
    _ticker.addEventListener("tick", Animation._updateRoot);
    var _register = function(target, tween, scrub) {
        var id = target._gsTweenID, a, i;
        if (!_tweenLookup[id || (target._gsTweenID = id = "t" + _tweenLookupNum++)]) _tweenLookup[id] = {
            target: target,
            tweens: []
        };
        if (tween) {
            a = _tweenLookup[id].tweens;
            a[i = a.length] = tween;
            if (scrub) {
                while(--i > -1)if (a[i] === tween) a.splice(i, 1);
            }
        }
        return _tweenLookup[id].tweens;
    }, _onOverwrite = function(overwrittenTween, overwritingTween, target, killedProps) {
        var func = overwrittenTween.vars.onOverwrite, r1, r2;
        if (func) r1 = func(overwrittenTween, overwritingTween, target, killedProps);
        func = TweenLite.onOverwrite;
        if (func) r2 = func(overwrittenTween, overwritingTween, target, killedProps);
        return r1 !== false && r2 !== false;
    }, _applyOverwrite = function(target, tween, props, mode, siblings) {
        var i, changed, curTween, l;
        if (mode === 1 || mode >= 4) {
            l = siblings.length;
            for(i = 0; i < l; i++){
                if ((curTween = siblings[i]) !== tween) {
                    if (!curTween._gc) {
                        if (curTween._kill(null, target, tween)) changed = true;
                    }
                } else if (mode === 5) break;
            }
            return changed;
        }
        //NOTE: Add tiny amount to overcome floating point errors that can cause the startTime to be VERY slightly off (when a tween's time() is set for example)
        var startTime = tween._startTime + _tinyNum, overlaps = [], oCount = 0, zeroDur = tween._duration === 0, globalStart;
        i = siblings.length;
        while(--i > -1){
            if ((curTween = siblings[i]) === tween || curTween._gc || curTween._paused) ;
            else if (curTween._timeline !== tween._timeline) {
                globalStart = globalStart || _checkOverlap(tween, 0, zeroDur);
                if (_checkOverlap(curTween, globalStart, zeroDur) === 0) overlaps[oCount++] = curTween;
            } else if (curTween._startTime <= startTime) {
                if (curTween._startTime + curTween.totalDuration() / curTween._timeScale > startTime) {
                    if (!((zeroDur || !curTween._initted) && startTime - curTween._startTime <= _tinyNum * 2)) overlaps[oCount++] = curTween;
                }
            }
        }
        i = oCount;
        while(--i > -1){
            curTween = overlaps[i];
            l = curTween._firstPT; //we need to discern if there were property tweens originally; if they all get removed in the next line's _kill() call, the tween should be killed. See https://github.com/greensock/GreenSock-JS/issues/278
            if (mode === 2) {
                if (curTween._kill(props, target, tween)) changed = true;
            }
            if (mode !== 2 || !curTween._firstPT && curTween._initted && l) {
                if (mode !== 2 && !_onOverwrite(curTween, tween)) continue;
                if (curTween._enabled(false, false)) changed = true;
            }
        }
        return changed;
    }, _checkOverlap = function(tween, reference, zeroDur) {
        var tl = tween._timeline, ts = tl._timeScale, t = tween._startTime;
        while(tl._timeline){
            t += tl._startTime;
            ts *= tl._timeScale;
            if (tl._paused) return -100;
            tl = tl._timeline;
        }
        t /= ts;
        return t > reference ? t - reference : zeroDur && t === reference || !tween._initted && t - reference < 2 * _tinyNum ? _tinyNum : (t += tween.totalDuration() / tween._timeScale / ts) > reference + _tinyNum ? 0 : t - reference - _tinyNum;
    };
    //---- TweenLite instance methods -----------------------------------------------------------------------------
    p._init = function() {
        var v = this.vars, op = this._overwrittenProps, dur = this._duration, immediate = !!v.immediateRender, ease = v.ease, startAt = this._startAt, i, initPlugins, pt, p, startVars, l;
        if (v.startAt) {
            if (startAt) {
                startAt.render(-1, true); //if we've run a startAt previously (when the tween instantiated), we should revert it so that the values re-instantiate correctly particularly for relative tweens. Without this, a TweenLite.fromTo(obj, 1, {x:"+=100"}, {x:"-=100"}), for example, would actually jump to +=200 because the startAt would run twice, doubling the relative change.
                startAt.kill();
            }
            startVars = {};
            for(p in v.startAt)startVars[p] = v.startAt[p];
            startVars.data = "isStart";
            startVars.overwrite = false;
            startVars.immediateRender = true;
            startVars.lazy = immediate && v.lazy !== false;
            startVars.startAt = startVars.delay = null; //no nesting of startAt objects allowed (otherwise it could cause an infinite loop).
            startVars.onUpdate = v.onUpdate;
            startVars.onUpdateParams = v.onUpdateParams;
            startVars.onUpdateScope = v.onUpdateScope || v.callbackScope || this;
            this._startAt = TweenLite.to(this.target || {}, 0, startVars);
            if (immediate) {
                if (this._time > 0) this._startAt = null; //tweens that render immediately (like most from() and fromTo() tweens) shouldn't revert when their parent timeline's playhead goes backward past the startTime because the initial render could have happened anytime and it shouldn't be directly correlated to this tween's startTime. Imagine setting up a complex animation where the beginning states of various objects are rendered immediately but the tween doesn't happen for quite some time - if we revert to the starting values as soon as the playhead goes backward past the tween's startTime, it will throw things off visually. Reversion should only happen in TimelineLite/Max instances where immediateRender was false (which is the default in the convenience methods like from()).
                else if (dur !== 0) return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a TimelineLite or TimelineMax, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
            }
        } else if (v.runBackwards && dur !== 0) {
            //from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
            if (startAt) {
                startAt.render(-1, true);
                startAt.kill();
                this._startAt = null;
            } else {
                if (this._time !== 0) immediate = false;
                pt = {};
                for(p in v)if (!_reservedProps[p] || p === "autoCSS") pt[p] = v[p];
                pt.overwrite = 0;
                pt.data = "isFromStart"; //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
                pt.lazy = immediate && v.lazy !== false;
                pt.immediateRender = immediate; //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
                this._startAt = TweenLite.to(this.target, 0, pt);
                if (!immediate) {
                    this._startAt._init(); //ensures that the initial values are recorded
                    this._startAt._enabled(false); //no need to have the tween render on the next cycle. Disable it because we'll always manually control the renders of the _startAt tween.
                    if (this.vars.immediateRender) this._startAt = null;
                } else if (this._time === 0) return;
            }
        }
        this._ease = ease = !ease ? TweenLite.defaultEase : ease instanceof Ease ? ease : typeof ease === "function" ? new Ease(ease, v.easeParams) : _easeMap[ease] || TweenLite.defaultEase;
        if (v.easeParams instanceof Array && ease.config) this._ease = ease.config.apply(ease, v.easeParams);
        this._easeType = this._ease._type;
        this._easePower = this._ease._power;
        this._firstPT = null;
        if (this._targets) {
            l = this._targets.length;
            for(i = 0; i < l; i++)if (this._initProps(this._targets[i], this._propLookup[i] = {}, this._siblings[i], op ? op[i] : null, i)) initPlugins = true;
        } else initPlugins = this._initProps(this.target, this._propLookup, this._siblings, op, 0);
        if (initPlugins) TweenLite._onPluginEvent("_onInitAllProps", this); //reorders the array in order of priority. Uses a static TweenPlugin method in order to minimize file size in TweenLite
        if (op) {
            if (!this._firstPT) {
                if (typeof this.target !== "function") this._enabled(false, false);
            }
        }
        if (v.runBackwards) {
            pt = this._firstPT;
            while(pt){
                pt.s += pt.c;
                pt.c = -pt.c;
                pt = pt._next;
            }
        }
        this._onUpdate = v.onUpdate;
        this._initted = true;
    };
    p._initProps = function(target, propLookup, siblings, overwrittenProps, index) {
        var p, i, initPlugins, plugin, pt, v;
        if (target == null) return false;
        if (_lazyLookup[target._gsTweenID]) _lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)
        if (!this.vars.css) {
            if (target.style) {
                if (target !== window1 && target.nodeType) {
                    if (_plugins.css) {
                        if (this.vars.autoCSS !== false) _autoCSS(this.vars, target);
                    }
                }
            }
        }
        for(p in this.vars){
            v = this.vars[p];
            if (_reservedProps[p]) {
                if (v) {
                    if (v instanceof Array || v.push && _isArray(v)) {
                        if (v.join("").indexOf("{self}") !== -1) this.vars[p] = v = this._swapSelfInParams(v, this);
                    }
                }
            } else if (_plugins[p] && (plugin = new _plugins[p]())._onInitTween(target, this.vars[p], this, index)) {
                //t - target 		[object]
                //p - property 		[string]
                //s - start			[number]
                //c - change		[number]
                //f - isFunction	[boolean]
                //n - name			[string]
                //pg - isPlugin 	[boolean]
                //pr - priority		[number]
                //m - mod           [function | 0]
                this._firstPT = pt = {
                    _next: this._firstPT,
                    t: plugin,
                    p: "setRatio",
                    s: 0,
                    c: 1,
                    f: 1,
                    n: p,
                    pg: 1,
                    pr: plugin._priority,
                    m: 0
                };
                i = plugin._overwriteProps.length;
                while(--i > -1)propLookup[plugin._overwriteProps[i]] = this._firstPT;
                if (plugin._priority || plugin._onInitAllProps) initPlugins = true;
                if (plugin._onDisable || plugin._onEnable) this._notifyPluginsOfEnabled = true;
                if (pt._next) pt._next._prev = pt;
            } else propLookup[p] = _addPropTween.call(this, target, p, "get", v, p, 0, null, this.vars.stringFilter, index);
        }
        if (overwrittenProps) {
            if (this._kill(overwrittenProps, target)) return this._initProps(target, propLookup, siblings, overwrittenProps, index);
        }
        if (this._overwrite > 1) {
            if (this._firstPT) {
                if (siblings.length > 1) {
                    if (_applyOverwrite(target, this, propLookup, this._overwrite, siblings)) {
                        this._kill(propLookup, target);
                        return this._initProps(target, propLookup, siblings, overwrittenProps, index);
                    }
                }
            }
        }
        if (this._firstPT) {
            if (this.vars.lazy !== false && this._duration || this.vars.lazy && !this._duration) _lazyLookup[target._gsTweenID] = true;
        }
        return initPlugins;
    };
    p.render = function(time, suppressEvents, force) {
        var self = this, prevTime = self._time, duration = self._duration, prevRawPrevTime = self._rawPrevTime, isComplete, callback, pt, rawPrevTime;
        if (time >= duration - _tinyNum && time >= 0) {
            self._totalTime = self._time = duration;
            self.ratio = self._ease._calcEnd ? self._ease.getRatio(1) : 1;
            if (!self._reversed) {
                isComplete = true;
                callback = "onComplete";
                force = force || self._timeline.autoRemoveChildren; //otherwise, if the animation is unpaused/activated after it's already finished, it doesn't get removed from the parent timeline.
            }
            if (duration === 0) {
                if (self._initted || !self.vars.lazy || force) {
                    if (self._startTime === self._timeline._duration) time = 0;
                    if (prevRawPrevTime < 0 || time <= 0 && time >= -_tinyNum || prevRawPrevTime === _tinyNum && self.data !== "isPause") {
                        if (prevRawPrevTime !== time) {
                            force = true;
                            if (prevRawPrevTime > _tinyNum) callback = "onReverseComplete";
                        }
                    }
                    self._rawPrevTime = rawPrevTime = !suppressEvents || time || prevRawPrevTime === time ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
                }
            }
        } else if (time < _tinyNum) {
            self._totalTime = self._time = 0;
            self.ratio = self._ease._calcEnd ? self._ease.getRatio(0) : 0;
            if (prevTime !== 0 || duration === 0 && prevRawPrevTime > 0) {
                callback = "onReverseComplete";
                isComplete = self._reversed;
            }
            if (time > -_tinyNum) time = 0;
            else if (time < 0) {
                self._active = false;
                if (duration === 0) {
                    if (self._initted || !self.vars.lazy || force) {
                        if (prevRawPrevTime >= 0 && !(prevRawPrevTime === _tinyNum && self.data === "isPause")) force = true;
                        self._rawPrevTime = rawPrevTime = !suppressEvents || time || prevRawPrevTime === time ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
                    }
                }
            }
            if (!self._initted || self._startAt && self._startAt.progress()) force = true;
        } else {
            self._totalTime = self._time = time;
            if (self._easeType) {
                var r = time / duration, type = self._easeType, pow = self._easePower;
                if (type === 1 || type === 3 && r >= 0.5) r = 1 - r;
                if (type === 3) r *= 2;
                if (pow === 1) r *= r;
                else if (pow === 2) r *= r * r;
                else if (pow === 3) r *= r * r * r;
                else if (pow === 4) r *= r * r * r * r;
                self.ratio = type === 1 ? 1 - r : type === 2 ? r : time / duration < 0.5 ? r / 2 : 1 - r / 2;
            } else self.ratio = self._ease.getRatio(time / duration);
        }
        if (self._time === prevTime && !force) return;
        else if (!self._initted) {
            self._init();
            if (!self._initted || self._gc) return;
            else if (!force && self._firstPT && (self.vars.lazy !== false && self._duration || self.vars.lazy && !self._duration)) {
                self._time = self._totalTime = prevTime;
                self._rawPrevTime = prevRawPrevTime;
                _lazyTweens.push(self);
                self._lazy = [
                    time,
                    suppressEvents
                ];
                return;
            }
            //_ease is initially set to defaultEase, so now that init() has run, _ease is set properly and we need to recalculate the ratio. Overall this is faster than using conditional logic earlier in the method to avoid having to set ratio twice because we only init() once but renderTime() gets called VERY frequently.
            if (self._time && !isComplete) self.ratio = self._ease.getRatio(self._time / duration);
            else if (isComplete && self._ease._calcEnd) self.ratio = self._ease.getRatio(self._time === 0 ? 0 : 1);
        }
        if (self._lazy !== false) self._lazy = false;
        if (!self._active) {
            if (!self._paused && self._time !== prevTime && time >= 0) self._active = true; //so that if the user renders a tween (as opposed to the timeline rendering it), the timeline is forced to re-render and align it with the proper time/frame on the next rendering cycle. Maybe the tween already finished but the user manually re-renders it as halfway done.
        }
        if (prevTime === 0) {
            if (self._startAt) {
                if (time >= 0) self._startAt.render(time, true, force);
                else if (!callback) callback = "_dummyGS"; //if no callback is defined, use a dummy value just so that the condition at the end evaluates as true because _startAt should render AFTER the normal render loop when the time is negative. We could handle this in a more intuitive way, of course, but the render loop is the MOST important thing to optimize, so this technique allows us to avoid adding extra conditional logic in a high-frequency area.
            }
            if (self.vars.onStart) {
                if (self._time !== 0 || duration === 0) {
                    if (!suppressEvents) self._callback("onStart");
                }
            }
        }
        pt = self._firstPT;
        while(pt){
            if (pt.f) pt.t[pt.p](pt.c * self.ratio + pt.s);
            else pt.t[pt.p] = pt.c * self.ratio + pt.s;
            pt = pt._next;
        }
        if (self._onUpdate) {
            if (time < 0) {
                if (self._startAt && time !== -0.0001) self._startAt.render(time, true, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
            }
            if (!suppressEvents) {
                if (self._time !== prevTime || isComplete || force) self._callback("onUpdate");
            }
        }
        if (callback) {
            if (!self._gc || force) {
                if (time < 0 && self._startAt && !self._onUpdate && time !== -0.0001) self._startAt.render(time, true, force);
                if (isComplete) {
                    if (self._timeline.autoRemoveChildren) self._enabled(false, false);
                    self._active = false;
                }
                if (!suppressEvents && self.vars[callback]) self._callback(callback);
                if (duration === 0 && self._rawPrevTime === _tinyNum && rawPrevTime !== _tinyNum) self._rawPrevTime = 0;
            }
        }
    };
    p._kill = function(vars, target, overwritingTween) {
        if (vars === "all") vars = null;
        if (vars == null) {
            if (target == null || target === this.target) {
                this._lazy = false;
                return this._enabled(false, false);
            }
        }
        target = typeof target !== "string" ? target || this._targets || this.target : TweenLite.selector(target) || target;
        var simultaneousOverwrite = overwritingTween && this._time && overwritingTween._startTime === this._startTime && this._timeline === overwritingTween._timeline, firstPT = this._firstPT, i, overwrittenProps, p, pt, propLookup, changed, killProps, record, killed;
        if ((_isArray(target) || _isSelector(target)) && typeof target[0] !== "number") {
            i = target.length;
            while(--i > -1)if (this._kill(vars, target[i], overwritingTween)) changed = true;
        } else {
            if (this._targets) {
                i = this._targets.length;
                while(--i > -1)if (target === this._targets[i]) {
                    propLookup = this._propLookup[i] || {};
                    this._overwrittenProps = this._overwrittenProps || [];
                    overwrittenProps = this._overwrittenProps[i] = vars ? this._overwrittenProps[i] || {} : "all";
                    break;
                }
            } else if (target !== this.target) return false;
            else {
                propLookup = this._propLookup;
                overwrittenProps = this._overwrittenProps = vars ? this._overwrittenProps || {} : "all";
            }
            if (propLookup) {
                killProps = vars || propLookup;
                record = vars !== overwrittenProps && overwrittenProps !== "all" && vars !== propLookup && (typeof vars !== "object" || !vars._tempKill); //_tempKill is a super-secret way to delete a particular tweening property but NOT have it remembered as an official overwritten property (like in BezierPlugin)
                if (overwritingTween && (TweenLite.onOverwrite || this.vars.onOverwrite)) {
                    for(p in killProps)if (propLookup[p]) {
                        if (!killed) killed = [];
                        killed.push(p);
                    }
                    if ((killed || !vars) && !_onOverwrite(this, overwritingTween, target, killed)) return false;
                }
                for(p in killProps){
                    if (pt = propLookup[p]) {
                        if (simultaneousOverwrite) {
                            if (pt.f) pt.t[pt.p](pt.s);
                            else pt.t[pt.p] = pt.s;
                            changed = true;
                        }
                        if (pt.pg && pt.t._kill(killProps)) changed = true; //some plugins need to be notified so they can perform cleanup tasks first
                        if (!pt.pg || pt.t._overwriteProps.length === 0) {
                            if (pt._prev) pt._prev._next = pt._next;
                            else if (pt === this._firstPT) this._firstPT = pt._next;
                            if (pt._next) pt._next._prev = pt._prev;
                            pt._next = pt._prev = null;
                        }
                        delete propLookup[p];
                    }
                    if (record) overwrittenProps[p] = 1;
                }
                if (!this._firstPT && this._initted && firstPT) this._enabled(false, false);
            }
        }
        return changed;
    };
    p.invalidate = function() {
        if (this._notifyPluginsOfEnabled) TweenLite._onPluginEvent("_onDisable", this);
        var t = this._time;
        this._firstPT = this._overwrittenProps = this._startAt = this._onUpdate = null;
        this._notifyPluginsOfEnabled = this._active = this._lazy = false;
        this._propLookup = this._targets ? {} : [];
        Animation.prototype.invalidate.call(this);
        if (this.vars.immediateRender) {
            this._time = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
            this.render(t, false, this.vars.lazy !== false);
        }
        return this;
    };
    p._enabled = function(enabled, ignoreTimeline) {
        if (!_tickerActive) _ticker.wake();
        if (enabled && this._gc) {
            var targets = this._targets, i;
            if (targets) {
                i = targets.length;
                while(--i > -1)this._siblings[i] = _register(targets[i], this, true);
            } else this._siblings = _register(this.target, this, true);
        }
        Animation.prototype._enabled.call(this, enabled, ignoreTimeline);
        if (this._notifyPluginsOfEnabled) {
            if (this._firstPT) return TweenLite._onPluginEvent(enabled ? "_onEnable" : "_onDisable", this);
        }
        return false;
    };
    //----TweenLite static methods -----------------------------------------------------
    TweenLite.to = function(target, duration, vars) {
        return new TweenLite(target, duration, vars);
    };
    TweenLite.from = function(target, duration, vars) {
        vars.runBackwards = true;
        vars.immediateRender = vars.immediateRender != false;
        return new TweenLite(target, duration, vars);
    };
    TweenLite.fromTo = function(target, duration, fromVars, toVars) {
        toVars.startAt = fromVars;
        toVars.immediateRender = toVars.immediateRender != false && fromVars.immediateRender != false;
        return new TweenLite(target, duration, toVars);
    };
    TweenLite.delayedCall = function(delay, callback, params, scope, useFrames) {
        return new TweenLite(callback, 0, {
            delay: delay,
            onComplete: callback,
            onCompleteParams: params,
            callbackScope: scope,
            onReverseComplete: callback,
            onReverseCompleteParams: params,
            immediateRender: false,
            lazy: false,
            useFrames: useFrames,
            overwrite: 0
        });
    };
    TweenLite.set = function(target, vars) {
        return new TweenLite(target, 0, vars);
    };
    TweenLite.getTweensOf = function(target, onlyActive) {
        if (target == null) return [];
        target = typeof target !== "string" ? target : TweenLite.selector(target) || target;
        var i, a, j, t;
        if ((_isArray(target) || _isSelector(target)) && typeof target[0] !== "number") {
            i = target.length;
            a = [];
            while(--i > -1)a = a.concat(TweenLite.getTweensOf(target[i], onlyActive));
            i = a.length;
            //now get rid of any duplicates (tweens of arrays of objects could cause duplicates)
            while(--i > -1){
                t = a[i];
                j = i;
                while(--j > -1)if (t === a[j]) a.splice(i, 1);
            }
        } else if (target._gsTweenID) {
            a = _register(target).concat();
            i = a.length;
            while(--i > -1)if (a[i]._gc || onlyActive && !a[i].isActive()) a.splice(i, 1);
        }
        return a || [];
    };
    TweenLite.killTweensOf = TweenLite.killDelayedCallsTo = function(target, onlyActive, vars) {
        if (typeof onlyActive === "object") {
            vars = onlyActive; //for backwards compatibility (before "onlyActive" parameter was inserted)
            onlyActive = false;
        }
        var a = TweenLite.getTweensOf(target, onlyActive), i = a.length;
        while(--i > -1)a[i]._kill(vars, target);
    };
    /*
 * ----------------------------------------------------------------
 * TweenPlugin   (could easily be split out as a separate file/class, but included for ease of use (so that people don't need to include another script call before loading plugins which is easy to forget)
 * ----------------------------------------------------------------
 */ var TweenPlugin = _class("plugins.TweenPlugin", function(props, priority) {
        this._overwriteProps = (props || "").split(",");
        this._propName = this._overwriteProps[0];
        this._priority = priority || 0;
        this._super = TweenPlugin.prototype;
    }, true);
    p = TweenPlugin.prototype;
    TweenPlugin.version = "1.19.0";
    TweenPlugin.API = 2;
    p._firstPT = null;
    p._addTween = _addPropTween;
    p.setRatio = _setRatio;
    p._kill = function(lookup) {
        var a = this._overwriteProps, pt = this._firstPT, i;
        if (lookup[this._propName] != null) this._overwriteProps = [];
        else {
            i = a.length;
            while(--i > -1)if (lookup[a[i]] != null) a.splice(i, 1);
        }
        while(pt){
            if (lookup[pt.n] != null) {
                if (pt._next) pt._next._prev = pt._prev;
                if (pt._prev) {
                    pt._prev._next = pt._next;
                    pt._prev = null;
                } else if (this._firstPT === pt) this._firstPT = pt._next;
            }
            pt = pt._next;
        }
        return false;
    };
    p._mod = p._roundProps = function(lookup) {
        var pt = this._firstPT, val;
        while(pt){
            val = lookup[this._propName] || pt.n != null && lookup[pt.n.split(this._propName + "_").join("")];
            if (val && typeof val === "function") {
                if (pt.f === 2) pt.t._applyPT.m = val;
                else pt.m = val;
            }
            pt = pt._next;
        }
    };
    TweenLite._onPluginEvent = function(type, tween) {
        var pt = tween._firstPT, changed, pt2, first, last, next;
        if (type === "_onInitAllProps") {
            //sorts the PropTween linked list in order of priority because some plugins need to render earlier/later than others, like MotionBlurPlugin applies its effects after all x/y/alpha tweens have rendered on each frame.
            while(pt){
                next = pt._next;
                pt2 = first;
                while(pt2 && pt2.pr > pt.pr)pt2 = pt2._next;
                if (pt._prev = pt2 ? pt2._prev : last) pt._prev._next = pt;
                else first = pt;
                if (pt._next = pt2) pt2._prev = pt;
                else last = pt;
                pt = next;
            }
            pt = tween._firstPT = first;
        }
        while(pt){
            if (pt.pg) {
                if (typeof pt.t[type] === "function") {
                    if (pt.t[type]()) changed = true;
                }
            }
            pt = pt._next;
        }
        return changed;
    };
    TweenPlugin.activate = function(plugins) {
        var i = plugins.length;
        while(--i > -1)if (plugins[i].API === TweenPlugin.API) _plugins[new plugins[i]()._propName] = plugins[i];
        return true;
    };
    //provides a more concise way to define plugins that have no dependencies besides TweenPlugin and TweenLite, wrapping common boilerplate stuff into one function (added in 1.9.0). You don't NEED to use this to define a plugin - the old way still works and can be useful in certain (rare) situations.
    _gsDefine.plugin = function(config) {
        if (!config || !config.propName || !config.init || !config.API) throw "illegal plugin definition.";
        var propName = config.propName, priority = config.priority || 0, overwriteProps = config.overwriteProps, map = {
            init: "_onInitTween",
            set: "setRatio",
            kill: "_kill",
            round: "_mod",
            mod: "_mod",
            initAll: "_onInitAllProps"
        }, Plugin = _class("plugins." + propName.charAt(0).toUpperCase() + propName.substr(1) + "Plugin", function() {
            TweenPlugin.call(this, propName, priority);
            this._overwriteProps = overwriteProps || [];
        }, config.global === true), p = Plugin.prototype = new TweenPlugin(propName), prop;
        p.constructor = Plugin;
        Plugin.API = config.API;
        for(prop in map)if (typeof config[prop] === "function") p[map[prop]] = config[prop];
        Plugin.version = config.version;
        TweenPlugin.activate([
            Plugin
        ]);
        return Plugin;
    };
    //now run through all the dependencies discovered and if any are missing, log that to the console as a warning. This is why it's best to have TweenLite load last - it can check all the dependencies for you.
    a = window1._gsQueue;
    if (a) {
        for(i = 0; i < a.length; i++)a[i]();
        for(p in _defLookup)if (!_defLookup[p].func) window1.console.log("GSAP encountered missing dependency: " + p);
    }
    _tickerActive = false; //ensures that the first official animation forces a ticker.tick() to update the time when it is instantiated
    return TweenLite;
}($d163dbfd7d10e9ea$export$1824eb36b59182, "TweenLite");
var $d163dbfd7d10e9ea$export$816be348776d53c1 = $d163dbfd7d10e9ea$export$1824eb36b59182.GreenSockGlobals;
var $d163dbfd7d10e9ea$var$nonGlobals = $d163dbfd7d10e9ea$export$816be348776d53c1.com.greensock;
var $d163dbfd7d10e9ea$export$8c24d35d7aa285be = $d163dbfd7d10e9ea$var$nonGlobals.core.SimpleTimeline;
var $d163dbfd7d10e9ea$export$c35d437ae5945fcd = $d163dbfd7d10e9ea$var$nonGlobals.core.Animation;
var $d163dbfd7d10e9ea$export$e60daad661aebae6 = $d163dbfd7d10e9ea$export$816be348776d53c1.Ease;
var $d163dbfd7d10e9ea$export$cff00ccf6e2392de = $d163dbfd7d10e9ea$export$816be348776d53c1.Linear;
var $d163dbfd7d10e9ea$export$2fae1e8613537d5f = $d163dbfd7d10e9ea$export$cff00ccf6e2392de;
var $d163dbfd7d10e9ea$export$5d84ab4efbecec39 = $d163dbfd7d10e9ea$export$816be348776d53c1.Power1;
var $d163dbfd7d10e9ea$export$d8c694b7490ad65d = $d163dbfd7d10e9ea$export$816be348776d53c1.Power2;
var $d163dbfd7d10e9ea$export$acebdf2b184a0b6f = $d163dbfd7d10e9ea$export$816be348776d53c1.Power3;
var $d163dbfd7d10e9ea$export$42e40a141003d2f0 = $d163dbfd7d10e9ea$export$816be348776d53c1.Power4;
var $d163dbfd7d10e9ea$export$dff375347c6b75b7 = $d163dbfd7d10e9ea$export$816be348776d53c1.TweenPlugin;
var $d163dbfd7d10e9ea$export$ec8b666c5fe2c75a = $d163dbfd7d10e9ea$var$nonGlobals.events.EventDispatcher;

});

parcelRequire.register("6ifWP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4950cb68bb9e31b3$export$fcaf79afd042bc65; });
/*!
 * VERSION: 2.1.3
 * DATE: 2019-05-17
 * UPDATES AND DOCS AT: http://greensock.com
 *
 * @license Copyright (c) 2008-2019, GreenSock. All rights reserved.
 * This work is subject to the terms at http://greensock.com/standard-license or for
 * Club GreenSock members, the software agreement that was issued with your membership.
 * 
 * @author: Jack Doyle, jack@greensock.com
 */ /* eslint-disable */ 
var $hYzRA = parcelRequire("hYzRA");
(0, $hYzRA._gsScope)._gsDefine("TimelineLite", [
    "core.Animation",
    "core.SimpleTimeline",
    "TweenLite"
], function() {
    var TimelineLite = function(vars) {
        (0, $hYzRA.SimpleTimeline).call(this, vars);
        var self = this, v = self.vars, val, p;
        self._labels = {};
        self.autoRemoveChildren = !!v.autoRemoveChildren;
        self.smoothChildTiming = !!v.smoothChildTiming;
        self._sortChildren = true;
        self._onUpdate = v.onUpdate;
        for(p in v){
            val = v[p];
            if (_isArray(val)) {
                if (val.join("").indexOf("{self}") !== -1) v[p] = self._swapSelfInParams(val);
            }
        }
        if (_isArray(v.tweens)) self.add(v.tweens, 0, v.align, v.stagger);
    }, _tinyNum = 0.00000001, TweenLiteInternals = (0, $hYzRA.default)._internals, _internals = TimelineLite._internals = {}, _isSelector = TweenLiteInternals.isSelector, _isArray = TweenLiteInternals.isArray, _lazyTweens = TweenLiteInternals.lazyTweens, _lazyRender = TweenLiteInternals.lazyRender, _globals = (0, $hYzRA._gsScope)._gsDefine.globals, _copy = function(vars) {
        var copy = {}, p;
        for(p in vars)copy[p] = vars[p];
        return copy;
    }, _applyCycle = function(vars, targets, i) {
        var alt = vars.cycle, p, val;
        for(p in alt){
            val = alt[p];
            vars[p] = typeof val === "function" ? val(i, targets[i], targets) : val[i % val.length];
        }
        delete vars.cycle;
    }, _pauseCallback = _internals.pauseCallback = function() {}, _slice = function(a) {
        var b = [], l = a.length, i;
        for(i = 0; i !== l; b.push(a[i++]));
        return b;
    }, _defaultImmediateRender = function(tl, toVars, fromVars, defaultFalse) {
        var ir = "immediateRender";
        if (!(ir in toVars)) toVars[ir] = !(fromVars && fromVars[ir] === false || defaultFalse);
        return toVars;
    }, //for distributing values across an array. Can accept a number, a function or (most commonly) a function which can contain the following properties: {base, amount, from, ease, grid, axis, length, each}. Returns a function that expects the following parameters: index, target, array. Recognizes the following
    _distribute = function(v) {
        if (typeof v === "function") return v;
        var vars = typeof v === "object" ? v : {
            each: v
        }, ease = vars.ease, from = vars.from || 0, base = vars.base || 0, cache = {}, isFromKeyword = isNaN(from), axis = vars.axis, ratio = {
            center: 0.5,
            end: 1
        }[from] || 0;
        return function(i, target, a) {
            var l = (a || vars).length, distances = cache[l], originX, originY, x, y, d, j, max, min, wrap;
            if (!distances) {
                wrap = vars.grid === "auto" ? 0 : (vars.grid || [
                    Infinity
                ])[0];
                if (!wrap) {
                    max = -Infinity;
                    while(max < (max = a[wrap++].getBoundingClientRect().left) && wrap < l);
                    wrap--;
                }
                distances = cache[l] = [];
                originX = isFromKeyword ? Math.min(wrap, l) * ratio - 0.5 : from % wrap;
                originY = isFromKeyword ? l * ratio / wrap - 0.5 : from / wrap | 0;
                max = 0;
                min = Infinity;
                for(j = 0; j < l; j++){
                    x = j % wrap - originX;
                    y = originY - (j / wrap | 0);
                    distances[j] = d = !axis ? Math.sqrt(x * x + y * y) : Math.abs(axis === "y" ? y : x);
                    if (d > max) max = d;
                    if (d < min) min = d;
                }
                distances.max = max - min;
                distances.min = min;
                distances.v = l = vars.amount || vars.each * (wrap > l ? l - 1 : !axis ? Math.max(wrap, l / wrap) : axis === "y" ? l / wrap : wrap) || 0;
                distances.b = l < 0 ? base - l : base;
            }
            l = (distances[i] - distances.min) / distances.max;
            return distances.b + (ease ? ease.getRatio(l) : l) * distances.v;
        };
    }, p = TimelineLite.prototype = new (0, $hYzRA.SimpleTimeline)();
    TimelineLite.version = "2.1.3";
    TimelineLite.distribute = _distribute;
    p.constructor = TimelineLite;
    p.kill()._gc = p._forcingPlayhead = p._hasPause = false;
    /* might use later...
		//translates a local time inside an animation to the corresponding time on the root/global timeline, factoring in all nesting and timeScales.
		function localToGlobal(time, animation) {
			while (animation) {
				time = (time / animation._timeScale) + animation._startTime;
				animation = animation.timeline;
			}
			return time;
		}

		//translates the supplied time on the root/global timeline into the corresponding local time inside a particular animation, factoring in all nesting and timeScales
		function globalToLocal(time, animation) {
			var scale = 1;
			time -= localToGlobal(0, animation);
			while (animation) {
				scale *= animation._timeScale;
				animation = animation.timeline;
			}
			return time * scale;
		}
		*/ p.to = function(target, duration, vars, position) {
        var Engine = vars.repeat && _globals.TweenMax || (0, $hYzRA.default);
        return duration ? this.add(new Engine(target, duration, vars), position) : this.set(target, vars, position);
    };
    p.from = function(target, duration, vars, position) {
        return this.add((vars.repeat && _globals.TweenMax || (0, $hYzRA.default)).from(target, duration, _defaultImmediateRender(this, vars)), position);
    };
    p.fromTo = function(target, duration, fromVars, toVars, position) {
        var Engine = toVars.repeat && _globals.TweenMax || (0, $hYzRA.default);
        toVars = _defaultImmediateRender(this, toVars, fromVars);
        return duration ? this.add(Engine.fromTo(target, duration, fromVars, toVars), position) : this.set(target, toVars, position);
    };
    p.staggerTo = function(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
        var tl = new TimelineLite({
            onComplete: onCompleteAll,
            onCompleteParams: onCompleteAllParams,
            callbackScope: onCompleteAllScope,
            smoothChildTiming: this.smoothChildTiming
        }), staggerFunc = _distribute(vars.stagger || stagger), startAt = vars.startAt, cycle = vars.cycle, copy, i;
        if (typeof targets === "string") targets = (0, $hYzRA.default).selector(targets) || targets;
        targets = targets || [];
        if (_isSelector(targets)) targets = _slice(targets);
        for(i = 0; i < targets.length; i++){
            copy = _copy(vars);
            if (startAt) {
                copy.startAt = _copy(startAt);
                if (startAt.cycle) _applyCycle(copy.startAt, targets, i);
            }
            if (cycle) {
                _applyCycle(copy, targets, i);
                if (copy.duration != null) {
                    duration = copy.duration;
                    delete copy.duration;
                }
            }
            tl.to(targets[i], duration, copy, staggerFunc(i, targets[i], targets));
        }
        return this.add(tl, position);
    };
    p.staggerFrom = function(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
        vars.runBackwards = true;
        return this.staggerTo(targets, duration, _defaultImmediateRender(this, vars), stagger, position, onCompleteAll, onCompleteAllParams, onCompleteAllScope);
    };
    p.staggerFromTo = function(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
        toVars.startAt = fromVars;
        return this.staggerTo(targets, duration, _defaultImmediateRender(this, toVars, fromVars), stagger, position, onCompleteAll, onCompleteAllParams, onCompleteAllScope);
    };
    p.call = function(callback, params, scope, position) {
        return this.add((0, $hYzRA.default).delayedCall(0, callback, params, scope), position);
    };
    p.set = function(target, vars, position) {
        return this.add(new (0, $hYzRA.default)(target, 0, _defaultImmediateRender(this, vars, null, true)), position);
    };
    TimelineLite.exportRoot = function(vars, ignoreDelayedCalls) {
        vars = vars || {};
        if (vars.smoothChildTiming == null) vars.smoothChildTiming = true;
        var tl = new TimelineLite(vars), root = tl._timeline, hasNegativeStart, time, tween, next;
        if (ignoreDelayedCalls == null) ignoreDelayedCalls = true;
        root._remove(tl, true);
        tl._startTime = 0;
        tl._rawPrevTime = tl._time = tl._totalTime = root._time;
        tween = root._first;
        while(tween){
            next = tween._next;
            if (!ignoreDelayedCalls || !(tween instanceof (0, $hYzRA.default) && tween.target === tween.vars.onComplete)) {
                time = tween._startTime - tween._delay;
                if (time < 0) hasNegativeStart = 1;
                tl.add(tween, time);
            }
            tween = next;
        }
        root.add(tl, 0);
        if (hasNegativeStart) tl.totalDuration();
        return tl;
    };
    p.add = function(value, position, align, stagger) {
        var self = this, curTime, l, i, child, tl, beforeRawTime;
        if (typeof position !== "number") position = self._parseTimeOrLabel(position, 0, true, value);
        if (!(value instanceof (0, $hYzRA.Animation))) {
            if (value instanceof Array || value && value.push && _isArray(value)) {
                align = align || "normal";
                stagger = stagger || 0;
                curTime = position;
                l = value.length;
                for(i = 0; i < l; i++){
                    if (_isArray(child = value[i])) child = new TimelineLite({
                        tweens: child
                    });
                    self.add(child, curTime);
                    if (typeof child !== "string" && typeof child !== "function") {
                        if (align === "sequence") curTime = child._startTime + child.totalDuration() / child._timeScale;
                        else if (align === "start") child._startTime -= child.delay();
                    }
                    curTime += stagger;
                }
                return self._uncache(true);
            } else if (typeof value === "string") return self.addLabel(value, position);
            else if (typeof value === "function") value = (0, $hYzRA.default).delayedCall(0, value);
            else throw "Cannot add " + value + " into the timeline; it is not a tween, timeline, function, or string.";
        }
        (0, $hYzRA.SimpleTimeline).prototype.add.call(self, value, position);
        if (value._time || !value._duration && value._initted) {
            curTime = (self.rawTime() - value._startTime) * value._timeScale;
            if (!value._duration || Math.abs(Math.max(0, Math.min(value.totalDuration(), curTime))) - value._totalTime > 0.00001) value.render(curTime, false, false);
        }
        //if the timeline has already ended but the inserted tween/timeline extends the duration, we should enable this timeline again so that it renders properly. We should also align the playhead with the parent timeline's when appropriate.
        if (self._gc || self._time === self._duration) {
            if (!self._paused) {
                if (self._duration < self.duration()) {
                    //in case any of the ancestors had completed but should now be enabled...
                    tl = self;
                    beforeRawTime = tl.rawTime() > value._startTime; //if the tween is placed on the timeline so that it starts BEFORE the current rawTime, we should align the playhead (move the timeline). This is because sometimes users will create a timeline, let it finish, and much later append a tween and expect it to run instead of jumping to its end state. While technically one could argue that it should jump to its end state, that's not what users intuitively expect.
                    while(tl._timeline){
                        if (beforeRawTime && tl._timeline.smoothChildTiming) tl.totalTime(tl._totalTime, true); //moves the timeline (shifts its startTime) if necessary, and also enables it.
                        else if (tl._gc) tl._enabled(true, false);
                        tl = tl._timeline;
                    }
                }
            }
        }
        return self;
    };
    p.remove = function(value) {
        if (value instanceof (0, $hYzRA.Animation)) {
            this._remove(value, false);
            var tl = value._timeline = value.vars.useFrames ? (0, $hYzRA.Animation)._rootFramesTimeline : (0, $hYzRA.Animation)._rootTimeline; //now that it's removed, default it to the root timeline so that if it gets played again, it doesn't jump back into this timeline.
            value._startTime = (value._paused ? value._pauseTime : tl._time) - (!value._reversed ? value._totalTime : value.totalDuration() - value._totalTime) / value._timeScale; //ensure that if it gets played again, the timing is correct.
            return this;
        } else if (value instanceof Array || value && value.push && _isArray(value)) {
            var i = value.length;
            while(--i > -1)this.remove(value[i]);
            return this;
        } else if (typeof value === "string") return this.removeLabel(value);
        return this.kill(null, value);
    };
    p._remove = function(tween, skipDisable) {
        (0, $hYzRA.SimpleTimeline).prototype._remove.call(this, tween, skipDisable);
        var last = this._last;
        if (!last) this._time = this._totalTime = this._duration = this._totalDuration = 0;
        else if (this._time > this.duration()) {
            this._time = this._duration;
            this._totalTime = this._totalDuration;
        }
        return this;
    };
    p.append = function(value, offsetOrLabel) {
        return this.add(value, this._parseTimeOrLabel(null, offsetOrLabel, true, value));
    };
    p.insert = p.insertMultiple = function(value, position, align, stagger) {
        return this.add(value, position || 0, align, stagger);
    };
    p.appendMultiple = function(tweens, offsetOrLabel, align, stagger) {
        return this.add(tweens, this._parseTimeOrLabel(null, offsetOrLabel, true, tweens), align, stagger);
    };
    p.addLabel = function(label, position) {
        this._labels[label] = this._parseTimeOrLabel(position);
        return this;
    };
    p.addPause = function(position, callback, params, scope) {
        var t = (0, $hYzRA.default).delayedCall(0, _pauseCallback, params, scope || this);
        t.vars.onComplete = t.vars.onReverseComplete = callback;
        t.data = "isPause";
        this._hasPause = true;
        return this.add(t, position);
    };
    p.removeLabel = function(label) {
        delete this._labels[label];
        return this;
    };
    p.getLabelTime = function(label) {
        return this._labels[label] != null ? this._labels[label] : -1;
    };
    p._parseTimeOrLabel = function(timeOrLabel, offsetOrLabel, appendIfAbsent, ignore) {
        var clippedDuration, i;
        //if we're about to add a tween/timeline (or an array of them) that's already a child of this timeline, we should remove it first so that it doesn't contaminate the duration().
        if (ignore instanceof (0, $hYzRA.Animation) && ignore.timeline === this) this.remove(ignore);
        else if (ignore && (ignore instanceof Array || ignore.push && _isArray(ignore))) {
            i = ignore.length;
            while(--i > -1)if (ignore[i] instanceof (0, $hYzRA.Animation) && ignore[i].timeline === this) this.remove(ignore[i]);
        }
        clippedDuration = typeof timeOrLabel === "number" && !offsetOrLabel ? 0 : this.duration() > 99999999999 ? this.recent().endTime(false) : this._duration; //in case there's a child that infinitely repeats, users almost never intend for the insertion point of a new child to be based on a SUPER long value like that so we clip it and assume the most recently-added child's endTime should be used instead.
        if (typeof offsetOrLabel === "string") return this._parseTimeOrLabel(offsetOrLabel, appendIfAbsent && typeof timeOrLabel === "number" && this._labels[offsetOrLabel] == null ? timeOrLabel - clippedDuration : 0, appendIfAbsent);
        offsetOrLabel = offsetOrLabel || 0;
        if (typeof timeOrLabel === "string" && (isNaN(timeOrLabel) || this._labels[timeOrLabel] != null)) {
            i = timeOrLabel.indexOf("=");
            if (i === -1) {
                if (this._labels[timeOrLabel] == null) return appendIfAbsent ? this._labels[timeOrLabel] = clippedDuration + offsetOrLabel : offsetOrLabel;
                return this._labels[timeOrLabel] + offsetOrLabel;
            }
            offsetOrLabel = parseInt(timeOrLabel.charAt(i - 1) + "1", 10) * Number(timeOrLabel.substr(i + 1));
            timeOrLabel = i > 1 ? this._parseTimeOrLabel(timeOrLabel.substr(0, i - 1), 0, appendIfAbsent) : clippedDuration;
        } else if (timeOrLabel == null) timeOrLabel = clippedDuration;
        return Number(timeOrLabel) + offsetOrLabel;
    };
    p.seek = function(position, suppressEvents) {
        return this.totalTime(typeof position === "number" ? position : this._parseTimeOrLabel(position), suppressEvents !== false);
    };
    p.stop = function() {
        return this.paused(true);
    };
    p.gotoAndPlay = function(position, suppressEvents) {
        return this.play(position, suppressEvents);
    };
    p.gotoAndStop = function(position, suppressEvents) {
        return this.pause(position, suppressEvents);
    };
    p.render = function(time, suppressEvents, force) {
        if (this._gc) this._enabled(true, false);
        var self = this, prevTime = self._time, totalDur = !self._dirty ? self._totalDuration : self.totalDuration(), prevStart = self._startTime, prevTimeScale = self._timeScale, prevPaused = self._paused, tween, isComplete, next, callback, internalForce, pauseTween, curTime, pauseTime;
        if (prevTime !== self._time) time += self._time - prevTime;
        if (self._hasPause && !self._forcingPlayhead && !suppressEvents) {
            if (time > prevTime) {
                tween = self._first;
                while(tween && tween._startTime <= time && !pauseTween){
                    if (!tween._duration) {
                        if (tween.data === "isPause" && !tween.ratio && !(tween._startTime === 0 && self._rawPrevTime === 0)) pauseTween = tween;
                    }
                    tween = tween._next;
                }
            } else {
                tween = self._last;
                while(tween && tween._startTime >= time && !pauseTween){
                    if (!tween._duration) {
                        if (tween.data === "isPause" && tween._rawPrevTime > 0) pauseTween = tween;
                    }
                    tween = tween._prev;
                }
            }
            if (pauseTween) {
                self._time = self._totalTime = time = pauseTween._startTime;
                pauseTime = self._startTime + (self._reversed ? self._duration - time : time) / self._timeScale;
            }
        }
        if (time >= totalDur - _tinyNum && time >= 0) {
            self._totalTime = self._time = totalDur;
            if (!self._reversed) {
                if (!self._hasPausedChild()) {
                    isComplete = true;
                    callback = "onComplete";
                    internalForce = !!self._timeline.autoRemoveChildren; //otherwise, if the animation is unpaused/activated after it's already finished, it doesn't get removed from the parent timeline.
                    if (self._duration === 0) {
                        if (time <= 0 && time >= -_tinyNum || self._rawPrevTime < 0 || self._rawPrevTime === _tinyNum) {
                            if (self._rawPrevTime !== time && self._first) {
                                internalForce = true;
                                if (self._rawPrevTime > _tinyNum) callback = "onReverseComplete";
                            }
                        }
                    }
                }
            }
            self._rawPrevTime = self._duration || !suppressEvents || time || self._rawPrevTime === time ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline or tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
            time = totalDur + 0.0001; //to avoid occasional floating point rounding errors - sometimes child tweens/timelines were not being fully completed (their progress might be 0.999999999999998 instead of 1 because when _time - tween._startTime is performed, floating point errors would return a value that was SLIGHTLY off). Try (999999999999.7 - 999999999999) * 1 = 0.699951171875 instead of 0.7.
        } else if (time < _tinyNum) {
            self._totalTime = self._time = 0;
            if (time > -_tinyNum) time = 0;
            if (prevTime !== 0 || self._duration === 0 && self._rawPrevTime !== _tinyNum && (self._rawPrevTime > 0 || time < 0 && self._rawPrevTime >= 0)) {
                callback = "onReverseComplete";
                isComplete = self._reversed;
            }
            if (time < 0) {
                self._active = false;
                if (self._timeline.autoRemoveChildren && self._reversed) {
                    internalForce = isComplete = true;
                    callback = "onReverseComplete";
                } else if (self._rawPrevTime >= 0 && self._first) internalForce = true;
                self._rawPrevTime = time;
            } else {
                self._rawPrevTime = self._duration || !suppressEvents || time || self._rawPrevTime === time ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline or tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
                if (time === 0 && isComplete) {
                    tween = self._first;
                    while(tween && tween._startTime === 0){
                        if (!tween._duration) isComplete = false;
                        tween = tween._next;
                    }
                }
                time = 0; //to avoid occasional floating point rounding errors (could cause problems especially with zero-duration tweens at the very beginning of the timeline)
                if (!self._initted) internalForce = true;
            }
        } else self._totalTime = self._time = self._rawPrevTime = time;
        if ((self._time === prevTime || !self._first) && !force && !internalForce && !pauseTween) return;
        else if (!self._initted) self._initted = true;
        if (!self._active) {
            if (!self._paused && self._time !== prevTime && time > 0) self._active = true; //so that if the user renders the timeline (as opposed to the parent timeline rendering it), it is forced to re-render and align it with the proper time/frame on the next rendering cycle. Maybe the timeline already finished but the user manually re-renders it as halfway done, for example.
        }
        if (prevTime === 0) {
            if (self.vars.onStart) {
                if (self._time !== 0 || !self._duration) {
                    if (!suppressEvents) self._callback("onStart");
                }
            }
        }
        curTime = self._time;
        if (curTime >= prevTime) {
            tween = self._first;
            while(tween){
                next = tween._next; //record it here because the value could change after rendering...
                if (curTime !== self._time || self._paused && !prevPaused) break;
                else if (tween._active || tween._startTime <= curTime && !tween._paused && !tween._gc) {
                    if (pauseTween === tween) {
                        self.pause();
                        self._pauseTime = pauseTime; //so that when we resume(), it's starting from exactly the right spot (the pause() method uses the rawTime for the parent, but that may be a bit too far ahead)
                    }
                    if (!tween._reversed) tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
                    else tween.render((!tween._dirty ? tween._totalDuration : tween.totalDuration()) - (time - tween._startTime) * tween._timeScale, suppressEvents, force);
                }
                tween = next;
            }
        } else {
            tween = self._last;
            while(tween){
                next = tween._prev; //record it here because the value could change after rendering...
                if (curTime !== self._time || self._paused && !prevPaused) break;
                else if (tween._active || tween._startTime <= prevTime && !tween._paused && !tween._gc) {
                    if (pauseTween === tween) {
                        pauseTween = tween._prev; //the linked list is organized by _startTime, thus it's possible that a tween could start BEFORE the pause and end after it, in which case it would be positioned before the pause tween in the linked list, but we should render it before we pause() the timeline and cease rendering. This is only a concern when going in reverse.
                        while(pauseTween && pauseTween.endTime() > self._time){
                            pauseTween.render(pauseTween._reversed ? pauseTween.totalDuration() - (time - pauseTween._startTime) * pauseTween._timeScale : (time - pauseTween._startTime) * pauseTween._timeScale, suppressEvents, force);
                            pauseTween = pauseTween._prev;
                        }
                        pauseTween = null;
                        self.pause();
                        self._pauseTime = pauseTime; //so that when we resume(), it's starting from exactly the right spot (the pause() method uses the rawTime for the parent, but that may be a bit too far ahead)
                    }
                    if (!tween._reversed) tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
                    else tween.render((!tween._dirty ? tween._totalDuration : tween.totalDuration()) - (time - tween._startTime) * tween._timeScale, suppressEvents, force);
                }
                tween = next;
            }
        }
        if (self._onUpdate) {
            if (!suppressEvents) {
                if (_lazyTweens.length) _lazyRender();
                self._callback("onUpdate");
            }
        }
        if (callback) {
            if (!self._gc) {
                if (prevStart === self._startTime || prevTimeScale !== self._timeScale) {
                    if (self._time === 0 || totalDur >= self.totalDuration()) {
                        if (isComplete) {
                            if (_lazyTweens.length) _lazyRender();
                            if (self._timeline.autoRemoveChildren) self._enabled(false, false);
                            self._active = false;
                        }
                        if (!suppressEvents && self.vars[callback]) self._callback(callback);
                    }
                }
            }
        }
    };
    p._hasPausedChild = function() {
        var tween = this._first;
        while(tween){
            if (tween._paused || tween instanceof TimelineLite && tween._hasPausedChild()) return true;
            tween = tween._next;
        }
        return false;
    };
    p.getChildren = function(nested, tweens, timelines, ignoreBeforeTime) {
        ignoreBeforeTime = ignoreBeforeTime || -9999999999;
        var a = [], tween = this._first, cnt = 0;
        while(tween){
            if (tween._startTime < ignoreBeforeTime) ;
            else if (tween instanceof (0, $hYzRA.default)) {
                if (tweens !== false) a[cnt++] = tween;
            } else {
                if (timelines !== false) a[cnt++] = tween;
                if (nested !== false) {
                    a = a.concat(tween.getChildren(true, tweens, timelines));
                    cnt = a.length;
                }
            }
            tween = tween._next;
        }
        return a;
    };
    p.getTweensOf = function(target, nested) {
        var disabled = this._gc, a = [], cnt = 0, tweens, i;
        if (disabled) this._enabled(true, true); //getTweensOf() filters out disabled tweens, and we have to mark them as _gc = true when the timeline completes in order to allow clean garbage collection, so temporarily re-enable the timeline here.
        tweens = (0, $hYzRA.default).getTweensOf(target);
        i = tweens.length;
        while(--i > -1)if (tweens[i].timeline === this || nested && this._contains(tweens[i])) a[cnt++] = tweens[i];
        if (disabled) this._enabled(false, true);
        return a;
    };
    p.recent = function() {
        return this._recent;
    };
    p._contains = function(tween) {
        var tl = tween.timeline;
        while(tl){
            if (tl === this) return true;
            tl = tl.timeline;
        }
        return false;
    };
    p.shiftChildren = function(amount, adjustLabels, ignoreBeforeTime) {
        ignoreBeforeTime = ignoreBeforeTime || 0;
        var tween = this._first, labels = this._labels, p;
        while(tween){
            if (tween._startTime >= ignoreBeforeTime) tween._startTime += amount;
            tween = tween._next;
        }
        if (adjustLabels) {
            for(p in labels)if (labels[p] >= ignoreBeforeTime) labels[p] += amount;
        }
        return this._uncache(true);
    };
    p._kill = function(vars, target) {
        if (!vars && !target) return this._enabled(false, false);
        var tweens = !target ? this.getChildren(true, true, false) : this.getTweensOf(target), i = tweens.length, changed = false;
        while(--i > -1)if (tweens[i]._kill(vars, target)) changed = true;
        return changed;
    };
    p.clear = function(labels) {
        var tweens = this.getChildren(false, true, true), i = tweens.length;
        this._time = this._totalTime = 0;
        while(--i > -1)tweens[i]._enabled(false, false);
        if (labels !== false) this._labels = {};
        return this._uncache(true);
    };
    p.invalidate = function() {
        var tween = this._first;
        while(tween){
            tween.invalidate();
            tween = tween._next;
        }
        return (0, $hYzRA.Animation).prototype.invalidate.call(this);
    };
    p._enabled = function(enabled, ignoreTimeline) {
        if (enabled === this._gc) {
            var tween = this._first;
            while(tween){
                tween._enabled(enabled, true);
                tween = tween._next;
            }
        }
        return (0, $hYzRA.SimpleTimeline).prototype._enabled.call(this, enabled, ignoreTimeline);
    };
    p.totalTime = function(time, suppressEvents, uncapped) {
        this._forcingPlayhead = true;
        var val = (0, $hYzRA.Animation).prototype.totalTime.apply(this, arguments);
        this._forcingPlayhead = false;
        return val;
    };
    p.duration = function(value) {
        if (!arguments.length) {
            if (this._dirty) this.totalDuration(); //just triggers recalculation
            return this._duration;
        }
        if (this.duration() !== 0 && value !== 0) this.timeScale(this._duration / value);
        return this;
    };
    p.totalDuration = function(value) {
        if (!arguments.length) {
            if (this._dirty) {
                var max = 0, self = this, tween = self._last, prevStart = 999999999999, prev, end;
                while(tween){
                    prev = tween._prev; //record it here in case the tween changes position in the sequence...
                    if (tween._dirty) tween.totalDuration(); //could change the tween._startTime, so make sure the tween's cache is clean before analyzing it.
                    if (tween._startTime > prevStart && self._sortChildren && !tween._paused && !self._calculatingDuration) {
                        self._calculatingDuration = 1; //prevent endless recursive calls - there are methods that get triggered that check duration/totalDuration when we add(), like _parseTimeOrLabel().
                        self.add(tween, tween._startTime - tween._delay);
                        self._calculatingDuration = 0;
                    } else prevStart = tween._startTime;
                    if (tween._startTime < 0 && !tween._paused) {
                        max -= tween._startTime;
                        if (self._timeline.smoothChildTiming) {
                            self._startTime += tween._startTime / self._timeScale;
                            self._time -= tween._startTime;
                            self._totalTime -= tween._startTime;
                            self._rawPrevTime -= tween._startTime;
                        }
                        self.shiftChildren(-tween._startTime, false, -9999999999);
                        prevStart = 0;
                    }
                    end = tween._startTime + tween._totalDuration / tween._timeScale;
                    if (end > max) max = end;
                    tween = prev;
                }
                self._duration = self._totalDuration = max;
                self._dirty = false;
            }
            return this._totalDuration;
        }
        return value && this.totalDuration() ? this.timeScale(this._totalDuration / value) : this;
    };
    p.paused = function(value) {
        if (value === false && this._paused) {
            var tween = this._first;
            while(tween){
                if (tween._startTime === this._time && tween.data === "isPause") tween._rawPrevTime = 0; //remember, _rawPrevTime is how zero-duration tweens/callbacks sense directionality and determine whether or not to fire. If _rawPrevTime is the same as _startTime on the next render, it won't fire.
                tween = tween._next;
            }
        }
        return (0, $hYzRA.Animation).prototype.paused.apply(this, arguments);
    };
    p.usesFrames = function() {
        var tl = this._timeline;
        while(tl._timeline)tl = tl._timeline;
        return tl === (0, $hYzRA.Animation)._rootFramesTimeline;
    };
    p.rawTime = function(wrapRepeats) {
        return wrapRepeats && (this._paused || this._repeat && this.time() > 0 && this.totalProgress() < 1) ? this._totalTime % (this._duration + this._repeatDelay) : this._paused ? this._totalTime : (this._timeline.rawTime(wrapRepeats) - this._startTime) * this._timeScale;
    };
    return TimelineLite;
}, true);
var $4950cb68bb9e31b3$export$fcaf79afd042bc65 = (0, $hYzRA.globals).TimelineLite;

});

parcelRequire.register("9fTje", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6bd06b0586a6a5ab$export$100fffa6b25ca05d; });
/*!
 * VERSION: 2.1.3
 * DATE: 2019-05-17
 * UPDATES AND DOCS AT: http://greensock.com
 *
 * @license Copyright (c) 2008-2019, GreenSock. All rights reserved.
 * This work is subject to the terms at http://greensock.com/standard-license or for
 * Club GreenSock members, the software agreement that was issued with your membership.
 * 
 * @author: Jack Doyle, jack@greensock.com
 */ /* eslint-disable */ 
var $hYzRA = parcelRequire("hYzRA");

var $6ifWP = parcelRequire("6ifWP");
(0, $hYzRA._gsScope)._gsDefine("TimelineMax", [
    "TimelineLite",
    "TweenLite",
    "easing.Ease"
], function() {
    var TimelineMax = function(vars) {
        (0, $6ifWP.default).call(this, vars);
        this._repeat = this.vars.repeat || 0;
        this._repeatDelay = this.vars.repeatDelay || 0;
        this._cycle = 0;
        this._yoyo = !!this.vars.yoyo;
        this._dirty = true;
    }, _tinyNum = 0.00000001, TweenLiteInternals = (0, $hYzRA.default)._internals, _lazyTweens = TweenLiteInternals.lazyTweens, _lazyRender = TweenLiteInternals.lazyRender, _globals = (0, $hYzRA._gsScope)._gsDefine.globals, _easeNone = new (0, $hYzRA.Ease)(null, null, 1, 0), p = TimelineMax.prototype = new (0, $6ifWP.default)();
    p.constructor = TimelineMax;
    p.kill()._gc = false;
    TimelineMax.version = "2.1.3";
    p.invalidate = function() {
        this._yoyo = !!this.vars.yoyo;
        this._repeat = this.vars.repeat || 0;
        this._repeatDelay = this.vars.repeatDelay || 0;
        this._uncache(true);
        return (0, $6ifWP.default).prototype.invalidate.call(this);
    };
    p.addCallback = function(callback, position, params, scope) {
        return this.add((0, $hYzRA.default).delayedCall(0, callback, params, scope), position);
    };
    p.removeCallback = function(callback, position) {
        if (callback) {
            if (position == null) this._kill(null, callback);
            else {
                var a = this.getTweensOf(callback, false), i = a.length, time = this._parseTimeOrLabel(position);
                while(--i > -1)if (a[i]._startTime === time) a[i]._enabled(false, false);
            }
        }
        return this;
    };
    p.removePause = function(position) {
        return this.removeCallback((0, $6ifWP.default)._internals.pauseCallback, position);
    };
    p.tweenTo = function(position, vars) {
        vars = vars || {};
        var copy = {
            ease: _easeNone,
            useFrames: this.usesFrames(),
            immediateRender: false,
            lazy: false
        }, Engine = vars.repeat && _globals.TweenMax || (0, $hYzRA.default), duration, p, t;
        for(p in vars)copy[p] = vars[p];
        copy.time = this._parseTimeOrLabel(position);
        duration = Math.abs(Number(copy.time) - this._time) / this._timeScale || 0.001;
        t = new Engine(this, duration, copy);
        copy.onStart = function() {
            t.target.paused(true);
            if (t.vars.time !== t.target.time() && duration === t.duration() && !t.isFromTo) t.duration(Math.abs(t.vars.time - t.target.time()) / t.target._timeScale).render(t.time(), true, true); //render() right away to ensure that things look right, especially in the case of .tweenTo(0).
            if (vars.onStart) vars.onStart.apply(vars.onStartScope || vars.callbackScope || t, vars.onStartParams || []); //don't use t._callback("onStart") or it'll point to the copy.onStart and we'll get a recursion error.
        };
        return t;
    };
    p.tweenFromTo = function(fromPosition, toPosition, vars) {
        vars = vars || {};
        fromPosition = this._parseTimeOrLabel(fromPosition);
        vars.startAt = {
            onComplete: this.seek,
            onCompleteParams: [
                fromPosition
            ],
            callbackScope: this
        };
        vars.immediateRender = vars.immediateRender !== false;
        var t = this.tweenTo(toPosition, vars);
        t.isFromTo = 1; //to ensure we don't mess with the duration in the onStart (we've got the start and end values here, so lock it in)
        return t.duration(Math.abs(t.vars.time - fromPosition) / this._timeScale || 0.001);
    };
    p.render = function(time, suppressEvents, force) {
        if (this._gc) this._enabled(true, false);
        var self = this, prevTime = self._time, totalDur = !self._dirty ? self._totalDuration : self.totalDuration(), dur = self._duration, prevTotalTime = self._totalTime, prevStart = self._startTime, prevTimeScale = self._timeScale, prevRawPrevTime = self._rawPrevTime, prevPaused = self._paused, prevCycle = self._cycle, tween, isComplete, next, callback, internalForce, cycleDuration, pauseTween, curTime, pauseTime;
        if (prevTime !== self._time) time += self._time - prevTime;
        if (time >= totalDur - _tinyNum && time >= 0) {
            if (!self._locked) {
                self._totalTime = totalDur;
                self._cycle = self._repeat;
            }
            if (!self._reversed) {
                if (!self._hasPausedChild()) {
                    isComplete = true;
                    callback = "onComplete";
                    internalForce = !!self._timeline.autoRemoveChildren; //otherwise, if the animation is unpaused/activated after it's already finished, it doesn't get removed from the parent timeline.
                    if (self._duration === 0) {
                        if (time <= 0 && time >= -_tinyNum || prevRawPrevTime < 0 || prevRawPrevTime === _tinyNum) {
                            if (prevRawPrevTime !== time && self._first) {
                                internalForce = true;
                                if (prevRawPrevTime > _tinyNum) callback = "onReverseComplete";
                            }
                        }
                    }
                }
            }
            self._rawPrevTime = self._duration || !suppressEvents || time || self._rawPrevTime === time ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline or tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
            if (self._yoyo && self._cycle & 1) self._time = time = 0;
            else {
                self._time = dur;
                time = dur + 0.0001; //to avoid occasional floating point rounding errors - sometimes child tweens/timelines were not being fully completed (their progress might be 0.999999999999998 instead of 1 because when _time - tween._startTime is performed, floating point errors would return a value that was SLIGHTLY off). Try (999999999999.7 - 999999999999) * 1 = 0.699951171875 instead of 0.7. We cannot do less then 0.0001 because the same issue can occur when the duration is extremely large like 999999999999 in which case adding 0.00000001, for example, causes it to act like nothing was added.
            }
        } else if (time < _tinyNum) {
            if (!self._locked) self._totalTime = self._cycle = 0;
            self._time = 0;
            if (time > -_tinyNum) time = 0;
            if (prevTime !== 0 || dur === 0 && prevRawPrevTime !== _tinyNum && (prevRawPrevTime > 0 || time < 0 && prevRawPrevTime >= 0) && !self._locked) {
                callback = "onReverseComplete";
                isComplete = self._reversed;
            }
            if (time < 0) {
                self._active = false;
                if (self._timeline.autoRemoveChildren && self._reversed) {
                    internalForce = isComplete = true;
                    callback = "onReverseComplete";
                } else if (prevRawPrevTime >= 0 && self._first) internalForce = true;
                self._rawPrevTime = time;
            } else {
                self._rawPrevTime = dur || !suppressEvents || time || self._rawPrevTime === time ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline or tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
                if (time === 0 && isComplete) {
                    tween = self._first;
                    while(tween && tween._startTime === 0){
                        if (!tween._duration) isComplete = false;
                        tween = tween._next;
                    }
                }
                time = 0; //to avoid occasional floating point rounding errors (could cause problems especially with zero-duration tweens at the very beginning of the timeline)
                if (!self._initted) internalForce = true;
            }
        } else {
            if (dur === 0 && prevRawPrevTime < 0) internalForce = true;
            self._time = self._rawPrevTime = time;
            if (!self._locked) {
                self._totalTime = time;
                if (self._repeat !== 0) {
                    cycleDuration = dur + self._repeatDelay;
                    self._cycle = self._totalTime / cycleDuration >> 0; //originally _totalTime % cycleDuration but floating point errors caused problems, so I normalized it. (4 % 0.8 should be 0 but it gets reported as 0.79999999!)
                    if (self._cycle) {
                        if (self._cycle === self._totalTime / cycleDuration && prevTotalTime <= time) self._cycle--; //otherwise when rendered exactly at the end time, it will act as though it is repeating (at the beginning)
                    }
                    self._time = self._totalTime - self._cycle * cycleDuration;
                    if (self._yoyo) {
                        if (self._cycle & 1) self._time = dur - self._time;
                    }
                    if (self._time > dur) {
                        self._time = dur;
                        time = dur + 0.0001; //to avoid occasional floating point rounding error
                    } else if (self._time < 0) self._time = time = 0;
                    else time = self._time;
                }
            }
        }
        if (self._hasPause && !self._forcingPlayhead && !suppressEvents) {
            time = self._time;
            if (time > prevTime || self._repeat && prevCycle !== self._cycle) {
                tween = self._first;
                while(tween && tween._startTime <= time && !pauseTween){
                    if (!tween._duration) {
                        if (tween.data === "isPause" && !tween.ratio && !(tween._startTime === 0 && self._rawPrevTime === 0)) pauseTween = tween;
                    }
                    tween = tween._next;
                }
            } else {
                tween = self._last;
                while(tween && tween._startTime >= time && !pauseTween){
                    if (!tween._duration) {
                        if (tween.data === "isPause" && tween._rawPrevTime > 0) pauseTween = tween;
                    }
                    tween = tween._prev;
                }
            }
            if (pauseTween) {
                pauseTime = self._startTime + (self._reversed ? self._duration - pauseTween._startTime : pauseTween._startTime) / self._timeScale;
                if (pauseTween._startTime < dur) {
                    self._time = self._rawPrevTime = time = pauseTween._startTime;
                    self._totalTime = time + self._cycle * (self._totalDuration + self._repeatDelay);
                }
            }
        }
        if (self._cycle !== prevCycle) {
            if (!self._locked) {
                /*
				make sure children at the end/beginning of the timeline are rendered properly. If, for example,
				a 3-second long timeline rendered at 2.9 seconds previously, and now renders at 3.2 seconds (which
				would get translated to 2.8 seconds if the timeline yoyos or 0.2 seconds if it just repeats), there
				could be a callback or a short tween that's at 2.95 or 3 seconds in which wouldn't render. So
				we need to push the timeline to the end (and/or beginning depending on its yoyo value). Also we must
				ensure that zero-duration tweens at the very beginning or end of the TimelineMax work.
				*/ var backwards = self._yoyo && (prevCycle & 1) !== 0, wrap = backwards === (self._yoyo && (self._cycle & 1) !== 0), recTotalTime = self._totalTime, recCycle = self._cycle, recRawPrevTime = self._rawPrevTime, recTime = self._time;
                self._totalTime = prevCycle * dur;
                if (self._cycle < prevCycle) backwards = !backwards;
                else self._totalTime += dur;
                self._time = prevTime; //temporarily revert _time so that render() renders the children in the correct order. Without this, tweens won't rewind correctly. We could arhictect things in a "cleaner" way by splitting out the rendering queue into a separate method but for performance reasons, we kept it all inside this method.
                self._rawPrevTime = dur === 0 ? prevRawPrevTime - 0.0001 : prevRawPrevTime;
                self._cycle = prevCycle;
                self._locked = true; //prevents changes to totalTime and skips repeat/yoyo behavior when we recursively call render()
                prevTime = backwards ? 0 : dur;
                self.render(prevTime, suppressEvents, dur === 0);
                if (!suppressEvents) {
                    if (!self._gc) {
                        if (self.vars.onRepeat) {
                            self._cycle = recCycle; //in case the onRepeat alters the playhead or invalidates(), we shouldn't stay locked or use the previous cycle.
                            self._locked = false;
                            self._callback("onRepeat");
                        }
                    }
                }
                if (prevTime !== self._time) return;
                if (wrap) {
                    self._cycle = prevCycle; //if there's an onRepeat, we reverted this above, so make sure it's set properly again. We also unlocked in that scenario, so reset that too.
                    self._locked = true;
                    prevTime = backwards ? dur + 0.0001 : -0.0001;
                    self.render(prevTime, true, false);
                }
                self._locked = false;
                if (self._paused && !prevPaused) return;
                self._time = recTime;
                self._totalTime = recTotalTime;
                self._cycle = recCycle;
                self._rawPrevTime = recRawPrevTime;
            }
        }
        if ((self._time === prevTime || !self._first) && !force && !internalForce && !pauseTween) {
            if (prevTotalTime !== self._totalTime) {
                if (self._onUpdate) {
                    if (!suppressEvents) self._callback("onUpdate");
                }
            }
            return;
        } else if (!self._initted) self._initted = true;
        if (!self._active) {
            if (!self._paused && self._totalTime !== prevTotalTime && time > 0) self._active = true; //so that if the user renders the timeline (as opposed to the parent timeline rendering it), it is forced to re-render and align it with the proper time/frame on the next rendering cycle. Maybe the timeline already finished but the user manually re-renders it as halfway done, for example.
        }
        if (prevTotalTime === 0) {
            if (self.vars.onStart) {
                if (self._totalTime !== 0 || !self._totalDuration) {
                    if (!suppressEvents) self._callback("onStart");
                }
            }
        }
        curTime = self._time;
        if (curTime >= prevTime) {
            tween = self._first;
            while(tween){
                next = tween._next; //record it here because the value could change after rendering...
                if (curTime !== self._time || self._paused && !prevPaused) break;
                else if (tween._active || tween._startTime <= self._time && !tween._paused && !tween._gc) {
                    if (pauseTween === tween) {
                        self.pause();
                        self._pauseTime = pauseTime; //so that when we resume(), it's starting from exactly the right spot (the pause() method uses the rawTime for the parent, but that may be a bit too far ahead)
                    }
                    if (!tween._reversed) tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
                    else tween.render((!tween._dirty ? tween._totalDuration : tween.totalDuration()) - (time - tween._startTime) * tween._timeScale, suppressEvents, force);
                }
                tween = next;
            }
        } else {
            tween = self._last;
            while(tween){
                next = tween._prev; //record it here because the value could change after rendering...
                if (curTime !== self._time || self._paused && !prevPaused) break;
                else if (tween._active || tween._startTime <= prevTime && !tween._paused && !tween._gc) {
                    if (pauseTween === tween) {
                        pauseTween = tween._prev; //the linked list is organized by _startTime, thus it's possible that a tween could start BEFORE the pause and end after it, in which case it would be positioned before the pause tween in the linked list, but we should render it before we pause() the timeline and cease rendering. This is only a concern when going in reverse.
                        while(pauseTween && pauseTween.endTime() > self._time){
                            pauseTween.render(pauseTween._reversed ? pauseTween.totalDuration() - (time - pauseTween._startTime) * pauseTween._timeScale : (time - pauseTween._startTime) * pauseTween._timeScale, suppressEvents, force);
                            pauseTween = pauseTween._prev;
                        }
                        pauseTween = null;
                        self.pause();
                        self._pauseTime = pauseTime; //so that when we resume(), it's starting from exactly the right spot (the pause() method uses the rawTime for the parent, but that may be a bit too far ahead)
                    }
                    if (!tween._reversed) tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
                    else tween.render((!tween._dirty ? tween._totalDuration : tween.totalDuration()) - (time - tween._startTime) * tween._timeScale, suppressEvents, force);
                }
                tween = next;
            }
        }
        if (self._onUpdate) {
            if (!suppressEvents) {
                if (_lazyTweens.length) _lazyRender();
                self._callback("onUpdate");
            }
        }
        if (callback) {
            if (!self._locked) {
                if (!self._gc) {
                    if (prevStart === self._startTime || prevTimeScale !== self._timeScale) {
                        if (self._time === 0 || totalDur >= self.totalDuration()) {
                            if (isComplete) {
                                if (_lazyTweens.length) _lazyRender();
                                if (self._timeline.autoRemoveChildren) self._enabled(false, false);
                                self._active = false;
                            }
                            if (!suppressEvents && self.vars[callback]) self._callback(callback);
                        }
                    }
                }
            }
        }
    };
    p.getActive = function(nested, tweens, timelines) {
        var a = [], all = this.getChildren(nested || nested == null, tweens || nested == null, !!timelines), cnt = 0, l = all.length, i, tween;
        for(i = 0; i < l; i++){
            tween = all[i];
            if (tween.isActive()) a[cnt++] = tween;
        }
        return a;
    };
    p.getLabelAfter = function(time) {
        if (!time) {
            if (time !== 0) time = this._time;
        }
        var labels = this.getLabelsArray(), l = labels.length, i;
        for(i = 0; i < l; i++){
            if (labels[i].time > time) return labels[i].name;
        }
        return null;
    };
    p.getLabelBefore = function(time) {
        if (time == null) time = this._time;
        var labels = this.getLabelsArray(), i = labels.length;
        while(--i > -1){
            if (labels[i].time < time) return labels[i].name;
        }
        return null;
    };
    p.getLabelsArray = function() {
        var a = [], cnt = 0, p;
        for(p in this._labels)a[cnt++] = {
            time: this._labels[p],
            name: p
        };
        a.sort(function(a, b) {
            return a.time - b.time;
        });
        return a;
    };
    p.invalidate = function() {
        this._locked = false; //unlock and set cycle in case invalidate() is called from inside an onRepeat
        return (0, $6ifWP.default).prototype.invalidate.call(this);
    };
    //---- GETTERS / SETTERS -------------------------------------------------------------------------------------------------------
    p.progress = function(value, suppressEvents) {
        return !arguments.length ? this._time / this.duration() || 0 : this.totalTime(this.duration() * (this._yoyo && (this._cycle & 1) !== 0 ? 1 - value : value) + this._cycle * (this._duration + this._repeatDelay), suppressEvents);
    };
    p.totalProgress = function(value, suppressEvents) {
        return !arguments.length ? this._totalTime / this.totalDuration() || 0 : this.totalTime(this.totalDuration() * value, suppressEvents);
    };
    p.totalDuration = function(value) {
        if (!arguments.length) {
            if (this._dirty) {
                (0, $6ifWP.default).prototype.totalDuration.call(this); //just forces refresh
                //Instead of Infinity, we use 999999999999 so that we can accommodate reverses.
                this._totalDuration = this._repeat === -1 ? 999999999999 : this._duration * (this._repeat + 1) + this._repeatDelay * this._repeat;
            }
            return this._totalDuration;
        }
        return this._repeat === -1 || !value ? this : this.timeScale(this.totalDuration() / value);
    };
    p.time = function(value, suppressEvents) {
        if (!arguments.length) return this._time;
        if (this._dirty) this.totalDuration();
        var duration = this._duration, cycle = this._cycle, cycleDur = cycle * (duration + this._repeatDelay);
        if (value > duration) value = duration;
        return this.totalTime(this._yoyo && cycle & 1 ? duration - value + cycleDur : this._repeat ? value + cycleDur : value, suppressEvents);
    };
    p.repeat = function(value) {
        if (!arguments.length) return this._repeat;
        this._repeat = value;
        return this._uncache(true);
    };
    p.repeatDelay = function(value) {
        if (!arguments.length) return this._repeatDelay;
        this._repeatDelay = value;
        return this._uncache(true);
    };
    p.yoyo = function(value) {
        if (!arguments.length) return this._yoyo;
        this._yoyo = value;
        return this;
    };
    p.currentLabel = function(value) {
        if (!arguments.length) return this.getLabelBefore(this._time + _tinyNum);
        return this.seek(value, true);
    };
    return TimelineMax;
}, true);
var $6bd06b0586a6a5ab$export$100fffa6b25ca05d = (0, $hYzRA.globals).TimelineMax;

});

parcelRequire.register("876af", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e83c24304faee1c$export$7b23975ad686bf91; });
/*!
 * VERSION: 2.1.3
 * DATE: 2019-05-17
 * UPDATES AND DOCS AT: http://greensock.com
 *
 * @license Copyright (c) 2008-2019, GreenSock. All rights reserved.
 * This work is subject to the terms at http://greensock.com/standard-license or for
 * Club GreenSock members, the software agreement that was issued with your membership.
 * 
 * @author: Jack Doyle, jack@greensock.com
 **/ /* eslint-disable */ 
var $hYzRA = parcelRequire("hYzRA");

var $cUYoZ = parcelRequire("cUYoZ");

var $50C1t = parcelRequire("50C1t");

var $uj8kT = parcelRequire("uj8kT");

var $jPhug = parcelRequire("jPhug");

var $dMZ37 = parcelRequire("dMZ37");

var $6ifWP = parcelRequire("6ifWP");

var $9fTje = parcelRequire("9fTje");

var $51K6f = parcelRequire("51K6f");

var $4kabR = parcelRequire("4kabR");
var $5e83c24304faee1c$export$7b23975ad686bf91 = (0, $cUYoZ.default);
$5e83c24304faee1c$export$7b23975ad686bf91._autoActivated = [
    (0, $6ifWP.default),
    (0, $9fTje.default),
    (0, $50C1t.default),
    (0, $uj8kT.default),
    (0, $51K6f.default),
    (0, $jPhug.default),
    (0, $dMZ37.default),
    (0, $4kabR.Back),
    (0, $4kabR.Elastic),
    (0, $4kabR.Bounce),
    (0, $4kabR.RoughEase),
    (0, $4kabR.SlowMo),
    (0, $4kabR.SteppedEase),
    (0, $4kabR.Circ),
    (0, $4kabR.Expo),
    (0, $4kabR.Sine),
    (0, $4kabR.ExpoScaleEase)
];

});
parcelRequire.register("cUYoZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9679919748ea4311$export$7b23975ad686bf91; });
/*!
 * VERSION: 2.1.3
 * DATE: 2019-05-17
 * UPDATES AND DOCS AT: http://greensock.com
 *
 * @license Copyright (c) 2008-2019, GreenSock. All rights reserved.
 * This work is subject to the terms at http://greensock.com/standard-license or for
 * Club GreenSock members, the software agreement that was issued with your membership.
 * 
 * @author: Jack Doyle, jack@greensock.com
 **/ /* eslint-disable */ 
var $hYzRA = parcelRequire("hYzRA");
(0, $hYzRA._gsScope)._gsDefine("TweenMax", [
    "core.Animation",
    "core.SimpleTimeline",
    "TweenLite"
], function() {
    var _slice = function(a) {
        var b = [], l = a.length, i;
        for(i = 0; i !== l; b.push(a[i++]));
        return b;
    }, _applyCycle = function(vars, targets, i) {
        var alt = vars.cycle, p, val;
        for(p in alt){
            val = alt[p];
            vars[p] = typeof val === "function" ? val(i, targets[i], targets) : val[i % val.length];
        }
        delete vars.cycle;
    }, //for distributing values across an array. Can accept a number, a function or (most commonly) a function which can contain the following properties: {base, amount, from, ease, grid, axis, length, each}. Returns a function that expects the following parameters: index, target, array. Recognizes the following
    _distribute = function(v) {
        if (typeof v === "function") return v;
        var vars = typeof v === "object" ? v : {
            each: v
        }, ease = vars.ease, from = vars.from || 0, base = vars.base || 0, cache = {}, isFromKeyword = isNaN(from), axis = vars.axis, ratio = {
            center: 0.5,
            end: 1
        }[from] || 0;
        return function(i, target, a) {
            var l = (a || vars).length, distances = cache[l], originX, originY, x, y, d, j, max, min, wrap;
            if (!distances) {
                wrap = vars.grid === "auto" ? 0 : (vars.grid || [
                    Infinity
                ])[0];
                if (!wrap) {
                    max = -Infinity;
                    while(max < (max = a[wrap++].getBoundingClientRect().left) && wrap < l);
                    wrap--;
                }
                distances = cache[l] = [];
                originX = isFromKeyword ? Math.min(wrap, l) * ratio - 0.5 : from % wrap;
                originY = isFromKeyword ? l * ratio / wrap - 0.5 : from / wrap | 0;
                max = 0;
                min = Infinity;
                for(j = 0; j < l; j++){
                    x = j % wrap - originX;
                    y = originY - (j / wrap | 0);
                    distances[j] = d = !axis ? Math.sqrt(x * x + y * y) : Math.abs(axis === "y" ? y : x);
                    if (d > max) max = d;
                    if (d < min) min = d;
                }
                distances.max = max - min;
                distances.min = min;
                distances.v = l = vars.amount || vars.each * (wrap > l ? l - 1 : !axis ? Math.max(wrap, l / wrap) : axis === "y" ? l / wrap : wrap) || 0;
                distances.b = l < 0 ? base - l : base;
            }
            l = (distances[i] - distances.min) / distances.max;
            return distances.b + (ease ? ease.getRatio(l) : l) * distances.v;
        };
    }, TweenMax = function(target, duration, vars) {
        (0, $hYzRA.default).call(this, target, duration, vars);
        this._cycle = 0;
        this._yoyo = this.vars.yoyo === true || !!this.vars.yoyoEase;
        this._repeat = this.vars.repeat || 0;
        this._repeatDelay = this.vars.repeatDelay || 0;
        if (this._repeat) this._uncache(true); //ensures that if there is any repeat, the totalDuration will get recalculated to accurately report it.
        this.render = TweenMax.prototype.render; //speed optimization (avoid prototype lookup on this "hot" method)
    }, _tinyNum = 0.00000001, TweenLiteInternals = (0, $hYzRA.default)._internals, _isSelector = TweenLiteInternals.isSelector, _isArray = TweenLiteInternals.isArray, p = TweenMax.prototype = (0, $hYzRA.default).to({}, 0.1, {}), _blankArray = [];
    TweenMax.version = "2.1.3";
    p.constructor = TweenMax;
    p.kill()._gc = false;
    TweenMax.killTweensOf = TweenMax.killDelayedCallsTo = (0, $hYzRA.default).killTweensOf;
    TweenMax.getTweensOf = (0, $hYzRA.default).getTweensOf;
    TweenMax.lagSmoothing = (0, $hYzRA.default).lagSmoothing;
    TweenMax.ticker = (0, $hYzRA.default).ticker;
    TweenMax.render = (0, $hYzRA.default).render;
    TweenMax.distribute = _distribute;
    p.invalidate = function() {
        this._yoyo = this.vars.yoyo === true || !!this.vars.yoyoEase;
        this._repeat = this.vars.repeat || 0;
        this._repeatDelay = this.vars.repeatDelay || 0;
        this._yoyoEase = null;
        this._uncache(true);
        return (0, $hYzRA.default).prototype.invalidate.call(this);
    };
    p.updateTo = function(vars, resetDuration) {
        var self = this, curRatio = self.ratio, immediate = self.vars.immediateRender || vars.immediateRender, p;
        if (resetDuration && self._startTime < self._timeline._time) {
            self._startTime = self._timeline._time;
            self._uncache(false);
            if (self._gc) self._enabled(true, false);
            else self._timeline.insert(self, self._startTime - self._delay); //ensures that any necessary re-sequencing of Animations in the timeline occurs to make sure the rendering order is correct.
        }
        for(p in vars)self.vars[p] = vars[p];
        if (self._initted || immediate) {
            if (resetDuration) {
                self._initted = false;
                if (immediate) self.render(0, true, true);
            } else {
                if (self._gc) self._enabled(true, false);
                if (self._notifyPluginsOfEnabled && self._firstPT) (0, $hYzRA.default)._onPluginEvent("_onDisable", self); //in case a plugin like MotionBlur must perform some cleanup tasks
                if (self._time / self._duration > 0.998) {
                    var prevTime = self._totalTime;
                    self.render(0, true, false);
                    self._initted = false;
                    self.render(prevTime, true, false);
                } else {
                    self._initted = false;
                    self._init();
                    if (self._time > 0 || immediate) {
                        var inv = 1 / (1 - curRatio), pt = self._firstPT, endValue;
                        while(pt){
                            endValue = pt.s + pt.c;
                            pt.c *= inv;
                            pt.s = endValue - pt.c;
                            pt = pt._next;
                        }
                    }
                }
            }
        }
        return self;
    };
    p.render = function(time, suppressEvents, force) {
        if (!this._initted) {
            if (this._duration === 0 && this.vars.repeat) this.invalidate();
        }
        var self = this, totalDur = !self._dirty ? self._totalDuration : self.totalDuration(), prevTime = self._time, prevTotalTime = self._totalTime, prevCycle = self._cycle, duration = self._duration, prevRawPrevTime = self._rawPrevTime, isComplete, callback, pt, cycleDuration, r, type, pow, rawPrevTime, yoyoEase;
        if (time >= totalDur - _tinyNum && time >= 0) {
            self._totalTime = totalDur;
            self._cycle = self._repeat;
            if (self._yoyo && (self._cycle & 1) !== 0) {
                self._time = 0;
                self.ratio = self._ease._calcEnd ? self._ease.getRatio(0) : 0;
            } else {
                self._time = duration;
                self.ratio = self._ease._calcEnd ? self._ease.getRatio(1) : 1;
            }
            if (!self._reversed) {
                isComplete = true;
                callback = "onComplete";
                force = force || self._timeline.autoRemoveChildren; //otherwise, if the animation is unpaused/activated after it's already finished, it doesn't get removed from the parent timeline.
            }
            if (duration === 0) {
                if (self._initted || !self.vars.lazy || force) {
                    if (self._startTime === self._timeline._duration) time = 0;
                    if (prevRawPrevTime < 0 || time <= 0 && time >= -_tinyNum || prevRawPrevTime === _tinyNum && self.data !== "isPause") {
                        if (prevRawPrevTime !== time) {
                            force = true;
                            if (prevRawPrevTime > _tinyNum) callback = "onReverseComplete";
                        }
                    }
                    self._rawPrevTime = rawPrevTime = !suppressEvents || time || prevRawPrevTime === time ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
                }
            }
        } else if (time < _tinyNum) {
            self._totalTime = self._time = self._cycle = 0;
            self.ratio = self._ease._calcEnd ? self._ease.getRatio(0) : 0;
            if (prevTotalTime !== 0 || duration === 0 && prevRawPrevTime > 0) {
                callback = "onReverseComplete";
                isComplete = self._reversed;
            }
            if (time > -_tinyNum) time = 0;
            else if (time < 0) {
                self._active = false;
                if (duration === 0) {
                    if (self._initted || !self.vars.lazy || force) {
                        if (prevRawPrevTime >= 0) force = true;
                        self._rawPrevTime = rawPrevTime = !suppressEvents || time || prevRawPrevTime === time ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
                    }
                }
            }
            if (!self._initted) force = true;
        } else {
            self._totalTime = self._time = time;
            if (self._repeat !== 0) {
                cycleDuration = duration + self._repeatDelay;
                self._cycle = self._totalTime / cycleDuration >> 0; //originally _totalTime % cycleDuration but floating point errors caused problems, so I normalized it. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (self._cycle !== 0) {
                    if (self._cycle === self._totalTime / cycleDuration && prevTotalTime <= time) self._cycle--; //otherwise when rendered exactly at the end time, it will act as though it is repeating (at the beginning)
                }
                self._time = self._totalTime - self._cycle * cycleDuration;
                if (self._yoyo) {
                    if ((self._cycle & 1) !== 0) {
                        self._time = duration - self._time;
                        yoyoEase = self._yoyoEase || self.vars.yoyoEase; //note: we don't set this._yoyoEase in _init() like we do other properties because it's TweenMax-specific and doing it here allows us to optimize performance (most tweens don't have a yoyoEase). Note that we also must skip the this.ratio calculation further down right after we _init() in this function, because we're doing it here.
                        if (yoyoEase) {
                            if (!self._yoyoEase) {
                                if (yoyoEase === true && !self._initted) {
                                    yoyoEase = self.vars.ease;
                                    self._yoyoEase = yoyoEase = !yoyoEase ? (0, $hYzRA.default).defaultEase : yoyoEase instanceof (0, $hYzRA.Ease) ? yoyoEase : typeof yoyoEase === "function" ? new (0, $hYzRA.Ease)(yoyoEase, self.vars.easeParams) : (0, $hYzRA.Ease).map[yoyoEase] || (0, $hYzRA.default).defaultEase;
                                } else self._yoyoEase = yoyoEase = yoyoEase === true ? self._ease : yoyoEase instanceof (0, $hYzRA.Ease) ? yoyoEase : (0, $hYzRA.Ease).map[yoyoEase];
                            }
                            self.ratio = yoyoEase ? 1 - yoyoEase.getRatio((duration - self._time) / duration) : 0;
                        }
                    }
                }
                if (self._time > duration) self._time = duration;
                else if (self._time < 0) self._time = 0;
            }
            if (self._easeType && !yoyoEase) {
                r = self._time / duration;
                type = self._easeType;
                pow = self._easePower;
                if (type === 1 || type === 3 && r >= 0.5) r = 1 - r;
                if (type === 3) r *= 2;
                if (pow === 1) r *= r;
                else if (pow === 2) r *= r * r;
                else if (pow === 3) r *= r * r * r;
                else if (pow === 4) r *= r * r * r * r;
                self.ratio = type === 1 ? 1 - r : type === 2 ? r : self._time / duration < 0.5 ? r / 2 : 1 - r / 2;
            } else if (!yoyoEase) self.ratio = self._ease.getRatio(self._time / duration);
        }
        if (prevTime === self._time && !force && prevCycle === self._cycle) {
            if (prevTotalTime !== self._totalTime) {
                if (self._onUpdate) {
                    if (!suppressEvents) self._callback("onUpdate");
                }
            }
            return;
        } else if (!self._initted) {
            self._init();
            if (!self._initted || self._gc) return;
            else if (!force && self._firstPT && (self.vars.lazy !== false && self._duration || self.vars.lazy && !self._duration)) {
                self._time = prevTime;
                self._totalTime = prevTotalTime;
                self._rawPrevTime = prevRawPrevTime;
                self._cycle = prevCycle;
                TweenLiteInternals.lazyTweens.push(self);
                self._lazy = [
                    time,
                    suppressEvents
                ];
                return;
            }
            //_ease is initially set to defaultEase, so now that init() has run, _ease is set properly and we need to recalculate the ratio. Overall this is faster than using conditional logic earlier in the method to avoid having to set ratio twice because we only init() once but renderTime() gets called VERY frequently.
            if (self._time && !isComplete && !yoyoEase) self.ratio = self._ease.getRatio(self._time / duration);
            else if (isComplete && this._ease._calcEnd && !yoyoEase) self.ratio = self._ease.getRatio(self._time === 0 ? 0 : 1);
        }
        if (self._lazy !== false) self._lazy = false;
        if (!self._active) {
            if (!self._paused && self._time !== prevTime && time >= 0) self._active = true; //so that if the user renders a tween (as opposed to the timeline rendering it), the timeline is forced to re-render and align it with the proper time/frame on the next rendering cycle. Maybe the tween already finished but the user manually re-renders it as halfway done.
        }
        if (prevTotalTime === 0) {
            if (self._initted === 2 && time > 0) self._init(); //will just apply overwriting since _initted of (2) means it was a from() tween that had immediateRender:true
            if (self._startAt) {
                if (time >= 0) self._startAt.render(time, true, force);
                else if (!callback) callback = "_dummyGS"; //if no callback is defined, use a dummy value just so that the condition at the end evaluates as true because _startAt should render AFTER the normal render loop when the time is negative. We could handle this in a more intuitive way, of course, but the render loop is the MOST important thing to optimize, so this technique allows us to avoid adding extra conditional logic in a high-frequency area.
            }
            if (self.vars.onStart) {
                if (self._totalTime !== 0 || duration === 0) {
                    if (!suppressEvents) self._callback("onStart");
                }
            }
        }
        pt = self._firstPT;
        while(pt){
            if (pt.f) pt.t[pt.p](pt.c * self.ratio + pt.s);
            else pt.t[pt.p] = pt.c * self.ratio + pt.s;
            pt = pt._next;
        }
        if (self._onUpdate) {
            if (time < 0) {
                if (self._startAt && self._startTime) self._startAt.render(time, true, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
            }
            if (!suppressEvents) {
                if (self._totalTime !== prevTotalTime || callback) self._callback("onUpdate");
            }
        }
        if (self._cycle !== prevCycle) {
            if (!suppressEvents) {
                if (!self._gc) {
                    if (self.vars.onRepeat) self._callback("onRepeat");
                }
            }
        }
        if (callback) {
            if (!self._gc || force) {
                if (time < 0 && self._startAt && !self._onUpdate && self._startTime) self._startAt.render(time, true, force);
                if (isComplete) {
                    if (self._timeline.autoRemoveChildren) self._enabled(false, false);
                    self._active = false;
                }
                if (!suppressEvents && self.vars[callback]) self._callback(callback);
                if (duration === 0 && self._rawPrevTime === _tinyNum && rawPrevTime !== _tinyNum) self._rawPrevTime = 0;
            }
        }
    };
    //---- STATIC FUNCTIONS -----------------------------------------------------------------------------------------------------------
    TweenMax.to = function(target, duration, vars) {
        return new TweenMax(target, duration, vars);
    };
    TweenMax.from = function(target, duration, vars) {
        vars.runBackwards = true;
        vars.immediateRender = vars.immediateRender != false;
        return new TweenMax(target, duration, vars);
    };
    TweenMax.fromTo = function(target, duration, fromVars, toVars) {
        toVars.startAt = fromVars;
        toVars.immediateRender = toVars.immediateRender != false && fromVars.immediateRender != false;
        return new TweenMax(target, duration, toVars);
    };
    TweenMax.staggerTo = TweenMax.allTo = function(targets, duration, vars, stagger, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
        var a = [], staggerFunc = _distribute(vars.stagger || stagger), cycle = vars.cycle, fromCycle = (vars.startAt || _blankArray).cycle, l, copy, i, p;
        if (!_isArray(targets)) {
            if (typeof targets === "string") targets = (0, $hYzRA.default).selector(targets) || targets;
            if (_isSelector(targets)) targets = _slice(targets);
        }
        targets = targets || [];
        l = targets.length - 1;
        for(i = 0; i <= l; i++){
            copy = {};
            for(p in vars)copy[p] = vars[p];
            if (cycle) {
                _applyCycle(copy, targets, i);
                if (copy.duration != null) {
                    duration = copy.duration;
                    delete copy.duration;
                }
            }
            if (fromCycle) {
                fromCycle = copy.startAt = {};
                for(p in vars.startAt)fromCycle[p] = vars.startAt[p];
                _applyCycle(copy.startAt, targets, i);
            }
            copy.delay = staggerFunc(i, targets[i], targets) + (copy.delay || 0);
            if (i === l && onCompleteAll) copy.onComplete = function() {
                if (vars.onComplete) vars.onComplete.apply(vars.onCompleteScope || this, arguments);
                onCompleteAll.apply(onCompleteAllScope || vars.callbackScope || this, onCompleteAllParams || _blankArray);
            };
            a[i] = new TweenMax(targets[i], duration, copy);
        }
        return a;
    };
    TweenMax.staggerFrom = TweenMax.allFrom = function(targets, duration, vars, stagger, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
        vars.runBackwards = true;
        vars.immediateRender = vars.immediateRender != false;
        return TweenMax.staggerTo(targets, duration, vars, stagger, onCompleteAll, onCompleteAllParams, onCompleteAllScope);
    };
    TweenMax.staggerFromTo = TweenMax.allFromTo = function(targets, duration, fromVars, toVars, stagger, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
        toVars.startAt = fromVars;
        toVars.immediateRender = toVars.immediateRender != false && fromVars.immediateRender != false;
        return TweenMax.staggerTo(targets, duration, toVars, stagger, onCompleteAll, onCompleteAllParams, onCompleteAllScope);
    };
    TweenMax.delayedCall = function(delay, callback, params, scope, useFrames) {
        return new TweenMax(callback, 0, {
            delay: delay,
            onComplete: callback,
            onCompleteParams: params,
            callbackScope: scope,
            onReverseComplete: callback,
            onReverseCompleteParams: params,
            immediateRender: false,
            useFrames: useFrames,
            overwrite: 0
        });
    };
    TweenMax.set = function(target, vars) {
        return new TweenMax(target, 0, vars);
    };
    TweenMax.isTweening = function(target) {
        return (0, $hYzRA.default).getTweensOf(target, true).length > 0;
    };
    var _getChildrenOf = function(timeline, includeTimelines) {
        var a = [], cnt = 0, tween = timeline._first;
        while(tween){
            if (tween instanceof (0, $hYzRA.default)) a[cnt++] = tween;
            else {
                if (includeTimelines) a[cnt++] = tween;
                a = a.concat(_getChildrenOf(tween, includeTimelines));
                cnt = a.length;
            }
            tween = tween._next;
        }
        return a;
    }, getAllTweens = TweenMax.getAllTweens = function(includeTimelines) {
        return _getChildrenOf((0, $hYzRA.Animation)._rootTimeline, includeTimelines).concat(_getChildrenOf((0, $hYzRA.Animation)._rootFramesTimeline, includeTimelines));
    };
    TweenMax.killAll = function(complete, tweens, delayedCalls, timelines) {
        if (tweens == null) tweens = true;
        if (delayedCalls == null) delayedCalls = true;
        var a = getAllTweens(timelines != false), l = a.length, allTrue = tweens && delayedCalls && timelines, isDC, tween, i;
        for(i = 0; i < l; i++){
            tween = a[i];
            if (allTrue || tween instanceof (0, $hYzRA.SimpleTimeline) || (isDC = tween.target === tween.vars.onComplete) && delayedCalls || tweens && !isDC) {
                if (complete) tween.totalTime(tween._reversed ? 0 : tween.totalDuration());
                else tween._enabled(false, false);
            }
        }
    };
    TweenMax.killChildTweensOf = function(parent, complete) {
        if (parent == null) return;
        var tl = TweenLiteInternals.tweenLookup, a, curParent, p, i, l;
        if (typeof parent === "string") parent = (0, $hYzRA.default).selector(parent) || parent;
        if (_isSelector(parent)) parent = _slice(parent);
        if (_isArray(parent)) {
            i = parent.length;
            while(--i > -1)TweenMax.killChildTweensOf(parent[i], complete);
            return;
        }
        a = [];
        for(p in tl){
            curParent = tl[p].target.parentNode;
            while(curParent){
                if (curParent === parent) a = a.concat(tl[p].tweens);
                curParent = curParent.parentNode;
            }
        }
        l = a.length;
        for(i = 0; i < l; i++){
            if (complete) a[i].totalTime(a[i].totalDuration());
            a[i]._enabled(false, false);
        }
    };
    var _changePause = function(pause, tweens, delayedCalls, timelines) {
        tweens = tweens !== false;
        delayedCalls = delayedCalls !== false;
        timelines = timelines !== false;
        var a = getAllTweens(timelines), allTrue = tweens && delayedCalls && timelines, i = a.length, isDC, tween;
        while(--i > -1){
            tween = a[i];
            if (allTrue || tween instanceof (0, $hYzRA.SimpleTimeline) || (isDC = tween.target === tween.vars.onComplete) && delayedCalls || tweens && !isDC) tween.paused(pause);
        }
    };
    TweenMax.pauseAll = function(tweens, delayedCalls, timelines) {
        _changePause(true, tweens, delayedCalls, timelines);
    };
    TweenMax.resumeAll = function(tweens, delayedCalls, timelines) {
        _changePause(false, tweens, delayedCalls, timelines);
    };
    TweenMax.globalTimeScale = function(value) {
        var tl = (0, $hYzRA.Animation)._rootTimeline, t = (0, $hYzRA.default).ticker.time;
        if (!arguments.length) return tl._timeScale;
        value = value || _tinyNum; //can't allow zero because it'll throw the math off
        tl._startTime = t - (t - tl._startTime) * tl._timeScale / value;
        tl = (0, $hYzRA.Animation)._rootFramesTimeline;
        t = (0, $hYzRA.default).ticker.frame;
        tl._startTime = t - (t - tl._startTime) * tl._timeScale / value;
        tl._timeScale = (0, $hYzRA.Animation)._rootTimeline._timeScale = value;
        return value;
    };
    //---- GETTERS / SETTERS ----------------------------------------------------------------------------------------------------------
    p.progress = function(value, suppressEvents) {
        return !arguments.length ? this.duration() ? this._time / this._duration : this.ratio : this.totalTime(this.duration() * (this._yoyo && (this._cycle & 1) !== 0 ? 1 - value : value) + this._cycle * (this._duration + this._repeatDelay), suppressEvents);
    };
    p.totalProgress = function(value, suppressEvents) {
        return !arguments.length ? this._totalTime / this.totalDuration() : this.totalTime(this.totalDuration() * value, suppressEvents);
    };
    p.time = function(value, suppressEvents) {
        if (!arguments.length) return this._time;
        if (this._dirty) this.totalDuration();
        var duration = this._duration, cycle = this._cycle, cycleDur = cycle * (duration + this._repeatDelay);
        if (value > duration) value = duration;
        return this.totalTime(this._yoyo && cycle & 1 ? duration - value + cycleDur : this._repeat ? value + cycleDur : value, suppressEvents);
    };
    p.duration = function(value) {
        if (!arguments.length) return this._duration; //don't set _dirty = false because there could be repeats that haven't been factored into the _totalDuration yet. Otherwise, if you create a repeated TweenMax and then immediately check its duration(), it would cache the value and the totalDuration would not be correct, thus repeats wouldn't take effect.
        return (0, $hYzRA.Animation).prototype.duration.call(this, value);
    };
    p.totalDuration = function(value) {
        if (!arguments.length) {
            if (this._dirty) {
                //instead of Infinity, we use 999999999999 so that we can accommodate reverses
                this._totalDuration = this._repeat === -1 ? 999999999999 : this._duration * (this._repeat + 1) + this._repeatDelay * this._repeat;
                this._dirty = false;
            }
            return this._totalDuration;
        }
        return this._repeat === -1 ? this : this.duration((value - this._repeat * this._repeatDelay) / (this._repeat + 1));
    };
    p.repeat = function(value) {
        if (!arguments.length) return this._repeat;
        this._repeat = value;
        return this._uncache(true);
    };
    p.repeatDelay = function(value) {
        if (!arguments.length) return this._repeatDelay;
        this._repeatDelay = value;
        return this._uncache(true);
    };
    p.yoyo = function(value) {
        if (!arguments.length) return this._yoyo;
        this._yoyo = value;
        return this;
    };
    return TweenMax;
}, true);
var $9679919748ea4311$export$7b23975ad686bf91 = (0, $hYzRA.globals).TweenMax;
var $9679919748ea4311$export$27635e50bfb83ed5 = $9679919748ea4311$export$7b23975ad686bf91;

});

parcelRequire.register("50C1t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a5a725fd2fa0609$export$855822f522f18eef; });
/*!
 * VERSION: 2.1.3
 * DATE: 2019-05-17
 * UPDATES AND DOCS AT: http://greensock.com
 *
 * @license Copyright (c) 2008-2019, GreenSock. All rights reserved.
 * This work is subject to the terms at http://greensock.com/standard-license or for
 * Club GreenSock members, the software agreement that was issued with your membership.
 * 
 * @author: Jack Doyle, jack@greensock.com
 */ /* eslint-disable */ 
var $hYzRA = parcelRequire("hYzRA");
(0, $hYzRA._gsScope)._gsDefine("plugins.CSSPlugin", [
    "plugins.TweenPlugin",
    "TweenLite"
], function() {
    /** @constructor **/ var CSSPlugin = function() {
        (0, $hYzRA.TweenPlugin).call(this, "css");
        this._overwriteProps.length = 0;
        this.setRatio = CSSPlugin.prototype.setRatio; //speed optimization (avoid prototype lookup on this "hot" method)
    }, _globals = (0, $hYzRA._gsScope)._gsDefine.globals, _hasPriority, _suffixMap, _cs, _overwriteProps, _specialProps = {}, p = CSSPlugin.prototype = new (0, $hYzRA.TweenPlugin)("css");
    p.constructor = CSSPlugin;
    CSSPlugin.version = "2.1.3";
    CSSPlugin.API = 2;
    CSSPlugin.defaultTransformPerspective = 0;
    CSSPlugin.defaultSkewType = "compensated";
    CSSPlugin.defaultSmoothOrigin = true;
    p = "px"; //we'll reuse the "p" variable to keep file size down
    CSSPlugin.suffixMap = {
        top: p,
        right: p,
        bottom: p,
        left: p,
        width: p,
        height: p,
        fontSize: p,
        padding: p,
        margin: p,
        perspective: p,
        lineHeight: ""
    };
    var _numExp = /(?:\-|\.|\b)(\d|\.|e\-)+/g, _relNumExp = /(?:\d|\-\d|\.\d|\-\.\d|\+=\d|\-=\d|\+=.\d|\-=\.\d)+/g, _valuesExp = /(?:\+=|\-=|\-|\b)[\d\-\.]+[a-zA-Z0-9]*(?:%|\b)/gi, _valuesExpWithCommas = /(?:\+=|\-=|\-|\b)[\d\-\.]+[a-zA-Z0-9]*(?:%|\b),?/gi, _NaNExp = /(?![+-]?\d*\.?\d+|[+-]|e[+-]\d+)[^0-9]/g, _suffixExp = /(?:\d|\-|\+|=|#|\.)*/g, _opacityExp = /opacity *= *([^)]*)/i, _opacityValExp = /opacity:([^;]*)/i, _alphaFilterExp = /alpha\(opacity *=.+?\)/i, _rgbhslExp = /^(rgb|hsl)/, _capsExp = /([A-Z])/g, _camelExp = /-([a-z])/gi, _urlExp = /(^(?:url\(\"|url\())|(?:(\"\))$|\)$)/gi, _camelFunc = function(s, g) {
        return g.toUpperCase();
    }, _horizExp = /(?:Left|Right|Width)/i, _ieGetMatrixExp = /(M11|M12|M21|M22)=[\d\-\.e]+/gi, _ieSetMatrixExp = /progid\:DXImageTransform\.Microsoft\.Matrix\(.+?\)/i, _commasOutsideParenExp = /,(?=[^\)]*(?:\(|$))/gi, _complexExp = /[\s,\(]/i, _DEG2RAD = Math.PI / 180, _RAD2DEG = 180 / Math.PI, _forcePT = {}, _dummyElement = {
        style: {}
    }, _doc = (0, $hYzRA._gsScope).document || {
        createElement: function() {
            return _dummyElement;
        }
    }, _createElement = function(type, ns) {
        var e = _doc.createElementNS ? _doc.createElementNS(ns || "http://www.w3.org/1999/xhtml", type) : _doc.createElement(type);
        return e.style ? e : _doc.createElement(type); //some environments won't allow access to the element's style when created with a namespace in which case we default to the standard createElement() to work around the issue. Also note that when GSAP is embedded directly inside an SVG file, createElement() won't allow access to the style object in Firefox (see https://greensock.com/forums/topic/20215-problem-using-tweenmax-in-standalone-self-containing-svg-file-err-cannot-set-property-csstext-of-undefined/).
    }, _tempDiv = _createElement("div"), _tempImg = _createElement("img"), _internals = CSSPlugin._internals = {
        _specialProps: _specialProps
    }, _agent = ((0, $hYzRA._gsScope).navigator || {}).userAgent || "", _autoRound, _reqSafariFix, _isSafari, _isFirefox, _isSafariLT6, _ieVers, _supportsOpacity = function() {
        var i = _agent.indexOf("Android"), a = _createElement("a");
        _isSafari = _agent.indexOf("Safari") !== -1 && _agent.indexOf("Chrome") === -1 && (i === -1 || parseFloat(_agent.substr(i + 8, 2)) > 3);
        _isSafariLT6 = _isSafari && parseFloat(_agent.substr(_agent.indexOf("Version/") + 8, 2)) < 6;
        _isFirefox = _agent.indexOf("Firefox") !== -1;
        if (/MSIE ([0-9]{1,}[\.0-9]{0,})/.exec(_agent) || /Trident\/.*rv:([0-9]{1,}[\.0-9]{0,})/.exec(_agent)) _ieVers = parseFloat(RegExp.$1);
        if (!a) return false;
        a.style.cssText = "top:1px;opacity:.55;";
        return /^0.55/.test(a.style.opacity);
    }(), _getIEOpacity = function(v) {
        return _opacityExp.test(typeof v === "string" ? v : (v.currentStyle ? v.currentStyle.filter : v.style.filter) || "") ? parseFloat(RegExp.$1) / 100 : 1;
    }, _log = function(s) {
        if ((0, $hYzRA._gsScope).console) console.log(s);
    }, _target, _index, _prefixCSS = "", _prefix = "", // @private feed in a camelCase property name like "transform" and it will check to see if it is valid as-is or if it needs a vendor prefix. It returns the corrected camelCase property name (i.e. "WebkitTransform" or "MozTransform" or "transform" or null if no such property is found, like if the browser is IE8 or before, "transform" won't be found at all)
    _checkPropPrefix = function(p, e) {
        e = e || _tempDiv;
        var s = e.style, a, i;
        if (s[p] !== undefined) return p;
        p = p.charAt(0).toUpperCase() + p.substr(1);
        a = [
            "O",
            "Moz",
            "ms",
            "Ms",
            "Webkit"
        ];
        i = 5;
        while(--i > -1 && s[a[i] + p] === undefined);
        if (i >= 0) {
            _prefix = i === 3 ? "ms" : a[i];
            _prefixCSS = "-" + _prefix.toLowerCase() + "-";
            return _prefix + p;
        }
        return null;
    }, _computedStyleScope = typeof window !== "undefined" ? window : _doc.defaultView || {
        getComputedStyle: function() {}
    }, _getComputedStyle = function(e) {
        return _computedStyleScope.getComputedStyle(e); //to avoid errors in Microsoft Edge, we need to call getComputedStyle() from a specific scope, typically window.
    }, /**
			 * @private Returns the css style for a particular property of an element. For example, to get whatever the current "left" css value for an element with an ID of "myElement", you could do:
			 * var currentLeft = CSSPlugin.getStyle( document.getElementById("myElement"), "left");
			 *
			 * @param {!Object} t Target element whose style property you want to query
			 * @param {!string} p Property name (like "left" or "top" or "marginTop", etc.)
			 * @param {Object=} cs Computed style object. This just provides a way to speed processing if you're going to get several properties on the same element in quick succession - you can reuse the result of the getComputedStyle() call.
			 * @param {boolean=} calc If true, the value will not be read directly from the element's "style" property (if it exists there), but instead the getComputedStyle() result will be used. This can be useful when you want to ensure that the browser itself is interpreting the value.
			 * @param {string=} dflt Default value that should be returned in the place of null, "none", "auto" or "auto auto".
			 * @return {?string} The current property value
			 */ _getStyle = CSSPlugin.getStyle = function(t, p, cs, calc, dflt) {
        var rv;
        if (!_supportsOpacity) {
            if (p === "opacity") return _getIEOpacity(t);
        }
        if (!calc && t.style[p]) rv = t.style[p];
        else if (cs = cs || _getComputedStyle(t)) rv = cs[p] || cs.getPropertyValue(p) || cs.getPropertyValue(p.replace(_capsExp, "-$1").toLowerCase());
        else if (t.currentStyle) rv = t.currentStyle[p];
        return dflt != null && (!rv || rv === "none" || rv === "auto" || rv === "auto auto") ? dflt : rv;
    }, /**
			 * @private Pass the target element, the property name, the numeric value, and the suffix (like "%", "em", "px", etc.) and it will spit back the equivalent pixel number.
			 * @param {!Object} t Target element
			 * @param {!string} p Property name (like "left", "top", "marginLeft", etc.)
			 * @param {!number} v Value
			 * @param {string=} sfx Suffix (like "px" or "%" or "em")
			 * @param {boolean=} recurse If true, the call is a recursive one. In some browsers (like IE7/8), occasionally the value isn't accurately reported initially, but if we run the function again it will take effect.
			 * @return {number} value in pixels
			 */ _convertToPixels = _internals.convertToPixels = function(t, p, v, sfx, recurse) {
        if (sfx === "px" || !sfx && p !== "lineHeight") return v;
        if (sfx === "auto" || !v) return 0;
        var horiz = _horizExp.test(p), node = t, style = _tempDiv.style, neg = v < 0, precise = v === 1, pix, cache, time;
        if (neg) v = -v;
        if (precise) v *= 100;
        if (p === "lineHeight" && !sfx) {
            cache = _getComputedStyle(t).lineHeight;
            t.style.lineHeight = v;
            pix = parseFloat(_getComputedStyle(t).lineHeight);
            t.style.lineHeight = cache;
        } else if (sfx === "%" && p.indexOf("border") !== -1) pix = v / 100 * (horiz ? t.clientWidth : t.clientHeight);
        else {
            style.cssText = "border:0 solid red;position:" + _getStyle(t, "position") + ";line-height:0;";
            if (sfx === "%" || !node.appendChild || sfx.charAt(0) === "v" || sfx === "rem") {
                node = t.parentNode || _doc.body;
                if (_getStyle(node, "display").indexOf("flex") !== -1) style.position = "absolute";
                cache = node._gsCache;
                time = (0, $hYzRA.default).ticker.frame;
                if (cache && horiz && cache.time === time) return cache.width * v / 100;
                style[horiz ? "width" : "height"] = v + sfx;
            } else style[horiz ? "borderLeftWidth" : "borderTopWidth"] = v + sfx;
            node.appendChild(_tempDiv);
            pix = parseFloat(_tempDiv[horiz ? "offsetWidth" : "offsetHeight"]);
            node.removeChild(_tempDiv);
            if (horiz && sfx === "%" && CSSPlugin.cacheWidths !== false) {
                cache = node._gsCache = node._gsCache || {};
                cache.time = time;
                cache.width = pix / v * 100;
            }
            if (pix === 0 && !recurse) pix = _convertToPixels(t, p, v, sfx, true);
        }
        if (precise) pix /= 100;
        return neg ? -pix : pix;
    }, _calculateOffset = _internals.calculateOffset = function(t, p, cs) {
        if (_getStyle(t, "position", cs) !== "absolute") return 0;
        var dim = p === "left" ? "Left" : "Top", v = _getStyle(t, "margin" + dim, cs);
        return t["offset" + dim] - (_convertToPixels(t, p, parseFloat(v), v.replace(_suffixExp, "")) || 0);
    }, // @private returns at object containing ALL of the style properties in camelCase and their associated values.
    _getAllStyles = function(t, cs) {
        var s = {}, i, tr, p;
        if (cs = cs || _getComputedStyle(t, null)) {
            if (i = cs.length) while(--i > -1){
                p = cs[i];
                if (p.indexOf("-transform") === -1 || _transformPropCSS === p) s[p.replace(_camelExp, _camelFunc)] = cs.getPropertyValue(p);
            }
            else {
                for(i in cs)if (i.indexOf("Transform") === -1 || _transformProp === i) s[i] = cs[i];
            }
        } else if (cs = t.currentStyle || t.style) {
            for(i in cs)if (typeof i === "string" && s[i] === undefined) s[i.replace(_camelExp, _camelFunc)] = cs[i];
        }
        if (!_supportsOpacity) s.opacity = _getIEOpacity(t);
        tr = _getTransform(t, cs, false);
        s.rotation = tr.rotation;
        s.skewX = tr.skewX;
        s.scaleX = tr.scaleX;
        s.scaleY = tr.scaleY;
        s.x = tr.x;
        s.y = tr.y;
        if (_supports3D) {
            s.z = tr.z;
            s.rotationX = tr.rotationX;
            s.rotationY = tr.rotationY;
            s.scaleZ = tr.scaleZ;
        }
        if (s.filters) delete s.filters;
        return s;
    }, // @private analyzes two style objects (as returned by _getAllStyles()) and only looks for differences between them that contain tweenable values (like a number or color). It returns an object with a "difs" property which refers to an object containing only those isolated properties and values for tweening, and a "firstMPT" property which refers to the first MiniPropTween instance in a linked list that recorded all the starting values of the different properties so that we can revert to them at the end or beginning of the tween - we don't want the cascading to get messed up. The forceLookup parameter is an optional generic object with properties that should be forced into the results - this is necessary for className tweens that are overwriting others because imagine a scenario where a rollover/rollout adds/removes a class and the user swipes the mouse over the target SUPER fast, thus nothing actually changed yet and the subsequent comparison of the properties would indicate they match (especially when px rounding is taken into consideration), thus no tweening is necessary even though it SHOULD tween and remove those properties after the tween (otherwise the inline styles will contaminate things). See the className SpecialProp code for details.
    _cssDif = function(t, s1, s2, vars, forceLookup) {
        var difs = {}, style = t.style, val, p, mpt;
        for(p in s2){
            if (p !== "cssText") {
                if (p !== "length") {
                    if (isNaN(p)) {
                        if (s1[p] !== (val = s2[p]) || forceLookup && forceLookup[p]) {
                            if (p.indexOf("Origin") === -1) {
                                if (typeof val === "number" || typeof val === "string") {
                                    difs[p] = val === "auto" && (p === "left" || p === "top") ? _calculateOffset(t, p) : (val === "" || val === "auto" || val === "none") && typeof s1[p] === "string" && s1[p].replace(_NaNExp, "") !== "" ? 0 : val; //if the ending value is defaulting ("" or "auto"), we check the starting value and if it can be parsed into a number (a string which could have a suffix too, like 700px), then we swap in 0 for "" or "auto" so that things actually tween.
                                    if (style[p] !== undefined) mpt = new MiniPropTween(style, p, style[p], mpt);
                                }
                            }
                        }
                    }
                }
            }
        }
        if (vars) {
            for(p in vars)if (p !== "className") difs[p] = vars[p];
        }
        return {
            difs: difs,
            firstMPT: mpt
        };
    }, _dimensions = {
        width: [
            "Left",
            "Right"
        ],
        height: [
            "Top",
            "Bottom"
        ]
    }, _margins = [
        "marginLeft",
        "marginRight",
        "marginTop",
        "marginBottom"
    ], /**
			 * @private Gets the width or height of an element
			 * @param {!Object} t Target element
			 * @param {!string} p Property name ("width" or "height")
			 * @param {Object=} cs Computed style object (if one exists). Just a speed optimization.
			 * @return {number} Dimension (in pixels)
			 */ _getDimension = function(t, p, cs) {
        if ((t.nodeName + "").toLowerCase() === "svg") return (cs || _getComputedStyle(t))[p] || 0;
        else if (t.getCTM && _isSVG(t)) return t.getBBox()[p] || 0;
        var v = parseFloat(p === "width" ? t.offsetWidth : t.offsetHeight), a = _dimensions[p], i = a.length;
        cs = cs || _getComputedStyle(t, null);
        while(--i > -1){
            v -= parseFloat(_getStyle(t, "padding" + a[i], cs, true)) || 0;
            v -= parseFloat(_getStyle(t, "border" + a[i] + "Width", cs, true)) || 0;
        }
        return v;
    }, // @private Parses position-related complex strings like "top left" or "50px 10px" or "70% 20%", etc. which are used for things like transformOrigin or backgroundPosition. Optionally decorates a supplied object (recObj) with the following properties: "ox" (offsetX), "oy" (offsetY), "oxp" (if true, "ox" is a percentage not a pixel value), and "oxy" (if true, "oy" is a percentage not a pixel value)
    _parsePosition = function(v, recObj) {
        if (v === "contain" || v === "auto" || v === "auto auto") return v + " ";
        if (v == null || v === "") v = "0 0";
        var a = v.split(" "), x = v.indexOf("left") !== -1 ? "0%" : v.indexOf("right") !== -1 ? "100%" : a[0], y = v.indexOf("top") !== -1 ? "0%" : v.indexOf("bottom") !== -1 ? "100%" : a[1], i;
        if (a.length > 3 && !recObj) {
            a = v.split(", ").join(",").split(",");
            v = [];
            for(i = 0; i < a.length; i++)v.push(_parsePosition(a[i]));
            return v.join(",");
        }
        if (y == null) y = x === "center" ? "50%" : "0";
        else if (y === "center") y = "50%";
        if (x === "center" || isNaN(parseFloat(x)) && (x + "").indexOf("=") === -1) x = "50%";
        v = x + " " + y + (a.length > 2 ? " " + a[2] : "");
        if (recObj) {
            recObj.oxp = x.indexOf("%") !== -1;
            recObj.oyp = y.indexOf("%") !== -1;
            recObj.oxr = x.charAt(1) === "=";
            recObj.oyr = y.charAt(1) === "=";
            recObj.ox = parseFloat(x.replace(_NaNExp, ""));
            recObj.oy = parseFloat(y.replace(_NaNExp, ""));
            recObj.v = v;
        }
        return recObj || v;
    }, /**
			 * @private Takes an ending value (typically a string, but can be a number) and a starting value and returns the change between the two, looking for relative value indicators like += and -= and it also ignores suffixes (but make sure the ending value starts with a number or +=/-= and that the starting value is a NUMBER!)
			 * @param {(number|string)} e End value which is typically a string, but could be a number
			 * @param {(number|string)} b Beginning value which is typically a string but could be a number
			 * @return {number} Amount of change between the beginning and ending values (relative values that have a "+=" or "-=" are recognized)
			 */ _parseChange = function(e, b) {
        if (typeof e === "function") e = e(_index, _target);
        return typeof e === "string" && e.charAt(1) === "=" ? parseInt(e.charAt(0) + "1", 10) * parseFloat(e.substr(2)) : parseFloat(e) - parseFloat(b) || 0;
    }, /**
			 * @private Takes a value and a default number, checks if the value is relative, null, or numeric and spits back a normalized number accordingly. Primarily used in the _parseTransform() function.
			 * @param {Object} v Value to be parsed
			 * @param {!number} d Default value (which is also used for relative calculations if "+=" or "-=" is found in the first parameter)
			 * @return {number} Parsed value
			 */ _parseVal = function(v, d) {
        if (typeof v === "function") v = v(_index, _target);
        var isRelative = typeof v === "string" && v.charAt(1) === "=";
        if (typeof v === "string" && v.charAt(v.length - 2) === "v") v = (isRelative ? v.substr(0, 2) : 0) + window["inner" + (v.substr(-2) === "vh" ? "Height" : "Width")] * (parseFloat(isRelative ? v.substr(2) : v) / 100);
        return v == null ? d : isRelative ? parseInt(v.charAt(0) + "1", 10) * parseFloat(v.substr(2)) + d : parseFloat(v) || 0;
    }, /**
			 * @private Translates strings like "40deg" or "40" or 40rad" or "+=40deg" or "270_short" or "-90_cw" or "+=45_ccw" to a numeric radian angle. Of course a starting/default value must be fed in too so that relative values can be calculated properly.
			 * @param {Object} v Value to be parsed
			 * @param {!number} d Default value (which is also used for relative calculations if "+=" or "-=" is found in the first parameter)
			 * @param {string=} p property name for directionalEnd (optional - only used when the parsed value is directional ("_short", "_cw", or "_ccw" suffix). We need a way to store the uncompensated value so that at the end of the tween, we set it to exactly what was requested with no directional compensation). Property name would be "rotation", "rotationX", or "rotationY"
			 * @param {Object=} directionalEnd An object that will store the raw end values for directional angles ("_short", "_cw", or "_ccw" suffix). We need a way to store the uncompensated value so that at the end of the tween, we set it to exactly what was requested with no directional compensation.
			 * @return {number} parsed angle in radians
			 */ _parseAngle = function(v, d, p, directionalEnd) {
        var min = 0.000001, cap, split, dif, result, isRelative;
        if (typeof v === "function") v = v(_index, _target);
        if (v == null) result = d;
        else if (typeof v === "number") result = v;
        else {
            cap = 360;
            split = v.split("_");
            isRelative = v.charAt(1) === "=";
            dif = (isRelative ? parseInt(v.charAt(0) + "1", 10) * parseFloat(split[0].substr(2)) : parseFloat(split[0])) * (v.indexOf("rad") === -1 ? 1 : _RAD2DEG) - (isRelative ? 0 : d);
            if (split.length) {
                if (directionalEnd) directionalEnd[p] = d + dif;
                if (v.indexOf("short") !== -1) {
                    dif = dif % cap;
                    if (dif !== dif % (cap / 2)) dif = dif < 0 ? dif + cap : dif - cap;
                }
                if (v.indexOf("_cw") !== -1 && dif < 0) dif = (dif + cap * 9999999999) % cap - (dif / cap | 0) * cap;
                else if (v.indexOf("ccw") !== -1 && dif > 0) dif = (dif - cap * 9999999999) % cap - (dif / cap | 0) * cap;
            }
            result = d + dif;
        }
        if (result < min && result > -min) result = 0;
        return result;
    }, _colorLookup = {
        aqua: [
            0,
            255,
            255
        ],
        lime: [
            0,
            255,
            0
        ],
        silver: [
            192,
            192,
            192
        ],
        black: [
            0,
            0,
            0
        ],
        maroon: [
            128,
            0,
            0
        ],
        teal: [
            0,
            128,
            128
        ],
        blue: [
            0,
            0,
            255
        ],
        navy: [
            0,
            0,
            128
        ],
        white: [
            255,
            255,
            255
        ],
        fuchsia: [
            255,
            0,
            255
        ],
        olive: [
            128,
            128,
            0
        ],
        yellow: [
            255,
            255,
            0
        ],
        orange: [
            255,
            165,
            0
        ],
        gray: [
            128,
            128,
            128
        ],
        purple: [
            128,
            0,
            128
        ],
        green: [
            0,
            128,
            0
        ],
        red: [
            255,
            0,
            0
        ],
        pink: [
            255,
            192,
            203
        ],
        cyan: [
            0,
            255,
            255
        ],
        transparent: [
            255,
            255,
            255,
            0
        ]
    }, _hue = function(h, m1, m2) {
        h = h < 0 ? h + 1 : h > 1 ? h - 1 : h;
        return (h * 6 < 1 ? m1 + (m2 - m1) * h * 6 : h < 0.5 ? m2 : h * 3 < 2 ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * 255 + 0.5 | 0;
    }, /**
			 * @private Parses a color (like #9F0, #FF9900, rgb(255,51,153) or hsl(108, 50%, 10%)) into an array with 3 elements for red, green, and blue or if toHSL parameter is true, it will populate the array with hue, saturation, and lightness values. If a relative value is found in an hsl() or hsla() string, it will preserve those relative prefixes and all the values in the array will be strings instead of numbers (in all other cases it will be populated with numbers).
			 * @param {(string|number)} v The value the should be parsed which could be a string like #9F0 or rgb(255,102,51) or rgba(255,0,0,0.5) or it could be a number like 0xFF00CC or even a named color like red, blue, purple, etc.
			 * @param {(boolean)} toHSL If true, an hsl() or hsla() value will be returned instead of rgb() or rgba()
			 * @return {Array.<number>} An array containing red, green, and blue (and optionally alpha) in that order, or if the toHSL parameter was true, the array will contain hue, saturation and lightness (and optionally alpha) in that order. Always numbers unless there's a relative prefix found in an hsl() or hsla() string and toHSL is true.
			 */ _parseColor = CSSPlugin.parseColor = function(v, toHSL) {
        var a, r, g, b, h, s, l, max, min, d, wasHSL;
        if (!v) a = _colorLookup.black;
        else if (typeof v === "number") a = [
            v >> 16,
            v >> 8 & 255,
            v & 255
        ];
        else {
            if (v.charAt(v.length - 1) === ",") v = v.substr(0, v.length - 1);
            if (_colorLookup[v]) a = _colorLookup[v];
            else if (v.charAt(0) === "#") {
                if (v.length === 4) {
                    r = v.charAt(1);
                    g = v.charAt(2);
                    b = v.charAt(3);
                    v = "#" + r + r + g + g + b + b;
                }
                v = parseInt(v.substr(1), 16);
                a = [
                    v >> 16,
                    v >> 8 & 255,
                    v & 255
                ];
            } else if (v.substr(0, 3) === "hsl") {
                a = wasHSL = v.match(_numExp);
                if (!toHSL) {
                    h = Number(a[0]) % 360 / 360;
                    s = Number(a[1]) / 100;
                    l = Number(a[2]) / 100;
                    g = l <= 0.5 ? l * (s + 1) : l + s - l * s;
                    r = l * 2 - g;
                    if (a.length > 3) a[3] = Number(a[3]);
                    a[0] = _hue(h + 1 / 3, r, g);
                    a[1] = _hue(h, r, g);
                    a[2] = _hue(h - 1 / 3, r, g);
                } else if (v.indexOf("=") !== -1) return v.match(_relNumExp);
            } else a = v.match(_numExp) || _colorLookup.transparent;
            a[0] = Number(a[0]);
            a[1] = Number(a[1]);
            a[2] = Number(a[2]);
            if (a.length > 3) a[3] = Number(a[3]);
        }
        if (toHSL && !wasHSL) {
            r = a[0] / 255;
            g = a[1] / 255;
            b = a[2] / 255;
            max = Math.max(r, g, b);
            min = Math.min(r, g, b);
            l = (max + min) / 2;
            if (max === min) h = s = 0;
            else {
                d = max - min;
                s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
                h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
                h *= 60;
            }
            a[0] = h + 0.5 | 0;
            a[1] = s * 100 + 0.5 | 0;
            a[2] = l * 100 + 0.5 | 0;
        }
        return a;
    }, _formatColors = function(s, toHSL) {
        var colors = s.match(_colorExp) || [], charIndex = 0, parsed = "", i, color, temp;
        if (!colors.length) return s;
        for(i = 0; i < colors.length; i++){
            color = colors[i];
            temp = s.substr(charIndex, s.indexOf(color, charIndex) - charIndex);
            charIndex += temp.length + color.length;
            color = _parseColor(color, toHSL);
            if (color.length === 3) color.push(1);
            parsed += temp + (toHSL ? "hsla(" + color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : "rgba(" + color.join(",")) + ")";
        }
        return parsed + s.substr(charIndex);
    }, _colorExp = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3}){1,2}\\b"; //we'll dynamically build this Regular Expression to conserve file size. After building it, it will be able to find rgb(), rgba(), # (hexadecimal), and named color values like red, blue, purple, etc.
    for(p in _colorLookup)_colorExp += "|" + p + "\\b";
    _colorExp = new RegExp(_colorExp + ")", "gi");
    CSSPlugin.colorStringFilter = function(a) {
        var combined = a[0] + " " + a[1], toHSL;
        if (_colorExp.test(combined)) {
            toHSL = combined.indexOf("hsl(") !== -1 || combined.indexOf("hsla(") !== -1;
            a[0] = _formatColors(a[0], toHSL);
            a[1] = _formatColors(a[1], toHSL);
        }
        _colorExp.lastIndex = 0;
    };
    if (!(0, $hYzRA.default).defaultStringFilter) (0, $hYzRA.default).defaultStringFilter = CSSPlugin.colorStringFilter;
    /**
		 * @private Returns a formatter function that handles taking a string (or number in some cases) and returning a consistently formatted one in terms of delimiters, quantity of values, etc. For example, we may get boxShadow values defined as "0px red" or "0px 0px 10px rgb(255,0,0)" or "0px 0px 20px 20px #F00" and we need to ensure that what we get back is described with 4 numbers and a color. This allows us to feed it into the _parseComplex() method and split the values up appropriately. The neat thing about this _getFormatter() function is that the dflt defines a pattern as well as a default, so for example, _getFormatter("0px 0px 0px 0px #777", true) not only sets the default as 0px for all distances and #777 for the color, but also sets the pattern such that 4 numbers and a color will always get returned.
		 * @param {!string} dflt The default value and pattern to follow. So "0px 0px 0px 0px #777" will ensure that 4 numbers and a color will always get returned.
		 * @param {boolean=} clr If true, the values should be searched for color-related data. For example, boxShadow values typically contain a color whereas borderRadius don't.
		 * @param {boolean=} collapsible If true, the value is a top/left/right/bottom style one that acts like margin or padding, where if only one value is received, it's used for all 4; if 2 are received, the first is duplicated for 3rd (bottom) and the 2nd is duplicated for the 4th spot (left), etc.
		 * @return {Function} formatter function
		 */ var _getFormatter = function(dflt, clr, collapsible, multi) {
        if (dflt == null) return function(v) {
            return v;
        };
        var dColor = clr ? (dflt.match(_colorExp) || [
            ""
        ])[0] : "", dVals = dflt.split(dColor).join("").match(_valuesExp) || [], pfx = dflt.substr(0, dflt.indexOf(dVals[0])), sfx = dflt.charAt(dflt.length - 1) === ")" ? ")" : "", delim = dflt.indexOf(" ") !== -1 ? " " : ",", numVals = dVals.length, dSfx = numVals > 0 ? dVals[0].replace(_numExp, "") : "", formatter;
        if (!numVals) return function(v) {
            return v;
        };
        if (clr) {
            formatter = function(v) {
                var color, vals, i, a;
                if (typeof v === "number") v += dSfx;
                else if (multi && _commasOutsideParenExp.test(v)) {
                    a = v.replace(_commasOutsideParenExp, "|").split("|");
                    for(i = 0; i < a.length; i++)a[i] = formatter(a[i]);
                    return a.join(",");
                }
                color = (v.match(_colorExp) || [
                    dColor
                ])[0];
                vals = v.split(color).join("").match(_valuesExp) || [];
                i = vals.length;
                if (numVals > i--) while(++i < numVals)vals[i] = collapsible ? vals[(i - 1) / 2 | 0] : dVals[i];
                return pfx + vals.join(delim) + delim + color + sfx + (v.indexOf("inset") !== -1 ? " inset" : "");
            };
            return formatter;
        }
        formatter = function(v) {
            var vals, a, i;
            if (typeof v === "number") v += dSfx;
            else if (multi && _commasOutsideParenExp.test(v)) {
                a = v.replace(_commasOutsideParenExp, "|").split("|");
                for(i = 0; i < a.length; i++)a[i] = formatter(a[i]);
                return a.join(",");
            }
            vals = v.match(delim === "," ? _valuesExp : _valuesExpWithCommas) || [];
            i = vals.length;
            if (numVals > i--) while(++i < numVals)vals[i] = collapsible ? vals[(i - 1) / 2 | 0] : dVals[i];
            return (pfx && v !== "none" ? v.substr(0, v.indexOf(vals[0])) || pfx : pfx) + vals.join(delim) + sfx; //note: prefix might be different, like for clipPath it could start with inset( or polygon(
        };
        return formatter;
    }, /**
			 * @private returns a formatter function that's used for edge-related values like marginTop, marginLeft, paddingBottom, paddingRight, etc. Just pass a comma-delimited list of property names related to the edges.
			 * @param {!string} props a comma-delimited list of property names in order from top to left, like "marginTop,marginRight,marginBottom,marginLeft"
			 * @return {Function} a formatter function
			 */ _getEdgeParser = function(props) {
        props = props.split(",");
        return function(t, e, p, cssp, pt, plugin, vars) {
            var a = (e + "").split(" "), i;
            vars = {};
            for(i = 0; i < 4; i++)vars[props[i]] = a[i] = a[i] || a[(i - 1) / 2 >> 0];
            return cssp.parse(t, vars, pt, plugin);
        };
    }, // @private used when other plugins must tween values first, like BezierPlugin or ThrowPropsPlugin, etc. That plugin's setRatio() gets called first so that the values are updated, and then we loop through the MiniPropTweens which handle copying the values into their appropriate slots so that they can then be applied correctly in the main CSSPlugin setRatio() method. Remember, we typically create a proxy object that has a bunch of uniquely-named properties that we feed to the sub-plugin and it does its magic normally, and then we must interpret those values and apply them to the css because often numbers must get combined/concatenated, suffixes added, etc. to work with css, like boxShadow could have 4 values plus a color.
    _setPluginRatio = _internals._setPluginRatio = function(v) {
        this.plugin.setRatio(v);
        var d = this.data, proxy = d.proxy, mpt = d.firstMPT, min = 0.000001, val, pt, i, str, p;
        while(mpt){
            val = proxy[mpt.v];
            if (mpt.r) val = mpt.r(val);
            else if (val < min && val > -min) val = 0;
            mpt.t[mpt.p] = val;
            mpt = mpt._next;
        }
        if (d.autoRotate) d.autoRotate.rotation = d.mod ? d.mod.call(this._tween, proxy.rotation, this.t, this._tween) : proxy.rotation; //special case for ModifyPlugin to hook into an auto-rotating bezier
        //at the end, we must set the CSSPropTween's "e" (end) value dynamically here because that's what is used in the final setRatio() method. Same for "b" at the beginning.
        if (v === 1 || v === 0) {
            mpt = d.firstMPT;
            p = v === 1 ? "e" : "b";
            while(mpt){
                pt = mpt.t;
                if (!pt.type) pt[p] = pt.s + pt.xs0;
                else if (pt.type === 1) {
                    str = pt.xs0 + pt.s + pt.xs1;
                    for(i = 1; i < pt.l; i++)str += pt["xn" + i] + pt["xs" + (i + 1)];
                    pt[p] = str;
                }
                mpt = mpt._next;
            }
        }
    }, /**
			 * @private @constructor Used by a few SpecialProps to hold important values for proxies. For example, _parseToProxy() creates a MiniPropTween instance for each property that must get tweened on the proxy, and we record the original property name as well as the unique one we create for the proxy, plus whether or not the value needs to be rounded plus the original value.
			 * @param {!Object} t target object whose property we're tweening (often a CSSPropTween)
			 * @param {!string} p property name
			 * @param {(number|string|object)} v value
			 * @param {MiniPropTween=} next next MiniPropTween in the linked list
			 * @param {boolean=} r if true, the tweened value should be rounded to the nearest integer
			 */ MiniPropTween = function(t, p, v, next, r) {
        this.t = t;
        this.p = p;
        this.v = v;
        this.r = r;
        if (next) {
            next._prev = this;
            this._next = next;
        }
    }, /**
			 * @private Most other plugins (like BezierPlugin and ThrowPropsPlugin and others) can only tween numeric values, but CSSPlugin must accommodate special values that have a bunch of extra data (like a suffix or strings between numeric values, etc.). For example, boxShadow has values like "10px 10px 20px 30px rgb(255,0,0)" which would utterly confuse other plugins. This method allows us to split that data apart and grab only the numeric data and attach it to uniquely-named properties of a generic proxy object ({}) so that we can feed that to virtually any plugin to have the numbers tweened. However, we must also keep track of which properties from the proxy go with which CSSPropTween values and instances. So we create a linked list of MiniPropTweens. Each one records a target (the original CSSPropTween), property (like "s" or "xn1" or "xn2") that we're tweening and the unique property name that was used for the proxy (like "boxShadow_xn1" and "boxShadow_xn2") and whether or not they need to be rounded. That way, in the _setPluginRatio() method we can simply copy the values over from the proxy to the CSSPropTween instance(s). Then, when the main CSSPlugin setRatio() method runs and applies the CSSPropTween values accordingly, they're updated nicely. So the external plugin tweens the numbers, _setPluginRatio() copies them over, and setRatio() acts normally, applying css-specific values to the element.
			 * This method returns an object that has the following properties:
			 *  - proxy: a generic object containing the starting values for all the properties that will be tweened by the external plugin.  This is what we feed to the external _onInitTween() as the target
			 *  - end: a generic object containing the ending values for all the properties that will be tweened by the external plugin. This is what we feed to the external plugin's _onInitTween() as the destination values
			 *  - firstMPT: the first MiniPropTween in the linked list
			 *  - pt: the first CSSPropTween in the linked list that was created when parsing. If shallow is true, this linked list will NOT attach to the one passed into the _parseToProxy() as the "pt" (4th) parameter.
			 * @param {!Object} t target object to be tweened
			 * @param {!(Object|string)} vars the object containing the information about the tweening values (typically the end/destination values) that should be parsed
			 * @param {!CSSPlugin} cssp The CSSPlugin instance
			 * @param {CSSPropTween=} pt the next CSSPropTween in the linked list
			 * @param {TweenPlugin=} plugin the external TweenPlugin instance that will be handling tweening the numeric values
			 * @param {boolean=} shallow if true, the resulting linked list from the parse will NOT be attached to the CSSPropTween that was passed in as the "pt" (4th) parameter.
			 * @return An object containing the following properties: proxy, end, firstMPT, and pt (see above for descriptions)
			 */ _parseToProxy = _internals._parseToProxy = function(t, vars, cssp, pt, plugin, shallow) {
        var bpt = pt, start = {}, end = {}, transform = cssp._transform, oldForce = _forcePT, i, p, xp, mpt, firstPT;
        cssp._transform = null;
        _forcePT = vars;
        pt = firstPT = cssp.parse(t, vars, pt, plugin);
        _forcePT = oldForce;
        //break off from the linked list so the new ones are isolated.
        if (shallow) {
            cssp._transform = transform;
            if (bpt) {
                bpt._prev = null;
                if (bpt._prev) bpt._prev._next = null;
            }
        }
        while(pt && pt !== bpt){
            if (pt.type <= 1) {
                p = pt.p;
                end[p] = pt.s + pt.c;
                start[p] = pt.s;
                if (!shallow) {
                    mpt = new MiniPropTween(pt, "s", p, mpt, pt.r);
                    pt.c = 0;
                }
                if (pt.type === 1) {
                    i = pt.l;
                    while(--i > 0){
                        xp = "xn" + i;
                        p = pt.p + "_" + xp;
                        end[p] = pt.data[xp];
                        start[p] = pt[xp];
                        if (!shallow) mpt = new MiniPropTween(pt, xp, p, mpt, pt.rxp[xp]);
                    }
                }
            }
            pt = pt._next;
        }
        return {
            proxy: start,
            end: end,
            firstMPT: mpt,
            pt: firstPT
        };
    }, /**
			 * @constructor Each property that is tweened has at least one CSSPropTween associated with it. These instances store important information like the target, property, starting value, amount of change, etc. They can also optionally have a number of "extra" strings and numeric values named xs1, xn1, xs2, xn2, xs3, xn3, etc. where "s" indicates string and "n" indicates number. These can be pieced together in a complex-value tween (type:1) that has alternating types of data like a string, number, string, number, etc. For example, boxShadow could be "5px 5px 8px rgb(102, 102, 51)". In that value, there are 6 numbers that may need to tween and then pieced back together into a string again with spaces, suffixes, etc. xs0 is special in that it stores the suffix for standard (type:0) tweens, -OR- the first string (prefix) in a complex-value (type:1) CSSPropTween -OR- it can be the non-tweening value in a type:-1 CSSPropTween. We do this to conserve memory.
			 * CSSPropTweens have the following optional properties as well (not defined through the constructor):
			 *  - l: Length in terms of the number of extra properties that the CSSPropTween has (default: 0). For example, for a boxShadow we may need to tween 5 numbers in which case l would be 5; Keep in mind that the start/end values for the first number that's tweened are always stored in the s and c properties to conserve memory. All additional values thereafter are stored in xn1, xn2, etc.
			 *  - xfirst: The first instance of any sub-CSSPropTweens that are tweening properties of this instance. For example, we may split up a boxShadow tween so that there's a main CSSPropTween of type:1 that has various xs* and xn* values associated with the h-shadow, v-shadow, blur, color, etc. Then we spawn a CSSPropTween for each of those that has a higher priority and runs BEFORE the main CSSPropTween so that the values are all set by the time it needs to re-assemble them. The xfirst gives us an easy way to identify the first one in that chain which typically ends at the main one (because they're all prepende to the linked list)
			 *  - plugin: The TweenPlugin instance that will handle the tweening of any complex values. For example, sometimes we don't want to use normal subtweens (like xfirst refers to) to tween the values - we might want ThrowPropsPlugin or BezierPlugin some other plugin to do the actual tweening, so we create a plugin instance and store a reference here. We need this reference so that if we get a request to round values or disable a tween, we can pass along that request.
			 *  - data: Arbitrary data that needs to be stored with the CSSPropTween. Typically if we're going to have a plugin handle the tweening of a complex-value tween, we create a generic object that stores the END values that we're tweening to and the CSSPropTween's xs1, xs2, etc. have the starting values. We store that object as data. That way, we can simply pass that object to the plugin and use the CSSPropTween as the target.
			 *  - setRatio: Only used for type:2 tweens that require custom functionality. In this case, we call the CSSPropTween's setRatio() method and pass the ratio each time the tween updates. This isn't quite as efficient as doing things directly in the CSSPlugin's setRatio() method, but it's very convenient and flexible.
			 * @param {!Object} t Target object whose property will be tweened. Often a DOM element, but not always. It could be anything.
			 * @param {string} p Property to tween (name). For example, to tween element.width, p would be "width".
			 * @param {number} s Starting numeric value
			 * @param {number} c Change in numeric value over the course of the entire tween. For example, if element.width starts at 5 and should end at 100, c would be 95.
			 * @param {CSSPropTween=} next The next CSSPropTween in the linked list. If one is defined, we will define its _prev as the new instance, and the new instance's _next will be pointed at it.
			 * @param {number=} type The type of CSSPropTween where -1 = a non-tweening value, 0 = a standard simple tween, 1 = a complex value (like one that has multiple numbers in a comma- or space-delimited string like border:"1px solid red"), and 2 = one that uses a custom setRatio function that does all of the work of applying the values on each update.
			 * @param {string=} n Name of the property that should be used for overwriting purposes which is typically the same as p but not always. For example, we may need to create a subtween for the 2nd part of a "clip:rect(...)" tween in which case "p" might be xs1 but "n" is still "clip"
			 * @param {boolean=} r If true, the value(s) should be rounded
			 * @param {number=} pr Priority in the linked list order. Higher priority CSSPropTweens will be updated before lower priority ones. The default priority is 0.
			 * @param {string=} b Beginning value. We store this to ensure that it is EXACTLY what it was when the tween began without any risk of interpretation issues.
			 * @param {string=} e Ending value. We store this to ensure that it is EXACTLY what the user defined at the end of the tween without any risk of interpretation issues.
			 */ CSSPropTween = _internals.CSSPropTween = function(t, p, s, c, next, type, n, r, pr, b, e) {
        this.t = t; //target
        this.p = p; //property
        this.s = s; //starting value
        this.c = c; //change value
        this.n = n || p; //name that this CSSPropTween should be associated to (usually the same as p, but not always - n is what overwriting looks at)
        if (!(t instanceof CSSPropTween)) _overwriteProps.push(this.n);
        this.r = !r ? r : typeof r === "function" ? r : Math.round; //round (boolean)
        this.type = type || 0; //0 = normal tween, -1 = non-tweening (in which case xs0 will be applied to the target's property, like tp.t[tp.p] = tp.xs0), 1 = complex-value SpecialProp, 2 = custom setRatio() that does all the work
        if (pr) {
            this.pr = pr;
            _hasPriority = true;
        }
        this.b = b === undefined ? s : b;
        this.e = e === undefined ? s + c : e;
        if (next) {
            this._next = next;
            next._prev = this;
        }
    }, _addNonTweeningNumericPT = function(target, prop, start, end, next, overwriteProp) {
        var pt = new CSSPropTween(target, prop, start, end - start, next, -1, overwriteProp);
        pt.b = start;
        pt.e = pt.xs0 = end;
        return pt;
    }, /**
			 * Takes a target, the beginning value and ending value (as strings) and parses them into a CSSPropTween (possibly with child CSSPropTweens) that accommodates multiple numbers, colors, comma-delimited values, etc. For example:
			 * sp.parseComplex(element, "boxShadow", "5px 10px 20px rgb(255,102,51)", "0px 0px 0px red", true, "0px 0px 0px rgb(0,0,0,0)", pt);
			 * It will walk through the beginning and ending values (which should be in the same format with the same number and type of values) and figure out which parts are numbers, what strings separate the numeric/tweenable values, and then create the CSSPropTweens accordingly. If a plugin is defined, no child CSSPropTweens will be created. Instead, the ending values will be stored in the "data" property of the returned CSSPropTween like: {s:-5, xn1:-10, xn2:-20, xn3:255, xn4:0, xn5:0} so that it can be fed to any other plugin and it'll be plain numeric tweens but the recomposition of the complex value will be handled inside CSSPlugin's setRatio().
			 * If a setRatio is defined, the type of the CSSPropTween will be set to 2 and recomposition of the values will be the responsibility of that method.
			 *
			 * @param {!Object} t Target whose property will be tweened
			 * @param {!string} p Property that will be tweened (its name, like "left" or "backgroundColor" or "boxShadow")
			 * @param {string} b Beginning value
			 * @param {string} e Ending value
			 * @param {boolean} clrs If true, the value could contain a color value like "rgb(255,0,0)" or "#F00" or "red". The default is false, so no colors will be recognized (a performance optimization)
			 * @param {(string|number|Object)} dflt The default beginning value that should be used if no valid beginning value is defined or if the number of values inside the complex beginning and ending values don't match
			 * @param {?CSSPropTween} pt CSSPropTween instance that is the current head of the linked list (we'll prepend to this).
			 * @param {number=} pr Priority in the linked list order. Higher priority properties will be updated before lower priority ones. The default priority is 0.
			 * @param {TweenPlugin=} plugin If a plugin should handle the tweening of extra properties, pass the plugin instance here. If one is defined, then NO subtweens will be created for any extra properties (the properties will be created - just not additional CSSPropTween instances to tween them) because the plugin is expected to do so. However, the end values WILL be populated in the "data" property, like {s:100, xn1:50, xn2:300}
			 * @param {function(number)=} setRatio If values should be set in a custom function instead of being pieced together in a type:1 (complex-value) CSSPropTween, define that custom function here.
			 * @return {CSSPropTween} The first CSSPropTween in the linked list which includes the new one(s) added by the parseComplex() call.
			 */ _parseComplex = CSSPlugin.parseComplex = function(t, p, b, e, clrs, dflt, pt, pr, plugin, setRatio) {
        //DEBUG: _log("parseComplex: "+p+", b: "+b+", e: "+e);
        b = b || dflt || "";
        if (typeof e === "function") e = e(_index, _target);
        pt = new CSSPropTween(t, p, 0, 0, pt, setRatio ? 2 : 1, null, false, pr, b, e);
        e += ""; //ensures it's a string
        if (clrs && _colorExp.test(e + b)) {
            e = [
                b,
                e
            ];
            CSSPlugin.colorStringFilter(e);
            b = e[0];
            e = e[1];
        }
        var ba = b.split(", ").join(",").split(" "), ea = e.split(", ").join(",").split(" "), l = ba.length, autoRound = _autoRound !== false, i, xi, ni, bv, ev, bnums, enums, bn, hasAlpha, temp, cv, str, useHSL;
        if (e.indexOf(",") !== -1 || b.indexOf(",") !== -1) {
            if ((e + b).indexOf("rgb") !== -1 || (e + b).indexOf("hsl") !== -1) {
                ba = ba.join(" ").replace(_commasOutsideParenExp, ", ").split(" ");
                ea = ea.join(" ").replace(_commasOutsideParenExp, ", ").split(" ");
            } else {
                ba = ba.join(" ").split(",").join(", ").split(" ");
                ea = ea.join(" ").split(",").join(", ").split(" ");
            }
            l = ba.length;
        }
        if (l !== ea.length) {
            //DEBUG: _log("mismatched formatting detected on " + p + " (" + b + " vs " + e + ")");
            ba = (dflt || "").split(" ");
            l = ba.length;
        }
        pt.plugin = plugin;
        pt.setRatio = setRatio;
        _colorExp.lastIndex = 0;
        for(i = 0; i < l; i++){
            bv = ba[i];
            ev = ea[i] + "";
            bn = parseFloat(bv);
            //if the value begins with a number (most common). It's fine if it has a suffix like px
            if (bn || bn === 0) pt.appendXtra("", bn, _parseChange(ev, bn), ev.replace(_relNumExp, ""), autoRound && ev.indexOf("px") !== -1 ? Math.round : false, true);
            else if (clrs && _colorExp.test(bv)) {
                str = ev.indexOf(")") + 1;
                str = ")" + (str ? ev.substr(str) : ""); //if there's a comma or ) at the end, retain it.
                useHSL = ev.indexOf("hsl") !== -1 && _supportsOpacity;
                temp = ev; //original string value so we can look for any prefix later.
                bv = _parseColor(bv, useHSL);
                ev = _parseColor(ev, useHSL);
                hasAlpha = bv.length + ev.length > 6;
                if (hasAlpha && !_supportsOpacity && ev[3] === 0) {
                    pt["xs" + pt.l] += pt.l ? " transparent" : "transparent";
                    pt.e = pt.e.split(ea[i]).join("transparent");
                } else {
                    if (!_supportsOpacity) hasAlpha = false;
                    if (useHSL) pt.appendXtra(temp.substr(0, temp.indexOf("hsl")) + (hasAlpha ? "hsla(" : "hsl("), bv[0], _parseChange(ev[0], bv[0]), ",", false, true).appendXtra("", bv[1], _parseChange(ev[1], bv[1]), "%,", false).appendXtra("", bv[2], _parseChange(ev[2], bv[2]), hasAlpha ? "%," : "%" + str, false);
                    else pt.appendXtra(temp.substr(0, temp.indexOf("rgb")) + (hasAlpha ? "rgba(" : "rgb("), bv[0], ev[0] - bv[0], ",", Math.round, true).appendXtra("", bv[1], ev[1] - bv[1], ",", Math.round).appendXtra("", bv[2], ev[2] - bv[2], hasAlpha ? "," : str, Math.round);
                    if (hasAlpha) {
                        bv = bv.length < 4 ? 1 : bv[3];
                        pt.appendXtra("", bv, (ev.length < 4 ? 1 : ev[3]) - bv, str, false);
                    }
                }
                _colorExp.lastIndex = 0; //otherwise the test() on the RegExp could move the lastIndex and taint future results.
            } else {
                bnums = bv.match(_numExp); //gets each group of numbers in the beginning value string and drops them into an array
                //if no number is found, treat it as a non-tweening value and just append the string to the current xs.
                if (!bnums) pt["xs" + pt.l] += pt.l || pt["xs" + pt.l] ? " " + ev : ev;
                else {
                    enums = ev.match(_relNumExp); //get each group of numbers in the end value string and drop them into an array. We allow relative values too, like +=50 or -=.5
                    if (!enums || enums.length !== bnums.length) //DEBUG: _log("mismatched formatting detected on " + p + " (" + b + " vs " + e + ")");
                    return pt;
                    ni = 0;
                    for(xi = 0; xi < bnums.length; xi++){
                        cv = bnums[xi];
                        temp = bv.indexOf(cv, ni);
                        pt.appendXtra(bv.substr(ni, temp - ni), Number(cv), _parseChange(enums[xi], cv), "", autoRound && bv.substr(temp + cv.length, 2) === "px" ? Math.round : false, xi === 0);
                        ni = temp + cv.length;
                    }
                    pt["xs" + pt.l] += bv.substr(ni);
                }
            }
        }
        //if there are relative values ("+=" or "-=" prefix), we need to adjust the ending value to eliminate the prefixes and combine the values properly.
        if (e.indexOf("=") !== -1) {
            if (pt.data) {
                str = pt.xs0 + pt.data.s;
                for(i = 1; i < pt.l; i++)str += pt["xs" + i] + pt.data["xn" + i];
                pt.e = str + pt["xs" + i];
            }
        }
        if (!pt.l) {
            pt.type = -1;
            pt.xs0 = pt.e;
        }
        return pt.xfirst || pt;
    }, i = 9;
    p = CSSPropTween.prototype;
    p.l = p.pr = 0; //length (number of extra properties like xn1, xn2, xn3, etc.
    while(--i > 0){
        p["xn" + i] = 0;
        p["xs" + i] = "";
    }
    p.xs0 = "";
    p._next = p._prev = p.xfirst = p.data = p.plugin = p.setRatio = p.rxp = null;
    /**
		 * Appends and extra tweening value to a CSSPropTween and automatically manages any prefix and suffix strings. The first extra value is stored in the s and c of the main CSSPropTween instance, but thereafter any extras are stored in the xn1, xn2, xn3, etc. The prefixes and suffixes are stored in the xs0, xs1, xs2, etc. properties. For example, if I walk through a clip value like "rect(10px, 5px, 0px, 20px)", the values would be stored like this:
		 * xs0:"rect(", s:10, xs1:"px, ", xn1:5, xs2:"px, ", xn2:0, xs3:"px, ", xn3:20, xn4:"px)"
		 * And they'd all get joined together when the CSSPlugin renders (in the setRatio() method).
		 * @param {string=} pfx Prefix (if any)
		 * @param {!number} s Starting value
		 * @param {!number} c Change in numeric value over the course of the entire tween. For example, if the start is 5 and the end is 100, the change would be 95.
		 * @param {string=} sfx Suffix (if any)
		 * @param {boolean=} r Round (if true).
		 * @param {boolean=} pad If true, this extra value should be separated by the previous one by a space. If there is no previous extra and pad is true, it will automatically drop the space.
		 * @return {CSSPropTween} returns itself so that multiple methods can be chained together.
		 */ p.appendXtra = function(pfx, s, c, sfx, r, pad) {
        var pt = this, l = pt.l;
        pt["xs" + l] += pad && (l || pt["xs" + l]) ? " " + pfx : pfx || "";
        if (!c) {
            if (l !== 0 && !pt.plugin) {
                pt["xs" + l] += s + (sfx || "");
                return pt;
            }
        }
        pt.l++;
        pt.type = pt.setRatio ? 2 : 1;
        pt["xs" + pt.l] = sfx || "";
        if (l > 0) {
            pt.data["xn" + l] = s + c;
            pt.rxp["xn" + l] = r; //round extra property (we need to tap into this in the _parseToProxy() method)
            pt["xn" + l] = s;
            if (!pt.plugin) {
                pt.xfirst = new CSSPropTween(pt, "xn" + l, s, c, pt.xfirst || pt, 0, pt.n, r, pt.pr);
                pt.xfirst.xs0 = 0; //just to ensure that the property stays numeric which helps modern browsers speed up processing. Remember, in the setRatio() method, we do pt.t[pt.p] = val + pt.xs0 so if pt.xs0 is "" (the default), it'll cast the end value as a string. When a property is a number sometimes and a string sometimes, it prevents the compiler from locking in the data type, slowing things down slightly.
            }
            return pt;
        }
        pt.data = {
            s: s + c
        };
        pt.rxp = {};
        pt.s = s;
        pt.c = c;
        pt.r = r;
        return pt;
    };
    /**
		 * @constructor A SpecialProp is basically a css property that needs to be treated in a non-standard way, like if it may contain a complex value like boxShadow:"5px 10px 15px rgb(255, 102, 51)" or if it is associated with another plugin like ThrowPropsPlugin or BezierPlugin. Every SpecialProp is associated with a particular property name like "boxShadow" or "throwProps" or "bezier" and it will intercept those values in the vars object that's passed to the CSSPlugin and handle them accordingly.
		 * @param {!string} p Property name (like "boxShadow" or "throwProps")
		 * @param {Object=} options An object containing any of the following configuration options:
		 *                      - defaultValue: the default value
		 *                      - parser: A function that should be called when the associated property name is found in the vars. This function should return a CSSPropTween instance and it should ensure that it is properly inserted into the linked list. It will receive 4 paramters: 1) The target, 2) The value defined in the vars, 3) The CSSPlugin instance (whose _firstPT should be used for the linked list), and 4) A computed style object if one was calculated (this is a speed optimization that allows retrieval of starting values quicker)
		 *                      - formatter: a function that formats any value received for this special property (for example, boxShadow could take "5px 5px red" and format it to "5px 5px 0px 0px red" so that both the beginning and ending values have a common order and quantity of values.)
		 *                      - prefix: if true, we'll determine whether or not this property requires a vendor prefix (like Webkit or Moz or ms or O)
		 *                      - color: set this to true if the value for this SpecialProp may contain color-related values like rgb(), rgba(), etc.
		 *                      - priority: priority in the linked list order. Higher priority SpecialProps will be updated before lower priority ones. The default priority is 0.
		 *                      - multi: if true, the formatter should accommodate a comma-delimited list of values, like boxShadow could have multiple boxShadows listed out.
		 *                      - collapsible: if true, the formatter should treat the value like it's a top/right/bottom/left value that could be collapsed, like "5px" would apply to all, "5px, 10px" would use 5px for top/bottom and 10px for right/left, etc.
		 *                      - keyword: a special keyword that can [optionally] be found inside the value (like "inset" for boxShadow). This allows us to validate beginning/ending values to make sure they match (if the keyword is found in one, it'll be added to the other for consistency by default).
		 */ var SpecialProp = function(p, options) {
        options = options || {};
        this.p = options.prefix ? _checkPropPrefix(p) || p : p;
        _specialProps[p] = _specialProps[this.p] = this;
        this.format = options.formatter || _getFormatter(options.defaultValue, options.color, options.collapsible, options.multi);
        if (options.parser) this.parse = options.parser;
        this.clrs = options.color;
        this.multi = options.multi;
        this.keyword = options.keyword;
        this.dflt = options.defaultValue;
        this.allowFunc = options.allowFunc;
        this.pr = options.priority || 0;
    }, //shortcut for creating a new SpecialProp that can accept multiple properties as a comma-delimited list (helps minification). dflt can be an array for multiple values (we don't do a comma-delimited list because the default value may contain commas, like rect(0px,0px,0px,0px)). We attach this method to the SpecialProp class/object instead of using a private _createSpecialProp() method so that we can tap into it externally if necessary, like from another plugin.
    _registerComplexSpecialProp = _internals._registerComplexSpecialProp = function(p, options, defaults) {
        if (typeof options !== "object") options = {
            parser: defaults
        }; //to make backwards compatible with older versions of BezierPlugin and ThrowPropsPlugin
        var a = p.split(","), d = options.defaultValue, i, temp;
        defaults = defaults || [
            d
        ];
        for(i = 0; i < a.length; i++){
            options.prefix = i === 0 && options.prefix;
            options.defaultValue = defaults[i] || d;
            temp = new SpecialProp(a[i], options);
        }
    }, //creates a placeholder special prop for a plugin so that the property gets caught the first time a tween of it is attempted, and at that time it makes the plugin register itself, thus taking over for all future tweens of that property. This allows us to not mandate that things load in a particular order and it also allows us to log() an error that informs the user when they attempt to tween an external plugin-related property without loading its .js file.
    _registerPluginProp = _internals._registerPluginProp = function(p) {
        if (!_specialProps[p]) {
            var pluginName = p.charAt(0).toUpperCase() + p.substr(1) + "Plugin";
            _registerComplexSpecialProp(p, {
                parser: function(t, e, p, cssp, pt, plugin, vars) {
                    var pluginClass = _globals.com.greensock.plugins[pluginName];
                    if (!pluginClass) {
                        _log("Error: " + pluginName + " js file not loaded.");
                        return pt;
                    }
                    pluginClass._cssRegister();
                    return _specialProps[p].parse(t, e, p, cssp, pt, plugin, vars);
                }
            });
        }
    };
    p = SpecialProp.prototype;
    /**
		 * Alias for _parseComplex() that automatically plugs in certain values for this SpecialProp, like its property name, whether or not colors should be sensed, the default value, and priority. It also looks for any keyword that the SpecialProp defines (like "inset" for boxShadow) and ensures that the beginning and ending values have the same number of values for SpecialProps where multi is true (like boxShadow and textShadow can have a comma-delimited list)
		 * @param {!Object} t target element
		 * @param {(string|number|object)} b beginning value
		 * @param {(string|number|object)} e ending (destination) value
		 * @param {CSSPropTween=} pt next CSSPropTween in the linked list
		 * @param {TweenPlugin=} plugin If another plugin will be tweening the complex value, that TweenPlugin instance goes here.
		 * @param {function=} setRatio If a custom setRatio() method should be used to handle this complex value, that goes here.
		 * @return {CSSPropTween=} First CSSPropTween in the linked list
		 */ p.parseComplex = function(t, b, e, pt, plugin, setRatio) {
        var kwd = this.keyword, i, ba, ea, l, bi, ei;
        //if this SpecialProp's value can contain a comma-delimited list of values (like boxShadow or textShadow), we must parse them in a special way, and look for a keyword (like "inset" for boxShadow) and ensure that the beginning and ending BOTH have it if the end defines it as such. We also must ensure that there are an equal number of values specified (we can't tween 1 boxShadow to 3 for example)
        if (this.multi) {
            if (_commasOutsideParenExp.test(e) || _commasOutsideParenExp.test(b)) {
                ba = b.replace(_commasOutsideParenExp, "|").split("|");
                ea = e.replace(_commasOutsideParenExp, "|").split("|");
            } else if (kwd) {
                ba = [
                    b
                ];
                ea = [
                    e
                ];
            }
        }
        if (ea) {
            l = ea.length > ba.length ? ea.length : ba.length;
            for(i = 0; i < l; i++){
                b = ba[i] = ba[i] || this.dflt;
                e = ea[i] = ea[i] || this.dflt;
                if (kwd) {
                    bi = b.indexOf(kwd);
                    ei = e.indexOf(kwd);
                    if (bi !== ei) {
                        if (ei === -1) ba[i] = ba[i].split(kwd).join("");
                        else if (bi === -1) ba[i] += " " + kwd;
                    }
                }
            }
            b = ba.join(", ");
            e = ea.join(", ");
        }
        return _parseComplex(t, this.p, b, e, this.clrs, this.dflt, pt, this.pr, plugin, setRatio);
    };
    /**
		 * Accepts a target and end value and spits back a CSSPropTween that has been inserted into the CSSPlugin's linked list and conforms with all the conventions we use internally, like type:-1, 0, 1, or 2, setting up any extra property tweens, priority, etc. For example, if we have a boxShadow SpecialProp and call:
		 * this._firstPT = sp.parse(element, "5px 10px 20px rgb(2550,102,51)", "boxShadow", this);
		 * It should figure out the starting value of the element's boxShadow, compare it to the provided end value and create all the necessary CSSPropTweens of the appropriate types to tween the boxShadow. The CSSPropTween that gets spit back should already be inserted into the linked list (the 4th parameter is the current head, so prepend to that).
		 * @param {!Object} t Target object whose property is being tweened
		 * @param {Object} e End value as provided in the vars object (typically a string, but not always - like a throwProps would be an object).
		 * @param {!string} p Property name
		 * @param {!CSSPlugin} cssp The CSSPlugin instance that should be associated with this tween.
		 * @param {?CSSPropTween} pt The CSSPropTween that is the current head of the linked list (we'll prepend to it)
		 * @param {TweenPlugin=} plugin If a plugin will be used to tween the parsed value, this is the plugin instance.
		 * @param {Object=} vars Original vars object that contains the data for parsing.
		 * @return {CSSPropTween} The first CSSPropTween in the linked list which includes the new one(s) added by the parse() call.
		 */ p.parse = function(t, e, p, cssp, pt, plugin, vars) {
        return this.parseComplex(t.style, this.format(_getStyle(t, this.p, _cs, false, this.dflt)), this.format(e), pt, plugin);
    };
    /**
		 * Registers a special property that should be intercepted from any "css" objects defined in tweens. This allows you to handle them however you want without CSSPlugin doing it for you. The 2nd parameter should be a function that accepts 3 parameters:
		 *  1) Target object whose property should be tweened (typically a DOM element)
		 *  2) The end/destination value (could be a string, number, object, or whatever you want)
		 *  3) The tween instance (you probably don't need to worry about this, but it can be useful for looking up information like the duration)
		 *
		 * Then, your function should return a function which will be called each time the tween gets rendered, passing a numeric "ratio" parameter to your function that indicates the change factor (usually between 0 and 1). For example:
		 *
		 * CSSPlugin.registerSpecialProp("myCustomProp", function(target, value, tween) {
		 *      var start = target.style.width;
		 *      return function(ratio) {
		 *              target.style.width = (start + value * ratio) + "px";
		 *              console.log("set width to " + target.style.width);
		 *          }
		 * }, 0);
		 *
		 * Then, when I do this tween, it will trigger my special property:
		 *
		 * TweenLite.to(element, 1, {css:{myCustomProp:100}});
		 *
		 * In the example, of course, we're just changing the width, but you can do anything you want.
		 *
		 * @param {!string} name Property name (or comma-delimited list of property names) that should be intercepted and handled by your function. For example, if I define "myCustomProp", then it would handle that portion of the following tween: TweenLite.to(element, 1, {css:{myCustomProp:100}})
		 * @param {!function(Object, Object, Object, string):function(number)} onInitTween The function that will be called when a tween of this special property is performed. The function will receive 4 parameters: 1) Target object that should be tweened, 2) Value that was passed to the tween, 3) The tween instance itself (rarely used), and 4) The property name that's being tweened. Your function should return a function that should be called on every update of the tween. That function will receive a single parameter that is a "change factor" value (typically between 0 and 1) indicating the amount of change as a ratio. You can use this to determine how to set the values appropriately in your function.
		 * @param {number=} priority Priority that helps the engine determine the order in which to set the properties (default: 0). Higher priority properties will be updated before lower priority ones.
		 */ CSSPlugin.registerSpecialProp = function(name, onInitTween, priority) {
        _registerComplexSpecialProp(name, {
            parser: function(t, e, p, cssp, pt, plugin, vars) {
                var rv = new CSSPropTween(t, p, 0, 0, pt, 2, p, false, priority);
                rv.plugin = plugin;
                rv.setRatio = onInitTween(t, e, cssp._tween, p);
                return rv;
            },
            priority: priority
        });
    };
    //transform-related methods and properties
    CSSPlugin.useSVGTransformAttr = true; //Safari and Firefox both have some rendering bugs when applying CSS transforms to SVG elements, so default to using the "transform" attribute instead (users can override this).
    var _transformProps = "scaleX,scaleY,scaleZ,x,y,z,skewX,skewY,rotation,rotationX,rotationY,perspective,xPercent,yPercent".split(","), _transformProp = _checkPropPrefix("transform"), _transformPropCSS = _prefixCSS + "transform", _transformOriginProp = _checkPropPrefix("transformOrigin"), _supports3D = _checkPropPrefix("perspective") !== null, Transform = _internals.Transform = function() {
        this.perspective = parseFloat(CSSPlugin.defaultTransformPerspective) || 0;
        this.force3D = CSSPlugin.defaultForce3D === false || !_supports3D ? false : CSSPlugin.defaultForce3D || "auto";
    }, _SVGElement = (0, $hYzRA._gsScope).SVGElement, _useSVGTransformAttr, //Some browsers (like Firefox and IE) don't honor transform-origin properly in SVG elements, so we need to manually adjust the matrix accordingly. We feature detect here rather than always doing the conversion for certain browsers because they may fix the problem at some point in the future.
    _createSVG = function(type, container, attributes) {
        var element = _doc.createElementNS("http://www.w3.org/2000/svg", type), reg = /([a-z])([A-Z])/g, p;
        for(p in attributes)element.setAttributeNS(null, p.replace(reg, "$1-$2").toLowerCase(), attributes[p]);
        container.appendChild(element);
        return element;
    }, _docElement = _doc.documentElement || {}, _forceSVGTransformAttr = function() {
        //IE and Android stock don't support CSS transforms on SVG elements, so we must write them to the "transform" attribute. We populate this variable in the _parseTransform() method, and only if/when we come across an SVG element
        var force = _ieVers || /Android/i.test(_agent) && !(0, $hYzRA._gsScope).chrome, svg, rect, width;
        if (_doc.createElementNS && _docElement.appendChild && !force) {
            svg = _createSVG("svg", _docElement);
            rect = _createSVG("rect", svg, {
                width: 100,
                height: 50,
                x: 100
            });
            width = rect.getBoundingClientRect().width;
            rect.style[_transformOriginProp] = "50% 50%";
            rect.style[_transformProp] = "scaleX(0.5)";
            force = width === rect.getBoundingClientRect().width && !(_isFirefox && _supports3D); //note: Firefox fails the test even though it does support CSS transforms in 3D. Since we can't push 3D stuff into the transform attribute, we force Firefox to pass the test here (as long as it does truly support 3D).
            _docElement.removeChild(svg);
        }
        return force;
    }(), _parseSVGOrigin = function(e, local, decoratee, absolute, smoothOrigin, skipRecord) {
        var tm = e._gsTransform, m = _getMatrix(e, true), v, x, y, xOrigin, yOrigin, a, b, c, d, tx, ty, determinant, xOriginOld, yOriginOld;
        if (tm) {
            xOriginOld = tm.xOrigin; //record the original values before we alter them.
            yOriginOld = tm.yOrigin;
        }
        if (!absolute || (v = absolute.split(" ")).length < 2) {
            b = e.getBBox();
            if (b.x === 0 && b.y === 0 && b.width + b.height === 0) b = {
                x: parseFloat(e.hasAttribute("x") ? e.getAttribute("x") : e.hasAttribute("cx") ? e.getAttribute("cx") : 0) || 0,
                y: parseFloat(e.hasAttribute("y") ? e.getAttribute("y") : e.hasAttribute("cy") ? e.getAttribute("cy") : 0) || 0,
                width: 0,
                height: 0
            };
            local = _parsePosition(local).split(" ");
            v = [
                (local[0].indexOf("%") !== -1 ? parseFloat(local[0]) / 100 * b.width : parseFloat(local[0])) + b.x,
                (local[1].indexOf("%") !== -1 ? parseFloat(local[1]) / 100 * b.height : parseFloat(local[1])) + b.y
            ];
        }
        decoratee.xOrigin = xOrigin = parseFloat(v[0]);
        decoratee.yOrigin = yOrigin = parseFloat(v[1]);
        if (absolute && m !== _identity2DMatrix) {
            a = m[0];
            b = m[1];
            c = m[2];
            d = m[3];
            tx = m[4];
            ty = m[5];
            determinant = a * d - b * c;
            if (determinant) {
                x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + (c * ty - d * tx) / determinant;
                y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - (a * ty - b * tx) / determinant;
                xOrigin = decoratee.xOrigin = v[0] = x;
                yOrigin = decoratee.yOrigin = v[1] = y;
            }
        }
        if (tm) {
            if (skipRecord) {
                decoratee.xOffset = tm.xOffset;
                decoratee.yOffset = tm.yOffset;
                tm = decoratee;
            }
            if (smoothOrigin || smoothOrigin !== false && CSSPlugin.defaultSmoothOrigin !== false) {
                x = xOrigin - xOriginOld;
                y = yOrigin - yOriginOld;
                //originally, we simply adjusted the x and y values, but that would cause problems if, for example, you created a rotational tween part-way through an x/y tween. Managing the offset in a separate variable gives us ultimate flexibility.
                //tm.x -= x - (x * m[0] + y * m[2]);
                //tm.y -= y - (x * m[1] + y * m[3]);
                tm.xOffset += x * m[0] + y * m[2] - x;
                tm.yOffset += x * m[1] + y * m[3] - y;
            } else tm.xOffset = tm.yOffset = 0;
        }
        if (!skipRecord) e.setAttribute("data-svg-origin", v.join(" "));
    }, _getBBoxHack = function(swapIfPossible) {
        var svg = _createElement("svg", this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), oldParent = this.parentNode, oldSibling = this.nextSibling, oldCSS = this.style.cssText, bbox;
        _docElement.appendChild(svg);
        svg.appendChild(this);
        this.style.display = "block";
        if (swapIfPossible) try {
            bbox = this.getBBox();
            this._originalGetBBox = this.getBBox;
            this.getBBox = _getBBoxHack;
        } catch (e) {}
        else if (this._originalGetBBox) bbox = this._originalGetBBox();
        if (oldSibling) oldParent.insertBefore(this, oldSibling);
        else oldParent.appendChild(this);
        _docElement.removeChild(svg);
        this.style.cssText = oldCSS;
        return bbox;
    }, _getBBox = function(e) {
        try {
            return e.getBBox(); //Firefox throws errors if you try calling getBBox() on an SVG element that's not rendered (like in a <symbol> or <defs>). https://bugzilla.mozilla.org/show_bug.cgi?id=612118
        } catch (error) {
            return _getBBoxHack.call(e, true);
        }
    }, _isSVG = function(e) {
        return !!(_SVGElement && e.getCTM && (!e.parentNode || e.ownerSVGElement) && _getBBox(e));
    }, _identity2DMatrix = [
        1,
        0,
        0,
        1,
        0,
        0
    ], _getMatrix = function(e, force2D) {
        var tm = e._gsTransform || new Transform(), rnd = 100000, style = e.style, isDefault, s, m, n, dec, nextSibling, parent;
        if (_transformProp) s = _getStyle(e, _transformPropCSS, null, true);
        else if (e.currentStyle) {
            //for older versions of IE, we need to interpret the filter portion that is in the format: progid:DXImageTransform.Microsoft.Matrix(M11=6.123233995736766e-17, M12=-1, M21=1, M22=6.123233995736766e-17, sizingMethod='auto expand') Notice that we need to swap b and c compared to a normal matrix.
            s = e.currentStyle.filter.match(_ieGetMatrixExp);
            s = s && s.length === 4 ? [
                s[0].substr(4),
                Number(s[2].substr(4)),
                Number(s[1].substr(4)),
                s[3].substr(4),
                tm.x || 0,
                tm.y || 0
            ].join(",") : "";
        }
        isDefault = !s || s === "none" || s === "matrix(1, 0, 0, 1, 0, 0)";
        if (_transformProp && isDefault && !e.offsetParent && e !== _docElement) {
            //browsers don't report transforms accurately unless the element is in the DOM and has a display value that's not "none". Firefox and Microsoft browsers have a partial bug where they'll report transforms even if display:none BUT not any percentage-based values like translate(-50%, 8px) will be reported as if it's translate(0, 8px).
            n = style.display;
            style.display = "block";
            parent = e.parentNode;
            if (!parent || !e.offsetParent) {
                dec = 1; //flag
                nextSibling = e.nextSibling;
                _docElement.appendChild(e); //we must add it to the DOM in order to get values properly
            }
            s = _getStyle(e, _transformPropCSS, null, true);
            isDefault = !s || s === "none" || s === "matrix(1, 0, 0, 1, 0, 0)";
            if (n) style.display = n;
            else _removeProp(style, "display");
            if (dec) {
                if (nextSibling) parent.insertBefore(e, nextSibling);
                else if (parent) parent.appendChild(e);
                else _docElement.removeChild(e);
            }
        }
        if (tm.svg || e.getCTM && _isSVG(e)) {
            if (isDefault && (style[_transformProp] + "").indexOf("matrix") !== -1) {
                s = style[_transformProp];
                isDefault = 0;
            }
            m = e.getAttribute("transform");
            if (isDefault && m) {
                m = e.transform.baseVal.consolidate().matrix; //ensures that even complex values like "translate(50,60) rotate(135,0,0)" are parsed because it mashes it into a matrix.
                s = "matrix(" + m.a + "," + m.b + "," + m.c + "," + m.d + "," + m.e + "," + m.f + ")";
                isDefault = 0;
            }
        }
        if (isDefault) return _identity2DMatrix;
        //split the matrix values out into an array (m for matrix)
        m = (s || "").match(_numExp) || [];
        i = m.length;
        while(--i > -1){
            n = Number(m[i]);
            m[i] = (dec = n - (n |= 0)) ? (dec * rnd + (dec < 0 ? -0.5 : 0.5) | 0) / rnd + n : n; //convert strings to Numbers and round to 5 decimal places to avoid issues with tiny numbers. Roughly 20x faster than Number.toFixed(). We also must make sure to round before dividing so that values like 0.9999999999 become 1 to avoid glitches in browser rendering and interpretation of flipped/rotated 3D matrices. And don't just multiply the number by rnd, floor it, and then divide by rnd because the bitwise operations max out at a 32-bit signed integer, thus it could get clipped at a relatively low value (like 22,000.00000 for example).
        }
        return force2D && m.length > 6 ? [
            m[0],
            m[1],
            m[4],
            m[5],
            m[12],
            m[13]
        ] : m;
    }, /**
			 * Parses the transform values for an element, returning an object with x, y, z, scaleX, scaleY, scaleZ, rotation, rotationX, rotationY, skewX, and skewY properties. Note: by default (for performance reasons), all skewing is combined into skewX and rotation but skewY still has a place in the transform object so that we can record how much of the skew is attributed to skewX vs skewY. Remember, a skewY of 10 looks the same as a rotation of 10 and skewX of -10.
			 * @param {!Object} t target element
			 * @param {Object=} cs computed style object (optional)
			 * @param {boolean=} rec if true, the transform values will be recorded to the target element's _gsTransform object, like target._gsTransform = {x:0, y:0, z:0, scaleX:1...}
			 * @param {boolean=} parse if true, we'll ignore any _gsTransform values that already exist on the element, and force a reparsing of the css (calculated style)
			 * @return {object} object containing all of the transform properties/values like {x:0, y:0, z:0, scaleX:1...}
			 */ _getTransform = _internals.getTransform = function(t, cs, rec, parse) {
        if (t._gsTransform && rec && !parse) return t._gsTransform; //if the element already has a _gsTransform, use that. Note: some browsers don't accurately return the calculated style for the transform (particularly for SVG), so it's almost always safest to just use the values we've already applied rather than re-parsing things.
        var tm = rec ? t._gsTransform || new Transform() : new Transform(), invX = tm.scaleX < 0, min = 0.00002, rnd = 100000, zOrigin = _supports3D ? parseFloat(_getStyle(t, _transformOriginProp, cs, false, "0 0 0").split(" ")[2]) || tm.zOrigin || 0 : 0, defaultTransformPerspective = parseFloat(CSSPlugin.defaultTransformPerspective) || 0, m, i, scaleX, scaleY, rotation, skewX;
        tm.svg = !!(t.getCTM && _isSVG(t));
        if (tm.svg) {
            _parseSVGOrigin(t, _getStyle(t, _transformOriginProp, cs, false, "50% 50%") + "", tm, t.getAttribute("data-svg-origin"));
            _useSVGTransformAttr = CSSPlugin.useSVGTransformAttr || _forceSVGTransformAttr;
        }
        m = _getMatrix(t);
        if (m !== _identity2DMatrix) {
            if (m.length === 16) {
                //we'll only look at these position-related 6 variables first because if x/y/z all match, it's relatively safe to assume we don't need to re-parse everything which risks losing important rotational information (like rotationX:180 plus rotationY:180 would look the same as rotation:180 - there's no way to know for sure which direction was taken based solely on the matrix3d() values)
                var a11 = m[0], a21 = m[1], a31 = m[2], a41 = m[3], a12 = m[4], a22 = m[5], a32 = m[6], a42 = m[7], a13 = m[8], a23 = m[9], a33 = m[10], a14 = m[12], a24 = m[13], a34 = m[14], a43 = m[11], angle = Math.atan2(a32, a33), t1, t2, t3, t4, cos, sin;
                //we manually compensate for non-zero z component of transformOrigin to work around bugs in Safari
                if (tm.zOrigin) {
                    a34 = -tm.zOrigin;
                    a14 = a13 * a34 - m[12];
                    a24 = a23 * a34 - m[13];
                    a34 = a33 * a34 + tm.zOrigin - m[14];
                }
                //note for possible future consolidation: rotationX: Math.atan2(a32, a33), rotationY: Math.atan2(-a31, Math.sqrt(a33 * a33 + a32 * a32)), rotation: Math.atan2(a21, a11), skew: Math.atan2(a12, a22). However, it doesn't seem to be quite as reliable as the full-on backwards rotation procedure.
                tm.rotationX = angle * _RAD2DEG;
                //rotationX
                if (angle) {
                    cos = Math.cos(-angle);
                    sin = Math.sin(-angle);
                    t1 = a12 * cos + a13 * sin;
                    t2 = a22 * cos + a23 * sin;
                    t3 = a32 * cos + a33 * sin;
                    a13 = a12 * -sin + a13 * cos;
                    a23 = a22 * -sin + a23 * cos;
                    a33 = a32 * -sin + a33 * cos;
                    a43 = a42 * -sin + a43 * cos;
                    a12 = t1;
                    a22 = t2;
                    a32 = t3;
                }
                //rotationY
                angle = Math.atan2(-a31, a33);
                tm.rotationY = angle * _RAD2DEG;
                if (angle) {
                    cos = Math.cos(-angle);
                    sin = Math.sin(-angle);
                    t1 = a11 * cos - a13 * sin;
                    t2 = a21 * cos - a23 * sin;
                    t3 = a31 * cos - a33 * sin;
                    a23 = a21 * sin + a23 * cos;
                    a33 = a31 * sin + a33 * cos;
                    a43 = a41 * sin + a43 * cos;
                    a11 = t1;
                    a21 = t2;
                    a31 = t3;
                }
                //rotationZ
                angle = Math.atan2(a21, a11);
                tm.rotation = angle * _RAD2DEG;
                if (angle) {
                    cos = Math.cos(angle);
                    sin = Math.sin(angle);
                    t1 = a11 * cos + a21 * sin;
                    t2 = a12 * cos + a22 * sin;
                    t3 = a13 * cos + a23 * sin;
                    a21 = a21 * cos - a11 * sin;
                    a22 = a22 * cos - a12 * sin;
                    a23 = a23 * cos - a13 * sin;
                    a11 = t1;
                    a12 = t2;
                    a13 = t3;
                }
                if (tm.rotationX && Math.abs(tm.rotationX) + Math.abs(tm.rotation) > 359.9) {
                    tm.rotationX = tm.rotation = 0;
                    tm.rotationY = 180 - tm.rotationY;
                }
                //skewX
                angle = Math.atan2(a12, a22);
                //scales
                tm.scaleX = (Math.sqrt(a11 * a11 + a21 * a21 + a31 * a31) * rnd + 0.5 | 0) / rnd;
                tm.scaleY = (Math.sqrt(a22 * a22 + a32 * a32) * rnd + 0.5 | 0) / rnd;
                tm.scaleZ = (Math.sqrt(a13 * a13 + a23 * a23 + a33 * a33) * rnd + 0.5 | 0) / rnd;
                a11 /= tm.scaleX;
                a12 /= tm.scaleY;
                a21 /= tm.scaleX;
                a22 /= tm.scaleY;
                if (Math.abs(angle) > min) {
                    tm.skewX = angle * _RAD2DEG;
                    a12 = 0; //unskews
                    if (tm.skewType !== "simple") tm.scaleY *= 1 / Math.cos(angle); //by default, we compensate the scale based on the skew so that the element maintains a similar proportion when skewed, so we have to alter the scaleY here accordingly to match the default (non-adjusted) skewing that CSS does (stretching more and more as it skews).
                } else tm.skewX = 0;
                /* //for testing purposes
						var transform = "matrix3d(",
							comma = ",",
							zero = "0";
						a13 /= tm.scaleZ;
						a23 /= tm.scaleZ;
						a31 /= tm.scaleX;
						a32 /= tm.scaleY;
						a33 /= tm.scaleZ;
						transform += ((a11 < min && a11 > -min) ? zero : a11) + comma + ((a21 < min && a21 > -min) ? zero : a21) + comma + ((a31 < min && a31 > -min) ? zero : a31);
						transform += comma + ((a41 < min && a41 > -min) ? zero : a41) + comma + ((a12 < min && a12 > -min) ? zero : a12) + comma + ((a22 < min && a22 > -min) ? zero : a22);
						transform += comma + ((a32 < min && a32 > -min) ? zero : a32) + comma + ((a42 < min && a42 > -min) ? zero : a42) + comma + ((a13 < min && a13 > -min) ? zero : a13);
						transform += comma + ((a23 < min && a23 > -min) ? zero : a23) + comma + ((a33 < min && a33 > -min) ? zero : a33) + comma + ((a43 < min && a43 > -min) ? zero : a43) + comma;
						transform += a14 + comma + a24 + comma + a34 + comma + (tm.perspective ? (1 + (-a34 / tm.perspective)) : 1) + ")";
						console.log(transform);
						document.querySelector(".test").style[_transformProp] = transform;
						*/ tm.perspective = a43 ? 1 / (a43 < 0 ? -a43 : a43) : 0;
                tm.x = a14;
                tm.y = a24;
                tm.z = a34;
                if (tm.svg) {
                    tm.x -= tm.xOrigin - (tm.xOrigin * a11 - tm.yOrigin * a12);
                    tm.y -= tm.yOrigin - (tm.yOrigin * a21 - tm.xOrigin * a22);
                }
            } else if (!_supports3D || parse || !m.length || tm.x !== m[4] || tm.y !== m[5] || !tm.rotationX && !tm.rotationY) {
                var k = m.length >= 6, a = k ? m[0] : 1, b = m[1] || 0, c = m[2] || 0, d = k ? m[3] : 1;
                tm.x = m[4] || 0;
                tm.y = m[5] || 0;
                scaleX = Math.sqrt(a * a + b * b);
                scaleY = Math.sqrt(d * d + c * c);
                rotation = a || b ? Math.atan2(b, a) * _RAD2DEG : tm.rotation || 0; //note: if scaleX is 0, we cannot accurately measure rotation. Same for skewX with a scaleY of 0. Therefore, we default to the previously recorded value (or zero if that doesn't exist).
                skewX = c || d ? Math.atan2(c, d) * _RAD2DEG + rotation : tm.skewX || 0;
                tm.scaleX = scaleX;
                tm.scaleY = scaleY;
                tm.rotation = rotation;
                tm.skewX = skewX;
                if (_supports3D) {
                    tm.rotationX = tm.rotationY = tm.z = 0;
                    tm.perspective = defaultTransformPerspective;
                    tm.scaleZ = 1;
                }
                if (tm.svg) {
                    tm.x -= tm.xOrigin - (tm.xOrigin * a + tm.yOrigin * c);
                    tm.y -= tm.yOrigin - (tm.xOrigin * b + tm.yOrigin * d);
                }
            }
            if (Math.abs(tm.skewX) > 90 && Math.abs(tm.skewX) < 270) {
                if (invX) {
                    tm.scaleX *= -1;
                    tm.skewX += tm.rotation <= 0 ? 180 : -180;
                    tm.rotation += tm.rotation <= 0 ? 180 : -180;
                } else {
                    tm.scaleY *= -1;
                    tm.skewX += tm.skewX <= 0 ? 180 : -180;
                }
            }
            tm.zOrigin = zOrigin;
            //some browsers have a hard time with very small values like 2.4492935982947064e-16 (notice the "e-" towards the end) and would render the object slightly off. So we round to 0 in these cases. The conditional logic here is faster than calling Math.abs(). Also, browsers tend to render a SLIGHTLY rotated object in a fuzzy way, so we need to snap to exactly 0 when appropriate.
            for(i in tm){
                if (tm[i] < min) {
                    if (tm[i] > -min) tm[i] = 0;
                }
            }
        }
        //DEBUG: _log("parsed rotation of " + t.getAttribute("id")+": "+(tm.rotationX)+", "+(tm.rotationY)+", "+(tm.rotation)+", scale: "+tm.scaleX+", "+tm.scaleY+", "+tm.scaleZ+", position: "+tm.x+", "+tm.y+", "+tm.z+", perspective: "+tm.perspective+ ", origin: "+ tm.xOrigin+ ","+ tm.yOrigin);
        if (rec) {
            t._gsTransform = tm; //record to the object's _gsTransform which we use so that tweens can control individual properties independently (we need all the properties to accurately recompose the matrix in the setRatio() method)
            if (tm.svg) {
                if (_useSVGTransformAttr && t.style[_transformProp]) (0, $hYzRA.default).delayedCall(0.001, function() {
                    _removeProp(t.style, _transformProp);
                });
                else if (!_useSVGTransformAttr && t.getAttribute("transform")) (0, $hYzRA.default).delayedCall(0.001, function() {
                    t.removeAttribute("transform");
                });
            }
        }
        return tm;
    }, //for setting 2D transforms in IE6, IE7, and IE8 (must use a "filter" to emulate the behavior of modern day browser transforms)
    _setIETransformRatio = function(v) {
        var t = this.data, ang = -t.rotation * _DEG2RAD, skew = ang + t.skewX * _DEG2RAD, rnd = 100000, a = (Math.cos(ang) * t.scaleX * rnd | 0) / rnd, b = (Math.sin(ang) * t.scaleX * rnd | 0) / rnd, c = (Math.sin(skew) * -t.scaleY * rnd | 0) / rnd, d = (Math.cos(skew) * t.scaleY * rnd | 0) / rnd, style = this.t.style, cs = this.t.currentStyle, filters, val;
        if (!cs) return;
        val = b; //just for swapping the variables an inverting them (reused "val" to avoid creating another variable in memory). IE's filter matrix uses a non-standard matrix configuration (angle goes the opposite way, and b and c are reversed and inverted)
        b = -c;
        c = -val;
        filters = cs.filter;
        style.filter = ""; //remove filters so that we can accurately measure offsetWidth/offsetHeight
        var w = this.t.offsetWidth, h = this.t.offsetHeight, clip = cs.position !== "absolute", m = "progid:DXImageTransform.Microsoft.Matrix(M11=" + a + ", M12=" + b + ", M21=" + c + ", M22=" + d, ox = t.x + w * t.xPercent / 100, oy = t.y + h * t.yPercent / 100, dx, dy;
        //if transformOrigin is being used, adjust the offset x and y
        if (t.ox != null) {
            dx = (t.oxp ? w * t.ox * 0.01 : t.ox) - w / 2;
            dy = (t.oyp ? h * t.oy * 0.01 : t.oy) - h / 2;
            ox += dx - (dx * a + dy * b);
            oy += dy - (dx * c + dy * d);
        }
        if (!clip) m += ", sizingMethod='auto expand')";
        else {
            dx = w / 2;
            dy = h / 2;
            //translate to ensure that transformations occur around the correct origin (default is center).
            m += ", Dx=" + (dx - (dx * a + dy * b) + ox) + ", Dy=" + (dy - (dx * c + dy * d) + oy) + ")";
        }
        if (filters.indexOf("DXImageTransform.Microsoft.Matrix(") !== -1) style.filter = filters.replace(_ieSetMatrixExp, m);
        else style.filter = m + " " + filters; //we must always put the transform/matrix FIRST (before alpha(opacity=xx)) to avoid an IE bug that slices part of the object when rotation is applied with alpha.
        //at the end or beginning of the tween, if the matrix is normal (1, 0, 0, 1) and opacity is 100 (or doesn't exist), remove the filter to improve browser performance.
        if (v === 0 || v === 1) {
            if (a === 1) {
                if (b === 0) {
                    if (c === 0) {
                        if (d === 1) {
                            if (!clip || m.indexOf("Dx=0, Dy=0") !== -1) {
                                if (!_opacityExp.test(filters) || parseFloat(RegExp.$1) === 100) {
                                    if (filters.indexOf(filters.indexOf("Alpha")) === -1) style.removeAttribute("filter");
                                }
                            }
                        }
                    }
                }
            }
        }
        //we must set the margins AFTER applying the filter in order to avoid some bugs in IE8 that could (in rare scenarios) cause them to be ignored intermittently (vibration).
        if (!clip) {
            var mult = _ieVers < 8 ? 1 : -1, marg, prop, dif;
            dx = t.ieOffsetX || 0;
            dy = t.ieOffsetY || 0;
            t.ieOffsetX = Math.round((w - ((a < 0 ? -a : a) * w + (b < 0 ? -b : b) * h)) / 2 + ox);
            t.ieOffsetY = Math.round((h - ((d < 0 ? -d : d) * h + (c < 0 ? -c : c) * w)) / 2 + oy);
            for(i = 0; i < 4; i++){
                prop = _margins[i];
                marg = cs[prop];
                //we need to get the current margin in case it is being tweened separately (we want to respect that tween's changes)
                val = marg.indexOf("px") !== -1 ? parseFloat(marg) : _convertToPixels(this.t, prop, parseFloat(marg), marg.replace(_suffixExp, "")) || 0;
                if (val !== t[prop]) dif = i < 2 ? -t.ieOffsetX : -t.ieOffsetY; //if another tween is controlling a margin, we cannot only apply the difference in the ieOffsets, so we essentially zero-out the dx and dy here in that case. We record the margin(s) later so that we can keep comparing them, making this code very flexible.
                else dif = i < 2 ? dx - t.ieOffsetX : dy - t.ieOffsetY;
                style[prop] = (t[prop] = Math.round(val - dif * (i === 0 || i === 2 ? 1 : mult))) + "px";
            }
        }
    }, /* translates a super small decimal to a string WITHOUT scientific notation
			_safeDecimal = function(n) {
				var s = (n < 0 ? -n : n) + "",
					a = s.split("e-");
				return (n < 0 ? "-0." : "0.") + new Array(parseInt(a[1], 10) || 0).join("0") + a[0].split(".").join("");
			},
			*/ _setTransformRatio = _internals.set3DTransformRatio = _internals.setTransformRatio = function(v) {
        var t = this.data, style = this.t.style, angle = t.rotation, rotationX = t.rotationX, rotationY = t.rotationY, sx = t.scaleX, sy = t.scaleY, sz = t.scaleZ, x = t.x, y = t.y, z = t.z, isSVG = t.svg, perspective = t.perspective, force3D = t.force3D, skewY = t.skewY, skewX = t.skewX, t1, a11, a12, a13, a21, a22, a23, a31, a32, a33, a41, a42, a43, zOrigin, min, cos, sin, t2, transform, comma, zero, skew, rnd;
        if (skewY) {
            skewX += skewY;
            angle += skewY;
        }
        //check to see if we should render as 2D (and SVGs must use 2D when _useSVGTransformAttr is true)
        if (((v === 1 || v === 0) && force3D === "auto" && (this.tween._totalTime === this.tween._totalDuration || !this.tween._totalTime) || !force3D) && !z && !perspective && !rotationY && !rotationX && sz === 1 || _useSVGTransformAttr && isSVG || !_supports3D) {
            //2D
            if (angle || skewX || isSVG) {
                angle *= _DEG2RAD;
                skew = skewX * _DEG2RAD;
                rnd = 100000;
                a11 = Math.cos(angle) * sx;
                a21 = Math.sin(angle) * sx;
                a12 = Math.sin(angle - skew) * -sy;
                a22 = Math.cos(angle - skew) * sy;
                if (skew && t.skewType === "simple") {
                    t1 = Math.tan(skew - skewY * _DEG2RAD);
                    t1 = Math.sqrt(1 + t1 * t1);
                    a12 *= t1;
                    a22 *= t1;
                    if (skewY) {
                        t1 = Math.tan(skewY * _DEG2RAD);
                        t1 = Math.sqrt(1 + t1 * t1);
                        a11 *= t1;
                        a21 *= t1;
                    }
                }
                if (isSVG) {
                    x += t.xOrigin - (t.xOrigin * a11 + t.yOrigin * a12) + t.xOffset;
                    y += t.yOrigin - (t.xOrigin * a21 + t.yOrigin * a22) + t.yOffset;
                    if (_useSVGTransformAttr && (t.xPercent || t.yPercent)) {
                        min = this.t.getBBox();
                        x += t.xPercent * 0.01 * min.width;
                        y += t.yPercent * 0.01 * min.height;
                    }
                    min = 0.000001;
                    if (x < min) {
                        if (x > -min) x = 0;
                    }
                    if (y < min) {
                        if (y > -min) y = 0;
                    }
                }
                transform = (a11 * rnd | 0) / rnd + "," + (a21 * rnd | 0) / rnd + "," + (a12 * rnd | 0) / rnd + "," + (a22 * rnd | 0) / rnd + "," + x + "," + y + ")";
                if (isSVG && _useSVGTransformAttr) this.t.setAttribute("transform", "matrix(" + transform);
                else //some browsers have a hard time with very small values like 2.4492935982947064e-16 (notice the "e-" towards the end) and would render the object slightly off. So we round to 5 decimal places.
                style[_transformProp] = (t.xPercent || t.yPercent ? "translate(" + t.xPercent + "%," + t.yPercent + "%) matrix(" : "matrix(") + transform;
            } else style[_transformProp] = (t.xPercent || t.yPercent ? "translate(" + t.xPercent + "%," + t.yPercent + "%) matrix(" : "matrix(") + sx + ",0,0," + sy + "," + x + "," + y + ")";
            return;
        }
        if (_isFirefox) {
            min = 0.0001;
            if (sx < min && sx > -min) sx = sz = 0.00002;
            if (sy < min && sy > -min) sy = sz = 0.00002;
            if (perspective && !t.z && !t.rotationX && !t.rotationY) perspective = 0;
        }
        if (angle || skewX) {
            angle *= _DEG2RAD;
            cos = a11 = Math.cos(angle);
            sin = a21 = Math.sin(angle);
            if (skewX) {
                angle -= skewX * _DEG2RAD;
                cos = Math.cos(angle);
                sin = Math.sin(angle);
                if (t.skewType === "simple") {
                    t1 = Math.tan((skewX - skewY) * _DEG2RAD);
                    t1 = Math.sqrt(1 + t1 * t1);
                    cos *= t1;
                    sin *= t1;
                    if (t.skewY) {
                        t1 = Math.tan(skewY * _DEG2RAD);
                        t1 = Math.sqrt(1 + t1 * t1);
                        a11 *= t1;
                        a21 *= t1;
                    }
                }
            }
            a12 = -sin;
            a22 = cos;
        } else if (!rotationY && !rotationX && sz === 1 && !perspective && !isSVG) {
            style[_transformProp] = (t.xPercent || t.yPercent ? "translate(" + t.xPercent + "%," + t.yPercent + "%) translate3d(" : "translate3d(") + x + "px," + y + "px," + z + "px)" + (sx !== 1 || sy !== 1 ? " scale(" + sx + "," + sy + ")" : "");
            return;
        } else {
            a11 = a22 = 1;
            a12 = a21 = 0;
        }
        // KEY  INDEX   AFFECTS a[row][column]
        // a11  0       rotation, rotationY, scaleX
        // a21  1       rotation, rotationY, scaleX
        // a31  2       rotationY, scaleX
        // a41  3       rotationY, scaleX
        // a12  4       rotation, skewX, rotationX, scaleY
        // a22  5       rotation, skewX, rotationX, scaleY
        // a32  6       rotationX, scaleY
        // a42  7       rotationX, scaleY
        // a13  8       rotationY, rotationX, scaleZ
        // a23  9       rotationY, rotationX, scaleZ
        // a33  10      rotationY, rotationX, scaleZ
        // a43  11      rotationY, rotationX, perspective, scaleZ
        // a14  12      x, zOrigin, svgOrigin
        // a24  13      y, zOrigin, svgOrigin
        // a34  14      z, zOrigin
        // a44  15
        // rotation: Math.atan2(a21, a11)
        // rotationY: Math.atan2(a13, a33) (or Math.atan2(a13, a11))
        // rotationX: Math.atan2(a32, a33)
        a33 = 1;
        a13 = a23 = a31 = a32 = a41 = a42 = 0;
        a43 = perspective ? -1 / perspective : 0;
        zOrigin = t.zOrigin;
        min = 0.000001; //threshold below which browsers use scientific notation which won't work.
        comma = ",";
        zero = "0";
        angle = rotationY * _DEG2RAD;
        if (angle) {
            cos = Math.cos(angle);
            sin = Math.sin(angle);
            a31 = -sin;
            a41 = a43 * -sin;
            a13 = a11 * sin;
            a23 = a21 * sin;
            a33 = cos;
            a43 *= cos;
            a11 *= cos;
            a21 *= cos;
        }
        angle = rotationX * _DEG2RAD;
        if (angle) {
            cos = Math.cos(angle);
            sin = Math.sin(angle);
            t1 = a12 * cos + a13 * sin;
            t2 = a22 * cos + a23 * sin;
            a32 = a33 * sin;
            a42 = a43 * sin;
            a13 = a12 * -sin + a13 * cos;
            a23 = a22 * -sin + a23 * cos;
            a33 = a33 * cos;
            a43 = a43 * cos;
            a12 = t1;
            a22 = t2;
        }
        if (sz !== 1) {
            a13 *= sz;
            a23 *= sz;
            a33 *= sz;
            a43 *= sz;
        }
        if (sy !== 1) {
            a12 *= sy;
            a22 *= sy;
            a32 *= sy;
            a42 *= sy;
        }
        if (sx !== 1) {
            a11 *= sx;
            a21 *= sx;
            a31 *= sx;
            a41 *= sx;
        }
        if (zOrigin || isSVG) {
            if (zOrigin) {
                x += a13 * -zOrigin;
                y += a23 * -zOrigin;
                z += a33 * -zOrigin + zOrigin;
            }
            if (isSVG) {
                x += t.xOrigin - (t.xOrigin * a11 + t.yOrigin * a12) + t.xOffset;
                y += t.yOrigin - (t.xOrigin * a21 + t.yOrigin * a22) + t.yOffset;
            }
            if (x < min && x > -min) x = zero;
            if (y < min && y > -min) y = zero;
            if (z < min && z > -min) z = 0; //don't use string because we calculate perspective later and need the number.
        }
        //optimized way of concatenating all the values into a string. If we do it all in one shot, it's slower because of the way browsers have to create temp strings and the way it affects memory. If we do it piece-by-piece with +=, it's a bit slower too. We found that doing it in these sized chunks works best overall:
        transform = t.xPercent || t.yPercent ? "translate(" + t.xPercent + "%," + t.yPercent + "%) matrix3d(" : "matrix3d(";
        transform += (a11 < min && a11 > -min ? zero : a11) + comma + (a21 < min && a21 > -min ? zero : a21) + comma + (a31 < min && a31 > -min ? zero : a31);
        transform += comma + (a41 < min && a41 > -min ? zero : a41) + comma + (a12 < min && a12 > -min ? zero : a12) + comma + (a22 < min && a22 > -min ? zero : a22);
        if (rotationX || rotationY || sz !== 1) {
            transform += comma + (a32 < min && a32 > -min ? zero : a32) + comma + (a42 < min && a42 > -min ? zero : a42) + comma + (a13 < min && a13 > -min ? zero : a13);
            transform += comma + (a23 < min && a23 > -min ? zero : a23) + comma + (a33 < min && a33 > -min ? zero : a33) + comma + (a43 < min && a43 > -min ? zero : a43) + comma;
        } else transform += ",0,0,0,0,1,0,";
        transform += x + comma + y + comma + z + comma + (perspective ? 1 + -z / perspective : 1) + ")";
        style[_transformProp] = transform;
    };
    p = Transform.prototype;
    p.x = p.y = p.z = p.skewX = p.skewY = p.rotation = p.rotationX = p.rotationY = p.zOrigin = p.xPercent = p.yPercent = p.xOffset = p.yOffset = 0;
    p.scaleX = p.scaleY = p.scaleZ = 1;
    _registerComplexSpecialProp("transform,scale,scaleX,scaleY,scaleZ,x,y,z,rotation,rotationX,rotationY,rotationZ,skewX,skewY,shortRotation,shortRotationX,shortRotationY,shortRotationZ,transformOrigin,svgOrigin,transformPerspective,directionalRotation,parseTransform,force3D,skewType,xPercent,yPercent,smoothOrigin", {
        parser: function(t, e, parsingProp, cssp, pt, plugin, vars) {
            if (cssp._lastParsedTransform === vars) return pt;
             //only need to parse the transform once, and only if the browser supports it.
            cssp._lastParsedTransform = vars;
            var scaleFunc = vars.scale && typeof vars.scale === "function" ? vars.scale : 0; //if there's a function-based "scale" value, swap in the resulting numeric value temporarily. Otherwise, if it's called for both scaleX and scaleY independently, they may not match (like if the function uses Math.random()).
            if (scaleFunc) vars.scale = scaleFunc(_index, t);
            var originalGSTransform = t._gsTransform, style = t.style, min = 0.000001, i = _transformProps.length, v = vars, endRotations = {}, transformOriginString = "transformOrigin", m1 = _getTransform(t, _cs, true, v.parseTransform), orig = v.transform && (typeof v.transform === "function" ? v.transform(_index, _target) : v.transform), m2, copy, has3D, hasChange, dr, x, y, matrix, p;
            m1.skewType = v.skewType || m1.skewType || CSSPlugin.defaultSkewType;
            cssp._transform = m1;
            if ("rotationZ" in v) v.rotation = v.rotationZ;
            if (orig && typeof orig === "string" && _transformProp) {
                copy = _tempDiv.style; //don't use the original target because it might be SVG in which case some browsers don't report computed style correctly.
                copy[_transformProp] = orig;
                copy.display = "block"; //if display is "none", the browser often refuses to report the transform properties correctly.
                copy.position = "absolute";
                if (orig.indexOf("%") !== -1) {
                    copy.width = _getStyle(t, "width");
                    copy.height = _getStyle(t, "height");
                }
                _doc.body.appendChild(_tempDiv);
                m2 = _getTransform(_tempDiv, null, false);
                if (m1.skewType === "simple") m2.scaleY *= Math.cos(m2.skewX * _DEG2RAD);
                if (m1.svg) {
                    x = m1.xOrigin;
                    y = m1.yOrigin;
                    m2.x -= m1.xOffset;
                    m2.y -= m1.yOffset;
                    if (v.transformOrigin || v.svgOrigin) {
                        orig = {};
                        _parseSVGOrigin(t, _parsePosition(v.transformOrigin), orig, v.svgOrigin, v.smoothOrigin, true);
                        x = orig.xOrigin;
                        y = orig.yOrigin;
                        m2.x -= orig.xOffset - m1.xOffset;
                        m2.y -= orig.yOffset - m1.yOffset;
                    }
                    if (x || y) {
                        matrix = _getMatrix(_tempDiv, true);
                        m2.x -= x - (x * matrix[0] + y * matrix[2]);
                        m2.y -= y - (x * matrix[1] + y * matrix[3]);
                    }
                }
                _doc.body.removeChild(_tempDiv);
                if (!m2.perspective) m2.perspective = m1.perspective; //tweening to no perspective gives very unintuitive results - just keep the same perspective in that case.
                if (v.xPercent != null) m2.xPercent = _parseVal(v.xPercent, m1.xPercent);
                if (v.yPercent != null) m2.yPercent = _parseVal(v.yPercent, m1.yPercent);
            } else if (typeof v === "object") {
                m2 = {
                    scaleX: _parseVal(v.scaleX != null ? v.scaleX : v.scale, m1.scaleX),
                    scaleY: _parseVal(v.scaleY != null ? v.scaleY : v.scale, m1.scaleY),
                    scaleZ: _parseVal(v.scaleZ, m1.scaleZ),
                    x: _parseVal(v.x, m1.x),
                    y: _parseVal(v.y, m1.y),
                    z: _parseVal(v.z, m1.z),
                    xPercent: _parseVal(v.xPercent, m1.xPercent),
                    yPercent: _parseVal(v.yPercent, m1.yPercent),
                    perspective: _parseVal(v.transformPerspective, m1.perspective)
                };
                dr = v.directionalRotation;
                if (dr != null) {
                    if (typeof dr === "object") for(copy in dr)v[copy] = dr[copy];
                    else v.rotation = dr;
                }
                if (typeof v.x === "string" && v.x.indexOf("%") !== -1) {
                    m2.x = 0;
                    m2.xPercent = _parseVal(v.x, m1.xPercent);
                }
                if (typeof v.y === "string" && v.y.indexOf("%") !== -1) {
                    m2.y = 0;
                    m2.yPercent = _parseVal(v.y, m1.yPercent);
                }
                m2.rotation = _parseAngle("rotation" in v ? v.rotation : "shortRotation" in v ? v.shortRotation + "_short" : m1.rotation, m1.rotation, "rotation", endRotations);
                if (_supports3D) {
                    m2.rotationX = _parseAngle("rotationX" in v ? v.rotationX : "shortRotationX" in v ? v.shortRotationX + "_short" : m1.rotationX || 0, m1.rotationX, "rotationX", endRotations);
                    m2.rotationY = _parseAngle("rotationY" in v ? v.rotationY : "shortRotationY" in v ? v.shortRotationY + "_short" : m1.rotationY || 0, m1.rotationY, "rotationY", endRotations);
                }
                m2.skewX = _parseAngle(v.skewX, m1.skewX);
                m2.skewY = _parseAngle(v.skewY, m1.skewY);
            }
            if (_supports3D && v.force3D != null) {
                m1.force3D = v.force3D;
                hasChange = true;
            }
            has3D = m1.force3D || m1.z || m1.rotationX || m1.rotationY || m2.z || m2.rotationX || m2.rotationY || m2.perspective;
            if (!has3D && v.scale != null) m2.scaleZ = 1; //no need to tween scaleZ.
            while(--i > -1){
                p = _transformProps[i];
                orig = m2[p] - m1[p];
                if (orig > min || orig < -min || v[p] != null || _forcePT[p] != null) {
                    hasChange = true;
                    pt = new CSSPropTween(m1, p, m1[p], orig, pt);
                    if (p in endRotations) pt.e = endRotations[p]; //directional rotations typically have compensated values during the tween, but we need to make sure they end at exactly what the user requested
                    pt.xs0 = 0; //ensures the value stays numeric in setRatio()
                    pt.plugin = plugin;
                    cssp._overwriteProps.push(pt.n);
                }
            }
            orig = typeof v.transformOrigin === "function" ? v.transformOrigin(_index, _target) : v.transformOrigin;
            if (m1.svg && (orig || v.svgOrigin)) {
                x = m1.xOffset; //when we change the origin, in order to prevent things from jumping we adjust the x/y so we must record those here so that we can create PropTweens for them and flip them at the same time as the origin
                y = m1.yOffset;
                _parseSVGOrigin(t, _parsePosition(orig), m2, v.svgOrigin, v.smoothOrigin);
                pt = _addNonTweeningNumericPT(m1, "xOrigin", (originalGSTransform ? m1 : m2).xOrigin, m2.xOrigin, pt, transformOriginString); //note: if there wasn't a transformOrigin defined yet, just start with the destination one; it's wasteful otherwise, and it causes problems with fromTo() tweens. For example, TweenLite.to("#wheel", 3, {rotation:180, transformOrigin:"50% 50%", delay:1}); TweenLite.fromTo("#wheel", 3, {scale:0.5, transformOrigin:"50% 50%"}, {scale:1, delay:2}); would cause a jump when the from values revert at the beginning of the 2nd tween.
                pt = _addNonTweeningNumericPT(m1, "yOrigin", (originalGSTransform ? m1 : m2).yOrigin, m2.yOrigin, pt, transformOriginString);
                if (x !== m1.xOffset || y !== m1.yOffset) {
                    pt = _addNonTweeningNumericPT(m1, "xOffset", originalGSTransform ? x : m1.xOffset, m1.xOffset, pt, transformOriginString);
                    pt = _addNonTweeningNumericPT(m1, "yOffset", originalGSTransform ? y : m1.yOffset, m1.yOffset, pt, transformOriginString);
                }
                orig = "0px 0px"; //certain browsers (like firefox) completely botch transform-origin, so we must remove it to prevent it from contaminating transforms. We manage it ourselves with xOrigin and yOrigin
            }
            if (orig || _supports3D && has3D && m1.zOrigin) {
                if (_transformProp) {
                    hasChange = true;
                    p = _transformOriginProp;
                    if (!orig) {
                        orig = (_getStyle(t, p, _cs, false, "50% 50%") + "").split(" ");
                        orig = orig[0] + " " + orig[1] + " " + m1.zOrigin + "px";
                    }
                    orig += "";
                    pt = new CSSPropTween(style, p, 0, 0, pt, -1, transformOriginString);
                    pt.b = style[p];
                    pt.plugin = plugin;
                    if (_supports3D) {
                        copy = m1.zOrigin;
                        orig = orig.split(" ");
                        m1.zOrigin = (orig.length > 2 ? parseFloat(orig[2]) : copy) || 0; //Safari doesn't handle the z part of transformOrigin correctly, so we'll manually handle it in the _set3DTransformRatio() method.
                        pt.xs0 = pt.e = orig[0] + " " + (orig[1] || "50%") + " 0px"; //we must define a z value of 0px specifically otherwise iOS 5 Safari will stick with the old one (if one was defined)!
                        pt = new CSSPropTween(m1, "zOrigin", 0, 0, pt, -1, pt.n); //we must create a CSSPropTween for the _gsTransform.zOrigin so that it gets reset properly at the beginning if the tween runs backward (as opposed to just setting m1.zOrigin here)
                        pt.b = copy;
                        pt.xs0 = pt.e = m1.zOrigin;
                    } else pt.xs0 = pt.e = orig;
                //for older versions of IE (6-8), we need to manually calculate things inside the setRatio() function. We record origin x and y (ox and oy) and whether or not the values are percentages (oxp and oyp).
                } else _parsePosition(orig + "", m1);
            }
            if (hasChange) cssp._transformType = !(m1.svg && _useSVGTransformAttr) && (has3D || this._transformType === 3) ? 3 : 2; //quicker than calling cssp._enableTransforms();
            if (scaleFunc) vars.scale = scaleFunc;
            return pt;
        },
        allowFunc: true,
        prefix: true
    });
    _registerComplexSpecialProp("boxShadow", {
        defaultValue: "0px 0px 0px 0px #999",
        prefix: true,
        color: true,
        multi: true,
        keyword: "inset"
    });
    _registerComplexSpecialProp("clipPath", {
        defaultValue: "inset(0%)",
        prefix: true,
        multi: true,
        formatter: _getFormatter("inset(0% 0% 0% 0%)", false, true)
    });
    _registerComplexSpecialProp("borderRadius", {
        defaultValue: "0px",
        parser: function(t, e, p, cssp, pt, plugin) {
            e = this.format(e);
            var props = [
                "borderTopLeftRadius",
                "borderTopRightRadius",
                "borderBottomRightRadius",
                "borderBottomLeftRadius"
            ], style = t.style, ea1, i, es2, bs2, bs, es, bn, en, w, h, esfx, bsfx, rel, hn, vn, em;
            w = parseFloat(t.offsetWidth);
            h = parseFloat(t.offsetHeight);
            ea1 = e.split(" ");
            for(i = 0; i < props.length; i++){
                if (this.p.indexOf("border")) props[i] = _checkPropPrefix(props[i]);
                bs = bs2 = _getStyle(t, props[i], _cs, false, "0px");
                if (bs.indexOf(" ") !== -1) {
                    bs2 = bs.split(" ");
                    bs = bs2[0];
                    bs2 = bs2[1];
                }
                es = es2 = ea1[i];
                bn = parseFloat(bs);
                bsfx = bs.substr((bn + "").length);
                rel = es.charAt(1) === "=";
                if (rel) {
                    en = parseInt(es.charAt(0) + "1", 10);
                    es = es.substr(2);
                    en *= parseFloat(es);
                    esfx = es.substr((en + "").length - (en < 0 ? 1 : 0)) || "";
                } else {
                    en = parseFloat(es);
                    esfx = es.substr((en + "").length);
                }
                if (esfx === "") esfx = _suffixMap[p] || bsfx;
                if (esfx !== bsfx) {
                    hn = _convertToPixels(t, "borderLeft", bn, bsfx); //horizontal number (we use a bogus "borderLeft" property just because the _convertToPixels() method searches for the keywords "Left", "Right", "Top", and "Bottom" to determine of it's a horizontal or vertical property, and we need "border" in the name so that it knows it should measure relative to the element itself, not its parent.
                    vn = _convertToPixels(t, "borderTop", bn, bsfx); //vertical number
                    if (esfx === "%") {
                        bs = hn / w * 100 + "%";
                        bs2 = vn / h * 100 + "%";
                    } else if (esfx === "em") {
                        em = _convertToPixels(t, "borderLeft", 1, "em");
                        bs = hn / em + "em";
                        bs2 = vn / em + "em";
                    } else {
                        bs = hn + "px";
                        bs2 = vn + "px";
                    }
                    if (rel) {
                        es = parseFloat(bs) + en + esfx;
                        es2 = parseFloat(bs2) + en + esfx;
                    }
                }
                pt = _parseComplex(style, props[i], bs + " " + bs2, es + " " + es2, false, "0px", pt);
            }
            return pt;
        },
        prefix: true,
        formatter: _getFormatter("0px 0px 0px 0px", false, true)
    });
    _registerComplexSpecialProp("borderBottomLeftRadius,borderBottomRightRadius,borderTopLeftRadius,borderTopRightRadius", {
        defaultValue: "0px",
        parser: function(t, e, p, cssp, pt, plugin) {
            return _parseComplex(t.style, p, this.format(_getStyle(t, p, _cs, false, "0px 0px")), this.format(e), false, "0px", pt);
        },
        prefix: true,
        formatter: _getFormatter("0px 0px", false, true)
    });
    _registerComplexSpecialProp("backgroundPosition", {
        defaultValue: "0 0",
        parser: function(t, e, p, cssp, pt, plugin) {
            var bp = "background-position", cs = _cs || _getComputedStyle(t, null), bs = this.format((cs ? _ieVers ? cs.getPropertyValue(bp + "-x") + " " + cs.getPropertyValue(bp + "-y") : cs.getPropertyValue(bp) : t.currentStyle.backgroundPositionX + " " + t.currentStyle.backgroundPositionY) || "0 0"), es = this.format(e), ba, ea, i, pct, overlap, src;
            if (bs.indexOf("%") !== -1 !== (es.indexOf("%") !== -1) && es.split(",").length < 2) {
                src = _getStyle(t, "backgroundImage").replace(_urlExp, "");
                if (src && src !== "none") {
                    ba = bs.split(" ");
                    ea = es.split(" ");
                    _tempImg.setAttribute("src", src); //set the temp IMG's src to the background-image so that we can measure its width/height
                    i = 2;
                    while(--i > -1){
                        bs = ba[i];
                        pct = bs.indexOf("%") !== -1;
                        if (pct !== (ea[i].indexOf("%") !== -1)) {
                            overlap = i === 0 ? t.offsetWidth - _tempImg.width : t.offsetHeight - _tempImg.height;
                            ba[i] = pct ? parseFloat(bs) / 100 * overlap + "px" : parseFloat(bs) / overlap * 100 + "%";
                        }
                    }
                    bs = ba.join(" ");
                }
            }
            return this.parseComplex(t.style, bs, es, pt, plugin);
        },
        formatter: _parsePosition
    });
    _registerComplexSpecialProp("backgroundSize", {
        defaultValue: "0 0",
        formatter: function(v) {
            v += ""; //ensure it's a string
            return v.substr(0, 2) === "co" ? v : _parsePosition(v.indexOf(" ") === -1 ? v + " " + v : v); //if set to something like "100% 100%", Safari typically reports the computed style as just "100%" (no 2nd value), but we should ensure that there are two values, so copy the first one. Otherwise, it'd be interpreted as "100% 0" (wrong). Also remember that it could be "cover" or "contain" which we can't tween but should be able to set.
        }
    });
    _registerComplexSpecialProp("perspective", {
        defaultValue: "0px",
        prefix: true
    });
    _registerComplexSpecialProp("perspectiveOrigin", {
        defaultValue: "50% 50%",
        prefix: true
    });
    _registerComplexSpecialProp("transformStyle", {
        prefix: true
    });
    _registerComplexSpecialProp("backfaceVisibility", {
        prefix: true
    });
    _registerComplexSpecialProp("userSelect", {
        prefix: true
    });
    _registerComplexSpecialProp("margin", {
        parser: _getEdgeParser("marginTop,marginRight,marginBottom,marginLeft")
    });
    _registerComplexSpecialProp("padding", {
        parser: _getEdgeParser("paddingTop,paddingRight,paddingBottom,paddingLeft")
    });
    _registerComplexSpecialProp("clip", {
        defaultValue: "rect(0px,0px,0px,0px)",
        parser: function(t, e, p, cssp, pt, plugin) {
            var b, cs, delim;
            if (_ieVers < 9) {
                cs = t.currentStyle;
                delim = _ieVers < 8 ? " " : ",";
                b = "rect(" + cs.clipTop + delim + cs.clipRight + delim + cs.clipBottom + delim + cs.clipLeft + ")";
                e = this.format(e).split(",").join(delim);
            } else {
                b = this.format(_getStyle(t, this.p, _cs, false, this.dflt));
                e = this.format(e);
            }
            return this.parseComplex(t.style, b, e, pt, plugin);
        }
    });
    _registerComplexSpecialProp("textShadow", {
        defaultValue: "0px 0px 0px #999",
        color: true,
        multi: true
    });
    _registerComplexSpecialProp("autoRound,strictUnits", {
        parser: function(t, e, p, cssp, pt) {
            return pt;
        }
    }); //just so that we can ignore these properties (not tween them)
    _registerComplexSpecialProp("border", {
        defaultValue: "0px solid #000",
        parser: function(t, e, p, cssp, pt, plugin) {
            var bw = _getStyle(t, "borderTopWidth", _cs, false, "0px"), end = this.format(e).split(" "), esfx = end[0].replace(_suffixExp, "");
            if (esfx !== "px") bw = parseFloat(bw) / _convertToPixels(t, "borderTopWidth", 1, esfx) + esfx;
            return this.parseComplex(t.style, this.format(bw + " " + _getStyle(t, "borderTopStyle", _cs, false, "solid") + " " + _getStyle(t, "borderTopColor", _cs, false, "#000")), end.join(" "), pt, plugin);
        },
        color: true,
        formatter: function(v) {
            var a = v.split(" ");
            return a[0] + " " + (a[1] || "solid") + " " + (v.match(_colorExp) || [
                "#000"
            ])[0];
        }
    });
    _registerComplexSpecialProp("borderWidth", {
        parser: _getEdgeParser("borderTopWidth,borderRightWidth,borderBottomWidth,borderLeftWidth")
    }); //Firefox doesn't pick up on borderWidth set in style sheets (only inline).
    _registerComplexSpecialProp("float,cssFloat,styleFloat", {
        parser: function(t, e, p, cssp, pt, plugin) {
            var s = t.style, prop = "cssFloat" in s ? "cssFloat" : "styleFloat";
            return new CSSPropTween(s, prop, 0, 0, pt, -1, p, false, 0, s[prop], e);
        }
    });
    //opacity-related
    var _setIEOpacityRatio = function(v) {
        var t = this.t, filters = t.filter || _getStyle(this.data, "filter") || "", val = this.s + this.c * v | 0, skip;
        if (val === 100) {
            if (filters.indexOf("atrix(") === -1 && filters.indexOf("radient(") === -1 && filters.indexOf("oader(") === -1) {
                t.removeAttribute("filter");
                skip = !_getStyle(this.data, "filter"); //if a class is applied that has an alpha filter, it will take effect (we don't want that), so re-apply our alpha filter in that case. We must first remove it and then check.
            } else {
                t.filter = filters.replace(_alphaFilterExp, "");
                skip = true;
            }
        }
        if (!skip) {
            if (this.xn1) t.filter = filters = filters || "alpha(opacity=" + val + ")"; //works around bug in IE7/8 that prevents changes to "visibility" from being applied properly if the filter is changed to a different alpha on the same frame.
            if (filters.indexOf("pacity") === -1) {
                if (val !== 0 || !this.xn1) t.filter = filters + " alpha(opacity=" + val + ")"; //we round the value because otherwise, bugs in IE7/8 can prevent "visibility" changes from being applied properly.
            } else t.filter = filters.replace(_opacityExp, "opacity=" + val);
        }
    };
    _registerComplexSpecialProp("opacity,alpha,autoAlpha", {
        defaultValue: "1",
        parser: function(t, e, p, cssp, pt, plugin) {
            var b = parseFloat(_getStyle(t, "opacity", _cs, false, "1")), style = t.style, isAutoAlpha = p === "autoAlpha";
            if (typeof e === "string" && e.charAt(1) === "=") e = (e.charAt(0) === "-" ? -1 : 1) * parseFloat(e.substr(2)) + b;
            if (isAutoAlpha && b === 1 && _getStyle(t, "visibility", _cs) === "hidden" && e !== 0) b = 0;
            if (_supportsOpacity) pt = new CSSPropTween(style, "opacity", b, e - b, pt);
            else {
                pt = new CSSPropTween(style, "opacity", b * 100, (e - b) * 100, pt);
                pt.xn1 = isAutoAlpha ? 1 : 0; //we need to record whether or not this is an autoAlpha so that in the setRatio(), we know to duplicate the setting of the alpha in order to work around a bug in IE7 and IE8 that prevents changes to "visibility" from taking effect if the filter is changed to a different alpha(opacity) at the same time. Setting it to the SAME value first, then the new value works around the IE7/8 bug.
                style.zoom = 1; //helps correct an IE issue.
                pt.type = 2;
                pt.b = "alpha(opacity=" + pt.s + ")";
                pt.e = "alpha(opacity=" + (pt.s + pt.c) + ")";
                pt.data = t;
                pt.plugin = plugin;
                pt.setRatio = _setIEOpacityRatio;
            }
            if (isAutoAlpha) {
                pt = new CSSPropTween(style, "visibility", 0, 0, pt, -1, null, false, 0, b !== 0 ? "inherit" : "hidden", e === 0 ? "hidden" : "inherit");
                pt.xs0 = "inherit";
                cssp._overwriteProps.push(pt.n);
                cssp._overwriteProps.push(p);
            }
            return pt;
        }
    });
    var _removeProp = function(s, p) {
        if (p) {
            if (s.removeProperty) {
                if (p.substr(0, 2) === "ms" || p.substr(0, 6) === "webkit") p = "-" + p;
                s.removeProperty(p.replace(_capsExp, "-$1").toLowerCase());
            } else s.removeAttribute(p);
        }
    }, _setClassNameRatio = function(v) {
        this.t._gsClassPT = this;
        if (v === 1 || v === 0) {
            this.t.setAttribute("class", v === 0 ? this.b : this.e);
            var mpt = this.data, s = this.t.style;
            while(mpt){
                if (!mpt.v) _removeProp(s, mpt.p);
                else s[mpt.p] = mpt.v;
                mpt = mpt._next;
            }
            if (v === 1 && this.t._gsClassPT === this) this.t._gsClassPT = null;
        } else if (this.t.getAttribute("class") !== this.e) this.t.setAttribute("class", this.e);
    };
    _registerComplexSpecialProp("className", {
        parser: function(t, e, p, cssp, pt, plugin, vars) {
            var b = t.getAttribute("class") || "", cssText = t.style.cssText, difData, bs, cnpt, cnptLookup, mpt;
            pt = cssp._classNamePT = new CSSPropTween(t, p, 0, 0, pt, 2);
            pt.setRatio = _setClassNameRatio;
            pt.pr = -11;
            _hasPriority = true;
            pt.b = b;
            bs = _getAllStyles(t, _cs);
            //if there's a className tween already operating on the target, force it to its end so that the necessary inline styles are removed and the class name is applied before we determine the end state (we don't want inline styles interfering that were there just for class-specific values)
            cnpt = t._gsClassPT;
            if (cnpt) {
                cnptLookup = {};
                mpt = cnpt.data; //first MiniPropTween which stores the inline styles - we need to force these so that the inline styles don't contaminate things. Otherwise, there's a small chance that a tween could start and the inline values match the destination values and they never get cleaned.
                while(mpt){
                    cnptLookup[mpt.p] = 1;
                    mpt = mpt._next;
                }
                cnpt.setRatio(1);
            }
            t._gsClassPT = pt;
            pt.e = e.charAt(1) !== "=" ? e : b.replace(new RegExp("(?:\\s|^)" + e.substr(2) + "(?![\\w-])"), "") + (e.charAt(0) === "+" ? " " + e.substr(2) : "");
            t.setAttribute("class", pt.e);
            difData = _cssDif(t, bs, _getAllStyles(t), vars, cnptLookup);
            t.setAttribute("class", b);
            pt.data = difData.firstMPT;
            if (t.style.cssText !== cssText) t.style.cssText = cssText; //we recorded cssText before we swapped classes and ran _getAllStyles() because in cases when a className tween is overwritten, we remove all the related tweening properties from that class change (otherwise class-specific stuff can't override properties we've directly set on the target's style object due to specificity).
            pt = pt.xfirst = cssp.parse(t, difData.difs, pt, plugin); //we record the CSSPropTween as the xfirst so that we can handle overwriting propertly (if "className" gets overwritten, we must kill all the properties associated with the className part of the tween, so we can loop through from xfirst to the pt itself)
            return pt;
        }
    });
    var _setClearPropsRatio = function(v) {
        if (v === 1 || v === 0) {
            if (this.data._totalTime === this.data._totalDuration && this.data.data !== "isFromStart") {
                var s = this.t.style, transformParse = _specialProps.transform.parse, a, p, i, clearTransform, transform;
                if (this.e === "all") {
                    s.cssText = "";
                    clearTransform = true;
                } else {
                    a = this.e.split(" ").join("").split(",");
                    i = a.length;
                    while(--i > -1){
                        p = a[i];
                        if (_specialProps[p]) {
                            if (_specialProps[p].parse === transformParse) clearTransform = true;
                            else p = p === "transformOrigin" ? _transformOriginProp : _specialProps[p].p; //ensures that special properties use the proper browser-specific property name, like "scaleX" might be "-webkit-transform" or "boxShadow" might be "-moz-box-shadow"
                        }
                        _removeProp(s, p);
                    }
                }
                if (clearTransform) {
                    _removeProp(s, _transformProp);
                    transform = this.t._gsTransform;
                    if (transform) {
                        if (transform.svg) {
                            this.t.removeAttribute("data-svg-origin");
                            this.t.removeAttribute("transform");
                        }
                        delete this.t._gsTransform;
                    }
                }
            }
        }
    };
    _registerComplexSpecialProp("clearProps", {
        parser: function(t, e, p, cssp, pt) {
            pt = new CSSPropTween(t, p, 0, 0, pt, 2);
            pt.setRatio = _setClearPropsRatio;
            pt.e = e;
            pt.pr = -10;
            pt.data = cssp._tween;
            _hasPriority = true;
            return pt;
        }
    });
    p = "bezier,throwProps,physicsProps,physics2D".split(",");
    i = p.length;
    while(i--)_registerPluginProp(p[i]);
    p = CSSPlugin.prototype;
    p._firstPT = p._lastParsedTransform = p._transform = null;
    //gets called when the tween renders for the first time. This kicks everything off, recording start/end values, etc.
    p._onInitTween = function(target, vars, tween, index) {
        if (!target.nodeType) return false;
        this._target = _target = target;
        this._tween = tween;
        this._vars = vars;
        _index = index;
        _autoRound = vars.autoRound;
        _hasPriority = false;
        _suffixMap = vars.suffixMap || CSSPlugin.suffixMap;
        _cs = _getComputedStyle(target, "");
        _overwriteProps = this._overwriteProps;
        var style = target.style, v, pt, pt2, first, last, next, zIndex, tpt, threeD;
        if (_reqSafariFix) {
            if (style.zIndex === "") {
                v = _getStyle(target, "zIndex", _cs);
                if (v === "auto" || v === "") //corrects a bug in [non-Android] Safari that prevents it from repainting elements in their new positions if they don't have a zIndex set. We also can't just apply this inside _parseTransform() because anything that's moved in any way (like using "left" or "top" instead of transforms like "x" and "y") can be affected, so it is best to ensure that anything that's tweening has a z-index. Setting "WebkitPerspective" to a non-zero value worked too except that on iOS Safari things would flicker randomly. Plus zIndex is less memory-intensive.
                this._addLazySet(style, "zIndex", 0);
            }
        }
        if (typeof vars === "string") {
            first = style.cssText;
            v = _getAllStyles(target, _cs);
            style.cssText = first + ";" + vars;
            v = _cssDif(target, v, _getAllStyles(target)).difs;
            if (!_supportsOpacity && _opacityValExp.test(vars)) v.opacity = parseFloat(RegExp.$1);
            vars = v;
            style.cssText = first;
        }
        if (vars.className) this._firstPT = pt = _specialProps.className.parse(target, vars.className, "className", this, null, null, vars);
        else this._firstPT = pt = this.parse(target, vars, null);
        if (this._transformType) {
            threeD = this._transformType === 3;
            if (!_transformProp) style.zoom = 1; //helps correct an IE issue.
            else if (_isSafari) {
                _reqSafariFix = true;
                //if zIndex isn't set, iOS Safari doesn't repaint things correctly sometimes (seemingly at random).
                if (style.zIndex === "") {
                    zIndex = _getStyle(target, "zIndex", _cs);
                    if (zIndex === "auto" || zIndex === "") this._addLazySet(style, "zIndex", 0);
                }
                //Setting WebkitBackfaceVisibility corrects 3 bugs:
                // 1) [non-Android] Safari skips rendering changes to "top" and "left" that are made on the same frame/render as a transform update.
                // 2) iOS Safari sometimes neglects to repaint elements in their new positions. Setting "WebkitPerspective" to a non-zero value worked too except that on iOS Safari things would flicker randomly.
                // 3) Safari sometimes displayed odd artifacts when tweening the transform (or WebkitTransform) property, like ghosts of the edges of the element remained. Definitely a browser bug.
                //Note: we allow the user to override the auto-setting by defining WebkitBackfaceVisibility in the vars of the tween.
                if (_isSafariLT6) this._addLazySet(style, "WebkitBackfaceVisibility", this._vars.WebkitBackfaceVisibility || (threeD ? "visible" : "hidden"));
            }
            pt2 = pt;
            while(pt2 && pt2._next)pt2 = pt2._next;
            tpt = new CSSPropTween(target, "transform", 0, 0, null, 2);
            this._linkCSSP(tpt, null, pt2);
            tpt.setRatio = _transformProp ? _setTransformRatio : _setIETransformRatio;
            tpt.data = this._transform || _getTransform(target, _cs, true);
            tpt.tween = tween;
            tpt.pr = -1; //ensures that the transforms get applied after the components are updated.
            _overwriteProps.pop(); //we don't want to force the overwrite of all "transform" tweens of the target - we only care about individual transform properties like scaleX, rotation, etc. The CSSPropTween constructor automatically adds the property to _overwriteProps which is why we need to pop() here.
        }
        if (_hasPriority) {
            //reorders the linked list in order of pr (priority)
            while(pt){
                next = pt._next;
                pt2 = first;
                while(pt2 && pt2.pr > pt.pr)pt2 = pt2._next;
                if (pt._prev = pt2 ? pt2._prev : last) pt._prev._next = pt;
                else first = pt;
                if (pt._next = pt2) pt2._prev = pt;
                else last = pt;
                pt = next;
            }
            this._firstPT = first;
        }
        return true;
    };
    p.parse = function(target, vars, pt, plugin) {
        var style = target.style, p, sp, bn, en, bs, es, bsfx, esfx, isStr, rel;
        for(p in vars){
            es = vars[p]; //ending value string
            sp = _specialProps[p]; //SpecialProp lookup.
            if (typeof es === "function" && !(sp && sp.allowFunc)) es = es(_index, _target);
            if (sp) pt = sp.parse(target, es, p, this, pt, plugin, vars);
            else if (p.substr(0, 2) === "--") {
                this._tween._propLookup[p] = this._addTween.call(this._tween, target.style, "setProperty", _getComputedStyle(target).getPropertyValue(p) + "", es + "", p, false, p);
                continue;
            } else {
                bs = _getStyle(target, p, _cs) + "";
                isStr = typeof es === "string";
                if (p === "color" || p === "fill" || p === "stroke" || p.indexOf("Color") !== -1 || isStr && _rgbhslExp.test(es)) {
                    if (!isStr) {
                        es = _parseColor(es);
                        es = (es.length > 3 ? "rgba(" : "rgb(") + es.join(",") + ")";
                    }
                    pt = _parseComplex(style, p, bs, es, true, "transparent", pt, 0, plugin);
                } else if (isStr && _complexExp.test(es)) pt = _parseComplex(style, p, bs, es, true, null, pt, 0, plugin);
                else {
                    bn = parseFloat(bs);
                    bsfx = bn || bn === 0 ? bs.substr((bn + "").length) : ""; //remember, bs could be non-numeric like "normal" for fontWeight, so we should default to a blank suffix in that case.
                    if (bs === "" || bs === "auto") {
                        if (p === "width" || p === "height") {
                            bn = _getDimension(target, p, _cs);
                            bsfx = "px";
                        } else if (p === "left" || p === "top") {
                            bn = _calculateOffset(target, p, _cs);
                            bsfx = "px";
                        } else {
                            bn = p !== "opacity" ? 0 : 1;
                            bsfx = "";
                        }
                    }
                    rel = isStr && es.charAt(1) === "=";
                    if (rel) {
                        en = parseInt(es.charAt(0) + "1", 10);
                        es = es.substr(2);
                        en *= parseFloat(es);
                        esfx = es.replace(_suffixExp, "");
                    } else {
                        en = parseFloat(es);
                        esfx = isStr ? es.replace(_suffixExp, "") : "";
                    }
                    if (esfx === "") esfx = p in _suffixMap ? _suffixMap[p] : bsfx; //populate the end suffix, prioritizing the map, then if none is found, use the beginning suffix.
                    es = en || en === 0 ? (rel ? en + bn : en) + esfx : vars[p]; //ensures that any += or -= prefixes are taken care of. Record the end value before normalizing the suffix because we always want to end the tween on exactly what they intended even if it doesn't match the beginning value's suffix.
                    //if the beginning/ending suffixes don't match, normalize them...
                    if (bsfx !== esfx) {
                        if (esfx !== "" || p === "lineHeight") {
                            if (en || en === 0) {
                                if (bn) {
                                    bn = _convertToPixels(target, p, bn, bsfx);
                                    if (esfx === "%") {
                                        bn /= _convertToPixels(target, p, 100, "%") / 100;
                                        if (vars.strictUnits !== true) bs = bn + "%";
                                    } else if (esfx === "em" || esfx === "rem" || esfx === "vw" || esfx === "vh") bn /= _convertToPixels(target, p, 1, esfx);
                                    else if (esfx !== "px") {
                                        en = _convertToPixels(target, p, en, esfx);
                                        esfx = "px"; //we don't use bsfx after this, so we don't need to set it to px too.
                                    }
                                    if (rel) {
                                        if (en || en === 0) es = en + bn + esfx; //the changes we made affect relative calculations, so adjust the end value here.
                                    }
                                }
                            }
                        }
                    }
                    if (rel) en += bn;
                    if ((bn || bn === 0) && (en || en === 0)) {
                        pt = new CSSPropTween(style, p, bn, en - bn, pt, 0, p, _autoRound !== false && (esfx === "px" || p === "zIndex"), 0, bs, es);
                        pt.xs0 = esfx;
                    //DEBUG: _log("tween "+p+" from "+pt.b+" ("+bn+esfx+") to "+pt.e+" with suffix: "+pt.xs0);
                    } else if (style[p] === undefined || !es && (es + "" === "NaN" || es == null)) _log("invalid " + p + " tween value: " + vars[p]);
                    else {
                        pt = new CSSPropTween(style, p, en || bn || 0, 0, pt, -1, p, false, 0, bs, es);
                        pt.xs0 = es === "none" && (p === "display" || p.indexOf("Style") !== -1) ? bs : es; //intermediate value should typically be set immediately (end value) except for "display" or things like borderTopStyle, borderBottomStyle, etc. which should use the beginning value during the tween.
                    //DEBUG: _log("non-tweening value "+p+": "+pt.xs0);
                    }
                }
            }
            if (plugin) {
                if (pt && !pt.plugin) pt.plugin = plugin;
            }
        }
        return pt;
    };
    //gets called every time the tween updates, passing the new ratio (typically a value between 0 and 1, but not always (for example, if an Elastic.easeOut is used, the value can jump above 1 mid-tween). It will always start and 0 and end at 1.
    p.setRatio = function(v) {
        var pt = this._firstPT, min = 0.000001, val, str, i;
        //at the end of the tween, we set the values to exactly what we received in order to make sure non-tweening values (like "position" or "float" or whatever) are set and so that if the beginning/ending suffixes (units) didn't match and we normalized to px, the value that the user passed in is used here. We check to see if the tween is at its beginning in case it's a from() tween in which case the ratio will actually go from 1 to 0 over the course of the tween (backwards).
        if (v === 1 && (this._tween._time === this._tween._duration || this._tween._time === 0)) while(pt){
            if (pt.type !== 2) {
                if (pt.r && pt.type !== -1) {
                    val = pt.r(pt.s + pt.c);
                    if (!pt.type) pt.t[pt.p] = val + pt.xs0;
                    else if (pt.type === 1) {
                        i = pt.l;
                        str = pt.xs0 + val + pt.xs1;
                        for(i = 1; i < pt.l; i++)str += pt["xn" + i] + pt["xs" + (i + 1)];
                        pt.t[pt.p] = str;
                    }
                } else pt.t[pt.p] = pt.e;
            } else pt.setRatio(v);
            pt = pt._next;
        }
        else if (v || !(this._tween._time === this._tween._duration || this._tween._time === 0) || this._tween._rawPrevTime === -0.000001) while(pt){
            val = pt.c * v + pt.s;
            if (pt.r) val = pt.r(val);
            else if (val < min) {
                if (val > -min) val = 0;
            }
            if (!pt.type) pt.t[pt.p] = val + pt.xs0;
            else if (pt.type === 1) {
                i = pt.l;
                if (i === 2) pt.t[pt.p] = pt.xs0 + val + pt.xs1 + pt.xn1 + pt.xs2;
                else if (i === 3) pt.t[pt.p] = pt.xs0 + val + pt.xs1 + pt.xn1 + pt.xs2 + pt.xn2 + pt.xs3;
                else if (i === 4) pt.t[pt.p] = pt.xs0 + val + pt.xs1 + pt.xn1 + pt.xs2 + pt.xn2 + pt.xs3 + pt.xn3 + pt.xs4;
                else if (i === 5) pt.t[pt.p] = pt.xs0 + val + pt.xs1 + pt.xn1 + pt.xs2 + pt.xn2 + pt.xs3 + pt.xn3 + pt.xs4 + pt.xn4 + pt.xs5;
                else {
                    str = pt.xs0 + val + pt.xs1;
                    for(i = 1; i < pt.l; i++)str += pt["xn" + i] + pt["xs" + (i + 1)];
                    pt.t[pt.p] = str;
                }
            } else if (pt.type === -1) pt.t[pt.p] = pt.xs0;
            else if (pt.setRatio) pt.setRatio(v);
            pt = pt._next;
        }
        else while(pt){
            if (pt.type !== 2) pt.t[pt.p] = pt.b;
            else pt.setRatio(v);
            pt = pt._next;
        }
    };
    /**
		 * @private
		 * Forces rendering of the target's transforms (rotation, scale, etc.) whenever the CSSPlugin's setRatio() is called.
		 * Basically, this tells the CSSPlugin to create a CSSPropTween (type 2) after instantiation that runs last in the linked
		 * list and calls the appropriate (3D or 2D) rendering function. We separate this into its own method so that we can call
		 * it from other plugins like BezierPlugin if, for example, it needs to apply an autoRotation and this CSSPlugin
		 * doesn't have any transform-related properties of its own. You can call this method as many times as you
		 * want and it won't create duplicate CSSPropTweens.
		 *
		 * @param {boolean} threeD if true, it should apply 3D tweens (otherwise, just 2D ones are fine and typically faster)
		 */ p._enableTransforms = function(threeD) {
        this._transform = this._transform || _getTransform(this._target, _cs, true); //ensures that the element has a _gsTransform property with the appropriate values.
        this._transformType = !(this._transform.svg && _useSVGTransformAttr) && (threeD || this._transformType === 3) ? 3 : 2;
    };
    var lazySet = function(v) {
        this.t[this.p] = this.e;
        this.data._linkCSSP(this, this._next, null, true); //we purposefully keep this._next even though it'd make sense to null it, but this is a performance optimization, as this happens during the while (pt) {} loop in setRatio() at the bottom of which it sets pt = pt._next, so if we null it, the linked list will be broken in that loop.
    };
    /** @private Gives us a way to set a value on the first render (and only the first render). **/ p._addLazySet = function(t, p, v) {
        var pt = this._firstPT = new CSSPropTween(t, p, 0, 0, this._firstPT, 2);
        pt.e = v;
        pt.setRatio = lazySet;
        pt.data = this;
    };
    /** @private **/ p._linkCSSP = function(pt, next, prev, remove) {
        if (pt) {
            if (next) next._prev = pt;
            if (pt._next) pt._next._prev = pt._prev;
            if (pt._prev) pt._prev._next = pt._next;
            else if (this._firstPT === pt) {
                this._firstPT = pt._next;
                remove = true; //just to prevent resetting this._firstPT 5 lines down in case pt._next is null. (optimized for speed)
            }
            if (prev) prev._next = pt;
            else if (!remove && this._firstPT === null) this._firstPT = pt;
            pt._next = next;
            pt._prev = prev;
        }
        return pt;
    };
    p._mod = function(lookup) {
        var pt = this._firstPT;
        while(pt){
            if (typeof lookup[pt.p] === "function") pt.r = lookup[pt.p];
            pt = pt._next;
        }
    };
    //we need to make sure that if alpha or autoAlpha is killed, opacity is too. And autoAlpha affects the "visibility" property.
    p._kill = function(lookup) {
        var copy = lookup, pt, p, xfirst;
        if (lookup.autoAlpha || lookup.alpha) {
            copy = {};
            for(p in lookup)copy[p] = lookup[p];
            copy.opacity = 1;
            if (copy.autoAlpha) copy.visibility = 1;
        }
        if (lookup.className && (pt = this._classNamePT)) {
            xfirst = pt.xfirst;
            if (xfirst && xfirst._prev) this._linkCSSP(xfirst._prev, pt._next, xfirst._prev._prev); //break off the prev
            else if (xfirst === this._firstPT) this._firstPT = pt._next;
            if (pt._next) this._linkCSSP(pt._next, pt._next._next, xfirst._prev);
            this._classNamePT = null;
        }
        pt = this._firstPT;
        while(pt){
            if (pt.plugin && pt.plugin !== p && pt.plugin._kill) {
                pt.plugin._kill(lookup);
                p = pt.plugin;
            }
            pt = pt._next;
        }
        return (0, $hYzRA.TweenPlugin).prototype._kill.call(this, copy);
    };
    //used by cascadeTo() for gathering all the style properties of each child element into an array for comparison.
    var _getChildStyles = function(e, props, targets) {
        var children, i, child, type;
        if (e.slice) {
            i = e.length;
            while(--i > -1)_getChildStyles(e[i], props, targets);
            return;
        }
        children = e.childNodes;
        i = children.length;
        while(--i > -1){
            child = children[i];
            type = child.type;
            if (child.style) {
                props.push(_getAllStyles(child));
                if (targets) targets.push(child);
            }
            if ((type === 1 || type === 9 || type === 11) && child.childNodes.length) _getChildStyles(child, props, targets);
        }
    };
    /**
		 * Typically only useful for className tweens that may affect child elements, this method creates a TweenLite
		 * and then compares the style properties of all the target's child elements at the tween's start and end, and
		 * if any are different, it also creates tweens for those and returns an array containing ALL of the resulting
		 * tweens (so that you can easily add() them to a TimelineLite, for example). The reason this functionality is
		 * wrapped into a separate static method of CSSPlugin instead of being integrated into all regular className tweens
		 * is because it creates entirely new tweens that may have completely different targets than the original tween,
		 * so if they were all lumped into the original tween instance, it would be inconsistent with the rest of the API
		 * and it would create other problems. For example:
		 *  - If I create a tween of elementA, that tween instance may suddenly change its target to include 50 other elements (unintuitive if I specifically defined the target I wanted)
		 *  - We can't just create new independent tweens because otherwise, what happens if the original/parent tween is reversed or pause or dropped into a TimelineLite for tight control? You'd expect that tween's behavior to affect all the others.
		 *  - Analyzing every style property of every child before and after the tween is an expensive operation when there are many children, so this behavior shouldn't be imposed on all className tweens by default, especially since it's probably rare that this extra functionality is needed.
		 *
		 * @param {Object} target object to be tweened
		 * @param {number} Duration in seconds (or frames for frames-based tweens)
		 * @param {Object} Object containing the end values, like {className:"newClass", ease:Linear.easeNone}
		 * @return {Array} An array of TweenLite instances
		 */ CSSPlugin.cascadeTo = function(target, duration, vars) {
        var tween = (0, $hYzRA.default).to(target, duration, vars), results = [
            tween
        ], b = [], e = [], targets = [], _reservedProps = (0, $hYzRA.default)._internals.reservedProps, i, difs, p, from;
        target = tween._targets || tween.target;
        _getChildStyles(target, b, targets);
        tween.render(duration, true, true);
        _getChildStyles(target, e);
        tween.render(0, true, true);
        tween._enabled(true);
        i = targets.length;
        while(--i > -1){
            difs = _cssDif(targets[i], b[i], e[i]);
            if (difs.firstMPT) {
                difs = difs.difs;
                for(p in vars)if (_reservedProps[p]) difs[p] = vars[p];
                from = {};
                for(p in difs)from[p] = b[i][p];
                results.push((0, $hYzRA.default).fromTo(targets[i], duration, from, difs));
            }
        }
        return results;
    };
    (0, $hYzRA.TweenPlugin).activate([
        CSSPlugin
    ]);
    return CSSPlugin;
}, true);
var $3a5a725fd2fa0609$export$855822f522f18eef = (0, $hYzRA.globals).CSSPlugin;

});

parcelRequire.register("uj8kT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05b1a4f623c19a7a$export$978627e983ecb8cf; });
/*!
 * VERSION: 0.6.1
 * DATE: 2018-08-27
 * UPDATES AND DOCS AT: http://greensock.com
 *
 * @license Copyright (c) 2008-2019, GreenSock. All rights reserved.
 * This work is subject to the terms at http://greensock.com/standard-license or for
 * Club GreenSock members, the software agreement that was issued with your membership.
 * 
 * @author: Jack Doyle, jack@greensock.com
 */ /* eslint-disable */ 
var $hYzRA = parcelRequire("hYzRA");
var $05b1a4f623c19a7a$export$978627e983ecb8cf = (0, $hYzRA._gsScope)._gsDefine.plugin({
    propName: "attr",
    API: 2,
    version: "0.6.1",
    //called when the tween renders for the first time. This is where initial values should be recorded and any setup routines should run.
    init: function(target, value, tween, index) {
        var p, end;
        if (typeof target.setAttribute !== "function") return false;
        for(p in value){
            end = value[p];
            if (typeof end === "function") end = end(index, target);
            this._addTween(target, "setAttribute", target.getAttribute(p) + "", end + "", p, false, p);
            this._overwriteProps.push(p);
        }
        return true;
    }
});

});

parcelRequire.register("jPhug", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e6f05854f9f01020$export$9f55b1031bdcb70a; });
/*!
 * VERSION: 1.6.0
 * DATE: 2018-08-27
 * UPDATES AND DOCS AT: http://greensock.com
 *
 * @license Copyright (c) 2008-2019, GreenSock. All rights reserved.
 * This work is subject to the terms at http://greensock.com/standard-license or for
 * Club GreenSock members, the software agreement that was issued with your membership.
 * 
 * @author: Jack Doyle, jack@greensock.com
 **/ /* eslint-disable */ 
var $hYzRA = parcelRequire("hYzRA");
var $e6f05854f9f01020$export$9f55b1031bdcb70a = (0, $hYzRA._gsScope)._gsDefine.plugin({
    propName: "roundProps",
    version: "1.7.0",
    priority: -1,
    API: 2,
    //called when the tween renders for the first time. This is where initial values should be recorded and any setup routines should run.
    init: function(target, value, tween) {
        this._tween = tween;
        return true;
    }
}), $e6f05854f9f01020$export$c9988be5a9dd13bd = function(v) {
    var p = v < 1 ? Math.pow(10, (v + "").length - 2) : 1; //to avoid floating point math errors (like 24 * 0.1 == 2.4000000000000004), we chop off at a specific number of decimal places (much faster than toFixed()
    return function(n) {
        return (Math.round(n / v) * v * p | 0) / p;
    };
}, $e6f05854f9f01020$export$1a0b5eb3e0a6c61f = function(node, mod) {
    while(node){
        if (!node.f && !node.blob) node.m = mod || Math.round;
        node = node._next;
    }
}, $e6f05854f9f01020$export$ffb5f4729a158638 = $e6f05854f9f01020$export$9f55b1031bdcb70a.prototype;
$e6f05854f9f01020$export$ffb5f4729a158638._onInitAllProps = function() {
    var tween = this._tween, rp = tween.vars.roundProps, lookup = {}, rpt = tween._propLookup.roundProps, pt, next, i, p;
    if (typeof rp === "object" && !rp.push) for(p in rp)lookup[p] = $e6f05854f9f01020$export$c9988be5a9dd13bd(rp[p]);
    else {
        if (typeof rp === "string") rp = rp.split(",");
        i = rp.length;
        while(--i > -1)lookup[rp[i]] = Math.round;
    }
    for(p in lookup){
        pt = tween._firstPT;
        while(pt){
            next = pt._next; //record here, because it may get removed
            if (pt.pg) pt.t._mod(lookup);
            else if (pt.n === p) {
                if (pt.f === 2 && pt.t) $e6f05854f9f01020$export$1a0b5eb3e0a6c61f(pt.t._firstPT, lookup[p]);
                else {
                    this._add(pt.t, p, pt.s, pt.c, lookup[p]);
                    //remove from linked list
                    if (next) next._prev = pt._prev;
                    if (pt._prev) pt._prev._next = next;
                    else if (tween._firstPT === pt) tween._firstPT = next;
                    pt._next = pt._prev = null;
                    tween._propLookup[p] = rpt;
                }
            }
            pt = next;
        }
    }
    return false;
};
$e6f05854f9f01020$export$ffb5f4729a158638._add = function(target, p, s, c, mod) {
    this._addTween(target, p, s, s + c, p, mod || Math.round);
    this._overwriteProps.push(p);
};

});

parcelRequire.register("dMZ37", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a09f1d2aefaf439c$export$bf8ac39a69a809ed; });
/*!
 * VERSION: 0.3.1
 * DATE: 2018-08-27
 * UPDATES AND DOCS AT: http://greensock.com
 *
 * @license Copyright (c) 2008-2019, GreenSock. All rights reserved.
 * This work is subject to the terms at http://greensock.com/standard-license or for
 * Club GreenSock members, the software agreement that was issued with your membership.
 * 
 * @author: Jack Doyle, jack@greensock.com
 **/ /* eslint-disable */ 
var $hYzRA = parcelRequire("hYzRA");
var $a09f1d2aefaf439c$export$bf8ac39a69a809ed = (0, $hYzRA._gsScope)._gsDefine.plugin({
    propName: "directionalRotation",
    version: "0.3.1",
    API: 2,
    //called when the tween renders for the first time. This is where initial values should be recorded and any setup routines should run.
    init: function(target, value, tween, index) {
        if (typeof value !== "object") value = {
            rotation: value
        };
        this.finals = {};
        var cap = value.useRadians === true ? Math.PI * 2 : 360, min = 0.000001, p, v, start, end, dif, split;
        for(p in value)if (p !== "useRadians") {
            end = value[p];
            if (typeof end === "function") end = end(index, target);
            split = (end + "").split("_");
            v = split[0];
            start = parseFloat(typeof target[p] !== "function" ? target[p] : target[p.indexOf("set") || typeof target["get" + p.substr(3)] !== "function" ? p : "get" + p.substr(3)]());
            end = this.finals[p] = typeof v === "string" && v.charAt(1) === "=" ? start + parseInt(v.charAt(0) + "1", 10) * Number(v.substr(2)) : Number(v) || 0;
            dif = end - start;
            if (split.length) {
                v = split.join("_");
                if (v.indexOf("short") !== -1) {
                    dif = dif % cap;
                    if (dif !== dif % (cap / 2)) dif = dif < 0 ? dif + cap : dif - cap;
                }
                if (v.indexOf("_cw") !== -1 && dif < 0) dif = (dif + cap * 9999999999) % cap - (dif / cap | 0) * cap;
                else if (v.indexOf("ccw") !== -1 && dif > 0) dif = (dif - cap * 9999999999) % cap - (dif / cap | 0) * cap;
            }
            if (dif > min || dif < -min) {
                this._addTween(target, p, start, start + dif, p);
                this._overwriteProps.push(p);
            }
        }
        return true;
    },
    //called each time the values should be updated, and the ratio gets passed as the only parameter (typically it's a value between 0 and 1, but it can exceed those when using an ease like Elastic.easeOut or Back.easeOut, etc.)
    set: function(ratio) {
        var pt;
        if (ratio !== 1) this._super.setRatio.call(this, ratio);
        else {
            pt = this._firstPT;
            while(pt){
                if (pt.f) pt.t[pt.p](this.finals[pt.p]);
                else pt.t[pt.p] = this.finals[pt.p];
                pt = pt._next;
            }
        }
    }
});
$a09f1d2aefaf439c$export$bf8ac39a69a809ed._autoCSS = true;

});

parcelRequire.register("51K6f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a90ce2eea302b86$export$b95388143095feb9; });
/*!
 * VERSION: 1.3.9
 * DATE: 2019-05-17
 * UPDATES AND DOCS AT: http://greensock.com
 *
 * @license Copyright (c) 2008-2019, GreenSock. All rights reserved.
 * This work is subject to the terms at http://greensock.com/standard-license or for
 * Club GreenSock members, the software agreement that was issued with your membership.
 * 
 * @author: Jack Doyle, jack@greensock.com
 **/ /* eslint-disable */ 
var $hYzRA = parcelRequire("hYzRA");
var $3a90ce2eea302b86$var$_RAD2DEG = 180 / Math.PI, $3a90ce2eea302b86$var$_r1 = [], $3a90ce2eea302b86$var$_r2 = [], $3a90ce2eea302b86$var$_r3 = [], $3a90ce2eea302b86$var$_corProps = {}, $3a90ce2eea302b86$var$_globals = (0, $hYzRA._gsScope)._gsDefine.globals, $3a90ce2eea302b86$var$Segment = function(a, b, c, d) {
    if (c === d) c = d - (d - b) / 1000000;
    if (a === b) b = a + (c - a) / 1000000;
    this.a = a;
    this.b = b;
    this.c = c;
    this.d = d;
    this.da = d - a;
    this.ca = c - a;
    this.ba = b - a;
}, $3a90ce2eea302b86$var$_correlate = ",x,y,z,left,top,right,bottom,marginTop,marginLeft,marginRight,marginBottom,paddingLeft,paddingTop,paddingRight,paddingBottom,backgroundPosition,backgroundPosition_y,", $3a90ce2eea302b86$var$cubicToQuadratic = function(a, b, c, d) {
    var q1 = {
        a: a
    }, q2 = {}, q3 = {}, q4 = {
        c: d
    }, mab = (a + b) / 2, mbc = (b + c) / 2, mcd = (c + d) / 2, mabc = (mab + mbc) / 2, mbcd = (mbc + mcd) / 2, m8 = (mbcd - mabc) / 8;
    q1.b = mab + (a - mab) / 4;
    q2.b = mabc + m8;
    q1.c = q2.a = (q1.b + q2.b) / 2;
    q2.c = q3.a = (mabc + mbcd) / 2;
    q3.b = mbcd - m8;
    q4.b = mcd + (d - mcd) / 4;
    q3.c = q4.a = (q3.b + q4.b) / 2;
    return [
        q1,
        q2,
        q3,
        q4
    ];
}, $3a90ce2eea302b86$var$_calculateControlPoints = function(a, curviness, quad, basic, correlate) {
    var l = a.length - 1, ii = 0, cp1 = a[0].a, i, p1, p2, p3, seg, m1, m2, mm, cp2, qb, r1, r2, tl;
    for(i = 0; i < l; i++){
        seg = a[ii];
        p1 = seg.a;
        p2 = seg.d;
        p3 = a[ii + 1].d;
        if (correlate) {
            r1 = $3a90ce2eea302b86$var$_r1[i];
            r2 = $3a90ce2eea302b86$var$_r2[i];
            tl = (r2 + r1) * curviness * 0.25 / (basic ? 0.5 : $3a90ce2eea302b86$var$_r3[i] || 0.5);
            m1 = p2 - (p2 - p1) * (basic ? curviness * 0.5 : r1 !== 0 ? tl / r1 : 0);
            m2 = p2 + (p3 - p2) * (basic ? curviness * 0.5 : r2 !== 0 ? tl / r2 : 0);
            mm = p2 - (m1 + ((m2 - m1) * (r1 * 3 / (r1 + r2) + 0.5) / 4 || 0));
        } else {
            m1 = p2 - (p2 - p1) * curviness * 0.5;
            m2 = p2 + (p3 - p2) * curviness * 0.5;
            mm = p2 - (m1 + m2) / 2;
        }
        m1 += mm;
        m2 += mm;
        seg.c = cp2 = m1;
        if (i !== 0) seg.b = cp1;
        else seg.b = cp1 = seg.a + (seg.c - seg.a) * 0.6; //instead of placing b on a exactly, we move it inline with c so that if the user specifies an ease like Back.easeIn or Elastic.easeIn which goes BEYOND the beginning, it will do so smoothly.
        seg.da = p2 - p1;
        seg.ca = cp2 - p1;
        seg.ba = cp1 - p1;
        if (quad) {
            qb = $3a90ce2eea302b86$var$cubicToQuadratic(p1, cp1, cp2, p2);
            a.splice(ii, 1, qb[0], qb[1], qb[2], qb[3]);
            ii += 4;
        } else ii++;
        cp1 = m2;
    }
    seg = a[ii];
    seg.b = cp1;
    seg.c = cp1 + (seg.d - cp1) * 0.4; //instead of placing c on d exactly, we move it inline with b so that if the user specifies an ease like Back.easeOut or Elastic.easeOut which goes BEYOND the end, it will do so smoothly.
    seg.da = seg.d - seg.a;
    seg.ca = seg.c - seg.a;
    seg.ba = cp1 - seg.a;
    if (quad) {
        qb = $3a90ce2eea302b86$var$cubicToQuadratic(seg.a, cp1, seg.c, seg.d);
        a.splice(ii, 1, qb[0], qb[1], qb[2], qb[3]);
    }
}, $3a90ce2eea302b86$var$_parseAnchors = function(values, p, correlate, prepend) {
    var a = [], l, i, p1, p2, p3, tmp;
    if (prepend) {
        values = [
            prepend
        ].concat(values);
        i = values.length;
        while(--i > -1){
            if (typeof (tmp = values[i][p]) === "string") {
                if (tmp.charAt(1) === "=") values[i][p] = prepend[p] + Number(tmp.charAt(0) + tmp.substr(2)); //accommodate relative values. Do it inline instead of breaking it out into a function for speed reasons
            }
        }
    }
    l = values.length - 2;
    if (l < 0) {
        a[0] = new $3a90ce2eea302b86$var$Segment(values[0][p], 0, 0, values[0][p]);
        return a;
    }
    for(i = 0; i < l; i++){
        p1 = values[i][p];
        p2 = values[i + 1][p];
        a[i] = new $3a90ce2eea302b86$var$Segment(p1, 0, 0, p2);
        if (correlate) {
            p3 = values[i + 2][p];
            $3a90ce2eea302b86$var$_r1[i] = ($3a90ce2eea302b86$var$_r1[i] || 0) + (p2 - p1) * (p2 - p1);
            $3a90ce2eea302b86$var$_r2[i] = ($3a90ce2eea302b86$var$_r2[i] || 0) + (p3 - p2) * (p3 - p2);
        }
    }
    a[i] = new $3a90ce2eea302b86$var$Segment(values[i][p], 0, 0, values[i + 1][p]);
    return a;
}, $3a90ce2eea302b86$var$bezierThrough = function(values, curviness, quadratic, basic, correlate, prepend) {
    var obj = {}, props = [], first = prepend || values[0], i, p, a, j, r, l, seamless, last;
    correlate = typeof correlate === "string" ? "," + correlate + "," : $3a90ce2eea302b86$var$_correlate;
    if (curviness == null) curviness = 1;
    for(p in values[0])props.push(p);
    //check to see if the last and first values are identical (well, within 0.05). If so, make seamless by appending the second element to the very end of the values array and the 2nd-to-last element to the very beginning (we'll remove those segments later)
    if (values.length > 1) {
        last = values[values.length - 1];
        seamless = true;
        i = props.length;
        while(--i > -1){
            p = props[i];
            if (Math.abs(first[p] - last[p]) > 0.05) {
                seamless = false;
                break;
            }
        }
        if (seamless) {
            values = values.concat(); //duplicate the array to avoid contaminating the original which the user may be reusing for other tweens
            if (prepend) values.unshift(prepend);
            values.push(values[1]);
            prepend = values[values.length - 3];
        }
    }
    $3a90ce2eea302b86$var$_r1.length = $3a90ce2eea302b86$var$_r2.length = $3a90ce2eea302b86$var$_r3.length = 0;
    i = props.length;
    while(--i > -1){
        p = props[i];
        $3a90ce2eea302b86$var$_corProps[p] = correlate.indexOf("," + p + ",") !== -1;
        obj[p] = $3a90ce2eea302b86$var$_parseAnchors(values, p, $3a90ce2eea302b86$var$_corProps[p], prepend);
    }
    i = $3a90ce2eea302b86$var$_r1.length;
    while(--i > -1){
        $3a90ce2eea302b86$var$_r1[i] = Math.sqrt($3a90ce2eea302b86$var$_r1[i]);
        $3a90ce2eea302b86$var$_r2[i] = Math.sqrt($3a90ce2eea302b86$var$_r2[i]);
    }
    if (!basic) {
        i = props.length;
        while(--i > -1)if ($3a90ce2eea302b86$var$_corProps[p]) {
            a = obj[props[i]];
            l = a.length - 1;
            for(j = 0; j < l; j++){
                r = a[j + 1].da / $3a90ce2eea302b86$var$_r2[j] + a[j].da / $3a90ce2eea302b86$var$_r1[j] || 0;
                $3a90ce2eea302b86$var$_r3[j] = ($3a90ce2eea302b86$var$_r3[j] || 0) + r * r;
            }
        }
        i = $3a90ce2eea302b86$var$_r3.length;
        while(--i > -1)$3a90ce2eea302b86$var$_r3[i] = Math.sqrt($3a90ce2eea302b86$var$_r3[i]);
    }
    i = props.length;
    j = quadratic ? 4 : 1;
    while(--i > -1){
        p = props[i];
        a = obj[p];
        $3a90ce2eea302b86$var$_calculateControlPoints(a, curviness, quadratic, basic, $3a90ce2eea302b86$var$_corProps[p]); //this method requires that _parseAnchors() and _setSegmentRatios() ran first so that _r1, _r2, and _r3 values are populated for all properties
        if (seamless) {
            a.splice(0, j);
            a.splice(a.length - j, j);
        }
    }
    return obj;
}, $3a90ce2eea302b86$var$_parseBezierData = function(values, type, prepend) {
    type = type || "soft";
    var obj = {}, inc = type === "cubic" ? 3 : 2, soft = type === "soft", props = [], a, b, c, d, cur, i, j, l, p, cnt, tmp;
    if (soft && prepend) values = [
        prepend
    ].concat(values);
    if (values == null || values.length < inc + 1) throw "invalid Bezier data";
    for(p in values[0])props.push(p);
    i = props.length;
    while(--i > -1){
        p = props[i];
        obj[p] = cur = [];
        cnt = 0;
        l = values.length;
        for(j = 0; j < l; j++){
            a = prepend == null ? values[j][p] : typeof (tmp = values[j][p]) === "string" && tmp.charAt(1) === "=" ? prepend[p] + Number(tmp.charAt(0) + tmp.substr(2)) : Number(tmp);
            if (soft) {
                if (j > 1) {
                    if (j < l - 1) cur[cnt++] = (a + cur[cnt - 2]) / 2;
                }
            }
            cur[cnt++] = a;
        }
        l = cnt - inc + 1;
        cnt = 0;
        for(j = 0; j < l; j += inc){
            a = cur[j];
            b = cur[j + 1];
            c = cur[j + 2];
            d = inc === 2 ? 0 : cur[j + 3];
            cur[cnt++] = tmp = inc === 3 ? new $3a90ce2eea302b86$var$Segment(a, b, c, d) : new $3a90ce2eea302b86$var$Segment(a, (2 * b + a) / 3, (2 * b + c) / 3, c);
        }
        cur.length = cnt;
    }
    return obj;
}, $3a90ce2eea302b86$var$_addCubicLengths = function(a, steps, resolution) {
    var inc = 1 / resolution, j = a.length, d, d1, s, da, ca, ba, p, i, inv, bez, index;
    while(--j > -1){
        bez = a[j];
        s = bez.a;
        da = bez.d - s;
        ca = bez.c - s;
        ba = bez.b - s;
        d = d1 = 0;
        for(i = 1; i <= resolution; i++){
            p = inc * i;
            inv = 1 - p;
            d = d1 - (d1 = (p * p * da + 3 * inv * (p * ca + inv * ba)) * p);
            index = j * resolution + i - 1;
            steps[index] = (steps[index] || 0) + d * d;
        }
    }
}, $3a90ce2eea302b86$var$_parseLengthData = function(obj, resolution) {
    resolution = resolution >> 0 || 6;
    var a = [], lengths = [], d = 0, total = 0, threshold = resolution - 1, segments = [], curLS = [], p, i, l, index;
    for(p in obj)$3a90ce2eea302b86$var$_addCubicLengths(obj[p], a, resolution);
    l = a.length;
    for(i = 0; i < l; i++){
        d += Math.sqrt(a[i]);
        index = i % resolution;
        curLS[index] = d;
        if (index === threshold) {
            total += d;
            index = i / resolution >> 0;
            segments[index] = curLS;
            lengths[index] = total;
            d = 0;
            curLS = [];
        }
    }
    return {
        length: total,
        lengths: lengths,
        segments: segments
    };
}, $3a90ce2eea302b86$export$b95388143095feb9 = (0, $hYzRA._gsScope)._gsDefine.plugin({
    propName: "bezier",
    priority: -1,
    version: "1.3.9",
    API: 2,
    global: true,
    //gets called when the tween renders for the first time. This is where initial values should be recorded and any setup routines should run.
    init: function(target, vars, tween) {
        this._target = target;
        if (vars instanceof Array) vars = {
            values: vars
        };
        this._func = {};
        this._mod = {};
        this._props = [];
        this._timeRes = vars.timeResolution == null ? 6 : parseInt(vars.timeResolution, 10);
        var values = vars.values || [], first = {}, second = values[0], autoRotate = vars.autoRotate || tween.vars.orientToBezier, p, isFunc, i, j, prepend;
        this._autoRotate = autoRotate ? autoRotate instanceof Array ? autoRotate : [
            [
                "x",
                "y",
                "rotation",
                autoRotate === true ? 0 : Number(autoRotate) || 0
            ]
        ] : null;
        for(p in second)this._props.push(p);
        i = this._props.length;
        while(--i > -1){
            p = this._props[i];
            this._overwriteProps.push(p);
            isFunc = this._func[p] = typeof target[p] === "function";
            first[p] = !isFunc ? parseFloat(target[p]) : target[p.indexOf("set") || typeof target["get" + p.substr(3)] !== "function" ? p : "get" + p.substr(3)]();
            if (!prepend) {
                if (first[p] !== values[0][p]) prepend = first;
            }
        }
        this._beziers = vars.type !== "cubic" && vars.type !== "quadratic" && vars.type !== "soft" ? $3a90ce2eea302b86$var$bezierThrough(values, isNaN(vars.curviness) ? 1 : vars.curviness, false, vars.type === "thruBasic", vars.correlate, prepend) : $3a90ce2eea302b86$var$_parseBezierData(values, vars.type, first);
        this._segCount = this._beziers[p].length;
        if (this._timeRes) {
            var ld = $3a90ce2eea302b86$var$_parseLengthData(this._beziers, this._timeRes);
            this._length = ld.length;
            this._lengths = ld.lengths;
            this._segments = ld.segments;
            this._l1 = this._li = this._s1 = this._si = 0;
            this._l2 = this._lengths[0];
            this._curSeg = this._segments[0];
            this._s2 = this._curSeg[0];
            this._prec = 1 / this._curSeg.length;
        }
        if (autoRotate = this._autoRotate) {
            this._initialRotations = [];
            if (!(autoRotate[0] instanceof Array)) this._autoRotate = autoRotate = [
                autoRotate
            ];
            i = autoRotate.length;
            while(--i > -1){
                for(j = 0; j < 3; j++){
                    p = autoRotate[i][j];
                    this._func[p] = typeof target[p] === "function" ? target[p.indexOf("set") || typeof target["get" + p.substr(3)] !== "function" ? p : "get" + p.substr(3)] : false;
                }
                p = autoRotate[i][2];
                this._initialRotations[i] = (this._func[p] ? this._func[p].call(this._target) : this._target[p]) || 0;
                this._overwriteProps.push(p);
            }
        }
        this._startRatio = tween.vars.runBackwards ? 1 : 0; //we determine the starting ratio when the tween inits which is always 0 unless the tween has runBackwards:true (indicating it's a from() tween) in which case it's 1.
        return true;
    },
    //called each time the values should be updated, and the ratio gets passed as the only parameter (typically it's a value between 0 and 1, but it can exceed those when using an ease like Elastic.easeOut or Back.easeOut, etc.)
    set: function(v) {
        var segments = this._segCount, func = this._func, target = this._target, notStart = v !== this._startRatio, curIndex, inv, i, p, b, t, val, l, lengths, curSeg, v1;
        if (!this._timeRes) {
            curIndex = v < 0 ? 0 : v >= 1 ? segments - 1 : segments * v >> 0;
            t = (v - curIndex * (1 / segments)) * segments;
        } else {
            lengths = this._lengths;
            curSeg = this._curSeg;
            v1 = v * this._length;
            i = this._li;
            //find the appropriate segment (if the currently cached one isn't correct)
            if (v1 > this._l2 && i < segments - 1) {
                l = segments - 1;
                while(i < l && (this._l2 = lengths[++i]) <= v1);
                this._l1 = lengths[i - 1];
                this._li = i;
                this._curSeg = curSeg = this._segments[i];
                this._s2 = curSeg[this._s1 = this._si = 0];
            } else if (v1 < this._l1 && i > 0) {
                while(i > 0 && (this._l1 = lengths[--i]) >= v1);
                if (i === 0 && v1 < this._l1) this._l1 = 0;
                else i++;
                this._l2 = lengths[i];
                this._li = i;
                this._curSeg = curSeg = this._segments[i];
                this._s1 = curSeg[(this._si = curSeg.length - 1) - 1] || 0;
                this._s2 = curSeg[this._si];
            }
            curIndex = i;
            //now find the appropriate sub-segment (we split it into the number of pieces that was defined by "precision" and measured each one)
            v1 -= this._l1;
            i = this._si;
            if (v1 > this._s2 && i < curSeg.length - 1) {
                l = curSeg.length - 1;
                while(i < l && (this._s2 = curSeg[++i]) <= v1);
                this._s1 = curSeg[i - 1];
                this._si = i;
            } else if (v1 < this._s1 && i > 0) {
                while(i > 0 && (this._s1 = curSeg[--i]) >= v1);
                if (i === 0 && v1 < this._s1) this._s1 = 0;
                else i++;
                this._s2 = curSeg[i];
                this._si = i;
            }
            t = v === 1 ? 1 : (i + (v1 - this._s1) / (this._s2 - this._s1)) * this._prec || 0;
        }
        inv = 1 - t;
        i = this._props.length;
        while(--i > -1){
            p = this._props[i];
            b = this._beziers[p][curIndex];
            val = (t * t * b.da + 3 * inv * (t * b.ca + inv * b.ba)) * t + b.a;
            if (this._mod[p]) val = this._mod[p](val, target);
            if (func[p]) target[p](val);
            else target[p] = val;
        }
        if (this._autoRotate) {
            var ar = this._autoRotate, b2, x1, y1, x2, y2, add, conv;
            i = ar.length;
            while(--i > -1){
                p = ar[i][2];
                add = ar[i][3] || 0;
                conv = ar[i][4] === true ? 1 : $3a90ce2eea302b86$var$_RAD2DEG;
                b = this._beziers[ar[i][0]];
                b2 = this._beziers[ar[i][1]];
                if (b && b2) {
                    b = b[curIndex];
                    b2 = b2[curIndex];
                    x1 = b.a + (b.b - b.a) * t;
                    x2 = b.b + (b.c - b.b) * t;
                    x1 += (x2 - x1) * t;
                    x2 += (b.c + (b.d - b.c) * t - x2) * t;
                    y1 = b2.a + (b2.b - b2.a) * t;
                    y2 = b2.b + (b2.c - b2.b) * t;
                    y1 += (y2 - y1) * t;
                    y2 += (b2.c + (b2.d - b2.c) * t - y2) * t;
                    val = notStart ? Math.atan2(y2 - y1, x2 - x1) * conv + add : this._initialRotations[i];
                    if (this._mod[p]) val = this._mod[p](val, target); //for modProps
                    if (func[p]) target[p](val);
                    else target[p] = val;
                }
            }
        }
    }
}), $3a90ce2eea302b86$var$p = $3a90ce2eea302b86$export$b95388143095feb9.prototype;
$3a90ce2eea302b86$export$b95388143095feb9.bezierThrough = $3a90ce2eea302b86$var$bezierThrough;
$3a90ce2eea302b86$export$b95388143095feb9.cubicToQuadratic = $3a90ce2eea302b86$var$cubicToQuadratic;
$3a90ce2eea302b86$export$b95388143095feb9._autoCSS = true; //indicates that this plugin can be inserted into the "css" object using the autoCSS feature of TweenLite
$3a90ce2eea302b86$export$b95388143095feb9.quadraticToCubic = function(a, b, c) {
    return new $3a90ce2eea302b86$var$Segment(a, (2 * b + a) / 3, (2 * b + c) / 3, c);
};
$3a90ce2eea302b86$export$b95388143095feb9._cssRegister = function() {
    var CSSPlugin = $3a90ce2eea302b86$var$_globals.CSSPlugin;
    if (!CSSPlugin) return;
    var _internals = CSSPlugin._internals, _parseToProxy = _internals._parseToProxy, _setPluginRatio = _internals._setPluginRatio, CSSPropTween = _internals.CSSPropTween;
    _internals._registerComplexSpecialProp("bezier", {
        parser: function(t, e, prop, cssp, pt, plugin) {
            if (e instanceof Array) e = {
                values: e
            };
            plugin = new $3a90ce2eea302b86$export$b95388143095feb9();
            var values = e.values, l = values.length - 1, pluginValues = [], v = {}, i, p, data;
            if (l < 0) return pt;
            for(i = 0; i <= l; i++){
                data = _parseToProxy(t, values[i], cssp, pt, plugin, l !== i);
                pluginValues[i] = data.end;
            }
            for(p in e)v[p] = e[p]; //duplicate the vars object because we need to alter some things which would cause problems if the user plans to reuse the same vars object for another tween.
            v.values = pluginValues;
            pt = new CSSPropTween(t, "bezier", 0, 0, data.pt, 2);
            pt.data = data;
            pt.plugin = plugin;
            pt.setRatio = _setPluginRatio;
            if (v.autoRotate === 0) v.autoRotate = true;
            if (v.autoRotate && !(v.autoRotate instanceof Array)) {
                i = v.autoRotate === true ? 0 : Number(v.autoRotate);
                v.autoRotate = data.end.left != null ? [
                    [
                        "left",
                        "top",
                        "rotation",
                        i,
                        false
                    ]
                ] : data.end.x != null ? [
                    [
                        "x",
                        "y",
                        "rotation",
                        i,
                        false
                    ]
                ] : false;
            }
            if (v.autoRotate) {
                if (!cssp._transform) cssp._enableTransforms(false);
                data.autoRotate = cssp._target._gsTransform;
                data.proxy.rotation = data.autoRotate.rotation || 0;
                cssp._overwriteProps.push("rotation");
            }
            plugin._onInitTween(data.proxy, v, cssp._tween);
            return pt;
        }
    });
};
$3a90ce2eea302b86$var$p._mod = function(lookup) {
    var op = this._overwriteProps, i = op.length, val;
    while(--i > -1){
        val = lookup[op[i]];
        if (val && typeof val === "function") this._mod[op[i]] = val;
    }
};
$3a90ce2eea302b86$var$p._kill = function(lookup) {
    var a = this._props, p, i;
    for(p in this._beziers)if (p in lookup) {
        delete this._beziers[p];
        delete this._func[p];
        i = a.length;
        while(--i > -1)if (a[i] === p) a.splice(i, 1);
    }
    a = this._autoRotate;
    if (a) {
        i = a.length;
        while(--i > -1)if (lookup[a[i][2]]) a.splice(i, 1);
    }
    return this._super._kill.call(this, lookup);
};

});

parcelRequire.register("4kabR", function(module, exports) {

$parcel$export(module.exports, "Back", function () { return $3260ef4742851ffd$export$25e48ac541203d4a; });
$parcel$export(module.exports, "Elastic", function () { return $3260ef4742851ffd$export$56ebabebb04a9ca9; });
$parcel$export(module.exports, "Bounce", function () { return $3260ef4742851ffd$export$d20e79fdc3899e95; });
$parcel$export(module.exports, "RoughEase", function () { return $3260ef4742851ffd$export$116b12203755670f; });
$parcel$export(module.exports, "SlowMo", function () { return $3260ef4742851ffd$export$5b8ec41d2880926f; });
$parcel$export(module.exports, "SteppedEase", function () { return $3260ef4742851ffd$export$f7a11c7543d81853; });
$parcel$export(module.exports, "Circ", function () { return $3260ef4742851ffd$export$ce49a57dd865b86c; });
$parcel$export(module.exports, "Expo", function () { return $3260ef4742851ffd$export$41e9d1ff1a2fb15a; });
$parcel$export(module.exports, "Sine", function () { return $3260ef4742851ffd$export$bed2d20ad96b784c; });
$parcel$export(module.exports, "ExpoScaleEase", function () { return $3260ef4742851ffd$export$f95db16282c8d7a4; });
/*!
 * VERSION: 1.16.1
 * DATE: 2018-08-27
 * UPDATES AND DOCS AT: http://greensock.com
 *
 * @license Copyright (c) 2008-2019, GreenSock. All rights reserved.
 * This work is subject to the terms at http://greensock.com/standard-license or for
 * Club GreenSock members, the software agreement that was issued with your membership.
 * 
 * @author: Jack Doyle, jack@greensock.com
 **/ /* eslint-disable */ 
var $hYzRA = parcelRequire("hYzRA");
(0, $hYzRA._gsScope)._gsDefine("easing.Back", [
    "easing.Ease"
], function() {
    var w = (0, $hYzRA._gsScope).GreenSockGlobals || (0, $hYzRA._gsScope), gs = w.com.greensock, _2PI = Math.PI * 2, _HALF_PI = Math.PI / 2, _class = gs._class, _create = function(n, f) {
        var C = _class("easing." + n, function() {}, true), p = C.prototype = new (0, $hYzRA.Ease)();
        p.constructor = C;
        p.getRatio = f;
        return C;
    }, _easeReg = (0, $hYzRA.Ease).register || function() {}, _wrap = function(name, EaseOut, EaseIn, EaseInOut, aliases) {
        var C = _class("easing." + name, {
            easeOut: new EaseOut(),
            easeIn: new EaseIn(),
            easeInOut: new EaseInOut()
        }, true);
        _easeReg(C, name);
        return C;
    }, EasePoint = function(time, value, next) {
        this.t = time;
        this.v = value;
        if (next) {
            this.next = next;
            next.prev = this;
            this.c = next.v - value;
            this.gap = next.t - time;
        }
    }, //Back
    _createBack = function(n, f) {
        var C = _class("easing." + n, function(overshoot) {
            this._p1 = overshoot || overshoot === 0 ? overshoot : 1.70158;
            this._p2 = this._p1 * 1.525;
        }, true), p = C.prototype = new (0, $hYzRA.Ease)();
        p.constructor = C;
        p.getRatio = f;
        p.config = function(overshoot) {
            return new C(overshoot);
        };
        return C;
    }, Back = _wrap("Back", _createBack("BackOut", function(p) {
        return (p = p - 1) * p * ((this._p1 + 1) * p + this._p1) + 1;
    }), _createBack("BackIn", function(p) {
        return p * p * ((this._p1 + 1) * p - this._p1);
    }), _createBack("BackInOut", function(p) {
        return (p *= 2) < 1 ? 0.5 * p * p * ((this._p2 + 1) * p - this._p2) : 0.5 * ((p -= 2) * p * ((this._p2 + 1) * p + this._p2) + 2);
    })), //SlowMo
    SlowMo = _class("easing.SlowMo", function(linearRatio, power, yoyoMode) {
        power = power || power === 0 ? power : 0.7;
        if (linearRatio == null) linearRatio = 0.7;
        else if (linearRatio > 1) linearRatio = 1;
        this._p = linearRatio !== 1 ? power : 0;
        this._p1 = (1 - linearRatio) / 2;
        this._p2 = linearRatio;
        this._p3 = this._p1 + this._p2;
        this._calcEnd = yoyoMode === true;
    }, true), p = SlowMo.prototype = new (0, $hYzRA.Ease)(), SteppedEase, ExpoScaleEase, RoughEase, _createElastic;
    p.constructor = SlowMo;
    p.getRatio = function(p) {
        var r = p + (0.5 - p) * this._p;
        if (p < this._p1) return this._calcEnd ? 1 - (p = 1 - p / this._p1) * p : r - (p = 1 - p / this._p1) * p * p * p * r;
        else if (p > this._p3) return this._calcEnd ? p === 1 ? 0 : 1 - (p = (p - this._p3) / this._p1) * p : r + (p - r) * (p = (p - this._p3) / this._p1) * p * p * p; //added p === 1 ? 0 to avoid floating point rounding errors from affecting the final value, like 1 - 0.7 = 0.30000000000000004 instead of 0.3
        return this._calcEnd ? 1 : r;
    };
    SlowMo.ease = new SlowMo(0.7, 0.7);
    p.config = SlowMo.config = function(linearRatio, power, yoyoMode) {
        return new SlowMo(linearRatio, power, yoyoMode);
    };
    //SteppedEase
    SteppedEase = _class("easing.SteppedEase", function(steps, immediateStart) {
        steps = steps || 1;
        this._p1 = 1 / steps;
        this._p2 = steps + (immediateStart ? 0 : 1);
        this._p3 = immediateStart ? 1 : 0;
    }, true);
    p = SteppedEase.prototype = new (0, $hYzRA.Ease)();
    p.constructor = SteppedEase;
    p.getRatio = function(p) {
        if (p < 0) p = 0;
        else if (p >= 1) p = 0.999999999;
        return ((this._p2 * p | 0) + this._p3) * this._p1;
    };
    p.config = SteppedEase.config = function(steps, immediateStart) {
        return new SteppedEase(steps, immediateStart);
    };
    //ExpoScaleEase
    ExpoScaleEase = _class("easing.ExpoScaleEase", function(start, end, ease) {
        this._p1 = Math.log(end / start);
        this._p2 = end - start;
        this._p3 = start;
        this._ease = ease;
    }, true);
    p = ExpoScaleEase.prototype = new (0, $hYzRA.Ease)();
    p.constructor = ExpoScaleEase;
    p.getRatio = function(p) {
        if (this._ease) p = this._ease.getRatio(p);
        return (this._p3 * Math.exp(this._p1 * p) - this._p3) / this._p2;
    };
    p.config = ExpoScaleEase.config = function(start, end, ease) {
        return new ExpoScaleEase(start, end, ease);
    };
    //RoughEase
    RoughEase = _class("easing.RoughEase", function(vars) {
        vars = vars || {};
        var taper = vars.taper || "none", a = [], cnt = 0, points = (vars.points || 20) | 0, i = points, randomize = vars.randomize !== false, clamp = vars.clamp === true, template = vars.template instanceof (0, $hYzRA.Ease) ? vars.template : null, strength = typeof vars.strength === "number" ? vars.strength * 0.4 : 0.4, x, y, bump, invX, obj, pnt;
        while(--i > -1){
            x = randomize ? Math.random() : 1 / points * i;
            y = template ? template.getRatio(x) : x;
            if (taper === "none") bump = strength;
            else if (taper === "out") {
                invX = 1 - x;
                bump = invX * invX * strength;
            } else if (taper === "in") bump = x * x * strength;
            else if (x < 0.5) {
                invX = x * 2;
                bump = invX * invX * 0.5 * strength;
            } else {
                invX = (1 - x) * 2;
                bump = invX * invX * 0.5 * strength;
            }
            if (randomize) y += Math.random() * bump - bump * 0.5;
            else if (i % 2) y += bump * 0.5;
            else y -= bump * 0.5;
            if (clamp) {
                if (y > 1) y = 1;
                else if (y < 0) y = 0;
            }
            a[cnt++] = {
                x: x,
                y: y
            };
        }
        a.sort(function(a, b) {
            return a.x - b.x;
        });
        pnt = new EasePoint(1, 1, null);
        i = points;
        while(--i > -1){
            obj = a[i];
            pnt = new EasePoint(obj.x, obj.y, pnt);
        }
        this._prev = new EasePoint(0, 0, pnt.t !== 0 ? pnt : pnt.next);
    }, true);
    p = RoughEase.prototype = new (0, $hYzRA.Ease)();
    p.constructor = RoughEase;
    p.getRatio = function(p) {
        var pnt = this._prev;
        if (p > pnt.t) {
            while(pnt.next && p >= pnt.t)pnt = pnt.next;
            pnt = pnt.prev;
        } else while(pnt.prev && p <= pnt.t)pnt = pnt.prev;
        this._prev = pnt;
        return pnt.v + (p - pnt.t) / pnt.gap * pnt.c;
    };
    p.config = function(vars) {
        return new RoughEase(vars);
    };
    RoughEase.ease = new RoughEase();
    //Bounce
    _wrap("Bounce", _create("BounceOut", function(p) {
        if (p < 1 / 2.75) return 7.5625 * p * p;
        else if (p < 2 / 2.75) return 7.5625 * (p -= 1.5 / 2.75) * p + 0.75;
        else if (p < 2.5 / 2.75) return 7.5625 * (p -= 2.25 / 2.75) * p + 0.9375;
        return 7.5625 * (p -= 2.625 / 2.75) * p + 0.984375;
    }), _create("BounceIn", function(p) {
        if ((p = 1 - p) < 1 / 2.75) return 1 - 7.5625 * p * p;
        else if (p < 2 / 2.75) return 1 - (7.5625 * (p -= 1.5 / 2.75) * p + 0.75);
        else if (p < 2.5 / 2.75) return 1 - (7.5625 * (p -= 2.25 / 2.75) * p + 0.9375);
        return 1 - (7.5625 * (p -= 2.625 / 2.75) * p + 0.984375);
    }), _create("BounceInOut", function(p) {
        var invert = p < 0.5;
        if (invert) p = 1 - p * 2;
        else p = p * 2 - 1;
        if (p < 1 / 2.75) p = 7.5625 * p * p;
        else if (p < 2 / 2.75) p = 7.5625 * (p -= 1.5 / 2.75) * p + 0.75;
        else if (p < 2.5 / 2.75) p = 7.5625 * (p -= 2.25 / 2.75) * p + 0.9375;
        else p = 7.5625 * (p -= 2.625 / 2.75) * p + 0.984375;
        return invert ? (1 - p) * 0.5 : p * 0.5 + 0.5;
    }));
    //CIRC
    _wrap("Circ", _create("CircOut", function(p) {
        return Math.sqrt(1 - (p = p - 1) * p);
    }), _create("CircIn", function(p) {
        return -(Math.sqrt(1 - p * p) - 1);
    }), _create("CircInOut", function(p) {
        return (p *= 2) < 1 ? -0.5 * (Math.sqrt(1 - p * p) - 1) : 0.5 * (Math.sqrt(1 - (p -= 2) * p) + 1);
    }));
    //Elastic
    _createElastic = function(n, f, def) {
        var C = _class("easing." + n, function(amplitude, period) {
            this._p1 = amplitude >= 1 ? amplitude : 1; //note: if amplitude is < 1, we simply adjust the period for a more natural feel. Otherwise the math doesn't work right and the curve starts at 1.
            this._p2 = (period || def) / (amplitude < 1 ? amplitude : 1);
            this._p3 = this._p2 / _2PI * (Math.asin(1 / this._p1) || 0);
            this._p2 = _2PI / this._p2; //precalculate to optimize
        }, true), p = C.prototype = new (0, $hYzRA.Ease)();
        p.constructor = C;
        p.getRatio = f;
        p.config = function(amplitude, period) {
            return new C(amplitude, period);
        };
        return C;
    };
    _wrap("Elastic", _createElastic("ElasticOut", function(p) {
        return this._p1 * Math.pow(2, -10 * p) * Math.sin((p - this._p3) * this._p2) + 1;
    }, 0.3), _createElastic("ElasticIn", function(p) {
        return -(this._p1 * Math.pow(2, 10 * (p -= 1)) * Math.sin((p - this._p3) * this._p2));
    }, 0.3), _createElastic("ElasticInOut", function(p) {
        return (p *= 2) < 1 ? -0.5 * (this._p1 * Math.pow(2, 10 * (p -= 1)) * Math.sin((p - this._p3) * this._p2)) : this._p1 * Math.pow(2, -10 * (p -= 1)) * Math.sin((p - this._p3) * this._p2) * 0.5 + 1;
    }, 0.45));
    //Expo
    _wrap("Expo", _create("ExpoOut", function(p) {
        return 1 - Math.pow(2, -10 * p);
    }), _create("ExpoIn", function(p) {
        return Math.pow(2, 10 * (p - 1)) - 0.001;
    }), _create("ExpoInOut", function(p) {
        return (p *= 2) < 1 ? 0.5 * Math.pow(2, 10 * (p - 1)) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));
    }));
    //Sine
    _wrap("Sine", _create("SineOut", function(p) {
        return Math.sin(p * _HALF_PI);
    }), _create("SineIn", function(p) {
        return -Math.cos(p * _HALF_PI) + 1;
    }), _create("SineInOut", function(p) {
        return -0.5 * (Math.cos(Math.PI * p) - 1);
    }));
    _class("easing.EaseLookup", {
        find: function(s) {
            return (0, $hYzRA.Ease).map[s];
        }
    }, true);
    //register the non-standard eases
    _easeReg(w.SlowMo, "SlowMo", "ease,");
    _easeReg(RoughEase, "RoughEase", "ease,");
    _easeReg(SteppedEase, "SteppedEase", "ease,");
    return Back;
}, true);
var $3260ef4742851ffd$export$25e48ac541203d4a = (0, $hYzRA.globals).Back;
var $3260ef4742851ffd$export$56ebabebb04a9ca9 = (0, $hYzRA.globals).Elastic;
var $3260ef4742851ffd$export$d20e79fdc3899e95 = (0, $hYzRA.globals).Bounce;
var $3260ef4742851ffd$export$116b12203755670f = (0, $hYzRA.globals).RoughEase;
var $3260ef4742851ffd$export$5b8ec41d2880926f = (0, $hYzRA.globals).SlowMo;
var $3260ef4742851ffd$export$f7a11c7543d81853 = (0, $hYzRA.globals).SteppedEase;
var $3260ef4742851ffd$export$ce49a57dd865b86c = (0, $hYzRA.globals).Circ;
var $3260ef4742851ffd$export$41e9d1ff1a2fb15a = (0, $hYzRA.globals).Expo;
var $3260ef4742851ffd$export$bed2d20ad96b784c = (0, $hYzRA.globals).Sine;
var $3260ef4742851ffd$export$f95db16282c8d7a4 = (0, $hYzRA.globals).ExpoScaleEase;

});



parcelRequire.register("ctrgf", function(module, exports) {
/*!
 * ScrollMagic v2.0.7 (2019-05-07)
 * The javascript library for magical scroll interactions.
 * (c) 2019 Jan Paepke (@janpaepke)
 * Project Website: http://scrollmagic.io
 * 
 * @version 2.0.7
 * @license Dual licensed under MIT license and GPL.
 * @author Jan Paepke - e-mail@janpaepke.de
 *
 * @file ScrollMagic main library.
 */ /**
 * @namespace ScrollMagic
 */ (function(root, factory) {
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define(factory);
    else // CommonJS
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    var ScrollMagic = function() {
        _util.log(2, "(COMPATIBILITY NOTICE) -> As of ScrollMagic 2.0.0 you need to use 'new ScrollMagic.Controller()' to create a new controller instance. Use 'new ScrollMagic.Scene()' to instance a scene.");
    };
    ScrollMagic.version = "2.0.7";
    // TODO: temporary workaround for chrome's scroll jitter bug
    window.addEventListener("mousewheel", function() {});
    // global const
    var PIN_SPACER_ATTRIBUTE = "data-scrollmagic-pin-spacer";
    /**
	 * The main class that is needed once per scroll container.
	 *
	 * @class
	 *
	 * @example
	 * // basic initialization
	 * var controller = new ScrollMagic.Controller();
	 *
	 * // passing options
	 * var controller = new ScrollMagic.Controller({container: "#myContainer", loglevel: 3});
	 *
	 * @param {object} [options] - An object containing one or more options for the controller.
	 * @param {(string|object)} [options.container=window] - A selector, DOM object that references the main container for scrolling.
	 * @param {boolean} [options.vertical=true] - Sets the scroll mode to vertical (`true`) or horizontal (`false`) scrolling.
	 * @param {object} [options.globalSceneOptions={}] - These options will be passed to every Scene that is added to the controller using the addScene method. For more information on Scene options see {@link ScrollMagic.Scene}.
	 * @param {number} [options.loglevel=2] Loglevel for debugging. Note that logging is disabled in the minified version of ScrollMagic.
											 ** `0` => silent
											 ** `1` => errors
											 ** `2` => errors, warnings
											 ** `3` => errors, warnings, debuginfo
	 * @param {boolean} [options.refreshInterval=100] - Some changes don't call events by default, like changing the container size or moving a scene trigger element.  
	 																										 This interval polls these parameters to fire the necessary events.  
	 																										 If you don't use custom containers, trigger elements or have static layouts, where the positions of the trigger elements don't change, you can set this to 0 disable interval checking and improve performance.
	 *
	 */ ScrollMagic.Controller = function(options) {
        /*
		 * ----------------------------------------------------------------
		 * settings
		 * ----------------------------------------------------------------
		 */ var NAMESPACE = "ScrollMagic.Controller", SCROLL_DIRECTION_FORWARD = "FORWARD", SCROLL_DIRECTION_REVERSE = "REVERSE", SCROLL_DIRECTION_PAUSED = "PAUSED", DEFAULT_OPTIONS = CONTROLLER_OPTIONS.defaults;
        /*
		 * ----------------------------------------------------------------
		 * private vars
		 * ----------------------------------------------------------------
		 */ var Controller = this, _options = _util.extend({}, DEFAULT_OPTIONS, options), _sceneObjects = [], _updateScenesOnNextCycle = false, _scrollPos = 0, _scrollDirection = SCROLL_DIRECTION_PAUSED, _isDocument = true, _viewPortSize = 0, _enabled = true, _updateTimeout, _refreshTimeout;
        /*
		 * ----------------------------------------------------------------
		 * private functions
		 * ----------------------------------------------------------------
		 */ /**
		 * Internal constructor function of the ScrollMagic Controller
		 * @private
		 */ var construct = function() {
            for(var key in _options)if (!DEFAULT_OPTIONS.hasOwnProperty(key)) {
                log(2, 'WARNING: Unknown option "' + key + '"');
                delete _options[key];
            }
            _options.container = _util.get.elements(_options.container)[0];
            // check ScrollContainer
            if (!_options.container) {
                log(1, "ERROR creating object " + NAMESPACE + ": No valid scroll container supplied");
                throw NAMESPACE + " init failed."; // cancel
            }
            _isDocument = _options.container === window || _options.container === document.body || !document.body.contains(_options.container);
            // normalize to window
            if (_isDocument) _options.container = window;
            // update container size immediately
            _viewPortSize = getViewportSize();
            // set event handlers
            _options.container.addEventListener("resize", onChange);
            _options.container.addEventListener("scroll", onChange);
            var ri = parseInt(_options.refreshInterval, 10);
            _options.refreshInterval = _util.type.Number(ri) ? ri : DEFAULT_OPTIONS.refreshInterval;
            scheduleRefresh();
            log(3, "added new " + NAMESPACE + " controller (v" + ScrollMagic.version + ")");
        };
        /**
		 * Schedule the next execution of the refresh function
		 * @private
		 */ var scheduleRefresh = function() {
            if (_options.refreshInterval > 0) _refreshTimeout = window.setTimeout(refresh, _options.refreshInterval);
        };
        /**
		 * Default function to get scroll pos - overwriteable using `Controller.scrollPos(newFunction)`
		 * @private
		 */ var getScrollPos = function() {
            return _options.vertical ? _util.get.scrollTop(_options.container) : _util.get.scrollLeft(_options.container);
        };
        /**
		 * Returns the current viewport Size (width vor horizontal, height for vertical)
		 * @private
		 */ var getViewportSize = function() {
            return _options.vertical ? _util.get.height(_options.container) : _util.get.width(_options.container);
        };
        /**
		 * Default function to set scroll pos - overwriteable using `Controller.scrollTo(newFunction)`
		 * Make available publicly for pinned mousewheel workaround.
		 * @private
		 */ var setScrollPos = this._setScrollPos = function(pos) {
            if (_options.vertical) {
                if (_isDocument) window.scrollTo(_util.get.scrollLeft(), pos);
                else _options.container.scrollTop = pos;
            } else if (_isDocument) window.scrollTo(pos, _util.get.scrollTop());
            else _options.container.scrollLeft = pos;
        };
        /**
		 * Handle updates in cycles instead of on scroll (performance)
		 * @private
		 */ var updateScenes = function() {
            if (_enabled && _updateScenesOnNextCycle) {
                // determine scenes to update
                var scenesToUpdate = _util.type.Array(_updateScenesOnNextCycle) ? _updateScenesOnNextCycle : _sceneObjects.slice(0);
                // reset scenes
                _updateScenesOnNextCycle = false;
                var oldScrollPos = _scrollPos;
                // update scroll pos now instead of onChange, as it might have changed since scheduling (i.e. in-browser smooth scroll)
                _scrollPos = Controller.scrollPos();
                var deltaScroll = _scrollPos - oldScrollPos;
                if (deltaScroll !== 0) _scrollDirection = deltaScroll > 0 ? SCROLL_DIRECTION_FORWARD : SCROLL_DIRECTION_REVERSE;
                // reverse order of scenes if scrolling reverse
                if (_scrollDirection === SCROLL_DIRECTION_REVERSE) scenesToUpdate.reverse();
                // update scenes
                scenesToUpdate.forEach(function(scene, index) {
                    log(3, "updating Scene " + (index + 1) + "/" + scenesToUpdate.length + " (" + _sceneObjects.length + " total)");
                    scene.update(true);
                });
                if (scenesToUpdate.length === 0 && _options.loglevel >= 3) log(3, "updating 0 Scenes (nothing added to controller)");
            }
        };
        /**
		 * Initializes rAF callback
		 * @private
		 */ var debounceUpdate = function() {
            _updateTimeout = _util.rAF(updateScenes);
        };
        /**
		 * Handles Container changes
		 * @private
		 */ var onChange = function(e) {
            log(3, "event fired causing an update:", e.type);
            if (e.type == "resize") {
                // resize
                _viewPortSize = getViewportSize();
                _scrollDirection = SCROLL_DIRECTION_PAUSED;
            }
            // schedule update
            if (_updateScenesOnNextCycle !== true) {
                _updateScenesOnNextCycle = true;
                debounceUpdate();
            }
        };
        var refresh = function() {
            if (!_isDocument) // simulate resize event. Only works for viewport relevant param (performance)
            {
                if (_viewPortSize != getViewportSize()) {
                    var resizeEvent;
                    try {
                        resizeEvent = new Event("resize", {
                            bubbles: false,
                            cancelable: false
                        });
                    } catch (e) {
                        resizeEvent = document.createEvent("Event");
                        resizeEvent.initEvent("resize", false, false);
                    }
                    _options.container.dispatchEvent(resizeEvent);
                }
            }
            _sceneObjects.forEach(function(scene, index) {
                scene.refresh();
            });
            scheduleRefresh();
        };
        /**
		 * Send a debug message to the console.
		 * provided publicly with _log for plugins
		 * @private
		 *
		 * @param {number} loglevel - The loglevel required to initiate output for the message.
		 * @param {...mixed} output - One or more variables that should be passed to the console.
		 */ var log = this._log = function(loglevel, output) {
            if (_options.loglevel >= loglevel) {
                Array.prototype.splice.call(arguments, 1, 0, "(" + NAMESPACE + ") ->");
                _util.log.apply(window, arguments);
            }
        };
        // for scenes we have getters for each option, but for the controller we don't, so we need to make it available externally for plugins
        this._options = _options;
        /**
		 * Sort scenes in ascending order of their start offset.
		 * @private
		 *
		 * @param {array} ScenesArray - an array of ScrollMagic Scenes that should be sorted
		 * @return {array} The sorted array of Scenes.
		 */ var sortScenes = function(ScenesArray) {
            if (ScenesArray.length <= 1) return ScenesArray;
            else {
                var scenes = ScenesArray.slice(0);
                scenes.sort(function(a, b) {
                    return a.scrollOffset() > b.scrollOffset() ? 1 : -1;
                });
                return scenes;
            }
        };
        /**
		 * ----------------------------------------------------------------
		 * public functions
		 * ----------------------------------------------------------------
		 */ /**
		 * Add one ore more scene(s) to the controller.  
		 * This is the equivalent to `Scene.addTo(controller)`.
		 * @public
		 * @example
		 * // with a previously defined scene
		 * controller.addScene(scene);
		 *
		 * // with a newly created scene.
		 * controller.addScene(new ScrollMagic.Scene({duration : 0}));
		 *
		 * // adding multiple scenes
		 * controller.addScene([scene, scene2, new ScrollMagic.Scene({duration : 0})]);
		 *
		 * @param {(ScrollMagic.Scene|array)} newScene - ScrollMagic Scene or Array of Scenes to be added to the controller.
		 * @return {Controller} Parent object for chaining.
		 */ this.addScene = function(newScene) {
            if (_util.type.Array(newScene)) newScene.forEach(function(scene, index) {
                Controller.addScene(scene);
            });
            else if (newScene instanceof ScrollMagic.Scene) {
                if (newScene.controller() !== Controller) newScene.addTo(Controller);
                else if (_sceneObjects.indexOf(newScene) < 0) {
                    // new scene
                    _sceneObjects.push(newScene); // add to array
                    _sceneObjects = sortScenes(_sceneObjects); // sort
                    newScene.on("shift.controller_sort", function() {
                        _sceneObjects = sortScenes(_sceneObjects);
                    });
                    // insert Global defaults.
                    for(var key in _options.globalSceneOptions)if (newScene[key]) newScene[key].call(newScene, _options.globalSceneOptions[key]);
                    log(3, "adding Scene (now " + _sceneObjects.length + " total)");
                }
            } else log(1, "ERROR: invalid argument supplied for '.addScene()'");
            return Controller;
        };
        /**
		 * Remove one ore more scene(s) from the controller.  
		 * This is the equivalent to `Scene.remove()`.
		 * @public
		 * @example
		 * // remove a scene from the controller
		 * controller.removeScene(scene);
		 *
		 * // remove multiple scenes from the controller
		 * controller.removeScene([scene, scene2, scene3]);
		 *
		 * @param {(ScrollMagic.Scene|array)} Scene - ScrollMagic Scene or Array of Scenes to be removed from the controller.
		 * @returns {Controller} Parent object for chaining.
		 */ this.removeScene = function(Scene) {
            if (_util.type.Array(Scene)) Scene.forEach(function(scene, index) {
                Controller.removeScene(scene);
            });
            else {
                var index = _sceneObjects.indexOf(Scene);
                if (index > -1) {
                    Scene.off("shift.controller_sort");
                    _sceneObjects.splice(index, 1);
                    log(3, "removing Scene (now " + _sceneObjects.length + " left)");
                    Scene.remove();
                }
            }
            return Controller;
        };
        /**
	 * Update one ore more scene(s) according to the scroll position of the container.  
	 * This is the equivalent to `Scene.update()`.  
	 * The update method calculates the scene's start and end position (based on the trigger element, trigger hook, duration and offset) and checks it against the current scroll position of the container.  
	 * It then updates the current scene state accordingly (or does nothing, if the state is already correct) – Pins will be set to their correct position and tweens will be updated to their correct progress.  
	 * _**Note:** This method gets called constantly whenever Controller detects a change. The only application for you is if you change something outside of the realm of ScrollMagic, like moving the trigger or changing tween parameters._
	 * @public
	 * @example
	 * // update a specific scene on next cycle
 	 * controller.updateScene(scene);
 	 *
	 * // update a specific scene immediately
	 * controller.updateScene(scene, true);
 	 *
	 * // update multiple scenes scene on next cycle
	 * controller.updateScene([scene1, scene2, scene3]);
	 *
	 * @param {ScrollMagic.Scene} Scene - ScrollMagic Scene or Array of Scenes that is/are supposed to be updated.
	 * @param {boolean} [immediately=false] - If `true` the update will be instant, if `false` it will wait until next update cycle.  
	 										  This is useful when changing multiple properties of the scene - this way it will only be updated once all new properties are set (updateScenes).
	 * @return {Controller} Parent object for chaining.
	 */ this.updateScene = function(Scene, immediately) {
            if (_util.type.Array(Scene)) Scene.forEach(function(scene, index) {
                Controller.updateScene(scene, immediately);
            });
            else {
                if (immediately) Scene.update(true);
                else if (_updateScenesOnNextCycle !== true && Scene instanceof ScrollMagic.Scene) {
                    // prep array for next update cycle
                    _updateScenesOnNextCycle = _updateScenesOnNextCycle || [];
                    if (_updateScenesOnNextCycle.indexOf(Scene) == -1) _updateScenesOnNextCycle.push(Scene);
                    _updateScenesOnNextCycle = sortScenes(_updateScenesOnNextCycle); // sort
                    debounceUpdate();
                }
            }
            return Controller;
        };
        /**
		 * Updates the controller params and calls updateScene on every scene, that is attached to the controller.  
		 * See `Controller.updateScene()` for more information about what this means.  
		 * In most cases you will not need this function, as it is called constantly, whenever ScrollMagic detects a state change event, like resize or scroll.  
		 * The only application for this method is when ScrollMagic fails to detect these events.  
		 * One application is with some external scroll libraries (like iScroll) that move an internal container to a negative offset instead of actually scrolling. In this case the update on the controller needs to be called whenever the child container's position changes.
		 * For this case there will also be the need to provide a custom function to calculate the correct scroll position. See `Controller.scrollPos()` for details.
		 * @public
		 * @example
		 * // update the controller on next cycle (saves performance due to elimination of redundant updates)
		 * controller.update();
		 *
		 * // update the controller immediately
		 * controller.update(true);
		 *
		 * @param {boolean} [immediately=false] - If `true` the update will be instant, if `false` it will wait until next update cycle (better performance)
		 * @return {Controller} Parent object for chaining.
		 */ this.update = function(immediately) {
            onChange({
                type: "resize"
            }); // will update size and set _updateScenesOnNextCycle to true
            if (immediately) updateScenes();
            return Controller;
        };
        /**
		 * Scroll to a numeric scroll offset, a DOM element, the start of a scene or provide an alternate method for scrolling.  
		 * For vertical controllers it will change the top scroll offset and for horizontal applications it will change the left offset.
		 * @public
		 *
		 * @since 1.1.0
		 * @example
		 * // scroll to an offset of 100
		 * controller.scrollTo(100);
		 *
		 * // scroll to a DOM element
		 * controller.scrollTo("#anchor");
		 *
		 * // scroll to the beginning of a scene
		 * var scene = new ScrollMagic.Scene({offset: 200});
		 * controller.scrollTo(scene);
		 *
		 * // define a new scroll position modification function (jQuery animate instead of jump)
		 * controller.scrollTo(function (newScrollPos) {
		 *	$("html, body").animate({scrollTop: newScrollPos});
		 * });
		 * controller.scrollTo(100); // call as usual, but the new function will be used instead
		 *
		 * // define a new scroll function with an additional parameter
		 * controller.scrollTo(function (newScrollPos, message) {
		 *  console.log(message);
		 *	$(this).animate({scrollTop: newScrollPos});
		 * });
		 * // call as usual, but supply an extra parameter to the defined custom function
		 * controller.scrollTo(100, "my message");
		 *
		 * // define a new scroll function with an additional parameter containing multiple variables
		 * controller.scrollTo(function (newScrollPos, options) {
		 *  someGlobalVar = options.a + options.b;
		 *	$(this).animate({scrollTop: newScrollPos});
		 * });
		 * // call as usual, but supply an extra parameter containing multiple options
		 * controller.scrollTo(100, {a: 1, b: 2});
		 *
		 * // define a new scroll function with a callback supplied as an additional parameter
		 * controller.scrollTo(function (newScrollPos, callback) {
		 *	$(this).animate({scrollTop: newScrollPos}, 400, "swing", callback);
		 * });
		 * // call as usual, but supply an extra parameter, which is used as a callback in the previously defined custom scroll function
		 * controller.scrollTo(100, function() {
		 *	console.log("scroll has finished.");
		 * });
		 *
		 * @param {mixed} scrollTarget - The supplied argument can be one of these types:
		 * 1. `number` -> The container will scroll to this new scroll offset.
		 * 2. `string` or `object` -> Can be a selector or a DOM object.  
		 *  The container will scroll to the position of this element.
		 * 3. `ScrollMagic Scene` -> The container will scroll to the start of this scene.
		 * 4. `function` -> This function will be used for future scroll position modifications.  
		 *  This provides a way for you to change the behaviour of scrolling and adding new behaviour like animation. The function receives the new scroll position as a parameter and a reference to the container element using `this`.  
		 *  It may also optionally receive an optional additional parameter (see below)  
		 *  _**NOTE:**  
		 *  All other options will still work as expected, using the new function to scroll._
		 * @param {mixed} [additionalParameter] - If a custom scroll function was defined (see above 4.), you may want to supply additional parameters to it, when calling it. You can do this using this parameter – see examples for details. Please note, that this parameter will have no effect, if you use the default scrolling function.
		 * @returns {Controller} Parent object for chaining.
		 */ this.scrollTo = function(scrollTarget, additionalParameter) {
            if (_util.type.Number(scrollTarget)) setScrollPos.call(_options.container, scrollTarget, additionalParameter);
            else if (scrollTarget instanceof ScrollMagic.Scene) {
                if (scrollTarget.controller() === Controller) Controller.scrollTo(scrollTarget.scrollOffset(), additionalParameter);
                else log(2, "scrollTo(): The supplied scene does not belong to this controller. Scroll cancelled.", scrollTarget);
            } else if (_util.type.Function(scrollTarget)) setScrollPos = scrollTarget;
            else {
                var elem = _util.get.elements(scrollTarget)[0];
                if (elem) {
                    // if parent is pin spacer, use spacer position instead so correct start position is returned for pinned elements.
                    while(elem.parentNode.hasAttribute(PIN_SPACER_ATTRIBUTE))elem = elem.parentNode;
                    var param = _options.vertical ? "top" : "left", containerOffset = _util.get.offset(_options.container), elementOffset = _util.get.offset(elem);
                    if (!_isDocument) containerOffset[param] -= Controller.scrollPos();
                    Controller.scrollTo(elementOffset[param] - containerOffset[param], additionalParameter);
                } else log(2, "scrollTo(): The supplied argument is invalid. Scroll cancelled.", scrollTarget);
            }
            return Controller;
        };
        /**
		 * **Get** the current scrollPosition or **Set** a new method to calculate it.  
		 * -> **GET**:
		 * When used as a getter this function will return the current scroll position.  
		 * To get a cached value use Controller.info("scrollPos"), which will be updated in the update cycle.  
		 * For vertical controllers it will return the top scroll offset and for horizontal applications it will return the left offset.
		 *
		 * -> **SET**:
		 * When used as a setter this method prodes a way to permanently overwrite the controller's scroll position calculation.  
		 * A typical usecase is when the scroll position is not reflected by the containers scrollTop or scrollLeft values, but for example by the inner offset of a child container.  
		 * Moving a child container inside a parent is a commonly used method for several scrolling frameworks, including iScroll.  
		 * By providing an alternate calculation function you can make sure ScrollMagic receives the correct scroll position.  
		 * Please also bear in mind that your function should return y values for vertical scrolls an x for horizontals.
		 *
		 * To change the current scroll position please use `Controller.scrollTo()`.
		 * @public
		 *
		 * @example
		 * // get the current scroll Position
		 * var scrollPos = controller.scrollPos();
		 *
		 * // set a new scroll position calculation method
		 * controller.scrollPos(function () {
		 *	return this.info("vertical") ? -mychildcontainer.y : -mychildcontainer.x
		 * });
		 *
		 * @param {function} [scrollPosMethod] - The function to be used for the scroll position calculation of the container.
		 * @returns {(number|Controller)} Current scroll position or parent object for chaining.
		 */ this.scrollPos = function(scrollPosMethod) {
            if (!arguments.length) return getScrollPos.call(Controller);
            else if (_util.type.Function(scrollPosMethod)) getScrollPos = scrollPosMethod;
            else log(2, "Provided value for method 'scrollPos' is not a function. To change the current scroll position use 'scrollTo()'.");
            return Controller;
        };
        /**
		 * **Get** all infos or one in particular about the controller.
		 * @public
		 * @example
		 * // returns the current scroll position (number)
		 * var scrollPos = controller.info("scrollPos");
		 *
		 * // returns all infos as an object
		 * var infos = controller.info();
		 *
		 * @param {string} [about] - If passed only this info will be returned instead of an object containing all.  
		 							 Valid options are:
		 							 ** `"size"` => the current viewport size of the container
		 							 ** `"vertical"` => true if vertical scrolling, otherwise false
		 							 ** `"scrollPos"` => the current scroll position
		 							 ** `"scrollDirection"` => the last known direction of the scroll
		 							 ** `"container"` => the container element
		 							 ** `"isDocument"` => true if container element is the document.
		 * @returns {(mixed|object)} The requested info(s).
		 */ this.info = function(about) {
            var values = {
                size: _viewPortSize,
                vertical: _options.vertical,
                scrollPos: _scrollPos,
                scrollDirection: _scrollDirection,
                container: _options.container,
                isDocument: _isDocument
            };
            if (!arguments.length) return values;
            else if (values[about] !== undefined) return values[about];
            else {
                log(1, 'ERROR: option "' + about + '" is not available');
                return;
            }
        };
        /**
		 * **Get** or **Set** the current loglevel option value.
		 * @public
		 *
		 * @example
		 * // get the current value
		 * var loglevel = controller.loglevel();
		 *
		 * // set a new value
		 * controller.loglevel(3);
		 *
		 * @param {number} [newLoglevel] - The new loglevel setting of the Controller. `[0-3]`
		 * @returns {(number|Controller)} Current loglevel or parent object for chaining.
		 */ this.loglevel = function(newLoglevel) {
            if (!arguments.length) return _options.loglevel;
            else if (_options.loglevel != newLoglevel) _options.loglevel = newLoglevel;
            return Controller;
        };
        /**
		 * **Get** or **Set** the current enabled state of the controller.  
		 * This can be used to disable all Scenes connected to the controller without destroying or removing them.
		 * @public
		 *
		 * @example
		 * // get the current value
		 * var enabled = controller.enabled();
		 *
		 * // disable the controller
		 * controller.enabled(false);
		 *
		 * @param {boolean} [newState] - The new enabled state of the controller `true` or `false`.
		 * @returns {(boolean|Controller)} Current enabled state or parent object for chaining.
		 */ this.enabled = function(newState) {
            if (!arguments.length) return _enabled;
            else if (_enabled != newState) {
                _enabled = !!newState;
                Controller.updateScene(_sceneObjects, true);
            }
            return Controller;
        };
        /**
		 * Destroy the Controller, all Scenes and everything.
		 * @public
		 *
		 * @example
		 * // without resetting the scenes
		 * controller = controller.destroy();
		 *
		 * // with scene reset
		 * controller = controller.destroy(true);
		 *
		 * @param {boolean} [resetScenes=false] - If `true` the pins and tweens (if existent) of all scenes will be reset.
		 * @returns {null} Null to unset handler variables.
		 */ this.destroy = function(resetScenes) {
            window.clearTimeout(_refreshTimeout);
            var i = _sceneObjects.length;
            while(i--)_sceneObjects[i].destroy(resetScenes);
            _options.container.removeEventListener("resize", onChange);
            _options.container.removeEventListener("scroll", onChange);
            _util.cAF(_updateTimeout);
            log(3, "destroyed " + NAMESPACE + " (reset: " + (resetScenes ? "true" : "false") + ")");
            return null;
        };
        // INIT
        construct();
        return Controller;
    };
    // store pagewide controller options
    var CONTROLLER_OPTIONS = {
        defaults: {
            container: window,
            vertical: true,
            globalSceneOptions: {},
            loglevel: 2,
            refreshInterval: 100
        }
    };
    /*
	 * method used to add an option to ScrollMagic Scenes.
	 */ ScrollMagic.Controller.addOption = function(name, defaultValue) {
        CONTROLLER_OPTIONS.defaults[name] = defaultValue;
    };
    // instance extension function for plugins
    ScrollMagic.Controller.extend = function(extension) {
        var oldClass = this;
        ScrollMagic.Controller = function() {
            oldClass.apply(this, arguments);
            this.$super = _util.extend({}, this); // copy parent state
            return extension.apply(this, arguments) || this;
        };
        _util.extend(ScrollMagic.Controller, oldClass); // copy properties
        ScrollMagic.Controller.prototype = oldClass.prototype; // copy prototype
        ScrollMagic.Controller.prototype.constructor = ScrollMagic.Controller; // restore constructor
    };
    /**
	 * A Scene defines where the controller should react and how.
	 *
	 * @class
	 *
	 * @example
	 * // create a standard scene and add it to a controller
	 * new ScrollMagic.Scene()
	 *		.addTo(controller);
	 *
	 * // create a scene with custom options and assign a handler to it.
	 * var scene = new ScrollMagic.Scene({
	 * 		duration: 100,
	 *		offset: 200,
	 *		triggerHook: "onEnter",
	 *		reverse: false
	 * });
	 *
	 * @param {object} [options] - Options for the Scene. The options can be updated at any time.  
	 							   Instead of setting the options for each scene individually you can also set them globally in the controller as the controllers `globalSceneOptions` option. The object accepts the same properties as the ones below.  
	 							   When a scene is added to the controller the options defined using the Scene constructor will be overwritten by those set in `globalSceneOptions`.
	 * @param {(number|string|function)} [options.duration=0] - The duration of the scene. 
	 					Please see `Scene.duration()` for details.
	 * @param {number} [options.offset=0] - Offset Value for the Trigger Position. If no triggerElement is defined this will be the scroll distance from the start of the page, after which the scene will start.
	 * @param {(string|object)} [options.triggerElement=null] - Selector or DOM object that defines the start of the scene. If undefined the scene will start right at the start of the page (unless an offset is set).
	 * @param {(number|string)} [options.triggerHook="onCenter"] - Can be a number between 0 and 1 defining the position of the trigger Hook in relation to the viewport.  
	 															  Can also be defined using a string:
	 															  ** `"onEnter"` => `1`
	 															  ** `"onCenter"` => `0.5`
	 															  ** `"onLeave"` => `0`
	 * @param {boolean} [options.reverse=true] - Should the scene reverse, when scrolling up?
	 * @param {number} [options.loglevel=2] - Loglevel for debugging. Note that logging is disabled in the minified version of ScrollMagic.
	 										  ** `0` => silent
	 										  ** `1` => errors
	 										  ** `2` => errors, warnings
	 										  ** `3` => errors, warnings, debuginfo
	 * 
	 */ ScrollMagic.Scene = function(options) {
        /*
		 * ----------------------------------------------------------------
		 * settings
		 * ----------------------------------------------------------------
		 */ var NAMESPACE = "ScrollMagic.Scene", SCENE_STATE_BEFORE = "BEFORE", SCENE_STATE_DURING = "DURING", SCENE_STATE_AFTER = "AFTER", DEFAULT_OPTIONS = SCENE_OPTIONS.defaults;
        /*
		 * ----------------------------------------------------------------
		 * private vars
		 * ----------------------------------------------------------------
		 */ var Scene = this, _options = _util.extend({}, DEFAULT_OPTIONS, options), _state = SCENE_STATE_BEFORE, _progress = 0, _scrollOffset = {
            start: 0,
            end: 0
        }, _triggerPos = 0, _enabled = true, _durationUpdateMethod, _controller;
        /**
		 * Internal constructor function of the ScrollMagic Scene
		 * @private
		 */ var construct = function() {
            for(var key in _options)if (!DEFAULT_OPTIONS.hasOwnProperty(key)) {
                log(2, 'WARNING: Unknown option "' + key + '"');
                delete _options[key];
            }
            // add getters/setters for all possible options
            for(var optionName in DEFAULT_OPTIONS)addSceneOption(optionName);
            // validate all options
            validateOption();
        };
        /*
		 * ----------------------------------------------------------------
		 * Event Management
		 * ----------------------------------------------------------------
		 */ var _listeners = {};
        /**
		 * Scene start event.  
		 * Fires whenever the scroll position its the starting point of the scene.  
		 * It will also fire when scrolling back up going over the start position of the scene. If you want something to happen only when scrolling down/right, use the scrollDirection parameter passed to the callback.
		 *
		 * For details on this event and the order in which it is fired, please review the {@link Scene.progress} method.
		 *
		 * @event ScrollMagic.Scene#start
		 *
		 * @example
		 * scene.on("start", function (event) {
		 * 	console.log("Hit start point of scene.");
		 * });
		 *
		 * @property {object} event - The event Object passed to each callback
		 * @property {string} event.type - The name of the event
		 * @property {Scene} event.target - The Scene object that triggered this event
		 * @property {number} event.progress - Reflects the current progress of the scene
		 * @property {string} event.state - The current state of the scene `"BEFORE"` or `"DURING"`
		 * @property {string} event.scrollDirection - Indicates which way we are scrolling `"PAUSED"`, `"FORWARD"` or `"REVERSE"`
		 */ /**
		 * Scene end event.  
		 * Fires whenever the scroll position its the ending point of the scene.  
		 * It will also fire when scrolling back up from after the scene and going over its end position. If you want something to happen only when scrolling down/right, use the scrollDirection parameter passed to the callback.
		 *
		 * For details on this event and the order in which it is fired, please review the {@link Scene.progress} method.
		 *
		 * @event ScrollMagic.Scene#end
		 *
		 * @example
		 * scene.on("end", function (event) {
		 * 	console.log("Hit end point of scene.");
		 * });
		 *
		 * @property {object} event - The event Object passed to each callback
		 * @property {string} event.type - The name of the event
		 * @property {Scene} event.target - The Scene object that triggered this event
		 * @property {number} event.progress - Reflects the current progress of the scene
		 * @property {string} event.state - The current state of the scene `"DURING"` or `"AFTER"`
		 * @property {string} event.scrollDirection - Indicates which way we are scrolling `"PAUSED"`, `"FORWARD"` or `"REVERSE"`
		 */ /**
		 * Scene enter event.  
		 * Fires whenever the scene enters the "DURING" state.  
		 * Keep in mind that it doesn't matter if the scene plays forward or backward: This event always fires when the scene enters its active scroll timeframe, regardless of the scroll-direction.
		 *
		 * For details on this event and the order in which it is fired, please review the {@link Scene.progress} method.
		 *
		 * @event ScrollMagic.Scene#enter
		 *
		 * @example
		 * scene.on("enter", function (event) {
		 * 	console.log("Scene entered.");
		 * });
		 *
		 * @property {object} event - The event Object passed to each callback
		 * @property {string} event.type - The name of the event
		 * @property {Scene} event.target - The Scene object that triggered this event
		 * @property {number} event.progress - Reflects the current progress of the scene
		 * @property {string} event.state - The current state of the scene - always `"DURING"`
		 * @property {string} event.scrollDirection - Indicates which way we are scrolling `"PAUSED"`, `"FORWARD"` or `"REVERSE"`
		 */ /**
		 * Scene leave event.  
		 * Fires whenever the scene's state goes from "DURING" to either "BEFORE" or "AFTER".  
		 * Keep in mind that it doesn't matter if the scene plays forward or backward: This event always fires when the scene leaves its active scroll timeframe, regardless of the scroll-direction.
		 *
		 * For details on this event and the order in which it is fired, please review the {@link Scene.progress} method.
		 *
		 * @event ScrollMagic.Scene#leave
		 *
		 * @example
		 * scene.on("leave", function (event) {
		 * 	console.log("Scene left.");
		 * });
		 *
		 * @property {object} event - The event Object passed to each callback
		 * @property {string} event.type - The name of the event
		 * @property {Scene} event.target - The Scene object that triggered this event
		 * @property {number} event.progress - Reflects the current progress of the scene
		 * @property {string} event.state - The current state of the scene `"BEFORE"` or `"AFTER"`
		 * @property {string} event.scrollDirection - Indicates which way we are scrolling `"PAUSED"`, `"FORWARD"` or `"REVERSE"`
		 */ /**
		 * Scene update event.  
		 * Fires whenever the scene is updated (but not necessarily changes the progress).
		 *
		 * @event ScrollMagic.Scene#update
		 *
		 * @example
		 * scene.on("update", function (event) {
		 * 	console.log("Scene updated.");
		 * });
		 *
		 * @property {object} event - The event Object passed to each callback
		 * @property {string} event.type - The name of the event
		 * @property {Scene} event.target - The Scene object that triggered this event
		 * @property {number} event.startPos - The starting position of the scene (in relation to the conainer)
		 * @property {number} event.endPos - The ending position of the scene (in relation to the conainer)
		 * @property {number} event.scrollPos - The current scroll position of the container
		 */ /**
		 * Scene progress event.  
		 * Fires whenever the progress of the scene changes.
		 *
		 * For details on this event and the order in which it is fired, please review the {@link Scene.progress} method.
		 *
		 * @event ScrollMagic.Scene#progress
		 *
		 * @example
		 * scene.on("progress", function (event) {
		 * 	console.log("Scene progress changed to " + event.progress);
		 * });
		 *
		 * @property {object} event - The event Object passed to each callback
		 * @property {string} event.type - The name of the event
		 * @property {Scene} event.target - The Scene object that triggered this event
		 * @property {number} event.progress - Reflects the current progress of the scene
		 * @property {string} event.state - The current state of the scene `"BEFORE"`, `"DURING"` or `"AFTER"`
		 * @property {string} event.scrollDirection - Indicates which way we are scrolling `"PAUSED"`, `"FORWARD"` or `"REVERSE"`
		 */ /**
		 * Scene change event.  
		 * Fires whenvever a property of the scene is changed.
		 *
		 * @event ScrollMagic.Scene#change
		 *
		 * @example
		 * scene.on("change", function (event) {
		 * 	console.log("Scene Property \"" + event.what + "\" changed to " + event.newval);
		 * });
		 *
		 * @property {object} event - The event Object passed to each callback
		 * @property {string} event.type - The name of the event
		 * @property {Scene} event.target - The Scene object that triggered this event
		 * @property {string} event.what - Indicates what value has been changed
		 * @property {mixed} event.newval - The new value of the changed property
		 */ /**
		 * Scene shift event.  
		 * Fires whenvever the start or end **scroll offset** of the scene change.
		 * This happens explicitely, when one of these values change: `offset`, `duration` or `triggerHook`.
		 * It will fire implicitly when the `triggerElement` changes, if the new element has a different position (most cases).
		 * It will also fire implicitly when the size of the container changes and the triggerHook is anything other than `onLeave`.
		 *
		 * @event ScrollMagic.Scene#shift
		 * @since 1.1.0
		 *
		 * @example
		 * scene.on("shift", function (event) {
		 * 	console.log("Scene moved, because the " + event.reason + " has changed.)");
		 * });
		 *
		 * @property {object} event - The event Object passed to each callback
		 * @property {string} event.type - The name of the event
		 * @property {Scene} event.target - The Scene object that triggered this event
		 * @property {string} event.reason - Indicates why the scene has shifted
		 */ /**
		 * Scene destroy event.  
		 * Fires whenvever the scene is destroyed.
		 * This can be used to tidy up custom behaviour used in events.
		 *
		 * @event ScrollMagic.Scene#destroy
		 * @since 1.1.0
		 *
		 * @example
		 * scene.on("enter", function (event) {
		 *        // add custom action
		 *        $("#my-elem").left("200");
		 *      })
		 *      .on("destroy", function (event) {
		 *        // reset my element to start position
		 *        if (event.reset) {
		 *          $("#my-elem").left("0");
		 *        }
		 *      });
		 *
		 * @property {object} event - The event Object passed to each callback
		 * @property {string} event.type - The name of the event
		 * @property {Scene} event.target - The Scene object that triggered this event
		 * @property {boolean} event.reset - Indicates if the destroy method was called with reset `true` or `false`.
		 */ /**
		 * Scene add event.  
		 * Fires when the scene is added to a controller.
		 * This is mostly used by plugins to know that change might be due.
		 *
		 * @event ScrollMagic.Scene#add
		 * @since 2.0.0
		 *
		 * @example
		 * scene.on("add", function (event) {
		 * 	console.log('Scene was added to a new controller.');
		 * });
		 *
		 * @property {object} event - The event Object passed to each callback
		 * @property {string} event.type - The name of the event
		 * @property {Scene} event.target - The Scene object that triggered this event
		 * @property {boolean} event.controller - The controller object the scene was added to.
		 */ /**
		 * Scene remove event.  
		 * Fires when the scene is removed from a controller.
		 * This is mostly used by plugins to know that change might be due.
		 *
		 * @event ScrollMagic.Scene#remove
		 * @since 2.0.0
		 *
		 * @example
		 * scene.on("remove", function (event) {
		 * 	console.log('Scene was removed from its controller.');
		 * });
		 *
		 * @property {object} event - The event Object passed to each callback
		 * @property {string} event.type - The name of the event
		 * @property {Scene} event.target - The Scene object that triggered this event
		 */ /**
		 * Add one ore more event listener.  
		 * The callback function will be fired at the respective event, and an object containing relevant data will be passed to the callback.
		 * @method ScrollMagic.Scene#on
		 *
		 * @example
		 * function callback (event) {
		 * 		console.log("Event fired! (" + event.type + ")");
		 * }
		 * // add listeners
		 * scene.on("change update progress start end enter leave", callback);
		 *
		 * @param {string} names - The name or names of the event the callback should be attached to.
		 * @param {function} callback - A function that should be executed, when the event is dispatched. An event object will be passed to the callback.
		 * @returns {Scene} Parent object for chaining.
		 */ this.on = function(names, callback) {
            if (_util.type.Function(callback)) {
                names = names.trim().split(" ");
                names.forEach(function(fullname) {
                    var nameparts = fullname.split("."), eventname = nameparts[0], namespace = nameparts[1];
                    if (eventname != "*") {
                        if (!_listeners[eventname]) _listeners[eventname] = [];
                        _listeners[eventname].push({
                            namespace: namespace || "",
                            callback: callback
                        });
                    }
                });
            } else log(1, "ERROR when calling '.on()': Supplied callback for '" + names + "' is not a valid function!");
            return Scene;
        };
        /**
		 * Remove one or more event listener.
		 * @method ScrollMagic.Scene#off
		 *
		 * @example
		 * function callback (event) {
		 * 		console.log("Event fired! (" + event.type + ")");
		 * }
		 * // add listeners
		 * scene.on("change update", callback);
		 * // remove listeners
		 * scene.off("change update", callback);
		 *
		 * @param {string} names - The name or names of the event that should be removed.
		 * @param {function} [callback] - A specific callback function that should be removed. If none is passed all callbacks to the event listener will be removed.
		 * @returns {Scene} Parent object for chaining.
		 */ this.off = function(names, callback) {
            if (!names) {
                log(1, "ERROR: Invalid event name supplied.");
                return Scene;
            }
            names = names.trim().split(" ");
            names.forEach(function(fullname, key) {
                var nameparts = fullname.split("."), eventname = nameparts[0], namespace = nameparts[1] || "", removeList = eventname === "*" ? Object.keys(_listeners) : [
                    eventname
                ];
                removeList.forEach(function(remove) {
                    var list = _listeners[remove] || [], i = list.length;
                    while(i--){
                        var listener = list[i];
                        if (listener && (namespace === listener.namespace || namespace === "*") && (!callback || callback == listener.callback)) list.splice(i, 1);
                    }
                    if (!list.length) delete _listeners[remove];
                });
            });
            return Scene;
        };
        /**
		 * Trigger an event.
		 * @method ScrollMagic.Scene#trigger
		 *
		 * @example
		 * this.trigger("change");
		 *
		 * @param {string} name - The name of the event that should be triggered.
		 * @param {object} [vars] - An object containing info that should be passed to the callback.
		 * @returns {Scene} Parent object for chaining.
		 */ this.trigger = function(name, vars) {
            if (name) {
                var nameparts = name.trim().split("."), eventname = nameparts[0], namespace = nameparts[1], listeners = _listeners[eventname];
                log(3, "event fired:", eventname, vars ? "->" : "", vars || "");
                if (listeners) listeners.forEach(function(listener, key) {
                    if (!namespace || namespace === listener.namespace) listener.callback.call(Scene, new ScrollMagic.Event(eventname, listener.namespace, Scene, vars));
                });
            } else log(1, "ERROR: Invalid event name supplied.");
            return Scene;
        };
        // set event listeners
        Scene.on("change.internal", function(e) {
            if (e.what !== "loglevel" && e.what !== "tweenChanges") {
                if (e.what === "triggerElement") updateTriggerElementPosition();
                else if (e.what === "reverse") Scene.update();
            }
        }).on("shift.internal", function(e) {
            updateScrollOffset();
            Scene.update(); // update scene to reflect new position
        });
        /**
		 * Send a debug message to the console.
		 * @private
		 * but provided publicly with _log for plugins
		 *
		 * @param {number} loglevel - The loglevel required to initiate output for the message.
		 * @param {...mixed} output - One or more variables that should be passed to the console.
		 */ var log = this._log = function(loglevel, output) {
            if (_options.loglevel >= loglevel) {
                Array.prototype.splice.call(arguments, 1, 0, "(" + NAMESPACE + ") ->");
                _util.log.apply(window, arguments);
            }
        };
        /**
		 * Add the scene to a controller.  
		 * This is the equivalent to `Controller.addScene(scene)`.
		 * @method ScrollMagic.Scene#addTo
		 *
		 * @example
		 * // add a scene to a ScrollMagic Controller
		 * scene.addTo(controller);
		 *
		 * @param {ScrollMagic.Controller} controller - The controller to which the scene should be added.
		 * @returns {Scene} Parent object for chaining.
		 */ this.addTo = function(controller) {
            if (!(controller instanceof ScrollMagic.Controller)) log(1, "ERROR: supplied argument of 'addTo()' is not a valid ScrollMagic Controller");
            else if (_controller != controller) {
                // new controller
                if (_controller) _controller.removeScene(Scene);
                _controller = controller;
                validateOption();
                updateDuration(true);
                updateTriggerElementPosition(true);
                updateScrollOffset();
                _controller.info("container").addEventListener("resize", onContainerResize);
                controller.addScene(Scene);
                Scene.trigger("add", {
                    controller: _controller
                });
                log(3, "added " + NAMESPACE + " to controller");
                Scene.update();
            }
            return Scene;
        };
        /**
		 * **Get** or **Set** the current enabled state of the scene.  
		 * This can be used to disable this scene without removing or destroying it.
		 * @method ScrollMagic.Scene#enabled
		 *
		 * @example
		 * // get the current value
		 * var enabled = scene.enabled();
		 *
		 * // disable the scene
		 * scene.enabled(false);
		 *
		 * @param {boolean} [newState] - The new enabled state of the scene `true` or `false`.
		 * @returns {(boolean|Scene)} Current enabled state or parent object for chaining.
		 */ this.enabled = function(newState) {
            if (!arguments.length) return _enabled;
            else if (_enabled != newState) {
                _enabled = !!newState;
                Scene.update(true);
            }
            return Scene;
        };
        /**
		 * Remove the scene from the controller.  
		 * This is the equivalent to `Controller.removeScene(scene)`.
		 * The scene will not be updated anymore until you readd it to a controller.
		 * To remove the pin or the tween you need to call removeTween() or removePin() respectively.
		 * @method ScrollMagic.Scene#remove
		 * @example
		 * // remove the scene from its controller
		 * scene.remove();
		 *
		 * @returns {Scene} Parent object for chaining.
		 */ this.remove = function() {
            if (_controller) {
                _controller.info("container").removeEventListener("resize", onContainerResize);
                var tmpParent = _controller;
                _controller = undefined;
                tmpParent.removeScene(Scene);
                Scene.trigger("remove");
                log(3, "removed " + NAMESPACE + " from controller");
            }
            return Scene;
        };
        /**
		 * Destroy the scene and everything.
		 * @method ScrollMagic.Scene#destroy
		 * @example
		 * // destroy the scene without resetting the pin and tween to their initial positions
		 * scene = scene.destroy();
		 *
		 * // destroy the scene and reset the pin and tween
		 * scene = scene.destroy(true);
		 *
		 * @param {boolean} [reset=false] - If `true` the pin and tween (if existent) will be reset.
		 * @returns {null} Null to unset handler variables.
		 */ this.destroy = function(reset) {
            Scene.trigger("destroy", {
                reset: reset
            });
            Scene.remove();
            Scene.off("*.*");
            log(3, "destroyed " + NAMESPACE + " (reset: " + (reset ? "true" : "false") + ")");
            return null;
        };
        /**
		 * Updates the Scene to reflect the current state.  
		 * This is the equivalent to `Controller.updateScene(scene, immediately)`.  
		 * The update method calculates the scene's start and end position (based on the trigger element, trigger hook, duration and offset) and checks it against the current scroll position of the container.  
		 * It then updates the current scene state accordingly (or does nothing, if the state is already correct) – Pins will be set to their correct position and tweens will be updated to their correct progress.
		 * This means an update doesn't necessarily result in a progress change. The `progress` event will be fired if the progress has indeed changed between this update and the last.  
		 * _**NOTE:** This method gets called constantly whenever ScrollMagic detects a change. The only application for you is if you change something outside of the realm of ScrollMagic, like moving the trigger or changing tween parameters._
		 * @method ScrollMagic.Scene#update
		 * @example
		 * // update the scene on next tick
		 * scene.update();
		 *
		 * // update the scene immediately
		 * scene.update(true);
		 *
		 * @fires Scene.update
		 *
		 * @param {boolean} [immediately=false] - If `true` the update will be instant, if `false` it will wait until next update cycle (better performance).
		 * @returns {Scene} Parent object for chaining.
		 */ this.update = function(immediately) {
            if (_controller) {
                if (immediately) {
                    if (_controller.enabled() && _enabled) {
                        var scrollPos = _controller.info("scrollPos"), newProgress;
                        if (_options.duration > 0) newProgress = (scrollPos - _scrollOffset.start) / (_scrollOffset.end - _scrollOffset.start);
                        else newProgress = scrollPos >= _scrollOffset.start ? 1 : 0;
                        Scene.trigger("update", {
                            startPos: _scrollOffset.start,
                            endPos: _scrollOffset.end,
                            scrollPos: scrollPos
                        });
                        Scene.progress(newProgress);
                    } else if (_pin && _state === SCENE_STATE_DURING) updatePinState(true); // unpin in position
                } else _controller.updateScene(Scene, false);
            }
            return Scene;
        };
        /**
		 * Updates dynamic scene variables like the trigger element position or the duration.
		 * This method is automatically called in regular intervals from the controller. See {@link ScrollMagic.Controller} option `refreshInterval`.
		 * 
		 * You can call it to minimize lag, for example when you intentionally change the position of the triggerElement.
		 * If you don't it will simply be updated in the next refresh interval of the container, which is usually sufficient.
		 *
		 * @method ScrollMagic.Scene#refresh
		 * @since 1.1.0
		 * @example
		 * scene = new ScrollMagic.Scene({triggerElement: "#trigger"});
		 * 
		 * // change the position of the trigger
		 * $("#trigger").css("top", 500);
		 * // immediately let the scene know of this change
		 * scene.refresh();
		 *
		 * @fires {@link Scene.shift}, if the trigger element position or the duration changed
		 * @fires {@link Scene.change}, if the duration changed
		 *
		 * @returns {Scene} Parent object for chaining.
		 */ this.refresh = function() {
            updateDuration();
            updateTriggerElementPosition();
            // update trigger element position
            return Scene;
        };
        /**
		 * **Get** or **Set** the scene's progress.  
		 * Usually it shouldn't be necessary to use this as a setter, as it is set automatically by scene.update().  
		 * The order in which the events are fired depends on the duration of the scene:
		 *  1. Scenes with `duration == 0`:  
		 *  Scenes that have no duration by definition have no ending. Thus the `end` event will never be fired.  
		 *  When the trigger position of the scene is passed the events are always fired in this order:  
		 *  `enter`, `start`, `progress` when scrolling forward  
		 *  and  
		 *  `progress`, `start`, `leave` when scrolling in reverse
		 *  2. Scenes with `duration > 0`:  
		 *  Scenes with a set duration have a defined start and end point.  
		 *  When scrolling past the start position of the scene it will fire these events in this order:  
		 *  `enter`, `start`, `progress`  
		 *  When continuing to scroll and passing the end point it will fire these events:  
		 *  `progress`, `end`, `leave`  
		 *  When reversing through the end point these events are fired:  
		 *  `enter`, `end`, `progress`  
		 *  And when continuing to scroll past the start position in reverse it will fire:  
		 *  `progress`, `start`, `leave`  
		 *  In between start and end the `progress` event will be called constantly, whenever the progress changes.
		 * 
		 * In short:  
		 * `enter` events will always trigger **before** the progress update and `leave` envents will trigger **after** the progress update.  
		 * `start` and `end` will always trigger at their respective position.
		 * 
		 * Please review the event descriptions for details on the events and the event object that is passed to the callback.
		 * 
		 * @method ScrollMagic.Scene#progress
		 * @example
		 * // get the current scene progress
		 * var progress = scene.progress();
		 *
		 * // set new scene progress
		 * scene.progress(0.3);
		 *
		 * @fires {@link Scene.enter}, when used as setter
		 * @fires {@link Scene.start}, when used as setter
		 * @fires {@link Scene.progress}, when used as setter
		 * @fires {@link Scene.end}, when used as setter
		 * @fires {@link Scene.leave}, when used as setter
		 *
		 * @param {number} [progress] - The new progress value of the scene `[0-1]`.
		 * @returns {number} `get` -  Current scene progress.
		 * @returns {Scene} `set` -  Parent object for chaining.
		 */ this.progress = function(progress) {
            if (!arguments.length) return _progress;
            else {
                var doUpdate = false, oldState = _state, scrollDirection = _controller ? _controller.info("scrollDirection") : "PAUSED", reverseOrForward = _options.reverse || progress >= _progress;
                if (_options.duration === 0) {
                    // zero duration scenes
                    doUpdate = _progress != progress;
                    _progress = progress < 1 && reverseOrForward ? 0 : 1;
                    _state = _progress === 0 ? SCENE_STATE_BEFORE : SCENE_STATE_DURING;
                } else {
                    // scenes with start and end
                    if (progress < 0 && _state !== SCENE_STATE_BEFORE && reverseOrForward) {
                        // go back to initial state
                        _progress = 0;
                        _state = SCENE_STATE_BEFORE;
                        doUpdate = true;
                    } else if (progress >= 0 && progress < 1 && reverseOrForward) {
                        _progress = progress;
                        _state = SCENE_STATE_DURING;
                        doUpdate = true;
                    } else if (progress >= 1 && _state !== SCENE_STATE_AFTER) {
                        _progress = 1;
                        _state = SCENE_STATE_AFTER;
                        doUpdate = true;
                    } else if (_state === SCENE_STATE_DURING && !reverseOrForward) updatePinState(); // in case we scrolled backwards mid-scene and reverse is disabled => update the pin position, so it doesn't move back as well.
                }
                if (doUpdate) {
                    // fire events
                    var eventVars = {
                        progress: _progress,
                        state: _state,
                        scrollDirection: scrollDirection
                    }, stateChanged = _state != oldState;
                    var trigger = function(eventName) {
                        Scene.trigger(eventName, eventVars);
                    };
                    if (stateChanged) {
                        if (oldState !== SCENE_STATE_DURING) {
                            trigger("enter");
                            trigger(oldState === SCENE_STATE_BEFORE ? "start" : "end");
                        }
                    }
                    trigger("progress");
                    if (stateChanged) {
                        if (_state !== SCENE_STATE_DURING) {
                            trigger(_state === SCENE_STATE_BEFORE ? "start" : "end");
                            trigger("leave");
                        }
                    }
                }
                return Scene;
            }
        };
        /**
		 * Update the start and end scrollOffset of the container.
		 * The positions reflect what the controller's scroll position will be at the start and end respectively.
		 * Is called, when:
		 *   - Scene event "change" is called with: offset, triggerHook, duration 
		 *   - scroll container event "resize" is called
		 *   - the position of the triggerElement changes
		 *   - the controller changes -> addTo()
		 * @private
		 */ var updateScrollOffset = function() {
            _scrollOffset = {
                start: _triggerPos + _options.offset
            };
            if (_controller && _options.triggerElement) // take away triggerHook portion to get relative to top
            _scrollOffset.start -= _controller.info("size") * _options.triggerHook;
            _scrollOffset.end = _scrollOffset.start + _options.duration;
        };
        /**
		 * Updates the duration if set to a dynamic function.
		 * This method is called when the scene is added to a controller and in regular intervals from the controller through scene.refresh().
		 * 
		 * @fires {@link Scene.change}, if the duration changed
		 * @fires {@link Scene.shift}, if the duration changed
		 *
		 * @param {boolean} [suppressEvents=false] - If true the shift event will be suppressed.
		 * @private
		 */ var updateDuration = function(suppressEvents) {
            // update duration
            if (_durationUpdateMethod) {
                var varname = "duration";
                if (changeOption(varname, _durationUpdateMethod.call(Scene)) && !suppressEvents) {
                    Scene.trigger("change", {
                        what: varname,
                        newval: _options[varname]
                    });
                    Scene.trigger("shift", {
                        reason: varname
                    });
                }
            }
        };
        /**
		 * Updates the position of the triggerElement, if present.
		 * This method is called ...
		 *  - ... when the triggerElement is changed
		 *  - ... when the scene is added to a (new) controller
		 *  - ... in regular intervals from the controller through scene.refresh().
		 * 
		 * @fires {@link Scene.shift}, if the position changed
		 *
		 * @param {boolean} [suppressEvents=false] - If true the shift event will be suppressed.
		 * @private
		 */ var updateTriggerElementPosition = function(suppressEvents) {
            var elementPos = 0, telem = _options.triggerElement;
            if (_controller && (telem || _triggerPos > 0)) {
                if (telem) {
                    if (telem.parentNode) {
                        var controllerInfo = _controller.info(), containerOffset = _util.get.offset(controllerInfo.container), param = controllerInfo.vertical ? "top" : "left"; // which param is of interest ?
                        // if parent is spacer, use spacer position instead so correct start position is returned for pinned elements.
                        while(telem.parentNode.hasAttribute(PIN_SPACER_ATTRIBUTE))telem = telem.parentNode;
                        var elementOffset = _util.get.offset(telem);
                        if (!controllerInfo.isDocument) containerOffset[param] -= _controller.scrollPos();
                        elementPos = elementOffset[param] - containerOffset[param];
                    } else {
                        log(2, "WARNING: triggerElement was removed from DOM and will be reset to", undefined);
                        Scene.triggerElement(undefined); // unset, so a change event is triggered
                    }
                }
                var changed = elementPos != _triggerPos;
                _triggerPos = elementPos;
                if (changed && !suppressEvents) Scene.trigger("shift", {
                    reason: "triggerElementPosition"
                });
            }
        };
        /**
		 * Trigger a shift event, when the container is resized and the triggerHook is > 1.
		 * @private
		 */ var onContainerResize = function(e) {
            if (_options.triggerHook > 0) Scene.trigger("shift", {
                reason: "containerResize"
            });
        };
        var _validate = _util.extend(SCENE_OPTIONS.validate, {
            // validation for duration handled internally for reference to private var _durationMethod
            duration: function(val) {
                if (_util.type.String(val) && val.match(/^(\.|\d)*\d+%$/)) {
                    // percentage value
                    var perc = parseFloat(val) / 100;
                    val = function() {
                        return _controller ? _controller.info("size") * perc : 0;
                    };
                }
                if (_util.type.Function(val)) {
                    // function
                    _durationUpdateMethod = val;
                    try {
                        val = parseFloat(_durationUpdateMethod.call(Scene));
                    } catch (e) {
                        val = -1; // will cause error below
                    }
                }
                // val has to be float
                val = parseFloat(val);
                if (!_util.type.Number(val) || val < 0) {
                    if (_durationUpdateMethod) {
                        _durationUpdateMethod = undefined;
                        throw [
                            'Invalid return value of supplied function for option "duration":',
                            val
                        ];
                    } else throw [
                        'Invalid value for option "duration":',
                        val
                    ];
                }
                return val;
            }
        });
        /**
		 * Checks the validity of a specific or all options and reset to default if neccessary.
		 * @private
		 */ var validateOption = function(check) {
            check = arguments.length ? [
                check
            ] : Object.keys(_validate);
            check.forEach(function(optionName, key) {
                var value;
                if (_validate[optionName]) try {
                    value = _validate[optionName](_options[optionName]);
                } catch (e) {
                    value = DEFAULT_OPTIONS[optionName];
                    var logMSG = _util.type.String(e) ? [
                        e
                    ] : e;
                    if (_util.type.Array(logMSG)) {
                        logMSG[0] = "ERROR: " + logMSG[0];
                        logMSG.unshift(1); // loglevel 1 for error msg
                        log.apply(this, logMSG);
                    } else log(1, "ERROR: Problem executing validation callback for option '" + optionName + "':", e.message);
                } finally{
                    _options[optionName] = value;
                }
            });
        };
        /**
		 * Helper used by the setter/getters for scene options
		 * @private
		 */ var changeOption = function(varname, newval) {
            var changed = false, oldval = _options[varname];
            if (_options[varname] != newval) {
                _options[varname] = newval;
                validateOption(varname); // resets to default if necessary
                changed = oldval != _options[varname];
            }
            return changed;
        };
        // generate getters/setters for all options
        var addSceneOption = function(optionName) {
            if (!Scene[optionName]) Scene[optionName] = function(newVal) {
                if (!arguments.length) return _options[optionName];
                else {
                    if (optionName === "duration") _durationUpdateMethod = undefined;
                    if (changeOption(optionName, newVal)) {
                        Scene.trigger("change", {
                            what: optionName,
                            newval: _options[optionName]
                        });
                        if (SCENE_OPTIONS.shifts.indexOf(optionName) > -1) Scene.trigger("shift", {
                            reason: optionName
                        });
                    }
                }
                return Scene;
            };
        };
        /**
		 * **Get** or **Set** the duration option value.
		 *
		 * As a **setter** it accepts three types of parameters:
		 * 1. `number`: Sets the duration of the scene to exactly this amount of pixels.  
		 *   This means the scene will last for exactly this amount of pixels scrolled. Sub-Pixels are also valid.
		 *   A value of `0` means that the scene is 'open end' and no end will be triggered. Pins will never unpin and animations will play independently of scroll progress.
		 * 2. `string`: Always updates the duration relative to parent scroll container.  
		 *   For example `"100%"` will keep the duration always exactly at the inner height of the scroll container.
		 *   When scrolling vertically the width is used for reference respectively.
		 * 3. `function`: The supplied function will be called to return the scene duration.
		 *   This is useful in setups where the duration depends on other elements who might change size. By supplying a function you can return a value instead of updating potentially multiple scene durations.  
		 *   The scene can be referenced inside the callback using `this`.
		 *   _**WARNING:** This is an easy way to kill performance, as the callback will be executed every time `Scene.refresh()` is called, which happens a lot. The interval is defined by the controller (see ScrollMagic.Controller option `refreshInterval`).  
		 *   It's recomended to avoid calculations within the function and use cached variables as return values.  
		 *   This counts double if you use the same function for multiple scenes._
		 *
		 * @method ScrollMagic.Scene#duration
		 * @example
		 * // get the current duration value
		 * var duration = scene.duration();
		 *
		 * // set a new duration
		 * scene.duration(300);
		 *
		 * // set duration responsively to container size
		 * scene.duration("100%");
		 *
		 * // use a function to randomize the duration for some reason.
		 * var durationValueCache;
		 * function durationCallback () {
		 *   return durationValueCache;
		 * }
		 * function updateDuration () {
		 *   durationValueCache = Math.random() * 100;
		 * }
		 * updateDuration(); // set to initial value
		 * scene.duration(durationCallback); // set duration callback
		 *
		 * @fires {@link Scene.change}, when used as setter
		 * @fires {@link Scene.shift}, when used as setter
		 * @param {(number|string|function)} [newDuration] - The new duration setting for the scene.
		 * @returns {number} `get` -  Current scene duration.
		 * @returns {Scene} `set` -  Parent object for chaining.
		 */ /**
		 * **Get** or **Set** the offset option value.
		 * @method ScrollMagic.Scene#offset
		 * @example
		 * // get the current offset
		 * var offset = scene.offset();
		 *
		 * // set a new offset
		 * scene.offset(100);
		 *
		 * @fires {@link Scene.change}, when used as setter
		 * @fires {@link Scene.shift}, when used as setter
		 * @param {number} [newOffset] - The new offset of the scene.
		 * @returns {number} `get` -  Current scene offset.
		 * @returns {Scene} `set` -  Parent object for chaining.
		 */ /**
		 * **Get** or **Set** the triggerElement option value.
		 * Does **not** fire `Scene.shift`, because changing the trigger Element doesn't necessarily mean the start position changes. This will be determined in `Scene.refresh()`, which is automatically triggered.
		 * @method ScrollMagic.Scene#triggerElement
		 * @example
		 * // get the current triggerElement
		 * var triggerElement = scene.triggerElement();
		 *
		 * // set a new triggerElement using a selector
		 * scene.triggerElement("#trigger");
		 * // set a new triggerElement using a DOM object
		 * scene.triggerElement(document.getElementById("trigger"));
		 *
		 * @fires {@link Scene.change}, when used as setter
		 * @param {(string|object)} [newTriggerElement] - The new trigger element for the scene.
		 * @returns {(string|object)} `get` -  Current triggerElement.
		 * @returns {Scene} `set` -  Parent object for chaining.
		 */ /**
		 * **Get** or **Set** the triggerHook option value.
		 * @method ScrollMagic.Scene#triggerHook
		 * @example
		 * // get the current triggerHook value
		 * var triggerHook = scene.triggerHook();
		 *
		 * // set a new triggerHook using a string
		 * scene.triggerHook("onLeave");
		 * // set a new triggerHook using a number
		 * scene.triggerHook(0.7);
		 *
		 * @fires {@link Scene.change}, when used as setter
		 * @fires {@link Scene.shift}, when used as setter
		 * @param {(number|string)} [newTriggerHook] - The new triggerHook of the scene. See {@link Scene} parameter description for value options.
		 * @returns {number} `get` -  Current triggerHook (ALWAYS numerical).
		 * @returns {Scene} `set` -  Parent object for chaining.
		 */ /**
		 * **Get** or **Set** the reverse option value.
		 * @method ScrollMagic.Scene#reverse
		 * @example
		 * // get the current reverse option
		 * var reverse = scene.reverse();
		 *
		 * // set new reverse option
		 * scene.reverse(false);
		 *
		 * @fires {@link Scene.change}, when used as setter
		 * @param {boolean} [newReverse] - The new reverse setting of the scene.
		 * @returns {boolean} `get` -  Current reverse option value.
		 * @returns {Scene} `set` -  Parent object for chaining.
		 */ /**
		 * **Get** or **Set** the loglevel option value.
		 * @method ScrollMagic.Scene#loglevel
		 * @example
		 * // get the current loglevel
		 * var loglevel = scene.loglevel();
		 *
		 * // set new loglevel
		 * scene.loglevel(3);
		 *
		 * @fires {@link Scene.change}, when used as setter
		 * @param {number} [newLoglevel] - The new loglevel setting of the scene. `[0-3]`
		 * @returns {number} `get` -  Current loglevel.
		 * @returns {Scene} `set` -  Parent object for chaining.
		 */ /**
		 * **Get** the associated controller.
		 * @method ScrollMagic.Scene#controller
		 * @example
		 * // get the controller of a scene
		 * var controller = scene.controller();
		 *
		 * @returns {ScrollMagic.Controller} Parent controller or `undefined`
		 */ this.controller = function() {
            return _controller;
        };
        /**
		 * **Get** the current state.
		 * @method ScrollMagic.Scene#state
		 * @example
		 * // get the current state
		 * var state = scene.state();
		 *
		 * @returns {string} `"BEFORE"`, `"DURING"` or `"AFTER"`
		 */ this.state = function() {
            return _state;
        };
        /**
		 * **Get** the current scroll offset for the start of the scene.  
		 * Mind, that the scrollOffset is related to the size of the container, if `triggerHook` is bigger than `0` (or `"onLeave"`).  
		 * This means, that resizing the container or changing the `triggerHook` will influence the scene's start offset.
		 * @method ScrollMagic.Scene#scrollOffset
		 * @example
		 * // get the current scroll offset for the start and end of the scene.
		 * var start = scene.scrollOffset();
		 * var end = scene.scrollOffset() + scene.duration();
		 * console.log("the scene starts at", start, "and ends at", end);
		 *
		 * @returns {number} The scroll offset (of the container) at which the scene will trigger. Y value for vertical and X value for horizontal scrolls.
		 */ this.scrollOffset = function() {
            return _scrollOffset.start;
        };
        /**
		 * **Get** the trigger position of the scene (including the value of the `offset` option).  
		 * @method ScrollMagic.Scene#triggerPosition
		 * @example
		 * // get the scene's trigger position
		 * var triggerPosition = scene.triggerPosition();
		 *
		 * @returns {number} Start position of the scene. Top position value for vertical and left position value for horizontal scrolls.
		 */ this.triggerPosition = function() {
            var pos = _options.offset; // the offset is the basis
            if (_controller) {
                // get the trigger position
                if (_options.triggerElement) // Element as trigger
                pos += _triggerPos;
                else // return the height of the triggerHook to start at the beginning
                pos += _controller.info("size") * Scene.triggerHook();
            }
            return pos;
        };
        var _pin, _pinOptions;
        Scene.on("shift.internal", function(e) {
            var durationChanged = e.reason === "duration";
            if (_state === SCENE_STATE_AFTER && durationChanged || _state === SCENE_STATE_DURING && _options.duration === 0) // if [duration changed after a scene (inside scene progress updates pin position)] or [duration is 0, we are in pin phase and some other value changed].
            updatePinState();
            if (durationChanged) updatePinDimensions();
        }).on("progress.internal", function(e) {
            updatePinState();
        }).on("add.internal", function(e) {
            updatePinDimensions();
        }).on("destroy.internal", function(e) {
            Scene.removePin(e.reset);
        });
        /**
		 * Update the pin state.
		 * @private
		 */ var updatePinState = function(forceUnpin) {
            if (_pin && _controller) {
                var containerInfo = _controller.info(), pinTarget = _pinOptions.spacer.firstChild; // may be pin element or another spacer, if cascading pins
                if (!forceUnpin && _state === SCENE_STATE_DURING) {
                    // pinned state
                    if (_util.css(pinTarget, "position") != "fixed") {
                        // change state before updating pin spacer (position changes due to fixed collapsing might occur.)
                        _util.css(pinTarget, {
                            "position": "fixed"
                        });
                        // update pin spacer
                        updatePinDimensions();
                    }
                    var fixedPos = _util.get.offset(_pinOptions.spacer, true), scrollDistance = _options.reverse || _options.duration === 0 ? containerInfo.scrollPos - _scrollOffset.start // quicker
                     : Math.round(_progress * _options.duration * 10) / 10; // if no reverse and during pin the position needs to be recalculated using the progress
                    // add scrollDistance
                    fixedPos[containerInfo.vertical ? "top" : "left"] += scrollDistance;
                    // set new values
                    _util.css(_pinOptions.spacer.firstChild, {
                        top: fixedPos.top,
                        left: fixedPos.left
                    });
                } else {
                    // unpinned state
                    var newCSS = {
                        position: _pinOptions.inFlow ? "relative" : "absolute",
                        top: 0,
                        left: 0
                    }, change = _util.css(pinTarget, "position") != newCSS.position;
                    if (!_pinOptions.pushFollowers) newCSS[containerInfo.vertical ? "top" : "left"] = _options.duration * _progress;
                    else if (_options.duration > 0) {
                        if (_state === SCENE_STATE_AFTER && parseFloat(_util.css(_pinOptions.spacer, "padding-top")) === 0) change = true; // if in after state but havent updated spacer yet (jumped past pin)
                        else if (_state === SCENE_STATE_BEFORE && parseFloat(_util.css(_pinOptions.spacer, "padding-bottom")) === 0) change = true; // jumped past fixed state upward direction
                    }
                    // set new values
                    _util.css(pinTarget, newCSS);
                    if (change) // update pin spacer if state changed
                    updatePinDimensions();
                }
            }
        };
        /**
		 * Update the pin spacer and/or element size.
		 * The size of the spacer needs to be updated whenever the duration of the scene changes, if it is to push down following elements.
		 * @private
		 */ var updatePinDimensions = function() {
            if (_pin && _controller && _pinOptions.inFlow) {
                var after = _state === SCENE_STATE_AFTER, before = _state === SCENE_STATE_BEFORE, during = _state === SCENE_STATE_DURING, vertical = _controller.info("vertical"), pinTarget = _pinOptions.spacer.firstChild, marginCollapse = _util.isMarginCollapseType(_util.css(_pinOptions.spacer, "display")), css = {};
                // set new size
                // if relsize: spacer -> pin | else: pin -> spacer
                if (_pinOptions.relSize.width || _pinOptions.relSize.autoFullWidth) {
                    if (during) _util.css(_pin, {
                        "width": _util.get.width(_pinOptions.spacer)
                    });
                    else _util.css(_pin, {
                        "width": "100%"
                    });
                } else {
                    // minwidth is needed for cascaded pins.
                    css["min-width"] = _util.get.width(vertical ? _pin : pinTarget, true, true);
                    css.width = during ? css["min-width"] : "auto";
                }
                if (_pinOptions.relSize.height) {
                    if (during) // the only padding the spacer should ever include is the duration (if pushFollowers = true), so we need to substract that.
                    _util.css(_pin, {
                        "height": _util.get.height(_pinOptions.spacer) - (_pinOptions.pushFollowers ? _options.duration : 0)
                    });
                    else _util.css(_pin, {
                        "height": "100%"
                    });
                } else {
                    // margin is only included if it's a cascaded pin to resolve an IE9 bug
                    css["min-height"] = _util.get.height(vertical ? pinTarget : _pin, true, !marginCollapse); // needed for cascading pins
                    css.height = during ? css["min-height"] : "auto";
                }
                // add space for duration if pushFollowers is true
                if (_pinOptions.pushFollowers) {
                    css["padding" + (vertical ? "Top" : "Left")] = _options.duration * _progress;
                    css["padding" + (vertical ? "Bottom" : "Right")] = _options.duration * (1 - _progress);
                }
                _util.css(_pinOptions.spacer, css);
            }
        };
        /**
		 * Updates the Pin state (in certain scenarios)
		 * If the controller container is not the document and we are mid-pin-phase scrolling or resizing the main document can result to wrong pin positions.
		 * So this function is called on resize and scroll of the document.
		 * @private
		 */ var updatePinInContainer = function() {
            if (_controller && _pin && _state === SCENE_STATE_DURING && !_controller.info("isDocument")) updatePinState();
        };
        /**
		 * Updates the Pin spacer size state (in certain scenarios)
		 * If container is resized during pin and relatively sized the size of the pin might need to be updated...
		 * So this function is called on resize of the container.
		 * @private
		 */ var updateRelativePinSpacer = function() {
            if (_controller && _pin && // well, duh
            _state === SCENE_STATE_DURING && // element in pinned state?
            ((_pinOptions.relSize.width || _pinOptions.relSize.autoFullWidth) && _util.get.width(window) != _util.get.width(_pinOptions.spacer.parentNode) || _pinOptions.relSize.height && _util.get.height(window) != _util.get.height(_pinOptions.spacer.parentNode))) updatePinDimensions();
        };
        /**
		 * Is called, when the mousewhel is used while over a pinned element inside a div container.
		 * If the scene is in fixed state scroll events would be counted towards the body. This forwards the event to the scroll container.
		 * @private
		 */ var onMousewheelOverPin = function(e) {
            if (_controller && _pin && _state === SCENE_STATE_DURING && !_controller.info("isDocument")) {
                e.preventDefault();
                _controller._setScrollPos(_controller.info("scrollPos") - ((e.wheelDelta || e[_controller.info("vertical") ? "wheelDeltaY" : "wheelDeltaX"]) / 3 || -e.detail * 30));
            }
        };
        /**
		 * Pin an element for the duration of the scene.
		 * If the scene duration is 0 the element will only be unpinned, if the user scrolls back past the start position.  
		 * Make sure only one pin is applied to an element at the same time.
		 * An element can be pinned multiple times, but only successively.
		 * _**NOTE:** The option `pushFollowers` has no effect, when the scene duration is 0._
		 * @method ScrollMagic.Scene#setPin
		 * @example
		 * // pin element and push all following elements down by the amount of the pin duration.
		 * scene.setPin("#pin");
		 *
		 * // pin element and keeping all following elements in their place. The pinned element will move past them.
		 * scene.setPin("#pin", {pushFollowers: false});
		 *
		 * @param {(string|object)} element - A Selector targeting an element or a DOM object that is supposed to be pinned.
		 * @param {object} [settings] - settings for the pin
		 * @param {boolean} [settings.pushFollowers=true] - If `true` following elements will be "pushed" down for the duration of the pin, if `false` the pinned element will just scroll past them.  
		 												   Ignored, when duration is `0`.
		 * @param {string} [settings.spacerClass="scrollmagic-pin-spacer"] - Classname of the pin spacer element, which is used to replace the element.
		 *
		 * @returns {Scene} Parent object for chaining.
		 */ this.setPin = function(element, settings) {
            var defaultSettings = {
                pushFollowers: true,
                spacerClass: "scrollmagic-pin-spacer"
            };
            var pushFollowersActivelySet = settings && settings.hasOwnProperty("pushFollowers");
            settings = _util.extend({}, defaultSettings, settings);
            // validate Element
            element = _util.get.elements(element)[0];
            if (!element) {
                log(1, "ERROR calling method 'setPin()': Invalid pin element supplied.");
                return Scene; // cancel
            } else if (_util.css(element, "position") === "fixed") {
                log(1, "ERROR calling method 'setPin()': Pin does not work with elements that are positioned 'fixed'.");
                return Scene; // cancel
            }
            if (_pin) {
                if (_pin === element) // same pin we already have -> do nothing
                return Scene; // cancel
                else // kill old pin
                Scene.removePin();
            }
            _pin = element;
            var parentDisplay = _pin.parentNode.style.display, boundsParams = [
                "top",
                "left",
                "bottom",
                "right",
                "margin",
                "marginLeft",
                "marginRight",
                "marginTop",
                "marginBottom"
            ];
            _pin.parentNode.style.display = "none"; // hack start to force css to return stylesheet values instead of calculated px values.
            var inFlow = _util.css(_pin, "position") != "absolute", pinCSS = _util.css(_pin, boundsParams.concat([
                "display"
            ])), sizeCSS = _util.css(_pin, [
                "width",
                "height"
            ]);
            _pin.parentNode.style.display = parentDisplay; // hack end.
            if (!inFlow && settings.pushFollowers) {
                log(2, "WARNING: If the pinned element is positioned absolutely pushFollowers will be disabled.");
                settings.pushFollowers = false;
            }
            window.setTimeout(function() {
                if (_pin && _options.duration === 0 && pushFollowersActivelySet && settings.pushFollowers) log(2, "WARNING: pushFollowers =", true, "has no effect, when scene duration is 0.");
            }, 0);
            // create spacer and insert
            var spacer = _pin.parentNode.insertBefore(document.createElement("div"), _pin), spacerCSS = _util.extend(pinCSS, {
                position: inFlow ? "relative" : "absolute",
                boxSizing: "content-box",
                mozBoxSizing: "content-box",
                webkitBoxSizing: "content-box"
            });
            if (!inFlow) _util.extend(spacerCSS, _util.css(_pin, [
                "width",
                "height"
            ]));
            _util.css(spacer, spacerCSS);
            spacer.setAttribute(PIN_SPACER_ATTRIBUTE, "");
            _util.addClass(spacer, settings.spacerClass);
            // set the pin Options
            _pinOptions = {
                spacer: spacer,
                relSize: {
                    width: sizeCSS.width.slice(-1) === "%",
                    height: sizeCSS.height.slice(-1) === "%",
                    autoFullWidth: sizeCSS.width === "auto" && inFlow && _util.isMarginCollapseType(pinCSS.display)
                },
                pushFollowers: settings.pushFollowers,
                inFlow: inFlow
            };
            if (!_pin.___origStyle) {
                _pin.___origStyle = {};
                var pinInlineCSS = _pin.style, copyStyles = boundsParams.concat([
                    "width",
                    "height",
                    "position",
                    "boxSizing",
                    "mozBoxSizing",
                    "webkitBoxSizing"
                ]);
                copyStyles.forEach(function(val) {
                    _pin.___origStyle[val] = pinInlineCSS[val] || "";
                });
            }
            // if relative size, transfer it to spacer and make pin calculate it...
            if (_pinOptions.relSize.width) _util.css(spacer, {
                width: sizeCSS.width
            });
            if (_pinOptions.relSize.height) _util.css(spacer, {
                height: sizeCSS.height
            });
            // now place the pin element inside the spacer	
            spacer.appendChild(_pin);
            // and set new css
            _util.css(_pin, {
                position: inFlow ? "relative" : "absolute",
                margin: "auto",
                top: "auto",
                left: "auto",
                bottom: "auto",
                right: "auto"
            });
            if (_pinOptions.relSize.width || _pinOptions.relSize.autoFullWidth) _util.css(_pin, {
                boxSizing: "border-box",
                mozBoxSizing: "border-box",
                webkitBoxSizing: "border-box"
            });
            // add listener to document to update pin position in case controller is not the document.
            window.addEventListener("scroll", updatePinInContainer);
            window.addEventListener("resize", updatePinInContainer);
            window.addEventListener("resize", updateRelativePinSpacer);
            // add mousewheel listener to catch scrolls over fixed elements
            _pin.addEventListener("mousewheel", onMousewheelOverPin);
            _pin.addEventListener("DOMMouseScroll", onMousewheelOverPin);
            log(3, "added pin");
            // finally update the pin to init
            updatePinState();
            return Scene;
        };
        /**
		 * Remove the pin from the scene.
		 * @method ScrollMagic.Scene#removePin
		 * @example
		 * // remove the pin from the scene without resetting it (the spacer is not removed)
		 * scene.removePin();
		 *
		 * // remove the pin from the scene and reset the pin element to its initial position (spacer is removed)
		 * scene.removePin(true);
		 *
		 * @param {boolean} [reset=false] - If `false` the spacer will not be removed and the element's position will not be reset.
		 * @returns {Scene} Parent object for chaining.
		 */ this.removePin = function(reset) {
            if (_pin) {
                if (_state === SCENE_STATE_DURING) updatePinState(true); // force unpin at position
                if (reset || !_controller) {
                    var pinTarget = _pinOptions.spacer.firstChild; // usually the pin element, but may be another spacer (cascaded pins)...
                    if (pinTarget.hasAttribute(PIN_SPACER_ATTRIBUTE)) {
                        var style = _pinOptions.spacer.style, values = [
                            "margin",
                            "marginLeft",
                            "marginRight",
                            "marginTop",
                            "marginBottom"
                        ], margins = {};
                        values.forEach(function(val) {
                            margins[val] = style[val] || "";
                        });
                        _util.css(pinTarget, margins);
                    }
                    _pinOptions.spacer.parentNode.insertBefore(pinTarget, _pinOptions.spacer);
                    _pinOptions.spacer.parentNode.removeChild(_pinOptions.spacer);
                    if (!_pin.parentNode.hasAttribute(PIN_SPACER_ATTRIBUTE)) {
                        // TODO: only correctly set for first pin (when cascading) - how to fix?
                        _util.css(_pin, _pin.___origStyle);
                        delete _pin.___origStyle;
                    }
                }
                window.removeEventListener("scroll", updatePinInContainer);
                window.removeEventListener("resize", updatePinInContainer);
                window.removeEventListener("resize", updateRelativePinSpacer);
                _pin.removeEventListener("mousewheel", onMousewheelOverPin);
                _pin.removeEventListener("DOMMouseScroll", onMousewheelOverPin);
                _pin = undefined;
                log(3, "removed pin (reset: " + (reset ? "true" : "false") + ")");
            }
            return Scene;
        };
        var _cssClasses, _cssClassElems = [];
        Scene.on("destroy.internal", function(e) {
            Scene.removeClassToggle(e.reset);
        });
        /**
		 * Define a css class modification while the scene is active.  
		 * When the scene triggers the classes will be added to the supplied element and removed, when the scene is over.
		 * If the scene duration is 0 the classes will only be removed if the user scrolls back past the start position.
		 * @method ScrollMagic.Scene#setClassToggle
		 * @example
		 * // add the class 'myclass' to the element with the id 'my-elem' for the duration of the scene
		 * scene.setClassToggle("#my-elem", "myclass");
		 *
		 * // add multiple classes to multiple elements defined by the selector '.classChange'
		 * scene.setClassToggle(".classChange", "class1 class2 class3");
		 *
		 * @param {(string|object)} element - A Selector targeting one or more elements or a DOM object that is supposed to be modified.
		 * @param {string} classes - One or more Classnames (separated by space) that should be added to the element during the scene.
		 *
		 * @returns {Scene} Parent object for chaining.
		 */ this.setClassToggle = function(element, classes) {
            var elems = _util.get.elements(element);
            if (elems.length === 0 || !_util.type.String(classes)) {
                log(1, "ERROR calling method 'setClassToggle()': Invalid " + (elems.length === 0 ? "element" : "classes") + " supplied.");
                return Scene;
            }
            if (_cssClassElems.length > 0) // remove old ones
            Scene.removeClassToggle();
            _cssClasses = classes;
            _cssClassElems = elems;
            Scene.on("enter.internal_class leave.internal_class", function(e) {
                var toggle = e.type === "enter" ? _util.addClass : _util.removeClass;
                _cssClassElems.forEach(function(elem, key) {
                    toggle(elem, _cssClasses);
                });
            });
            return Scene;
        };
        /**
		 * Remove the class binding from the scene.
		 * @method ScrollMagic.Scene#removeClassToggle
		 * @example
		 * // remove class binding from the scene without reset
		 * scene.removeClassToggle();
		 *
		 * // remove class binding and remove the changes it caused
		 * scene.removeClassToggle(true);
		 *
		 * @param {boolean} [reset=false] - If `false` and the classes are currently active, they will remain on the element. If `true` they will be removed.
		 * @returns {Scene} Parent object for chaining.
		 */ this.removeClassToggle = function(reset) {
            if (reset) _cssClassElems.forEach(function(elem, key) {
                _util.removeClass(elem, _cssClasses);
            });
            Scene.off("start.internal_class end.internal_class");
            _cssClasses = undefined;
            _cssClassElems = [];
            return Scene;
        };
        // INIT
        construct();
        return Scene;
    };
    // store pagewide scene options
    var SCENE_OPTIONS = {
        defaults: {
            duration: 0,
            offset: 0,
            triggerElement: undefined,
            triggerHook: 0.5,
            reverse: true,
            loglevel: 2
        },
        validate: {
            offset: function(val) {
                val = parseFloat(val);
                if (!_util.type.Number(val)) throw [
                    'Invalid value for option "offset":',
                    val
                ];
                return val;
            },
            triggerElement: function(val) {
                val = val || undefined;
                if (val) {
                    var elem = _util.get.elements(val)[0];
                    if (elem && elem.parentNode) val = elem;
                    else throw [
                        'Element defined in option "triggerElement" was not found:',
                        val
                    ];
                }
                return val;
            },
            triggerHook: function(val) {
                var translate = {
                    "onCenter": 0.5,
                    "onEnter": 1,
                    "onLeave": 0
                };
                if (_util.type.Number(val)) val = Math.max(0, Math.min(parseFloat(val), 1)); //  make sure its betweeen 0 and 1
                else if (val in translate) val = translate[val];
                else throw [
                    'Invalid value for option "triggerHook": ',
                    val
                ];
                return val;
            },
            reverse: function(val) {
                return !!val; // force boolean
            },
            loglevel: function(val) {
                val = parseInt(val);
                if (!_util.type.Number(val) || val < 0 || val > 3) throw [
                    'Invalid value for option "loglevel":',
                    val
                ];
                return val;
            }
        },
        shifts: [
            "duration",
            "offset",
            "triggerHook"
        ]
    };
    /*
	 * method used to add an option to ScrollMagic Scenes.
	 * TODO: DOC (private for dev)
	 */ ScrollMagic.Scene.addOption = function(name, defaultValue, validationCallback, shifts) {
        if (!(name in SCENE_OPTIONS.defaults)) {
            SCENE_OPTIONS.defaults[name] = defaultValue;
            SCENE_OPTIONS.validate[name] = validationCallback;
            if (shifts) SCENE_OPTIONS.shifts.push(name);
        } else ScrollMagic._util.log(1, "[static] ScrollMagic.Scene -> Cannot add Scene option '" + name + "', because it already exists.");
    };
    // instance extension function for plugins
    // TODO: DOC (private for dev)
    ScrollMagic.Scene.extend = function(extension) {
        var oldClass = this;
        ScrollMagic.Scene = function() {
            oldClass.apply(this, arguments);
            this.$super = _util.extend({}, this); // copy parent state
            return extension.apply(this, arguments) || this;
        };
        _util.extend(ScrollMagic.Scene, oldClass); // copy properties
        ScrollMagic.Scene.prototype = oldClass.prototype; // copy prototype
        ScrollMagic.Scene.prototype.constructor = ScrollMagic.Scene; // restore constructor
    };
    /**
	 * TODO: DOCS (private for dev)
	 * @class
	 * @private
	 */ ScrollMagic.Event = function(type, namespace, target, vars) {
        vars = vars || {};
        for(var key in vars)this[key] = vars[key];
        this.type = type;
        this.target = this.currentTarget = target;
        this.namespace = namespace || "";
        this.timeStamp = this.timestamp = Date.now();
        return this;
    };
    /*
	 * TODO: DOCS (private for dev)
	 */ var _util = ScrollMagic._util = function(window1) {
        var U = {}, i;
        /**
		 * ------------------------------
		 * internal helpers
		 * ------------------------------
		 */ // parse float and fall back to 0.
        var floatval = function(number) {
            return parseFloat(number) || 0;
        };
        // get current style IE safe (otherwise IE would return calculated values for 'auto')
        var _getComputedStyle = function(elem) {
            return elem.currentStyle ? elem.currentStyle : window1.getComputedStyle(elem);
        };
        // get element dimension (width or height)
        var _dimension = function(which, elem, outer, includeMargin) {
            elem = elem === document ? window1 : elem;
            if (elem === window1) includeMargin = false;
            else if (!_type.DomElement(elem)) return 0;
            which = which.charAt(0).toUpperCase() + which.substr(1).toLowerCase();
            var dimension = (outer ? elem["offset" + which] || elem["outer" + which] : elem["client" + which] || elem["inner" + which]) || 0;
            if (outer && includeMargin) {
                var style = _getComputedStyle(elem);
                dimension += which === "Height" ? floatval(style.marginTop) + floatval(style.marginBottom) : floatval(style.marginLeft) + floatval(style.marginRight);
            }
            return dimension;
        };
        // converts 'margin-top' into 'marginTop'
        var _camelCase = function(str) {
            return str.replace(/^[^a-z]+([a-z])/g, "$1").replace(/-([a-z])/g, function(g) {
                return g[1].toUpperCase();
            });
        };
        /**
		 * ------------------------------
		 * external helpers
		 * ------------------------------
		 */ // extend obj – same as jQuery.extend({}, objA, objB)
        U.extend = function(obj) {
            obj = obj || {};
            for(i = 1; i < arguments.length; i++){
                if (!arguments[i]) continue;
                for(var key in arguments[i])if (arguments[i].hasOwnProperty(key)) obj[key] = arguments[i][key];
            }
            return obj;
        };
        // check if a css display type results in margin-collapse or not
        U.isMarginCollapseType = function(str) {
            return [
                "block",
                "flex",
                "list-item",
                "table",
                "-webkit-box"
            ].indexOf(str) > -1;
        };
        // implementation of requestAnimationFrame
        // based on https://gist.github.com/paulirish/1579671
        var lastTime = 0, vendors = [
            "ms",
            "moz",
            "webkit",
            "o"
        ];
        var _requestAnimationFrame = window1.requestAnimationFrame;
        var _cancelAnimationFrame = window1.cancelAnimationFrame;
        // try vendor prefixes if the above doesn't work
        for(i = 0; !_requestAnimationFrame && i < vendors.length; ++i){
            _requestAnimationFrame = window1[vendors[i] + "RequestAnimationFrame"];
            _cancelAnimationFrame = window1[vendors[i] + "CancelAnimationFrame"] || window1[vendors[i] + "CancelRequestAnimationFrame"];
        }
        // fallbacks
        if (!_requestAnimationFrame) _requestAnimationFrame = function(callback) {
            var currTime = new Date().getTime(), timeToCall = Math.max(0, 16 - (currTime - lastTime)), id = window1.setTimeout(function() {
                callback(currTime + timeToCall);
            }, timeToCall);
            lastTime = currTime + timeToCall;
            return id;
        };
        if (!_cancelAnimationFrame) _cancelAnimationFrame = function(id) {
            window1.clearTimeout(id);
        };
        U.rAF = _requestAnimationFrame.bind(window1);
        U.cAF = _cancelAnimationFrame.bind(window1);
        var loglevels = [
            "error",
            "warn",
            "log"
        ], console = window1.console || {};
        console.log = console.log || function() {}; // no console log, well - do nothing then...
        // make sure methods for all levels exist.
        for(i = 0; i < loglevels.length; i++){
            var method = loglevels[i];
            if (!console[method]) console[method] = console.log; // prefer .log over nothing
        }
        U.log = function(loglevel) {
            if (loglevel > loglevels.length || loglevel <= 0) loglevel = loglevels.length;
            var now = new Date(), time = ("0" + now.getHours()).slice(-2) + ":" + ("0" + now.getMinutes()).slice(-2) + ":" + ("0" + now.getSeconds()).slice(-2) + ":" + ("00" + now.getMilliseconds()).slice(-3), method = loglevels[loglevel - 1], args = Array.prototype.splice.call(arguments, 1), func = Function.prototype.bind.call(console[method], console);
            args.unshift(time);
            func.apply(console, args);
        };
        /**
		 * ------------------------------
		 * type testing
		 * ------------------------------
		 */ var _type = U.type = function(v) {
            return Object.prototype.toString.call(v).replace(/^\[object (.+)\]$/, "$1").toLowerCase();
        };
        _type.String = function(v) {
            return _type(v) === "string";
        };
        _type.Function = function(v) {
            return _type(v) === "function";
        };
        _type.Array = function(v) {
            return Array.isArray(v);
        };
        _type.Number = function(v) {
            return !_type.Array(v) && v - parseFloat(v) + 1 >= 0;
        };
        _type.DomElement = function(o) {
            return typeof HTMLElement === "object" || typeof HTMLElement === "function" ? o instanceof HTMLElement || o instanceof SVGElement : o && typeof o === "object" && o !== null && o.nodeType === 1 && typeof o.nodeName === "string";
        };
        /**
		 * ------------------------------
		 * DOM Element info
		 * ------------------------------
		 */ // always returns a list of matching DOM elements, from a selector, a DOM element or an list of elements or even an array of selectors
        var _get = U.get = {};
        _get.elements = function(selector) {
            var arr = [];
            if (_type.String(selector)) try {
                selector = document.querySelectorAll(selector);
            } catch (e) {
                return arr;
            }
            if (_type(selector) === "nodelist" || _type.Array(selector) || selector instanceof NodeList) for(var i = 0, ref = arr.length = selector.length; i < ref; i++){
                var elem = selector[i];
                arr[i] = _type.DomElement(elem) ? elem : _get.elements(elem); // if not an element, try to resolve recursively
            }
            else if (_type.DomElement(selector) || selector === document || selector === window1) arr = [
                selector
            ]; // only the element
            return arr;
        };
        // get scroll top value
        _get.scrollTop = function(elem) {
            return elem && typeof elem.scrollTop === "number" ? elem.scrollTop : window1.pageYOffset || 0;
        };
        // get scroll left value
        _get.scrollLeft = function(elem) {
            return elem && typeof elem.scrollLeft === "number" ? elem.scrollLeft : window1.pageXOffset || 0;
        };
        // get element height
        _get.width = function(elem, outer, includeMargin) {
            return _dimension("width", elem, outer, includeMargin);
        };
        // get element width
        _get.height = function(elem, outer, includeMargin) {
            return _dimension("height", elem, outer, includeMargin);
        };
        // get element position (optionally relative to viewport)
        _get.offset = function(elem, relativeToViewport) {
            var offset = {
                top: 0,
                left: 0
            };
            if (elem && elem.getBoundingClientRect) {
                var rect = elem.getBoundingClientRect();
                offset.top = rect.top;
                offset.left = rect.left;
                if (!relativeToViewport) {
                    offset.top += _get.scrollTop();
                    offset.left += _get.scrollLeft();
                }
            }
            return offset;
        };
        /**
		 * ------------------------------
		 * DOM Element manipulation
		 * ------------------------------
		 */ U.addClass = function(elem, classname) {
            if (classname) {
                if (elem.classList) elem.classList.add(classname);
                else elem.className += " " + classname;
            }
        };
        U.removeClass = function(elem, classname) {
            if (classname) {
                if (elem.classList) elem.classList.remove(classname);
                else elem.className = elem.className.replace(new RegExp("(^|\\b)" + classname.split(" ").join("|") + "(\\b|$)", "gi"), " ");
            }
        };
        // if options is string -> returns css value
        // if options is array -> returns object with css value pairs
        // if options is object -> set new css values
        U.css = function(elem, options) {
            if (_type.String(options)) return _getComputedStyle(elem)[_camelCase(options)];
            else if (_type.Array(options)) {
                var obj = {}, style = _getComputedStyle(elem);
                options.forEach(function(option, key) {
                    obj[option] = style[_camelCase(option)];
                });
                return obj;
            } else for(var option in options){
                var val = options[option];
                if (val == parseFloat(val)) val += "px";
                elem.style[_camelCase(option)] = val;
            }
        };
        return U;
    }(window || {});
    ScrollMagic.Scene.prototype.addIndicators = function() {
        ScrollMagic._util.log(1, "(ScrollMagic.Scene) -> ERROR calling addIndicators() due to missing Plugin 'debug.addIndicators'. Please make sure to include plugins/debug.addIndicators.js");
        return this;
    };
    ScrollMagic.Scene.prototype.removeIndicators = function() {
        ScrollMagic._util.log(1, "(ScrollMagic.Scene) -> ERROR calling removeIndicators() due to missing Plugin 'debug.addIndicators'. Please make sure to include plugins/debug.addIndicators.js");
        return this;
    };
    ScrollMagic.Scene.prototype.setTween = function() {
        ScrollMagic._util.log(1, "(ScrollMagic.Scene) -> ERROR calling setTween() due to missing Plugin 'animation.gsap'. Please make sure to include plugins/animation.gsap.js");
        return this;
    };
    ScrollMagic.Scene.prototype.removeTween = function() {
        ScrollMagic._util.log(1, "(ScrollMagic.Scene) -> ERROR calling removeTween() due to missing Plugin 'animation.gsap'. Please make sure to include plugins/animation.gsap.js");
        return this;
    };
    ScrollMagic.Scene.prototype.setVelocity = function() {
        ScrollMagic._util.log(1, "(ScrollMagic.Scene) -> ERROR calling setVelocity() due to missing Plugin 'animation.velocity'. Please make sure to include plugins/animation.velocity.js");
        return this;
    };
    ScrollMagic.Scene.prototype.removeVelocity = function() {
        ScrollMagic._util.log(1, "(ScrollMagic.Scene) -> ERROR calling removeVelocity() due to missing Plugin 'animation.velocity'. Please make sure to include plugins/animation.velocity.js");
        return this;
    };
    return ScrollMagic;
});

});

parcelRequire.register("igG5D", function(module, exports) {
/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */ 
var $41cgx = parcelRequire("41cgx");

exports = module.exports = (parcelRequire("1x1DX"));
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = "undefined" != typeof chrome && "undefined" != typeof chrome.storage ? chrome.storage.local : localstorage();
/**
 * Colors.
 */ exports.colors = [
    "lightseagreen",
    "forestgreen",
    "goldenrod",
    "dodgerblue",
    "darkorchid",
    "crimson"
];
/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */ function useColors() {
    // NB: In an Electron preload script, document will be defined but not fully
    // initialized. Since we know we're in Chrome, we'll just detect this case
    // explicitly
    if (typeof window !== "undefined" && window.process && window.process.type === "renderer") return true;
    // is webkit? http://stackoverflow.com/a/16459606/376773
    // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
    return typeof document !== "undefined" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // is firebug? http://stackoverflow.com/a/398120/376773
    typeof window !== "undefined" && window.console && (window.console.firebug || window.console.exception && window.console.table) || // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // double check webkit in userAgent just in case we are in a worker
    typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
}
/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */ exports.formatters.j = function(v) {
    try {
        return JSON.stringify(v);
    } catch (err) {
        return "[UnexpectedJSONParseError]: " + err.message;
    }
};
/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */ function formatArgs(args) {
    var useColors = this.useColors;
    args[0] = (useColors ? "%c" : "") + this.namespace + (useColors ? " %c" : " ") + args[0] + (useColors ? "%c " : " ") + "+" + exports.humanize(this.diff);
    if (!useColors) return;
    var c = "color: " + this.color;
    args.splice(1, 0, c, "color: inherit");
    // the final "%c" is somewhat tricky, because there could be other
    // arguments passed either before or after the %c, so we need to
    // figure out the correct index to insert the CSS into
    var index = 0;
    var lastC = 0;
    args[0].replace(/%[a-zA-Z%]/g, function(match) {
        if ("%%" === match) return;
        index++;
        if ("%c" === match) // we only are interested in the *last* %c
        // (the user may have provided their own)
        lastC = index;
    });
    args.splice(lastC, 0, c);
}
/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */ function log() {
    // this hackery is required for IE8/9, where
    // the `console.log` function doesn't have 'apply'
    return "object" === typeof console && console.log && Function.prototype.apply.call(console.log, console, arguments);
}
/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */ function save(namespaces) {
    try {
        if (null == namespaces) exports.storage.removeItem("debug");
        else exports.storage.debug = namespaces;
    } catch (e) {}
}
/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */ function load() {
    var r;
    try {
        r = exports.storage.debug;
    } catch (e) {}
    // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
    if (!r && typeof $41cgx !== "undefined" && "env" in $41cgx) r = undefined;
    return r;
}
/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */ exports.enable(load());
/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */ function localstorage() {
    try {
        return window.localStorage;
    } catch (e) {}
}

});
parcelRequire.register("41cgx", function(module, exports) {
// shim for using process in browser
var $2ed0c51f0a1c31d6$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $2ed0c51f0a1c31d6$var$cachedSetTimeout;
var $2ed0c51f0a1c31d6$var$cachedClearTimeout;
function $2ed0c51f0a1c31d6$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $2ed0c51f0a1c31d6$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $2ed0c51f0a1c31d6$var$cachedSetTimeout = setTimeout;
        else $2ed0c51f0a1c31d6$var$cachedSetTimeout = $2ed0c51f0a1c31d6$var$defaultSetTimout;
    } catch (e) {
        $2ed0c51f0a1c31d6$var$cachedSetTimeout = $2ed0c51f0a1c31d6$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $2ed0c51f0a1c31d6$var$cachedClearTimeout = clearTimeout;
        else $2ed0c51f0a1c31d6$var$cachedClearTimeout = $2ed0c51f0a1c31d6$var$defaultClearTimeout;
    } catch (e) {
        $2ed0c51f0a1c31d6$var$cachedClearTimeout = $2ed0c51f0a1c31d6$var$defaultClearTimeout;
    }
})();
function $2ed0c51f0a1c31d6$var$runTimeout(fun) {
    if ($2ed0c51f0a1c31d6$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($2ed0c51f0a1c31d6$var$cachedSetTimeout === $2ed0c51f0a1c31d6$var$defaultSetTimout || !$2ed0c51f0a1c31d6$var$cachedSetTimeout) && setTimeout) {
        $2ed0c51f0a1c31d6$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $2ed0c51f0a1c31d6$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $2ed0c51f0a1c31d6$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $2ed0c51f0a1c31d6$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $2ed0c51f0a1c31d6$var$runClearTimeout(marker) {
    if ($2ed0c51f0a1c31d6$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($2ed0c51f0a1c31d6$var$cachedClearTimeout === $2ed0c51f0a1c31d6$var$defaultClearTimeout || !$2ed0c51f0a1c31d6$var$cachedClearTimeout) && clearTimeout) {
        $2ed0c51f0a1c31d6$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $2ed0c51f0a1c31d6$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $2ed0c51f0a1c31d6$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $2ed0c51f0a1c31d6$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $2ed0c51f0a1c31d6$var$queue = [];
var $2ed0c51f0a1c31d6$var$draining = false;
var $2ed0c51f0a1c31d6$var$currentQueue;
var $2ed0c51f0a1c31d6$var$queueIndex = -1;
function $2ed0c51f0a1c31d6$var$cleanUpNextTick() {
    if (!$2ed0c51f0a1c31d6$var$draining || !$2ed0c51f0a1c31d6$var$currentQueue) return;
    $2ed0c51f0a1c31d6$var$draining = false;
    if ($2ed0c51f0a1c31d6$var$currentQueue.length) $2ed0c51f0a1c31d6$var$queue = $2ed0c51f0a1c31d6$var$currentQueue.concat($2ed0c51f0a1c31d6$var$queue);
    else $2ed0c51f0a1c31d6$var$queueIndex = -1;
    if ($2ed0c51f0a1c31d6$var$queue.length) $2ed0c51f0a1c31d6$var$drainQueue();
}
function $2ed0c51f0a1c31d6$var$drainQueue() {
    if ($2ed0c51f0a1c31d6$var$draining) return;
    var timeout = $2ed0c51f0a1c31d6$var$runTimeout($2ed0c51f0a1c31d6$var$cleanUpNextTick);
    $2ed0c51f0a1c31d6$var$draining = true;
    var len = $2ed0c51f0a1c31d6$var$queue.length;
    while(len){
        $2ed0c51f0a1c31d6$var$currentQueue = $2ed0c51f0a1c31d6$var$queue;
        $2ed0c51f0a1c31d6$var$queue = [];
        while(++$2ed0c51f0a1c31d6$var$queueIndex < len)if ($2ed0c51f0a1c31d6$var$currentQueue) $2ed0c51f0a1c31d6$var$currentQueue[$2ed0c51f0a1c31d6$var$queueIndex].run();
        $2ed0c51f0a1c31d6$var$queueIndex = -1;
        len = $2ed0c51f0a1c31d6$var$queue.length;
    }
    $2ed0c51f0a1c31d6$var$currentQueue = null;
    $2ed0c51f0a1c31d6$var$draining = false;
    $2ed0c51f0a1c31d6$var$runClearTimeout(timeout);
}
$2ed0c51f0a1c31d6$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $2ed0c51f0a1c31d6$var$queue.push(new $2ed0c51f0a1c31d6$var$Item(fun, args));
    if ($2ed0c51f0a1c31d6$var$queue.length === 1 && !$2ed0c51f0a1c31d6$var$draining) $2ed0c51f0a1c31d6$var$runTimeout($2ed0c51f0a1c31d6$var$drainQueue);
};
// v8 likes predictible objects
function $2ed0c51f0a1c31d6$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$2ed0c51f0a1c31d6$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$2ed0c51f0a1c31d6$var$process.title = "browser";
$2ed0c51f0a1c31d6$var$process.browser = true;
$2ed0c51f0a1c31d6$var$process.env = {};
$2ed0c51f0a1c31d6$var$process.argv = [];
$2ed0c51f0a1c31d6$var$process.version = ""; // empty string to avoid regexp issues
$2ed0c51f0a1c31d6$var$process.versions = {};
function $2ed0c51f0a1c31d6$var$noop() {}
$2ed0c51f0a1c31d6$var$process.on = $2ed0c51f0a1c31d6$var$noop;
$2ed0c51f0a1c31d6$var$process.addListener = $2ed0c51f0a1c31d6$var$noop;
$2ed0c51f0a1c31d6$var$process.once = $2ed0c51f0a1c31d6$var$noop;
$2ed0c51f0a1c31d6$var$process.off = $2ed0c51f0a1c31d6$var$noop;
$2ed0c51f0a1c31d6$var$process.removeListener = $2ed0c51f0a1c31d6$var$noop;
$2ed0c51f0a1c31d6$var$process.removeAllListeners = $2ed0c51f0a1c31d6$var$noop;
$2ed0c51f0a1c31d6$var$process.emit = $2ed0c51f0a1c31d6$var$noop;
$2ed0c51f0a1c31d6$var$process.prependListener = $2ed0c51f0a1c31d6$var$noop;
$2ed0c51f0a1c31d6$var$process.prependOnceListener = $2ed0c51f0a1c31d6$var$noop;
$2ed0c51f0a1c31d6$var$process.listeners = function(name) {
    return [];
};
$2ed0c51f0a1c31d6$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$2ed0c51f0a1c31d6$var$process.cwd = function() {
    return "/";
};
$2ed0c51f0a1c31d6$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$2ed0c51f0a1c31d6$var$process.umask = function() {
    return 0;
};

});

parcelRequire.register("1x1DX", function(module, exports) {
/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */ exports = module.exports = createDebug.debug = createDebug["default"] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;

exports.humanize = (parcelRequire("etJDr"));
/**
 * The currently active debug mode names, and names to skip.
 */ exports.names = [];
exports.skips = [];
/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */ exports.formatters = {};
/**
 * Previous log timestamp.
 */ var prevTime;
/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */ function selectColor(namespace) {
    var hash = 0, i;
    for(i in namespace){
        hash = (hash << 5) - hash + namespace.charCodeAt(i);
        hash |= 0; // Convert to 32bit integer
    }
    return exports.colors[Math.abs(hash) % exports.colors.length];
}
/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */ function createDebug(namespace) {
    function debug() {
        // disabled?
        if (!debug.enabled) return;
        var self = debug;
        // set `diff` timestamp
        var curr = +new Date();
        var ms = curr - (prevTime || curr);
        self.diff = ms;
        self.prev = prevTime;
        self.curr = curr;
        prevTime = curr;
        // turn the `arguments` into a proper Array
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        args[0] = exports.coerce(args[0]);
        if ("string" !== typeof args[0]) // anything else let's inspect with %O
        args.unshift("%O");
        // apply any `formatters` transformations
        var index = 0;
        args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
            // if we encounter an escaped % then don't increase the array index
            if (match === "%%") return match;
            index++;
            var formatter = exports.formatters[format];
            if ("function" === typeof formatter) {
                var val = args[index];
                match = formatter.call(self, val);
                // now we need to remove `args[index]` since it's inlined in the `format`
                args.splice(index, 1);
                index--;
            }
            return match;
        });
        // apply env-specific formatting (colors, etc.)
        exports.formatArgs.call(self, args);
        var logFn = debug.log || exports.log || console.log.bind(console);
        logFn.apply(self, args);
    }
    debug.namespace = namespace;
    debug.enabled = exports.enabled(namespace);
    debug.useColors = exports.useColors();
    debug.color = selectColor(namespace);
    // env-specific initialization logic for debug instances
    if ("function" === typeof exports.init) exports.init(debug);
    return debug;
}
/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */ function enable(namespaces) {
    exports.save(namespaces);
    exports.names = [];
    exports.skips = [];
    var split = (typeof namespaces === "string" ? namespaces : "").split(/[\s,]+/);
    var len = split.length;
    for(var i = 0; i < len; i++){
        if (!split[i]) continue; // ignore empty strings
        namespaces = split[i].replace(/\*/g, ".*?");
        if (namespaces[0] === "-") exports.skips.push(new RegExp("^" + namespaces.substr(1) + "$"));
        else exports.names.push(new RegExp("^" + namespaces + "$"));
    }
}
/**
 * Disable debug output.
 *
 * @api public
 */ function disable() {
    exports.enable("");
}
/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */ function enabled(name) {
    var i, len;
    for(i = 0, len = exports.skips.length; i < len; i++){
        if (exports.skips[i].test(name)) return false;
    }
    for(i = 0, len = exports.names.length; i < len; i++){
        if (exports.names[i].test(name)) return true;
    }
    return false;
}
/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */ function coerce(val) {
    if (val instanceof Error) return val.stack || val.message;
    return val;
}

});
parcelRequire.register("etJDr", function(module, exports) {
/**
 * Helpers.
 */ var $a8a72c5246872f6b$var$s = 1000;
var $a8a72c5246872f6b$var$m = $a8a72c5246872f6b$var$s * 60;
var $a8a72c5246872f6b$var$h = $a8a72c5246872f6b$var$m * 60;
var $a8a72c5246872f6b$var$d = $a8a72c5246872f6b$var$h * 24;
var $a8a72c5246872f6b$var$y = $a8a72c5246872f6b$var$d * 365.25;
/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */ module.exports = function(val, options) {
    options = options || {};
    var type = typeof val;
    if (type === "string" && val.length > 0) return $a8a72c5246872f6b$var$parse(val);
    else if (type === "number" && isNaN(val) === false) return options.long ? $a8a72c5246872f6b$var$fmtLong(val) : $a8a72c5246872f6b$var$fmtShort(val);
    throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(val));
};
/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */ function $a8a72c5246872f6b$var$parse(str) {
    str = String(str);
    if (str.length > 100) return;
    var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);
    if (!match) return;
    var n = parseFloat(match[1]);
    var type = (match[2] || "ms").toLowerCase();
    switch(type){
        case "years":
        case "year":
        case "yrs":
        case "yr":
        case "y":
            return n * $a8a72c5246872f6b$var$y;
        case "days":
        case "day":
        case "d":
            return n * $a8a72c5246872f6b$var$d;
        case "hours":
        case "hour":
        case "hrs":
        case "hr":
        case "h":
            return n * $a8a72c5246872f6b$var$h;
        case "minutes":
        case "minute":
        case "mins":
        case "min":
        case "m":
            return n * $a8a72c5246872f6b$var$m;
        case "seconds":
        case "second":
        case "secs":
        case "sec":
        case "s":
            return n * $a8a72c5246872f6b$var$s;
        case "milliseconds":
        case "millisecond":
        case "msecs":
        case "msec":
        case "ms":
            return n;
        default:
            return undefined;
    }
}
/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $a8a72c5246872f6b$var$fmtShort(ms) {
    if (ms >= $a8a72c5246872f6b$var$d) return Math.round(ms / $a8a72c5246872f6b$var$d) + "d";
    if (ms >= $a8a72c5246872f6b$var$h) return Math.round(ms / $a8a72c5246872f6b$var$h) + "h";
    if (ms >= $a8a72c5246872f6b$var$m) return Math.round(ms / $a8a72c5246872f6b$var$m) + "m";
    if (ms >= $a8a72c5246872f6b$var$s) return Math.round(ms / $a8a72c5246872f6b$var$s) + "s";
    return ms + "ms";
}
/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $a8a72c5246872f6b$var$fmtLong(ms) {
    return $a8a72c5246872f6b$var$plural(ms, $a8a72c5246872f6b$var$d, "day") || $a8a72c5246872f6b$var$plural(ms, $a8a72c5246872f6b$var$h, "hour") || $a8a72c5246872f6b$var$plural(ms, $a8a72c5246872f6b$var$m, "minute") || $a8a72c5246872f6b$var$plural(ms, $a8a72c5246872f6b$var$s, "second") || ms + " ms";
}
/**
 * Pluralization helper.
 */ function $a8a72c5246872f6b$var$plural(ms, n, name) {
    if (ms < n) return;
    if (ms < n * 1.5) return Math.floor(ms / n) + " " + name;
    return Math.ceil(ms / n) + " " + name + "s";
}

});



// Global Style




var $g85JO = parcelRequire("g85JO");
var $48d91bc131875195$exports = {};
"use strict";
function $48d91bc131875195$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($48d91bc131875195$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$48d91bc131875195$var$checkDCE();

$48d91bc131875195$exports = (parcelRequire("8Iy3Z"));


var $fd960a74ca553f6f$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $fd960a74ca553f6f$var$__DEV__ = false;
var $fd960a74ca553f6f$var$warning = function() {};
if ($fd960a74ca553f6f$var$__DEV__) {
    var $fd960a74ca553f6f$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = "Warning: " + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== "undefined") console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $fd960a74ca553f6f$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $fd960a74ca553f6f$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$fd960a74ca553f6f$exports = $fd960a74ca553f6f$var$warning;



var $g85JO = parcelRequire("g85JO");
var $84856705c0d3bfb8$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $84856705c0d3bfb8$var$ReactIs, $84856705c0d3bfb8$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$84856705c0d3bfb8$exports = (parcelRequire("iaNTL"))();


function $b93a19e055f09f6e$export$2e2bcd8739ae039() {
    $b93a19e055f09f6e$export$2e2bcd8739ae039 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b93a19e055f09f6e$export$2e2bcd8739ae039.apply(this, arguments);
}


function $d4d1c00531282c6f$var$isAbsolute(pathname) {
    return pathname.charAt(0) === "/";
}
// About 1.5x faster than the two-arg version of Array#splice()
function $d4d1c00531282c6f$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $d4d1c00531282c6f$var$resolvePathname(to, from) {
    if (from === undefined) from = "";
    var toParts = to && to.split("/") || [];
    var fromParts = from && from.split("/") || [];
    var isToAbs = to && $d4d1c00531282c6f$var$isAbsolute(to);
    var isFromAbs = from && $d4d1c00531282c6f$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $d4d1c00531282c6f$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return "/";
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === "." || last === ".." || last === "";
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === ".") $d4d1c00531282c6f$var$spliceOne(fromParts, i);
        else if (part === "..") {
            $d4d1c00531282c6f$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $d4d1c00531282c6f$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift("..");
    if (mustEndAbs && fromParts[0] !== "" && (!fromParts[0] || !$d4d1c00531282c6f$var$isAbsolute(fromParts[0]))) fromParts.unshift("");
    var result = fromParts.join("/");
    if (hasTrailingSlash && result.substr(-1) !== "/") result += "/";
    return result;
}
var $d4d1c00531282c6f$export$2e2bcd8739ae039 = $d4d1c00531282c6f$var$resolvePathname;


function $7941b5108f4baa57$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $7941b5108f4baa57$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $7941b5108f4baa57$var$valueEqual(item, b[index]);
    });
    if (typeof a === "object" || typeof b === "object") {
        var aValue = $7941b5108f4baa57$var$valueOf(a);
        var bValue = $7941b5108f4baa57$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $7941b5108f4baa57$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $7941b5108f4baa57$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $7941b5108f4baa57$export$2e2bcd8739ae039 = $7941b5108f4baa57$var$valueEqual;



var $32fc97d7b12e6d42$var$isProduction = true;
var $32fc97d7b12e6d42$var$prefix = "Invariant failed";
function $32fc97d7b12e6d42$var$invariant(condition, message) {
    if (condition) return;
    if ($32fc97d7b12e6d42$var$isProduction) throw new Error($32fc97d7b12e6d42$var$prefix);
    throw new Error($32fc97d7b12e6d42$var$prefix + ": " + (message || ""));
}
var $32fc97d7b12e6d42$export$2e2bcd8739ae039 = $32fc97d7b12e6d42$var$invariant;


function $63924f9a93bd069f$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $63924f9a93bd069f$var$stripLeadingSlash(path) {
    return path.charAt(0) === "/" ? path.substr(1) : path;
}
function $63924f9a93bd069f$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && "/?#".indexOf(path.charAt(prefix.length)) !== -1;
}
function $63924f9a93bd069f$var$stripBasename(path, prefix) {
    return $63924f9a93bd069f$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $63924f9a93bd069f$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === "/" ? path.slice(0, -1) : path;
}
function $63924f9a93bd069f$export$8ccf933b0513f8d0(path) {
    var pathname = path || "/";
    var search = "";
    var hash = "";
    var hashIndex = pathname.indexOf("#");
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf("?");
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === "?" ? "" : search,
        hash: hash === "#" ? "" : hash
    };
}
function $63924f9a93bd069f$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || "/";
    if (search && search !== "?") path += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") path += hash.charAt(0) === "#" ? hash : "#" + hash;
    return path;
}
function $63924f9a93bd069f$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === "string") {
        // Two-arg form: push(path, state)
        location = $63924f9a93bd069f$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $b93a19e055f09f6e$export$2e2bcd8739ae039)({}, path);
        if (location.pathname === undefined) location.pathname = "";
        if (location.search) {
            if (location.search.charAt(0) !== "?") location.search = "?" + location.search;
        } else location.search = "";
        if (location.hash) {
            if (location.hash.charAt(0) !== "#") location.hash = "#" + location.hash;
        } else location.hash = "";
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + "This is likely caused by an invalid percent-encoding.");
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== "/") location.pathname = (0, $d4d1c00531282c6f$export$2e2bcd8739ae039)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = "/";
    return location;
}
function $63924f9a93bd069f$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $7941b5108f4baa57$export$2e2bcd8739ae039)(a.state, b.state);
}
function $63924f9a93bd069f$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === "function" ? prompt(location, action) : prompt;
            if (typeof result === "string") {
                if (typeof getUserConfirmation === "function") getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $63924f9a93bd069f$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $63924f9a93bd069f$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $63924f9a93bd069f$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf("Android 2.") !== -1 || ua.indexOf("Android 4.0") !== -1) && ua.indexOf("Mobile Safari") !== -1 && ua.indexOf("Chrome") === -1 && ua.indexOf("Windows Phone") === -1) return false;
    return window.history && "pushState" in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $63924f9a93bd069f$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf("Trident") === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $63924f9a93bd069f$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf("Firefox") === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $63924f9a93bd069f$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf("CriOS") === -1;
}
var $63924f9a93bd069f$var$PopStateEvent = "popstate";
var $63924f9a93bd069f$var$HashChangeEvent = "hashchange";
function $63924f9a93bd069f$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $63924f9a93bd069f$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$63924f9a93bd069f$var$canUseDOM && (0, $32fc97d7b12e6d42$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canUseHistory = $63924f9a93bd069f$var$supportsHistory();
    var needsHashChangeListener = !$63924f9a93bd069f$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $63924f9a93bd069f$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $63924f9a93bd069f$var$stripTrailingSlash($63924f9a93bd069f$var$addLeadingSlash(props.basename)) : "";
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $63924f9a93bd069f$var$stripBasename(path, basename);
        return $63924f9a93bd069f$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $63924f9a93bd069f$var$createTransitionManager();
    function setState(nextState) {
        (0, $b93a19e055f09f6e$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($63924f9a93bd069f$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($63924f9a93bd069f$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($63924f9a93bd069f$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $63924f9a93bd069f$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = "PUSH";
        var location = $63924f9a93bd069f$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $63924f9a93bd069f$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($63924f9a93bd069f$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($63924f9a93bd069f$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($63924f9a93bd069f$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($63924f9a93bd069f$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $63924f9a93bd069f$var$HashChangeEvent$1 = "hashchange";
var $63924f9a93bd069f$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === "!" ? path : "!/" + $63924f9a93bd069f$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === "!" ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $63924f9a93bd069f$var$stripLeadingSlash,
        decodePath: $63924f9a93bd069f$var$addLeadingSlash
    },
    slash: {
        encodePath: $63924f9a93bd069f$var$addLeadingSlash,
        decodePath: $63924f9a93bd069f$var$addLeadingSlash
    }
};
function $63924f9a93bd069f$var$stripHash(url) {
    var hashIndex = url.indexOf("#");
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $63924f9a93bd069f$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf("#");
    return hashIndex === -1 ? "" : href.substring(hashIndex + 1);
}
function $63924f9a93bd069f$var$pushHashPath(path) {
    window.location.hash = path;
}
function $63924f9a93bd069f$var$replaceHashPath(path) {
    window.location.replace($63924f9a93bd069f$var$stripHash(window.location.href) + "#" + path);
}
function $63924f9a93bd069f$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$63924f9a93bd069f$var$canUseDOM && (0, $32fc97d7b12e6d42$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $63924f9a93bd069f$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $63924f9a93bd069f$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? "slash" : _props$hashType;
    var basename = props.basename ? $63924f9a93bd069f$var$stripTrailingSlash($63924f9a93bd069f$var$addLeadingSlash(props.basename)) : "";
    var _HashPathCoders$hashT = $63924f9a93bd069f$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($63924f9a93bd069f$var$getHashPath());
        if (basename) path = $63924f9a93bd069f$var$stripBasename(path, basename);
        return $63924f9a93bd069f$export$90c043f1c57770b8(path);
    }
    var transitionManager = $63924f9a93bd069f$var$createTransitionManager();
    function setState(nextState) {
        (0, $b93a19e055f09f6e$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $63924f9a93bd069f$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $63924f9a93bd069f$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $63924f9a93bd069f$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($63924f9a93bd069f$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($63924f9a93bd069f$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $63924f9a93bd069f$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $63924f9a93bd069f$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $63924f9a93bd069f$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector("base");
        var href = "";
        if (baseTag && baseTag.getAttribute("href")) href = $63924f9a93bd069f$var$stripHash(window.location.href);
        return href + "#" + encodePath(basename + $63924f9a93bd069f$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = "PUSH";
        var location = $63924f9a93bd069f$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $63924f9a93bd069f$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $63924f9a93bd069f$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $63924f9a93bd069f$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($63924f9a93bd069f$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $63924f9a93bd069f$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $63924f9a93bd069f$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $63924f9a93bd069f$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $63924f9a93bd069f$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($63924f9a93bd069f$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($63924f9a93bd069f$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($63924f9a93bd069f$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $63924f9a93bd069f$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $63924f9a93bd069f$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        "/"
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $63924f9a93bd069f$var$createTransitionManager();
    function setState(nextState) {
        (0, $b93a19e055f09f6e$export$2e2bcd8739ae039)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $63924f9a93bd069f$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === "string" ? $63924f9a93bd069f$export$90c043f1c57770b8(entry, undefined, createKey()) : $63924f9a93bd069f$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $63924f9a93bd069f$export$fe53371bee54353d;
    function push(path, state) {
        var action = "PUSH";
        var location = $63924f9a93bd069f$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $63924f9a93bd069f$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $63924f9a93bd069f$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = "POP";
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: "POP",
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}


// Written in this round about way for babel-transform-imports

var $03461252d7aee875$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $03461252d7aee875$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = "Invariant Violation";
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
$03461252d7aee875$exports = $03461252d7aee875$var$invariant;



var $g85JO = parcelRequire("g85JO");

var $fbde9488619f45fa$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $fbde9488619f45fa$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $fbde9488619f45fa$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $fbde9488619f45fa$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * The public API for putting history on context.
 */ var $fbde9488619f45fa$var$Router = function(_React$Component) {
    $fbde9488619f45fa$var$_inherits(Router, _React$Component);
    function Router() {
        var _temp, _this, _ret;
        $fbde9488619f45fa$var$_classCallCheck(this, Router);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $fbde9488619f45fa$var$_possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), _this.state = {
            match: _this.computeMatch(_this.props.history.location.pathname)
        }, _temp), $fbde9488619f45fa$var$_possibleConstructorReturn(_this, _ret);
    }
    Router.prototype.getChildContext = function getChildContext() {
        return {
            router: $fbde9488619f45fa$var$_extends({}, this.context.router, {
                history: this.props.history,
                route: {
                    location: this.props.history.location,
                    match: this.state.match
                }
            })
        };
    };
    Router.prototype.computeMatch = function computeMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    Router.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;
        var _props = this.props, children = _props.children, history = _props.history;
        (0, (/*@__PURE__*/$parcel$interopDefault($03461252d7aee875$exports)))(children == null || (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).Children.count(children) === 1, "A <Router> may have only one child element");
        // Do this here so we can setState when a <Redirect> changes the
        // location in componentWillMount. This happens e.g. when doing
        // server rendering using a <StaticRouter>.
        this.unlisten = history.listen(function() {
            _this2.setState({
                match: _this2.computeMatch(history.location.pathname)
            });
        });
    };
    Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        (0, (/*@__PURE__*/$parcel$interopDefault($fd960a74ca553f6f$exports)))(this.props.history === nextProps.history, "You cannot change <Router history>");
    };
    Router.prototype.componentWillUnmount = function componentWillUnmount() {
        this.unlisten();
    };
    Router.prototype.render = function render() {
        var children = this.props.children;
        return children ? (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).Children.only(children) : null;
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).Component);
$fbde9488619f45fa$var$Router.propTypes = {
    history: (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).object.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).node
};
$fbde9488619f45fa$var$Router.contextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).object
};
$fbde9488619f45fa$var$Router.childContextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).object.isRequired
};
var $fbde9488619f45fa$export$2e2bcd8739ae039 = $fbde9488619f45fa$var$Router;


var $3524f4e31e5ef235$export$2e2bcd8739ae039 = (0, $fbde9488619f45fa$export$2e2bcd8739ae039);


function $a013cbff9d0a01ad$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a013cbff9d0a01ad$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $a013cbff9d0a01ad$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $a013cbff9d0a01ad$var$BrowserRouter = function(_React$Component) {
    $a013cbff9d0a01ad$var$_inherits(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _temp, _this, _ret;
        $a013cbff9d0a01ad$var$_classCallCheck(this, BrowserRouter);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $a013cbff9d0a01ad$var$_possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), _this.history = (0, $63924f9a93bd069f$export$719fc203c4e16dee)(_this.props), _temp), $a013cbff9d0a01ad$var$_possibleConstructorReturn(_this, _ret);
    }
    BrowserRouter.prototype.componentWillMount = function componentWillMount() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fd960a74ca553f6f$exports)))(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, use `import { Router }` instead of `import { BrowserRouter as Router }`.");
    };
    BrowserRouter.prototype.render = function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement((0, $3524f4e31e5ef235$export$2e2bcd8739ae039), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).Component);
$a013cbff9d0a01ad$var$BrowserRouter.propTypes = {
    basename: (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).string,
    forceRefresh: (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).bool,
    getUserConfirmation: (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).func,
    keyLength: (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).number,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).node
};
var $a013cbff9d0a01ad$export$2e2bcd8739ae039 = $a013cbff9d0a01ad$var$BrowserRouter;



var $g85JO = parcelRequire("g85JO");
// Written in this round about way for babel-transform-imports

var $g85JO = parcelRequire("g85JO");




var $8a9132e38d21c472$exports = {};
var $bd52bec36c6b79a5$exports = {};
$bd52bec36c6b79a5$exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == "[object Array]";
};


/**
 * Expose `pathToRegexp`.
 */ $8a9132e38d21c472$exports = $8a9132e38d21c472$var$pathToRegexp;
$8a9132e38d21c472$exports.parse = $8a9132e38d21c472$var$parse;
$8a9132e38d21c472$exports.compile = $8a9132e38d21c472$var$compile;
$8a9132e38d21c472$exports.tokensToFunction = $8a9132e38d21c472$var$tokensToFunction;
$8a9132e38d21c472$exports.tokensToRegExp = $8a9132e38d21c472$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $8a9132e38d21c472$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    "(\\\\.)",
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    "([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))"
].join("|"), "g");
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $8a9132e38d21c472$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = "";
    var defaultDelimiter = options && options.delimiter || "/";
    var res;
    while((res = $8a9132e38d21c472$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = "";
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === "+" || modifier === "*";
        var optional = modifier === "?" || modifier === "*";
        var delimiter = res[2] || defaultDelimiter;
        var pattern = capture || group;
        tokens.push({
            name: name || key++,
            prefix: prefix || "",
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $8a9132e38d21c472$var$escapeGroup(pattern) : asterisk ? ".*" : "[^" + $8a9132e38d21c472$var$escapeString(delimiter) + "]+?"
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $8a9132e38d21c472$var$compile(str, options) {
    return $8a9132e38d21c472$var$tokensToFunction($8a9132e38d21c472$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $8a9132e38d21c472$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $8a9132e38d21c472$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $8a9132e38d21c472$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === "object") matches[i] = new RegExp("^(?:" + tokens[i].pattern + ")$", $8a9132e38d21c472$var$flags(options));
    return function(obj, opts) {
        var path = "";
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $8a9132e38d21c472$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($bd52bec36c6b79a5$exports(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + "`");
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + "`");
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $8a9132e38d21c472$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $8a9132e38d21c472$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, "\\$1");
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $8a9132e38d21c472$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, "\\$1");
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $8a9132e38d21c472$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $8a9132e38d21c472$var$flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $8a9132e38d21c472$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $8a9132e38d21c472$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $8a9132e38d21c472$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($8a9132e38d21c472$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp("(?:" + parts.join("|") + ")", $8a9132e38d21c472$var$flags(options));
    return $8a9132e38d21c472$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $8a9132e38d21c472$var$stringToRegexp(path, keys, options) {
    return $8a9132e38d21c472$var$tokensToRegExp($8a9132e38d21c472$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $8a9132e38d21c472$var$tokensToRegExp(tokens, keys, options) {
    if (!$bd52bec36c6b79a5$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = "";
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === "string") route += $8a9132e38d21c472$var$escapeString(token);
        else {
            var prefix = $8a9132e38d21c472$var$escapeString(token.prefix);
            var capture = "(?:" + token.pattern + ")";
            keys.push(token);
            if (token.repeat) capture += "(?:" + prefix + capture + ")*";
            if (token.optional) {
                if (!token.partial) capture = "(?:" + prefix + "(" + capture + "))?";
                else capture = prefix + "(" + capture + ")?";
            } else capture = prefix + "(" + capture + ")";
            route += capture;
        }
    }
    var delimiter = $8a9132e38d21c472$var$escapeString(options.delimiter || "/");
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + "(?:" + delimiter + "(?=$))?";
    if (end) route += "$";
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? "" : "(?=" + delimiter + "|$)";
    return $8a9132e38d21c472$var$attachKeys(new RegExp("^" + route, $8a9132e38d21c472$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $8a9132e38d21c472$var$pathToRegexp(path, keys, options) {
    if (!$bd52bec36c6b79a5$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $8a9132e38d21c472$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($bd52bec36c6b79a5$exports(path)) return $8a9132e38d21c472$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $8a9132e38d21c472$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}


var $396a6a4072bcfb0c$var$patternCache = {};
var $396a6a4072bcfb0c$var$cacheLimit = 10000;
var $396a6a4072bcfb0c$var$cacheCount = 0;
var $396a6a4072bcfb0c$var$compileGenerator = function compileGenerator(pattern) {
    var cacheKey = pattern;
    var cache = $396a6a4072bcfb0c$var$patternCache[cacheKey] || ($396a6a4072bcfb0c$var$patternCache[cacheKey] = {});
    if (cache[pattern]) return cache[pattern];
    var compiledGenerator = (0, (/*@__PURE__*/$parcel$interopDefault($8a9132e38d21c472$exports))).compile(pattern);
    if ($396a6a4072bcfb0c$var$cacheCount < $396a6a4072bcfb0c$var$cacheLimit) {
        cache[pattern] = compiledGenerator;
        $396a6a4072bcfb0c$var$cacheCount++;
    }
    return compiledGenerator;
};
/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */ var $396a6a4072bcfb0c$var$generatePath = function generatePath() {
    var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (pattern === "/") return pattern;
    var generator = $396a6a4072bcfb0c$var$compileGenerator(pattern);
    return generator(params, {
        pretty: true
    });
};
var $396a6a4072bcfb0c$export$2e2bcd8739ae039 = $396a6a4072bcfb0c$var$generatePath;


var $54e1bd588dee71fd$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $54e1bd588dee71fd$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $54e1bd588dee71fd$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $54e1bd588dee71fd$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * The public API for updating the location programmatically
 * with a component.
 */ var $54e1bd588dee71fd$var$Redirect = function(_React$Component) {
    $54e1bd588dee71fd$var$_inherits(Redirect, _React$Component);
    function Redirect() {
        $54e1bd588dee71fd$var$_classCallCheck(this, Redirect);
        return $54e1bd588dee71fd$var$_possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }
    Redirect.prototype.isStatic = function isStatic() {
        return this.context.router && this.context.router.staticContext;
    };
    Redirect.prototype.componentWillMount = function componentWillMount() {
        (0, (/*@__PURE__*/$parcel$interopDefault($03461252d7aee875$exports)))(this.context.router, "You should not use <Redirect> outside a <Router>");
        if (this.isStatic()) this.perform();
    };
    Redirect.prototype.componentDidMount = function componentDidMount() {
        if (!this.isStatic()) this.perform();
    };
    Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
        var prevTo = (0, $63924f9a93bd069f$export$90c043f1c57770b8)(prevProps.to);
        var nextTo = (0, $63924f9a93bd069f$export$90c043f1c57770b8)(this.props.to);
        if ((0, $63924f9a93bd069f$export$c3e8bb440bd55b18)(prevTo, nextTo)) {
            (0, (/*@__PURE__*/$parcel$interopDefault($fd960a74ca553f6f$exports)))(false, "You tried to redirect to the same route you're currently on: " + ('"' + nextTo.pathname + nextTo.search + '"'));
            return;
        }
        this.perform();
    };
    Redirect.prototype.computeTo = function computeTo(_ref) {
        var computedMatch = _ref.computedMatch, to = _ref.to;
        if (computedMatch) {
            if (typeof to === "string") return (0, $396a6a4072bcfb0c$export$2e2bcd8739ae039)(to, computedMatch.params);
            else return $54e1bd588dee71fd$var$_extends({}, to, {
                pathname: (0, $396a6a4072bcfb0c$export$2e2bcd8739ae039)(to.pathname, computedMatch.params)
            });
        }
        return to;
    };
    Redirect.prototype.perform = function perform() {
        var history = this.context.router.history;
        var push = this.props.push;
        var to = this.computeTo(this.props);
        if (push) history.push(to);
        else history.replace(to);
    };
    Redirect.prototype.render = function render() {
        return null;
    };
    return Redirect;
}((0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).Component);
$54e1bd588dee71fd$var$Redirect.propTypes = {
    computedMatch: (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).object,
    push: (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).bool,
    from: (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).string,
    to: (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).object
    ]).isRequired
};
$54e1bd588dee71fd$var$Redirect.defaultProps = {
    push: false
};
$54e1bd588dee71fd$var$Redirect.contextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).shape({
        history: (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).shape({
            push: (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).func.isRequired,
            replace: (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).func.isRequired
        }).isRequired,
        staticContext: (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).object
    }).isRequired
};
var $54e1bd588dee71fd$export$2e2bcd8739ae039 = $54e1bd588dee71fd$var$Redirect;


var $2ace29d8b52175d2$export$2e2bcd8739ae039 = (0, $54e1bd588dee71fd$export$2e2bcd8739ae039);

// Written in this round about way for babel-transform-imports



var $g85JO = parcelRequire("g85JO");


var $2e086eea2fac2d2c$var$patternCache = {};
var $2e086eea2fac2d2c$var$cacheLimit = 10000;
var $2e086eea2fac2d2c$var$cacheCount = 0;
var $2e086eea2fac2d2c$var$compilePath = function compilePath(pattern, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var cache = $2e086eea2fac2d2c$var$patternCache[cacheKey] || ($2e086eea2fac2d2c$var$patternCache[cacheKey] = {});
    if (cache[pattern]) return cache[pattern];
    var keys = [];
    var re = (0, (/*@__PURE__*/$parcel$interopDefault($8a9132e38d21c472$exports)))(pattern, keys, options);
    var compiledPattern = {
        re: re,
        keys: keys
    };
    if ($2e086eea2fac2d2c$var$cacheCount < $2e086eea2fac2d2c$var$cacheLimit) {
        cache[pattern] = compiledPattern;
        $2e086eea2fac2d2c$var$cacheCount++;
    }
    return compiledPattern;
};
/**
 * Public API for matching a URL pathname to a path pattern.
 */ var $2e086eea2fac2d2c$var$matchPath = function matchPath(pathname) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var parent = arguments[2];
    if (typeof options === "string") options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === undefined ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === undefined ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === undefined ? false : _options$sensitive;
    if (path == null) return parent;
    var _compilePath = $2e086eea2fac2d2c$var$compilePath(path, {
        end: exact,
        strict: strict,
        sensitive: sensitive
    }), re = _compilePath.re, keys = _compilePath.keys;
    var match = re.exec(pathname);
    if (!match) return null;
    var url = match[0], values = match.slice(1);
    var isExact = pathname === url;
    if (exact && !isExact) return null;
    return {
        path: path,
        url: path === "/" && url === "" ? "/" : url,
        isExact: isExact,
        params: keys.reduce(function(memo, key, index) {
            memo[key.name] = values[index];
            return memo;
        }, {})
    };
};
var $2e086eea2fac2d2c$export$2e2bcd8739ae039 = $2e086eea2fac2d2c$var$matchPath;


var $356a0b0be035f33f$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $356a0b0be035f33f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $356a0b0be035f33f$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $356a0b0be035f33f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $356a0b0be035f33f$var$isEmptyChildren = function isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).Children.count(children) === 0;
};
/**
 * The public API for matching a single path and rendering.
 */ var $356a0b0be035f33f$var$Route = function(_React$Component) {
    $356a0b0be035f33f$var$_inherits(Route, _React$Component);
    function Route() {
        var _temp, _this, _ret;
        $356a0b0be035f33f$var$_classCallCheck(this, Route);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $356a0b0be035f33f$var$_possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), _this.state = {
            match: _this.computeMatch(_this.props, _this.context.router)
        }, _temp), $356a0b0be035f33f$var$_possibleConstructorReturn(_this, _ret);
    }
    Route.prototype.getChildContext = function getChildContext() {
        return {
            router: $356a0b0be035f33f$var$_extends({}, this.context.router, {
                route: {
                    location: this.props.location || this.context.router.route.location,
                    match: this.state.match
                }
            })
        };
    };
    Route.prototype.computeMatch = function computeMatch(_ref, router) {
        var computedMatch = _ref.computedMatch, location = _ref.location, path = _ref.path, strict = _ref.strict, exact = _ref.exact, sensitive = _ref.sensitive;
        if (computedMatch) return computedMatch; // <Switch> already computed the match for us
        (0, (/*@__PURE__*/$parcel$interopDefault($03461252d7aee875$exports)))(router, "You should not use <Route> or withRouter() outside a <Router>");
        var route = router.route;
        var pathname = (location || route.location).pathname;
        return (0, $2e086eea2fac2d2c$export$2e2bcd8739ae039)(pathname, {
            path: path,
            strict: strict,
            exact: exact,
            sensitive: sensitive
        }, route.match);
    };
    Route.prototype.componentWillMount = function componentWillMount() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fd960a74ca553f6f$exports)))(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");
        (0, (/*@__PURE__*/$parcel$interopDefault($fd960a74ca553f6f$exports)))(!(this.props.component && this.props.children && !$356a0b0be035f33f$var$isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");
        (0, (/*@__PURE__*/$parcel$interopDefault($fd960a74ca553f6f$exports)))(!(this.props.render && this.props.children && !$356a0b0be035f33f$var$isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
    };
    Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
        (0, (/*@__PURE__*/$parcel$interopDefault($fd960a74ca553f6f$exports)))(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
        (0, (/*@__PURE__*/$parcel$interopDefault($fd960a74ca553f6f$exports)))(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
        this.setState({
            match: this.computeMatch(nextProps, nextContext.router)
        });
    };
    Route.prototype.render = function render() {
        var match = this.state.match;
        var _props = this.props, children = _props.children, component = _props.component, render = _props.render;
        var _context$router = this.context.router, history = _context$router.history, route = _context$router.route, staticContext = _context$router.staticContext;
        var location = this.props.location || route.location;
        var props = {
            match: match,
            location: location,
            history: history,
            staticContext: staticContext
        };
        if (component) return match ? (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement(component, props) : null;
        if (render) return match ? render(props) : null;
        if (typeof children === "function") return children(props);
        if (children && !$356a0b0be035f33f$var$isEmptyChildren(children)) return (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).Children.only(children);
        return null;
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).Component);
$356a0b0be035f33f$var$Route.propTypes = {
    computedMatch: (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).object,
    path: (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).string,
    exact: (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).bool,
    strict: (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).bool,
    sensitive: (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).bool,
    component: (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).func,
    render: (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).func,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).node
    ]),
    location: (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).object
};
$356a0b0be035f33f$var$Route.contextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).shape({
        history: (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).object.isRequired,
        route: (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).object.isRequired,
        staticContext: (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).object
    })
};
$356a0b0be035f33f$var$Route.childContextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).object.isRequired
};
var $356a0b0be035f33f$export$2e2bcd8739ae039 = $356a0b0be035f33f$var$Route;


var $fcf1a16a32c1d7db$export$2e2bcd8739ae039 = (0, $356a0b0be035f33f$export$2e2bcd8739ae039);

// Written in this round about way for babel-transform-imports

var $g85JO = parcelRequire("g85JO");




function $7dab3a102adf18c8$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7dab3a102adf18c8$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $7dab3a102adf18c8$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * The public API for rendering the first <Route> that matches.
 */ var $7dab3a102adf18c8$var$Switch = function(_React$Component) {
    $7dab3a102adf18c8$var$_inherits(Switch, _React$Component);
    function Switch() {
        $7dab3a102adf18c8$var$_classCallCheck(this, Switch);
        return $7dab3a102adf18c8$var$_possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }
    Switch.prototype.componentWillMount = function componentWillMount() {
        (0, (/*@__PURE__*/$parcel$interopDefault($03461252d7aee875$exports)))(this.context.router, "You should not use <Switch> outside a <Router>");
    };
    Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        (0, (/*@__PURE__*/$parcel$interopDefault($fd960a74ca553f6f$exports)))(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
        (0, (/*@__PURE__*/$parcel$interopDefault($fd960a74ca553f6f$exports)))(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
    };
    Switch.prototype.render = function render() {
        var route = this.context.router.route;
        var children = this.props.children;
        var location = this.props.location || route.location;
        var match = void 0, child = void 0;
        (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).Children.forEach(children, function(element) {
            if (match == null && (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).isValidElement(element)) {
                var _element$props = element.props, pathProp = _element$props.path, exact = _element$props.exact, strict = _element$props.strict, sensitive = _element$props.sensitive, from = _element$props.from;
                var path = pathProp || from;
                child = element;
                match = (0, $2e086eea2fac2d2c$export$2e2bcd8739ae039)(location.pathname, {
                    path: path,
                    exact: exact,
                    strict: strict,
                    sensitive: sensitive
                }, route.match);
            }
        });
        return match ? (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).cloneElement(child, {
            location: location,
            computedMatch: match
        }) : null;
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).Component);
$7dab3a102adf18c8$var$Switch.contextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).shape({
        route: (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).object.isRequired
    }).isRequired
};
$7dab3a102adf18c8$var$Switch.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).node,
    location: (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).object
};
var $7dab3a102adf18c8$export$2e2bcd8739ae039 = $7dab3a102adf18c8$var$Switch;


var $d9cc27b375329b06$export$2e2bcd8739ae039 = (0, $7dab3a102adf18c8$export$2e2bcd8739ae039);

// Written in this round about way for babel-transform-imports

var $g85JO = parcelRequire("g85JO");

var $a2a596aeaa3ad39b$exports = {};
"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $a2a596aeaa3ad39b$var$REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $a2a596aeaa3ad39b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $a2a596aeaa3ad39b$var$defineProperty = Object.defineProperty;
var $a2a596aeaa3ad39b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $a2a596aeaa3ad39b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $a2a596aeaa3ad39b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $a2a596aeaa3ad39b$var$getPrototypeOf = Object.getPrototypeOf;
var $a2a596aeaa3ad39b$var$objectPrototype = $a2a596aeaa3ad39b$var$getPrototypeOf && $a2a596aeaa3ad39b$var$getPrototypeOf(Object);
function $a2a596aeaa3ad39b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        if ($a2a596aeaa3ad39b$var$objectPrototype) {
            var inheritedComponent = $a2a596aeaa3ad39b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $a2a596aeaa3ad39b$var$objectPrototype) $a2a596aeaa3ad39b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $a2a596aeaa3ad39b$var$getOwnPropertyNames(sourceComponent);
        if ($a2a596aeaa3ad39b$var$getOwnPropertySymbols) keys = keys.concat($a2a596aeaa3ad39b$var$getOwnPropertySymbols(sourceComponent));
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$a2a596aeaa3ad39b$var$REACT_STATICS[key] && !$a2a596aeaa3ad39b$var$KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = $a2a596aeaa3ad39b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $a2a596aeaa3ad39b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
        return targetComponent;
    }
    return targetComponent;
}
$a2a596aeaa3ad39b$exports = $a2a596aeaa3ad39b$var$hoistNonReactStatics;



var $ca5881c093edc68c$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $ca5881c093edc68c$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
/**
 * A public higher-order component to access the imperative API
 */ var $ca5881c093edc68c$var$withRouter = function withRouter(Component) {
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = $ca5881c093edc68c$var$_objectWithoutProperties(props, [
            "wrappedComponentRef"
        ]);
        return (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement((0, $356a0b0be035f33f$export$2e2bcd8739ae039), {
            children: function children(routeComponentProps) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement(Component, $ca5881c093edc68c$var$_extends({}, remainingProps, routeComponentProps, {
                    ref: wrappedComponentRef
                }));
            }
        });
    };
    C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    C.WrappedComponent = Component;
    C.propTypes = {
        wrappedComponentRef: (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).func
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($a2a596aeaa3ad39b$exports)))(C, Component);
};
var $ca5881c093edc68c$export$2e2bcd8739ae039 = $ca5881c093edc68c$var$withRouter;


var $7b5e727ae8dc8fde$export$2e2bcd8739ae039 = (0, $ca5881c093edc68c$export$2e2bcd8739ae039);



var $g85JO = parcelRequire("g85JO");
var $c3da8b13b9968bd3$exports = {};
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === "string" || argType === "number") classes.push(arg);
            else if (Array.isArray(arg) && arg.length) {
                var inner = classNames.apply(null, arg);
                if (inner) classes.push(inner);
            } else if (argType === "object") {
                for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
            }
        }
        return classes.join(" ");
    }
    if (0, $c3da8b13b9968bd3$exports) {
        classNames.default = classNames;
        $c3da8b13b9968bd3$exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();


var $548062b3fb4505b6$exports = {};

$parcel$export($548062b3fb4505b6$exports, "container", function () { return $548062b3fb4505b6$export$34e0f9847d4c02dd; }, function (v) { return $548062b3fb4505b6$export$34e0f9847d4c02dd = v; });
$parcel$export($548062b3fb4505b6$exports, "containerIntroAnimating", function () { return $548062b3fb4505b6$export$50688f243e24ed36; }, function (v) { return $548062b3fb4505b6$export$50688f243e24ed36 = v; });
$parcel$export($548062b3fb4505b6$exports, "landing", function () { return $548062b3fb4505b6$export$a9ae88069d8ac14e; }, function (v) { return $548062b3fb4505b6$export$a9ae88069d8ac14e = v; });
$parcel$export($548062b3fb4505b6$exports, "spacer", function () { return $548062b3fb4505b6$export$8cc075c801fd6817; }, function (v) { return $548062b3fb4505b6$export$8cc075c801fd6817 = v; });
$parcel$export($548062b3fb4505b6$exports, "trigger", function () { return $548062b3fb4505b6$export$e614dc9140f7ae71; }, function (v) { return $548062b3fb4505b6$export$e614dc9140f7ae71 = v; });
$parcel$export($548062b3fb4505b6$exports, "graphic", function () { return $548062b3fb4505b6$export$c96b99088d96cc6d; }, function (v) { return $548062b3fb4505b6$export$c96b99088d96cc6d = v; });
$parcel$export($548062b3fb4505b6$exports, "graphicSection", function () { return $548062b3fb4505b6$export$8c36b8c0719ce664; }, function (v) { return $548062b3fb4505b6$export$8c36b8c0719ce664 = v; });
$parcel$export($548062b3fb4505b6$exports, "blackwingTextLogo", function () { return $548062b3fb4505b6$export$4f4e6c83c4a24bf7; }, function (v) { return $548062b3fb4505b6$export$4f4e6c83c4a24bf7 = v; });
$parcel$export($548062b3fb4505b6$exports, "graphicShow", function () { return $548062b3fb4505b6$export$ae8302c815834caf; }, function (v) { return $548062b3fb4505b6$export$ae8302c815834caf = v; });
$parcel$export($548062b3fb4505b6$exports, "signupSection", function () { return $548062b3fb4505b6$export$a37364b464f82ce8; }, function (v) { return $548062b3fb4505b6$export$a37364b464f82ce8 = v; });
$parcel$export($548062b3fb4505b6$exports, "contact", function () { return $548062b3fb4505b6$export$414d047e665c7112; }, function (v) { return $548062b3fb4505b6$export$414d047e665c7112 = v; });
$parcel$export($548062b3fb4505b6$exports, "navHoverDiv", function () { return $548062b3fb4505b6$export$448ff1ec2fe1c80d; }, function (v) { return $548062b3fb4505b6$export$448ff1ec2fe1c80d = v; });
$parcel$export($548062b3fb4505b6$exports, "navHovering", function () { return $548062b3fb4505b6$export$e64b14c1af71a9e8; }, function (v) { return $548062b3fb4505b6$export$e64b14c1af71a9e8 = v; });
$parcel$export($548062b3fb4505b6$exports, "navMobileOpen", function () { return $548062b3fb4505b6$export$467fc2f54d2f1276; }, function (v) { return $548062b3fb4505b6$export$467fc2f54d2f1276 = v; });
$parcel$export($548062b3fb4505b6$exports, "social", function () { return $548062b3fb4505b6$export$cba3d3852a039325; }, function (v) { return $548062b3fb4505b6$export$cba3d3852a039325 = v; });
$parcel$export($548062b3fb4505b6$exports, "credit", function () { return $548062b3fb4505b6$export$cc6a8f8512087d91; }, function (v) { return $548062b3fb4505b6$export$cc6a8f8512087d91 = v; });
$parcel$export($548062b3fb4505b6$exports, "logoLink", function () { return $548062b3fb4505b6$export$ca5ab360c5bee0b1; }, function (v) { return $548062b3fb4505b6$export$ca5ab360c5bee0b1 = v; });
var $548062b3fb4505b6$export$34e0f9847d4c02dd;
var $548062b3fb4505b6$export$50688f243e24ed36;
var $548062b3fb4505b6$export$a9ae88069d8ac14e;
var $548062b3fb4505b6$export$8cc075c801fd6817;
var $548062b3fb4505b6$export$e614dc9140f7ae71;
var $548062b3fb4505b6$export$c96b99088d96cc6d;
var $548062b3fb4505b6$export$8c36b8c0719ce664;
var $548062b3fb4505b6$export$4f4e6c83c4a24bf7;
var $548062b3fb4505b6$export$ae8302c815834caf;
var $548062b3fb4505b6$export$a37364b464f82ce8;
var $548062b3fb4505b6$export$414d047e665c7112;
var $548062b3fb4505b6$export$448ff1ec2fe1c80d;
var $548062b3fb4505b6$export$e64b14c1af71a9e8;
var $548062b3fb4505b6$export$467fc2f54d2f1276;
var $548062b3fb4505b6$export$cba3d3852a039325;
var $548062b3fb4505b6$export$cc6a8f8512087d91;
var $548062b3fb4505b6$export$ca5ab360c5bee0b1;
$548062b3fb4505b6$export$34e0f9847d4c02dd = "_app-views-Home-_styles__container";
$548062b3fb4505b6$export$50688f243e24ed36 = "_app-views-Home-_styles__containerIntroAnimating";
$548062b3fb4505b6$export$a9ae88069d8ac14e = "_app-views-Home-_styles__landing";
$548062b3fb4505b6$export$8cc075c801fd6817 = "_app-views-Home-_styles__spacer";
$548062b3fb4505b6$export$e614dc9140f7ae71 = "_app-views-Home-_styles__trigger";
$548062b3fb4505b6$export$c96b99088d96cc6d = "_app-views-Home-_styles__graphic";
$548062b3fb4505b6$export$8c36b8c0719ce664 = "_app-views-Home-_styles__graphicSection";
$548062b3fb4505b6$export$4f4e6c83c4a24bf7 = "_app-views-Home-_styles__blackwingTextLogo";
$548062b3fb4505b6$export$ae8302c815834caf = "_app-views-Home-_styles__graphicShow";
$548062b3fb4505b6$export$a37364b464f82ce8 = "_app-views-Home-_styles__signupSection";
$548062b3fb4505b6$export$414d047e665c7112 = "_app-views-Home-_styles__contact";
$548062b3fb4505b6$export$448ff1ec2fe1c80d = "_app-views-Home-_styles__navHoverDiv";
$548062b3fb4505b6$export$e64b14c1af71a9e8 = "_app-views-Home-_styles__navHovering";
$548062b3fb4505b6$export$467fc2f54d2f1276 = "_app-views-Home-_styles__navMobileOpen";
$548062b3fb4505b6$export$cba3d3852a039325 = "_app-views-Home-_styles__social";
$548062b3fb4505b6$export$cc6a8f8512087d91 = "_app-views-Home-_styles__credit";
$548062b3fb4505b6$export$ca5ab360c5bee0b1 = "_app-views-Home-_styles__logoLink";



var $g85JO = parcelRequire("g85JO");

var $g85JO = parcelRequire("g85JO");

var $40cdf530675eeeef$exports = {};

$parcel$export($40cdf530675eeeef$exports, "item", function () { return $40cdf530675eeeef$export$7061c75fc5af8b7e; }, function (v) { return $40cdf530675eeeef$export$7061c75fc5af8b7e = v; });
$parcel$export($40cdf530675eeeef$exports, "itemHasAnchor", function () { return $40cdf530675eeeef$export$749115da4588a809; }, function (v) { return $40cdf530675eeeef$export$749115da4588a809 = v; });
$parcel$export($40cdf530675eeeef$exports, "inner", function () { return $40cdf530675eeeef$export$4ae363f1d88fb658; }, function (v) { return $40cdf530675eeeef$export$4ae363f1d88fb658 = v; });
$parcel$export($40cdf530675eeeef$exports, "wedge", function () { return $40cdf530675eeeef$export$232d01f292e83d; }, function (v) { return $40cdf530675eeeef$export$232d01f292e83d = v; });
$parcel$export($40cdf530675eeeef$exports, "internalLink", function () { return $40cdf530675eeeef$export$6a41e5454b6859fe; }, function (v) { return $40cdf530675eeeef$export$6a41e5454b6859fe = v; });
var $40cdf530675eeeef$export$7061c75fc5af8b7e;
var $40cdf530675eeeef$export$749115da4588a809;
var $40cdf530675eeeef$export$4ae363f1d88fb658;
var $40cdf530675eeeef$export$232d01f292e83d;
var $40cdf530675eeeef$export$6a41e5454b6859fe;
$40cdf530675eeeef$export$7061c75fc5af8b7e = "_app-components-NavItem-_styles__item";
$40cdf530675eeeef$export$749115da4588a809 = "_app-components-NavItem-_styles__itemHasAnchor";
$40cdf530675eeeef$export$4ae363f1d88fb658 = "_app-components-NavItem-_styles__inner";
$40cdf530675eeeef$export$232d01f292e83d = "_app-components-NavItem-_styles__wedge";
$40cdf530675eeeef$export$6a41e5454b6859fe = "_app-components-NavItem-_styles__internalLink";


var $c55b064831e1f1a0$exports = {};
/* smoothscroll v0.4.4 - 2019 - Dustan Kasten, Jeremias Menichelli - MIT License */ (function() {
    "use strict";
    // polyfill
    function polyfill() {
        // aliases
        var w = window;
        var d = document;
        // return if scroll behavior is supported and polyfill is not forced
        if ("scrollBehavior" in d.documentElement.style && w.__forceSmoothScrollPolyfill__ !== true) return;
        // globals
        var Element = w.HTMLElement || w.Element;
        var SCROLL_TIME = 468;
        // object gathering original scroll methods
        var original = {
            scroll: w.scroll || w.scrollTo,
            scrollBy: w.scrollBy,
            elementScroll: Element.prototype.scroll || scrollElement,
            scrollIntoView: Element.prototype.scrollIntoView
        };
        // define timing method
        var now = w.performance && w.performance.now ? w.performance.now.bind(w.performance) : Date.now;
        /**
     * indicates if a the current browser is made by Microsoft
     * @method isMicrosoftBrowser
     * @param {String} userAgent
     * @returns {Boolean}
     */ function isMicrosoftBrowser(userAgent) {
            var userAgentPatterns = [
                "MSIE ",
                "Trident/",
                "Edge/"
            ];
            return new RegExp(userAgentPatterns.join("|")).test(userAgent);
        }
        /*
     * IE has rounding bug rounding down clientHeight and clientWidth and
     * rounding up scrollHeight and scrollWidth causing false positives
     * on hasScrollableSpace
     */ var ROUNDING_TOLERANCE = isMicrosoftBrowser(w.navigator.userAgent) ? 1 : 0;
        /**
     * changes scroll position inside an element
     * @method scrollElement
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */ function scrollElement(x, y) {
            this.scrollLeft = x;
            this.scrollTop = y;
        }
        /**
     * returns result of applying ease math function to a number
     * @method ease
     * @param {Number} k
     * @returns {Number}
     */ function ease(k) {
            return 0.5 * (1 - Math.cos(Math.PI * k));
        }
        /**
     * indicates if a smooth behavior should be applied
     * @method shouldBailOut
     * @param {Number|Object} firstArg
     * @returns {Boolean}
     */ function shouldBailOut(firstArg) {
            if (firstArg === null || typeof firstArg !== "object" || firstArg.behavior === undefined || firstArg.behavior === "auto" || firstArg.behavior === "instant") // first argument is not an object/null
            // or behavior is auto, instant or undefined
            return true;
            if (typeof firstArg === "object" && firstArg.behavior === "smooth") // first argument is an object and behavior is smooth
            return false;
            // throw error when behavior is not supported
            throw new TypeError("behavior member of ScrollOptions " + firstArg.behavior + " is not a valid value for enumeration ScrollBehavior.");
        }
        /**
     * indicates if an element has scrollable space in the provided axis
     * @method hasScrollableSpace
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */ function hasScrollableSpace(el, axis) {
            if (axis === "Y") return el.clientHeight + ROUNDING_TOLERANCE < el.scrollHeight;
            if (axis === "X") return el.clientWidth + ROUNDING_TOLERANCE < el.scrollWidth;
        }
        /**
     * indicates if an element has a scrollable overflow property in the axis
     * @method canOverflow
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */ function canOverflow(el, axis) {
            var overflowValue = w.getComputedStyle(el, null)["overflow" + axis];
            return overflowValue === "auto" || overflowValue === "scroll";
        }
        /**
     * indicates if an element can be scrolled in either axis
     * @method isScrollable
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */ function isScrollable(el) {
            var isScrollableY = hasScrollableSpace(el, "Y") && canOverflow(el, "Y");
            var isScrollableX = hasScrollableSpace(el, "X") && canOverflow(el, "X");
            return isScrollableY || isScrollableX;
        }
        /**
     * finds scrollable parent of an element
     * @method findScrollableParent
     * @param {Node} el
     * @returns {Node} el
     */ function findScrollableParent(el) {
            while(el !== d.body && isScrollable(el) === false)el = el.parentNode || el.host;
            return el;
        }
        /**
     * self invoked function that, given a context, steps through scrolling
     * @method step
     * @param {Object} context
     * @returns {undefined}
     */ function step(context) {
            var time = now();
            var value;
            var currentX;
            var currentY;
            var elapsed = (time - context.startTime) / SCROLL_TIME;
            // avoid elapsed times higher than one
            elapsed = elapsed > 1 ? 1 : elapsed;
            // apply easing to elapsed time
            value = ease(elapsed);
            currentX = context.startX + (context.x - context.startX) * value;
            currentY = context.startY + (context.y - context.startY) * value;
            context.method.call(context.scrollable, currentX, currentY);
            // scroll more if we have not reached our destination
            if (currentX !== context.x || currentY !== context.y) w.requestAnimationFrame(step.bind(w, context));
        }
        /**
     * scrolls window or element with a smooth behavior
     * @method smoothScroll
     * @param {Object|Node} el
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */ function smoothScroll(el, x, y) {
            var scrollable;
            var startX;
            var startY;
            var method;
            var startTime = now();
            // define scroll context
            if (el === d.body) {
                scrollable = w;
                startX = w.scrollX || w.pageXOffset;
                startY = w.scrollY || w.pageYOffset;
                method = original.scroll;
            } else {
                scrollable = el;
                startX = el.scrollLeft;
                startY = el.scrollTop;
                method = scrollElement;
            }
            // scroll looping over a frame
            step({
                scrollable: scrollable,
                method: method,
                startTime: startTime,
                startX: startX,
                startY: startY,
                x: x,
                y: y
            });
        }
        // ORIGINAL METHODS OVERRIDES
        // w.scroll and w.scrollTo
        w.scroll = w.scrollTo = function() {
            // avoid action when no arguments are passed
            if (arguments[0] === undefined) return;
            // avoid smooth behavior if not required
            if (shouldBailOut(arguments[0]) === true) {
                original.scroll.call(w, arguments[0].left !== undefined ? arguments[0].left : typeof arguments[0] !== "object" ? arguments[0] : w.scrollX || w.pageXOffset, // use top prop, second argument if present or fallback to scrollY
                arguments[0].top !== undefined ? arguments[0].top : arguments[1] !== undefined ? arguments[1] : w.scrollY || w.pageYOffset);
                return;
            }
            // LET THE SMOOTHNESS BEGIN!
            smoothScroll.call(w, d.body, arguments[0].left !== undefined ? ~~arguments[0].left : w.scrollX || w.pageXOffset, arguments[0].top !== undefined ? ~~arguments[0].top : w.scrollY || w.pageYOffset);
        };
        // w.scrollBy
        w.scrollBy = function() {
            // avoid action when no arguments are passed
            if (arguments[0] === undefined) return;
            // avoid smooth behavior if not required
            if (shouldBailOut(arguments[0])) {
                original.scrollBy.call(w, arguments[0].left !== undefined ? arguments[0].left : typeof arguments[0] !== "object" ? arguments[0] : 0, arguments[0].top !== undefined ? arguments[0].top : arguments[1] !== undefined ? arguments[1] : 0);
                return;
            }
            // LET THE SMOOTHNESS BEGIN!
            smoothScroll.call(w, d.body, ~~arguments[0].left + (w.scrollX || w.pageXOffset), ~~arguments[0].top + (w.scrollY || w.pageYOffset));
        };
        // Element.prototype.scroll and Element.prototype.scrollTo
        Element.prototype.scroll = Element.prototype.scrollTo = function() {
            // avoid action when no arguments are passed
            if (arguments[0] === undefined) return;
            // avoid smooth behavior if not required
            if (shouldBailOut(arguments[0]) === true) {
                // if one number is passed, throw error to match Firefox implementation
                if (typeof arguments[0] === "number" && arguments[1] === undefined) throw new SyntaxError("Value could not be converted");
                original.elementScroll.call(this, // use left prop, first number argument or fallback to scrollLeft
                arguments[0].left !== undefined ? ~~arguments[0].left : typeof arguments[0] !== "object" ? ~~arguments[0] : this.scrollLeft, // use top prop, second argument or fallback to scrollTop
                arguments[0].top !== undefined ? ~~arguments[0].top : arguments[1] !== undefined ? ~~arguments[1] : this.scrollTop);
                return;
            }
            var left = arguments[0].left;
            var top = arguments[0].top;
            // LET THE SMOOTHNESS BEGIN!
            smoothScroll.call(this, this, typeof left === "undefined" ? this.scrollLeft : ~~left, typeof top === "undefined" ? this.scrollTop : ~~top);
        };
        // Element.prototype.scrollBy
        Element.prototype.scrollBy = function() {
            // avoid action when no arguments are passed
            if (arguments[0] === undefined) return;
            // avoid smooth behavior if not required
            if (shouldBailOut(arguments[0]) === true) {
                original.elementScroll.call(this, arguments[0].left !== undefined ? ~~arguments[0].left + this.scrollLeft : ~~arguments[0] + this.scrollLeft, arguments[0].top !== undefined ? ~~arguments[0].top + this.scrollTop : ~~arguments[1] + this.scrollTop);
                return;
            }
            this.scroll({
                left: ~~arguments[0].left + this.scrollLeft,
                top: ~~arguments[0].top + this.scrollTop,
                behavior: arguments[0].behavior
            });
        };
        // Element.prototype.scrollIntoView
        Element.prototype.scrollIntoView = function() {
            // avoid smooth behavior if not required
            if (shouldBailOut(arguments[0]) === true) {
                original.scrollIntoView.call(this, arguments[0] === undefined ? true : arguments[0]);
                return;
            }
            // LET THE SMOOTHNESS BEGIN!
            var scrollableParent = findScrollableParent(this);
            var parentRects = scrollableParent.getBoundingClientRect();
            var clientRects = this.getBoundingClientRect();
            if (scrollableParent !== d.body) {
                // reveal element inside parent
                smoothScroll.call(this, scrollableParent, scrollableParent.scrollLeft + clientRects.left - parentRects.left, scrollableParent.scrollTop + clientRects.top - parentRects.top);
                // reveal parent in viewport unless is fixed
                if (w.getComputedStyle(scrollableParent).position !== "fixed") w.scrollBy({
                    left: parentRects.left,
                    top: parentRects.top,
                    behavior: "smooth"
                });
            } else // reveal element in viewport
            w.scrollBy({
                left: clientRects.left,
                top: clientRects.top,
                behavior: "smooth"
            });
        };
    }
    // commonjs
    $c55b064831e1f1a0$exports = {
        polyfill: polyfill
    };
})();


function $ace49589997d421f$var$_defineProperty(obj, key, value) {
    key = $ace49589997d421f$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ace49589997d421f$var$_toPropertyKey(arg) {
    var key = $ace49589997d421f$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $ace49589997d421f$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
class $ace49589997d421f$var$NavItem extends (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).Component {
    constructor(props){
        super(props);
        $ace49589997d421f$var$_defineProperty(this, "getElementPosition", (elPosition)=>{
            return 100 - 100 * (Math.max(Math.pow(Math.abs(elPosition - this.props.scrollY) / this.props.bodyHeight, .3), .2) * 1.1 - .2);
        });
        $ace49589997d421f$var$_defineProperty(this, "getPinWidth", (elPosition)=>{
            return this.getElementPosition(elPosition) + "%";
        });
        $ace49589997d421f$var$_defineProperty(this, "getPinOpacity", (elPosition)=>{
            return this.getElementPosition(elPosition) / 100;
        });
        $ace49589997d421f$var$_defineProperty(this, "handleClick", ()=>{
            if (this.props.navItemTitle) {
                this.props.onAnchorClick(true);
                (0, (/*@__PURE__*/$parcel$interopDefault($c55b064831e1f1a0$exports))).polyfill();
                window.scrollTo({
                    top: this.props.position[1],
                    left: 0,
                    behavior: "smooth"
                });
            }
        });
        $ace49589997d421f$var$_defineProperty(this, "handleAnchorHover", ()=>{
            if (this.props.navItemTitle) this.props.onAnchorHover(true);
        });
    }
    // this reenables the hover state on the nav so users dont have to hover way from the nav to click multiple links
    render() {
        const itemOpacity = this.props.navHover ? 1 : this.getPinOpacity(this.props.position[1]);
        let itemWidth = "50%";
        if (this.props.navHover) {
            if (this.props.navItemTitle !== undefined) itemWidth = "100%";
        } else itemWidth = this.getPinWidth(this.props.position[1]);
        // const transition = this.props.navHover ? "all .1s" : ""
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($40cdf530675eeeef$exports))).item, {
                [(0, (/*@__PURE__*/$parcel$interopDefault($40cdf530675eeeef$exports))).itemHasAnchor]: this.props.navItemTitle
            }),
            style: {
                width: itemWidth,
                top: `${this.props.position[0]}%`,
                opacity: itemOpacity
            },
            onClick: this.handleClick,
            onMouseEnter: this.handleAnchorHover
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($40cdf530675eeeef$exports))).inner)
        }, this.props.navItemTitle && !this.props.navHover && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($40cdf530675eeeef$exports))).wedge)
        }), this.props.navItemTitle && this.props.navHover && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($40cdf530675eeeef$exports))).internalLink),
            dangerouslySetInnerHTML: {
                __html: this.props.navItemTitle
            }
        })));
    }
}
var $ace49589997d421f$export$2e2bcd8739ae039 = $ace49589997d421f$var$NavItem;



var $g85JO = parcelRequire("g85JO");
var $cbb6d6db0f0e8031$exports = {};

!function(root, factory) {
    $cbb6d6db0f0e8031$exports = factory((parcelRequire("g85JO")));
}("undefined" != typeof self ? self : $cbb6d6db0f0e8031$exports, function(__WEBPACK_EXTERNAL_MODULE_6__) {
    return function(modules) {
        function __webpack_require__(moduleId) {
            if (installedModules[moduleId]) return installedModules[moduleId].exports;
            var module1 = installedModules[moduleId] = {
                i: moduleId,
                l: !1,
                exports: {}
            };
            return modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__), module1.l = !0, module1.exports;
        }
        var installedModules = {};
        return __webpack_require__.m = modules, __webpack_require__.c = installedModules, __webpack_require__.d = function(exports, name, getter) {
            __webpack_require__.o(exports, name) || Object.defineProperty(exports, name, {
                configurable: !1,
                enumerable: !0,
                get: getter
            });
        }, __webpack_require__.n = function(module1) {
            var getter = module1 && module1.__esModule ? function() {
                return module1.default;
            } : function() {
                return module1;
            };
            return __webpack_require__.d(getter, "a", getter), getter;
        }, __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        }, __webpack_require__.p = "", __webpack_require__(__webpack_require__.s = 5);
    }([
        function(module1, exports, __webpack_require__) {
            var ReactIs = __webpack_require__(1);
            module1.exports = __webpack_require__(8)(ReactIs.isElement, !0);
        },
        function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = __webpack_require__(7);
        },
        function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
        },
        function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            function toHyphenLower(match) {
                return "-" + match.toLowerCase();
            }
            function hyphenateStyleName(name) {
                if (cache.hasOwnProperty(name)) return cache[name];
                var hName = name.replace(uppercasePattern, toHyphenLower);
                return cache[name] = msPattern.test(hName) ? "-" + hName : hName;
            }
            var uppercasePattern = /[A-Z]/g, msPattern = /^ms-/, cache = {};
            __webpack_exports__.a = hyphenateStyleName;
        },
        function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            function _objectSpread(target) {
                for(var i = 1; i < arguments.length; i++){
                    var source = null != arguments[i] ? arguments[i] : {}, ownKeys = Object.keys(source);
                    "function" == typeof Object.getOwnPropertySymbols && (ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
                    }))), ownKeys.forEach(function(key) {
                        _defineProperty(target, key, source[key]);
                    });
                }
                return target;
            }
            function _defineProperty(obj, key, value) {
                return key in obj ? Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : obj[key] = value, obj;
            }
            var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(0), __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__), stringOrNumber = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([
                __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
                __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number
            ]), matchers = {
                orientation: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf([
                    "portrait",
                    "landscape"
                ]),
                scan: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf([
                    "progressive",
                    "interlace"
                ]),
                aspectRatio: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
                deviceAspectRatio: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
                height: stringOrNumber,
                deviceHeight: stringOrNumber,
                width: stringOrNumber,
                deviceWidth: stringOrNumber,
                color: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
                colorIndex: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
                monochrome: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
                resolution: stringOrNumber
            }, features = _objectSpread({
                minAspectRatio: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
                maxAspectRatio: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
                minDeviceAspectRatio: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
                maxDeviceAspectRatio: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
                minHeight: stringOrNumber,
                maxHeight: stringOrNumber,
                minDeviceHeight: stringOrNumber,
                maxDeviceHeight: stringOrNumber,
                minWidth: stringOrNumber,
                maxWidth: stringOrNumber,
                minDeviceWidth: stringOrNumber,
                maxDeviceWidth: stringOrNumber,
                minColor: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
                maxColor: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
                minColorIndex: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
                maxColorIndex: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
                minMonochrome: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
                maxMonochrome: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
                minResolution: stringOrNumber,
                maxResolution: stringOrNumber
            }, matchers), types = {
                all: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
                grid: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
                aural: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
                braille: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
                handheld: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
                print: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
                projection: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
                screen: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
                tty: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
                tv: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
                embossed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
            }, all = _objectSpread({}, types, features);
            matchers.type = Object.keys(types), __webpack_exports__.a = {
                all: all,
                types: types,
                matchers: matchers,
                features: features
            };
        },
        function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            function _typeof(obj) {
                return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                })(obj);
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _defineProperties(target, props) {
                for(var i = 0; i < props.length; i++){
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                return protoProps && _defineProperties(Constructor.prototype, protoProps), staticProps && _defineProperties(Constructor, staticProps), Constructor;
            }
            function _possibleConstructorReturn(self1, call) {
                return !call || "object" !== _typeof(call) && "function" != typeof call ? _assertThisInitialized(self1) : call;
            }
            function _getPrototypeOf(o) {
                return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                })(o);
            }
            function _assertThisInitialized(self1) {
                if (void 0 === self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return self1;
            }
            function _inherits(subClass, superClass) {
                if ("function" != typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function");
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: !0,
                        configurable: !0
                    }
                }), superClass && _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                return (_setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                    return o.__proto__ = p, o;
                })(o, p);
            }
            function _objectSpread(target) {
                for(var i = 1; i < arguments.length; i++){
                    var source = null != arguments[i] ? arguments[i] : {}, ownKeys = Object.keys(source);
                    "function" == typeof Object.getOwnPropertySymbols && (ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
                    }))), ownKeys.forEach(function(key) {
                        _defineProperty(target, key, source[key]);
                    });
                }
                return target;
            }
            function _defineProperty(obj, key, value) {
                return key in obj ? Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : obj[key] = value, obj;
            }
            Object.defineProperty(__webpack_exports__, "__esModule", {
                value: !0
            }), __webpack_require__.d(__webpack_exports__, "default", function() {
                return MediaQuery;
            });
            var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(6), __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__), __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(0), __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__), __WEBPACK_IMPORTED_MODULE_2_matchmediaquery__ = __webpack_require__(11), __WEBPACK_IMPORTED_MODULE_2_matchmediaquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_matchmediaquery__), __WEBPACK_IMPORTED_MODULE_3_hyphenate_style_name__ = __webpack_require__(3), __WEBPACK_IMPORTED_MODULE_4__mediaQuery__ = __webpack_require__(4), __WEBPACK_IMPORTED_MODULE_5__toQuery__ = __webpack_require__(13);
            __webpack_require__.d(__webpack_exports__, "toQuery", function() {
                return __WEBPACK_IMPORTED_MODULE_5__toQuery__.a;
            });
            var defaultTypes = {
                component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
                query: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
                values: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_4__mediaQuery__.a.matchers),
                children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([
                    __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
                    __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
                ]),
                onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
            }, excludedQueryKeys = Object.keys(defaultTypes), omit = function(object, keys) {
                var newObject = _objectSpread({}, object);
                return keys.forEach(function(key) {
                    return delete newObject[key];
                }), newObject;
            }, getValues = function(_ref) {
                var values = _ref.values;
                if (!values) return null;
                var keys = Object.keys(values);
                return 0 === keys.length ? null : keys.reduce(function(result, key) {
                    return result[Object(__WEBPACK_IMPORTED_MODULE_3_hyphenate_style_name__.a)(key)] = values[key], result;
                }, {});
            }, getQuery = function(props) {
                return props.query || Object(__WEBPACK_IMPORTED_MODULE_5__toQuery__.a)(omit(props, excludedQueryKeys));
            }, MediaQuery = function(_React$Component) {
                function MediaQuery() {
                    var _getPrototypeOf2, _this;
                    _classCallCheck(this, MediaQuery);
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    return _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(MediaQuery)).call.apply(_getPrototypeOf2, [
                        this
                    ].concat(args))), _defineProperty(_assertThisInitialized(_this), "state", {
                        matches: !1,
                        mq: null,
                        query: "",
                        values: null
                    }), _defineProperty(_assertThisInitialized(_this), "componentDidMount", function() {
                        _this.state.mq.addListener(_this.updateMatches), _this.updateMatches();
                    }), _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function(prevProps, prevState) {
                        _this.state.mq !== prevState.mq && (_this.cleanupMediaQuery(prevState.mq), _this.state.mq.addListener(_this.updateMatches)), _this.props.onChange && prevState.matches !== _this.state.matches && _this.props.onChange(_this.state.matches);
                    }), _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function() {
                        _this._unmounted = !0, _this.cleanupMediaQuery(_this.state.mq);
                    }), _defineProperty(_assertThisInitialized(_this), "cleanupMediaQuery", function(mq) {
                        mq && (mq.removeListener(_this.updateMatches), mq.dispose());
                    }), _defineProperty(_assertThisInitialized(_this), "updateMatches", function() {
                        _this._unmounted || _this.state.mq.matches !== _this.state.matches && _this.setState({
                            matches: _this.state.mq.matches
                        });
                    }), _defineProperty(_assertThisInitialized(_this), "render", function() {
                        return "function" == typeof _this.props.children ? _this.props.children(_this.state.matches) : _this.state.matches ? _this.props.children : null;
                    }), _this;
                }
                return _inherits(MediaQuery, _React$Component), _createClass(MediaQuery, null, [
                    {
                        key: "getDerivedStateFromProps",
                        value: function(props, state) {
                            var query = getQuery(props);
                            if (!query) throw new Error("Invalid or missing MediaQuery!");
                            var values = getValues(props);
                            if (query === state.query && values === state.values) return null;
                            var mq = __WEBPACK_IMPORTED_MODULE_2_matchmediaquery___default()(query, values || {}, !!values);
                            return {
                                matches: mq.matches,
                                mq: mq,
                                query: query,
                                values: values
                            };
                        }
                    }
                ]), MediaQuery;
            }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);
            _defineProperty(MediaQuery, "displayName", "MediaQuery"), _defineProperty(MediaQuery, "defaultProps", {
                values: null
            });
        },
        function(module1, exports) {
            module1.exports = __WEBPACK_EXTERNAL_MODULE_6__;
        },
        function(module1, exports, __webpack_require__) {
            "use strict";
            !function() {
                function isValidElementType(type) {
                    return "string" == typeof type || "function" == typeof type || type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || "object" == typeof type && null !== type && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE);
                }
                function typeOf(object) {
                    if ("object" == typeof object && null !== object) {
                        var $$typeof = object.$$typeof;
                        switch($$typeof){
                            case REACT_ELEMENT_TYPE:
                                var type = object.type;
                                switch(type){
                                    case REACT_ASYNC_MODE_TYPE:
                                    case REACT_CONCURRENT_MODE_TYPE:
                                    case REACT_FRAGMENT_TYPE:
                                    case REACT_PROFILER_TYPE:
                                    case REACT_STRICT_MODE_TYPE:
                                    case REACT_SUSPENSE_TYPE:
                                        return type;
                                    default:
                                        var $$typeofType = type && type.$$typeof;
                                        switch($$typeofType){
                                            case REACT_CONTEXT_TYPE:
                                            case REACT_FORWARD_REF_TYPE:
                                            case REACT_PROVIDER_TYPE:
                                                return $$typeofType;
                                            default:
                                                return $$typeof;
                                        }
                                }
                            case REACT_LAZY_TYPE:
                            case REACT_MEMO_TYPE:
                            case REACT_PORTAL_TYPE:
                                return $$typeof;
                        }
                    }
                }
                function isAsyncMode(object) {
                    return hasWarnedAboutDeprecatedIsAsyncMode || (hasWarnedAboutDeprecatedIsAsyncMode = !0, lowPriorityWarning$1(!1, "The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
                }
                function isConcurrentMode(object) {
                    return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
                }
                function isContextConsumer(object) {
                    return typeOf(object) === REACT_CONTEXT_TYPE;
                }
                function isContextProvider(object) {
                    return typeOf(object) === REACT_PROVIDER_TYPE;
                }
                function isElement(object) {
                    return "object" == typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
                }
                function isForwardRef(object) {
                    return typeOf(object) === REACT_FORWARD_REF_TYPE;
                }
                function isFragment(object) {
                    return typeOf(object) === REACT_FRAGMENT_TYPE;
                }
                function isLazy(object) {
                    return typeOf(object) === REACT_LAZY_TYPE;
                }
                function isMemo(object) {
                    return typeOf(object) === REACT_MEMO_TYPE;
                }
                function isPortal(object) {
                    return typeOf(object) === REACT_PORTAL_TYPE;
                }
                function isProfiler(object) {
                    return typeOf(object) === REACT_PROFILER_TYPE;
                }
                function isStrictMode(object) {
                    return typeOf(object) === REACT_STRICT_MODE_TYPE;
                }
                function isSuspense(object) {
                    return typeOf(object) === REACT_SUSPENSE_TYPE;
                }
                Object.defineProperty(exports, "__esModule", {
                    value: !0
                });
                var hasSymbol = "function" == typeof Symbol && Symbol.for, REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 60103, REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106, REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107, REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108, REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114, REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109, REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110, REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111, REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111, REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112, REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113, REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115, REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116, lowPriorityWarning = function() {}, printWarning = function(format) {
                    for(var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                    var argIndex = 0, message = "Warning: " + format.replace(/%s/g, function() {
                        return args[argIndex++];
                    });
                    "undefined" != typeof console && console.warn(message);
                    try {
                        throw new Error(message);
                    } catch (x) {}
                };
                lowPriorityWarning = function(condition, format) {
                    if (void 0 === format) throw new Error("`lowPriorityWarning(condition, format, ...args)` requires a warning message argument");
                    if (!condition) {
                        for(var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++)args[_key2 - 2] = arguments[_key2];
                        printWarning.apply(void 0, [
                            format
                        ].concat(args));
                    }
                };
                var lowPriorityWarning$1 = lowPriorityWarning, AsyncMode = REACT_ASYNC_MODE_TYPE, ConcurrentMode = REACT_CONCURRENT_MODE_TYPE, ContextConsumer = REACT_CONTEXT_TYPE, ContextProvider = REACT_PROVIDER_TYPE, Element = REACT_ELEMENT_TYPE, ForwardRef = REACT_FORWARD_REF_TYPE, Fragment = REACT_FRAGMENT_TYPE, Lazy = REACT_LAZY_TYPE, Memo = REACT_MEMO_TYPE, Portal = REACT_PORTAL_TYPE, Profiler = REACT_PROFILER_TYPE, StrictMode = REACT_STRICT_MODE_TYPE, Suspense = REACT_SUSPENSE_TYPE, hasWarnedAboutDeprecatedIsAsyncMode = !1;
                exports.typeOf = typeOf, exports.AsyncMode = AsyncMode, exports.ConcurrentMode = ConcurrentMode, exports.ContextConsumer = ContextConsumer, exports.ContextProvider = ContextProvider, exports.Element = Element, exports.ForwardRef = ForwardRef, exports.Fragment = Fragment, exports.Lazy = Lazy, exports.Memo = Memo, exports.Portal = Portal, exports.Profiler = Profiler, exports.StrictMode = StrictMode, exports.Suspense = Suspense, exports.isValidElementType = isValidElementType, exports.isAsyncMode = isAsyncMode, exports.isConcurrentMode = isConcurrentMode, exports.isContextConsumer = isContextConsumer, exports.isContextProvider = isContextProvider, exports.isElement = isElement, exports.isForwardRef = isForwardRef, exports.isFragment = isFragment, exports.isLazy = isLazy, exports.isMemo = isMemo, exports.isPortal = isPortal, exports.isProfiler = isProfiler, exports.isStrictMode = isStrictMode, exports.isSuspense = isSuspense;
            }();
        },
        function(module1, exports, __webpack_require__) {
            "use strict";
            function emptyFunctionThatReturnsNull() {
                return null;
            }
            var ReactIs = __webpack_require__(1), assign = __webpack_require__(9), ReactPropTypesSecret = __webpack_require__(2), checkPropTypes = __webpack_require__(10), has = Function.call.bind(Object.prototype.hasOwnProperty), printWarning = function() {};
            printWarning = function(text) {
                var message = "Warning: " + text;
                "undefined" != typeof console && console.error(message);
                try {
                    throw new Error(message);
                } catch (x) {}
            }, module1.exports = function(isValidElement, throwOnDirectAccess) {
                function getIteratorFn(maybeIterable) {
                    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
                    if ("function" == typeof iteratorFn) return iteratorFn;
                }
                function is(x, y) {
                    return x === y ? 0 !== x || 1 / x == 1 / y : x !== x && y !== y;
                }
                function PropTypeError(message) {
                    this.message = message, this.stack = "";
                }
                function createChainableTypeChecker(validate) {
                    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
                        if (componentName = componentName || ANONYMOUS, propFullName = propFullName || propName, secret !== ReactPropTypesSecret) {
                            if (throwOnDirectAccess) {
                                var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
                                throw err.name = "Invariant Violation", err;
                            }
                            if ("undefined" != typeof console) {
                                var cacheKey = componentName + ":" + propName;
                                !manualPropTypeCallCache[cacheKey] && manualPropTypeWarningCount < 3 && (printWarning("You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), manualPropTypeCallCache[cacheKey] = !0, manualPropTypeWarningCount++);
                            }
                        }
                        return null == props[propName] ? isRequired ? new PropTypeError(null === props[propName] ? "The " + location + " `" + propFullName + "` is marked as required in `" + componentName + "`, but its value is `null`." : "The " + location + " `" + propFullName + "` is marked as required in `" + componentName + "`, but its value is `undefined`.") : null : validate(props, propName, componentName, location, propFullName);
                    }
                    var manualPropTypeCallCache = {}, manualPropTypeWarningCount = 0, chainedCheckType = checkType.bind(null, !1);
                    return chainedCheckType.isRequired = checkType.bind(null, !0), chainedCheckType;
                }
                function createPrimitiveTypeChecker(expectedType) {
                    function validate(props, propName, componentName, location, propFullName, secret) {
                        var propValue = props[propName];
                        if (getPropType(propValue) !== expectedType) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getPreciseType(propValue) + "` supplied to `" + componentName + "`, expected `" + expectedType + "`.");
                        return null;
                    }
                    return createChainableTypeChecker(validate);
                }
                function createArrayOfTypeChecker(typeChecker) {
                    function validate(props, propName, componentName, location, propFullName) {
                        if ("function" != typeof typeChecker) return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
                        var propValue = props[propName];
                        if (!Array.isArray(propValue)) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getPropType(propValue) + "` supplied to `" + componentName + "`, expected an array.");
                        for(var i = 0; i < propValue.length; i++){
                            var error = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", ReactPropTypesSecret);
                            if (error instanceof Error) return error;
                        }
                        return null;
                    }
                    return createChainableTypeChecker(validate);
                }
                function createInstanceTypeChecker(expectedClass) {
                    function validate(props, propName, componentName, location, propFullName) {
                        if (!(props[propName] instanceof expectedClass)) {
                            var expectedClassName = expectedClass.name || ANONYMOUS;
                            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getClassName(props[propName]) + "` supplied to `" + componentName + "`, expected instance of `" + expectedClassName + "`.");
                        }
                        return null;
                    }
                    return createChainableTypeChecker(validate);
                }
                function createEnumTypeChecker(expectedValues) {
                    function validate(props, propName, componentName, location, propFullName) {
                        for(var propValue = props[propName], i = 0; i < expectedValues.length; i++)if (is(propValue, expectedValues[i])) return null;
                        var valuesString = JSON.stringify(expectedValues, function(key, value) {
                            return "symbol" === getPreciseType(value) ? String(value) : value;
                        });
                        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` supplied to `" + componentName + "`, expected one of " + valuesString + ".");
                    }
                    return Array.isArray(expectedValues) ? createChainableTypeChecker(validate) : (printWarning(arguments.length > 1 ? "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])." : "Invalid argument supplied to oneOf, expected an array."), emptyFunctionThatReturnsNull);
                }
                function createObjectOfTypeChecker(typeChecker) {
                    function validate(props, propName, componentName, location, propFullName) {
                        if ("function" != typeof typeChecker) return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
                        var propValue = props[propName], propType = getPropType(propValue);
                        if ("object" !== propType) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` supplied to `" + componentName + "`, expected an object.");
                        for(var key in propValue)if (has(propValue, key)) {
                            var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
                            if (error instanceof Error) return error;
                        }
                        return null;
                    }
                    return createChainableTypeChecker(validate);
                }
                function createUnionTypeChecker(arrayOfTypeCheckers) {
                    function validate(props, propName, componentName, location, propFullName) {
                        for(var i = 0; i < arrayOfTypeCheckers.length; i++){
                            if (null == (0, arrayOfTypeCheckers[i])(props, propName, componentName, location, propFullName, ReactPropTypesSecret)) return null;
                        }
                        return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to `" + componentName + "`.");
                    }
                    if (!Array.isArray(arrayOfTypeCheckers)) return printWarning("Invalid argument supplied to oneOfType, expected an instance of array."), emptyFunctionThatReturnsNull;
                    for(var i = 0; i < arrayOfTypeCheckers.length; i++){
                        var checker = arrayOfTypeCheckers[i];
                        if ("function" != typeof checker) return printWarning("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + "."), emptyFunctionThatReturnsNull;
                    }
                    return createChainableTypeChecker(validate);
                }
                function createShapeTypeChecker(shapeTypes) {
                    function validate(props, propName, componentName, location, propFullName) {
                        var propValue = props[propName], propType = getPropType(propValue);
                        if ("object" !== propType) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` supplied to `" + componentName + "`, expected `object`.");
                        for(var key in shapeTypes){
                            var checker = shapeTypes[key];
                            if (checker) {
                                var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
                                if (error) return error;
                            }
                        }
                        return null;
                    }
                    return createChainableTypeChecker(validate);
                }
                function createStrictShapeTypeChecker(shapeTypes) {
                    function validate(props, propName, componentName, location, propFullName) {
                        var propValue = props[propName], propType = getPropType(propValue);
                        if ("object" !== propType) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` supplied to `" + componentName + "`, expected `object`.");
                        var allKeys = assign({}, props[propName], shapeTypes);
                        for(var key in allKeys){
                            var checker = shapeTypes[key];
                            if (!checker) return new PropTypeError("Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  "));
                            var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
                            if (error) return error;
                        }
                        return null;
                    }
                    return createChainableTypeChecker(validate);
                }
                function isNode(propValue) {
                    switch(typeof propValue){
                        case "number":
                        case "string":
                        case "undefined":
                            return !0;
                        case "boolean":
                            return !propValue;
                        case "object":
                            if (Array.isArray(propValue)) return propValue.every(isNode);
                            if (null === propValue || isValidElement(propValue)) return !0;
                            var iteratorFn = getIteratorFn(propValue);
                            if (!iteratorFn) return !1;
                            var step, iterator = iteratorFn.call(propValue);
                            if (iteratorFn !== propValue.entries) {
                                for(; !(step = iterator.next()).done;)if (!isNode(step.value)) return !1;
                            } else for(; !(step = iterator.next()).done;){
                                var entry = step.value;
                                if (entry && !isNode(entry[1])) return !1;
                            }
                            return !0;
                        default:
                            return !1;
                    }
                }
                function isSymbol(propType, propValue) {
                    return "symbol" === propType || !!propValue && ("Symbol" === propValue["@@toStringTag"] || "function" == typeof Symbol && propValue instanceof Symbol);
                }
                function getPropType(propValue) {
                    var propType = typeof propValue;
                    return Array.isArray(propValue) ? "array" : propValue instanceof RegExp ? "object" : isSymbol(propType, propValue) ? "symbol" : propType;
                }
                function getPreciseType(propValue) {
                    if (void 0 === propValue || null === propValue) return "" + propValue;
                    var propType = getPropType(propValue);
                    if ("object" === propType) {
                        if (propValue instanceof Date) return "date";
                        if (propValue instanceof RegExp) return "regexp";
                    }
                    return propType;
                }
                function getPostfixForTypeWarning(value) {
                    var type = getPreciseType(value);
                    switch(type){
                        case "array":
                        case "object":
                            return "an " + type;
                        case "boolean":
                        case "date":
                        case "regexp":
                            return "a " + type;
                        default:
                            return type;
                    }
                }
                function getClassName(propValue) {
                    return propValue.constructor && propValue.constructor.name ? propValue.constructor.name : ANONYMOUS;
                }
                var ITERATOR_SYMBOL = "function" == typeof Symbol && Symbol.iterator, FAUX_ITERATOR_SYMBOL = "@@iterator", ANONYMOUS = "<<anonymous>>", ReactPropTypes = {
                    array: createPrimitiveTypeChecker("array"),
                    bool: createPrimitiveTypeChecker("boolean"),
                    func: createPrimitiveTypeChecker("function"),
                    number: createPrimitiveTypeChecker("number"),
                    object: createPrimitiveTypeChecker("object"),
                    string: createPrimitiveTypeChecker("string"),
                    symbol: createPrimitiveTypeChecker("symbol"),
                    any: function() {
                        return createChainableTypeChecker(emptyFunctionThatReturnsNull);
                    }(),
                    arrayOf: createArrayOfTypeChecker,
                    element: function() {
                        function validate(props, propName, componentName, location, propFullName) {
                            var propValue = props[propName];
                            if (!isValidElement(propValue)) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getPropType(propValue) + "` supplied to `" + componentName + "`, expected a single ReactElement.");
                            return null;
                        }
                        return createChainableTypeChecker(validate);
                    }(),
                    elementType: function() {
                        function validate(props, propName, componentName, location, propFullName) {
                            var propValue = props[propName];
                            if (!ReactIs.isValidElementType(propValue)) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getPropType(propValue) + "` supplied to `" + componentName + "`, expected a single ReactElement type.");
                            return null;
                        }
                        return createChainableTypeChecker(validate);
                    }(),
                    instanceOf: createInstanceTypeChecker,
                    node: function() {
                        function validate(props, propName, componentName, location, propFullName) {
                            return isNode(props[propName]) ? null : new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to `" + componentName + "`, expected a ReactNode.");
                        }
                        return createChainableTypeChecker(validate);
                    }(),
                    objectOf: createObjectOfTypeChecker,
                    oneOf: createEnumTypeChecker,
                    oneOfType: createUnionTypeChecker,
                    shape: createShapeTypeChecker,
                    exact: createStrictShapeTypeChecker
                };
                return PropTypeError.prototype = Error.prototype, ReactPropTypes.checkPropTypes = checkPropTypes, ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache, ReactPropTypes.PropTypes = ReactPropTypes, ReactPropTypes;
            };
        },
        function(module1, exports, __webpack_require__) {
            "use strict";
            function toObject(val) {
                if (null === val || void 0 === val) throw new TypeError("Object.assign cannot be called with null or undefined");
                return Object(val);
            }
            /*
object-assign
(c) Sindre Sorhus
@license MIT
*/ var getOwnPropertySymbols = Object.getOwnPropertySymbols, hasOwnProperty = Object.prototype.hasOwnProperty, propIsEnumerable = Object.prototype.propertyIsEnumerable;
            module1.exports = function() {
                try {
                    if (!Object.assign) return !1;
                    var test1 = new String("abc");
                    if (test1[5] = "de", "5" === Object.getOwnPropertyNames(test1)[0]) return !1;
                    for(var test2 = {}, i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
                    if ("0123456789" !== Object.getOwnPropertyNames(test2).map(function(n) {
                        return test2[n];
                    }).join("")) return !1;
                    var test3 = {};
                    return "abcdefghijklmnopqrst".split("").forEach(function(letter) {
                        test3[letter] = letter;
                    }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, test3)).join("");
                } catch (err) {
                    return !1;
                }
            }() ? Object.assign : function(target, source) {
                for(var from, symbols, to = toObject(target), s = 1; s < arguments.length; s++){
                    from = Object(arguments[s]);
                    for(var key in from)hasOwnProperty.call(from, key) && (to[key] = from[key]);
                    if (getOwnPropertySymbols) {
                        symbols = getOwnPropertySymbols(from);
                        for(var i = 0; i < symbols.length; i++)propIsEnumerable.call(from, symbols[i]) && (to[symbols[i]] = from[symbols[i]]);
                    }
                }
                return to;
            };
        },
        function(module1, exports, __webpack_require__) {
            "use strict";
            function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
                for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
                    var error;
                    try {
                        if ("function" != typeof typeSpecs[typeSpecName]) {
                            var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.");
                            throw err.name = "Invariant Violation", err;
                        }
                        error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
                    } catch (ex) {
                        error = ex;
                    }
                    if (!error || error instanceof Error || printWarning((componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), error instanceof Error && !(error.message in loggedTypeFailures)) {
                        loggedTypeFailures[error.message] = !0;
                        var stack = getStack ? getStack() : "";
                        printWarning("Failed " + location + " type: " + error.message + (null != stack ? stack : ""));
                    }
                }
            }
            var printWarning = function() {}, ReactPropTypesSecret = __webpack_require__(2), loggedTypeFailures = {}, has = Function.call.bind(Object.prototype.hasOwnProperty);
            printWarning = function(text) {
                var message = "Warning: " + text;
                "undefined" != typeof console && console.error(message);
                try {
                    throw new Error(message);
                } catch (x) {}
            }, checkPropTypes.resetWarningCache = function() {
                loggedTypeFailures = {};
            }, module1.exports = checkPropTypes;
        },
        function(module1, exports, __webpack_require__) {
            "use strict";
            function Mql(query, values, forceStatic) {
                function addListener(listener) {
                    mql && mql.addListener(listener);
                }
                function removeListener(listener) {
                    mql && mql.removeListener(listener);
                }
                function update(evt) {
                    self1.matches = evt.matches, self1.media = evt.media;
                }
                function dispose() {
                    mql && mql.removeListener(update);
                }
                var self1 = this;
                if (dynamicMatch && !forceStatic) {
                    var mql = dynamicMatch.call(window, query);
                    this.matches = mql.matches, this.media = mql.media, mql.addListener(update);
                } else this.matches = staticMatch(query, values), this.media = query;
                this.addListener = addListener, this.removeListener = removeListener, this.dispose = dispose;
            }
            function matchMedia(query, values, forceStatic) {
                return new Mql(query, values, forceStatic);
            }
            var staticMatch = __webpack_require__(12).match, dynamicMatch = "undefined" != typeof window ? window.matchMedia : null;
            module1.exports = matchMedia;
        },
        function(module1, exports, __webpack_require__) {
            "use strict";
            function matchQuery(mediaQuery, values) {
                return parseQuery(mediaQuery).some(function(query) {
                    var inverse = query.inverse, typeMatch = "all" === query.type || values.type === query.type;
                    if (typeMatch && inverse || !typeMatch && !inverse) return !1;
                    var expressionsMatch = query.expressions.every(function(expression) {
                        var feature = expression.feature, modifier = expression.modifier, expValue = expression.value, value = values[feature];
                        if (!value) return !1;
                        switch(feature){
                            case "orientation":
                            case "scan":
                                return value.toLowerCase() === expValue.toLowerCase();
                            case "width":
                            case "height":
                            case "device-width":
                            case "device-height":
                                expValue = toPx(expValue), value = toPx(value);
                                break;
                            case "resolution":
                                expValue = toDpi(expValue), value = toDpi(value);
                                break;
                            case "aspect-ratio":
                            case "device-aspect-ratio":
                            case "device-pixel-ratio":
                                expValue = toDecimal(expValue), value = toDecimal(value);
                                break;
                            case "grid":
                            case "color":
                            case "color-index":
                            case "monochrome":
                                expValue = parseInt(expValue, 10) || 1, value = parseInt(value, 10) || 0;
                        }
                        switch(modifier){
                            case "min":
                                return value >= expValue;
                            case "max":
                                return value <= expValue;
                            default:
                                return value === expValue;
                        }
                    });
                    return expressionsMatch && !inverse || !expressionsMatch && inverse;
                });
            }
            function parseQuery(mediaQuery) {
                return mediaQuery.split(",").map(function(query) {
                    query = query.trim();
                    var captures = query.match(RE_MEDIA_QUERY), modifier = captures[1], type = captures[2], expressions = captures[3] || "", parsed = {};
                    return parsed.inverse = !!modifier && "not" === modifier.toLowerCase(), parsed.type = type ? type.toLowerCase() : "all", expressions = expressions.match(/\([^\)]+\)/g) || [], parsed.expressions = expressions.map(function(expression) {
                        var captures = expression.match(RE_MQ_EXPRESSION), feature = captures[1].toLowerCase().match(RE_MQ_FEATURE);
                        return {
                            modifier: feature[1],
                            feature: feature[2],
                            value: captures[2]
                        };
                    }), parsed;
                });
            }
            function toDecimal(ratio) {
                var numbers, decimal = Number(ratio);
                return decimal || (numbers = ratio.match(/^(\d+)\s*\/\s*(\d+)$/), decimal = numbers[1] / numbers[2]), decimal;
            }
            function toDpi(resolution) {
                var value = parseFloat(resolution);
                switch(String(resolution).match(RE_RESOLUTION_UNIT)[1]){
                    case "dpcm":
                        return value / 2.54;
                    case "dppx":
                        return 96 * value;
                    default:
                        return value;
                }
            }
            function toPx(length) {
                var value = parseFloat(length);
                switch(String(length).match(RE_LENGTH_UNIT)[1]){
                    case "em":
                    case "rem":
                        return 16 * value;
                    case "cm":
                        return 96 * value / 2.54;
                    case "mm":
                        return 96 * value / 2.54 / 10;
                    case "in":
                        return 96 * value;
                    case "pt":
                        return 72 * value;
                    case "pc":
                        return 72 * value / 12;
                    default:
                        return value;
                }
            }
            exports.match = matchQuery, exports.parse = parseQuery;
            var RE_MEDIA_QUERY = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i, RE_MQ_EXPRESSION = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/, RE_MQ_FEATURE = /^(?:(min|max)-)?(.+)/, RE_LENGTH_UNIT = /(em|rem|px|cm|mm|in|pt|pc)?$/, RE_RESOLUTION_UNIT = /(dpi|dpcm|dppx)?$/;
        },
        function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            function keyVal(k, v) {
                var realKey = Object(__WEBPACK_IMPORTED_MODULE_0_hyphenate_style_name__.a)(k);
                return "number" == typeof v && (v = "".concat(v, "px")), !0 === v ? k : !1 === v ? negate(k) : "(".concat(realKey, ": ").concat(v, ")");
            }
            function join(conds) {
                return conds.join(" and ");
            }
            var __WEBPACK_IMPORTED_MODULE_0_hyphenate_style_name__ = __webpack_require__(3), __WEBPACK_IMPORTED_MODULE_1__mediaQuery__ = __webpack_require__(4), negate = function(cond) {
                return "not ".concat(cond);
            };
            __webpack_exports__.a = function(obj) {
                var rules = [];
                return Object.keys(__WEBPACK_IMPORTED_MODULE_1__mediaQuery__.a.all).forEach(function(k) {
                    var v = obj[k];
                    null != v && rules.push(keyVal(k, v));
                }), join(rules);
            };
        }
    ]);
});


// these should be the same as the breakpoints defined at the bottom of mq.scss
const $9fbae048b55737ab$var$breakpoints = {
    desktop: 980,
    mobile: 320,
    mobileWide: 375,
    tablet: 740,
    desktop: 980,
    desktopWide: 1327,
    wide: 1300
};
const $9fbae048b55737ab$export$eb8deef317734844 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cbb6d6db0f0e8031$exports))), {
        ...props,
        minWidth: $9fbae048b55737ab$var$breakpoints.desktop
    });
const $9fbae048b55737ab$export$4d8a2dd92b1567c6 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cbb6d6db0f0e8031$exports))), {
        ...props,
        maxWidth: $9fbae048b55737ab$var$breakpoints.desktop - 1
    });
function $9fbae048b55737ab$export$1e4fed98bcaa1d82() {
    return window.innerWidth >= $9fbae048b55737ab$var$breakpoints["desktop"] && !$9fbae048b55737ab$export$d53806e03704a04e();
}
function $9fbae048b55737ab$export$6949f3324c4ace45(pageResolution) {
    const resolution = pageResolution ? pageResolution : window.innerWidth * window.innerHeight * window.devicePixelRatio;
    return pageResolution > 2500000;
}
function $9fbae048b55737ab$export$1394ee8a29384176() {
    return window.innerWidth >= $9fbae048b55737ab$var$breakpoints["desktop"] && $9fbae048b55737ab$export$d53806e03704a04e() && (window.orientation == 90 || window.orientation == -90);
}
function $9fbae048b55737ab$export$d0a8044dce8ff2fc() {
    return window.innerWidth < $9fbae048b55737ab$var$breakpoints["tablet"];
}
function $9fbae048b55737ab$export$b7d78993b74f766d() {
    return navigator.userAgent.toLowerCase().indexOf("firefox/") > -1 || $9fbae048b55737ab$export$67694733dc949122();
}
function $9fbae048b55737ab$export$67694733dc949122() {
    return navigator.userAgent.toLowerCase().indexOf("fxios/") > -1;
}
function $9fbae048b55737ab$export$d53806e03704a04e() {
    return $9fbae048b55737ab$export$fedb369cb70207f1() || $9fbae048b55737ab$export$a11b0059900ceec8() || $9fbae048b55737ab$export$e85df9795541c6f6();
}
function $9fbae048b55737ab$export$fedb369cb70207f1() {
    return /iPhone|iPad|iPod/i.test(navigator.userAgent);
}
function $9fbae048b55737ab$export$a11b0059900ceec8() {
    return /Android/i.test(navigator.userAgent);
}
function $9fbae048b55737ab$export$e85df9795541c6f6() {
    return navigator.userAgent.toLowerCase().indexOf("windows nt") != -1 && navigator.userAgent.toLowerCase().indexOf("touch") != -1;
}
function $9fbae048b55737ab$export$deb94605e54cb29e() {
    var isIeTest = false;
    var ua = navigator.userAgent;
    var re;
    if (navigator.appName == "Microsoft Internet Explorer") {
        re = new RegExp("MSIE ([0-9]{1,}[.0-9]{0,})");
        if (re.exec(ua) !== null) isIeTest = parseFloat(RegExp.$1);
    } else if (navigator.appName == "Netscape") {
        re = new RegExp("Trident/.*rv:([0-9]{1,}[.0-9]{0,})");
        if (re.exec(ua) !== null) isIeTest = parseFloat(RegExp.$1);
    }
    return isIeTest;
}
function $9fbae048b55737ab$export$cac3980734d91fbe() {
    return navigator.userAgent.toLowerCase().indexOf("edge/") > -1;
}
function $9fbae048b55737ab$export$a5fd75a9a0b4828d() {
    return $9fbae048b55737ab$export$deb94605e54cb29e() || $9fbae048b55737ab$export$cac3980734d91fbe();
}
function $9fbae048b55737ab$export$6d66bc094862134e() {
    return window.innerHeight < 501;
}
function $9fbae048b55737ab$export$7dfc72912e304fa(className) {
    document.documentElement.classList.add(className);
}
function $9fbae048b55737ab$export$a91250bfbb641554(className) {
    document.documentElement.classList.remove(className);
}
function $9fbae048b55737ab$export$a541a6e0388c2a55(className) {
    if ($9fbae048b55737ab$export$1394ee8a29384176()) {
        $9fbae048b55737ab$export$7dfc72912e304fa("tablet");
        $9fbae048b55737ab$export$7dfc72912e304fa("landscape");
    } else {
        $9fbae048b55737ab$export$a91250bfbb641554("tablet");
        $9fbae048b55737ab$export$a91250bfbb641554("landscape");
    }
    if ($9fbae048b55737ab$export$d53806e03704a04e()) $9fbae048b55737ab$export$7dfc72912e304fa("mobileOS");
    else $9fbae048b55737ab$export$a91250bfbb641554("mobileOS");
    if ($9fbae048b55737ab$export$6d66bc094862134e()) $9fbae048b55737ab$export$7dfc72912e304fa("short");
    else $9fbae048b55737ab$export$a91250bfbb641554("short");
    if ($9fbae048b55737ab$export$b7d78993b74f766d()) $9fbae048b55737ab$export$7dfc72912e304fa("firefox");
    else $9fbae048b55737ab$export$a91250bfbb641554("firefox");
}


class $f61de4c2c891d740$var$Nav extends (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).Component {
    constructor(props){
        super(props);
        this.state = {
            scrollY: 0,
            scrollBarRate: 0,
            bodyHeight: 1,
            elPositions: [],
            navHover: false,
            anchorClicked: false,
            viewportHeight: 1
        };
        this.UpdateNav = this.UpdateNav.bind(this);
        this.UpdateElementPositions = this.UpdateElementPositions.bind(this);
        this.handleAnchorClick = this.handleAnchorClick.bind(this);
        this.handleAnchorHover = this.handleAnchorHover.bind(this);
    }
    componentWillMount() {
        this.UpdateElementPositions();
    }
    componentDidMount() {
        this.UpdateNav();
        TweenMax.fromTo(this._el, 1, {
            x: 80
        }, {
            x: 0,
            delay: 0
        });
        TweenMax.fromTo(this._el, 1, {
            opacity: 0
        }, {
            opacity: 1,
            delay: 0
        });
        document.addEventListener("scroll", this.UpdateNav);
        window.addEventListener("hashchange", this.UpdateNav);
        document.addEventListener("click", this.UpdateNav);
        window.addEventListener("resize", this.UpdateElementPositions);
    }
    UpdateNav() {
        let viewportHeight = window.innerHeight; //A
        let bodyElement = document.querySelector("body"); //B1
        let rect = bodyElement.getBoundingClientRect(); //B2
        let bodyHeight = rect.height; //B3
        let scrollMax = Math.ceil(bodyHeight - viewportHeight); //C = B3 - A
        let scrollY = document.documentElement.scrollTop || document.body.scrollTop; //D
        // let scrollRate = parseInt( (scrollY / scrollMax) * 100, 10 ); //E = (D / C) *100
        this.setState({
            scrollY: scrollY,
            bodyHeight: // scrollBarRate: scrollRate,
            bodyHeight,
            viewportHeight: viewportHeight
        });
    }
    UpdateElementPositions() {
        const viewportHeight = window.innerHeight;
        const els = [].slice.call(document.querySelectorAll(".navPin"));
        const bodyHeight = document.querySelector("body").scrollHeight;
        let elPositions = new Array();
        els.forEach((element, index)=>{
            elPositions.push([
                element.offsetTop / bodyHeight * 100,
                // the vertical position of the pin in the nav
                element.offsetTop - innerHeight / 2 + element.offsetHeight / 2,
                element.dataset.navtitle,
                element.offsetTop // for scrolling to the main elements on the page
            ]);
        });
        this.setState({
            elPositions: elPositions,
            viewportHeight: viewportHeight
        });
        this.UpdateNav();
    }
    // the handles are to make sure that when user hovers:
    // ** the Nav changes appearance
    // ** the hover state lifts up to Home when user hovers on the nav
    // when user clicks an anchor:
    // ** user scrolls to the corresponding section
    // nav hover state is deactivated (even though user's mouse is still hovering on it)
    // hover state is reactivated when user hovers out of Nav or hovers on an anchor link
    handleMouseOver() {
        // console.log("anchorClicked");
        // console.log(this.state.anchorClicked);
        if (!this.state.anchorClicked) {
            this.setState({
                navHover: true
            });
            this.props.onNavHover(true);
        }
    }
    handleMouseOut() {
        this.setState({
            navHover: false,
            anchorClicked: false
        });
        this.props.onNavHover(false);
    }
    handleAnchorClick(anchorClicked) {
        this.setState({
            navHover: false
        });
        this.props.onNavHover(false);
    }
    handleAnchorHover(anchorHover) {
        this.setState({
            anchorClicked: false
        });
        this.setState({
            navHover: true
        });
        this.props.onNavHover(true);
    }
    render() {
        // hover glitch on firefox when clicking the right side of internalLink
        const navWidth = (0, $9fbae048b55737ab$export$b7d78993b74f766d)() ? "80px" : "110px";
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("nav", {
            style: {
                position: "fixed",
                top: "0",
                right: "0",
                width: this.state.navHover ? "220px" : navWidth,
                height: "100vh",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                zIndex: "9"
            },
            ref: (c)=>{
                this._el = c;
            },
            onMouseLeave: this.handleMouseOut.bind(this)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("div", {
            style: {
                margin: "35px 0",
                height: "100%",
                width: navWidth,
                alignSelf: "flex-end",
                maxHeight: "500px",
                position: "relative"
            },
            onMouseEnter: this.handleMouseOver.bind(this)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("div", {
            style: {
                marginLeft: (0, $9fbae048b55737ab$export$b7d78993b74f766d)() ? "" : "30px",
                position: "relative",
                height: "100%"
            }
        }, this.state.elPositions.map((elPosition, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement((0, $ace49589997d421f$export$2e2bcd8739ae039), {
                key: index,
                scrollY: this.state.scrollY,
                bodyHeight: this.state.bodyHeight,
                position: elPosition,
                navItemTitle: elPosition[2],
                element: elPosition[3],
                navHover: this.state.navHover,
                onAnchorClick: this.handleAnchorClick,
                onAnchorHover: this.handleAnchorHover
            })))));
    }
}
var $f61de4c2c891d740$export$2e2bcd8739ae039 = $f61de4c2c891d740$var$Nav;



var $g85JO = parcelRequire("g85JO");

var $afcd1189d30151f8$exports = {};

$parcel$export($afcd1189d30151f8$exports, "navMobile", function () { return $afcd1189d30151f8$export$3a2707b50c3b4a73; }, function (v) { return $afcd1189d30151f8$export$3a2707b50c3b4a73 = v; });
$parcel$export($afcd1189d30151f8$exports, "navMobileOpen", function () { return $afcd1189d30151f8$export$467fc2f54d2f1276; }, function (v) { return $afcd1189d30151f8$export$467fc2f54d2f1276 = v; });
$parcel$export($afcd1189d30151f8$exports, "logoNav", function () { return $afcd1189d30151f8$export$7e91a2df78a98107; }, function (v) { return $afcd1189d30151f8$export$7e91a2df78a98107 = v; });
var $afcd1189d30151f8$export$3a2707b50c3b4a73;
var $afcd1189d30151f8$export$467fc2f54d2f1276;
var $afcd1189d30151f8$export$7e91a2df78a98107;
$afcd1189d30151f8$export$3a2707b50c3b4a73 = "_app-components-NavMobile-_styles__navMobile";
$afcd1189d30151f8$export$467fc2f54d2f1276 = "_app-components-NavMobile-_styles__navMobileOpen";
$afcd1189d30151f8$export$7e91a2df78a98107 = "_app-components-NavMobile-_styles__logoNav";



var $g85JO = parcelRequire("g85JO");

var $a1385ded34aec7c0$exports = {};

$parcel$export($a1385ded34aec7c0$exports, "item", function () { return $a1385ded34aec7c0$export$7061c75fc5af8b7e; }, function (v) { return $a1385ded34aec7c0$export$7061c75fc5af8b7e = v; });
$parcel$export($a1385ded34aec7c0$exports, "linkWrap", function () { return $a1385ded34aec7c0$export$924fb92fe3106139; }, function (v) { return $a1385ded34aec7c0$export$924fb92fe3106139 = v; });
$parcel$export($a1385ded34aec7c0$exports, "link", function () { return $a1385ded34aec7c0$export$9c30223ca0a664fb; }, function (v) { return $a1385ded34aec7c0$export$9c30223ca0a664fb = v; });
var $a1385ded34aec7c0$export$7061c75fc5af8b7e;
var $a1385ded34aec7c0$export$924fb92fe3106139;
var $a1385ded34aec7c0$export$9c30223ca0a664fb;
$a1385ded34aec7c0$export$7061c75fc5af8b7e = "_app-components-NavMobileItem-_styles__item";
$a1385ded34aec7c0$export$924fb92fe3106139 = "_app-components-NavMobileItem-_styles__linkWrap";
$a1385ded34aec7c0$export$9c30223ca0a664fb = "_app-components-NavMobileItem-_styles__link";



function $e5b374e1bfd357fa$var$_defineProperty(obj, key, value) {
    key = $e5b374e1bfd357fa$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e5b374e1bfd357fa$var$_toPropertyKey(arg) {
    var key = $e5b374e1bfd357fa$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $e5b374e1bfd357fa$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
class $e5b374e1bfd357fa$var$NavMobileItem extends (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).Component {
    constructor(props){
        super(props);
        $e5b374e1bfd357fa$var$_defineProperty(this, "handleClick", ()=>{
            this.props.navMobileIsOpen(false);
            (0, (/*@__PURE__*/$parcel$interopDefault($c55b064831e1f1a0$exports))).polyfill();
            const el = this.props.el;
            window.scrollTo({
                top: el.offsetTop - window.innerHeight / 2 + el.offsetHeight / 2,
                left: 0,
                behavior: "smooth"
            });
        });
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement((0, $g85JO.Fragment), null, this.props.navItemTitle != "Social" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($a1385ded34aec7c0$exports))).item),
            onClick: this.handleClick,
            dangerouslySetInnerHTML: {
                __html: this.props.navItemTitle
            }
        }), this.props.navItemTitle == "Social" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($a1385ded34aec7c0$exports))).linkWrap)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("a", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($a1385ded34aec7c0$exports))).link),
            href: "https://www.instagram.com/7isatribe",
            target: "_blank"
        }, "Instagram", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("sup", null, "7"))));
    }
}
var $e5b374e1bfd357fa$export$2e2bcd8739ae039 = $e5b374e1bfd357fa$var$NavMobileItem;



var $g85JO = parcelRequire("g85JO");

var $1dc9c97919c5edf5$exports = {};

$parcel$export($1dc9c97919c5edf5$exports, "logo", function () { return $1dc9c97919c5edf5$export$db3c28d99448dcff; }, function (v) { return $1dc9c97919c5edf5$export$db3c28d99448dcff = v; });
$parcel$export($1dc9c97919c5edf5$exports, "topPath", function () { return $1dc9c97919c5edf5$export$1e80c203db7bfaf0; }, function (v) { return $1dc9c97919c5edf5$export$1e80c203db7bfaf0 = v; });
$parcel$export($1dc9c97919c5edf5$exports, "circlePath", function () { return $1dc9c97919c5edf5$export$f3ea4332080b36fb; }, function (v) { return $1dc9c97919c5edf5$export$f3ea4332080b36fb = v; });
$parcel$export($1dc9c97919c5edf5$exports, "hover", function () { return $1dc9c97919c5edf5$export$3f60957f5dbf3876; }, function (v) { return $1dc9c97919c5edf5$export$3f60957f5dbf3876 = v; });
$parcel$export($1dc9c97919c5edf5$exports, "hidden", function () { return $1dc9c97919c5edf5$export$73920f18ca706874; }, function (v) { return $1dc9c97919c5edf5$export$73920f18ca706874 = v; });
$parcel$export($1dc9c97919c5edf5$exports, "topAnimating", function () { return $1dc9c97919c5edf5$export$6533b2ee733d741b; }, function (v) { return $1dc9c97919c5edf5$export$6533b2ee733d741b = v; });
var $1dc9c97919c5edf5$export$db3c28d99448dcff;
var $1dc9c97919c5edf5$export$1e80c203db7bfaf0;
var $1dc9c97919c5edf5$export$f3ea4332080b36fb;
var $1dc9c97919c5edf5$export$3f60957f5dbf3876;
var $1dc9c97919c5edf5$export$73920f18ca706874;
var $1dc9c97919c5edf5$export$6533b2ee733d741b;
$1dc9c97919c5edf5$export$db3c28d99448dcff = "_app-components-LogoBlackwingT-_styles__logo";
$1dc9c97919c5edf5$export$1e80c203db7bfaf0 = "_app-components-LogoBlackwingT-_styles__topPath";
$1dc9c97919c5edf5$export$f3ea4332080b36fb = "_app-components-LogoBlackwingT-_styles__circlePath";
$1dc9c97919c5edf5$export$3f60957f5dbf3876 = "_app-components-LogoBlackwingT-_styles__hover";
$1dc9c97919c5edf5$export$73920f18ca706874 = "_app-components-LogoBlackwingT-_styles__hidden";
$1dc9c97919c5edf5$export$6533b2ee733d741b = "_app-components-LogoBlackwingT-_styles__topAnimating";


var $daee6ceb752040c3$exports = {};


$daee6ceb752040c3$exports = (parcelRequire("kSeqf")).getBundleURL("kqVE6") + (parcelRequire("7wgKE")).resolve("lDKkP");


var $e07afd1e71c148f6$exports = {};


$e07afd1e71c148f6$exports = (parcelRequire("kSeqf")).getBundleURL("kqVE6") + (parcelRequire("7wgKE")).resolve("2IzQd");


parcelRequire("4fEaA");
var $876af = parcelRequire("876af");
class $dd42c90e69fe31c1$var$LogoBlackwingT extends (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).Component {
    componentDidMount() {
        (0, $876af.default).to(this._el, 1, {
            opacity: 1
        });
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($1dc9c97919c5edf5$exports))).logo, this.props.className),
            ref: (c)=>{
                this._el = c;
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("a", {
            href: "https://www.blackwing7.com"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("img", {
            ref: (c)=>{
                this._topPath = c;
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($1dc9c97919c5edf5$exports))).topPath),
            src: (0, (/*@__PURE__*/$parcel$interopDefault($daee6ceb752040c3$exports)))
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("img", {
            ref: (c)=>{
                this._circlePath = c;
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($1dc9c97919c5edf5$exports))).circlePath),
            src: (0, (/*@__PURE__*/$parcel$interopDefault($e07afd1e71c148f6$exports)))
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("span", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($1dc9c97919c5edf5$exports))).hover
        }, "BLACKWING", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("sup", null, "7"))));
    }
}
var $dd42c90e69fe31c1$export$2e2bcd8739ae039 = $dd42c90e69fe31c1$var$LogoBlackwingT;


function $17ac225665c291ff$var$_defineProperty(obj, key, value) {
    key = $17ac225665c291ff$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $17ac225665c291ff$var$_toPropertyKey(arg) {
    var key = $17ac225665c291ff$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $17ac225665c291ff$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
class $17ac225665c291ff$var$NavMobile extends (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).Component {
    constructor(props){
        super(props);
        $17ac225665c291ff$var$_defineProperty(this, "getNavItems", ()=>{
            const els = [].slice.call(document.querySelectorAll('[data-navtitle]:not([data-navtitle=""])'));
            let elPositions = new Array();
            els.forEach((element, index)=>{
                elPositions.push([
                    element.dataset.navtitle,
                    element
                ]);
            });
            this.setState({
                elPositions: elPositions
            });
        });
        $17ac225665c291ff$var$_defineProperty(this, "handleNavMobileIsOpen", (navMobileIsOpen)=>{
            this.setState({
                navMobileIsOpen: navMobileIsOpen
            });
            this.props.onNavMobileOpenChange(navMobileIsOpen);
            this.getNavItems();
        });
        this.state = {
            navMobileIsOpen: false,
            elPositions: []
        };
    }
    componentWillMount() {
        this.getNavItems();
        window.addEventListener("resize", this.getNavItems());
    }
    // if Logo sends click action to NavMobile
    componentWillReceiveProps(nextProps) {
        if (nextProps.navMobileIsOpen !== this.state.navMobileIsOpen) this.setState({
            navMobileIsOpen: nextProps.navMobileIsOpen
        });
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($afcd1189d30151f8$exports))).navMobile, {
                [(0, (/*@__PURE__*/$parcel$interopDefault($afcd1189d30151f8$exports))).navMobileOpen]: this.state.navMobileIsOpen
            })
        }, this.state.elPositions.map((el, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement((0, $e5b374e1bfd357fa$export$2e2bcd8739ae039), {
                key: index,
                navItemTitle: el[0],
                el: el[1],
                navMobileIsOpen: this.handleNavMobileIsOpen
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement((0, $dd42c90e69fe31c1$export$2e2bcd8739ae039), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($afcd1189d30151f8$exports))).logoNav
        }));
    }
}
var $17ac225665c291ff$export$2e2bcd8739ae039 = $17ac225665c291ff$var$NavMobile;



var $g85JO = parcelRequire("g85JO");

var $137526b6b4b0b575$exports = {};

$parcel$export($137526b6b4b0b575$exports, "background", function () { return $137526b6b4b0b575$export$8ce1fd94bee2f412; }, function (v) { return $137526b6b4b0b575$export$8ce1fd94bee2f412 = v; });
$parcel$export($137526b6b4b0b575$exports, "img", function () { return $137526b6b4b0b575$export$463b44d9bf3628be; }, function (v) { return $137526b6b4b0b575$export$463b44d9bf3628be = v; });
$parcel$export($137526b6b4b0b575$exports, "active", function () { return $137526b6b4b0b575$export$89da14300d534261; }, function (v) { return $137526b6b4b0b575$export$89da14300d534261 = v; });
$parcel$export($137526b6b4b0b575$exports, "activeFirstChild", function () { return $137526b6b4b0b575$export$90bd4d493d5864d4; }, function (v) { return $137526b6b4b0b575$export$90bd4d493d5864d4 = v; });
$parcel$export($137526b6b4b0b575$exports, "inactive", function () { return $137526b6b4b0b575$export$3cd3724d2f91e9d3; }, function (v) { return $137526b6b4b0b575$export$3cd3724d2f91e9d3 = v; });
var $137526b6b4b0b575$export$8ce1fd94bee2f412;
var $137526b6b4b0b575$export$463b44d9bf3628be;
var $137526b6b4b0b575$export$89da14300d534261;
var $137526b6b4b0b575$export$90bd4d493d5864d4;
var $137526b6b4b0b575$export$3cd3724d2f91e9d3;
$137526b6b4b0b575$export$8ce1fd94bee2f412 = "_app-components-Background-_styles__background";
$137526b6b4b0b575$export$463b44d9bf3628be = "_app-components-Background-_styles__img";
$137526b6b4b0b575$export$89da14300d534261 = "_app-components-Background-_styles__active";
$137526b6b4b0b575$export$90bd4d493d5864d4 = "_app-components-Background-_styles__activeFirstChild";
$137526b6b4b0b575$export$3cd3724d2f91e9d3 = "_app-components-Background-_styles__inactive";


parcelRequire("4fEaA");
var $9fTje = parcelRequire("9fTje");

var $d3f4c4e7d083d97f$exports = {};
var $e58889697fac80cb$exports = {};


$e58889697fac80cb$exports = (parcelRequire("kSeqf")).getBundleURL("kqVE6") + (parcelRequire("7wgKE")).resolve("h5WcD");


var $b4c8e485b7e1a7af$exports = {};


$b4c8e485b7e1a7af$exports = (parcelRequire("kSeqf")).getBundleURL("kqVE6") + (parcelRequire("7wgKE")).resolve("iIWzO");


var $30aa130f0d276382$exports = {};


$30aa130f0d276382$exports = (parcelRequire("kSeqf")).getBundleURL("kqVE6") + (parcelRequire("7wgKE")).resolve("2nQQq");


var $c129627f177f3d35$exports = {};


$c129627f177f3d35$exports = (parcelRequire("kSeqf")).getBundleURL("kqVE6") + (parcelRequire("7wgKE")).resolve("fEwL1");


var $8c5b4fcdcad54b55$exports = {};


$8c5b4fcdcad54b55$exports = (parcelRequire("kSeqf")).getBundleURL("kqVE6") + (parcelRequire("7wgKE")).resolve("4BU4s");


var $78b7740641c7b224$exports = {};


$78b7740641c7b224$exports = (parcelRequire("kSeqf")).getBundleURL("kqVE6") + (parcelRequire("7wgKE")).resolve("c0YF9");


var $dba56fe55dcc4d76$exports = {};


$dba56fe55dcc4d76$exports = (parcelRequire("kSeqf")).getBundleURL("kqVE6") + (parcelRequire("7wgKE")).resolve("2nTi0");


var $4cc833a84d78161d$exports = {};


$4cc833a84d78161d$exports = (parcelRequire("kSeqf")).getBundleURL("kqVE6") + (parcelRequire("7wgKE")).resolve("l73gU");


var $a8e3751500881ae8$exports = {};


$a8e3751500881ae8$exports = (parcelRequire("kSeqf")).getBundleURL("kqVE6") + (parcelRequire("7wgKE")).resolve("9Mgft");


var $3ed95122714d90b1$exports = {};


$3ed95122714d90b1$exports = (parcelRequire("kSeqf")).getBundleURL("kqVE6") + (parcelRequire("7wgKE")).resolve("gcpne");


var $7bb93dddd4b10c79$exports = {};


$7bb93dddd4b10c79$exports = (parcelRequire("kSeqf")).getBundleURL("kqVE6") + (parcelRequire("7wgKE")).resolve("2x5vu");


var $71e441e5c66fa449$exports = {};


$71e441e5c66fa449$exports = (parcelRequire("kSeqf")).getBundleURL("kqVE6") + (parcelRequire("7wgKE")).resolve("21trl");


var $847e31a365413dd3$exports = {};


$847e31a365413dd3$exports = (parcelRequire("kSeqf")).getBundleURL("kqVE6") + (parcelRequire("7wgKE")).resolve("4WFxp");


var $aa96ec494623b5d6$exports = {};


$aa96ec494623b5d6$exports = (parcelRequire("kSeqf")).getBundleURL("kqVE6") + (parcelRequire("7wgKE")).resolve("dCj8S");


var $73042dca7258f18b$exports = {};


$73042dca7258f18b$exports = (parcelRequire("kSeqf")).getBundleURL("kqVE6") + (parcelRequire("7wgKE")).resolve("cf4V9");


var $dac494d24a549c80$exports = {};


$dac494d24a549c80$exports = (parcelRequire("kSeqf")).getBundleURL("kqVE6") + (parcelRequire("7wgKE")).resolve("gJMXh");


var $ae6f78d5adec3bf3$exports = {};


$ae6f78d5adec3bf3$exports = (parcelRequire("kSeqf")).getBundleURL("kqVE6") + (parcelRequire("7wgKE")).resolve("fu0ib");


var $a2d6f8a62c0dc3e2$exports = {};


$a2d6f8a62c0dc3e2$exports = (parcelRequire("kSeqf")).getBundleURL("kqVE6") + (parcelRequire("7wgKE")).resolve("4ktRG");


var $7ff4687ccec42210$exports = {};


$7ff4687ccec42210$exports = (parcelRequire("kSeqf")).getBundleURL("kqVE6") + (parcelRequire("7wgKE")).resolve("2GDZ3");


var $56b5744dc568fb5f$exports = {};


$56b5744dc568fb5f$exports = (parcelRequire("kSeqf")).getBundleURL("kqVE6") + (parcelRequire("7wgKE")).resolve("1x0nJ");


$d3f4c4e7d083d97f$exports = {
    "1-Miles2": $e58889697fac80cb$exports,
    "2-decarava": $b4c8e485b7e1a7af$exports,
    "2a-Denis": $30aa130f0d276382$exports,
    "3-basquiat": $c129627f177f3d35$exports,
    "4-stalker": $8c5b4fcdcad54b55$exports,
    "5-solaris": $78b7740641c7b224$exports,
    "5a-jdilla": $dba56fe55dcc4d76$exports,
    "6-maurice": $4cc833a84d78161d$exports,
    "7-In-the-Mood-for-Love": $a8e3751500881ae8$exports,
    "8-reels": $3ed95122714d90b1$exports,
    "9-wkwai": $7bb93dddd4b10c79$exports,
    "Herbie-Hancock": $71e441e5c66fa449$exports,
    "Sugimoto": $847e31a365413dd3$exports,
    "Sunshine": $aa96ec494623b5d6$exports,
    "Walkabout": $73042dca7258f18b$exports,
    "ayler": $dac494d24a549c80$exports,
    "sun-bush_mama_2": $ae6f78d5adec3bf3$exports,
    "z-dancing": $a2d6f8a62c0dc3e2$exports,
    "z-moolade": $7ff4687ccec42210$exports,
    "z-with_camera": $56b5744dc568fb5f$exports
};


function $c9cc34f22c5820b3$var$_defineProperty(obj, key, value) {
    key = $c9cc34f22c5820b3$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c9cc34f22c5820b3$var$_toPropertyKey(arg) {
    var key = $c9cc34f22c5820b3$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $c9cc34f22c5820b3$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
class $c9cc34f22c5820b3$var$Background extends (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).Component {
    constructor(props){
        super(props);
        $c9cc34f22c5820b3$var$_defineProperty(this, "loadImagesInSequence", (images)=>{
            if (!images.length) return;
            let img = new Image(), url = images.shift();
            let that = this;
            img.onload = function() {
                that.loadImagesInSequence(images);
            };
            img.src = url;
        });
        this.state = {
            pageResolution: window.innerWidth * window.innerHeight * window.devicePixelRatio
        };
    }
    componentDidMount() {
        // load all the lines, convert Nodelist to array
        let els = [].slice.call(this._el.querySelectorAll(`.${(0, (/*@__PURE__*/$parcel$interopDefault($137526b6b4b0b575$exports))).background} div`));
        let images = new Array();
        for(let key in 0, (/*@__PURE__*/$parcel$interopDefault($d3f4c4e7d083d97f$exports)))images.push((0, (/*@__PURE__*/$parcel$interopDefault($d3f4c4e7d083d97f$exports)))[key]);
        this.loadImagesInSequence(images.slice(1));
        let that = this;
        // Use GSAP only to time the adding/removal of classes
        setTimeout(()=>{
            els.forEach((element, index)=>{
                let isFirstChild = index == 0 ? true : false;
                let isSecondChild = index == 1 ? true : false;
                let secondChildEl = index == 1 ? els[0] : null;
                let nextElement = index == els.length - 1 ? els[0] : els[index + 1];
                // give cellular data connections a little more time to load each image
                let fadeInDuration = (0, $9fbae048b55737ab$export$d53806e03704a04e)() ? 9 : 8;
                let repeatDelay = (els.length - 2) * fadeInDuration;
                let delay = index * fadeInDuration;
                new (0, $9fTje.default)({
                    repeat: -1,
                    delay: delay,
                    repeatDelay: repeatDelay
                }).to(element, fadeInDuration * 2, {
                    onStart: that.fadeIn,
                    onStartParams: [
                        element,
                        nextElement,
                        isFirstChild,
                        isSecondChild,
                        secondChildEl
                    ],
                    onComplete: that.fadeOut,
                    onCompleteParams: [
                        element,
                        isFirstChild
                    ]
                });
            });
        }, 10);
    }
    fadeIn(el, nextEl, firstChild, secondChild, firstChildEl) {
        el.classList.remove((0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($137526b6b4b0b575$exports))).inactive));
        el.classList.add((0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($137526b6b4b0b575$exports))).active));
        nextEl.style.backgroundImage = `url(${nextEl.getAttribute("data-background-image")})`;
        if ((0, $9fbae048b55737ab$export$67694733dc949122)()) {
            // to fix viewport height issue on firefox mobile
            // https://stackoverflow.com/questions/37112218/css3-100vh-not-constant-in-mobile-browser#comment61769040_37113430
            const heightOverride = window.innerHeight + 100;
            el.style.height = `${heightOverride}px`;
        }
        if (firstChild) {
            el.style.backgroundImage = `url(${el.getAttribute("data-background-image")})`;
            el.classList.add((0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($137526b6b4b0b575$exports))).activeFirstChild));
        }
        if (secondChild) firstChildEl.classList.remove((0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($137526b6b4b0b575$exports))).activeFirstChild));
    }
    fadeOut(el, firstChild) {
        el.classList.remove((0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($137526b6b4b0b575$exports))).active));
        el.classList.add((0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($137526b6b4b0b575$exports))).inactive));
        // improves performance on safari
        el.style.backgroundImage = `none`;
        if (firstChild) el.classList.remove((0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($137526b6b4b0b575$exports))).activeFirstChild));
    }
    render() {
        let images = new Array();
        for(let key in 0, (/*@__PURE__*/$parcel$interopDefault($d3f4c4e7d083d97f$exports)))images.push((0, (/*@__PURE__*/$parcel$interopDefault($d3f4c4e7d083d97f$exports)))[key]);
        // only load the first 8 images on mobile — for slow cellular data connections
        if ((0, $9fbae048b55737ab$export$d53806e03704a04e)()) images = images.slice(0, 8);
        // to fix viewport height issue on firefox mobile
        let heightOverride = null;
        if ((0, $9fbae048b55737ab$export$67694733dc949122)() && heightOverride === null) heightOverride = window.innerHeight;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($137526b6b4b0b575$exports))).background),
            ref: (c)=>{
                this._el = c;
            }
        }, images.map((item, i)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("div", {
                key: i,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($137526b6b4b0b575$exports))).img),
                "data-background-image": item,
                style: {
                    height: heightOverride
                }
            });
        }));
    }
}
var $c9cc34f22c5820b3$export$2e2bcd8739ae039 = $c9cc34f22c5820b3$var$Background;



var $g85JO = parcelRequire("g85JO");

var $1f4b9e7c837b3fdb$exports = {};

$parcel$export($1f4b9e7c837b3fdb$exports, "backgroundSimple", function () { return $1f4b9e7c837b3fdb$export$6251f71e070decc7; }, function (v) { return $1f4b9e7c837b3fdb$export$6251f71e070decc7 = v; });
$parcel$export($1f4b9e7c837b3fdb$exports, "img", function () { return $1f4b9e7c837b3fdb$export$463b44d9bf3628be; }, function (v) { return $1f4b9e7c837b3fdb$export$463b44d9bf3628be = v; });
var $1f4b9e7c837b3fdb$export$6251f71e070decc7;
var $1f4b9e7c837b3fdb$export$463b44d9bf3628be;
$1f4b9e7c837b3fdb$export$6251f71e070decc7 = "_app-components-BackgroundSimple-_styles__backgroundSimple";
$1f4b9e7c837b3fdb$export$463b44d9bf3628be = "_app-components-BackgroundSimple-_styles__img";


var $920b427013469c0f$exports = {};




















$920b427013469c0f$exports = {
    "1-Miles2": $e58889697fac80cb$exports,
    "2-decarava": $b4c8e485b7e1a7af$exports,
    "2a-Denis": $30aa130f0d276382$exports,
    "3-basquiat": $c129627f177f3d35$exports,
    "4-stalker": $8c5b4fcdcad54b55$exports,
    "5-solaris": $78b7740641c7b224$exports,
    "5a-jdilla": $dba56fe55dcc4d76$exports,
    "6-maurice": $4cc833a84d78161d$exports,
    "7-In-the-Mood-for-Love": $a8e3751500881ae8$exports,
    "8-reels": $3ed95122714d90b1$exports,
    "9-wkwai": $7bb93dddd4b10c79$exports,
    "Herbie-Hancock": $71e441e5c66fa449$exports,
    "Sugimoto": $847e31a365413dd3$exports,
    "Sunshine": $aa96ec494623b5d6$exports,
    "Walkabout": $73042dca7258f18b$exports,
    "ayler": $dac494d24a549c80$exports,
    "sun-bush_mama_2": $ae6f78d5adec3bf3$exports,
    "z-dancing": $a2d6f8a62c0dc3e2$exports,
    "z-moolade": $7ff4687ccec42210$exports,
    "z-with_camera": $56b5744dc568fb5f$exports
};


class $131ecdc5eedb722c$var$BackgroundSimple extends (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).Component {
    render() {
        let images = new Array();
        for(let key in 0, (/*@__PURE__*/$parcel$interopDefault($920b427013469c0f$exports))){
            console.log({
                img: (0, (/*@__PURE__*/$parcel$interopDefault($920b427013469c0f$exports)))[key]
            });
            images.push((0, (/*@__PURE__*/$parcel$interopDefault($920b427013469c0f$exports)))[key]);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($1f4b9e7c837b3fdb$exports))).backgroundSimple)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($1f4b9e7c837b3fdb$exports))).img),
            style: {
                backgroundImage: `url(${images[0]})`
            }
        }));
    }
}
var $131ecdc5eedb722c$export$2e2bcd8739ae039 = $131ecdc5eedb722c$var$BackgroundSimple;



var $g85JO = parcelRequire("g85JO");

var $bd613b1f7513795e$exports = {};

$parcel$export($bd613b1f7513795e$exports, "logo", function () { return $bd613b1f7513795e$export$db3c28d99448dcff; }, function (v) { return $bd613b1f7513795e$export$db3c28d99448dcff = v; });
$parcel$export($bd613b1f7513795e$exports, "isClickable", function () { return $bd613b1f7513795e$export$8eed54c26009b0a9; }, function (v) { return $bd613b1f7513795e$export$8eed54c26009b0a9 = v; });
$parcel$export($bd613b1f7513795e$exports, "navMobileIsOpen", function () { return $bd613b1f7513795e$export$66237e0e2642dcb8; }, function (v) { return $bd613b1f7513795e$export$66237e0e2642dcb8 = v; });
$parcel$export($bd613b1f7513795e$exports, "seven", function () { return $bd613b1f7513795e$export$1075f0222defe31; }, function (v) { return $bd613b1f7513795e$export$1075f0222defe31 = v; });
$parcel$export($bd613b1f7513795e$exports, "sevenScroll", function () { return $bd613b1f7513795e$export$96539a6b0a4c5ebf; }, function (v) { return $bd613b1f7513795e$export$96539a6b0a4c5ebf = v; });
$parcel$export($bd613b1f7513795e$exports, "logoMobileScroll", function () { return $bd613b1f7513795e$export$4897b811e1b6ca10; }, function (v) { return $bd613b1f7513795e$export$4897b811e1b6ca10 = v; });
var $bd613b1f7513795e$export$db3c28d99448dcff;
var $bd613b1f7513795e$export$8eed54c26009b0a9;
var $bd613b1f7513795e$export$66237e0e2642dcb8;
var $bd613b1f7513795e$export$1075f0222defe31;
var $bd613b1f7513795e$export$96539a6b0a4c5ebf;
var $bd613b1f7513795e$export$4897b811e1b6ca10;
$bd613b1f7513795e$export$db3c28d99448dcff = "_app-components-Logo-_styles__logo";
$bd613b1f7513795e$export$8eed54c26009b0a9 = "_app-components-Logo-_styles__isClickable";
$bd613b1f7513795e$export$66237e0e2642dcb8 = "_app-components-Logo-_styles__navMobileIsOpen";
$bd613b1f7513795e$export$1075f0222defe31 = "_app-components-Logo-_styles__seven";
$bd613b1f7513795e$export$96539a6b0a4c5ebf = "_app-components-Logo-_styles__sevenScroll";
$bd613b1f7513795e$export$4897b811e1b6ca10 = "_app-components-Logo-_styles__logoMobileScroll";



parcelRequire("4fEaA");
var $9fTje = parcelRequire("9fTje");
var $876af = parcelRequire("876af");

var $ctrgf = parcelRequire("ctrgf");
var $5f15174b7ec90578$exports = {};

/*!
 * ScrollMagic v2.0.7 (2019-05-07)
 * The javascript library for magical scroll interactions.
 * (c) 2019 Jan Paepke (@janpaepke)
 * Project Website: http://scrollmagic.io
 * 
 * @version 2.0.7
 * @license Dual licensed under MIT license and GPL.
 * @author Jan Paepke - e-mail@janpaepke.de
 *
 * @file Debug Extension for ScrollMagic.
 */ /**
 * This plugin was formerly known as the ScrollMagic debug extension.
 *
 * It enables you to add visual indicators to your page, to be able to see exactly when a scene is triggered.
 *
 * To have access to this extension, please include `plugins/debug.addIndicators.js`.
 * @mixin debug.addIndicators
 */ (function(root, factory) {
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([
        "ScrollMagic"
    ], factory);
    else // CommonJS
    factory((parcelRequire("ctrgf")));
})($5f15174b7ec90578$exports, function(ScrollMagic) {
    "use strict";
    var NAMESPACE = "debug.addIndicators";
    var console = window.console || {}, err = Function.prototype.bind.call(console.error || console.log || function() {}, console);
    if (!ScrollMagic) err("(" + NAMESPACE + ") -> ERROR: The ScrollMagic main module could not be found. Please make sure it's loaded before this plugin or use an asynchronous loader like requirejs.");
    // plugin settings
    var FONT_SIZE = "0.85em", ZINDEX = "9999", EDGE_OFFSET = 15; // minimum edge distance, added to indentation
    // overall vars
    var _util = ScrollMagic._util, _autoindex = 0;
    ScrollMagic.Scene.extend(function() {
        var Scene = this, _indicator;
        var log = function() {
            if (Scene._log) {
                Array.prototype.splice.call(arguments, 1, 0, "(" + NAMESPACE + ")", "->");
                Scene._log.apply(this, arguments);
            }
        };
        /**
		 * Add visual indicators for a ScrollMagic.Scene.  
		 * @memberof! debug.addIndicators#
		 *
		 * @example
		 * // add basic indicators
		 * scene.addIndicators()
		 *
		 * // passing options
		 * scene.addIndicators({name: "pin scene", colorEnd: "#FFFFFF"});
		 *
		 * @param {object} [options] - An object containing one or more options for the indicators.
		 * @param {(string|object)} [options.parent] - A selector, DOM Object or a jQuery object that the indicators should be added to.  
		 														 														 If undefined, the controller's container will be used.
		 * @param {number} [options.name=""] - This string will be displayed at the start and end indicators of the scene for identification purposes. If no name is supplied an automatic index will be used.
		 * @param {number} [options.indent=0] - Additional position offset for the indicators (useful, when having multiple scenes starting at the same position).
		 * @param {string} [options.colorStart=green] - CSS color definition for the start indicator.
		 * @param {string} [options.colorEnd=red] - CSS color definition for the end indicator.
		 * @param {string} [options.colorTrigger=blue] - CSS color definition for the trigger indicator.
		 */ Scene.addIndicators = function(options) {
            if (!_indicator) {
                var DEFAULT_OPTIONS = {
                    name: "",
                    indent: 0,
                    parent: undefined,
                    colorStart: "green",
                    colorEnd: "red",
                    colorTrigger: "blue"
                };
                options = _util.extend({}, DEFAULT_OPTIONS, options);
                _autoindex++;
                _indicator = new Indicator(Scene, options);
                Scene.on("add.plugin_addIndicators", _indicator.add);
                Scene.on("remove.plugin_addIndicators", _indicator.remove);
                Scene.on("destroy.plugin_addIndicators", Scene.removeIndicators);
                // it the scene already has a controller we can start right away.
                if (Scene.controller()) _indicator.add();
            }
            return Scene;
        };
        /**
		 * Removes visual indicators from a ScrollMagic.Scene.
		 * @memberof! debug.addIndicators#
		 *
		 * @example
		 * // remove previously added indicators
		 * scene.removeIndicators()
		 *
		 */ Scene.removeIndicators = function() {
            if (_indicator) {
                _indicator.remove();
                this.off("*.plugin_addIndicators");
                _indicator = undefined;
            }
            return Scene;
        };
    });
    /*
	 * ----------------------------------------------------------------
	 * Extension for controller to store and update related indicators
	 * ----------------------------------------------------------------
	 */ // add option to globally auto-add indicators to scenes
    /**
	 * Every ScrollMagic.Controller instance now accepts an additional option.  
	 * See {@link ScrollMagic.Controller} for a complete list of the standard options.
	 * @memberof! debug.addIndicators#
	 * @method new ScrollMagic.Controller(options)
	 * @example
	 * // make a controller and add indicators to all scenes attached
	 * var controller = new ScrollMagic.Controller({addIndicators: true});
	 * // this scene will automatically have indicators added to it
	 * new ScrollMagic.Scene()
	 *                .addTo(controller);
	 *
	 * @param {object} [options] - Options for the Controller.
	 * @param {boolean} [options.addIndicators=false] - If set to `true` every scene that is added to the controller will automatically get indicators added to it.
	 */ ScrollMagic.Controller.addOption("addIndicators", false);
    // extend Controller
    ScrollMagic.Controller.extend(function() {
        var Controller = this, _info = Controller.info(), _container = _info.container, _isDocument = _info.isDocument, _vertical = _info.vertical, _indicators = {
            groups: []
        };
        var log = function() {
            if (Controller._log) {
                Array.prototype.splice.call(arguments, 1, 0, "(" + NAMESPACE + ")", "->");
                Controller._log.apply(this, arguments);
            }
        };
        if (Controller._indicators) log(2, "WARNING: Scene already has a property '_indicators', which will be overwritten by plugin.");
        // add indicators container
        this._indicators = _indicators;
        /*
			needed updates:
			+++++++++++++++
			start/end position on scene shift (handled in Indicator class)
			trigger parameters on triggerHook value change (handled in Indicator class)
			bounds position on container scroll or resize (to keep alignment to bottom/right)
			trigger position on container resize, window resize (if container isn't document) and window scroll (if container isn't document)
		*/ // event handler for when associated bounds markers need to be repositioned
        var handleBoundsPositionChange = function() {
            _indicators.updateBoundsPositions();
        };
        // event handler for when associated trigger groups need to be repositioned
        var handleTriggerPositionChange = function() {
            _indicators.updateTriggerGroupPositions();
        };
        _container.addEventListener("resize", handleTriggerPositionChange);
        if (!_isDocument) {
            window.addEventListener("resize", handleTriggerPositionChange);
            window.addEventListener("scroll", handleTriggerPositionChange);
        }
        // update all related bounds containers
        _container.addEventListener("resize", handleBoundsPositionChange);
        _container.addEventListener("scroll", handleBoundsPositionChange);
        // updates the position of the bounds container to aligned to the right for vertical containers and to the bottom for horizontal
        this._indicators.updateBoundsPositions = function(specificIndicator) {
            var groups = specificIndicator ? [
                _util.extend({}, specificIndicator.triggerGroup, {
                    members: [
                        specificIndicator
                    ]
                })
            ] : _indicators.groups, g = groups.length, css = {}, paramPos = _vertical ? "left" : "top", paramDimension = _vertical ? "width" : "height", edge = _vertical ? _util.get.scrollLeft(_container) + _util.get.width(_container) - EDGE_OFFSET : _util.get.scrollTop(_container) + _util.get.height(_container) - EDGE_OFFSET, b, triggerSize, group;
            while(g--){
                group = groups[g];
                b = group.members.length;
                triggerSize = _util.get[paramDimension](group.element.firstChild);
                while(b--){
                    css[paramPos] = edge - triggerSize;
                    _util.css(group.members[b].bounds, css);
                }
            }
        };
        // updates the positions of all trigger groups attached to a controller or a specific one, if provided
        this._indicators.updateTriggerGroupPositions = function(specificGroup) {
            var groups = specificGroup ? [
                specificGroup
            ] : _indicators.groups, i = groups.length, container = _isDocument ? document.body : _container, containerOffset = _isDocument ? {
                top: 0,
                left: 0
            } : _util.get.offset(container, true), edge = _vertical ? _util.get.width(_container) - EDGE_OFFSET : _util.get.height(_container) - EDGE_OFFSET, paramDimension = _vertical ? "width" : "height", paramTransform = _vertical ? "Y" : "X";
            var group, elem, pos, elemSize, transform;
            while(i--){
                group = groups[i];
                elem = group.element;
                pos = group.triggerHook * Controller.info("size");
                elemSize = _util.get[paramDimension](elem.firstChild.firstChild);
                transform = pos > elemSize ? "translate" + paramTransform + "(-100%)" : "";
                _util.css(elem, {
                    top: containerOffset.top + (_vertical ? pos : edge - group.members[0].options.indent),
                    left: containerOffset.left + (_vertical ? edge - group.members[0].options.indent : pos)
                });
                _util.css(elem.firstChild.firstChild, {
                    "-ms-transform": transform,
                    "-webkit-transform": transform,
                    "transform": transform
                });
            }
        };
        // updates the label for the group to contain the name, if it only has one member
        this._indicators.updateTriggerGroupLabel = function(group) {
            var text = "trigger" + (group.members.length > 1 ? "" : " " + group.members[0].options.name), elem = group.element.firstChild.firstChild, doUpdate = elem.textContent !== text;
            if (doUpdate) {
                elem.textContent = text;
                if (_vertical) _indicators.updateBoundsPositions();
            }
        };
        // add indicators if global option is set
        this.addScene = function(newScene) {
            if (this._options.addIndicators && newScene instanceof ScrollMagic.Scene && newScene.controller() === Controller) newScene.addIndicators();
            // call original destroy method
            this.$super.addScene.apply(this, arguments);
        };
        // remove all previously set listeners on destroy
        this.destroy = function() {
            _container.removeEventListener("resize", handleTriggerPositionChange);
            if (!_isDocument) {
                window.removeEventListener("resize", handleTriggerPositionChange);
                window.removeEventListener("scroll", handleTriggerPositionChange);
            }
            _container.removeEventListener("resize", handleBoundsPositionChange);
            _container.removeEventListener("scroll", handleBoundsPositionChange);
            // call original destroy method
            this.$super.destroy.apply(this, arguments);
        };
        return Controller;
    });
    /*
	 * ----------------------------------------------------------------
	 * Internal class for the construction of Indicators
	 * ----------------------------------------------------------------
	 */ var Indicator = function(Scene, options) {
        var Indicator = this, _elemBounds = TPL.bounds(), _elemStart = TPL.start(options.colorStart), _elemEnd = TPL.end(options.colorEnd), _boundsContainer = options.parent && _util.get.elements(options.parent)[0], _vertical, _ctrl;
        var log = function() {
            if (Scene._log) {
                Array.prototype.splice.call(arguments, 1, 0, "(" + NAMESPACE + ")", "->");
                Scene._log.apply(this, arguments);
            }
        };
        options.name = options.name || _autoindex;
        // prepare bounds elements
        _elemStart.firstChild.textContent += " " + options.name;
        _elemEnd.textContent += " " + options.name;
        _elemBounds.appendChild(_elemStart);
        _elemBounds.appendChild(_elemEnd);
        // set public variables
        Indicator.options = options;
        Indicator.bounds = _elemBounds;
        // will be set later
        Indicator.triggerGroup = undefined;
        // add indicators to DOM
        this.add = function() {
            _ctrl = Scene.controller();
            _vertical = _ctrl.info("vertical");
            var isDocument = _ctrl.info("isDocument");
            if (!_boundsContainer) // no parent supplied or doesnt exist
            _boundsContainer = isDocument ? document.body : _ctrl.info("container"); // check if window/document (then use body)
            if (!isDocument && _util.css(_boundsContainer, "position") === "static") // position mode needed for correct positioning of indicators
            _util.css(_boundsContainer, {
                position: "relative"
            });
            // add listeners for updates
            Scene.on("change.plugin_addIndicators", handleTriggerParamsChange);
            Scene.on("shift.plugin_addIndicators", handleBoundsParamsChange);
            // updates trigger & bounds (will add elements if needed)
            updateTriggerGroup();
            updateBounds();
            setTimeout(function() {
                _ctrl._indicators.updateBoundsPositions(Indicator);
            }, 0);
            log(3, "added indicators");
        };
        // remove indicators from DOM
        this.remove = function() {
            if (Indicator.triggerGroup) {
                Scene.off("change.plugin_addIndicators", handleTriggerParamsChange);
                Scene.off("shift.plugin_addIndicators", handleBoundsParamsChange);
                if (Indicator.triggerGroup.members.length > 1) {
                    // just remove from memberlist of old group
                    var group = Indicator.triggerGroup;
                    group.members.splice(group.members.indexOf(Indicator), 1);
                    _ctrl._indicators.updateTriggerGroupLabel(group);
                    _ctrl._indicators.updateTriggerGroupPositions(group);
                    Indicator.triggerGroup = undefined;
                } else // remove complete group
                removeTriggerGroup();
                removeBounds();
                log(3, "removed indicators");
            }
        };
        /*
		 * ----------------------------------------------------------------
		 * internal Event Handlers
		 * ----------------------------------------------------------------
		 */ // event handler for when bounds params change
        var handleBoundsParamsChange = function() {
            updateBounds();
        };
        // event handler for when trigger params change
        var handleTriggerParamsChange = function(e) {
            if (e.what === "triggerHook") updateTriggerGroup();
        };
        /*
		 * ----------------------------------------------------------------
		 * Bounds (start / stop) management
		 * ----------------------------------------------------------------
		 */ // adds an new bounds elements to the array and to the DOM
        var addBounds = function() {
            var v = _ctrl.info("vertical");
            // apply stuff we didn't know before...
            _util.css(_elemStart.firstChild, {
                "border-bottom-width": v ? 1 : 0,
                "border-right-width": v ? 0 : 1,
                "bottom": v ? -1 : options.indent,
                "right": v ? options.indent : -1,
                "padding": v ? "0 8px" : "2px 4px"
            });
            _util.css(_elemEnd, {
                "border-top-width": v ? 1 : 0,
                "border-left-width": v ? 0 : 1,
                "top": v ? "100%" : "",
                "right": v ? options.indent : "",
                "bottom": v ? "" : options.indent,
                "left": v ? "" : "100%",
                "padding": v ? "0 8px" : "2px 4px"
            });
            // append
            _boundsContainer.appendChild(_elemBounds);
        };
        // remove bounds from list and DOM
        var removeBounds = function() {
            _elemBounds.parentNode.removeChild(_elemBounds);
        };
        // update the start and end positions of the scene
        var updateBounds = function() {
            if (_elemBounds.parentNode !== _boundsContainer) addBounds(); // Add Bounds elements (start/end)
            var css = {};
            css[_vertical ? "top" : "left"] = Scene.triggerPosition();
            css[_vertical ? "height" : "width"] = Scene.duration();
            _util.css(_elemBounds, css);
            _util.css(_elemEnd, {
                display: Scene.duration() > 0 ? "" : "none"
            });
        };
        /*
		 * ----------------------------------------------------------------
		 * trigger and trigger group management
		 * ----------------------------------------------------------------
		 */ // adds an new trigger group to the array and to the DOM
        var addTriggerGroup = function() {
            var triggerElem = TPL.trigger(options.colorTrigger); // new trigger element
            var css = {};
            css[_vertical ? "right" : "bottom"] = 0;
            css[_vertical ? "border-top-width" : "border-left-width"] = 1;
            _util.css(triggerElem.firstChild, css);
            _util.css(triggerElem.firstChild.firstChild, {
                padding: _vertical ? "0 8px 3px 8px" : "3px 4px"
            });
            document.body.appendChild(triggerElem); // directly add to body
            var newGroup = {
                triggerHook: Scene.triggerHook(),
                element: triggerElem,
                members: [
                    Indicator
                ]
            };
            _ctrl._indicators.groups.push(newGroup);
            Indicator.triggerGroup = newGroup;
            // update right away
            _ctrl._indicators.updateTriggerGroupLabel(newGroup);
            _ctrl._indicators.updateTriggerGroupPositions(newGroup);
        };
        var removeTriggerGroup = function() {
            _ctrl._indicators.groups.splice(_ctrl._indicators.groups.indexOf(Indicator.triggerGroup), 1);
            Indicator.triggerGroup.element.parentNode.removeChild(Indicator.triggerGroup.element);
            Indicator.triggerGroup = undefined;
        };
        // updates the trigger group -> either join existing or add new one
        /*	
		 * Logic:
		 * 1 if a trigger group exist, check if it's in sync with Scene settings – if so, nothing else needs to happen
		 * 2 try to find an existing one that matches Scene parameters
		 * 	 2.1 If a match is found check if already assigned to an existing group
		 *			 If so:
		 *       A: it was the last member of existing group -> kill whole group
		 *       B: the existing group has other members -> just remove from member list
		 *	 2.2 Assign to matching group
		 * 3 if no new match could be found, check if assigned to existing group
		 *   A: yes, and it's the only member -> just update parameters and positions and keep using this group
		 *   B: yes but there are other members -> remove from member list and create a new one
		 *   C: no, so create a new one
		 */ var updateTriggerGroup = function() {
            var triggerHook = Scene.triggerHook(), closeEnough = 0.0001;
            // Have a group, check if it still matches
            if (Indicator.triggerGroup) {
                if (Math.abs(Indicator.triggerGroup.triggerHook - triggerHook) < closeEnough) // _util.log(0, "trigger", options.name, "->", "no need to change, still in sync");
                return; // all good
            }
            // Don't have a group, check if a matching one exists
            // _util.log(0, "trigger", options.name, "->", "out of sync!");
            var groups = _ctrl._indicators.groups, group, i = groups.length;
            while(i--){
                group = groups[i];
                if (Math.abs(group.triggerHook - triggerHook) < closeEnough) {
                    // found a match!
                    // _util.log(0, "trigger", options.name, "->", "found match");
                    if (Indicator.triggerGroup) {
                        if (Indicator.triggerGroup.members.length === 1) // _util.log(0, "trigger", options.name, "->", "kill");
                        // was the last member, remove the whole group
                        removeTriggerGroup();
                        else {
                            Indicator.triggerGroup.members.splice(Indicator.triggerGroup.members.indexOf(Indicator), 1); // just remove from memberlist of old group
                            _ctrl._indicators.updateTriggerGroupLabel(Indicator.triggerGroup);
                            _ctrl._indicators.updateTriggerGroupPositions(Indicator.triggerGroup);
                        // _util.log(0, "trigger", options.name, "->", "removing from previous member list");
                        }
                    }
                    // join new group
                    group.members.push(Indicator);
                    Indicator.triggerGroup = group;
                    _ctrl._indicators.updateTriggerGroupLabel(group);
                    return;
                }
            }
            // at this point I am obviously out of sync and don't match any other group
            if (Indicator.triggerGroup) {
                if (Indicator.triggerGroup.members.length === 1) {
                    // _util.log(0, "trigger", options.name, "->", "updating existing");
                    // out of sync but i'm the only member => just change and update
                    Indicator.triggerGroup.triggerHook = triggerHook;
                    _ctrl._indicators.updateTriggerGroupPositions(Indicator.triggerGroup);
                    return;
                } else {
                    // _util.log(0, "trigger", options.name, "->", "removing from previous member list");
                    Indicator.triggerGroup.members.splice(Indicator.triggerGroup.members.indexOf(Indicator), 1); // just remove from memberlist of old group
                    _ctrl._indicators.updateTriggerGroupLabel(Indicator.triggerGroup);
                    _ctrl._indicators.updateTriggerGroupPositions(Indicator.triggerGroup);
                    Indicator.triggerGroup = undefined; // need a brand new group...
                }
            }
            // _util.log(0, "trigger", options.name, "->", "add a new one");
            // did not find any match, make new trigger group
            addTriggerGroup();
        };
    };
    /*
	 * ----------------------------------------------------------------
	 * Templates for the indicators
	 * ----------------------------------------------------------------
	 */ var TPL = {
        start: function(color) {
            // inner element (for bottom offset -1, while keeping top position 0)
            var inner = document.createElement("div");
            inner.textContent = "start";
            _util.css(inner, {
                position: "absolute",
                overflow: "visible",
                "border-width": 0,
                "border-style": "solid",
                color: color,
                "border-color": color
            });
            var e = document.createElement("div");
            // wrapper
            _util.css(e, {
                position: "absolute",
                overflow: "visible",
                width: 0,
                height: 0
            });
            e.appendChild(inner);
            return e;
        },
        end: function(color) {
            var e = document.createElement("div");
            e.textContent = "end";
            _util.css(e, {
                position: "absolute",
                overflow: "visible",
                "border-width": 0,
                "border-style": "solid",
                color: color,
                "border-color": color
            });
            return e;
        },
        bounds: function() {
            var e = document.createElement("div");
            _util.css(e, {
                position: "absolute",
                overflow: "visible",
                "white-space": "nowrap",
                "pointer-events": "none",
                "font-size": FONT_SIZE
            });
            e.style.zIndex = ZINDEX;
            return e;
        },
        trigger: function(color) {
            // inner to be above or below line but keep position
            var inner = document.createElement("div");
            inner.textContent = "trigger";
            _util.css(inner, {
                position: "relative"
            });
            // inner wrapper for right: 0 and main element has no size
            var w = document.createElement("div");
            _util.css(w, {
                position: "absolute",
                overflow: "visible",
                "border-width": 0,
                "border-style": "solid",
                color: color,
                "border-color": color
            });
            w.appendChild(inner);
            // wrapper
            var e = document.createElement("div");
            _util.css(e, {
                position: "fixed",
                overflow: "visible",
                "white-space": "nowrap",
                "pointer-events": "none",
                "font-size": FONT_SIZE
            });
            e.style.zIndex = ZINDEX;
            e.appendChild(w);
            return e;
        }
    };
});


var $b486bddb010d3c4b$exports = {};


/*!
 * ScrollMagic v2.0.7 (2019-05-07)
 * The javascript library for magical scroll interactions.
 * (c) 2019 Jan Paepke (@janpaepke)
 * Project Website: http://scrollmagic.io
 * 
 * @version 2.0.7
 * @license Dual licensed under MIT license and GPL.
 * @author Jan Paepke - e-mail@janpaepke.de
 *
 * @file ScrollMagic GSAP Animation Plugin.
 *
 * requires: GSAP ~1.14
 * Powered by the Greensock Animation Platform (GSAP): http://www.greensock.com/js
 * Greensock License info at http://www.greensock.com/licensing/
 */ /**
 * This plugin is meant to be used in conjunction with the Greensock Animation Plattform.  
 * It offers an easy API to trigger Tweens or synchronize them to the scrollbar movement.
 *
 * Both the `lite` and the `max` versions of the GSAP library are supported.  
 * The most basic requirement is `TweenLite`.
 * 
 * To have access to this extension, please include `plugins/animation.gsap.js`.
 * @requires {@link http://greensock.com/gsap|GSAP ~1.14.x}
 * @mixin animation.GSAP
 */ (function(root, factory) {
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([
        "ScrollMagic",
        "TweenMax",
        "TimelineMax"
    ], factory);
    else {
        // CommonJS
        // Loads whole gsap package onto global scope.
        (parcelRequire("4fEaA"));
        factory((parcelRequire("ctrgf")), TweenMax, TimelineMax);
    }
})($b486bddb010d3c4b$exports, function(ScrollMagic, Tween, Timeline) {
    "use strict";
    var NAMESPACE = "animation.gsap";
    var console = window.console || {}, err = Function.prototype.bind.call(console.error || console.log || function() {}, console);
    if (!ScrollMagic) err("(" + NAMESPACE + ") -> ERROR: The ScrollMagic main module could not be found. Please make sure it's loaded before this plugin or use an asynchronous loader like requirejs.");
    if (!Tween) err("(" + NAMESPACE + ") -> ERROR: TweenLite or TweenMax could not be found. Please make sure GSAP is loaded before ScrollMagic or use an asynchronous loader like requirejs.");
    /*
	 * ----------------------------------------------------------------
	 * Extensions for Scene
	 * ----------------------------------------------------------------
	 */ /**
	 * Every instance of ScrollMagic.Scene now accepts an additional option.  
	 * See {@link ScrollMagic.Scene} for a complete list of the standard options.
	 * @memberof! animation.GSAP#
	 * @method new ScrollMagic.Scene(options)
	 * @example
	 * var scene = new ScrollMagic.Scene({tweenChanges: true});
	 *
	 * @param {object} [options] - Options for the Scene. The options can be updated at any time.
	 * @param {boolean} [options.tweenChanges=false] - Tweens Animation to the progress target instead of setting it.  
	 												  Does not affect animations where duration is `0`.
	 */ /**
	 * **Get** or **Set** the tweenChanges option value.  
	 * This only affects scenes with a duration. If `tweenChanges` is `true`, the progress update when scrolling will not be immediate, but instead the animation will smoothly animate to the target state.  
	 * For a better understanding, try enabling and disabling this option in the [Scene Manipulation Example](../examples/basic/scene_manipulation.html).
	 * @memberof! animation.GSAP#
	 * @method Scene.tweenChanges
	 * 
	 * @example
	 * // get the current tweenChanges option
	 * var tweenChanges = scene.tweenChanges();
	 *
	 * // set new tweenChanges option
	 * scene.tweenChanges(true);
	 *
	 * @fires {@link Scene.change}, when used as setter
	 * @param {boolean} [newTweenChanges] - The new tweenChanges setting of the scene.
	 * @returns {boolean} `get` -  Current tweenChanges option value.
	 * @returns {Scene} `set` -  Parent object for chaining.
	 */ // add option (TODO: DOC (private for dev))
    ScrollMagic.Scene.addOption("tweenChanges", false, function(val) {
        return !!val;
    });
    // extend scene
    ScrollMagic.Scene.extend(function() {
        var Scene = this, _tween;
        var log = function() {
            if (Scene._log) {
                Array.prototype.splice.call(arguments, 1, 0, "(" + NAMESPACE + ")", "->");
                Scene._log.apply(this, arguments);
            }
        };
        // set listeners
        Scene.on("progress.plugin_gsap", function() {
            updateTweenProgress();
        });
        Scene.on("destroy.plugin_gsap", function(e) {
            Scene.removeTween(e.reset);
        });
        /**
		 * Update the tween progress to current position.
		 * @private
		 */ var updateTweenProgress = function() {
            if (_tween) {
                var progress = Scene.progress(), state = Scene.state();
                if (_tween.repeat && _tween.repeat() === -1) {
                    // infinite loop, so not in relation to progress
                    if (state === "DURING" && _tween.paused()) _tween.play();
                    else if (state !== "DURING" && !_tween.paused()) _tween.pause();
                } else if (progress != _tween.progress()) {
                    // no infinite loop - so should we just play or go to a specific point in time?
                    if (Scene.duration() === 0) {
                        // play the animation
                        if (progress > 0) _tween.play();
                        else _tween.reverse();
                    } else // go to a specific point in time
                    if (Scene.tweenChanges() && _tween.tweenTo) // go smooth
                    _tween.tweenTo(progress * _tween.duration());
                    else // just hard set it
                    _tween.progress(progress).pause();
                }
            }
        };
        /**
		 * Add a tween to the scene.  
		 * If you want to add multiple tweens, add them into a GSAP Timeline object and supply it instead (see example below).  
		 * 
		 * If the scene has a duration, the tween's duration will be projected to the scroll distance of the scene, meaning its progress will be synced to scrollbar movement.  
		 * For a scene with a duration of `0`, the tween will be triggered when scrolling forward past the scene's trigger position and reversed, when scrolling back.  
		 * To gain better understanding, check out the [Simple Tweening example](../examples/basic/simple_tweening.html).
		 *
		 * Instead of supplying a tween this method can also be used as a shorthand for `TweenMax.to()` (see example below).
		 * @memberof! animation.GSAP#
		 *
		 * @example
		 * // add a single tween directly
		 * scene.setTween(TweenMax.to("obj"), 1, {x: 100});
		 *
		 * // add a single tween via variable
		 * var tween = TweenMax.to("obj"), 1, {x: 100};
		 * scene.setTween(tween);
		 *
		 * // add multiple tweens, wrapped in a timeline.
		 * var timeline = new TimelineMax();
		 * var tween1 = TweenMax.from("obj1", 1, {x: 100});
		 * var tween2 = TweenMax.to("obj2", 1, {y: 100});
		 * timeline
		 *		.add(tween1)
		 *		.add(tween2);
		 * scene.addTween(timeline);
		 *
		 * // short hand to add a TweenMax.to() tween
		 * scene.setTween("obj3", 0.5, {y: 100});
		 *
		 * // short hand to add a TweenMax.to() tween for 1 second
		 * // this is useful, when the scene has a duration and the tween duration isn't important anyway
		 * scene.setTween("obj3", {y: 100});
		 *
		 * @param {(object|string)} TweenObject - A TweenMax, TweenLite, TimelineMax or TimelineLite object that should be animated in the scene. Can also be a Dom Element or Selector, when using direct tween definition (see examples).
		 * @param {(number|object)} duration - A duration for the tween, or tween parameters. If an object containing parameters are supplied, a default duration of 1 will be used.
		 * @param {object} params - The parameters for the tween
		 * @returns {Scene} Parent object for chaining.
		 */ Scene.setTween = function(TweenObject, duration, params) {
            var newTween;
            if (arguments.length > 1) {
                if (arguments.length < 3) {
                    params = duration;
                    duration = 1;
                }
                TweenObject = Tween.to(TweenObject, duration, params);
            }
            try {
                // wrap Tween into a Timeline Object if available to include delay and repeats in the duration and standardize methods.
                if (Timeline) newTween = new Timeline({
                    smoothChildTiming: true
                }).add(TweenObject);
                else newTween = TweenObject;
                newTween.pause();
            } catch (e) {
                log(1, "ERROR calling method 'setTween()': Supplied argument is not a valid TweenObject");
                return Scene;
            }
            if (_tween) Scene.removeTween();
            _tween = newTween;
            // some properties need to be transferred it to the wrapper, otherwise they would get lost.
            if (TweenObject.repeat && TweenObject.repeat() === -1) {
                _tween.repeat(-1);
                _tween.yoyo(TweenObject.yoyo());
            }
            // Some tween validations and debugging helpers
            if (Scene.tweenChanges() && !_tween.tweenTo) log(2, "WARNING: tweenChanges will only work if the TimelineMax object is available for ScrollMagic.");
            // check if there are position tweens defined for the trigger and warn about it :)
            if (_tween && Scene.controller() && Scene.triggerElement() && Scene.loglevel() >= 2) {
                var triggerTweens = Tween.getTweensOf(Scene.triggerElement()), vertical = Scene.controller().info("vertical");
                triggerTweens.forEach(function(value, index) {
                    var tweenvars = value.vars.css || value.vars, condition = vertical ? tweenvars.top !== undefined || tweenvars.bottom !== undefined : tweenvars.left !== undefined || tweenvars.right !== undefined;
                    if (condition) {
                        log(2, "WARNING: Tweening the position of the trigger element affects the scene timing and should be avoided!");
                        return false;
                    }
                });
            }
            // warn about tween overwrites, when an element is tweened multiple times
            if (parseFloat(TweenLite.version) >= 1.14) {
                var list = _tween.getChildren ? _tween.getChildren(true, true, false) : [
                    _tween
                ], newCallback = function() {
                    log(2, "WARNING: tween was overwritten by another. To learn how to avoid this issue see here: https://github.com/janpaepke/ScrollMagic/wiki/WARNING:-tween-was-overwritten-by-another");
                };
                for(var i = 0, thisTween, oldCallback; i < list.length; i++){
                    /*jshint loopfunc: true */ thisTween = list[i];
                    if (oldCallback !== newCallback) {
                        oldCallback = thisTween.vars.onOverwrite;
                        thisTween.vars.onOverwrite = function() {
                            if (oldCallback) oldCallback.apply(this, arguments);
                            newCallback.apply(this, arguments);
                        };
                    }
                }
            }
            log(3, "added tween");
            updateTweenProgress();
            return Scene;
        };
        /**
		 * Remove the tween from the scene.  
		 * This will terminate the control of the Scene over the tween.
		 *
		 * Using the reset option you can decide if the tween should remain in the current state or be rewound to set the target elements back to the state they were in before the tween was added to the scene.
		 * @memberof! animation.GSAP#
		 *
		 * @example
		 * // remove the tween from the scene without resetting it
		 * scene.removeTween();
		 *
		 * // remove the tween from the scene and reset it to initial position
		 * scene.removeTween(true);
		 *
		 * @param {boolean} [reset=false] - If `true` the tween will be reset to its initial values.
		 * @returns {Scene} Parent object for chaining.
		 */ Scene.removeTween = function(reset) {
            if (_tween) {
                if (reset) _tween.progress(0).pause();
                _tween.kill();
                _tween = undefined;
                log(3, "removed tween (reset: " + (reset ? "true" : "false") + ")");
            }
            return Scene;
        };
    });
});



function $c98f1d1f5da0e46b$var$_defineProperty(obj, key, value) {
    key = $c98f1d1f5da0e46b$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c98f1d1f5da0e46b$var$_toPropertyKey(arg) {
    var key = $c98f1d1f5da0e46b$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $c98f1d1f5da0e46b$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
class $c98f1d1f5da0e46b$var$Logo extends (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).Component {
    constructor(props){
        super(props);
        $c98f1d1f5da0e46b$var$_defineProperty(this, "logoIsClickable", (isClickable)=>{
            this.setState({
                isClickable: isClickable
            });
        });
        $c98f1d1f5da0e46b$var$_defineProperty(this, "handleClick", ()=>{
            if ((0, $9fbae048b55737ab$export$1e4fed98bcaa1d82)()) {
                if (this.state.isClickable) {
                    (0, (/*@__PURE__*/$parcel$interopDefault($c55b064831e1f1a0$exports))).polyfill();
                    const el = document.querySelector(".logoWord");
                    window.scrollTo({
                        top: el.offsetTop - window.innerHeight / 2 + 100,
                        left: 0,
                        behavior: "smooth"
                    });
                }
            } else if (this.state.isClickable) this.props.onLogoClick(true);
        });
        this.state = {
            isClickable: false // when the logo functions as the button to show mobile nav
        };
    }
    componentDidMount() {
        // load all the lines, convert Nodelist to array
        let els = [].slice.call(this._el.querySelectorAll(`.${(0, (/*@__PURE__*/$parcel$interopDefault($bd613b1f7513795e$exports))).logo} g > *`));
        const duration = 10.0;
        const delayVal = 0.2;
        let tl = new (0, $9fTje.default)();
        let breathingEffectLoop = new (0, $9fTje.default)({
            delay: .75 + duration,
            yoyo: true,
            repeat: -1,
            repeatDelay: 0
        });
        let top = "50vh";
        if ((0, $9fbae048b55737ab$export$d53806e03704a04e)()) top = "calc(50vh - 35px)";
        tl.to(this._el, 0, {
            top: top,
            transformY: "-50%"
        });
        tl.fromTo(this._el, 1.5, {
            opacity: 0
        }, {
            opacity: 1
        }, .4);
        tl.fromTo(els.slice(0, -1), // all lines except for the "7" icon
        8, {
            attr: {
                "stroke-width": .5
            }
        }, {
            delay: delayVal,
            attr: {
                "stroke-width": 5
            },
            ease: Power1.easeOut
        }, 0);
        tl.to(els[0], duration, {
            delay: delayVal,
            attr: {
                cx: 200
            }
        }, 0).to(els[1], duration, {
            delay: delayVal,
            attr: {
                cx: 360
            }
        }, 0).to([
            els[3],
            els[4]
        ], duration, {
            delay: delayVal,
            attr: {
                x1: 200,
                x2: 360
            }
        }, 0).to(els[5], duration, {
            delay: delayVal,
            attr: {
                x1: 200,
                x2: 360
            }
        }, 0).to(els[6], duration * .8, {
            delay: delayVal,
            attr: {
                y2: 307
            }
        }, 0).to(els[7], duration * .3, {
            opacity: 1,
            delay: duration * .3
        }, 0);
        if ((0, $9fbae048b55737ab$export$d0a8044dce8ff2fc)()) // exaggerate breathing effect on smaller screens
        breathingEffectLoop.to(els[0], duration / 2, {
            ease: Power1.easeInOut,
            attr: {
                cx: 191
            }
        }, 0).to(els[1], duration / 2, {
            ease: Power1.easeInOut,
            attr: {
                cx: 369
            }
        }, 0).to([
            els[3],
            els[4]
        ], duration / 2, {
            ease: Power1.easeInOut,
            attr: {
                x1: 191,
                x2: 369
            }
        }, 0).to(els[5], duration / 2, {
            ease: Power1.easeInOut,
            attr: {
                x1: 207,
                x2: 353
            }
        }, 0).to(els[6], duration / 2 * .8, {
            ease: Power1.easeInOut,
            attr: {
                y2: 305
            }
        }, 0);
        else breathingEffectLoop.to(els[0], duration / 2, {
            ease: Power1.easeInOut,
            attr: {
                cx: 195
            }
        }, 0).to(els[1], duration / 2, {
            ease: Power1.easeInOut,
            attr: {
                cx: 365
            }
        }, 0).to([
            els[3],
            els[4]
        ], duration / 2, {
            ease: Power1.easeInOut,
            attr: {
                x1: 195,
                x2: 365
            }
        }, 0).to(els[5], duration / 2, {
            ease: Power1.easeInOut,
            attr: {
                x1: 205,
                x2: 355
            }
        }, 0).to(els[6], duration / 2 * .8, {
            ease: Power1.easeInOut,
            attr: {
                y2: 304
            }
        }, 0);
        // Shrink on scroll
        let controller = new (0, (/*@__PURE__*/$parcel$interopDefault($ctrgf))).Controller();
        if ((0, $9fbae048b55737ab$export$1e4fed98bcaa1d82)()) {
            let tween = (0, $876af.default).to(this._el, 1, {
                top: 10,
                scale: .2,
                opacity: .5
            });
            let scene = new (0, (/*@__PURE__*/$parcel$interopDefault($ctrgf))).Scene({
                duration: 250
            }).setTween(tween).addTo(controller);
            let that = this;
            let scene2 = new (0, (/*@__PURE__*/$parcel$interopDefault($ctrgf))).Scene({
                offset: 250
            }).on("enter leave", (e)=>{
                // console.log(e.type == "enter" ? "inside" : "outside")
                if (e.type == "enter") that.logoIsClickable(true);
                else that.logoIsClickable(false);
            }).addTo(controller);
        } else {
            let tween = new (0, $9fTje.default)().to(this._el, .5, {
                opacity: 0
            }).to(this._el, 0, {
                top: 10,
                width: 120,
                height: 73
            }).to(this._el, .5, {
                opacity: .5
            });
            let that = this;
            let scene = new (0, (/*@__PURE__*/$parcel$interopDefault($ctrgf))).Scene({
                offset: 5
            }).setTween(tween).on("enter leave", (e)=>{
                // console.log(e.type == "enter" ? "inside" : "outside")
                if (e.type == "enter") setTimeout(()=>{
                    that.logoIsClickable(true);
                }, 1000);
                else {
                    // close nav if it's open and user scrolls to top
                    // to avoid animation glitch on mobile
                    this.props.onLogoClick("scrolled to top");
                    that.logoIsClickable(false);
                }
            }).addTo(controller);
        }
        // this was too slow, no longer including it
        // var scene = new ScrollMagic.Scene({offset: 10})
        //   // trigger animation by adding a css class
        //   .setClassToggle(this._el, Cx(styles.logoScroll))
        //   .addIndicators({name: "1 - hide seven"}) // add indicators (requires plugin)
        //   .addTo(controller);
        const scene2 = new (0, (/*@__PURE__*/$parcel$interopDefault($ctrgf))).Scene({
            offset: 200
        })// trigger animation by adding a css class
        .setClassToggle("." + (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($bd613b1f7513795e$exports))).seven), (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($bd613b1f7513795e$exports))).sevenScroll)).addTo(controller);
    }
    render() {
        const className = (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))("logo", (0, (/*@__PURE__*/$parcel$interopDefault($bd613b1f7513795e$exports))).logo, {
            [(0, (/*@__PURE__*/$parcel$interopDefault($bd613b1f7513795e$exports))).navMobileIsOpen]: this.props.navMobileIsOpen
        }, {
            [(0, (/*@__PURE__*/$parcel$interopDefault($bd613b1f7513795e$exports))).isClickable]: this.state.isClickable
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("svg", {
            className: className,
            viewBox: "0 0 560 340",
            alt: "Tribe7 logo",
            title: "",
            ref: (c)=>{
                this._el = c;
            },
            onClick: this.handleClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("circle", {
            cx: "160",
            cy: "170",
            r: "160",
            stroke: "white",
            strokeWidth: "1",
            fill: "none",
            id: "circ1"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("circle", {
            cx: "400",
            cy: "170",
            r: "160",
            stroke: "white",
            strokeWidth: "1",
            fill: "none",
            id: "circ2"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("circle", {
            cx: "280",
            cy: "170",
            r: "160",
            stroke: "white",
            strokeWidth: "1",
            fill: "none",
            id: "circ3"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("line", {
            x1: "160",
            y1: "10",
            x2: "400",
            y2: "10",
            stroke: "white",
            strokeWidth: "1",
            id: "line1"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("line", {
            x1: "160",
            y1: "330",
            x2: "400",
            y2: "330",
            stroke: "white",
            strokeWidth: "1",
            id: "line2"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("line", {
            x1: "240",
            y1: "170",
            x2: "320",
            y2: "170",
            stroke: "white",
            strokeWidth: "1",
            id: "line3"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("line", {
            x1: "280",
            y1: "170",
            x2: "280",
            y2: "276",
            stroke: "white",
            strokeWidth: "1",
            id: "line4"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("polygon", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($bd613b1f7513795e$exports))).seven),
            id: "seven",
            fill: "white",
            points: "371.1,168.2 371.1,169.8 378.2,169.8 372.4,182 374.3,182 380,169.8 380,168.2 "
        })));
    }
}
var $c98f1d1f5da0e46b$export$2e2bcd8739ae039 = $c98f1d1f5da0e46b$var$Logo;



var $g85JO = parcelRequire("g85JO");

var $5a69c22399ef8376$exports = {};

$parcel$export($5a69c22399ef8376$exports, "wrap", function () { return $5a69c22399ef8376$export$4997ffc0176396a6; }, function (v) { return $5a69c22399ef8376$export$4997ffc0176396a6 = v; });
$parcel$export($5a69c22399ef8376$exports, "arrow", function () { return $5a69c22399ef8376$export$f2120bbfa5450bd2; }, function (v) { return $5a69c22399ef8376$export$f2120bbfa5450bd2 = v; });
$parcel$export($5a69c22399ef8376$exports, "arrowHide", function () { return $5a69c22399ef8376$export$4335504412a0549b; }, function (v) { return $5a69c22399ef8376$export$4335504412a0549b = v; });
$parcel$export($5a69c22399ef8376$exports, "hoverText", function () { return $5a69c22399ef8376$export$789464e77a4b51cf; }, function (v) { return $5a69c22399ef8376$export$789464e77a4b51cf = v; });
$parcel$export($5a69c22399ef8376$exports, "arrowRemoveMobile", function () { return $5a69c22399ef8376$export$ae8fca699fc80f7c; }, function (v) { return $5a69c22399ef8376$export$ae8fca699fc80f7c = v; });
var $5a69c22399ef8376$export$4997ffc0176396a6;
var $5a69c22399ef8376$export$f2120bbfa5450bd2;
var $5a69c22399ef8376$export$4335504412a0549b;
var $5a69c22399ef8376$export$789464e77a4b51cf;
var $5a69c22399ef8376$export$ae8fca699fc80f7c;
$5a69c22399ef8376$export$4997ffc0176396a6 = "_app-components-Arrow-_styles__wrap";
$5a69c22399ef8376$export$f2120bbfa5450bd2 = "_app-components-Arrow-_styles__arrow";
$5a69c22399ef8376$export$4335504412a0549b = "_app-components-Arrow-_styles__arrowHide";
$5a69c22399ef8376$export$789464e77a4b51cf = "_app-components-Arrow-_styles__hoverText";
$5a69c22399ef8376$export$ae8fca699fc80f7c = "_app-components-Arrow-_styles__arrowRemoveMobile";


parcelRequire("4fEaA");
var $9fTje = parcelRequire("9fTje");

var $ctrgf = parcelRequire("ctrgf");




function $71163170f3a5b83f$var$_defineProperty(obj, key, value) {
    key = $71163170f3a5b83f$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $71163170f3a5b83f$var$_toPropertyKey(arg) {
    var key = $71163170f3a5b83f$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $71163170f3a5b83f$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
class $71163170f3a5b83f$var$Arrow extends (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).Component {
    constructor(...args){
        super(...args);
        $71163170f3a5b83f$var$_defineProperty(this, "heightOverride", ()=>{
            // https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
            if ((0, $9fbae048b55737ab$export$d0a8044dce8ff2fc)() || (0, $9fbae048b55737ab$export$6d66bc094862134e)() && (0, $9fbae048b55737ab$export$d53806e03704a04e)()) return {
                bottom: "auto",
                top: `${window.innerHeight * .9 - 18}px`
            };
        });
    }
    componentDidMount() {
        let tl = new (0, $9fTje.default)();
        tl.fromTo(this._wrap, 1, {
            scaleY: 0
        }, {
            scaleY: 1,
            delay: 3.5
        });
        let controller = new (0, (/*@__PURE__*/$parcel$interopDefault($ctrgf))).Controller();
        let scene = new (0, (/*@__PURE__*/$parcel$interopDefault($ctrgf))).Scene({
            offset: 50
        })// trigger animation by adding a css class
        .setClassToggle(this._wrap, (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($5a69c22399ef8376$exports))).arrowHide)).addTo(controller);
    }
    scrollDown() {
        (0, (/*@__PURE__*/$parcel$interopDefault($c55b064831e1f1a0$exports))).polyfill();
        const el = document.querySelector(".logoWord");
        window.scrollTo({
            top: el.offsetTop - window.innerHeight / 2 + 100,
            left: 0,
            behavior: "smooth"
        });
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($5a69c22399ef8376$exports))).wrap),
            ref: (c)=>{
                this._wrap = c;
            },
            style: this.heightOverride()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("svg", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($5a69c22399ef8376$exports))).arrow),
            ref: (c)=>{
                this._el = c;
            },
            viewBox: "0 0 56.4 25.7"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("polyline", {
            strokeWidth: "2",
            fill: "transparent",
            stroke: "white",
            points: "0.3,0.4 28.2,25 56,0.4  "
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($5a69c22399ef8376$exports))).hoverText),
            onClick: this.scrollDown
        }, "SCROLL"));
    }
}
var $71163170f3a5b83f$export$2e2bcd8739ae039 = $71163170f3a5b83f$var$Arrow;



var $g85JO = parcelRequire("g85JO");

var $954090d17346e6c7$exports = {};

$parcel$export($954090d17346e6c7$exports, "logoWord", function () { return $954090d17346e6c7$export$9ac4ffbac5f53a85; }, function (v) { return $954090d17346e6c7$export$9ac4ffbac5f53a85 = v; });
$parcel$export($954090d17346e6c7$exports, "logoWordScroll", function () { return $954090d17346e6c7$export$242e3e8709e91a1; }, function (v) { return $954090d17346e6c7$export$242e3e8709e91a1 = v; });
var $954090d17346e6c7$export$9ac4ffbac5f53a85;
var $954090d17346e6c7$export$242e3e8709e91a1;
$954090d17346e6c7$export$9ac4ffbac5f53a85 = "_app-components-LogoWord-_styles__logoWord";
$954090d17346e6c7$export$242e3e8709e91a1 = "_app-components-LogoWord-_styles__logoWordScroll";




var $ctrgf = parcelRequire("ctrgf");


var $637368d86b52850d$exports = {};


$637368d86b52850d$exports = (parcelRequire("kSeqf")).getBundleURL("kqVE6") + (parcelRequire("7wgKE")).resolve("czVhU");


class $edfa5b392bfc3940$var$logoWord extends (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).Component {
    componentDidMount() {
        if (!(0, $9fbae048b55737ab$export$fedb369cb70207f1)() && (0, $9fbae048b55737ab$export$1e4fed98bcaa1d82)()) {
            let controller = new (0, (/*@__PURE__*/$parcel$interopDefault($ctrgf))).Controller();
            let scene = new (0, (/*@__PURE__*/$parcel$interopDefault($ctrgf))).Scene({
                offset: this._el.offsetTop - window.innerHeight + 180
            })// trigger animation by adding a css class
            .setClassToggle(this._el, (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($954090d17346e6c7$exports))).logoWordScroll)).addTo(controller);
        }
    }
    render() {
        // logoWord class is referenced in Arrow component
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("img", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($954090d17346e6c7$exports))).logoWord, "navPin logoWord"),
            "data-navtitle": "Tribe<sup>7</sup>",
            ref: (c)=>{
                this._el = c;
            },
            src: (0, (/*@__PURE__*/$parcel$interopDefault($637368d86b52850d$exports)))
        });
    }
}
var $edfa5b392bfc3940$export$2e2bcd8739ae039 = $edfa5b392bfc3940$var$logoWord;



var $g85JO = parcelRequire("g85JO");

var $3b5a92eb63d3e259$exports = {};

$parcel$export($3b5a92eb63d3e259$exports, "logoBlackwing", function () { return $3b5a92eb63d3e259$export$b5445ea5e895e52b; }, function (v) { return $3b5a92eb63d3e259$export$b5445ea5e895e52b = v; });
$parcel$export($3b5a92eb63d3e259$exports, "blackwingSeven", function () { return $3b5a92eb63d3e259$export$a48fd22995bf0c6a; }, function (v) { return $3b5a92eb63d3e259$export$a48fd22995bf0c6a = v; });
var $3b5a92eb63d3e259$export$b5445ea5e895e52b;
var $3b5a92eb63d3e259$export$a48fd22995bf0c6a;
$3b5a92eb63d3e259$export$b5445ea5e895e52b = "_app-components-LogoBlackwing-_styles__logoBlackwing";
$3b5a92eb63d3e259$export$a48fd22995bf0c6a = "_app-components-LogoBlackwing-_styles__blackwingSeven";


parcelRequire("4fEaA");
var $9fTje = parcelRequire("9fTje");

var $ctrgf = parcelRequire("ctrgf");


class $797ac14f841220e6$var$LogoBlackwing extends (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).Component {
    componentDidMount() {
        let controller = new (0, (/*@__PURE__*/$parcel$interopDefault($ctrgf))).Controller();
        let tween = new (0, $9fTje.default)().fromTo("#blackwingTop", 2.4, {
            scaleX: 0,
            transformOrigin: "50% 50%"
        }, {
            scaleX: 1,
            transformOrigin: "50% 50%",
            ease: Power4.easeOut
        }, 0).fromTo("#blackwingBottom", 2, {
            scale: 0,
            transformOrigin: "50% 50%"
        }, {
            scale: 1,
            transformOrigin: "50% 50%",
            ease: Power4.easeOut
        }, 0).fromTo("#blackwingSeven", .8, {
            opacity: 0
        }, {
            delay: 1,
            opacity: 1
        }, 0);
        const scene = new (0, (/*@__PURE__*/$parcel$interopDefault($ctrgf))).Scene({
            triggerElement: this._el,
            offset: 0 - window.innerHeight / 2 + 30
        }).setTween(tween)// .addIndicators({name: "blackwing - 1 (duration: 0)"}) // add indicators (requires plugin)
        .addTo(controller);
    }
    render() {
        const className = (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($3b5a92eb63d3e259$exports))).logoBlackwing);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement((0, $g85JO.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("svg", {
            className: className,
            viewBox: "0 0 248.3 124.2",
            alt: "Blackwing logo",
            ref: (c)=>{
                this._el = c;
            }
        }, ">", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("filter", {
            id: "sofGlow",
            height: "300%",
            width: "300%",
            x: "-75%",
            y: "-75%"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("feMorphology", {
            operator: "dilate",
            radius: "1",
            in: "SourceAlpha",
            result: "thicken"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("feGaussianBlur", {
            in: "thicken",
            stdDeviation: "3",
            result: "blurred"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("feFlood", {
            floodColor: "rgba(255,255,255,.5)",
            result: "glowColor"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("feComposite", {
            in: "glowColor",
            in2: "blurred",
            operator: "in",
            result: "softGlow_colored"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("feMerge", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("feMergeNode", {
            in: "softGlow_colored"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("feMergeNode", {
            in: "SourceGraphic"
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("path", {
            id: "blackwingTop",
            fill: "black",
            d: "M248.3,0c-5.6,13-13.3,25-22.5,35.5H22.4C13.2,25.1,5.6,13.2,0,0.3V0H248.3z"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("path", {
            id: "blackwingBottom",
            fill: "black",
            d: "M159.6,88.7c0,19.6-15.9,35.5-35.5,35.5s-35.5-15.9-35.5-35.5s15.9-35.5,35.5-35.5S159.6,69.1,159.6,88.7"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("polygon", {
            id: "blackwingSeven",
            filter: "url(#sofGlow)",
            fill: "white",
            points: "171.3,60.3 171.3,61.4 176.2,61.4 172.2,69.8 173.5,69.8 177.5,61.4 177.5,60.3 "
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("div", {
            "data-navtitle": "Blackwing<sup>7</sup>",
            className: "navPin",
            style: {
                position: "relative",
                top: "75px"
            }
        }));
    }
}
var $797ac14f841220e6$export$2e2bcd8739ae039 = $797ac14f841220e6$var$LogoBlackwing;




var $g85JO = parcelRequire("g85JO");

var $70ed86982437d08d$exports = {};

$parcel$export($70ed86982437d08d$exports, "textBox", function () { return $70ed86982437d08d$export$1fba60a20f17ac3e; }, function (v) { return $70ed86982437d08d$export$1fba60a20f17ac3e = v; });
$parcel$export($70ed86982437d08d$exports, "keepOnMobile", function () { return $70ed86982437d08d$export$8daca794ec780bc7; }, function (v) { return $70ed86982437d08d$export$8daca794ec780bc7 = v; });
$parcel$export($70ed86982437d08d$exports, "textBoxShow", function () { return $70ed86982437d08d$export$1d9f83c02298c4fe; }, function (v) { return $70ed86982437d08d$export$1d9f83c02298c4fe = v; });
$parcel$export($70ed86982437d08d$exports, "trigger", function () { return $70ed86982437d08d$export$e614dc9140f7ae71; }, function (v) { return $70ed86982437d08d$export$e614dc9140f7ae71 = v; });
$parcel$export($70ed86982437d08d$exports, "textBoxCol1", function () { return $70ed86982437d08d$export$4d9a33a31eccde07; }, function (v) { return $70ed86982437d08d$export$4d9a33a31eccde07 = v; });
$parcel$export($70ed86982437d08d$exports, "textBoxCol2", function () { return $70ed86982437d08d$export$5c2c18bc51780b92; }, function (v) { return $70ed86982437d08d$export$5c2c18bc51780b92 = v; });
$parcel$export($70ed86982437d08d$exports, "textBoxCol3", function () { return $70ed86982437d08d$export$bf650144640c7519; }, function (v) { return $70ed86982437d08d$export$bf650144640c7519 = v; });
$parcel$export($70ed86982437d08d$exports, "textBoxCol4", function () { return $70ed86982437d08d$export$72d59a3db23e5474; }, function (v) { return $70ed86982437d08d$export$72d59a3db23e5474 = v; });
$parcel$export($70ed86982437d08d$exports, "textBoxCol5", function () { return $70ed86982437d08d$export$787e1a56954cc753; }, function (v) { return $70ed86982437d08d$export$787e1a56954cc753 = v; });
$parcel$export($70ed86982437d08d$exports, "textBoxCol6", function () { return $70ed86982437d08d$export$cece9eb7b5184411; }, function (v) { return $70ed86982437d08d$export$cece9eb7b5184411 = v; });
$parcel$export($70ed86982437d08d$exports, "textBoxCol7", function () { return $70ed86982437d08d$export$b5fe32d149516c22; }, function (v) { return $70ed86982437d08d$export$b5fe32d149516c22 = v; });
var $70ed86982437d08d$export$1fba60a20f17ac3e;
var $70ed86982437d08d$export$8daca794ec780bc7;
var $70ed86982437d08d$export$1d9f83c02298c4fe;
var $70ed86982437d08d$export$e614dc9140f7ae71;
var $70ed86982437d08d$export$4d9a33a31eccde07;
var $70ed86982437d08d$export$5c2c18bc51780b92;
var $70ed86982437d08d$export$bf650144640c7519;
var $70ed86982437d08d$export$72d59a3db23e5474;
var $70ed86982437d08d$export$787e1a56954cc753;
var $70ed86982437d08d$export$cece9eb7b5184411;
var $70ed86982437d08d$export$b5fe32d149516c22;
$70ed86982437d08d$export$1fba60a20f17ac3e = "_app-components-TextBox-_styles__textBox";
$70ed86982437d08d$export$8daca794ec780bc7 = "_app-components-TextBox-_styles__keepOnMobile";
$70ed86982437d08d$export$1d9f83c02298c4fe = "_app-components-TextBox-_styles__textBoxShow";
$70ed86982437d08d$export$e614dc9140f7ae71 = "_app-components-TextBox-_styles__trigger";
$70ed86982437d08d$export$4d9a33a31eccde07 = "_app-components-TextBox-_styles__textBoxCol1";
$70ed86982437d08d$export$5c2c18bc51780b92 = "_app-components-TextBox-_styles__textBoxCol2";
$70ed86982437d08d$export$bf650144640c7519 = "_app-components-TextBox-_styles__textBoxCol3";
$70ed86982437d08d$export$72d59a3db23e5474 = "_app-components-TextBox-_styles__textBoxCol4";
$70ed86982437d08d$export$787e1a56954cc753 = "_app-components-TextBox-_styles__textBoxCol5";
$70ed86982437d08d$export$cece9eb7b5184411 = "_app-components-TextBox-_styles__textBoxCol6";
$70ed86982437d08d$export$b5fe32d149516c22 = "_app-components-TextBox-_styles__textBoxCol7";



parcelRequire("4fEaA");
var $876af = parcelRequire("876af");

var $ctrgf = parcelRequire("ctrgf");

class $73b8290289195dfa$var$TextBox extends (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).Component {
    componentDidMount() {
        if (!(0, $9fbae048b55737ab$export$fedb369cb70207f1)() && (0, $9fbae048b55737ab$export$1e4fed98bcaa1d82)()) {
            const controller = new (0, (/*@__PURE__*/$parcel$interopDefault($ctrgf))).Controller();
            // apply parallax effect
            const tween = new TimelineMax().add([
                (0, $876af.default).fromTo(this._el, 1, {
                    y: this.props.yFrom
                }, {
                    y: this.props.yTo,
                    ease: Linear.easeNone
                })
            ]);
            new (0, (/*@__PURE__*/$parcel$interopDefault($ctrgf))).Scene({
                triggerElement: this._trigger,
                duration: window.innerHeight
            }).setTween(tween).addTo(controller);
            // apply fade/slide in effect
            new (0, (/*@__PURE__*/$parcel$interopDefault($ctrgf))).Scene({
                triggerElement: this._trigger,
                offset: this.props.yFrom * .85
            }).setClassToggle(this._el, (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($70ed86982437d08d$exports))).textBoxShow)).addTo(controller);
        }
    }
    render() {
        // randomly vary the slide-in animation speed between .75-1.5s
        const transition = `opacity .8s, top ${Math.random() * .75 + .75}s`;
        const opacity = !(0, $9fbae048b55737ab$export$fedb369cb70207f1)() && (0, $9fbae048b55737ab$export$1e4fed98bcaa1d82)() ? 0 : 1;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement((0, $g85JO.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($70ed86982437d08d$exports))).trigger,
            ref: (c)=>{
                this._trigger = c;
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($70ed86982437d08d$exports))).textBox, {
                "navPin": this.props.isPin
            }, {
                [(0, (/*@__PURE__*/$parcel$interopDefault($70ed86982437d08d$exports))).keepOnMobile]: this.props.keepLineBreaksOnMobile
            }, (0, (/*@__PURE__*/$parcel$interopDefault($70ed86982437d08d$exports)))[`textBoxCol${this.props.col}`]),
            ref: (c)=>{
                this._el = c;
            },
            style: {
                opacity: // left: left,
                // width: width,
                opacity,
                transition: transition
            }
        }, this.props.children));
    }
}
var $73b8290289195dfa$export$2e2bcd8739ae039 = $73b8290289195dfa$var$TextBox;



var $g85JO = parcelRequire("g85JO");


var $g85JO = parcelRequire("g85JO");

var $1561601a55b8cdf0$exports = {};
/**
 * Module dependencies
 */ 
var $1561601a55b8cdf0$var$debug = (parcelRequire("igG5D"))("jsonp");
/**
 * Module exports.
 */ $1561601a55b8cdf0$exports = $1561601a55b8cdf0$var$jsonp;
/**
 * Callback index.
 */ var $1561601a55b8cdf0$var$count = 0;
/**
 * Noop function.
 */ function $1561601a55b8cdf0$var$noop() {}
/**
 * JSONP handler
 *
 * Options:
 *  - param {String} qs parameter (`callback`)
 *  - prefix {String} qs parameter (`__jp`)
 *  - name {String} qs parameter (`prefix` + incr)
 *  - timeout {Number} how long after a timeout error is emitted (`60000`)
 *
 * @param {String} url
 * @param {Object|Function} optional options / callback
 * @param {Function} optional callback
 */ function $1561601a55b8cdf0$var$jsonp(url, opts, fn) {
    if ("function" == typeof opts) {
        fn = opts;
        opts = {};
    }
    if (!opts) opts = {};
    var prefix = opts.prefix || "__jp";
    // use the callback name that was passed if one was provided.
    // otherwise generate a unique name by incrementing our counter.
    var id = opts.name || prefix + $1561601a55b8cdf0$var$count++;
    var param = opts.param || "callback";
    var timeout = null != opts.timeout ? opts.timeout : 60000;
    var enc = encodeURIComponent;
    var target = document.getElementsByTagName("script")[0] || document.head;
    var script;
    var timer;
    if (timeout) timer = setTimeout(function() {
        cleanup();
        if (fn) fn(new Error("Timeout"));
    }, timeout);
    function cleanup() {
        if (script.parentNode) script.parentNode.removeChild(script);
        window[id] = $1561601a55b8cdf0$var$noop;
        if (timer) clearTimeout(timer);
    }
    function cancel() {
        if (window[id]) cleanup();
    }
    window[id] = function(data) {
        $1561601a55b8cdf0$var$debug("jsonp got", data);
        cleanup();
        if (fn) fn(null, data);
    };
    // add qs component
    url += (~url.indexOf("?") ? "&" : "?") + param + "=" + enc(id);
    url = url.replace("?&", "?");
    $1561601a55b8cdf0$var$debug('jsonp req "%s"', url);
    // create script
    script = document.createElement("script");
    script.src = url;
    target.parentNode.insertBefore(script, target);
    return cancel;
}


var $4b90e8805b602d38$exports = {};
!function(e, t) {
    $4b90e8805b602d38$exports = t();
}("undefined" != typeof self ? self : $4b90e8805b602d38$exports, function() {
    return function(e) {
        function t(o) {
            if (n[o]) return n[o].exports;
            var r = n[o] = {
                i: o,
                l: !1,
                exports: {}
            };
            return e[o].call(r.exports, r, r.exports, t), r.l = !0, r.exports;
        }
        var n = {};
        return t.m = e, t.c = n, t.d = function(e, n, o) {
            t.o(e, n) || Object.defineProperty(e, n, {
                configurable: !1,
                enumerable: !0,
                get: o
            });
        }, t.n = function(e) {
            var n = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return t.d(n, "a", n), n;
        }, t.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, t.p = "", t(t.s = 0);
    }([
        function(e, t, n) {
            "use strict";
            function o(e, t, n) {
                if ("object" === (void 0 === t ? "undefined" : i(t))) return "" + u(t, "" + n + ("" + e + (n && "]") + "["));
                return n && n.length ? "" + n + e + "]=" + encodeURIComponent(t) : e + "=" + encodeURIComponent(t);
            }
            function r(e, t, n) {
                return t.map(function(t) {
                    return o(e, t, n);
                }).join("&");
            }
            function u(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "", n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, u = n.arrayPrefix || "", i = [];
                return i = Array.isArray(e) ? e.map(function(e, n) {
                    return o("" + n + u, e, t);
                }) : Object.keys(e).filter(function(t) {
                    return void 0 !== e[t];
                }).map(function(n) {
                    return e[n] && Array.isArray(e[n]) ? r("" + n + u, e[n], t) : o(n, e[n], t);
                }), i.join("&").replace(/%20/g, "+");
            }
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            };
            t.default = u;
        }
    ]);
});



var $g85JO = parcelRequire("g85JO");

var $f12c4da085369b60$exports = {};

$parcel$export($f12c4da085369b60$exports, "wrap", function () { return $f12c4da085369b60$export$4997ffc0176396a6; }, function (v) { return $f12c4da085369b60$export$4997ffc0176396a6 = v; });
$parcel$export($f12c4da085369b60$exports, "notice", function () { return $f12c4da085369b60$export$b31f6ae88848cf15; }, function (v) { return $f12c4da085369b60$export$b31f6ae88848cf15 = v; });
$parcel$export($f12c4da085369b60$exports, "success", function () { return $f12c4da085369b60$export$fe7c49d056ea1d88; }, function (v) { return $f12c4da085369b60$export$fe7c49d056ea1d88 = v; });
$parcel$export($f12c4da085369b60$exports, "form", function () { return $f12c4da085369b60$export$6210fa4921d2a466; }, function (v) { return $f12c4da085369b60$export$6210fa4921d2a466 = v; });
$parcel$export($f12c4da085369b60$exports, "line", function () { return $f12c4da085369b60$export$53f1d5ea8de3d7c; }, function (v) { return $f12c4da085369b60$export$53f1d5ea8de3d7c = v; });
$parcel$export($f12c4da085369b60$exports, "lineShow", function () { return $f12c4da085369b60$export$9519373988617a1f; }, function (v) { return $f12c4da085369b60$export$9519373988617a1f = v; });
$parcel$export($f12c4da085369b60$exports, "buttonShow", function () { return $f12c4da085369b60$export$942277c7b129ea21; }, function (v) { return $f12c4da085369b60$export$942277c7b129ea21 = v; });
$parcel$export($f12c4da085369b60$exports, "tLogo", function () { return $f12c4da085369b60$export$a5462297a432921; }, function (v) { return $f12c4da085369b60$export$a5462297a432921 = v; });
$parcel$export($f12c4da085369b60$exports, "externalLinkButton", function () { return $f12c4da085369b60$export$f02cbb504f26b596; }, function (v) { return $f12c4da085369b60$export$f02cbb504f26b596 = v; });
var $f12c4da085369b60$export$4997ffc0176396a6;
var $f12c4da085369b60$export$b31f6ae88848cf15;
var $f12c4da085369b60$export$fe7c49d056ea1d88;
var $f12c4da085369b60$export$6210fa4921d2a466;
var $f12c4da085369b60$export$53f1d5ea8de3d7c;
var $f12c4da085369b60$export$9519373988617a1f;
var $f12c4da085369b60$export$942277c7b129ea21;
var $f12c4da085369b60$export$a5462297a432921;
var $f12c4da085369b60$export$f02cbb504f26b596;
$f12c4da085369b60$export$4997ffc0176396a6 = "_app-components-MailchimpSimpleForm-_styles__wrap";
$f12c4da085369b60$export$b31f6ae88848cf15 = "_app-components-MailchimpSimpleForm-_styles__notice";
$f12c4da085369b60$export$fe7c49d056ea1d88 = "_app-components-MailchimpSimpleForm-_styles__success";
$f12c4da085369b60$export$6210fa4921d2a466 = "_app-components-MailchimpSimpleForm-_styles__form";
$f12c4da085369b60$export$53f1d5ea8de3d7c = "_app-components-MailchimpSimpleForm-_styles__line";
$f12c4da085369b60$export$9519373988617a1f = "_app-components-MailchimpSimpleForm-_styles__lineShow";
$f12c4da085369b60$export$942277c7b129ea21 = "_app-components-MailchimpSimpleForm-_styles__buttonShow";
$f12c4da085369b60$export$a5462297a432921 = "_app-components-MailchimpSimpleForm-_styles__tLogo";
$f12c4da085369b60$export$f02cbb504f26b596 = "_app-components-MailchimpSimpleForm-_styles__externalLinkButton";



var $g85JO = parcelRequire("g85JO");

var $23ec7c0a46e8ca35$exports = {};

$parcel$export($23ec7c0a46e8ca35$exports, "logoBlackwing", function () { return $23ec7c0a46e8ca35$export$b5445ea5e895e52b; }, function (v) { return $23ec7c0a46e8ca35$export$b5445ea5e895e52b = v; });
var $23ec7c0a46e8ca35$export$b5445ea5e895e52b;
$23ec7c0a46e8ca35$export$b5445ea5e895e52b = "_app-components-LogoBlackwingSignup-_styles__logoBlackwing";


parcelRequire("4fEaA");
var $9fTje = parcelRequire("9fTje");
class $cb88c98f1b4dfca5$var$LogoBlackwingSignup extends (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).Component {
    componentDidMount() {
        let tween = new (0, $9fTje.default)().fromTo(this._el, 2, {
            y: -50
        }, {
            y: -130
        }, 0).fromTo("#blackwingSignupTop", 2.5, {
            scaleX: 0,
            transformOrigin: "50% 50%"
        }, {
            scaleX: 1,
            transformOrigin: "50% 50%",
            ease: Power4.easeOut
        }, 0).fromTo("#blackwingSignupBottom", 2, {
            scale: 0,
            transformOrigin: "50% 50%"
        }, {
            scale: 1,
            transformOrigin: "50% 50%",
            ease: Power4.easeOut
        }, 0);
    }
    render() {
        const className = (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($23ec7c0a46e8ca35$exports))).logoBlackwing);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("svg", {
            className: className,
            viewBox: "0 0 248.3 124.2",
            alt: "Blackwing logo -- signup successful",
            ref: (c)=>{
                this._el = c;
            }
        }, ">", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("path", {
            id: "blackwingSignupTop",
            fill: "white",
            d: "M248.3,0c-5.6,13-13.3,25-22.5,35.5H22.4C13.2,25.1,5.6,13.2,0,0.3V0H248.3z"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("path", {
            id: "blackwingSignupBottom",
            fill: "white",
            d: "M159.6,88.7c0,19.6-15.9,35.5-35.5,35.5s-35.5-15.9-35.5-35.5s15.9-35.5,35.5-35.5S159.6,69.1,159.6,88.7"
        })));
    }
}
var $cb88c98f1b4dfca5$export$2e2bcd8739ae039 = $cb88c98f1b4dfca5$var$LogoBlackwingSignup;



var $g85JO = parcelRequire("g85JO");

parcelRequire("4fEaA");
var $9fTje = parcelRequire("9fTje");
class $84b504dfacdae796$var$ThankYou extends (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).Component {
    componentDidMount() {
        console.log("ThankYou mounted");
        let tween = new (0, $9fTje.default)().fromTo(this._el, 2, {
            y: -60
        }, {
            y: -110
        }, .3).fromTo(this._el, 1.5, {
            opacity: 0
        }, {
            opacity: 1
        }, .3);
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("div", {
            ref: (c)=>{
                this._el = c;
            },
            style: {
                willChange: "transform"
            }
        }, "THANK YOU");
    }
}
var $84b504dfacdae796$export$2e2bcd8739ae039 = $84b504dfacdae796$var$ThankYou;


var $c62d58e015264f54$exports = {};


$c62d58e015264f54$exports = (parcelRequire("kSeqf")).getBundleURL("kqVE6") + (parcelRequire("7wgKE")).resolve("d5NVk");




var $ctrgf = parcelRequire("ctrgf");

class $cbce4e4d3a00e62d$var$MailchimpSimpleForm extends (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).Component {
    constructor(props){
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }
    handleSubmit() {
        this.input && this.input.value.indexOf("@") > -1 && this.props.onSubmitted({
            EMAIL: this.input.value
        });
    }
    handleKeyPress(e) {
        if (e.key === "Enter") this.handleSubmit();
    }
    // TODO — use state to handle this…
    handleChange(e) {
        if (e.target.value) {
            const submitButton = document.querySelector(`.${(0, (/*@__PURE__*/$parcel$interopDefault($f12c4da085369b60$exports))).wrap} button`);
            submitButton.classList.add((0, (/*@__PURE__*/$parcel$interopDefault($f12c4da085369b60$exports))).buttonShow);
        }
    }
    componentDidMount() {
        const controller = new (0, (/*@__PURE__*/$parcel$interopDefault($ctrgf))).Controller();
        new (0, (/*@__PURE__*/$parcel$interopDefault($ctrgf))).Scene({
            triggerElement: this.line,
            offset: 0 - window.innerHeight / 2
        }).setClassToggle(this.line, (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($f12c4da085369b60$exports))).lineShow)).addTo(controller);
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($f12c4da085369b60$exports))).wrap)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($f12c4da085369b60$exports))).inner, {
                [(0, (/*@__PURE__*/$parcel$interopDefault($f12c4da085369b60$exports))).success]: this.props.status == "success"
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($f12c4da085369b60$exports))).notice)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("b", null, "Sign up"), " to stay informed"), (0, $9fbae048b55737ab$export$67694733dc949122)() && // https://github.com/revolunet/react-mailchimp-subscribe/issues/25
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("a", {
            href: "http://eepurl.com/gewNYz",
            target: "_blank"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("img", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($f12c4da085369b60$exports))).externalLinkButton),
            src: (0, (/*@__PURE__*/$parcel$interopDefault($c62d58e015264f54$exports)))
        })), !(0, $9fbae048b55737ab$export$67694733dc949122)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($f12c4da085369b60$exports))).form)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("input", {
            ref: (node)=>this.input = node,
            type: "email",
            placeholder: "EMAIL",
            onKeyPress: this.handleKeyPress,
            onChange: this.handleChange
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($f12c4da085369b60$exports))).line),
            ref: (node)=>this.line = node
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("button", {
            onClick: this.handleSubmit
        }, "SUBMIT")), this.props.status == "success" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement((0, $cb88c98f1b4dfca5$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement((0, $84b504dfacdae796$export$2e2bcd8739ae039), null))));
    }
}
var $cbce4e4d3a00e62d$export$2e2bcd8739ae039 = $cbce4e4d3a00e62d$var$MailchimpSimpleForm;


function $8e9afc4abec19735$var$_defineProperty(obj, key, value) {
    key = $8e9afc4abec19735$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8e9afc4abec19735$var$_toPropertyKey(arg) {
    var key = $8e9afc4abec19735$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $8e9afc4abec19735$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
const $8e9afc4abec19735$var$getAjaxUrl = (url)=>url.replace("/post?", "/post-json?");
class $8e9afc4abec19735$var$MailchimpSubscribe extends (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).Component {
    constructor(...args){
        super(...args);
        $8e9afc4abec19735$var$_defineProperty(this, "state", {
            status: null,
            message: null,
            userEnteredText: false
        });
        $8e9afc4abec19735$var$_defineProperty(this, "subscribe", (data)=>{
            const params = (0, (/*@__PURE__*/$parcel$interopDefault($4b90e8805b602d38$exports)))(data);
            const url = $8e9afc4abec19735$var$getAjaxUrl(this.props.url) + "&" + params;
            this.setState({
                status: "sending",
                message: null
            }, ()=>(0, (/*@__PURE__*/$parcel$interopDefault($1561601a55b8cdf0$exports)))(url, {
                    param: "c"
                }, (err, data)=>{
                    if (err) this.setState({
                        status: "error",
                        message: err
                    });
                    else if (data.result !== "success") this.setState({
                        status: "error",
                        message: data.msg
                    });
                    else this.setState({
                        status: "success",
                        message: data.msg
                    });
                }));
        });
        $8e9afc4abec19735$var$_defineProperty(this, "handleInputChange", (userEnteredText)=>{
            console.log("hi");
            this.setState({
                userEnteredText: true
            });
        });
    }
    render() {
        return this.props.render({
            subscribe: this.subscribe,
            status: this.state.status,
            message: this.state.message
        });
    }
}
$8e9afc4abec19735$var$MailchimpSubscribe.propTypes = {
    render: (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).func,
    url: (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).string.isRequired
};
$8e9afc4abec19735$var$MailchimpSubscribe.defaultProps = {
    render: ({ subscribe: subscribe, status: status, message: message })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement((0, $cbce4e4d3a00e62d$export$2e2bcd8739ae039), {
            status: status,
            message: message,
            onSubmitted: (formData)=>subscribe(formData)
        })
};
var $8e9afc4abec19735$export$2e2bcd8739ae039 = $8e9afc4abec19735$var$MailchimpSubscribe;


class $bd9ce264897d7dc7$var$MailchimpDemo extends (0, $g85JO.Component) {
    render() {
        const url = "//7isatribe.us20.list-manage.com/subscribe/post?u=0857837aeb237c6d9e69f70fa&id=713afd95a9";
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement((0, $8e9afc4abec19735$export$2e2bcd8739ae039), {
            url: url
        }));
    }
}
var $bd9ce264897d7dc7$export$2e2bcd8739ae039 = $bd9ce264897d7dc7$var$MailchimpDemo;




var $5b8c2371108cc960$exports = {};


$5b8c2371108cc960$exports = (parcelRequire("kSeqf")).getBundleURL("kqVE6") + (parcelRequire("7wgKE")).resolve("1Bu4G");


var $8dd943442f27cc57$exports = {};
var $e23cfdce207c625c$exports = {};


$e23cfdce207c625c$exports = (parcelRequire("kSeqf")).getBundleURL("kqVE6") + (parcelRequire("7wgKE")).resolve("56tij");


var $8b8ba57bb5217d5e$exports = {};


$8b8ba57bb5217d5e$exports = (parcelRequire("kSeqf")).getBundleURL("kqVE6") + (parcelRequire("7wgKE")).resolve("jfhWO");


var $4369d4ead3a3f31f$exports = {};


$4369d4ead3a3f31f$exports = (parcelRequire("kSeqf")).getBundleURL("kqVE6") + (parcelRequire("7wgKE")).resolve("1pbdG");


var $4d2d28c298137efb$exports = {};


$4d2d28c298137efb$exports = (parcelRequire("kSeqf")).getBundleURL("kqVE6") + (parcelRequire("7wgKE")).resolve("gHwhW");


var $bc4d9d28dd6e3090$exports = {};


$bc4d9d28dd6e3090$exports = (parcelRequire("kSeqf")).getBundleURL("kqVE6") + (parcelRequire("7wgKE")).resolve("107ps");


$8dd943442f27cc57$exports = {
    "lens1": $e23cfdce207c625c$exports,
    "lens2": $8b8ba57bb5217d5e$exports,
    "lens3": $4369d4ead3a3f31f$exports,
    "lens4": $4d2d28c298137efb$exports,
    "lens5": $bc4d9d28dd6e3090$exports
};



parcelRequire("4fEaA");

var $ctrgf = parcelRequire("ctrgf");

function $fd7550469072ac96$var$_defineProperty(obj, key, value) {
    key = $fd7550469072ac96$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $fd7550469072ac96$var$_toPropertyKey(arg) {
    var key = $fd7550469072ac96$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $fd7550469072ac96$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
class $fd7550469072ac96$var$Home extends (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).Component {
    constructor(props){
        super(props);
        $fd7550469072ac96$var$_defineProperty(this, "handleNavMobileOpenChange", (navMobileIsOpen)=>{
            this.setState({
                navMobileIsOpen: navMobileIsOpen
            });
        });
        $fd7550469072ac96$var$_defineProperty(this, "reRender", ()=>{
            // on browser resize
            this.forceUpdate();
        });
        this.state = {
            introAnimating: true,
            firstImageLoaded: false,
            homeMounted: false,
            navMobileIsOpen: false
        };
        this.handleNavHover = this.handleNavHover.bind(this);
        this.handleLogoClick = this.handleLogoClick.bind(this);
    }
    componentDidMount() {
        // console.log('Home mounted');
        // re-render on browser resize
        window.addEventListener("resize", this.reRender);
        // enable scrolling after the logo does its intro animation
        setTimeout(()=>{
            this.setState({
                introAnimating: false,
                isHovering: false
            });
        }, 500);
        // only load the Background when the first image is loaded
        let img = document.createElement("img");
        img.onload = ()=>{
            // console.log('first image loaded');
            this.setState({
                firstImageLoaded: true
            });
        };
        img.src = (0, (/*@__PURE__*/$parcel$interopDefault($e58889697fac80cb$exports)));
        const controller = new (0, (/*@__PURE__*/$parcel$interopDefault($ctrgf))).Controller();
        new (0, (/*@__PURE__*/$parcel$interopDefault($ctrgf))).Scene({
            triggerElement: "#trigger1"
        }).setClassToggle("#graphicSection1 > img", (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($548062b3fb4505b6$exports))).graphicShow)).addTo(controller);
        new (0, (/*@__PURE__*/$parcel$interopDefault($ctrgf))).Scene({
            triggerElement: "#trigger2"
        }).setClassToggle("#graphicSection2 > img", (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($548062b3fb4505b6$exports))).graphicShow)).addTo(controller);
        new (0, (/*@__PURE__*/$parcel$interopDefault($ctrgf))).Scene({
            triggerElement: "#trigger3"
        }).setClassToggle("#graphicSection3 > img", (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($548062b3fb4505b6$exports))).graphicShow)).addTo(controller);
        new (0, (/*@__PURE__*/$parcel$interopDefault($ctrgf))).Scene({
            triggerElement: "#trigger7"
        }).setClassToggle("#graphicSection7 img", (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($548062b3fb4505b6$exports))).graphicShow)).addTo(controller);
        new (0, (/*@__PURE__*/$parcel$interopDefault($ctrgf))).Scene({
            triggerElement: "#trigger4"
        }).setClassToggle("#graphicSection4 > img", (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($548062b3fb4505b6$exports))).graphicShow)).addTo(controller);
        new (0, (/*@__PURE__*/$parcel$interopDefault($ctrgf))).Scene({
            triggerElement: "#trigger5"
        }).setClassToggle("#graphicSection5 > img", (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($548062b3fb4505b6$exports))).graphicShow)).addTo(controller);
        setTimeout(()=>{
            this.setState({
                homeMounted: true
            });
        }, 3500);
    }
    handleNavHover(isHovering) {
        this.setState({
            isHovering: isHovering
        });
    }
    handleLogoClick(status) {
        if (this.state.navMobileIsOpen) this.setState({
            navMobileIsOpen: false
        });
        else // if user scrolls to the top, close the navigation (to prevent weird animation glitch on mobile)
        if (status != "scrolled to top") this.setState({
            navMobileIsOpen: true
        });
    }
    render() {
        (0, $9fbae048b55737ab$export$a541a6e0388c2a55)();
        // css class that hides the rest of the site until the logo animates for a couple seconds
        let classNames = (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($548062b3fb4505b6$exports))).container, {
            [(0, (/*@__PURE__*/$parcel$interopDefault($548062b3fb4505b6$exports))).containerIntroAnimating]: this.state.introAnimating
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("div", {
            className: classNames
        }, this.state.firstImageLoaded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement((0, $g85JO.Fragment), null, this.state.homeMounted && (0, $9fbae048b55737ab$export$1e4fed98bcaa1d82)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement((0, $g85JO.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement((0, $f61de4c2c891d740$export$2e2bcd8739ae039), {
            onNavHover: this.handleNavHover
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement((0, $dd42c90e69fe31c1$export$2e2bcd8739ae039), null)), !(0, $9fbae048b55737ab$export$1e4fed98bcaa1d82)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement((0, $17ac225665c291ff$export$2e2bcd8739ae039), {
            navMobileIsOpen: this.state.navMobileIsOpen,
            onNavMobileOpenChange: this.handleNavMobileOpenChange
        })), this.state.firstImageLoaded && !(0, $9fbae048b55737ab$export$deb94605e54cb29e)() && // load background after the first image has loaded, to prevent glitchy slideshow
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement((0, $c9cc34f22c5820b3$export$2e2bcd8739ae039), null), this.state.firstImageLoaded && (0, $9fbae048b55737ab$export$deb94605e54cb29e)() && // load background after the first image has loaded, to prevent glitchy slideshow
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement((0, $131ecdc5eedb722c$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))("landing", (0, (/*@__PURE__*/$parcel$interopDefault($548062b3fb4505b6$exports))).landing)
        }, this.state.firstImageLoaded && // logo animation skips if the images are still loading
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement((0, $g85JO.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement((0, $c98f1d1f5da0e46b$export$2e2bcd8739ae039), {
            onLogoClick: this.handleLogoClick,
            navMobileIsOpen: this.state.navMobileIsOpen
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement((0, $71163170f3a5b83f$export$2e2bcd8739ae039), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($548062b3fb4505b6$exports))).navHoverDiv, {
                [(0, (/*@__PURE__*/$parcel$interopDefault($548062b3fb4505b6$exports))).navHovering]: this.state.isHovering
            }, {
                [(0, (/*@__PURE__*/$parcel$interopDefault($548062b3fb4505b6$exports))).navMobileOpen]: this.state.navMobileIsOpen
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("div", {
            className: "main"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement((0, $edfa5b392bfc3940$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement((0, $73b8290289195dfa$export$2e2bcd8739ae039), {
            col: 3,
            yFrom: 360,
            yTo: -90
        }, "is a company dedicated to deepening the possibilities ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("br", null), "of ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("b", null, "contemporary image creation"), "."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement((0, $73b8290289195dfa$export$2e2bcd8739ae039), {
            col: 1,
            yFrom: 140,
            yTo: -60,
            isPin: true
        }, "Tribe", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("sup", null, "7"), " was founded as a collaboration ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("br", null), "between artist and Academy Award\xae-nominated  ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("br", null), "cinematographer ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("b", null, "Bradford Young"), ", ASC,"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement((0, $73b8290289195dfa$export$2e2bcd8739ae039), {
            col: 4,
            yFrom: 70,
            yTo: -30
        }, "and ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("b", null, "Neil Fanthom"), ", motion picture camera and lens\xa0technologist"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("div", {
            id: "graphicSection1",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($548062b3fb4505b6$exports))).graphicSection)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("div", {
            id: "trigger1",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($548062b3fb4505b6$exports))).trigger)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("img", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($548062b3fb4505b6$exports))).graphic),
            src: (0, (/*@__PURE__*/$parcel$interopDefault($8dd943442f27cc57$exports)))["lens1"]
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement((0, $73b8290289195dfa$export$2e2bcd8739ae039), {
            col: 1,
            yFrom: 140,
            yTo: -60,
            isPin: true,
            keepLineBreaksOnMobile: true
        }, "our primary areas of focus are ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("b", null, "color"), ", ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("b", null, "light"), ", and ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("b", null, "optics"), "."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement((0, $73b8290289195dfa$export$2e2bcd8739ae039), {
            col: 5,
            yFrom: 70,
            yTo: -30
        }, "we explore how these foundational aspects of imaging ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("br", null), "can be reimagined for ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("b", null, "today’s filmmakers"), "."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("div", {
            id: "graphicSection2",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($548062b3fb4505b6$exports))).graphicSection)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("div", {
            id: "trigger2",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($548062b3fb4505b6$exports))).trigger)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("img", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($548062b3fb4505b6$exports))).graphic),
            src: (0, (/*@__PURE__*/$parcel$interopDefault($8dd943442f27cc57$exports)))["lens1"]
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("img", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($548062b3fb4505b6$exports))).graphic),
            src: (0, (/*@__PURE__*/$parcel$interopDefault($8dd943442f27cc57$exports)))["lens2"]
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement((0, $73b8290289195dfa$export$2e2bcd8739ae039), {
            col: 7,
            yFrom: 360,
            yTo: -90,
            isPin: true
        }, "we aim to provide artists the ability ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("br", null), "to ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("b", null, "tune"), " (enhance) and ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("b", null, "de-tune"), " (distort) ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("br", null), "elements of color and ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("b", null, "light")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement((0, $73b8290289195dfa$export$2e2bcd8739ae039), {
            col: 2,
            yFrom: 140,
            yTo: -60
        }, "to bring a greater ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("b", null, "expressive"), " range, intentionality ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("br", null), "and unique ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("b", null, "visual"), " authorship to their story."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("div", {
            id: "graphicSection3",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($548062b3fb4505b6$exports))).graphicSection, "navPin")
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("div", {
            id: "trigger3",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($548062b3fb4505b6$exports))).trigger)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("img", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($548062b3fb4505b6$exports))).graphic),
            src: (0, (/*@__PURE__*/$parcel$interopDefault($8dd943442f27cc57$exports)))["lens1"]
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("img", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($548062b3fb4505b6$exports))).graphic),
            src: (0, (/*@__PURE__*/$parcel$interopDefault($8dd943442f27cc57$exports)))["lens2"]
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("img", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($548062b3fb4505b6$exports))).graphic),
            src: (0, (/*@__PURE__*/$parcel$interopDefault($8dd943442f27cc57$exports)))["lens3"]
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("div", {
            style: {
                textAlign: "center"
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("a", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($548062b3fb4505b6$exports))).logoLink,
            href: "https://www.blackwing7.com"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement((0, $797ac14f841220e6$export$2e2bcd8739ae039), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("div", {
            id: "graphicSection7",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($548062b3fb4505b6$exports))).graphicSection)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("div", {
            id: "trigger7",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($548062b3fb4505b6$exports))).trigger)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("a", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($548062b3fb4505b6$exports))).logoLink,
            href: "https://www.blackwing7.com"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("img", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($548062b3fb4505b6$exports))).blackwingTextLogo),
            src: (0, (/*@__PURE__*/$parcel$interopDefault($5b8c2371108cc960$exports)))
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement((0, $73b8290289195dfa$export$2e2bcd8739ae039), {
            col: 1,
            yFrom: 300,
            yTo: -90,
            keepLineBreaksOnMobile: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("b", null, "BLACKWING", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("sup", null, "7"), " imaging technology"), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("i", null, "will come in analogue and digital forms.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement((0, $73b8290289195dfa$export$2e2bcd8739ae039), {
            col: 5,
            yFrom: 140,
            yTo: -60
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("i", null, "We are partnering with artists and technologists to develop new creative"), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("b", null, "instruments, tools, approaches and services")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement((0, $73b8290289195dfa$export$2e2bcd8739ae039), {
            col: 3,
            yFrom: 70,
            yTo: -30
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("i", null, "across the spectrum of contemporary"), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("b", null, "cinematic image making"), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("i", null, "to"), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("b", null, "expand"), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("i", null, "expressive capabilities and"), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("b", null, "enable"), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("i", null, "possible voices.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("div", {
            id: "graphicSection4",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($548062b3fb4505b6$exports))).graphicSection, "navPin")
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("div", {
            id: "trigger4",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($548062b3fb4505b6$exports))).trigger)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("img", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($548062b3fb4505b6$exports))).graphic),
            src: (0, (/*@__PURE__*/$parcel$interopDefault($8dd943442f27cc57$exports)))["lens1"]
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("img", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($548062b3fb4505b6$exports))).graphic),
            src: (0, (/*@__PURE__*/$parcel$interopDefault($8dd943442f27cc57$exports)))["lens2"]
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("img", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($548062b3fb4505b6$exports))).graphic),
            src: (0, (/*@__PURE__*/$parcel$interopDefault($8dd943442f27cc57$exports)))["lens3"]
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("img", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($548062b3fb4505b6$exports))).graphic),
            src: (0, (/*@__PURE__*/$parcel$interopDefault($8dd943442f27cc57$exports)))["lens4"]
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement((0, $73b8290289195dfa$export$2e2bcd8739ae039), {
            col: 1,
            yFrom: 300,
            yTo: -90,
            keepLineBreaksOnMobile: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("b", null, "BLACKWING", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("sup", null, "7"), " LENSES"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("i", null, "are crafted through a process of innovation and intention.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement((0, $73b8290289195dfa$export$2e2bcd8739ae039), {
            col: 5,
            yFrom: 140,
            yTo: -60
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("i", null, "Lenses exhibit unique imaging properties which arise from the introduction of"), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("b", null, "DISTORTION AND MODULARITY"), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("i", null, "during development and manufacturing.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement((0, $73b8290289195dfa$export$2e2bcd8739ae039), {
            col: 2,
            yFrom: 70,
            yTo: -30
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("i", null, "Each lens has"), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("b", null, "TUNABLE OPTICAL QUALITIES"), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("i", null, "allowing properties such as sharpness, roll-off, field curvature and halation to be personalized to suit the character and intent of the owner.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement((0, $73b8290289195dfa$export$2e2bcd8739ae039), {
            col: 4,
            yFrom: 140,
            yTo: -60
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("i", null, "The ability to individually tune each"), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("b", null, "BLACKWING", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("sup", null, "7")), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("i", null, "lens parallels the application of EQ in music production to set"), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("b", null, "RANGE AND SHAPE OF TONALITY"), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("i", null, "across the audio frequency spectrum.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("div", {
            style: {
                marginTop: "120px"
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement((0, $73b8290289195dfa$export$2e2bcd8739ae039), {
            col: 1,
            yFrom: 70,
            yTo: -30
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("i", null, "Due to the tuneable nature of"), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("b", null, "BLACKWING", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("sup", null, "7")), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("i", null, "lenses, availability is strictly through advanced order placement.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("div", {
            style: {
                marginTop: "190px"
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($548062b3fb4505b6$exports))).contact, "navPin")
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("a", {
            href: "https://www.blackwing7.com"
        }, "EXPLORE BLACKWING7.COM"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($548062b3fb4505b6$exports))).signupSection, "navPin"),
            "data-navtitle": "Sign up"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement((0, $bd9ce264897d7dc7$export$2e2bcd8739ae039), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("div", {
            id: "graphicSection5",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($548062b3fb4505b6$exports))).graphicSection),
            style: {
                margin: "0 0 calc(50vh - 100px - 35px)"
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("div", {
            id: "trigger5",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($548062b3fb4505b6$exports))).trigger)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("img", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($548062b3fb4505b6$exports))).graphic),
            src: (0, (/*@__PURE__*/$parcel$interopDefault($8dd943442f27cc57$exports)))["lens1"]
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("img", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($548062b3fb4505b6$exports))).graphic),
            src: (0, (/*@__PURE__*/$parcel$interopDefault($8dd943442f27cc57$exports)))["lens2"]
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("img", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($548062b3fb4505b6$exports))).graphic),
            src: (0, (/*@__PURE__*/$parcel$interopDefault($8dd943442f27cc57$exports)))["lens3"]
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("img", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($548062b3fb4505b6$exports))).graphic),
            src: (0, (/*@__PURE__*/$parcel$interopDefault($8dd943442f27cc57$exports)))["lens4"]
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("img", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($548062b3fb4505b6$exports))).graphic),
            src: (0, (/*@__PURE__*/$parcel$interopDefault($8dd943442f27cc57$exports)))["lens5"]
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($548062b3fb4505b6$exports))).social)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("a", {
            href: "https://www.instagram.com/7isatribe",
            target: "_blank",
            className: "navPin",
            "data-navtitle": "Social"
        }, "Instagram", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("sup", null, "7"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($c62d58e015264f54$exports)))
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c3da8b13b9968bd3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($548062b3fb4505b6$exports))).credit)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("a", {
            href: "http://osk.co",
            target: "_blank"
        }, "SITE BY ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("span", null, "OSK"))))));
    }
}
var $fd7550469072ac96$export$2e2bcd8739ae039 = $fd7550469072ac96$var$Home;



var $fac7422b70f4bafc$exports = {};
"use strict";
function $fac7422b70f4bafc$var$_interopDefault(ex) {
    return ex && typeof ex === "object" && "default" in ex ? ex["default"] : ex;
}

var $g85JO = parcelRequire("g85JO");
var $fac7422b70f4bafc$var$React__default = $fac7422b70f4bafc$var$_interopDefault($g85JO);
function $fac7422b70f4bafc$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $fac7422b70f4bafc$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $fac7422b70f4bafc$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $fac7422b70f4bafc$var$withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
    if (typeof reducePropsToState !== "function") throw new Error("Expected reducePropsToState to be a function.");
    if (typeof handleStateChangeOnClient !== "function") throw new Error("Expected handleStateChangeOnClient to be a function.");
    if (typeof mapStateOnServer !== "undefined" && typeof mapStateOnServer !== "function") throw new Error("Expected mapStateOnServer to either be undefined or a function.");
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || "Component";
    }
    return function wrap(WrappedComponent) {
        if (typeof WrappedComponent !== "function") throw new Error("Expected WrappedComponent to be a React component.");
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            if (SideEffect.canUseDOM) handleStateChangeOnClient(state);
            else if (mapStateOnServer) state = mapStateOnServer(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            $fac7422b70f4bafc$var$_inheritsLoose(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            // Expose canUseDOM so tests can monkeypatch it
            SideEffect.peek = function peek() {
                return state;
            };
            SideEffect.rewind = function rewind() {
                if (SideEffect.canUseDOM) throw new Error("You may only call rewind() on the server. Call peek() to read the current state.");
                var recordedState = state;
                state = undefined;
                mountedInstances = [];
                return recordedState;
            };
            var _proto = SideEffect.prototype;
            _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return $fac7422b70f4bafc$var$React__default.createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }($g85JO.PureComponent);
        $fac7422b70f4bafc$var$_defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        $fac7422b70f4bafc$var$_defineProperty(SideEffect, "canUseDOM", $fac7422b70f4bafc$var$canUseDOM);
        return SideEffect;
    };
}
$fac7422b70f4bafc$exports = $fac7422b70f4bafc$var$withSideEffect;


var $1b21794642166ddd$exports = {};
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $1b21794642166ddd$var$hasElementType = typeof Element !== "undefined";
var $1b21794642166ddd$var$hasMap = typeof Map === "function";
var $1b21794642166ddd$var$hasSet = typeof Set === "function";
var $1b21794642166ddd$var$hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $1b21794642166ddd$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$1b21794642166ddd$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($1b21794642166ddd$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$1b21794642166ddd$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($1b21794642166ddd$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($1b21794642166ddd$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === "function" && typeof b.valueOf === "function") return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === "function" && typeof b.toString === "function") return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($1b21794642166ddd$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$1b21794642166ddd$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
$1b21794642166ddd$exports = function isEqual(a, b) {
    try {
        return $1b21794642166ddd$var$equal(a, b);
    } catch (error) {
        if ((error.message || "").match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("react-fast-compare cannot handle circular refs");
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};



var $g85JO = parcelRequire("g85JO");

var $22Kv0 = parcelRequire("22Kv0");
var $77d4e423430b81d0$var$ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};
var $77d4e423430b81d0$var$TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};
var $77d4e423430b81d0$var$VALID_TAG_NAMES = Object.keys($77d4e423430b81d0$var$TAG_NAMES).map(function(name) {
    return $77d4e423430b81d0$var$TAG_NAMES[name];
});
var $77d4e423430b81d0$var$TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src",
    TARGET: "target"
};
var $77d4e423430b81d0$var$REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};
var $77d4e423430b81d0$var$HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};
var $77d4e423430b81d0$var$HTML_TAG_MAP = Object.keys($77d4e423430b81d0$var$REACT_TAG_MAP).reduce(function(obj, key) {
    obj[$77d4e423430b81d0$var$REACT_TAG_MAP[key]] = key;
    return obj;
}, {});
var $77d4e423430b81d0$var$SELF_CLOSING_TAGS = [
    $77d4e423430b81d0$var$TAG_NAMES.NOSCRIPT,
    $77d4e423430b81d0$var$TAG_NAMES.SCRIPT,
    $77d4e423430b81d0$var$TAG_NAMES.STYLE
];
var $77d4e423430b81d0$var$HELMET_ATTRIBUTE = "data-react-helmet";
var $77d4e423430b81d0$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $77d4e423430b81d0$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $77d4e423430b81d0$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $77d4e423430b81d0$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $77d4e423430b81d0$var$inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var $77d4e423430b81d0$var$objectWithoutProperties = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};
var $77d4e423430b81d0$var$possibleConstructorReturn = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
var $77d4e423430b81d0$var$encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (encode === false) return String(str);
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};
var $77d4e423430b81d0$var$getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = $77d4e423430b81d0$var$getInnermostProperty(propsList, $77d4e423430b81d0$var$TAG_NAMES.TITLE);
    var innermostTemplate = $77d4e423430b81d0$var$getInnermostProperty(propsList, $77d4e423430b81d0$var$HELMET_PROPS.TITLE_TEMPLATE);
    if (innermostTemplate && innermostTitle) // use function arg to avoid need to escape $ characters
    return innermostTemplate.replace(/%s/g, function() {
        return Array.isArray(innermostTitle) ? innermostTitle.join("") : innermostTitle;
    });
    var innermostDefaultTitle = $77d4e423430b81d0$var$getInnermostProperty(propsList, $77d4e423430b81d0$var$HELMET_PROPS.DEFAULT_TITLE);
    return innermostTitle || innermostDefaultTitle || undefined;
};
var $77d4e423430b81d0$var$getOnChangeClientState = function getOnChangeClientState(propsList) {
    return $77d4e423430b81d0$var$getInnermostProperty(propsList, $77d4e423430b81d0$var$HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function() {};
};
var $77d4e423430b81d0$var$getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function(props) {
        return typeof props[tagType] !== "undefined";
    }).map(function(props) {
        return props[tagType];
    }).reduce(function(tagAttrs, current) {
        return $77d4e423430b81d0$var$_extends({}, tagAttrs, current);
    }, {});
};
var $77d4e423430b81d0$var$getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function(props) {
        return typeof props[$77d4e423430b81d0$var$TAG_NAMES.BASE] !== "undefined";
    }).map(function(props) {
        return props[$77d4e423430b81d0$var$TAG_NAMES.BASE];
    }).reverse().reduce(function(innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) return innermostBaseTag.concat(tag);
            }
        }
        return innermostBaseTag;
    }, []);
};
var $77d4e423430b81d0$var$getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};
    return propsList.filter(function(props) {
        if (Array.isArray(props[tagName])) return true;
        if (typeof props[tagName] !== "undefined") $77d4e423430b81d0$var$warn("Helmet: " + tagName + ' should be of type "Array". Instead found type "' + $77d4e423430b81d0$var$_typeof(props[tagName]) + '"');
        return false;
    }).map(function(props) {
        return props[tagName];
    }).reverse().reduce(function(approvedTags, instanceTags) {
        var instanceSeenTags = {};
        instanceTags.filter(function(tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === $77d4e423430b81d0$var$TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === $77d4e423430b81d0$var$TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) primaryAttributeKey = lowerCaseAttributeKey;
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === $77d4e423430b81d0$var$TAG_PROPERTIES.INNER_HTML || attributeKey === $77d4e423430b81d0$var$TAG_PROPERTIES.CSS_TEXT || attributeKey === $77d4e423430b81d0$var$TAG_PROPERTIES.ITEM_PROP)) primaryAttributeKey = attributeKey;
            }
            if (!primaryAttributeKey || !tag[primaryAttributeKey]) return false;
            var value = tag[primaryAttributeKey].toLowerCase();
            if (!approvedSeenTags[primaryAttributeKey]) approvedSeenTags[primaryAttributeKey] = {};
            if (!instanceSeenTags[primaryAttributeKey]) instanceSeenTags[primaryAttributeKey] = {};
            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }
            return false;
        }).reverse().forEach(function(tag) {
            return approvedTags.push(tag);
        });
        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for(var i = 0; i < keys.length; i++){
            var attributeKey = keys[i];
            var tagUnion = (0, (/*@__PURE__*/$parcel$interopDefault($22Kv0)))({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
            approvedSeenTags[attributeKey] = tagUnion;
        }
        return approvedTags;
    }, []).reverse();
};
var $77d4e423430b81d0$var$getInnermostProperty = function getInnermostProperty(propsList, property) {
    for(var i = propsList.length - 1; i >= 0; i--){
        var props = propsList[i];
        if (props.hasOwnProperty(property)) return props[property];
    }
    return null;
};
var $77d4e423430b81d0$var$reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: $77d4e423430b81d0$var$getBaseTagFromPropsList([
            $77d4e423430b81d0$var$TAG_PROPERTIES.HREF,
            $77d4e423430b81d0$var$TAG_PROPERTIES.TARGET
        ], propsList),
        bodyAttributes: $77d4e423430b81d0$var$getAttributesFromPropsList($77d4e423430b81d0$var$ATTRIBUTE_NAMES.BODY, propsList),
        defer: $77d4e423430b81d0$var$getInnermostProperty(propsList, $77d4e423430b81d0$var$HELMET_PROPS.DEFER),
        encode: $77d4e423430b81d0$var$getInnermostProperty(propsList, $77d4e423430b81d0$var$HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: $77d4e423430b81d0$var$getAttributesFromPropsList($77d4e423430b81d0$var$ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: $77d4e423430b81d0$var$getTagsFromPropsList($77d4e423430b81d0$var$TAG_NAMES.LINK, [
            $77d4e423430b81d0$var$TAG_PROPERTIES.REL,
            $77d4e423430b81d0$var$TAG_PROPERTIES.HREF
        ], propsList),
        metaTags: $77d4e423430b81d0$var$getTagsFromPropsList($77d4e423430b81d0$var$TAG_NAMES.META, [
            $77d4e423430b81d0$var$TAG_PROPERTIES.NAME,
            $77d4e423430b81d0$var$TAG_PROPERTIES.CHARSET,
            $77d4e423430b81d0$var$TAG_PROPERTIES.HTTPEQUIV,
            $77d4e423430b81d0$var$TAG_PROPERTIES.PROPERTY,
            $77d4e423430b81d0$var$TAG_PROPERTIES.ITEM_PROP
        ], propsList),
        noscriptTags: $77d4e423430b81d0$var$getTagsFromPropsList($77d4e423430b81d0$var$TAG_NAMES.NOSCRIPT, [
            $77d4e423430b81d0$var$TAG_PROPERTIES.INNER_HTML
        ], propsList),
        onChangeClientState: $77d4e423430b81d0$var$getOnChangeClientState(propsList),
        scriptTags: $77d4e423430b81d0$var$getTagsFromPropsList($77d4e423430b81d0$var$TAG_NAMES.SCRIPT, [
            $77d4e423430b81d0$var$TAG_PROPERTIES.SRC,
            $77d4e423430b81d0$var$TAG_PROPERTIES.INNER_HTML
        ], propsList),
        styleTags: $77d4e423430b81d0$var$getTagsFromPropsList($77d4e423430b81d0$var$TAG_NAMES.STYLE, [
            $77d4e423430b81d0$var$TAG_PROPERTIES.CSS_TEXT
        ], propsList),
        title: $77d4e423430b81d0$var$getTitleFromPropsList(propsList),
        titleAttributes: $77d4e423430b81d0$var$getAttributesFromPropsList($77d4e423430b81d0$var$ATTRIBUTE_NAMES.TITLE, propsList)
    };
};
var $77d4e423430b81d0$var$rafPolyfill = function() {
    var clock = Date.now();
    return function(callback) {
        var currentTime = Date.now();
        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else setTimeout(function() {
            $77d4e423430b81d0$var$rafPolyfill(callback);
        }, 0);
    };
}();
var $77d4e423430b81d0$var$cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};
var $77d4e423430b81d0$var$requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || $77d4e423430b81d0$var$rafPolyfill : $parcel$global.requestAnimationFrame || $77d4e423430b81d0$var$rafPolyfill;
var $77d4e423430b81d0$var$cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || $77d4e423430b81d0$var$cafPolyfill : $parcel$global.cancelAnimationFrame || $77d4e423430b81d0$var$cafPolyfill;
var $77d4e423430b81d0$var$warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};
var $77d4e423430b81d0$var$_helmetCallback = null;
var $77d4e423430b81d0$var$handleClientStateChange = function handleClientStateChange(newState) {
    if ($77d4e423430b81d0$var$_helmetCallback) $77d4e423430b81d0$var$cancelAnimationFrame($77d4e423430b81d0$var$_helmetCallback);
    if (newState.defer) $77d4e423430b81d0$var$_helmetCallback = $77d4e423430b81d0$var$requestAnimationFrame(function() {
        $77d4e423430b81d0$var$commitTagChanges(newState, function() {
            $77d4e423430b81d0$var$_helmetCallback = null;
        });
    });
    else {
        $77d4e423430b81d0$var$commitTagChanges(newState);
        $77d4e423430b81d0$var$_helmetCallback = null;
    }
};
var $77d4e423430b81d0$var$commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag, bodyAttributes = newState.bodyAttributes, htmlAttributes = newState.htmlAttributes, linkTags = newState.linkTags, metaTags = newState.metaTags, noscriptTags = newState.noscriptTags, onChangeClientState = newState.onChangeClientState, scriptTags = newState.scriptTags, styleTags = newState.styleTags, title = newState.title, titleAttributes = newState.titleAttributes;
    $77d4e423430b81d0$var$updateAttributes($77d4e423430b81d0$var$TAG_NAMES.BODY, bodyAttributes);
    $77d4e423430b81d0$var$updateAttributes($77d4e423430b81d0$var$TAG_NAMES.HTML, htmlAttributes);
    $77d4e423430b81d0$var$updateTitle(title, titleAttributes);
    var tagUpdates = {
        baseTag: $77d4e423430b81d0$var$updateTags($77d4e423430b81d0$var$TAG_NAMES.BASE, baseTag),
        linkTags: $77d4e423430b81d0$var$updateTags($77d4e423430b81d0$var$TAG_NAMES.LINK, linkTags),
        metaTags: $77d4e423430b81d0$var$updateTags($77d4e423430b81d0$var$TAG_NAMES.META, metaTags),
        noscriptTags: $77d4e423430b81d0$var$updateTags($77d4e423430b81d0$var$TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: $77d4e423430b81d0$var$updateTags($77d4e423430b81d0$var$TAG_NAMES.SCRIPT, scriptTags),
        styleTags: $77d4e423430b81d0$var$updateTags($77d4e423430b81d0$var$TAG_NAMES.STYLE, styleTags)
    };
    var addedTags = {};
    var removedTags = {};
    Object.keys(tagUpdates).forEach(function(tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType], newTags = _tagUpdates$tagType.newTags, oldTags = _tagUpdates$tagType.oldTags;
        if (newTags.length) addedTags[tagType] = newTags;
        if (oldTags.length) removedTags[tagType] = tagUpdates[tagType].oldTags;
    });
    cb && cb();
    onChangeClientState(newState, addedTags, removedTags);
};
var $77d4e423430b81d0$var$flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};
var $77d4e423430b81d0$var$updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) document.title = $77d4e423430b81d0$var$flattenArray(title);
    $77d4e423430b81d0$var$updateAttributes($77d4e423430b81d0$var$TAG_NAMES.TITLE, attributes);
};
var $77d4e423430b81d0$var$updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];
    if (!elementTag) return;
    var helmetAttributeString = elementTag.getAttribute($77d4e423430b81d0$var$HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);
    for(var i = 0; i < attributeKeys.length; i++){
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";
        if (elementTag.getAttribute(attribute) !== value) elementTag.setAttribute(attribute, value);
        if (helmetAttributes.indexOf(attribute) === -1) helmetAttributes.push(attribute);
        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) attributesToRemove.splice(indexToSave, 1);
    }
    for(var _i = attributesToRemove.length - 1; _i >= 0; _i--)elementTag.removeAttribute(attributesToRemove[_i]);
    if (helmetAttributes.length === attributesToRemove.length) elementTag.removeAttribute($77d4e423430b81d0$var$HELMET_ATTRIBUTE);
    else if (elementTag.getAttribute($77d4e423430b81d0$var$HELMET_ATTRIBUTE) !== attributeKeys.join(",")) elementTag.setAttribute($77d4e423430b81d0$var$HELMET_ATTRIBUTE, attributeKeys.join(","));
};
var $77d4e423430b81d0$var$updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector($77d4e423430b81d0$var$TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + $77d4e423430b81d0$var$HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;
    if (tags && tags.length) tags.forEach(function(tag) {
        var newElement = document.createElement(type);
        for(var attribute in tag)if (tag.hasOwnProperty(attribute)) {
            if (attribute === $77d4e423430b81d0$var$TAG_PROPERTIES.INNER_HTML) newElement.innerHTML = tag.innerHTML;
            else if (attribute === $77d4e423430b81d0$var$TAG_PROPERTIES.CSS_TEXT) {
                if (newElement.styleSheet) newElement.styleSheet.cssText = tag.cssText;
                else newElement.appendChild(document.createTextNode(tag.cssText));
            } else {
                var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                newElement.setAttribute(attribute, value);
            }
        }
        newElement.setAttribute($77d4e423430b81d0$var$HELMET_ATTRIBUTE, "true");
        // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
        if (oldTags.some(function(existingTag, index) {
            indexToDelete = index;
            return newElement.isEqualNode(existingTag);
        })) oldTags.splice(indexToDelete, 1);
        else newTags.push(newElement);
    });
    oldTags.forEach(function(tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function(tag) {
        return headElement.appendChild(tag);
    });
    return {
        oldTags: oldTags,
        newTags: newTags
    };
};
var $77d4e423430b81d0$var$generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function(str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + '="' + attributes[key] + '"' : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};
var $77d4e423430b81d0$var$generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = $77d4e423430b81d0$var$generateElementAttributesAsString(attributes);
    var flattenedTitle = $77d4e423430b81d0$var$flattenArray(title);
    return attributeString ? "<" + type + " " + $77d4e423430b81d0$var$HELMET_ATTRIBUTE + '="true" ' + attributeString + ">" + $77d4e423430b81d0$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + $77d4e423430b81d0$var$HELMET_ATTRIBUTE + '="true">' + $77d4e423430b81d0$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};
var $77d4e423430b81d0$var$generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function(str, tag) {
        var attributeHtml = Object.keys(tag).filter(function(attribute) {
            return !(attribute === $77d4e423430b81d0$var$TAG_PROPERTIES.INNER_HTML || attribute === $77d4e423430b81d0$var$TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function(string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + '="' + $77d4e423430b81d0$var$encodeSpecialCharacters(tag[attribute], encode) + '"';
            return string ? string + " " + attr : attr;
        }, "");
        var tagContent = tag.innerHTML || tag.cssText || "";
        var isSelfClosing = $77d4e423430b81d0$var$SELF_CLOSING_TAGS.indexOf(type) === -1;
        return str + "<" + type + " " + $77d4e423430b81d0$var$HELMET_ATTRIBUTE + '="true" ' + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};
var $77d4e423430b81d0$var$convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(attributes).reduce(function(obj, key) {
        obj[$77d4e423430b81d0$var$REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};
var $77d4e423430b81d0$var$convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(props).reduce(function(obj, key) {
        obj[$77d4e423430b81d0$var$HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};
var $77d4e423430b81d0$var$generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;
    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[$77d4e423430b81d0$var$HELMET_ATTRIBUTE] = true, _initProps);
    var props = $77d4e423430b81d0$var$convertElementAttributestoReactProps(attributes, initProps);
    return [
        (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement($77d4e423430b81d0$var$TAG_NAMES.TITLE, props, title)
    ];
};
var $77d4e423430b81d0$var$generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function(tag, i) {
        var _mappedTag;
        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[$77d4e423430b81d0$var$HELMET_ATTRIBUTE] = true, _mappedTag);
        Object.keys(tag).forEach(function(attribute) {
            var mappedAttribute = $77d4e423430b81d0$var$REACT_TAG_MAP[attribute] || attribute;
            if (mappedAttribute === $77d4e423430b81d0$var$TAG_PROPERTIES.INNER_HTML || mappedAttribute === $77d4e423430b81d0$var$TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = {
                    __html: content
                };
            } else mappedTag[mappedAttribute] = tag[attribute];
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement(type, mappedTag);
    });
};
var $77d4e423430b81d0$var$getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch(type){
        case $77d4e423430b81d0$var$TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return $77d4e423430b81d0$var$generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return $77d4e423430b81d0$var$generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case $77d4e423430b81d0$var$ATTRIBUTE_NAMES.BODY:
        case $77d4e423430b81d0$var$ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return $77d4e423430b81d0$var$convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return $77d4e423430b81d0$var$generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return $77d4e423430b81d0$var$generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return $77d4e423430b81d0$var$generateTagsAsString(type, tags, encode);
                }
            };
    }
};
var $77d4e423430b81d0$var$mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag, bodyAttributes = _ref.bodyAttributes, encode = _ref.encode, htmlAttributes = _ref.htmlAttributes, linkTags = _ref.linkTags, metaTags = _ref.metaTags, noscriptTags = _ref.noscriptTags, scriptTags = _ref.scriptTags, styleTags = _ref.styleTags, _ref$title = _ref.title, title = _ref$title === undefined ? "" : _ref$title, titleAttributes = _ref.titleAttributes;
    return {
        base: $77d4e423430b81d0$var$getMethodsForTag($77d4e423430b81d0$var$TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: $77d4e423430b81d0$var$getMethodsForTag($77d4e423430b81d0$var$ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: $77d4e423430b81d0$var$getMethodsForTag($77d4e423430b81d0$var$ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: $77d4e423430b81d0$var$getMethodsForTag($77d4e423430b81d0$var$TAG_NAMES.LINK, linkTags, encode),
        meta: $77d4e423430b81d0$var$getMethodsForTag($77d4e423430b81d0$var$TAG_NAMES.META, metaTags, encode),
        noscript: $77d4e423430b81d0$var$getMethodsForTag($77d4e423430b81d0$var$TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: $77d4e423430b81d0$var$getMethodsForTag($77d4e423430b81d0$var$TAG_NAMES.SCRIPT, scriptTags, encode),
        style: $77d4e423430b81d0$var$getMethodsForTag($77d4e423430b81d0$var$TAG_NAMES.STYLE, styleTags, encode),
        title: $77d4e423430b81d0$var$getMethodsForTag($77d4e423430b81d0$var$TAG_NAMES.TITLE, {
            title: title,
            titleAttributes: titleAttributes
        }, encode)
    };
};
var $77d4e423430b81d0$var$Helmet = function Helmet(Component) {
    var _class, _temp;
    return _temp = _class = function(_React$Component) {
        $77d4e423430b81d0$var$inherits(HelmetWrapper, _React$Component);
        function HelmetWrapper() {
            $77d4e423430b81d0$var$classCallCheck(this, HelmetWrapper);
            return $77d4e423430b81d0$var$possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }
        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, (/*@__PURE__*/$parcel$interopDefault($1b21794642166ddd$exports)))(this.props, nextProps);
        };
        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) return null;
            switch(child.type){
                case $77d4e423430b81d0$var$TAG_NAMES.SCRIPT:
                case $77d4e423430b81d0$var$TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };
                case $77d4e423430b81d0$var$TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }
            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };
        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _babelHelpers$extends;
            var child = _ref.child, arrayTypeChildren = _ref.arrayTypeChildren, newChildProps = _ref.newChildProps, nestedChildren = _ref.nestedChildren;
            return $77d4e423430b81d0$var$_extends({}, arrayTypeChildren, (_babelHelpers$extends = {}, _babelHelpers$extends[child.type] = [].concat(arrayTypeChildren[child.type] || [], [
                $77d4e423430b81d0$var$_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))
            ]), _babelHelpers$extends));
        };
        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _babelHelpers$extends2, _babelHelpers$extends3;
            var child = _ref2.child, newProps = _ref2.newProps, newChildProps = _ref2.newChildProps, nestedChildren = _ref2.nestedChildren;
            switch(child.type){
                case $77d4e423430b81d0$var$TAG_NAMES.TITLE:
                    return $77d4e423430b81d0$var$_extends({}, newProps, (_babelHelpers$extends2 = {}, _babelHelpers$extends2[child.type] = nestedChildren, _babelHelpers$extends2.titleAttributes = $77d4e423430b81d0$var$_extends({}, newChildProps), _babelHelpers$extends2));
                case $77d4e423430b81d0$var$TAG_NAMES.BODY:
                    return $77d4e423430b81d0$var$_extends({}, newProps, {
                        bodyAttributes: $77d4e423430b81d0$var$_extends({}, newChildProps)
                    });
                case $77d4e423430b81d0$var$TAG_NAMES.HTML:
                    return $77d4e423430b81d0$var$_extends({}, newProps, {
                        htmlAttributes: $77d4e423430b81d0$var$_extends({}, newChildProps)
                    });
            }
            return $77d4e423430b81d0$var$_extends({}, newProps, (_babelHelpers$extends3 = {}, _babelHelpers$extends3[child.type] = $77d4e423430b81d0$var$_extends({}, newChildProps), _babelHelpers$extends3));
        };
        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = $77d4e423430b81d0$var$_extends({}, newProps);
            Object.keys(arrayTypeChildren).forEach(function(arrayChildName) {
                var _babelHelpers$extends4;
                newFlattenedProps = $77d4e423430b81d0$var$_extends({}, newFlattenedProps, (_babelHelpers$extends4 = {}, _babelHelpers$extends4[arrayChildName] = arrayTypeChildren[arrayChildName], _babelHelpers$extends4));
            });
            return newFlattenedProps;
        };
        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            return true;
        };
        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;
            var arrayTypeChildren = {};
            (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).Children.forEach(children, function(child) {
                if (!child || !child.props) return;
                var _child$props = child.props, nestedChildren = _child$props.children, childProps = $77d4e423430b81d0$var$objectWithoutProperties(_child$props, [
                    "children"
                ]);
                var newChildProps = $77d4e423430b81d0$var$convertReactPropstoHtmlAttributes(childProps);
                _this2.warnOnInvalidChildren(child, nestedChildren);
                switch(child.type){
                    case $77d4e423430b81d0$var$TAG_NAMES.LINK:
                    case $77d4e423430b81d0$var$TAG_NAMES.META:
                    case $77d4e423430b81d0$var$TAG_NAMES.NOSCRIPT:
                    case $77d4e423430b81d0$var$TAG_NAMES.SCRIPT:
                    case $77d4e423430b81d0$var$TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });
            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };
        HelmetWrapper.prototype.render = function render() {
            var _props = this.props, children = _props.children, props = $77d4e423430b81d0$var$objectWithoutProperties(_props, [
                "children"
            ]);
            var newProps = $77d4e423430b81d0$var$_extends({}, props);
            if (children) newProps = this.mapChildrenToProps(children, newProps);
            return (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement(Component, newProps);
        };
        $77d4e423430b81d0$var$createClass(HelmetWrapper, null, [
            {
                key: "canUseDOM",
                // Component.peek comes from react-side-effect:
                // For testing, you may use a static peek() method available on the returned component.
                // It lets you get the current state without resetting the mounted instance stack.
                // Don’t use it for anything other than testing.
                /**
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Object} bodyAttributes: {"className": "root"}
             * @param {String} defaultTitle: "Default Title"
             * @param {Boolean} defer: true
             * @param {Boolean} encodeSpecialCharacters: true
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
             * @param {String} title: "Title"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {String} titleTemplate: "MySite.com - %s"
             */ set: function set$$1(canUseDOM) {
                    Component.canUseDOM = canUseDOM;
                }
            }
        ]);
        return HelmetWrapper;
    }((0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).Component), _class.propTypes = {
        base: (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).object,
        bodyAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).object,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).node),
            (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).node
        ]),
        defaultTitle: (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).string,
        defer: (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).bool,
        encodeSpecialCharacters: (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).bool,
        htmlAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).object,
        link: (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).object),
        meta: (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).object),
        noscript: (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).object),
        onChangeClientState: (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).func,
        script: (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).object),
        style: (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).object),
        title: (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).string,
        titleAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).object,
        titleTemplate: (0, (/*@__PURE__*/$parcel$interopDefault($84856705c0d3bfb8$exports))).string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function() {
        var mappedState = Component.rewind();
        if (!mappedState) // provide fallback if mappedState is undefined
        mappedState = $77d4e423430b81d0$var$mapStateOnServer({
            baseTag: [],
            bodyAttributes: {},
            encodeSpecialCharacters: true,
            htmlAttributes: {},
            linkTags: [],
            metaTags: [],
            noscriptTags: [],
            scriptTags: [],
            styleTags: [],
            title: "",
            titleAttributes: {}
        });
        return mappedState;
    }, _temp;
};
var $77d4e423430b81d0$var$NullComponent = function NullComponent() {
    return null;
};
var $77d4e423430b81d0$var$HelmetSideEffects = (0, (/*@__PURE__*/$parcel$interopDefault($fac7422b70f4bafc$exports)))($77d4e423430b81d0$var$reducePropsToState, $77d4e423430b81d0$var$handleClientStateChange, $77d4e423430b81d0$var$mapStateOnServer)($77d4e423430b81d0$var$NullComponent);
var $77d4e423430b81d0$export$dcef8f9bb9a41431 = $77d4e423430b81d0$var$Helmet($77d4e423430b81d0$var$HelmetSideEffects);
$77d4e423430b81d0$export$dcef8f9bb9a41431.renderStatic = $77d4e423430b81d0$export$dcef8f9bb9a41431.rewind;
var $77d4e423430b81d0$export$2e2bcd8739ae039 = $77d4e423430b81d0$export$dcef8f9bb9a41431;



class $387a463ceb76c41e$var$Root extends (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).Component {
    componentDidUpdate(prevProps) {
        // Scroll to top on URL Change
        if (this.props.location.pathname !== prevProps.location.pathname) window.scrollTo(0, 0);
        else if (!(0, $9fbae048b55737ab$export$1e4fed98bcaa1d82)()) // scroll to top on refresh on mobile
        window.scrollTo(0, 0);
    }
    componentDidMount() {}
    render() {
        const meta = {
            title: "TRIBE7",
            description: "Exploring how color, light and optics can be reimagined for contemporary filmmakers."
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement((0, $77d4e423430b81d0$export$dcef8f9bb9a41431), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("title", null, meta.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("meta", {
            name: "description",
            content: meta.description
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement((0, $d9cc27b375329b06$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement((0, $fcf1a16a32c1d7db$export$2e2bcd8739ae039), {
            path: "/",
            exact: true,
            component: (0, $fd7550469072ac96$export$2e2bcd8739ae039)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement((0, $2ace29d8b52175d2$export$2e2bcd8739ae039), {
            to: "/"
        })));
    }
}
var $387a463ceb76c41e$export$2e2bcd8739ae039 = (0, $7b5e727ae8dc8fde$export$2e2bcd8739ae039)($387a463ceb76c41e$var$Root);


function $e65d802c88480ffd$var$init() {
    (0, $48d91bc131875195$exports.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement((0, $a013cbff9d0a01ad$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement((0, $387a463ceb76c41e$export$2e2bcd8739ae039), null)), document.getElementById("root"));
}
$e65d802c88480ffd$var$init();

})();
//# sourceMappingURL=index.71b01196.js.map
